(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("vue-custom-element"));
	else if(typeof define === 'function' && define.amd)
		define(["vue", "vue-custom-element"], factory);
	else if(typeof exports === 'object')
		exports["mwcPpScenarioAnalysis"] = factory(require("vue"), require("vue-custom-element"));
	else
		root["mwcPpScenarioAnalysis"] = factory(root["Vue"], root["VueCustomElement"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__131__, __WEBPACK_EXTERNAL_MODULE__234__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 246);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var shared = __webpack_require__(101);
var has = __webpack_require__(8);
var uid = __webpack_require__(103);
var NATIVE_SYMBOL = __webpack_require__(104);
var USE_SYMBOL_AS_UID = __webpack_require__(171);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(13);
var defineProperty = __webpack_require__(14).f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(169)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var getOwnPropertyDescriptor = __webpack_require__(49).f;
var createNonEnumerableProperty = __webpack_require__(11);
var redefine = __webpack_require__(26);
var setGlobal = __webpack_require__(102);
var copyConstructorProperties = __webpack_require__(177);
var isForced = __webpack_require__(181);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var fails = __webpack_require__(2);
var isArray = __webpack_require__(48);
var isObject = __webpack_require__(9);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(20);
var createProperty = __webpack_require__(54);
var arraySpeciesCreate = __webpack_require__(107);
var arrayMethodHasSpeciesSupport = __webpack_require__(55);
var wellKnownSymbol = __webpack_require__(1);
var V8_VERSION = __webpack_require__(191);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(13);
var definePropertyModule = __webpack_require__(14);
var createPropertyDescriptor = __webpack_require__(36);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(2);

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(13);
var IE8_DOM_DEFINE = __webpack_require__(167);
var anObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(34);

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(193);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(19);

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _button_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(220);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _button_vue__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _button_container_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(224);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _button_container_vue__WEBPACK_IMPORTED_MODULE_1__["a"]; });





/***/ }),
/* 18 */
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"@mds/layout-grid\",\"version\":\"3.2.4\",\"license\":\"ISC\",\"author\":\"designsystem@morningstar.com\",\"contributors\":[{\"name\":\"James Harris\"}],\"repository\":{\"type\":\"git\",\"url\":\"https://msstash.morningstar.com/scm/mds/library.git\"},\"description\":\"The layout grid provides a 12-column, responsive, mobile-first, class-based grid system built using flexbox with alignment and arrangement utilities.\",\"main\":\"src/index.js\",\"types\":\"src/index.d.ts\",\"files\":[\"src/*.vue\",\"src/*.scss\",\"src/*.d.ts\"],\"dependencies\":{\"@mds/constants\":\"^3.3.0\",\"@mds/utils-scss\":\"^3.0.14\"},\"scripts\":{\"test\":\"start-server-and-test view http://localhost:6006 jest\",\"test:unit\":\"jest --testMatch '**/!(avr)+(.test).js'\",\"test:promote\":\"start-server-and-test view http://localhost:6006 promote\",\"promote\":\"jest -u\",\"view\":\"start-storybook -p 6006\",\"view:docs\":\"cross-env NODE_ENV=development webpack-dev-server --open --hot --config '../../configs/docs.config.js'\",\"build:docs\":\"cross-env NODE_ENV=production webpack --progress --hide-modules --config '../../configs/docs.config.js'\",\"build:storybook\":\"build-storybook -o public\"},\"gitHead\":\"b8711eb5853184a6fb733ab5fab8fe73921e4df6\"}");

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(38);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(106);
var requireObjectCoercible = __webpack_require__(19);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(285),
    getValue = __webpack_require__(290);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(367);


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var createNonEnumerableProperty = __webpack_require__(11);
var has = __webpack_require__(8);
var setGlobal = __webpack_require__(102);
var inspectSource = __webpack_require__(172);
var InternalStateModule = __webpack_require__(45);

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),
/* 27 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(202),
    baseKeys = __webpack_require__(318),
    isArrayLike = __webpack_require__(29);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(192),
    isLength = __webpack_require__(122);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _icon_vue_vue_type_template_id_4ac77a66___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(166);
/* harmony import */ var _icon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95);
/* harmony import */ var _icon_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(134);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_icon_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"].locals || _icon_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _icon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _icon_vue_vue_type_template_id_4ac77a66___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _icon_vue_vue_type_template_id_4ac77a66___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/node_modules/@mds/icon/src/icon.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 31 */
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"@mds/button\",\"version\":\"3.3.6\",\"license\":\"ISC\",\"author\":\"designsystem@morningstar.com\",\"contributors\":[{\"name\":\"James Harris\"},{\"name\":\"Trevor Rice\"}],\"repository\":{\"type\":\"git\",\"url\":\"https://msstash.morningstar.com/scm/mds/library.git\"},\"description\":\"Buttons trigger interactions throughout the experience.\",\"main\":\"src/index.js\",\"types\":\"src/index.d.ts\",\"files\":[\"src/*.vue\",\"src/*.scss\",\"src/*.d.ts\"],\"dependencies\":{\"@mds/constants\":\"^3.3.0\",\"@mds/fonts\":\"^3.1.1\",\"@mds/icon\":\"^4.3.3\",\"@mds/loader\":\"^3.3.5\",\"@mds/routable\":\"^3.1.0\",\"@mds/typography\":\"^3.1.9\",\"@mds/utils-scss\":\"^3.0.14\"},\"scripts\":{\"test\":\"start-server-and-test view http://localhost:6006 jest\",\"test:unit\":\"jest --testMatch '**/!(avr)+(.test).js'\",\"test:promote\":\"start-server-and-test view http://localhost:6006 promote\",\"promote\":\"jest -u\",\"view\":\"start-storybook -p 6006\",\"view:docs\":\"cross-env NODE_ENV=development webpack-dev-server --open --hot --config '../../configs/docs.config.js'\",\"build:docs\":\"cross-env NODE_ENV=production webpack --progress --hide-modules --config '../../configs/docs.config.js'\",\"build:storybook\":\"build-storybook -o public\"},\"gitHead\":\"b8711eb5853184a6fb733ab5fab8fe73921e4df6\"}");

/***/ }),
/* 32 */
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"@mds/list-group\",\"version\":\"4.1.8\",\"license\":\"ISC\",\"author\":\"designsystem@morningstar.com\",\"contributors\":[{\"name\":\"James Harris\"},{\"name\":\"Jonathan Duncan\"}],\"repository\":{\"type\":\"git\",\"url\":\"https://msstash.morningstar.com/scm/mds/library.git\"},\"description\":\"List groups create simple vertical lists as well as complex, multi-level collections of Links and other elements.\",\"main\":\"src/index.js\",\"types\":\"src/index.d.ts\",\"files\":[\"src/*.vue\",\"src/*.scss\",\"src/*.d.ts\"],\"dependencies\":{\"@mds/constants\":\"^3.3.0\",\"@mds/fonts\":\"^3.1.1\",\"@mds/icon\":\"^4.3.3\",\"@mds/typography\":\"^3.1.9\",\"@mds/utils-scss\":\"^3.0.14\"},\"scripts\":{\"test\":\"start-server-and-test view http://localhost:6006 jest\",\"test:unit\":\"jest --testMatch '**/!(avr)+(.test).js'\",\"test:promote\":\"start-server-and-test view http://localhost:6006 promote\",\"promote\":\"jest -u\",\"view\":\"start-storybook -s ./__test__/assets -p 6006\",\"view:docs\":\"cross-env NODE_ENV=development webpack-dev-server --open --hot --config '../../configs/docs.config.js'\",\"build:docs\":\"cross-env NODE_ENV=production webpack --progress --hide-modules --config '../../configs/docs.config.js'\",\"build:storybook\":\"build-storybook -o public\"},\"gitHead\":\"b8711eb5853184a6fb733ab5fab8fe73921e4df6\"}");

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(345);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(100);
var redefine = __webpack_require__(26);
var toString = __webpack_require__(248);

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var DOMIterables = __webpack_require__(174);
var forEach = __webpack_require__(249);
var createNonEnumerableProperty = __webpack_require__(11);

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),
/* 38 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(41),
    getRawTag = __webpack_require__(286),
    objectToString = __webpack_require__(287);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(212),
    baseAssignValue = __webpack_require__(213);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(272),
    findIndex = __webpack_require__(338);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(247);
var global = __webpack_require__(4);
var isObject = __webpack_require__(9);
var createNonEnumerableProperty = __webpack_require__(11);
var objectHas = __webpack_require__(8);
var sharedKey = __webpack_require__(46);
var hiddenKeys = __webpack_require__(47);

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(101);
var uid = __webpack_require__(103);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(27);

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(13);
var propertyIsEnumerableModule = __webpack_require__(108);
var createPropertyDescriptor = __webpack_require__(36);
var toIndexedObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(34);
var has = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(167);

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(178);
var global = __webpack_require__(4);

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(179);
var enumBugKeys = __webpack_require__(110);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var defineProperties = __webpack_require__(253);
var enumBugKeys = __webpack_require__(110);
var hiddenKeys = __webpack_require__(47);
var html = __webpack_require__(254);
var documentCreateElement = __webpack_require__(168);
var sharedKey = __webpack_require__(46);
var IE_PROTO = sharedKey('IE_PROTO');

var PROTOTYPE = 'prototype';
var Empty = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
  return createDict();
};

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

hiddenKeys[IE_PROTO] = true;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(179);
var enumBugKeys = __webpack_require__(110);

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(34);
var definePropertyModule = __webpack_require__(14);
var createPropertyDescriptor = __webpack_require__(36);

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(2);
var wellKnownSymbol = __webpack_require__(1);
var V8_VERSION = __webpack_require__(191);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__(271);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(275),
    listCacheDelete = __webpack_require__(276),
    listCacheGet = __webpack_require__(277),
    listCacheHas = __webpack_require__(278),
    listCacheSet = __webpack_require__(279);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(59);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(299);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(320),
    Map = __webpack_require__(116),
    Promise = __webpack_require__(321),
    Set = __webpack_require__(322),
    WeakMap = __webpack_require__(323),
    baseGetTag = __webpack_require__(40),
    toSource = __webpack_require__(194);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(40),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(63);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(202),
    baseKeysIn = __webpack_require__(348),
    isArrayLike = __webpack_require__(29);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mds-icon":"mds-icon__pp","mds-icon--small":"mds-icon--small__pp"};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mds-loader":"mds-loader__pp","mds-loader--small":"mds-loader--small__pp","mds-loader--large":"mds-loader--large__pp","mds-component--on-dark":"mds-component--on-dark__pp","mds-loader__item":"mds-loader__item__pp","mds-loader--hidden":"mds-loader--hidden__pp","burstAnimation":"burstAnimation__pp","mds-loader--static":"mds-loader--static__pp","mds-loader__item--0":"mds-loader__item--0__pp","mds-loader__item--1":"mds-loader__item--1__pp","mds-loader__item--2":"mds-loader__item--2__pp","mds-loader__item--3":"mds-loader__item--3__pp","mds-loader__item--4":"mds-loader__item--4__pp","mds-loader__item--5":"mds-loader__item--5__pp","mds-loader__item--6":"mds-loader__item--6__pp","mds-loader__item--7":"mds-loader__item--7__pp","mds-loader__item--8":"mds-loader__item--8__pp"};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mds-button":"mds-button__pp","mds-button--small":"mds-button--small__pp","mds-button--secondary":"mds-button--secondary__pp","mds-button__icon":"mds-button__icon__pp","mds-button__icon--right":"mds-button__icon--right__pp","mds-button--large":"mds-button--large__pp","mds-button--touch":"mds-button--touch__pp","mds-button--icon-only":"mds-button--icon-only__pp","mds-component--on-dark":"mds-component--on-dark__pp","mds-button--flat":"mds-button--flat__pp","mds-button--primary":"mds-button--primary__pp","mds-button__loader":"mds-button__loader__pp","mds-button--flat-m-icon":"mds-button--flat-m-icon__pp","mds-button--loading":"mds-button--loading__pp","mds-button__loader-enter-active":"mds-button__loader-enter-active__pp","mds-button__loader-leave-active":"mds-button__loader-leave-active__pp","mds-button__loader-enter":"mds-button__loader-enter__pp","mds-button__loader-leave-to":"mds-button__loader-leave-to__pp"};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mds-button-container":"mds-button-container__pp","mds-button":"mds-button__pp","mds-button--small":"mds-button--small__pp","mds-button--icon-only":"mds-button--icon-only__pp","mds-button-container--right-aligned":"mds-button-container--right-aligned__pp"};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mds-overlay":"mds-overlay__pp","mds-dialog":"mds-dialog__pp","mds-dialog__title":"mds-dialog__title__pp","mds-dialog__message":"mds-dialog__message__pp","mds-dialog__actions":"mds-dialog__actions__pp","mds-dialog__actions-right":"mds-dialog__actions-right__pp","mds-dialog--width-500px":"mds-dialog--width-500px__pp","mds-dialog-wrapper":"mds-dialog-wrapper__pp","mds-dialog-enter":"mds-dialog-enter__pp","mds-dialog-leave-to":"mds-dialog-leave-to__pp","mds-dialog-enter-active":"mds-dialog-enter-active__pp","mds-dialog-leave-active":"mds-dialog-leave-active__pp"};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mds-layout-grid":"mds-layout-grid__pp","mds-layout-grid__row":"mds-layout-grid__row__pp","mds-layout-grid__row--nowrap":"mds-layout-grid__row--nowrap__pp","mds-layout-grid__col":"mds-layout-grid__col__pp","mds-layout-grid__row--justify-content-center":"mds-layout-grid__row--justify-content-center__pp","mds-layout-grid__row--justify-content-flex-end":"mds-layout-grid__row--justify-content-flex-end__pp","mds-layout-grid__row--justify-content-flex-start":"mds-layout-grid__row--justify-content-flex-start__pp","mds-layout-grid__row--justify-content-space-around":"mds-layout-grid__row--justify-content-space-around__pp","mds-layout-grid__row--justify-content-space-between":"mds-layout-grid__row--justify-content-space-between__pp","mds-layout-grid__row--align-items-stretch":"mds-layout-grid__row--align-items-stretch__pp","mds-layout-grid__row--align-items-center":"mds-layout-grid__row--align-items-center__pp","mds-layout-grid__row--align-items-flex-end":"mds-layout-grid__row--align-items-flex-end__pp","mds-layout-grid__row--align-items-flex-start":"mds-layout-grid__row--align-items-flex-start__pp","mds-layout-grid__col--align-self-auto":"mds-layout-grid__col--align-self-auto__pp","mds-layout-grid__col--align-self-center":"mds-layout-grid__col--align-self-center__pp","mds-layout-grid__col--align-self-flex-end":"mds-layout-grid__col--align-self-flex-end__pp","mds-layout-grid__col--align-self-flex-start":"mds-layout-grid__col--align-self-flex-start__pp","mds-layout-grid__row--zero-margin":"mds-layout-grid__row--zero-margin__pp","mds-layout-grid__col--zero-padding":"mds-layout-grid__col--zero-padding__pp","mds-layout-grid__col--auto":"mds-layout-grid__col--auto__pp","mds-layout-grid__col--1":"mds-layout-grid__col--1__pp","mds-layout-grid__col--2":"mds-layout-grid__col--2__pp","mds-layout-grid__col--3":"mds-layout-grid__col--3__pp","mds-layout-grid__col--4":"mds-layout-grid__col--4__pp","mds-layout-grid__col--5":"mds-layout-grid__col--5__pp","mds-layout-grid__col--6":"mds-layout-grid__col--6__pp","mds-layout-grid__col--7":"mds-layout-grid__col--7__pp","mds-layout-grid__col--8":"mds-layout-grid__col--8__pp","mds-layout-grid__col--9":"mds-layout-grid__col--9__pp","mds-layout-grid__col--10":"mds-layout-grid__col--10__pp","mds-layout-grid__col--11":"mds-layout-grid__col--11__pp","mds-layout-grid__col--12":"mds-layout-grid__col--12__pp","mds-layout-grid__col--pull-0":"mds-layout-grid__col--pull-0__pp","mds-layout-grid__col--pull-1":"mds-layout-grid__col--pull-1__pp","mds-layout-grid__col--pull-2":"mds-layout-grid__col--pull-2__pp","mds-layout-grid__col--pull-3":"mds-layout-grid__col--pull-3__pp","mds-layout-grid__col--pull-4":"mds-layout-grid__col--pull-4__pp","mds-layout-grid__col--pull-5":"mds-layout-grid__col--pull-5__pp","mds-layout-grid__col--pull-6":"mds-layout-grid__col--pull-6__pp","mds-layout-grid__col--pull-7":"mds-layout-grid__col--pull-7__pp","mds-layout-grid__col--pull-8":"mds-layout-grid__col--pull-8__pp","mds-layout-grid__col--pull-9":"mds-layout-grid__col--pull-9__pp","mds-layout-grid__col--pull-10":"mds-layout-grid__col--pull-10__pp","mds-layout-grid__col--pull-11":"mds-layout-grid__col--pull-11__pp","mds-layout-grid__col--push-0":"mds-layout-grid__col--push-0__pp","mds-layout-grid__col--push-1":"mds-layout-grid__col--push-1__pp","mds-layout-grid__col--push-2":"mds-layout-grid__col--push-2__pp","mds-layout-grid__col--push-3":"mds-layout-grid__col--push-3__pp","mds-layout-grid__col--push-4":"mds-layout-grid__col--push-4__pp","mds-layout-grid__col--push-5":"mds-layout-grid__col--push-5__pp","mds-layout-grid__col--push-6":"mds-layout-grid__col--push-6__pp","mds-layout-grid__col--push-7":"mds-layout-grid__col--push-7__pp","mds-layout-grid__col--push-8":"mds-layout-grid__col--push-8__pp","mds-layout-grid__col--push-9":"mds-layout-grid__col--push-9__pp","mds-layout-grid__col--push-10":"mds-layout-grid__col--push-10__pp","mds-layout-grid__col--push-11":"mds-layout-grid__col--push-11__pp","mds-layout-grid__col--squeeze-0":"mds-layout-grid__col--squeeze-0__pp","mds-layout-grid__col--squeeze-1":"mds-layout-grid__col--squeeze-1__pp","mds-layout-grid__col--squeeze-2":"mds-layout-grid__col--squeeze-2__pp","mds-layout-grid__col--squeeze-3":"mds-layout-grid__col--squeeze-3__pp","mds-layout-grid__col--squeeze-4":"mds-layout-grid__col--squeeze-4__pp","mds-layout-grid__col--squeeze-5":"mds-layout-grid__col--squeeze-5__pp","mds-layout-grid__col--at-600":"mds-layout-grid__col--at-600__pp","mds-layout-grid__col--auto-at-600":"mds-layout-grid__col--auto-at-600__pp","mds-layout-grid__col--1-at-600":"mds-layout-grid__col--1-at-600__pp","mds-layout-grid__col--2-at-600":"mds-layout-grid__col--2-at-600__pp","mds-layout-grid__col--3-at-600":"mds-layout-grid__col--3-at-600__pp","mds-layout-grid__col--4-at-600":"mds-layout-grid__col--4-at-600__pp","mds-layout-grid__col--5-at-600":"mds-layout-grid__col--5-at-600__pp","mds-layout-grid__col--6-at-600":"mds-layout-grid__col--6-at-600__pp","mds-layout-grid__col--7-at-600":"mds-layout-grid__col--7-at-600__pp","mds-layout-grid__col--8-at-600":"mds-layout-grid__col--8-at-600__pp","mds-layout-grid__col--9-at-600":"mds-layout-grid__col--9-at-600__pp","mds-layout-grid__col--10-at-600":"mds-layout-grid__col--10-at-600__pp","mds-layout-grid__col--11-at-600":"mds-layout-grid__col--11-at-600__pp","mds-layout-grid__col--12-at-600":"mds-layout-grid__col--12-at-600__pp","mds-layout-grid__col--pull-0-at-600":"mds-layout-grid__col--pull-0-at-600__pp","mds-layout-grid__col--pull-1-at-600":"mds-layout-grid__col--pull-1-at-600__pp","mds-layout-grid__col--pull-2-at-600":"mds-layout-grid__col--pull-2-at-600__pp","mds-layout-grid__col--pull-3-at-600":"mds-layout-grid__col--pull-3-at-600__pp","mds-layout-grid__col--pull-4-at-600":"mds-layout-grid__col--pull-4-at-600__pp","mds-layout-grid__col--pull-5-at-600":"mds-layout-grid__col--pull-5-at-600__pp","mds-layout-grid__col--pull-6-at-600":"mds-layout-grid__col--pull-6-at-600__pp","mds-layout-grid__col--pull-7-at-600":"mds-layout-grid__col--pull-7-at-600__pp","mds-layout-grid__col--pull-8-at-600":"mds-layout-grid__col--pull-8-at-600__pp","mds-layout-grid__col--pull-9-at-600":"mds-layout-grid__col--pull-9-at-600__pp","mds-layout-grid__col--pull-10-at-600":"mds-layout-grid__col--pull-10-at-600__pp","mds-layout-grid__col--pull-11-at-600":"mds-layout-grid__col--pull-11-at-600__pp","mds-layout-grid__col--push-0-at-600":"mds-layout-grid__col--push-0-at-600__pp","mds-layout-grid__col--push-1-at-600":"mds-layout-grid__col--push-1-at-600__pp","mds-layout-grid__col--push-2-at-600":"mds-layout-grid__col--push-2-at-600__pp","mds-layout-grid__col--push-3-at-600":"mds-layout-grid__col--push-3-at-600__pp","mds-layout-grid__col--push-4-at-600":"mds-layout-grid__col--push-4-at-600__pp","mds-layout-grid__col--push-5-at-600":"mds-layout-grid__col--push-5-at-600__pp","mds-layout-grid__col--push-6-at-600":"mds-layout-grid__col--push-6-at-600__pp","mds-layout-grid__col--push-7-at-600":"mds-layout-grid__col--push-7-at-600__pp","mds-layout-grid__col--push-8-at-600":"mds-layout-grid__col--push-8-at-600__pp","mds-layout-grid__col--push-9-at-600":"mds-layout-grid__col--push-9-at-600__pp","mds-layout-grid__col--push-10-at-600":"mds-layout-grid__col--push-10-at-600__pp","mds-layout-grid__col--push-11-at-600":"mds-layout-grid__col--push-11-at-600__pp","mds-layout-grid__col--squeeze-0-at-600":"mds-layout-grid__col--squeeze-0-at-600__pp","mds-layout-grid__col--squeeze-1-at-600":"mds-layout-grid__col--squeeze-1-at-600__pp","mds-layout-grid__col--squeeze-2-at-600":"mds-layout-grid__col--squeeze-2-at-600__pp","mds-layout-grid__col--squeeze-3-at-600":"mds-layout-grid__col--squeeze-3-at-600__pp","mds-layout-grid__col--squeeze-4-at-600":"mds-layout-grid__col--squeeze-4-at-600__pp","mds-layout-grid__col--squeeze-5-at-600":"mds-layout-grid__col--squeeze-5-at-600__pp","mds-layout-grid__col--at-768":"mds-layout-grid__col--at-768__pp","mds-layout-grid__col--auto-at-768":"mds-layout-grid__col--auto-at-768__pp","mds-layout-grid__col--1-at-768":"mds-layout-grid__col--1-at-768__pp","mds-layout-grid__col--2-at-768":"mds-layout-grid__col--2-at-768__pp","mds-layout-grid__col--3-at-768":"mds-layout-grid__col--3-at-768__pp","mds-layout-grid__col--4-at-768":"mds-layout-grid__col--4-at-768__pp","mds-layout-grid__col--5-at-768":"mds-layout-grid__col--5-at-768__pp","mds-layout-grid__col--6-at-768":"mds-layout-grid__col--6-at-768__pp","mds-layout-grid__col--7-at-768":"mds-layout-grid__col--7-at-768__pp","mds-layout-grid__col--8-at-768":"mds-layout-grid__col--8-at-768__pp","mds-layout-grid__col--9-at-768":"mds-layout-grid__col--9-at-768__pp","mds-layout-grid__col--10-at-768":"mds-layout-grid__col--10-at-768__pp","mds-layout-grid__col--11-at-768":"mds-layout-grid__col--11-at-768__pp","mds-layout-grid__col--12-at-768":"mds-layout-grid__col--12-at-768__pp","mds-layout-grid__col--pull-0-at-768":"mds-layout-grid__col--pull-0-at-768__pp","mds-layout-grid__col--pull-1-at-768":"mds-layout-grid__col--pull-1-at-768__pp","mds-layout-grid__col--pull-2-at-768":"mds-layout-grid__col--pull-2-at-768__pp","mds-layout-grid__col--pull-3-at-768":"mds-layout-grid__col--pull-3-at-768__pp","mds-layout-grid__col--pull-4-at-768":"mds-layout-grid__col--pull-4-at-768__pp","mds-layout-grid__col--pull-5-at-768":"mds-layout-grid__col--pull-5-at-768__pp","mds-layout-grid__col--pull-6-at-768":"mds-layout-grid__col--pull-6-at-768__pp","mds-layout-grid__col--pull-7-at-768":"mds-layout-grid__col--pull-7-at-768__pp","mds-layout-grid__col--pull-8-at-768":"mds-layout-grid__col--pull-8-at-768__pp","mds-layout-grid__col--pull-9-at-768":"mds-layout-grid__col--pull-9-at-768__pp","mds-layout-grid__col--pull-10-at-768":"mds-layout-grid__col--pull-10-at-768__pp","mds-layout-grid__col--pull-11-at-768":"mds-layout-grid__col--pull-11-at-768__pp","mds-layout-grid__col--push-0-at-768":"mds-layout-grid__col--push-0-at-768__pp","mds-layout-grid__col--push-1-at-768":"mds-layout-grid__col--push-1-at-768__pp","mds-layout-grid__col--push-2-at-768":"mds-layout-grid__col--push-2-at-768__pp","mds-layout-grid__col--push-3-at-768":"mds-layout-grid__col--push-3-at-768__pp","mds-layout-grid__col--push-4-at-768":"mds-layout-grid__col--push-4-at-768__pp","mds-layout-grid__col--push-5-at-768":"mds-layout-grid__col--push-5-at-768__pp","mds-layout-grid__col--push-6-at-768":"mds-layout-grid__col--push-6-at-768__pp","mds-layout-grid__col--push-7-at-768":"mds-layout-grid__col--push-7-at-768__pp","mds-layout-grid__col--push-8-at-768":"mds-layout-grid__col--push-8-at-768__pp","mds-layout-grid__col--push-9-at-768":"mds-layout-grid__col--push-9-at-768__pp","mds-layout-grid__col--push-10-at-768":"mds-layout-grid__col--push-10-at-768__pp","mds-layout-grid__col--push-11-at-768":"mds-layout-grid__col--push-11-at-768__pp","mds-layout-grid__col--squeeze-0-at-768":"mds-layout-grid__col--squeeze-0-at-768__pp","mds-layout-grid__col--squeeze-1-at-768":"mds-layout-grid__col--squeeze-1-at-768__pp","mds-layout-grid__col--squeeze-2-at-768":"mds-layout-grid__col--squeeze-2-at-768__pp","mds-layout-grid__col--squeeze-3-at-768":"mds-layout-grid__col--squeeze-3-at-768__pp","mds-layout-grid__col--squeeze-4-at-768":"mds-layout-grid__col--squeeze-4-at-768__pp","mds-layout-grid__col--squeeze-5-at-768":"mds-layout-grid__col--squeeze-5-at-768__pp","mds-layout-grid__col--at-1000":"mds-layout-grid__col--at-1000__pp","mds-layout-grid__col--auto-at-1000":"mds-layout-grid__col--auto-at-1000__pp","mds-layout-grid__col--1-at-1000":"mds-layout-grid__col--1-at-1000__pp","mds-layout-grid__col--2-at-1000":"mds-layout-grid__col--2-at-1000__pp","mds-layout-grid__col--3-at-1000":"mds-layout-grid__col--3-at-1000__pp","mds-layout-grid__col--4-at-1000":"mds-layout-grid__col--4-at-1000__pp","mds-layout-grid__col--5-at-1000":"mds-layout-grid__col--5-at-1000__pp","mds-layout-grid__col--6-at-1000":"mds-layout-grid__col--6-at-1000__pp","mds-layout-grid__col--7-at-1000":"mds-layout-grid__col--7-at-1000__pp","mds-layout-grid__col--8-at-1000":"mds-layout-grid__col--8-at-1000__pp","mds-layout-grid__col--9-at-1000":"mds-layout-grid__col--9-at-1000__pp","mds-layout-grid__col--10-at-1000":"mds-layout-grid__col--10-at-1000__pp","mds-layout-grid__col--11-at-1000":"mds-layout-grid__col--11-at-1000__pp","mds-layout-grid__col--12-at-1000":"mds-layout-grid__col--12-at-1000__pp","mds-layout-grid__col--pull-0-at-1000":"mds-layout-grid__col--pull-0-at-1000__pp","mds-layout-grid__col--pull-1-at-1000":"mds-layout-grid__col--pull-1-at-1000__pp","mds-layout-grid__col--pull-2-at-1000":"mds-layout-grid__col--pull-2-at-1000__pp","mds-layout-grid__col--pull-3-at-1000":"mds-layout-grid__col--pull-3-at-1000__pp","mds-layout-grid__col--pull-4-at-1000":"mds-layout-grid__col--pull-4-at-1000__pp","mds-layout-grid__col--pull-5-at-1000":"mds-layout-grid__col--pull-5-at-1000__pp","mds-layout-grid__col--pull-6-at-1000":"mds-layout-grid__col--pull-6-at-1000__pp","mds-layout-grid__col--pull-7-at-1000":"mds-layout-grid__col--pull-7-at-1000__pp","mds-layout-grid__col--pull-8-at-1000":"mds-layout-grid__col--pull-8-at-1000__pp","mds-layout-grid__col--pull-9-at-1000":"mds-layout-grid__col--pull-9-at-1000__pp","mds-layout-grid__col--pull-10-at-1000":"mds-layout-grid__col--pull-10-at-1000__pp","mds-layout-grid__col--pull-11-at-1000":"mds-layout-grid__col--pull-11-at-1000__pp","mds-layout-grid__col--push-0-at-1000":"mds-layout-grid__col--push-0-at-1000__pp","mds-layout-grid__col--push-1-at-1000":"mds-layout-grid__col--push-1-at-1000__pp","mds-layout-grid__col--push-2-at-1000":"mds-layout-grid__col--push-2-at-1000__pp","mds-layout-grid__col--push-3-at-1000":"mds-layout-grid__col--push-3-at-1000__pp","mds-layout-grid__col--push-4-at-1000":"mds-layout-grid__col--push-4-at-1000__pp","mds-layout-grid__col--push-5-at-1000":"mds-layout-grid__col--push-5-at-1000__pp","mds-layout-grid__col--push-6-at-1000":"mds-layout-grid__col--push-6-at-1000__pp","mds-layout-grid__col--push-7-at-1000":"mds-layout-grid__col--push-7-at-1000__pp","mds-layout-grid__col--push-8-at-1000":"mds-layout-grid__col--push-8-at-1000__pp","mds-layout-grid__col--push-9-at-1000":"mds-layout-grid__col--push-9-at-1000__pp","mds-layout-grid__col--push-10-at-1000":"mds-layout-grid__col--push-10-at-1000__pp","mds-layout-grid__col--push-11-at-1000":"mds-layout-grid__col--push-11-at-1000__pp","mds-layout-grid__col--squeeze-0-at-1000":"mds-layout-grid__col--squeeze-0-at-1000__pp","mds-layout-grid__col--squeeze-1-at-1000":"mds-layout-grid__col--squeeze-1-at-1000__pp","mds-layout-grid__col--squeeze-2-at-1000":"mds-layout-grid__col--squeeze-2-at-1000__pp","mds-layout-grid__col--squeeze-3-at-1000":"mds-layout-grid__col--squeeze-3-at-1000__pp","mds-layout-grid__col--squeeze-4-at-1000":"mds-layout-grid__col--squeeze-4-at-1000__pp","mds-layout-grid__col--squeeze-5-at-1000":"mds-layout-grid__col--squeeze-5-at-1000__pp","mds-layout-grid__col--at-1200":"mds-layout-grid__col--at-1200__pp","mds-layout-grid__col--auto-at-1200":"mds-layout-grid__col--auto-at-1200__pp","mds-layout-grid__col--1-at-1200":"mds-layout-grid__col--1-at-1200__pp","mds-layout-grid__col--2-at-1200":"mds-layout-grid__col--2-at-1200__pp","mds-layout-grid__col--3-at-1200":"mds-layout-grid__col--3-at-1200__pp","mds-layout-grid__col--4-at-1200":"mds-layout-grid__col--4-at-1200__pp","mds-layout-grid__col--5-at-1200":"mds-layout-grid__col--5-at-1200__pp","mds-layout-grid__col--6-at-1200":"mds-layout-grid__col--6-at-1200__pp","mds-layout-grid__col--7-at-1200":"mds-layout-grid__col--7-at-1200__pp","mds-layout-grid__col--8-at-1200":"mds-layout-grid__col--8-at-1200__pp","mds-layout-grid__col--9-at-1200":"mds-layout-grid__col--9-at-1200__pp","mds-layout-grid__col--10-at-1200":"mds-layout-grid__col--10-at-1200__pp","mds-layout-grid__col--11-at-1200":"mds-layout-grid__col--11-at-1200__pp","mds-layout-grid__col--12-at-1200":"mds-layout-grid__col--12-at-1200__pp","mds-layout-grid__col--pull-0-at-1200":"mds-layout-grid__col--pull-0-at-1200__pp","mds-layout-grid__col--pull-1-at-1200":"mds-layout-grid__col--pull-1-at-1200__pp","mds-layout-grid__col--pull-2-at-1200":"mds-layout-grid__col--pull-2-at-1200__pp","mds-layout-grid__col--pull-3-at-1200":"mds-layout-grid__col--pull-3-at-1200__pp","mds-layout-grid__col--pull-4-at-1200":"mds-layout-grid__col--pull-4-at-1200__pp","mds-layout-grid__col--pull-5-at-1200":"mds-layout-grid__col--pull-5-at-1200__pp","mds-layout-grid__col--pull-6-at-1200":"mds-layout-grid__col--pull-6-at-1200__pp","mds-layout-grid__col--pull-7-at-1200":"mds-layout-grid__col--pull-7-at-1200__pp","mds-layout-grid__col--pull-8-at-1200":"mds-layout-grid__col--pull-8-at-1200__pp","mds-layout-grid__col--pull-9-at-1200":"mds-layout-grid__col--pull-9-at-1200__pp","mds-layout-grid__col--pull-10-at-1200":"mds-layout-grid__col--pull-10-at-1200__pp","mds-layout-grid__col--pull-11-at-1200":"mds-layout-grid__col--pull-11-at-1200__pp","mds-layout-grid__col--push-0-at-1200":"mds-layout-grid__col--push-0-at-1200__pp","mds-layout-grid__col--push-1-at-1200":"mds-layout-grid__col--push-1-at-1200__pp","mds-layout-grid__col--push-2-at-1200":"mds-layout-grid__col--push-2-at-1200__pp","mds-layout-grid__col--push-3-at-1200":"mds-layout-grid__col--push-3-at-1200__pp","mds-layout-grid__col--push-4-at-1200":"mds-layout-grid__col--push-4-at-1200__pp","mds-layout-grid__col--push-5-at-1200":"mds-layout-grid__col--push-5-at-1200__pp","mds-layout-grid__col--push-6-at-1200":"mds-layout-grid__col--push-6-at-1200__pp","mds-layout-grid__col--push-7-at-1200":"mds-layout-grid__col--push-7-at-1200__pp","mds-layout-grid__col--push-8-at-1200":"mds-layout-grid__col--push-8-at-1200__pp","mds-layout-grid__col--push-9-at-1200":"mds-layout-grid__col--push-9-at-1200__pp","mds-layout-grid__col--push-10-at-1200":"mds-layout-grid__col--push-10-at-1200__pp","mds-layout-grid__col--push-11-at-1200":"mds-layout-grid__col--push-11-at-1200__pp","mds-layout-grid__col--squeeze-0-at-1200":"mds-layout-grid__col--squeeze-0-at-1200__pp","mds-layout-grid__col--squeeze-1-at-1200":"mds-layout-grid__col--squeeze-1-at-1200__pp","mds-layout-grid__col--squeeze-2-at-1200":"mds-layout-grid__col--squeeze-2-at-1200__pp","mds-layout-grid__col--squeeze-3-at-1200":"mds-layout-grid__col--squeeze-3-at-1200__pp","mds-layout-grid__col--squeeze-4-at-1200":"mds-layout-grid__col--squeeze-4-at-1200__pp","mds-layout-grid__col--squeeze-5-at-1200":"mds-layout-grid__col--squeeze-5-at-1200__pp"};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mds-layout-grid":"mds-layout-grid__pp","mds-layout-grid__row":"mds-layout-grid__row__pp","mds-layout-grid__row--nowrap":"mds-layout-grid__row--nowrap__pp","mds-layout-grid__col":"mds-layout-grid__col__pp","mds-layout-grid__row--justify-content-center":"mds-layout-grid__row--justify-content-center__pp","mds-layout-grid__row--justify-content-flex-end":"mds-layout-grid__row--justify-content-flex-end__pp","mds-layout-grid__row--justify-content-flex-start":"mds-layout-grid__row--justify-content-flex-start__pp","mds-layout-grid__row--justify-content-space-around":"mds-layout-grid__row--justify-content-space-around__pp","mds-layout-grid__row--justify-content-space-between":"mds-layout-grid__row--justify-content-space-between__pp","mds-layout-grid__row--align-items-stretch":"mds-layout-grid__row--align-items-stretch__pp","mds-layout-grid__row--align-items-center":"mds-layout-grid__row--align-items-center__pp","mds-layout-grid__row--align-items-flex-end":"mds-layout-grid__row--align-items-flex-end__pp","mds-layout-grid__row--align-items-flex-start":"mds-layout-grid__row--align-items-flex-start__pp","mds-layout-grid__col--align-self-auto":"mds-layout-grid__col--align-self-auto__pp","mds-layout-grid__col--align-self-center":"mds-layout-grid__col--align-self-center__pp","mds-layout-grid__col--align-self-flex-end":"mds-layout-grid__col--align-self-flex-end__pp","mds-layout-grid__col--align-self-flex-start":"mds-layout-grid__col--align-self-flex-start__pp","mds-layout-grid__row--zero-margin":"mds-layout-grid__row--zero-margin__pp","mds-layout-grid__col--zero-padding":"mds-layout-grid__col--zero-padding__pp","mds-layout-grid__col--auto":"mds-layout-grid__col--auto__pp","mds-layout-grid__col--1":"mds-layout-grid__col--1__pp","mds-layout-grid__col--2":"mds-layout-grid__col--2__pp","mds-layout-grid__col--3":"mds-layout-grid__col--3__pp","mds-layout-grid__col--4":"mds-layout-grid__col--4__pp","mds-layout-grid__col--5":"mds-layout-grid__col--5__pp","mds-layout-grid__col--6":"mds-layout-grid__col--6__pp","mds-layout-grid__col--7":"mds-layout-grid__col--7__pp","mds-layout-grid__col--8":"mds-layout-grid__col--8__pp","mds-layout-grid__col--9":"mds-layout-grid__col--9__pp","mds-layout-grid__col--10":"mds-layout-grid__col--10__pp","mds-layout-grid__col--11":"mds-layout-grid__col--11__pp","mds-layout-grid__col--12":"mds-layout-grid__col--12__pp","mds-layout-grid__col--pull-0":"mds-layout-grid__col--pull-0__pp","mds-layout-grid__col--pull-1":"mds-layout-grid__col--pull-1__pp","mds-layout-grid__col--pull-2":"mds-layout-grid__col--pull-2__pp","mds-layout-grid__col--pull-3":"mds-layout-grid__col--pull-3__pp","mds-layout-grid__col--pull-4":"mds-layout-grid__col--pull-4__pp","mds-layout-grid__col--pull-5":"mds-layout-grid__col--pull-5__pp","mds-layout-grid__col--pull-6":"mds-layout-grid__col--pull-6__pp","mds-layout-grid__col--pull-7":"mds-layout-grid__col--pull-7__pp","mds-layout-grid__col--pull-8":"mds-layout-grid__col--pull-8__pp","mds-layout-grid__col--pull-9":"mds-layout-grid__col--pull-9__pp","mds-layout-grid__col--pull-10":"mds-layout-grid__col--pull-10__pp","mds-layout-grid__col--pull-11":"mds-layout-grid__col--pull-11__pp","mds-layout-grid__col--push-0":"mds-layout-grid__col--push-0__pp","mds-layout-grid__col--push-1":"mds-layout-grid__col--push-1__pp","mds-layout-grid__col--push-2":"mds-layout-grid__col--push-2__pp","mds-layout-grid__col--push-3":"mds-layout-grid__col--push-3__pp","mds-layout-grid__col--push-4":"mds-layout-grid__col--push-4__pp","mds-layout-grid__col--push-5":"mds-layout-grid__col--push-5__pp","mds-layout-grid__col--push-6":"mds-layout-grid__col--push-6__pp","mds-layout-grid__col--push-7":"mds-layout-grid__col--push-7__pp","mds-layout-grid__col--push-8":"mds-layout-grid__col--push-8__pp","mds-layout-grid__col--push-9":"mds-layout-grid__col--push-9__pp","mds-layout-grid__col--push-10":"mds-layout-grid__col--push-10__pp","mds-layout-grid__col--push-11":"mds-layout-grid__col--push-11__pp","mds-layout-grid__col--squeeze-0":"mds-layout-grid__col--squeeze-0__pp","mds-layout-grid__col--squeeze-1":"mds-layout-grid__col--squeeze-1__pp","mds-layout-grid__col--squeeze-2":"mds-layout-grid__col--squeeze-2__pp","mds-layout-grid__col--squeeze-3":"mds-layout-grid__col--squeeze-3__pp","mds-layout-grid__col--squeeze-4":"mds-layout-grid__col--squeeze-4__pp","mds-layout-grid__col--squeeze-5":"mds-layout-grid__col--squeeze-5__pp","mds-layout-grid__col--at-600":"mds-layout-grid__col--at-600__pp","mds-layout-grid__col--auto-at-600":"mds-layout-grid__col--auto-at-600__pp","mds-layout-grid__col--1-at-600":"mds-layout-grid__col--1-at-600__pp","mds-layout-grid__col--2-at-600":"mds-layout-grid__col--2-at-600__pp","mds-layout-grid__col--3-at-600":"mds-layout-grid__col--3-at-600__pp","mds-layout-grid__col--4-at-600":"mds-layout-grid__col--4-at-600__pp","mds-layout-grid__col--5-at-600":"mds-layout-grid__col--5-at-600__pp","mds-layout-grid__col--6-at-600":"mds-layout-grid__col--6-at-600__pp","mds-layout-grid__col--7-at-600":"mds-layout-grid__col--7-at-600__pp","mds-layout-grid__col--8-at-600":"mds-layout-grid__col--8-at-600__pp","mds-layout-grid__col--9-at-600":"mds-layout-grid__col--9-at-600__pp","mds-layout-grid__col--10-at-600":"mds-layout-grid__col--10-at-600__pp","mds-layout-grid__col--11-at-600":"mds-layout-grid__col--11-at-600__pp","mds-layout-grid__col--12-at-600":"mds-layout-grid__col--12-at-600__pp","mds-layout-grid__col--pull-0-at-600":"mds-layout-grid__col--pull-0-at-600__pp","mds-layout-grid__col--pull-1-at-600":"mds-layout-grid__col--pull-1-at-600__pp","mds-layout-grid__col--pull-2-at-600":"mds-layout-grid__col--pull-2-at-600__pp","mds-layout-grid__col--pull-3-at-600":"mds-layout-grid__col--pull-3-at-600__pp","mds-layout-grid__col--pull-4-at-600":"mds-layout-grid__col--pull-4-at-600__pp","mds-layout-grid__col--pull-5-at-600":"mds-layout-grid__col--pull-5-at-600__pp","mds-layout-grid__col--pull-6-at-600":"mds-layout-grid__col--pull-6-at-600__pp","mds-layout-grid__col--pull-7-at-600":"mds-layout-grid__col--pull-7-at-600__pp","mds-layout-grid__col--pull-8-at-600":"mds-layout-grid__col--pull-8-at-600__pp","mds-layout-grid__col--pull-9-at-600":"mds-layout-grid__col--pull-9-at-600__pp","mds-layout-grid__col--pull-10-at-600":"mds-layout-grid__col--pull-10-at-600__pp","mds-layout-grid__col--pull-11-at-600":"mds-layout-grid__col--pull-11-at-600__pp","mds-layout-grid__col--push-0-at-600":"mds-layout-grid__col--push-0-at-600__pp","mds-layout-grid__col--push-1-at-600":"mds-layout-grid__col--push-1-at-600__pp","mds-layout-grid__col--push-2-at-600":"mds-layout-grid__col--push-2-at-600__pp","mds-layout-grid__col--push-3-at-600":"mds-layout-grid__col--push-3-at-600__pp","mds-layout-grid__col--push-4-at-600":"mds-layout-grid__col--push-4-at-600__pp","mds-layout-grid__col--push-5-at-600":"mds-layout-grid__col--push-5-at-600__pp","mds-layout-grid__col--push-6-at-600":"mds-layout-grid__col--push-6-at-600__pp","mds-layout-grid__col--push-7-at-600":"mds-layout-grid__col--push-7-at-600__pp","mds-layout-grid__col--push-8-at-600":"mds-layout-grid__col--push-8-at-600__pp","mds-layout-grid__col--push-9-at-600":"mds-layout-grid__col--push-9-at-600__pp","mds-layout-grid__col--push-10-at-600":"mds-layout-grid__col--push-10-at-600__pp","mds-layout-grid__col--push-11-at-600":"mds-layout-grid__col--push-11-at-600__pp","mds-layout-grid__col--squeeze-0-at-600":"mds-layout-grid__col--squeeze-0-at-600__pp","mds-layout-grid__col--squeeze-1-at-600":"mds-layout-grid__col--squeeze-1-at-600__pp","mds-layout-grid__col--squeeze-2-at-600":"mds-layout-grid__col--squeeze-2-at-600__pp","mds-layout-grid__col--squeeze-3-at-600":"mds-layout-grid__col--squeeze-3-at-600__pp","mds-layout-grid__col--squeeze-4-at-600":"mds-layout-grid__col--squeeze-4-at-600__pp","mds-layout-grid__col--squeeze-5-at-600":"mds-layout-grid__col--squeeze-5-at-600__pp","mds-layout-grid__col--at-768":"mds-layout-grid__col--at-768__pp","mds-layout-grid__col--auto-at-768":"mds-layout-grid__col--auto-at-768__pp","mds-layout-grid__col--1-at-768":"mds-layout-grid__col--1-at-768__pp","mds-layout-grid__col--2-at-768":"mds-layout-grid__col--2-at-768__pp","mds-layout-grid__col--3-at-768":"mds-layout-grid__col--3-at-768__pp","mds-layout-grid__col--4-at-768":"mds-layout-grid__col--4-at-768__pp","mds-layout-grid__col--5-at-768":"mds-layout-grid__col--5-at-768__pp","mds-layout-grid__col--6-at-768":"mds-layout-grid__col--6-at-768__pp","mds-layout-grid__col--7-at-768":"mds-layout-grid__col--7-at-768__pp","mds-layout-grid__col--8-at-768":"mds-layout-grid__col--8-at-768__pp","mds-layout-grid__col--9-at-768":"mds-layout-grid__col--9-at-768__pp","mds-layout-grid__col--10-at-768":"mds-layout-grid__col--10-at-768__pp","mds-layout-grid__col--11-at-768":"mds-layout-grid__col--11-at-768__pp","mds-layout-grid__col--12-at-768":"mds-layout-grid__col--12-at-768__pp","mds-layout-grid__col--pull-0-at-768":"mds-layout-grid__col--pull-0-at-768__pp","mds-layout-grid__col--pull-1-at-768":"mds-layout-grid__col--pull-1-at-768__pp","mds-layout-grid__col--pull-2-at-768":"mds-layout-grid__col--pull-2-at-768__pp","mds-layout-grid__col--pull-3-at-768":"mds-layout-grid__col--pull-3-at-768__pp","mds-layout-grid__col--pull-4-at-768":"mds-layout-grid__col--pull-4-at-768__pp","mds-layout-grid__col--pull-5-at-768":"mds-layout-grid__col--pull-5-at-768__pp","mds-layout-grid__col--pull-6-at-768":"mds-layout-grid__col--pull-6-at-768__pp","mds-layout-grid__col--pull-7-at-768":"mds-layout-grid__col--pull-7-at-768__pp","mds-layout-grid__col--pull-8-at-768":"mds-layout-grid__col--pull-8-at-768__pp","mds-layout-grid__col--pull-9-at-768":"mds-layout-grid__col--pull-9-at-768__pp","mds-layout-grid__col--pull-10-at-768":"mds-layout-grid__col--pull-10-at-768__pp","mds-layout-grid__col--pull-11-at-768":"mds-layout-grid__col--pull-11-at-768__pp","mds-layout-grid__col--push-0-at-768":"mds-layout-grid__col--push-0-at-768__pp","mds-layout-grid__col--push-1-at-768":"mds-layout-grid__col--push-1-at-768__pp","mds-layout-grid__col--push-2-at-768":"mds-layout-grid__col--push-2-at-768__pp","mds-layout-grid__col--push-3-at-768":"mds-layout-grid__col--push-3-at-768__pp","mds-layout-grid__col--push-4-at-768":"mds-layout-grid__col--push-4-at-768__pp","mds-layout-grid__col--push-5-at-768":"mds-layout-grid__col--push-5-at-768__pp","mds-layout-grid__col--push-6-at-768":"mds-layout-grid__col--push-6-at-768__pp","mds-layout-grid__col--push-7-at-768":"mds-layout-grid__col--push-7-at-768__pp","mds-layout-grid__col--push-8-at-768":"mds-layout-grid__col--push-8-at-768__pp","mds-layout-grid__col--push-9-at-768":"mds-layout-grid__col--push-9-at-768__pp","mds-layout-grid__col--push-10-at-768":"mds-layout-grid__col--push-10-at-768__pp","mds-layout-grid__col--push-11-at-768":"mds-layout-grid__col--push-11-at-768__pp","mds-layout-grid__col--squeeze-0-at-768":"mds-layout-grid__col--squeeze-0-at-768__pp","mds-layout-grid__col--squeeze-1-at-768":"mds-layout-grid__col--squeeze-1-at-768__pp","mds-layout-grid__col--squeeze-2-at-768":"mds-layout-grid__col--squeeze-2-at-768__pp","mds-layout-grid__col--squeeze-3-at-768":"mds-layout-grid__col--squeeze-3-at-768__pp","mds-layout-grid__col--squeeze-4-at-768":"mds-layout-grid__col--squeeze-4-at-768__pp","mds-layout-grid__col--squeeze-5-at-768":"mds-layout-grid__col--squeeze-5-at-768__pp","mds-layout-grid__col--at-1000":"mds-layout-grid__col--at-1000__pp","mds-layout-grid__col--auto-at-1000":"mds-layout-grid__col--auto-at-1000__pp","mds-layout-grid__col--1-at-1000":"mds-layout-grid__col--1-at-1000__pp","mds-layout-grid__col--2-at-1000":"mds-layout-grid__col--2-at-1000__pp","mds-layout-grid__col--3-at-1000":"mds-layout-grid__col--3-at-1000__pp","mds-layout-grid__col--4-at-1000":"mds-layout-grid__col--4-at-1000__pp","mds-layout-grid__col--5-at-1000":"mds-layout-grid__col--5-at-1000__pp","mds-layout-grid__col--6-at-1000":"mds-layout-grid__col--6-at-1000__pp","mds-layout-grid__col--7-at-1000":"mds-layout-grid__col--7-at-1000__pp","mds-layout-grid__col--8-at-1000":"mds-layout-grid__col--8-at-1000__pp","mds-layout-grid__col--9-at-1000":"mds-layout-grid__col--9-at-1000__pp","mds-layout-grid__col--10-at-1000":"mds-layout-grid__col--10-at-1000__pp","mds-layout-grid__col--11-at-1000":"mds-layout-grid__col--11-at-1000__pp","mds-layout-grid__col--12-at-1000":"mds-layout-grid__col--12-at-1000__pp","mds-layout-grid__col--pull-0-at-1000":"mds-layout-grid__col--pull-0-at-1000__pp","mds-layout-grid__col--pull-1-at-1000":"mds-layout-grid__col--pull-1-at-1000__pp","mds-layout-grid__col--pull-2-at-1000":"mds-layout-grid__col--pull-2-at-1000__pp","mds-layout-grid__col--pull-3-at-1000":"mds-layout-grid__col--pull-3-at-1000__pp","mds-layout-grid__col--pull-4-at-1000":"mds-layout-grid__col--pull-4-at-1000__pp","mds-layout-grid__col--pull-5-at-1000":"mds-layout-grid__col--pull-5-at-1000__pp","mds-layout-grid__col--pull-6-at-1000":"mds-layout-grid__col--pull-6-at-1000__pp","mds-layout-grid__col--pull-7-at-1000":"mds-layout-grid__col--pull-7-at-1000__pp","mds-layout-grid__col--pull-8-at-1000":"mds-layout-grid__col--pull-8-at-1000__pp","mds-layout-grid__col--pull-9-at-1000":"mds-layout-grid__col--pull-9-at-1000__pp","mds-layout-grid__col--pull-10-at-1000":"mds-layout-grid__col--pull-10-at-1000__pp","mds-layout-grid__col--pull-11-at-1000":"mds-layout-grid__col--pull-11-at-1000__pp","mds-layout-grid__col--push-0-at-1000":"mds-layout-grid__col--push-0-at-1000__pp","mds-layout-grid__col--push-1-at-1000":"mds-layout-grid__col--push-1-at-1000__pp","mds-layout-grid__col--push-2-at-1000":"mds-layout-grid__col--push-2-at-1000__pp","mds-layout-grid__col--push-3-at-1000":"mds-layout-grid__col--push-3-at-1000__pp","mds-layout-grid__col--push-4-at-1000":"mds-layout-grid__col--push-4-at-1000__pp","mds-layout-grid__col--push-5-at-1000":"mds-layout-grid__col--push-5-at-1000__pp","mds-layout-grid__col--push-6-at-1000":"mds-layout-grid__col--push-6-at-1000__pp","mds-layout-grid__col--push-7-at-1000":"mds-layout-grid__col--push-7-at-1000__pp","mds-layout-grid__col--push-8-at-1000":"mds-layout-grid__col--push-8-at-1000__pp","mds-layout-grid__col--push-9-at-1000":"mds-layout-grid__col--push-9-at-1000__pp","mds-layout-grid__col--push-10-at-1000":"mds-layout-grid__col--push-10-at-1000__pp","mds-layout-grid__col--push-11-at-1000":"mds-layout-grid__col--push-11-at-1000__pp","mds-layout-grid__col--squeeze-0-at-1000":"mds-layout-grid__col--squeeze-0-at-1000__pp","mds-layout-grid__col--squeeze-1-at-1000":"mds-layout-grid__col--squeeze-1-at-1000__pp","mds-layout-grid__col--squeeze-2-at-1000":"mds-layout-grid__col--squeeze-2-at-1000__pp","mds-layout-grid__col--squeeze-3-at-1000":"mds-layout-grid__col--squeeze-3-at-1000__pp","mds-layout-grid__col--squeeze-4-at-1000":"mds-layout-grid__col--squeeze-4-at-1000__pp","mds-layout-grid__col--squeeze-5-at-1000":"mds-layout-grid__col--squeeze-5-at-1000__pp","mds-layout-grid__col--at-1200":"mds-layout-grid__col--at-1200__pp","mds-layout-grid__col--auto-at-1200":"mds-layout-grid__col--auto-at-1200__pp","mds-layout-grid__col--1-at-1200":"mds-layout-grid__col--1-at-1200__pp","mds-layout-grid__col--2-at-1200":"mds-layout-grid__col--2-at-1200__pp","mds-layout-grid__col--3-at-1200":"mds-layout-grid__col--3-at-1200__pp","mds-layout-grid__col--4-at-1200":"mds-layout-grid__col--4-at-1200__pp","mds-layout-grid__col--5-at-1200":"mds-layout-grid__col--5-at-1200__pp","mds-layout-grid__col--6-at-1200":"mds-layout-grid__col--6-at-1200__pp","mds-layout-grid__col--7-at-1200":"mds-layout-grid__col--7-at-1200__pp","mds-layout-grid__col--8-at-1200":"mds-layout-grid__col--8-at-1200__pp","mds-layout-grid__col--9-at-1200":"mds-layout-grid__col--9-at-1200__pp","mds-layout-grid__col--10-at-1200":"mds-layout-grid__col--10-at-1200__pp","mds-layout-grid__col--11-at-1200":"mds-layout-grid__col--11-at-1200__pp","mds-layout-grid__col--12-at-1200":"mds-layout-grid__col--12-at-1200__pp","mds-layout-grid__col--pull-0-at-1200":"mds-layout-grid__col--pull-0-at-1200__pp","mds-layout-grid__col--pull-1-at-1200":"mds-layout-grid__col--pull-1-at-1200__pp","mds-layout-grid__col--pull-2-at-1200":"mds-layout-grid__col--pull-2-at-1200__pp","mds-layout-grid__col--pull-3-at-1200":"mds-layout-grid__col--pull-3-at-1200__pp","mds-layout-grid__col--pull-4-at-1200":"mds-layout-grid__col--pull-4-at-1200__pp","mds-layout-grid__col--pull-5-at-1200":"mds-layout-grid__col--pull-5-at-1200__pp","mds-layout-grid__col--pull-6-at-1200":"mds-layout-grid__col--pull-6-at-1200__pp","mds-layout-grid__col--pull-7-at-1200":"mds-layout-grid__col--pull-7-at-1200__pp","mds-layout-grid__col--pull-8-at-1200":"mds-layout-grid__col--pull-8-at-1200__pp","mds-layout-grid__col--pull-9-at-1200":"mds-layout-grid__col--pull-9-at-1200__pp","mds-layout-grid__col--pull-10-at-1200":"mds-layout-grid__col--pull-10-at-1200__pp","mds-layout-grid__col--pull-11-at-1200":"mds-layout-grid__col--pull-11-at-1200__pp","mds-layout-grid__col--push-0-at-1200":"mds-layout-grid__col--push-0-at-1200__pp","mds-layout-grid__col--push-1-at-1200":"mds-layout-grid__col--push-1-at-1200__pp","mds-layout-grid__col--push-2-at-1200":"mds-layout-grid__col--push-2-at-1200__pp","mds-layout-grid__col--push-3-at-1200":"mds-layout-grid__col--push-3-at-1200__pp","mds-layout-grid__col--push-4-at-1200":"mds-layout-grid__col--push-4-at-1200__pp","mds-layout-grid__col--push-5-at-1200":"mds-layout-grid__col--push-5-at-1200__pp","mds-layout-grid__col--push-6-at-1200":"mds-layout-grid__col--push-6-at-1200__pp","mds-layout-grid__col--push-7-at-1200":"mds-layout-grid__col--push-7-at-1200__pp","mds-layout-grid__col--push-8-at-1200":"mds-layout-grid__col--push-8-at-1200__pp","mds-layout-grid__col--push-9-at-1200":"mds-layout-grid__col--push-9-at-1200__pp","mds-layout-grid__col--push-10-at-1200":"mds-layout-grid__col--push-10-at-1200__pp","mds-layout-grid__col--push-11-at-1200":"mds-layout-grid__col--push-11-at-1200__pp","mds-layout-grid__col--squeeze-0-at-1200":"mds-layout-grid__col--squeeze-0-at-1200__pp","mds-layout-grid__col--squeeze-1-at-1200":"mds-layout-grid__col--squeeze-1-at-1200__pp","mds-layout-grid__col--squeeze-2-at-1200":"mds-layout-grid__col--squeeze-2-at-1200__pp","mds-layout-grid__col--squeeze-3-at-1200":"mds-layout-grid__col--squeeze-3-at-1200__pp","mds-layout-grid__col--squeeze-4-at-1200":"mds-layout-grid__col--squeeze-4-at-1200__pp","mds-layout-grid__col--squeeze-5-at-1200":"mds-layout-grid__col--squeeze-5-at-1200__pp"};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mds-layout-grid":"mds-layout-grid__pp","mds-layout-grid__row":"mds-layout-grid__row__pp","mds-layout-grid__row--nowrap":"mds-layout-grid__row--nowrap__pp","mds-layout-grid__col":"mds-layout-grid__col__pp","mds-layout-grid__row--justify-content-center":"mds-layout-grid__row--justify-content-center__pp","mds-layout-grid__row--justify-content-flex-end":"mds-layout-grid__row--justify-content-flex-end__pp","mds-layout-grid__row--justify-content-flex-start":"mds-layout-grid__row--justify-content-flex-start__pp","mds-layout-grid__row--justify-content-space-around":"mds-layout-grid__row--justify-content-space-around__pp","mds-layout-grid__row--justify-content-space-between":"mds-layout-grid__row--justify-content-space-between__pp","mds-layout-grid__row--align-items-stretch":"mds-layout-grid__row--align-items-stretch__pp","mds-layout-grid__row--align-items-center":"mds-layout-grid__row--align-items-center__pp","mds-layout-grid__row--align-items-flex-end":"mds-layout-grid__row--align-items-flex-end__pp","mds-layout-grid__row--align-items-flex-start":"mds-layout-grid__row--align-items-flex-start__pp","mds-layout-grid__col--align-self-auto":"mds-layout-grid__col--align-self-auto__pp","mds-layout-grid__col--align-self-center":"mds-layout-grid__col--align-self-center__pp","mds-layout-grid__col--align-self-flex-end":"mds-layout-grid__col--align-self-flex-end__pp","mds-layout-grid__col--align-self-flex-start":"mds-layout-grid__col--align-self-flex-start__pp","mds-layout-grid__row--zero-margin":"mds-layout-grid__row--zero-margin__pp","mds-layout-grid__col--zero-padding":"mds-layout-grid__col--zero-padding__pp","mds-layout-grid__col--auto":"mds-layout-grid__col--auto__pp","mds-layout-grid__col--1":"mds-layout-grid__col--1__pp","mds-layout-grid__col--2":"mds-layout-grid__col--2__pp","mds-layout-grid__col--3":"mds-layout-grid__col--3__pp","mds-layout-grid__col--4":"mds-layout-grid__col--4__pp","mds-layout-grid__col--5":"mds-layout-grid__col--5__pp","mds-layout-grid__col--6":"mds-layout-grid__col--6__pp","mds-layout-grid__col--7":"mds-layout-grid__col--7__pp","mds-layout-grid__col--8":"mds-layout-grid__col--8__pp","mds-layout-grid__col--9":"mds-layout-grid__col--9__pp","mds-layout-grid__col--10":"mds-layout-grid__col--10__pp","mds-layout-grid__col--11":"mds-layout-grid__col--11__pp","mds-layout-grid__col--12":"mds-layout-grid__col--12__pp","mds-layout-grid__col--pull-0":"mds-layout-grid__col--pull-0__pp","mds-layout-grid__col--pull-1":"mds-layout-grid__col--pull-1__pp","mds-layout-grid__col--pull-2":"mds-layout-grid__col--pull-2__pp","mds-layout-grid__col--pull-3":"mds-layout-grid__col--pull-3__pp","mds-layout-grid__col--pull-4":"mds-layout-grid__col--pull-4__pp","mds-layout-grid__col--pull-5":"mds-layout-grid__col--pull-5__pp","mds-layout-grid__col--pull-6":"mds-layout-grid__col--pull-6__pp","mds-layout-grid__col--pull-7":"mds-layout-grid__col--pull-7__pp","mds-layout-grid__col--pull-8":"mds-layout-grid__col--pull-8__pp","mds-layout-grid__col--pull-9":"mds-layout-grid__col--pull-9__pp","mds-layout-grid__col--pull-10":"mds-layout-grid__col--pull-10__pp","mds-layout-grid__col--pull-11":"mds-layout-grid__col--pull-11__pp","mds-layout-grid__col--push-0":"mds-layout-grid__col--push-0__pp","mds-layout-grid__col--push-1":"mds-layout-grid__col--push-1__pp","mds-layout-grid__col--push-2":"mds-layout-grid__col--push-2__pp","mds-layout-grid__col--push-3":"mds-layout-grid__col--push-3__pp","mds-layout-grid__col--push-4":"mds-layout-grid__col--push-4__pp","mds-layout-grid__col--push-5":"mds-layout-grid__col--push-5__pp","mds-layout-grid__col--push-6":"mds-layout-grid__col--push-6__pp","mds-layout-grid__col--push-7":"mds-layout-grid__col--push-7__pp","mds-layout-grid__col--push-8":"mds-layout-grid__col--push-8__pp","mds-layout-grid__col--push-9":"mds-layout-grid__col--push-9__pp","mds-layout-grid__col--push-10":"mds-layout-grid__col--push-10__pp","mds-layout-grid__col--push-11":"mds-layout-grid__col--push-11__pp","mds-layout-grid__col--squeeze-0":"mds-layout-grid__col--squeeze-0__pp","mds-layout-grid__col--squeeze-1":"mds-layout-grid__col--squeeze-1__pp","mds-layout-grid__col--squeeze-2":"mds-layout-grid__col--squeeze-2__pp","mds-layout-grid__col--squeeze-3":"mds-layout-grid__col--squeeze-3__pp","mds-layout-grid__col--squeeze-4":"mds-layout-grid__col--squeeze-4__pp","mds-layout-grid__col--squeeze-5":"mds-layout-grid__col--squeeze-5__pp","mds-layout-grid__col--at-600":"mds-layout-grid__col--at-600__pp","mds-layout-grid__col--auto-at-600":"mds-layout-grid__col--auto-at-600__pp","mds-layout-grid__col--1-at-600":"mds-layout-grid__col--1-at-600__pp","mds-layout-grid__col--2-at-600":"mds-layout-grid__col--2-at-600__pp","mds-layout-grid__col--3-at-600":"mds-layout-grid__col--3-at-600__pp","mds-layout-grid__col--4-at-600":"mds-layout-grid__col--4-at-600__pp","mds-layout-grid__col--5-at-600":"mds-layout-grid__col--5-at-600__pp","mds-layout-grid__col--6-at-600":"mds-layout-grid__col--6-at-600__pp","mds-layout-grid__col--7-at-600":"mds-layout-grid__col--7-at-600__pp","mds-layout-grid__col--8-at-600":"mds-layout-grid__col--8-at-600__pp","mds-layout-grid__col--9-at-600":"mds-layout-grid__col--9-at-600__pp","mds-layout-grid__col--10-at-600":"mds-layout-grid__col--10-at-600__pp","mds-layout-grid__col--11-at-600":"mds-layout-grid__col--11-at-600__pp","mds-layout-grid__col--12-at-600":"mds-layout-grid__col--12-at-600__pp","mds-layout-grid__col--pull-0-at-600":"mds-layout-grid__col--pull-0-at-600__pp","mds-layout-grid__col--pull-1-at-600":"mds-layout-grid__col--pull-1-at-600__pp","mds-layout-grid__col--pull-2-at-600":"mds-layout-grid__col--pull-2-at-600__pp","mds-layout-grid__col--pull-3-at-600":"mds-layout-grid__col--pull-3-at-600__pp","mds-layout-grid__col--pull-4-at-600":"mds-layout-grid__col--pull-4-at-600__pp","mds-layout-grid__col--pull-5-at-600":"mds-layout-grid__col--pull-5-at-600__pp","mds-layout-grid__col--pull-6-at-600":"mds-layout-grid__col--pull-6-at-600__pp","mds-layout-grid__col--pull-7-at-600":"mds-layout-grid__col--pull-7-at-600__pp","mds-layout-grid__col--pull-8-at-600":"mds-layout-grid__col--pull-8-at-600__pp","mds-layout-grid__col--pull-9-at-600":"mds-layout-grid__col--pull-9-at-600__pp","mds-layout-grid__col--pull-10-at-600":"mds-layout-grid__col--pull-10-at-600__pp","mds-layout-grid__col--pull-11-at-600":"mds-layout-grid__col--pull-11-at-600__pp","mds-layout-grid__col--push-0-at-600":"mds-layout-grid__col--push-0-at-600__pp","mds-layout-grid__col--push-1-at-600":"mds-layout-grid__col--push-1-at-600__pp","mds-layout-grid__col--push-2-at-600":"mds-layout-grid__col--push-2-at-600__pp","mds-layout-grid__col--push-3-at-600":"mds-layout-grid__col--push-3-at-600__pp","mds-layout-grid__col--push-4-at-600":"mds-layout-grid__col--push-4-at-600__pp","mds-layout-grid__col--push-5-at-600":"mds-layout-grid__col--push-5-at-600__pp","mds-layout-grid__col--push-6-at-600":"mds-layout-grid__col--push-6-at-600__pp","mds-layout-grid__col--push-7-at-600":"mds-layout-grid__col--push-7-at-600__pp","mds-layout-grid__col--push-8-at-600":"mds-layout-grid__col--push-8-at-600__pp","mds-layout-grid__col--push-9-at-600":"mds-layout-grid__col--push-9-at-600__pp","mds-layout-grid__col--push-10-at-600":"mds-layout-grid__col--push-10-at-600__pp","mds-layout-grid__col--push-11-at-600":"mds-layout-grid__col--push-11-at-600__pp","mds-layout-grid__col--squeeze-0-at-600":"mds-layout-grid__col--squeeze-0-at-600__pp","mds-layout-grid__col--squeeze-1-at-600":"mds-layout-grid__col--squeeze-1-at-600__pp","mds-layout-grid__col--squeeze-2-at-600":"mds-layout-grid__col--squeeze-2-at-600__pp","mds-layout-grid__col--squeeze-3-at-600":"mds-layout-grid__col--squeeze-3-at-600__pp","mds-layout-grid__col--squeeze-4-at-600":"mds-layout-grid__col--squeeze-4-at-600__pp","mds-layout-grid__col--squeeze-5-at-600":"mds-layout-grid__col--squeeze-5-at-600__pp","mds-layout-grid__col--at-768":"mds-layout-grid__col--at-768__pp","mds-layout-grid__col--auto-at-768":"mds-layout-grid__col--auto-at-768__pp","mds-layout-grid__col--1-at-768":"mds-layout-grid__col--1-at-768__pp","mds-layout-grid__col--2-at-768":"mds-layout-grid__col--2-at-768__pp","mds-layout-grid__col--3-at-768":"mds-layout-grid__col--3-at-768__pp","mds-layout-grid__col--4-at-768":"mds-layout-grid__col--4-at-768__pp","mds-layout-grid__col--5-at-768":"mds-layout-grid__col--5-at-768__pp","mds-layout-grid__col--6-at-768":"mds-layout-grid__col--6-at-768__pp","mds-layout-grid__col--7-at-768":"mds-layout-grid__col--7-at-768__pp","mds-layout-grid__col--8-at-768":"mds-layout-grid__col--8-at-768__pp","mds-layout-grid__col--9-at-768":"mds-layout-grid__col--9-at-768__pp","mds-layout-grid__col--10-at-768":"mds-layout-grid__col--10-at-768__pp","mds-layout-grid__col--11-at-768":"mds-layout-grid__col--11-at-768__pp","mds-layout-grid__col--12-at-768":"mds-layout-grid__col--12-at-768__pp","mds-layout-grid__col--pull-0-at-768":"mds-layout-grid__col--pull-0-at-768__pp","mds-layout-grid__col--pull-1-at-768":"mds-layout-grid__col--pull-1-at-768__pp","mds-layout-grid__col--pull-2-at-768":"mds-layout-grid__col--pull-2-at-768__pp","mds-layout-grid__col--pull-3-at-768":"mds-layout-grid__col--pull-3-at-768__pp","mds-layout-grid__col--pull-4-at-768":"mds-layout-grid__col--pull-4-at-768__pp","mds-layout-grid__col--pull-5-at-768":"mds-layout-grid__col--pull-5-at-768__pp","mds-layout-grid__col--pull-6-at-768":"mds-layout-grid__col--pull-6-at-768__pp","mds-layout-grid__col--pull-7-at-768":"mds-layout-grid__col--pull-7-at-768__pp","mds-layout-grid__col--pull-8-at-768":"mds-layout-grid__col--pull-8-at-768__pp","mds-layout-grid__col--pull-9-at-768":"mds-layout-grid__col--pull-9-at-768__pp","mds-layout-grid__col--pull-10-at-768":"mds-layout-grid__col--pull-10-at-768__pp","mds-layout-grid__col--pull-11-at-768":"mds-layout-grid__col--pull-11-at-768__pp","mds-layout-grid__col--push-0-at-768":"mds-layout-grid__col--push-0-at-768__pp","mds-layout-grid__col--push-1-at-768":"mds-layout-grid__col--push-1-at-768__pp","mds-layout-grid__col--push-2-at-768":"mds-layout-grid__col--push-2-at-768__pp","mds-layout-grid__col--push-3-at-768":"mds-layout-grid__col--push-3-at-768__pp","mds-layout-grid__col--push-4-at-768":"mds-layout-grid__col--push-4-at-768__pp","mds-layout-grid__col--push-5-at-768":"mds-layout-grid__col--push-5-at-768__pp","mds-layout-grid__col--push-6-at-768":"mds-layout-grid__col--push-6-at-768__pp","mds-layout-grid__col--push-7-at-768":"mds-layout-grid__col--push-7-at-768__pp","mds-layout-grid__col--push-8-at-768":"mds-layout-grid__col--push-8-at-768__pp","mds-layout-grid__col--push-9-at-768":"mds-layout-grid__col--push-9-at-768__pp","mds-layout-grid__col--push-10-at-768":"mds-layout-grid__col--push-10-at-768__pp","mds-layout-grid__col--push-11-at-768":"mds-layout-grid__col--push-11-at-768__pp","mds-layout-grid__col--squeeze-0-at-768":"mds-layout-grid__col--squeeze-0-at-768__pp","mds-layout-grid__col--squeeze-1-at-768":"mds-layout-grid__col--squeeze-1-at-768__pp","mds-layout-grid__col--squeeze-2-at-768":"mds-layout-grid__col--squeeze-2-at-768__pp","mds-layout-grid__col--squeeze-3-at-768":"mds-layout-grid__col--squeeze-3-at-768__pp","mds-layout-grid__col--squeeze-4-at-768":"mds-layout-grid__col--squeeze-4-at-768__pp","mds-layout-grid__col--squeeze-5-at-768":"mds-layout-grid__col--squeeze-5-at-768__pp","mds-layout-grid__col--at-1000":"mds-layout-grid__col--at-1000__pp","mds-layout-grid__col--auto-at-1000":"mds-layout-grid__col--auto-at-1000__pp","mds-layout-grid__col--1-at-1000":"mds-layout-grid__col--1-at-1000__pp","mds-layout-grid__col--2-at-1000":"mds-layout-grid__col--2-at-1000__pp","mds-layout-grid__col--3-at-1000":"mds-layout-grid__col--3-at-1000__pp","mds-layout-grid__col--4-at-1000":"mds-layout-grid__col--4-at-1000__pp","mds-layout-grid__col--5-at-1000":"mds-layout-grid__col--5-at-1000__pp","mds-layout-grid__col--6-at-1000":"mds-layout-grid__col--6-at-1000__pp","mds-layout-grid__col--7-at-1000":"mds-layout-grid__col--7-at-1000__pp","mds-layout-grid__col--8-at-1000":"mds-layout-grid__col--8-at-1000__pp","mds-layout-grid__col--9-at-1000":"mds-layout-grid__col--9-at-1000__pp","mds-layout-grid__col--10-at-1000":"mds-layout-grid__col--10-at-1000__pp","mds-layout-grid__col--11-at-1000":"mds-layout-grid__col--11-at-1000__pp","mds-layout-grid__col--12-at-1000":"mds-layout-grid__col--12-at-1000__pp","mds-layout-grid__col--pull-0-at-1000":"mds-layout-grid__col--pull-0-at-1000__pp","mds-layout-grid__col--pull-1-at-1000":"mds-layout-grid__col--pull-1-at-1000__pp","mds-layout-grid__col--pull-2-at-1000":"mds-layout-grid__col--pull-2-at-1000__pp","mds-layout-grid__col--pull-3-at-1000":"mds-layout-grid__col--pull-3-at-1000__pp","mds-layout-grid__col--pull-4-at-1000":"mds-layout-grid__col--pull-4-at-1000__pp","mds-layout-grid__col--pull-5-at-1000":"mds-layout-grid__col--pull-5-at-1000__pp","mds-layout-grid__col--pull-6-at-1000":"mds-layout-grid__col--pull-6-at-1000__pp","mds-layout-grid__col--pull-7-at-1000":"mds-layout-grid__col--pull-7-at-1000__pp","mds-layout-grid__col--pull-8-at-1000":"mds-layout-grid__col--pull-8-at-1000__pp","mds-layout-grid__col--pull-9-at-1000":"mds-layout-grid__col--pull-9-at-1000__pp","mds-layout-grid__col--pull-10-at-1000":"mds-layout-grid__col--pull-10-at-1000__pp","mds-layout-grid__col--pull-11-at-1000":"mds-layout-grid__col--pull-11-at-1000__pp","mds-layout-grid__col--push-0-at-1000":"mds-layout-grid__col--push-0-at-1000__pp","mds-layout-grid__col--push-1-at-1000":"mds-layout-grid__col--push-1-at-1000__pp","mds-layout-grid__col--push-2-at-1000":"mds-layout-grid__col--push-2-at-1000__pp","mds-layout-grid__col--push-3-at-1000":"mds-layout-grid__col--push-3-at-1000__pp","mds-layout-grid__col--push-4-at-1000":"mds-layout-grid__col--push-4-at-1000__pp","mds-layout-grid__col--push-5-at-1000":"mds-layout-grid__col--push-5-at-1000__pp","mds-layout-grid__col--push-6-at-1000":"mds-layout-grid__col--push-6-at-1000__pp","mds-layout-grid__col--push-7-at-1000":"mds-layout-grid__col--push-7-at-1000__pp","mds-layout-grid__col--push-8-at-1000":"mds-layout-grid__col--push-8-at-1000__pp","mds-layout-grid__col--push-9-at-1000":"mds-layout-grid__col--push-9-at-1000__pp","mds-layout-grid__col--push-10-at-1000":"mds-layout-grid__col--push-10-at-1000__pp","mds-layout-grid__col--push-11-at-1000":"mds-layout-grid__col--push-11-at-1000__pp","mds-layout-grid__col--squeeze-0-at-1000":"mds-layout-grid__col--squeeze-0-at-1000__pp","mds-layout-grid__col--squeeze-1-at-1000":"mds-layout-grid__col--squeeze-1-at-1000__pp","mds-layout-grid__col--squeeze-2-at-1000":"mds-layout-grid__col--squeeze-2-at-1000__pp","mds-layout-grid__col--squeeze-3-at-1000":"mds-layout-grid__col--squeeze-3-at-1000__pp","mds-layout-grid__col--squeeze-4-at-1000":"mds-layout-grid__col--squeeze-4-at-1000__pp","mds-layout-grid__col--squeeze-5-at-1000":"mds-layout-grid__col--squeeze-5-at-1000__pp","mds-layout-grid__col--at-1200":"mds-layout-grid__col--at-1200__pp","mds-layout-grid__col--auto-at-1200":"mds-layout-grid__col--auto-at-1200__pp","mds-layout-grid__col--1-at-1200":"mds-layout-grid__col--1-at-1200__pp","mds-layout-grid__col--2-at-1200":"mds-layout-grid__col--2-at-1200__pp","mds-layout-grid__col--3-at-1200":"mds-layout-grid__col--3-at-1200__pp","mds-layout-grid__col--4-at-1200":"mds-layout-grid__col--4-at-1200__pp","mds-layout-grid__col--5-at-1200":"mds-layout-grid__col--5-at-1200__pp","mds-layout-grid__col--6-at-1200":"mds-layout-grid__col--6-at-1200__pp","mds-layout-grid__col--7-at-1200":"mds-layout-grid__col--7-at-1200__pp","mds-layout-grid__col--8-at-1200":"mds-layout-grid__col--8-at-1200__pp","mds-layout-grid__col--9-at-1200":"mds-layout-grid__col--9-at-1200__pp","mds-layout-grid__col--10-at-1200":"mds-layout-grid__col--10-at-1200__pp","mds-layout-grid__col--11-at-1200":"mds-layout-grid__col--11-at-1200__pp","mds-layout-grid__col--12-at-1200":"mds-layout-grid__col--12-at-1200__pp","mds-layout-grid__col--pull-0-at-1200":"mds-layout-grid__col--pull-0-at-1200__pp","mds-layout-grid__col--pull-1-at-1200":"mds-layout-grid__col--pull-1-at-1200__pp","mds-layout-grid__col--pull-2-at-1200":"mds-layout-grid__col--pull-2-at-1200__pp","mds-layout-grid__col--pull-3-at-1200":"mds-layout-grid__col--pull-3-at-1200__pp","mds-layout-grid__col--pull-4-at-1200":"mds-layout-grid__col--pull-4-at-1200__pp","mds-layout-grid__col--pull-5-at-1200":"mds-layout-grid__col--pull-5-at-1200__pp","mds-layout-grid__col--pull-6-at-1200":"mds-layout-grid__col--pull-6-at-1200__pp","mds-layout-grid__col--pull-7-at-1200":"mds-layout-grid__col--pull-7-at-1200__pp","mds-layout-grid__col--pull-8-at-1200":"mds-layout-grid__col--pull-8-at-1200__pp","mds-layout-grid__col--pull-9-at-1200":"mds-layout-grid__col--pull-9-at-1200__pp","mds-layout-grid__col--pull-10-at-1200":"mds-layout-grid__col--pull-10-at-1200__pp","mds-layout-grid__col--pull-11-at-1200":"mds-layout-grid__col--pull-11-at-1200__pp","mds-layout-grid__col--push-0-at-1200":"mds-layout-grid__col--push-0-at-1200__pp","mds-layout-grid__col--push-1-at-1200":"mds-layout-grid__col--push-1-at-1200__pp","mds-layout-grid__col--push-2-at-1200":"mds-layout-grid__col--push-2-at-1200__pp","mds-layout-grid__col--push-3-at-1200":"mds-layout-grid__col--push-3-at-1200__pp","mds-layout-grid__col--push-4-at-1200":"mds-layout-grid__col--push-4-at-1200__pp","mds-layout-grid__col--push-5-at-1200":"mds-layout-grid__col--push-5-at-1200__pp","mds-layout-grid__col--push-6-at-1200":"mds-layout-grid__col--push-6-at-1200__pp","mds-layout-grid__col--push-7-at-1200":"mds-layout-grid__col--push-7-at-1200__pp","mds-layout-grid__col--push-8-at-1200":"mds-layout-grid__col--push-8-at-1200__pp","mds-layout-grid__col--push-9-at-1200":"mds-layout-grid__col--push-9-at-1200__pp","mds-layout-grid__col--push-10-at-1200":"mds-layout-grid__col--push-10-at-1200__pp","mds-layout-grid__col--push-11-at-1200":"mds-layout-grid__col--push-11-at-1200__pp","mds-layout-grid__col--squeeze-0-at-1200":"mds-layout-grid__col--squeeze-0-at-1200__pp","mds-layout-grid__col--squeeze-1-at-1200":"mds-layout-grid__col--squeeze-1-at-1200__pp","mds-layout-grid__col--squeeze-2-at-1200":"mds-layout-grid__col--squeeze-2-at-1200__pp","mds-layout-grid__col--squeeze-3-at-1200":"mds-layout-grid__col--squeeze-3-at-1200__pp","mds-layout-grid__col--squeeze-4-at-1200":"mds-layout-grid__col--squeeze-4-at-1200__pp","mds-layout-grid__col--squeeze-5-at-1200":"mds-layout-grid__col--squeeze-5-at-1200__pp"};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mds-list-group":"mds-list-group__pp","mds-component--on-dark":"mds-component--on-dark__pp","mds-list-group__item":"mds-list-group__item__pp","mds-list-group__item--separator-before":"mds-list-group__item--separator-before__pp","mds-list-group__item--sublist":"mds-list-group__item--sublist__pp","mds-list-group__link":"mds-list-group__link__pp","mds-list-group__left-icon":"mds-list-group__left-icon__pp","mds-list-group__item--active":"mds-list-group__item--active__pp","mds-list-group__item-metadata":"mds-list-group__item-metadata__pp","mds-list-group__item-metadata-below":"mds-list-group__item-metadata-below__pp","mds-list-group__item-metadata-below-item":"mds-list-group__item-metadata-below-item__pp","mds-list-group__item-microcopy":"mds-list-group__item-microcopy__pp","mds-list-group__active-icon":"mds-list-group__active-icon__pp","mds-list-group__toggle":"mds-list-group__toggle__pp","mds-list-group__toggle-icon":"mds-list-group__toggle-icon__pp","mds-list-group__selection-input":"mds-list-group__selection-input__pp","mds-list-group__selection":"mds-list-group__selection__pp","mds-list-group--small":"mds-list-group--small__pp","mds-list-group__item-text":"mds-list-group__item-text__pp","mds-list-group--with-icon":"mds-list-group--with-icon__pp","mds-list-group__item-image":"mds-list-group__item-image__pp","mds-list-group__right-icon":"mds-list-group__right-icon__pp","mds-list-group__toggle-text":"mds-list-group__toggle-text__pp","mds-list-group--large":"mds-list-group--large__pp","mds-list-group--touch":"mds-list-group--touch__pp","mds-list-group__item--disabled":"mds-list-group__item--disabled__pp","mds-list-group__navigation":"mds-list-group__navigation__pp","mds-list-group__active-indicator":"mds-list-group__active-indicator__pp","mds-list-group__toggle-input":"mds-list-group__toggle-input__pp","mds-list-group__link--with-image":"mds-list-group__link--with-image__pp","mds-list-group__item-image--round":"mds-list-group__item-image--round__pp"};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mds-list-group":"mds-list-group__pp","mds-component--on-dark":"mds-component--on-dark__pp","mds-list-group__item":"mds-list-group__item__pp","mds-list-group__item--separator-before":"mds-list-group__item--separator-before__pp","mds-list-group__item--sublist":"mds-list-group__item--sublist__pp","mds-list-group__link":"mds-list-group__link__pp","mds-list-group__left-icon":"mds-list-group__left-icon__pp","mds-list-group__item--active":"mds-list-group__item--active__pp","mds-list-group__item-metadata":"mds-list-group__item-metadata__pp","mds-list-group__item-metadata-below":"mds-list-group__item-metadata-below__pp","mds-list-group__item-metadata-below-item":"mds-list-group__item-metadata-below-item__pp","mds-list-group__item-microcopy":"mds-list-group__item-microcopy__pp","mds-list-group__active-icon":"mds-list-group__active-icon__pp","mds-list-group__toggle":"mds-list-group__toggle__pp","mds-list-group__toggle-icon":"mds-list-group__toggle-icon__pp","mds-list-group__selection-input":"mds-list-group__selection-input__pp","mds-list-group__selection":"mds-list-group__selection__pp","mds-list-group--small":"mds-list-group--small__pp","mds-list-group__item-text":"mds-list-group__item-text__pp","mds-list-group--with-icon":"mds-list-group--with-icon__pp","mds-list-group__item-image":"mds-list-group__item-image__pp","mds-list-group__right-icon":"mds-list-group__right-icon__pp","mds-list-group__toggle-text":"mds-list-group__toggle-text__pp","mds-list-group--large":"mds-list-group--large__pp","mds-list-group--touch":"mds-list-group--touch__pp","mds-list-group__item--disabled":"mds-list-group__item--disabled__pp","mds-list-group__navigation":"mds-list-group__navigation__pp","mds-list-group__active-indicator":"mds-list-group__active-indicator__pp","mds-list-group__toggle-input":"mds-list-group__toggle-input__pp","mds-list-group__link--with-image":"mds-list-group__link--with-image__pp","mds-list-group__item-image--round":"mds-list-group__item-image--round__pp"};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mds-section":"mds-section__pp","mds-component--on-dark":"mds-component--on-dark__pp","mds-section__title":"mds-section__title__pp","mds-section__content":"mds-section__content__pp","mds-section__title-description":"mds-section__title-description__pp","mds-section__actions":"mds-section__actions__pp","mds-section--container":"mds-section--container__pp","mds-section--collapsible":"mds-section--collapsible__pp","mds-section__toggle":"mds-section__toggle__pp","mds-section__header-container":"mds-section__header-container__pp","mds-section--border-bottom":"mds-section--border-bottom__pp","mds-section--expanded":"mds-section--expanded__pp","mds-section--primary":"mds-section--primary__pp","mds-section--tertiary":"mds-section--tertiary__pp","mds-section--none":"mds-section--none__pp","mds-section--level-1":"mds-section--level-1__pp","mds-section--level-2":"mds-section--level-2__pp","mds-section--secondary":"mds-section--secondary__pp","mds-section--level-3":"mds-section--level-3__pp","mds-section--level-4":"mds-section--level-4__pp","mds-section--level-5":"mds-section--level-5__pp","mds-section--level-6":"mds-section--level-6__pp","mds-section--level-7":"mds-section--level-7__pp","mds-section--level-8":"mds-section--level-8__pp","mds-section--level-9":"mds-section--level-9__pp","mds-section__supplemental-content":"mds-section__supplemental-content__pp","mds-section--font-bold":"mds-section--font-bold__pp"};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mds-tabs":"mds-tabs__pp","mds-tabs--large":"mds-tabs--large__pp","mds-tabs__item":"mds-tabs__item__pp","mds-button":"mds-button__pp","mds-component--on-dark":"mds-component--on-dark__pp","mds-tabs__item--active":"mds-tabs__item--active__pp","mds-tabs--site-navigation":"mds-tabs--site-navigation__pp","mds-tabs__inner":"mds-tabs__inner__pp","mds-tabs--centered":"mds-tabs--centered__pp","mds-tabs--responsive":"mds-tabs--responsive__pp","mds-tabs--responsive-left":"mds-tabs--responsive-left__pp","mds-tabs--responsive-right":"mds-tabs--responsive-right__pp"};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mds-tabs":"mds-tabs__pp","mds-tabs--large":"mds-tabs--large__pp","mds-tabs__item":"mds-tabs__item__pp","mds-button":"mds-button__pp","mds-component--on-dark":"mds-component--on-dark__pp","mds-tabs__item--active":"mds-tabs__item--active__pp","mds-tabs--site-navigation":"mds-tabs--site-navigation__pp","mds-tabs__inner":"mds-tabs__inner__pp","mds-tabs--centered":"mds-tabs--centered__pp","mds-tabs--responsive":"mds-tabs--responsive__pp","mds-tabs--responsive-left":"mds-tabs--responsive-left__pp","mds-tabs--responsive-right":"mds-tabs--responsive-right__pp"};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"mwc-pp-scenario-analysis":"mwc-pp-scenario-analysis__pp","mwc-pp-scenario-analysis__left-section":"mwc-pp-scenario-analysis__left-section__pp","mwc-pp-scenario-analysis__right-section":"mwc-pp-scenario-analysis__right-section__pp","mwc-pp-scenario-analysis__top-market":"mwc-pp-scenario-analysis__top-market__pp","mds-section__title":"mds-section__title__pp","mwc-pp-scenario-analysis__what-if":"mwc-pp-scenario-analysis__what-if__pp","mds-section__header-container":"mds-section__header-container__pp","mds-section__content":"mds-section__content__pp","mwc-pp-scenario-analysis__tabs":"mwc-pp-scenario-analysis__tabs__pp","mds-button":"mds-button__pp","mwc-pp-scenario-analysis__cards":"mwc-pp-scenario-analysis__cards__pp","mwc-pp-scenario-analysis__cards-card":"mwc-pp-scenario-analysis__cards-card__pp","mwc-pp-scenario-analysis__chart":"mwc-pp-scenario-analysis__chart__pp","mds-loader":"mds-loader__pp"};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _tabs_item_vue_vue_type_template_id_9e7712ba___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(165);
/* harmony import */ var _tabs_item_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94);
/* harmony import */ var _tabs_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(148);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_tabs_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"].locals || _tabs_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _tabs_item_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _tabs_item_vue_vue_type_template_id_9e7712ba___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _tabs_item_vue_vue_type_template_id_9e7712ba___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/node_modules/@mds/tabs/src/tabs-item.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(251);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(256);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(257);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(184);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(261);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(262);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(263);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(269);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(113);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/lodash/find.js
var find = __webpack_require__(43);
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(33);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/lodash/each.js
var each = __webpack_require__(25);
var each_default = /*#__PURE__*/__webpack_require__.n(each);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/lodash/map.js
var map = __webpack_require__(235);
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(128);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(7);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(375);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(35);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(37);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/mwc-vue-component-helper/dist/main.js
var main = __webpack_require__(98);
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/lodash/isNil.js
var isNil = __webpack_require__(236);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__(377);

// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/ec-mwc-component-helper/src/usage-tracking-mixin.js



/* harmony default export */ var usage_tracking_mixin = ({
  created: function created() {
    this.enableUsageTrackingLogging = false;
    this.componentLoadWaitsOn = [];
    this.componentLoadStartTime = Date.now();
  },
  mounted: function mounted() {
    var _this = this;

    // Should we log usage tracking events in the current component or just bubble up to the parent tool?
    this.logUsageTrackingEvents = isNil_default()(this.settings.logUsageTrackingEvents) ? this.isTopLevelComponent() : this.settings.logUsageTrackingEvents; // Listen for events raised by child components

    this.$el.addEventListener('component-loaded', this.componentLoaded);
    this.$el.addEventListener('usage-tracking-action', this.handleUsageTrackingEvent);
    this.$nextTick(function () {
      _this.enableUsageTrackingLogging = true;
    });
  },
  methods: {
    componentLoaded: function componentLoaded(e) {
      e.stopPropagation(); // This handles the component-loaded event and checks to see if all the required child components are loaded
      // If the child components are all loaded then the "component-loaded" event is dispatched for this component

      var childMwcId = e.detail && e.detail.mwcId;
      var secIds = e.detail && e.detail.secIds;
      var index = this.componentLoadWaitsOn.indexOf(childMwcId);

      if (index > -1) {
        this.componentLoadWaitsOn.splice(index, 1);

        if (this.componentLoadWaitsOn.length === 0) {
          this.$el.removeEventListener('component-loaded', this.componentLoaded); // Check if we can call the getMwcToolName and getMwcComponentName methods on the base mixin (needs v2.17.0 of mwc-vue-component-helper)
          // Otherwise default to the current component name

          var tool = this.getMwcToolName && this.getMwcToolName(this.$options.name);
          var component = this.getMwcComponentName && this.getMwcComponentName(this.$options.name);
          this.logUsageTrackingEvent({
            mwcId: this.mwcId,
            action: 'componentLoaded',
            tool: tool || this.$options.name,
            component: component || this.$options.name,
            primaryValue: this.$options.name,
            startTime: this.componentLoadStartTime,
            endTime: Date.now(),
            secIds: secIds
          });
          this.raiseComponentLoaded();
        }
      }
    },
    handleUsageTrackingEvent: function handleUsageTrackingEvent(e) {
      // Let the event bubble up until it reaches a component that will log it
      if (e && e.detail && this.logUsageTrackingEvents) {
        e.stopPropagation();
        this.logUsageTrackingEvent(e.detail);
      }
    },
    isTopLevelComponent: function isTopLevelComponent() {
      return this.mwcId.indexOf('.') === -1;
    },
    logUsageTrackingEvent: function logUsageTrackingEvent(options) {
      var _this$logger$supports;

      // tool - the name of the tool or component doing the logging
      // component - the name of the child component that triggered the event
      options.tool = options.tool || this.$options.name;
      options.mwcId = options.mwcId || this.mwcId; // Pass object param with tool and component if the current version of mwc logger supports it, otherwise pass separate params

      if ((_this$logger$supports = this.logger.supports) !== null && _this$logger$supports !== void 0 && _this$logger$supports.usageObject) {
        this.logger.usage(options);
      } else {
        this.logger.usage(options.mwcId, options.action, options.primaryValue, options.secondaryValue, options.startTime, options.endTime, options.secIds);
      }
    },
    raiseComponentLoaded: function raiseComponentLoaded() {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$options.name;
      var mwcId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.mwcId;
      // Emit the "component-loaded" event to inform upstream components that the specified component has loaded
      this.$el.dispatchEvent(new CustomEvent('component-loaded', {
        bubbles: true,
        detail: {
          tag: tag,
          mwcId: mwcId
        }
      }));
    },
    raiseUsageTrackingEvent: function raiseUsageTrackingEvent(options) {
      // Emit the "usage-tracking-action" event to inform upstream components that an event has been triggered
      this.$el.dispatchEvent(new CustomEvent('usage-tracking-action', {
        bubbles: true,
        detail: options
      }));
    },
    setComponentLoadWaitsOn: function setComponentLoadWaitsOn(components) {
      // Set the list of components this component must wait on before it is considered loaded
      this.componentLoadWaitsOn = components;
    },
    trackUsageEvent: function trackUsageEvent(options) {
      var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // Ignore events triggered on load unless immediate is true
      if (!this.enableUsageTrackingLogging && !immediate) {
        return;
      } // Log the mwcId of the component triggering the event


      options.mwcId = this.mwcId; // Add the source component to the options

      options.component = this.$options.name; // Either log the event directly or dispatch it for the parent to handle

      if (this.logUsageTrackingEvents) {
        this.logUsageTrackingEvent(options);
      } else {
        this.raiseUsageTrackingEvent(options);
      }
    }
  }
});
// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/button/src/index.js
var src = __webpack_require__(17);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/dialog/src/dialog.vue
var dialog = __webpack_require__(238);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/layout-grid.vue
var layout_grid = __webpack_require__(228);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/row.vue
var row = __webpack_require__(229);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/col.vue
var col = __webpack_require__(230);

// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/index.js




// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/list-group/src/list-group.vue
var list_group = __webpack_require__(231);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/list-group/src/list-group-item.vue
var list_group_item = __webpack_require__(232);

// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/list-group/src/index.js



// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/loader/src/loader.vue
var loader = __webpack_require__(97);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/section/src/section.vue
var section = __webpack_require__(239);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/tabs/src/tabs.vue
var tabs = __webpack_require__(130);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/tabs/src/tabs-item.vue
var tabs_item = __webpack_require__(81);

// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/tabs/src/index.js



/* harmony default export */ var tabs_src = (tabs["a" /* default */]);
// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/lodash/extend.js
var extend = __webpack_require__(240);
var extend_default = /*#__PURE__*/__webpack_require__.n(extend);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(227);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(226);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/d3/d3.js
var d3 = __webpack_require__(99);
var d3_default = /*#__PURE__*/__webpack_require__.n(d3);

// EXTERNAL MODULE: ./node_modules/mbc/dist/mbc-time-series-line.js
var mbc_time_series_line = __webpack_require__(241);
var mbc_time_series_line_default = /*#__PURE__*/__webpack_require__.n(mbc_time_series_line);

// CONCATENATED MODULE: ./packages/pp-scenario-analysis/src/line-chart-service.js







 // eslint-disable-line import/no-unresolved, import/extensions

/* harmony default export */ var line_chart_service = ({
  options: null,
  settings: null,
  labels: null,
  format: null,
  init: function init(options, settings, labels, format) {
    this.options = options;
    this.settings = settings;
    this.labels = labels;
    this.format = format;
  },
  drawChart: function drawChart(chartContainerId, chartData) {
    var data = this.replaceLabelKeys(chartData);
    var chart = this.initChart(chartData);

    if (chart) {
      d3_default.a.select("#".concat(chartContainerId)).datum(data).call(chart.init());
      chart.set('initialized', true);
    }
  },
  removeChart: function removeChart(chartContainerId) {
    var myNode = document.getElementById(chartContainerId);

    while (myNode && myNode.firstChild) {
      myNode.removeChild(myNode.firstChild);
    }
  },
  updateChart: function updateChart(chartContainerId, chartData) {
    this.removeChart(chartContainerId);
    this.drawChart(chartContainerId, chartData);
  },
  initChart: function initChart(chartData) {
    var formatOptions = 'shortDecimal';
    var numberFormatFn = this.format.number;
    var currency = this.settings.currencyId;
    var currencySymbol = this.format.currency(0, currency);
    currencySymbol = currencySymbol.substring(0, currencySymbol.indexOf('0'));
    var chart = null;

    if (chartData) {
      var chartSettings = this.settings.timeSeriesLineChartSettings;
      chart = new mbc_time_series_line_default.a(extend_default()({
        format: function format(number) {
          return numberFormatFn(number, formatOptions);
        },
        parseFormat: function parseFormat(date) {
          return d3_default.a.time.format('%Y%m%d').parse(date);
        },
        legendValuesFormat: d3_default.a.format('$.2f'),
        originData: chartData,
        y1TickSymbol: currencySymbol
      }, chartSettings));
    }

    return chart;
  },
  replaceLabelKeys: function replaceLabelKeys(chartData) {
    var self = this;

    if (chartData) {
      // The "for" loop below is to mimick the API returning Date() objects in the dataset for this working example
      Object.keys(chartData).forEach(function (key) {
        chartData[key].map(function (item) {
          if (item.date) {
            item.date = new Date(item.date);
          }

          if (!item.name) {
            item.name = self.labels.getLabel('value');
          }

          return item;
        });
      });
    }

    return chartData;
  }
});
// EXTERNAL MODULE: ./packages/pp-scenario-analysis/src/config/components.json
var components = __webpack_require__(242);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/src/config/labels.json
var labels = __webpack_require__(243);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/src/config/settings.json
var settings = __webpack_require__(244);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/src/blueprints/standard-us/standard-us.json
var standard_us = __webpack_require__(245);

// CONCATENATED MODULE: ./packages/pp-scenario-analysis/src/blueprints/index.js

/* harmony default export */ var blueprints = ({
  standardUs: standard_us
});
// EXTERNAL MODULE: ./packages/pp-scenario-analysis/src/config/usage-tracking-events.json
var usage_tracking_events = __webpack_require__(151);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./packages/pp-scenario-analysis/src/pp-scenario-analysis.js?vue&type=script&lang=js&














function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }






















/* harmony default export */ var pp_scenario_analysisvue_type_script_lang_js_ = ({
  name: 'mwc-pp-scenario-analysis',
  mixins: [main_default.a, main["MwcConfigMixin"], main["MwcLayoutMixin"], usage_tracking_mixin],
  components: {
    MdsButton: src["a" /* MdsButton */],
    MdsButtonContainer: src["b" /* MdsButtonContainer */],
    MdsDialog: dialog["a" /* default */],
    MdsLoader: loader["a" /* default */],
    MdsLayoutGrid: layout_grid["a" /* default */],
    MdsRow: row["a" /* default */],
    MdsCol: col["a" /* default */],
    MdsListGroup: list_group["a" /* default */],
    MdsListGroupItem: list_group_item["a" /* default */],
    MdsSection: section["a" /* default */],
    MdsTabs: tabs["a" /* default */],
    MdsTabsItem: tabs_item["a" /* default */]
  },
  props: {
    growth10KModel: {
      type: Object
    },
    customScenarios: {
      type: Object
    },
    portfolios: {
      type: Array
    },
    periodReturnModel: {
      type: Object
    },
    riskModelId: {
      type: String
    },
    scenariosModel: {
      type: Object
    },
    startValue: {
      type: Number
    }
  },
  data: function data() {
    return {
      cardDataList: null,
      loading: false,
      selectedScenario: null,
      scenarios: null,
      tabsContent: null,
      defaultConfig: {
        type: 'mwcPpScenarioAnalysis',
        blueprints: blueprints,
        settings: settings,
        components: components,
        labels: labels,
        intlNamespace: this.mwcId
      }
    };
  },
  computed: {
    chartContainerId: function chartContainerId() {
      return this.getNamespaceId('mbc-line-chart');
    }
  },
  watch: {
    customScenarios: {
      handler: function handler(newValue, oldValue) {
        var _this = this;

        if (newValue !== oldValue && newValue && newValue.data) {
          var customScenario = cloneDeep_default()(newValue.data);

          each_default()(customScenario, function (item, index) {
            if (index === 0 && !_this.selectedScenario) {
              item.active = true;
              item.name = item.scenarioName;
              item.id = item.scenarioId;
              _this.selectedScenario = item;
            } else {
              item.active = false;
              item.name = item.scenarioName;
              item.id = item.scenarioId;
            }
          });

          this.scenarios = this.scenarios && this.scenarios.length ? [].concat(_toConsumableArray(this.scenarios), _toConsumableArray(customScenario)) : _toConsumableArray(customScenario);
          this.getPeriodReturn();
        }
      },
      deep: true
    },
    scenariosModel: {
      handler: function handler(newValue, oldValue) {
        var _this2 = this;

        if (newValue !== oldValue && newValue && newValue.data && newValue.data.scenarios) {
          this.scenarios = cloneDeep_default()(newValue.data.scenarios);

          each_default()(this.scenarios, function (item, index) {
            if (index === 0 && !_this2.selectedScenario) {
              item.active = true;
              _this2.selectedScenario = item;
            } else {
              item.active = false;
            }
          });

          this.getPeriodReturn();
        }
      },
      deep: true
    },
    periodReturnModel: {
      handler: function handler(newValue, oldValue) {
        if (newValue !== oldValue && newValue && newValue.scenarios) {
          this.raiseComponentLoaded('mwc-pp-sa-data', "".concat(this.mwcId, ".saData"));
          this.renderCards(newValue.scenarios);
        }
      },
      deep: true
    },
    growth10KModel: {
      handler: function handler(newValue, oldValue) {
        if (newValue !== oldValue && newValue && newValue.scenarios) {
          this.drawChart(newValue.scenarios);
        }
      },
      deep: true
    },
    'options.portfolios': {
      handler: function handler(newValue, oldValue) {
        if (newValue !== oldValue && newValue) {
          this.loadScenarios();
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.componentLoadWaitsOn = ["".concat(this.mwcId, ".saData")];
    this.$nextTick(function () {
      _this3.tabsContent = cloneDeep_default()(_this3.settings.tabsContent);

      map_default()(_this3.tabsContent, function (tab) {
        tab.text = tab.show ? _this3.labeller.getLabel(tab.text) : null;
        return tab;
      });

      line_chart_service.init(_this3.options, _this3.settings, _this3.labeller, _this3.formatter);
    });
  },
  methods: {
    loadScenarios: function loadScenarios() {
      if (this.settings.showDefaultScenarios) {
        this.getScenarios();
      }

      if (this.settings.showMacroShockScenarios) {
        this.getMacroShockScenarios();
      }

      if (this.settings.showMarketShockScenarios) {
        this.getMarketShockScenarios();
      }

      if (this.settings.showCustomScenarios) {
        this.getCustomScenarios();
      }
    },
    getPeriodReturn: function getPeriodReturn() {
      if (!this.selectedScenario) {
        return;
      }

      var radomId = this.generateRandomId();
      var dataSourceId = "".concat(this.mwcId, "-").concat(this.selectedScenario.id, "-calculatePeriodReturn-").concat(radomId);
      var parameters = Object.assign({}, this.getMwcDataManagerParameters(), {
        dataSourceId: dataSourceId,
        riskModelId: this.options.riskModelId,
        scenarios: [this.selectedScenario.id],
        portfolios: this.options.portfolios,
        amount: this.options.startValue
      });
      this.callApi(dataSourceId, parameters, 'periodReturnModel', 'calculatePeriodReturn');
    },
    generateRandomId: function generateRandomId() {
      return Math.floor(Math.random() * 100 + 1);
    },
    getLanguageId: function getLanguageId() {
      return (this.settings.languageId || 'en-US').toLowerCase();
    },
    getScenarios: function getScenarios() {
      var radomId = this.generateRandomId();
      var dataSourceId = "".concat(this.mwcId, "-scenarios-").concat(radomId);
      var parameters = Object.assign({}, this.getMwcDataManagerParameters(), {
        riskModelId: this.options.riskModelId
      });
      this.callApi(dataSourceId, parameters, 'scenariosModel', 'scenarios');
    },
    getGrowth10K: function getGrowth10K() {
      if (!this.selectedScenario) {
        return;
      }

      var dataSourceId = "".concat(this.mwcId, "-").concat(this.selectedScenario.id, "-calculateTenKGrowth");
      var parameters = Object.assign(this.getMwcDataManagerParameters(), {
        dataSourceId: dataSourceId,
        riskModelId: this.options.riskModelId,
        scenarios: [this.selectedScenario.id],
        portfolios: this.options.portfolios,
        amount: this.options.startValue
      });
      this.callApi(dataSourceId, parameters, 'growth10KModel', 'calculateTenKGrowth');
    },
    getMacroShockScenarios: function getMacroShockScenarios() {
      this.getSpecificScenarios('macroShock', 'customScenarios', 'macroShockScenarios');
    },
    getMarketShockScenarios: function getMarketShockScenarios() {
      this.getSpecificScenarios('marketShock', 'customScenarios', 'marketShockScenarios');
    },
    getCustomScenarios: function getCustomScenarios() {
      this.getSpecificScenarios('custom-scenarios', 'customScenarios', 'customScenarios');
    },
    getSpecificScenarios: function getSpecificScenarios(id, modelName, dataSource) {
      var randomId = this.generateRandomId();
      var dataSourceId = "".concat(this.mwcId, "-").concat(id, "-").concat(randomId);
      var parameters = Object.assign(this.getMwcDataManagerParameters(), {
        dataSourceId: dataSourceId
      });
      this.callApi(dataSourceId, parameters, modelName, dataSource);
    },
    callApi: function callApi(dataSourceId, parameters, modelName, dataSource) {
      this.loading = true;
      var options = {
        dataSourceId: dataSourceId,
        parameters: parameters,
        mwcId: this.mwcId,
        element: this.$el.parentElement,
        modelName: modelName,
        additionalTransforms: null,
        successFunction: this.apiSuccess,
        errorFunction: this.errorFunction
      };
      var isSubscribed = window.mwc.dataManager.isComponentSubscribed(dataSourceId, this.mwcId, this.$el);

      if (!isSubscribed) {
        options.updateDataSource = this.settings.updateDataSourceOnSubscribe;
      }

      var dataEvent = "".concat(dataSource, "-data-").concat(isSubscribed ? 'update' : 'subscribe');
      this.$emit(dataEvent, options);
    },
    apiSuccess: function apiSuccess() {
      this.loading = false;
    },
    errorFunction: function errorFunction(e) {
      this.cardDataList = [];
      var cardDataError; // Print in the card the error message

      if (e.messages && e.messages.length > 0) {
        cardDataError = {
          name: this.labeller.translate(e.messages[0].level),
          errorMessage: this.labeller.translate(e.messages[0].msg),
          isDataError: true
        };
      }

      this.cardDataList.push(cardDataError);
      this.loading = false;
    },
    listItemClicked: function listItemClicked(selectedItem) {
      var cloned = cloneDeep_default()(this.scenarios);

      each_default()(cloned, function (item) {
        item.active = item.id === selectedItem.id;
      });

      this.selectedScenario = selectedItem;
      this.trackUsageEvent(Object.assign({
        primaryValue: selectedItem.id
      }, usage_tracking_events.scenarioSelected));
      this.scenarios = cloned;
      this.changeTab(this.tabsContent);
    },
    changeTab: function changeTab(tabsContent) {
      var chartTab = find_default()(tabsContent, function (tab) {
        return tab.active === true;
      });

      if (chartTab) {
        this.trackUsageEvent(Object.assign({
          primaryValue: chartTab.id
        }, usage_tracking_events.tabChanged));

        if (chartTab.id === 'snapshot') {
          this.getPeriodReturn();
        } else if (chartTab.id === 'chart') {
          this.getGrowth10K();
        }
      }
    },
    renderCards: function renderCards(dataScenarios) {
      var _this4 = this;

      var vm = this;
      vm.cardDataList = [];

      if (dataScenarios.length) {
        var scenario = dataScenarios[0];

        each_default()(scenario.investments, function (investment) {
          var portfolio = find_default()(vm.options.portfolios, function (p) {
            return p.id === investment.id;
          });

          if (portfolio) {
            if (investment.errorMessage) {
              var cardDataError = {
                name: vm.getPortfolioCategory(portfolio.category),
                errorMessage: _this4.labeller.translate(investment.errorMessage),
                isDataError: true
              };
              vm.cardDataList.push(cardDataError);
            } else {
              var cardData = {
                name: vm.getPortfolioCategory(portfolio.category),
                description: portfolio.name,
                duration: scenario.duration,
                durationUnit: scenario.durationUnit,
                startValue: investment.startValue,
                endValue: investment.endValue,
                modelData: {
                  amount: Math.round(investment.lossOrGain * 100) / 100,
                  percentage: investment.percentage
                },
                isDataError: false
              };
              vm.cardDataList.push(cardData);
            }
          }
        });
      }
    },
    getPortfolioCategory: function getPortfolioCategory(category) {
      if (category === 'current') {
        return this.labeller.getLabel('currentPortfolio');
      } else if (category === 'proposed') {
        return this.labeller.getLabel('proposedPortfolio');
      } else if (this.labeller.getLabel(category) === category) {
        // We don't have the translation for this category
        return this.labeller.getLabel('portfolio');
      }

      return this.labeller.getLabel(category);
    },
    setTabActiveItem: function setTabActiveItem(event) {
      var _this5 = this;

      this.tabsContent.forEach(function (item) {
        if (item.id === event.currentTarget.id) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
      this.$nextTick(function () {
        _this5.changeTab(_this5.tabsContent);
      });
    },
    drawChart: function drawChart(dataScenarios) {
      var chartData = this.getChartData(dataScenarios);

      if (chartData) {
        if (this.$el.querySelectorAll("#".concat(this.chartContainerId, " svg")).length > 0) {
          line_chart_service.updateChart(this.chartContainerId, chartData);
        } else {
          line_chart_service.drawChart(this.chartContainerId, chartData);
        }
      }
    },
    getChartData: function getChartData(dataScenarios) {
      var vm = this;

      if (dataScenarios.length) {
        var scenario = dataScenarios[0];
        var chartData = {
          y1: []
        };

        each_default()(scenario.investments, function (investment) {
          var portfolio = find_default()(vm.options.portfolios, function (p) {
            return p.id === investment.id;
          });

          if (portfolio) {
            var name = vm.getPortfolioCategory(portfolio.category);

            var growth10k = cloneDeep_default()(investment.returns);

            each_default()(growth10k, function (date) {
              date.name = name;
              chartData.y1.push(date);
            });
          }
        });

        return chartData;
      }

      return null;
    },
    showTab: function showTab(tabId) {
      if (this.tabsContent) {
        var foundTab = find_default()(this.tabsContent, function (tab) {
          return tab.id === tabId && tab.active === true;
        });

        return foundTab;
      }

      return false;
    },
    getScenarioDescription: function getScenarioDescription() {
      if (this.selectedScenario) {
        if (this.settings.scenarioDescriptionType === 'short') {
          return this.selectedScenario.shortDescription;
        }

        return this.selectedScenario.definition;
      }

      return '';
    }
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/src/pp-scenario-analysis.js?vue&type=script&lang=js&
 /* harmony default export */ var src_pp_scenario_analysisvue_type_script_lang_js_ = __webpack_exports__["a"] = (pp_scenario_analysisvue_type_script_lang_js_); 

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(7);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(379);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(380);

// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/utils-js/src/keyboard-navigation/keyboard-navigation.js
/* harmony default export */ var keyboard_navigation = ({
  keyboardNavigation: {
    bind: function bind(el, binding, vnode) {
      el.keyListener = function (event) {
        vnode.context[binding.expression](event);
      };

      document.addEventListener('keydown', el.keyListener);
    },
    unbind: function unbind(el) {
      document.removeEventListener('keydown', el.keyListener);
    }
  },
  autoDirection: {
    inserted: function inserted(el, binding, vnode) {
      vnode.context[binding.expression](el);
    }
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/utils-js/src/overlay/overlay.js
var bodyStyling = function bodyStyling(enable) {
  if (enable) {
    // Set padding-right for scrollbar width to avoid any overlaying components "jumping"
    var scrollbarWidth = 0;
    scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = "".concat(scrollbarWidth, "px");
  } else {
    document.body.style.removeProperty('padding-right');
    document.body.style.removeProperty('overflow');
  }
};

var showOverlay = function showOverlay(overlay) {
  bodyStyling(true);
  overlay.style.display = 'block';
  setTimeout(function () {
    overlay.style.opacity = 0.5;
  }, 10);
};

var MdsOverlay = {
  inserted: function inserted(el, binding, vnode) {
    var overlay = document.createElement('div');
    var additionalClass = binding.arg.class ? " ".concat(binding.arg.class) : '';
    overlay.className = "mds-directive--overlay__v3".concat(additionalClass);

    if (binding.arg.value) {
      showOverlay(overlay);
    }

    el.clickOutsideEvent = function (event) {
      if (binding.expression) {
        vnode.context[binding.expression](event);
      }
    };

    overlay.addEventListener('click', el.clickOutsideEvent);
    el.appendChild(overlay);
  },
  update: function update(el, binding) {
    if (el.hasChildNodes()) {
      var sibling = el.querySelector('.mds-directive--overlay__v3');

      if (sibling === null) {
        return;
      }

      var visible = binding.arg.value;

      if (visible) {
        showOverlay(sibling);
      } else {
        setTimeout(function () {
          sibling.style.opacity = 0;
        }, 10);
        setTimeout(function () {
          sibling.style.display = 'none';
          bodyStyling(false);
        }, 500);
      }
    }
  },
  unbind: function unbind(el, binding) {
    if (el.hasChildNodes()) {
      if (binding.arg.value) {
        bodyStyling(false);
      }
    }
  }
};
/* harmony default export */ var overlay = (MdsOverlay);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(113);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(383);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(385);

// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/utils-js/src/positioning/positioning.js




var POSITION_TOP_CENTER = 'top-center';
var POSITION_TOP_RIGHT = 'top-right';
var POSITION_RIGHT_CENTER = 'right-center';
var POSITION_BOTTOM_RIGHT = 'bottom-right';
var POSITION_BOTTOM_CENTER = 'bottom-center';
var POSITION_BOTTOM_LEFT = 'bottom-left';
var POSITION_LEFT_CENTER = 'left-center';
var POSITION_TOP_LEFT = 'top-left'; // collect positions in original priority order

var positions = [POSITION_BOTTOM_RIGHT, POSITION_RIGHT_CENTER, POSITION_TOP_RIGHT, POSITION_TOP_CENTER, POSITION_TOP_LEFT, POSITION_LEFT_CENTER, POSITION_BOTTOM_LEFT, POSITION_BOTTOM_CENTER];
var MdsPositioning = {
  methods: {
    /**********************************************
    Main methods
    **********************************************/
    getPositionAttributes: function getPositionAttributes() {
      var spaceFromTrigger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
      var attributes = {};
      var sizes = this.getComponentTriggerSizes();
      var setPosition = this.position[0];

      if (this.autoPosition) {
        setPosition = this.findFirstViablePosition(sizes.component, sizes.trigger, sizes.window, this.position);
      }

      var heightBorders = this.variation === 'default' && setPosition.split('-')[0] === 'top' ? -2 : 0;
      var widthBorders = this.variation === 'default' && setPosition.split('-')[0] === 'left' ? -2 : 0; // check if trigger sizes are available

      if (sizes.trigger !== {}) {
        var _this$getTopLeftPosit = this.getTopLeftPosition(sizes.component, sizes.trigger, setPosition, spaceFromTrigger),
            topPos = _this$getTopLeftPosit.topPos,
            leftPos = _this$getTopLeftPosit.leftPos;

        topPos += heightBorders + sizes.window.pageYOffset;
        leftPos += widthBorders + sizes.window.pageXOffset;
        attributes.top = topPos;
        attributes.left = leftPos;
      }

      return {
        setPosition: setPosition,
        attributes: attributes
      };
    },

    /**********************************************
    Define top and left positions
    **********************************************/
    getTopLeftPosition: function getTopLeftPosition(componentSize, triggerSize, newPosition, spaceFromTrigger) {
      var topPos;
      var leftPos; // determine trigger centers

      var triggerCenterHorizontal = triggerSize.left + 0.5 * triggerSize.width;
      var triggerCenterVertical = triggerSize.top + 0.5 * triggerSize.height; // get top position

      switch (newPosition) {
        case POSITION_TOP_CENTER:
        case POSITION_TOP_RIGHT:
        case POSITION_TOP_LEFT:
          topPos = triggerSize.top - (componentSize.height + spaceFromTrigger);
          break;

        case POSITION_BOTTOM_CENTER:
        case POSITION_BOTTOM_RIGHT:
        case POSITION_BOTTOM_LEFT:
          topPos = triggerSize.bottom + spaceFromTrigger;
          break;

        case POSITION_LEFT_CENTER:
        case POSITION_RIGHT_CENTER:
          topPos = triggerCenterVertical - 0.5 * componentSize.height;
          break;
      } // get left position


      switch (newPosition) {
        case POSITION_TOP_CENTER:
        case POSITION_BOTTOM_CENTER:
          leftPos = triggerCenterHorizontal - 0.5 * componentSize.width;
          break;

        case POSITION_TOP_RIGHT:
        case POSITION_BOTTOM_RIGHT:
          leftPos = triggerSize.left;
          break;

        case POSITION_TOP_LEFT:
        case POSITION_BOTTOM_LEFT:
          leftPos = triggerSize.right - componentSize.width;
          break;

        case POSITION_RIGHT_CENTER:
          leftPos = triggerSize.right + spaceFromTrigger;
          break;

        case POSITION_LEFT_CENTER:
          leftPos = triggerSize.left - (componentSize.width + spaceFromTrigger);
          break;
      }

      return {
        topPos: topPos,
        leftPos: leftPos
      };
    },

    /**********************************************
    Helper functions
    **********************************************/
    // get size and its position relative to the viewport for component and trigger
    getComponentTriggerSizes: function getComponentTriggerSizes() {
      var objWindow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

      var windowSize = function (_ref) {
        var innerHeight = _ref.innerHeight,
            innerWidth = _ref.innerWidth,
            pageXOffset = _ref.pageXOffset,
            pageYOffset = _ref.pageYOffset;
        return {
          innerHeight: innerHeight,
          innerWidth: innerWidth,
          pageXOffset: pageXOffset,
          pageYOffset: pageYOffset
        };
      }(objWindow);

      var componentSize = this.$el.getBoundingClientRect();
      var triggerSize = this.triggeredBy && document.getElementById("".concat(this.triggeredBy)) ? document.getElementById("".concat(this.triggeredBy)).getBoundingClientRect() : {};
      return {
        window: windowSize,
        component: componentSize,
        trigger: triggerSize
      };
    },
    // Apply `style` attribute to component
    formatPositionStyleAttributes: function formatPositionStyleAttributes(attributes) {
      var top = attributes.top ? "top: ".concat(attributes.top, "px; ") : '';
      var left = attributes.left ? "left: ".concat(attributes.left, "px; ") : '';
      return "".concat(top).concat(left).trim();
    },

    /**********************************************
    Helper functions for auto positioning
    **********************************************/
    // determine positions where component can be displayed
    // returns array of viable positions
    findViablePositions: function findViablePositions(componentSize, triggerSize, windowSize) {
      // determine trigger centers
      var triggerCenterHorizontal = triggerSize.left + 0.5 * triggerSize.width;
      var triggerCenterVertical = triggerSize.top + 0.5 * triggerSize.height; // determine component center height and width

      var componentHalfHeight = 0.5 * (componentSize.height + 2);
      var componentHalfWidth = 0.5 * componentSize.width; // determine if component fits on top, bottom, left, or right of trigger

      var fitsTop = triggerSize.top >= componentSize.height;
      var fitsBottom = windowSize.innerHeight - triggerSize.bottom >= componentSize.height;
      var fitsLeft = triggerSize.left - componentSize.width > 0;
      var fitsRight = windowSize.innerWidth > componentSize.width + triggerSize.right;
      var fitsCenter = triggerCenterHorizontal - componentHalfWidth > 0 && triggerCenterHorizontal + componentHalfWidth < windowSize.innerWidth;
      var viablePositions = {};
      viablePositions[POSITION_TOP_CENTER] = fitsTop && fitsCenter;
      viablePositions[POSITION_TOP_RIGHT] = fitsTop && triggerSize.left + componentSize.width < windowSize.innerWidth;
      viablePositions[POSITION_RIGHT_CENTER] = fitsRight && triggerCenterVertical - componentHalfHeight > 0 && triggerCenterVertical + componentHalfHeight < windowSize.innerHeight;
      viablePositions[POSITION_BOTTOM_RIGHT] = fitsBottom && triggerSize.left > 0 && triggerCenterHorizontal + componentSize.width < windowSize.innerWidth;
      viablePositions[POSITION_BOTTOM_CENTER] = fitsBottom && fitsCenter;
      viablePositions[POSITION_BOTTOM_LEFT] = fitsBottom && triggerCenterHorizontal < windowSize.innerWidth && triggerCenterHorizontal - componentSize.width > 0;
      viablePositions[POSITION_LEFT_CENTER] = fitsLeft && triggerCenterVertical - componentHalfHeight > 0 && triggerCenterVertical + componentHalfHeight < windowSize.innerHeight;
      viablePositions[POSITION_TOP_LEFT] = fitsTop && triggerSize.right < windowSize.innerWidth && triggerSize.right - componentSize.width > 0;
      return viablePositions;
    },
    // determines best positions from viable positions
    findFirstViablePosition: function findFirstViablePosition(componentSize, triggerSize, windowSize, sortedPositions) {
      var viablePositions = this.findViablePositions(componentSize, triggerSize, windowSize);
      var foundPosition = sortedPositions[0];

      for (var i = 0; i < sortedPositions.length; i++) {
        if (viablePositions[sortedPositions[i]]) {
          foundPosition = sortedPositions[i];
          break;
        }
      }

      return foundPosition;
    },
    debounce: function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this;
        var args = arguments;

        var later = function later() {
          timeout = null;

          if (!immediate) {
            func.apply(context, args);
          }
        };

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) {
          func.apply(context, args);
        }
      };
    }
  }
};
/* harmony default export */ var positioning = (MdsPositioning);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(226);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(227);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(35);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(37);

// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/utils-js/src/trap-focus/trap-focus.js





/*
    TODO
        - add inert support
        - remove parentFocus method
*/
var MdsTrapFocus = {
  data: function data() {
    return {
      initialActiveElement: null,
      container: '',
      focusableNodes: null,
      firstFocusableElement: null,
      lastFocusableElement: null
    };
  },
  methods: {
    // Tabindex setting
    setTabIndex: function setTabIndex() {
      var set = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (set) {
        if (this.container && this.$refs[this.container]) {
          this.$refs[this.container].setAttribute('tabindex', '-1');
        } else {
          this.$el.setAttribute('tabindex', '-1');
        }
      } else {
        if (this.container && this.$refs[this.container]) {
          this.$refs[this.container].removeAttribute('tabindex');
        } else {
          this.$el.removeAttribute('tabindex');
        }
      }
    },
    // Event listener for tabbing
    trapFocusKeyDownEvents: function trapFocusKeyDownEvents(event) {
      if (event.key === 'Tab' || event.keyCode === 9) {
        this.maintainFocus(event);
      }
    },
    // Remove focus
    disableTrapFocus: function disableTrapFocus() {
      if (this.initialActiveElement) {
        this.initialActiveElement.focus(); // Reset

        this.initialActiveElement = null;
        this.focusableNodes = null;
        this.firstFocusableElement = null;
        this.lastFocusableElement = null;
      }

      this.setTabIndex(false);
      document.removeEventListener('keydown', this.trapFocusKeyDownEvents, true);
    },
    // Start focus
    enableTrapFocus: function enableTrapFocus(container) {
      var _this = this;

      // Get last active element and store reference for later
      if (!this.initialActiveElement) {
        this.initialActiveElement = document.activeElement;
      }

      this.container = container;
      this.setTabIndex(); // Set up focusable elements ready for tabbing

      setTimeout(function () {
        _this.focusableNodes = _this.focusableElements();
        _this.firstFocusableElement = _this.focusableNodes[0];
        _this.lastFocusableElement = _this.focusableNodes[_this.focusableNodes.length - 1]; // Shift focus

        if (_this.focusableNodes.length && !_this.container) {
          _this.$el.focus();
        } else if (_this.focusableNodes.length && _this.container) {
          // e.g. page-shell
          _this.firstFocusableElement.focus();
        } else {
          var nonfocusableElements = _this.parentFocus();

          if (nonfocusableElements.length) {
            nonfocusableElements[0].focus();
          }
        }
      }, 100); // Add listener for tabbing

      document.addEventListener('keydown', this.trapFocusKeyDownEvents, true);
    },
    // Maintain focus during tabbing
    maintainFocus: function maintainFocus(event) {
      if (event.shiftKey) {
        if (document.activeElement.isEqualNode(this.firstFocusableElement)) {
          this.lastFocusableElement.focus();
          event.preventDefault();
        }
      } else {
        if (document.activeElement.isEqualNode(this.lastFocusableElement)) {
          this.firstFocusableElement.focus();
          event.preventDefault();
        }
      }
    },
    // Returns all focusable elements
    // https://github.com/jkup/focusable/blob/master/index.js
    focusableElements: function focusableElements() {
      var elements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type="hidden"])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[tabindex="0"]', '[contenteditable]', 'audio[controls]', 'video[controls]', 'summary', '[tabindex^="0"]', '[tabindex^="1"]', '[tabindex^="2"]', '[tabindex^="3"]', '[tabindex^="4"]', '[tabindex^="5"]', '[tabindex^="6"]', '[tabindex^="7"]', '[tabindex^="8"]', '[tabindex^="9"]'];
      var nodes = this.container && this.$refs[this.container] ? this.$refs[this.container].querySelectorAll(elements) : this.$el.querySelectorAll(elements);
      return Object.keys(nodes).map(function (key) {
        return nodes[key];
      });
    },
    // TODO: Remove
    // Deprecated - DO NOT USE
    parentFocus: function parentFocus() {
      var elements = ['[role="dialog"]', '[role="alert"]', '[role="menu"]', '[role="tooltip"]'];
      var nodes = this.container && this.$refs[this.container] ? this.$refs[this.container].querySelectorAll(elements) : this.$el.querySelectorAll(elements); // As it's a div or section, by nature it's not focusable so add tabindex attribute

      nodes.forEach(function (node) {
        node.setAttribute('tabindex', '0');
      });
      return Object.keys(nodes).map(function (key) {
        return nodes[key];
      });
    }
  }
};
/* harmony default export */ var trap_focus = (MdsTrapFocus);
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/utils-js/src/index.js






// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/button/src/index.js
var src = __webpack_require__(17);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/dialog/package.json
var dialog_package = __webpack_require__(139);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/dialog/src/dialog.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Import component's API



var dialogvue_type_script_lang_js_name = dialog_package.name,
    version = dialog_package.version;
/* harmony default export */ var dialogvue_type_script_lang_js_ = ({
  name: 'MdsDialog',
  components: {
    MdsButton: src["a" /* MdsButton */]
  },
  mixins: [trap_focus],
  directives: {
    overlay: overlay
  },
  props: {
    actionRequired: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, suppresses the ability to dismiss the dialog with the `esc` key or by clicking the underlying page. An action in the dialog must be used to dismiss.'
      }
    },
    disableFocusTrap: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, suppresses the built-in focus trap focus allowing you to leverage your own or third-party focus management.'
      }
    },
    text: {
      type: String,
      docs: {
        validation: '—',
        description: 'Sets the text for the dialog.'
      }
    },
    title: {
      type: String,
      docs: {
        validation: '—',
        description: 'Sets the title for the dialog.',
        support: ['v-html']
      }
    },
    visible: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'Used to toggle the visibility of the dialog.',
        support: ['v-model']
      }
    },
    width: {
      type: String,
      default: '350px',
      values: ['350px', '500px'],
      validator: function validator(value) {
        return ['350px', '500px'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `350px`, `500px`.',
        description: 'Sets the width of the dialog.'
      }
    },
    version: {
      type: String,
      default: "".concat(dialogvue_type_script_lang_js_name, "-").concat(version),
      docs: {
        validation: 'Read-only',
        description: 'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.'
      }
    }
  },
  model: {
    prop: 'visible',
    event: 'mds-dialog-dismissed'
  },
  data: function data() {
    return {
      classes: this.$style['mds-overlay'],
      isVisible: this.visible
    };
  },
  watch: {
    visible: function visible(_visible) {
      this[_visible ? 'show' : 'hide']();
    }
  },
  computed: {
    widthClass: function widthClass() {
      return this.$style["mds-dialog--width-".concat(this.width)];
    }
  },
  methods: {
    show: function show(event) {
      if (!this.disableFocusTrap) {
        this.enableTrapFocus();
      }

      this.isVisible = true;
      this.$emit('mds-dialog-opened', event);
    },
    hide: function hide(event) {
      // to negate duplicate dismiss event emit
      if (!this.isVisible) {
        return;
      }

      if (!this.disableFocusTrap && this.actionRequired && event && event.target.classList[0].includes('mds-directive--overlay__v3')) {
        this.enableTrapFocus(); // force focus back into dialog

        return;
      }

      if (!this.disableFocusTrap) {
        this.disableTrapFocus();
      }

      this.isVisible = false;
      this.$emit('mds-dialog-dismissed', this.isVisible, event);
    },
    bindEventHandlers: function bindEventHandlers() {
      window.addEventListener('keydown', this.dialogKeyDownEvents, true);
    },
    dialogKeyDownEvents: function dialogKeyDownEvents(event) {
      if (!this.actionRequired && event.keyCode === 27) {
        this.hide();
      }
    }
  },
  mounted: function mounted() {
    this.bindEventHandlers();
  },
  destroyed: function destroyed() {
    window.removeEventListener('keydown', this.dialogKeyDownEvents, true);
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/dialog/src/dialog.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_dialogvue_type_script_lang_js_ = __webpack_exports__["a"] = (dialogvue_type_script_lang_js_); 

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(7);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/loader/package.json
var loader_package = __webpack_require__(135);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/loader/src/loader.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//

var loadervue_type_script_lang_js_name = loader_package.name,
    version = loader_package.version;
/* harmony default export */ var loadervue_type_script_lang_js_ = ({
  name: 'MdsLoader',
  inheritAttrs: false,
  props: {
    ariaValuetext: {
      type: String,
      default: 'Loading...',
      docs: {
        validation: '',
        description: 'Sets the loader `aria-valuetext` attribute.'
      }
    },
    onDark: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, changes component to on-dark styling.'
      }
    },
    size: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return ['small', 'medium', 'large'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `small`, `medium`, `large`.',
        description: 'Sets the size of the loader.'
      }
    },
    version: {
      type: String,
      default: "".concat(loadervue_type_script_lang_js_name, "-").concat(version),
      docs: {
        validation: 'Read-only',
        description: 'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.'
      }
    }
  },
  computed: {
    sizeClass: function sizeClass() {
      return this.$style["mds-loader--".concat(this.size)];
    },
    classObject: function classObject() {
      var obj = {};
      obj[this.$style['mds-component--on-dark']] = this.onDark;
      return obj;
    }
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/loader/src/loader.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_loadervue_type_script_lang_js_ = __webpack_exports__["a"] = (loadervue_type_script_lang_js_); 

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(128);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(7);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.bold.js
var es_string_bold = __webpack_require__(387);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/button/src/index.js
var src = __webpack_require__(17);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/icon/src/icon.vue
var icon = __webpack_require__(30);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/section/package.json
var section_package = __webpack_require__(146);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/section/src/section.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var sectionvue_type_script_lang_js_name = section_package.name,
    version = section_package.version;
/* harmony default export */ var sectionvue_type_script_lang_js_ = ({
  name: 'MdsSection',
  components: {
    MdsButton: src["a" /* MdsButton */],
    MdsIcon: icon["a" /* default */]
  },
  data: function data() {
    return {
      open: this.expanded
    };
  },
  watch: {
    expanded: function expanded(newVal) {
      if (this.open !== newVal) {
        this.toggle();
      }
    }
  },
  props: {
    bold: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, sets the section heading text to bold.'
      }
    },
    border: {
      type: String,
      default: 'primary',
      validator: function validator(value) {
        return ['primary', 'secondary', 'tertiary', 'none'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `primary`, `secondary`, `tertiary`, `none`.',
        description: 'Sets section heading border style.'
      }
    },
    borderPosition: {
      type: String,
      default: 'top',
      validator: function validator(value) {
        return ['top', 'bottom'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `top`, `bottom`.',
        description: 'Sets section heading border position.'
      }
    },
    container: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, renders a visible container around a section.'
      }
    },
    content: {
      type: String,
      docs: {
        validation: '—',
        description: 'Sets the section content.',
        support: ['v-html']
      }
    },
    collapsible: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, enables the ability to collapse a section.'
      }
    },
    expanded: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, expands a collapsible section.'
      }
    },
    headingLevel: {
      type: Number,
      default: 2,
      validator: function validator(value) {
        return value >= 1 && value <= 6;
      },
      docs: {
        validation: '—',
        description: 'Sets the `<h#>` section heading level of the card title.'
      }
    },
    onDark: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, changes component to on-dark styling.'
      }
    },
    size: {
      type: Number,
      default: 5,
      validator: function validator(value) {
        return value >= 1 && value <= 9;
      },
      docs: {
        validation: 'Number between `1` and `9`.',
        description: 'Sets the section heading text size, based on [typography heading level styles](/visual-language/typography).'
      }
    },
    title: {
      type: String,
      docs: {
        validation: '—',
        description: 'Sets the section section heading text.'
      }
    },
    version: {
      type: String,
      default: "".concat(sectionvue_type_script_lang_js_name, "-").concat(version),
      docs: {
        validation: 'Read-only',
        description: 'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.'
      }
    }
  },
  computed: {
    ariaExpanded: function ariaExpanded() {
      if (!this.collapsible) {
        return null;
      }

      return this.open ? 'true' : 'false';
    },
    headingType: function headingType() {
      return "h".concat(this.headingLevel);
    },
    classObject: function classObject() {
      var obj = {};
      obj[this.$style['mds-component--on-dark']] = this.onDark;
      obj[this.$style['mds-section--expanded']] = this.open;
      obj[this.$style['mds-section--collapsible']] = this.collapsible;
      obj[this.$style['mds-section--container']] = this.container;
      return obj;
    },
    headerClasses: function headerClasses() {
      var obj = {};
      obj[this.$style['mds-section--border-bottom']] = this.borderPosition === 'bottom' || this.container;
      obj[this.$style["mds-section--".concat(this.border)]] = this.border;
      obj[this.$style['mds-section--font-bold']] = this.bold;
      return obj;
    },
    sizeClass: function sizeClass() {
      return this.$style["mds-section--level-".concat(this.size)];
    },
    iconSize: function iconSize() {
      return this.size < 6 ? 'medium' : 'small';
    },
    tabIndex: function tabIndex() {
      return this.collapsible ? 0 : null;
    },
    expandedId: function expandedId() {
      var randomId = Math.random() * Math.floor(1000000);
      return "mds-section-".concat(Math.round(randomId));
    },
    hasTitleDescription: function hasTitleDescription() {
      return !!this.$slots['mds-section-title-description'];
    }
  },
  methods: {
    toggle: function toggle(event) {
      if (this.collapsible) {
        if (event) {
          // if triggered by user action, invert value
          this.open = !this.open;
          this.$emit("mds-section-".concat(this.open ? 'expanded' : 'closed'), event);
        } else {
          // if called by v-model change on expanded,
          // don't assume invert, but rather update to new value.
          this.open = this.expanded;
          this.$emit("mds-section-".concat(this.open ? 'expanded' : 'closed'));
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/section/src/section.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_sectionvue_type_script_lang_js_ = __webpack_exports__["a"] = (sectionvue_type_script_lang_js_); 

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(7);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/icon/src/icon.vue
var icon = __webpack_require__(30);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/routable/src/routable.js
var routable = __webpack_require__(96);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/loader/src/loader.vue
var loader = __webpack_require__(97);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/button/package.json
var button_package = __webpack_require__(31);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/button/src/button.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var buttonvue_type_script_lang_js_name = button_package.name,
    version = button_package.version;
/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
  name: 'MdsButton',
  components: {
    MdsIcon: icon["a" /* default */],
    MdsLoader: loader["a" /* default */]
  },
  mixins: [routable["a" /* default */]],
  props: {
    href: {
      type: String,
      docs: {
        validation: '—',
        description: 'When provided, makes the button `a`-based and sets the `href` path.'
      }
    },
    flatButtonIconSize: {
      type: String,
      default: 'default',
      validator: function validator(value) {
        return ['default', 'small', 'medium'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'Button variation must be `flat`. One of: `default`, `small`, `medium`.',
        description: 'Sets the size of icons within a flat button.'
      }
    },
    icon: {
      type: String,
      docs: {
        validation: 'Must be a valid icon name.',
        description: 'Sets the left icon.'
      }
    },
    iconRight: {
      type: String,
      docs: {
        validation: 'Must be a valid icon name.',
        description: 'Sets the right icon.'
      }
    },
    loaderAriaValuetext: {
      type: String,
      default: 'Loading...',
      docs: {
        validation: '—',
        description: 'Sets the loader `aria-valuetext` attribute.'
      }
    },
    loading: {
      type: Boolean,
      default: false,
      docs: {
        validation: 'Button variation must be `primary`.',
        description: 'If `true`, hides the button content and displays a loader in its place.'
      }
    },
    onDark: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, changes component to on-dark styling.'
      }
    },
    size: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return ['small', 'medium', 'large', 'touch'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `small`, `medium`, `large`, `touch`.',
        description: 'Sets the size of the button.'
      }
    },
    text: {
      type: String,
      docs: {
        validation: '**Required**',
        description: 'Sets the button text.'
      }
    },
    variation: {
      type: String,
      default: 'secondary',
      validator: function validator(value) {
        return ['primary', 'secondary', 'flat', 'icon-only'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `primary`, `secondary`, `flat`, `icon-only`.',
        description: 'Sets the button variation.'
      }
    },
    version: {
      type: String,
      default: "".concat(buttonvue_type_script_lang_js_name, "-").concat(version),
      docs: {
        validation: 'Read-only',
        description: 'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.'
      }
    }
  },
  computed: {
    componentType: function componentType() {
      return this.isRoutable ? this.linkTag : this.href ? 'a' : 'button';
    },
    sizeClass: function sizeClass() {
      return this.$style["mds-button--".concat(this.size)];
    },
    classObject: function classObject() {
      var obj = {};
      obj[this.$style['mds-component--on-dark']] = this.onDark;
      obj[this.$style['mds-button--flat-m-icon']] = this.mediumIcon;
      obj[this.$style['mds-button--loading']] = this.loading && this.variation === 'primary';
      return obj;
    },
    iconSize: function iconSize() {
      var isSmall = this.size === 'small' || this.size === 'medium' && this.variation !== 'icon-only' && this.flatButtonIconSize !== 'medium' || this.flatButtonIconSize === 'small';
      return isSmall ? 'small' : 'medium';
    },
    variationClass: function variationClass() {
      return this.$style["mds-button--".concat(this.variation)];
    },
    iconAriaLabel: function iconAriaLabel() {
      var buttonText = this.text;

      if (this.$slots.default) {
        buttonText = this.$slots.default[0].text;
      }

      return this.variation === 'icon-only' ? buttonText : null;
    }
  },
  data: function data() {
    return {
      mediumIcon: false
    };
  },
  mounted: function mounted() {
    this.mediumIcon = this.iconSize === 'medium' && this.variation === 'flat' && this.size === 'medium';
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/button/src/button.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = __webpack_exports__["a"] = (buttonvue_type_script_lang_js_); 

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(7);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/button/package.json
var button_package = __webpack_require__(31);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/button/src/button-container.vue?vue&type=script&lang=js&


//
//
//
//
//
//

var button_containervue_type_script_lang_js_name = button_package.name,
    version = button_package.version;
/* harmony default export */ var button_containervue_type_script_lang_js_ = ({
  name: 'MdsButtonContainer',
  props: {
    rightAligned: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, right aligns the buttons in the container.'
      }
    },
    version: {
      type: String,
      default: "".concat(button_containervue_type_script_lang_js_name, "-").concat(version),
      docs: {
        validation: 'Read-only',
        description: 'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.'
      }
    }
  },
  computed: {
    classObject: function classObject() {
      var obj = {};
      obj[this.$style['mds-button-container--right-aligned']] = this.rightAligned;
      return obj;
    }
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/button/src/button-container.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_button_containervue_type_script_lang_js_ = __webpack_exports__["a"] = (button_containervue_type_script_lang_js_); 

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(7);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/package.json
var layout_grid_package = __webpack_require__(18);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/layout-grid.vue?vue&type=script&lang=js&


//
//
//
//
//
//

var layout_gridvue_type_script_lang_js_name = layout_grid_package.name,
    version = layout_grid_package.version;
/* harmony default export */ var layout_gridvue_type_script_lang_js_ = ({
  name: 'MdsLayoutGrid',
  props: {
    gutters: {
      type: String,
      default: '32px',
      validator: function validator(value) {
        return ['32px', 'none'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `32px`, `none`.',
        description: 'Sets the layout grid gutter width.'
      }
    },
    version: {
      type: String,
      default: "".concat(layout_gridvue_type_script_lang_js_name, "-").concat(version),
      docs: {
        validation: 'Read-only',
        description: 'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.'
      }
    }
  },
  provide: function provide() {
    var _this = this;

    var parent = {};
    Object.defineProperty(parent, 'gutters', {
      enumerable: true,
      get: function get() {
        return _this.colGutters;
      }
    });
    return {
      parent: parent
    };
  },
  data: function data() {
    return {
      colGutters: this.gutters
    };
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/layout-grid.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_layout_gridvue_type_script_lang_js_ = __webpack_exports__["a"] = (layout_gridvue_type_script_lang_js_); 

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(7);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/package.json
var layout_grid_package = __webpack_require__(18);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/row.vue?vue&type=script&lang=js&


//
//
//
//
//

var rowvue_type_script_lang_js_name = layout_grid_package.name,
    version = layout_grid_package.version;
/* harmony default export */ var rowvue_type_script_lang_js_ = ({
  name: 'MdsRow',
  inject: ['parent'],
  props: {
    alignHorizontal: {
      type: String,
      validator: function validator(value) {
        return ['center', 'flex-end', 'space-around', 'space-between'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `center`, `flex-end`, `space-around`, `space-between`.',
        description: 'Sets the `justify-content` behavior for the content of the row.'
      }
    },
    alignVertical: {
      type: String,
      validator: function validator(value) {
        return ['flex-start', 'center', 'flex-end'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `flex-start`, `center`, `flex-end`.',
        description: 'Sets the `align-items` behavior for the content of the row.'
      }
    },
    nowrap: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, prevents a row with more than 12 columns of content from wrapping.'
      }
    },
    version: {
      type: String,
      default: "".concat(rowvue_type_script_lang_js_name, "-").concat(version),
      docs: {
        validation: 'Read-only',
        description: 'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.'
      }
    }
  },
  computed: {
    classObject: function classObject() {
      var obj = {};
      var baseClassName = 'mds-layout-grid__row';
      obj[this.$style["".concat(baseClassName, "--nowrap")]] = this.nowrap;
      obj[this.$style["".concat(baseClassName, "--justify-content-").concat(this.alignHorizontal)]] = this.alignHorizontal;
      obj[this.$style["".concat(baseClassName, "--align-items-").concat(this.alignVertical)]] = this.alignVertical;
      obj[this.$style["".concat(baseClassName, "--zero-margin")]] = this.parent.gutters === 'none';
      return obj;
    }
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/row.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_rowvue_type_script_lang_js_ = __webpack_exports__["a"] = (rowvue_type_script_lang_js_); 

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(128);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(7);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/package.json
var layout_grid_package = __webpack_require__(18);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/col.vue?vue&type=script&lang=js&



//
//
//
//
//
//

var colvue_type_script_lang_js_name = layout_grid_package.name,
    version = layout_grid_package.version;
/* harmony default export */ var colvue_type_script_lang_js_ = ({
  name: 'MdsCol',
  props: {
    alignVertical: {
      type: String,
      validator: function validator(value) {
        return ['flex-start', 'center', 'flex-end'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `flex-start`, `center`, `flex-end`.',
        description: 'Sets the `align-self` behavior for column content.'
      }
    },
    cols: {
      type: [Number, String],
      validator: function validator(value) {
        return value === 'auto' || value > 0 && value < 13;
      },
      docs: {
        validation: 'Must be either a number between `1` and `12` or `auto`.',
        description: 'Sets the number of columns, out of 12, for the column to span.'
      }
    },
    colsAtS: {
      type: [Number, String],
      validator: function validator(value) {
        return value === 'auto' || value > 0 && value < 13;
      },
      docs: {
        validation: 'Must be either a number between `1` and `12` or `auto`.',
        description: 'Sets the number of columns, out of 12, for the column to span at the small breakpoint (>600px).'
      }
    },
    colsAtM: {
      type: [Number, String],
      validator: function validator(value) {
        return value === 'auto' || value > 0 && value < 13;
      },
      docs: {
        validation: 'Must be either a number between `1` and `12` or `auto`.',
        description: 'Sets the number of columns, out of 12, for the column to span at the medium breakpoint (>768px).'
      }
    },
    colsAtL: {
      type: [Number, String],
      validator: function validator(value) {
        return value === 'auto' || value > 0 && value < 13;
      },
      docs: {
        validation: 'Must be either a number between `1` and `12` or `auto`.',
        description: 'Sets the number of columns, out of 12, for the column to span at the large breakpoint (>1000px).'
      }
    },
    colsAtXl: {
      type: [Number, String],
      validator: function validator(value) {
        return value === 'auto' || value > 0 && value < 13;
      },
      docs: {
        validation: 'Must be either a number between `1` and `12` or `auto`.',
        description: 'Sets the number of columns, out of 12, for the column to span at the extra-large breakpoint (>1200px).'
      }
    },
    pull: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 12;
      },
      docs: {
        validation: 'Must be number between `1` and `11`.',
        description: 'Applies right margin in column increments.'
      }
    },
    pullAtS: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 12;
      },
      docs: {
        validation: 'Must be number between `1` and `11`.',
        description: 'Applies right margin in column increments at the small breakpoint (>600px).'
      }
    },
    pullAtM: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 12;
      },
      docs: {
        validation: 'Must be number between `1` and `11`.',
        description: 'Applies right margin in column increments at the medium breakpoint (>768px).'
      }
    },
    pullAtL: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 12;
      },
      docs: {
        validation: 'Must be number between `1` and `11`.',
        description: 'Applies right margin in column increments at the large breakpoint (>1000px).'
      }
    },
    pullAtXl: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 12;
      },
      docs: {
        validation: 'Must be number between `1` and `11`.',
        description: 'Applies right margin in column increments at the extra-large breakpoint (>1200px).'
      }
    },
    push: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 12;
      },
      docs: {
        validation: 'Must be number between `1` and `11`.',
        description: 'Applies left margin in column increments.'
      }
    },
    pushAtS: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 12;
      },
      docs: {
        validation: 'Must be number between `1` and `11`.',
        description: 'Applies left margin in column increments at the small breakpoint (>600px).'
      }
    },
    pushAtM: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 12;
      },
      docs: {
        validation: 'Must be number between `1` and `11`.',
        description: 'Applies left margin in column increments at the medium breakpoint (>768px).'
      }
    },
    pushAtL: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 12;
      },
      docs: {
        validation: 'Must be number between `1` and `11`.',
        description: 'Applies left margin in column increments at the large breakpoint (>1000px).'
      }
    },
    pushAtXl: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 12;
      },
      docs: {
        validation: 'Must be number between `1` and `11`.',
        description: 'Applies left margin in column increments at the extra-large breakpoint (>1200px).'
      }
    },
    squeeze: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 6;
      },
      docs: {
        validation: 'Must be number between `1` and `5.',
        description: 'Applies left and right margin equally in column increments.'
      }
    },
    squeezeAtS: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 6;
      },
      docs: {
        validation: 'Must be number between `1` and `5.',
        description: 'Applies left and right margin equally in column increments at the small breakpoint (>600px).'
      }
    },
    squeezeAtM: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 6;
      },
      docs: {
        validation: 'Must be number between `1` and `5.',
        description: 'Applies left and right margin equally in column increments at the medium breakpoint (>768px).'
      }
    },
    squeezeAtL: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 6;
      },
      docs: {
        validation: 'Must be number between `1` and `5.',
        description: 'Applies left and right margin equally in column increments at the large breakpoint (>1000px).'
      }
    },
    squeezeAtXl: {
      type: Number,
      validator: function validator(value) {
        return value >= 0 && value < 6;
      },
      docs: {
        validation: 'Must be number between `1` and `5.',
        description: 'Applies left and right margin equally in column increments at the extra-large breakpoint (>1200px).'
      }
    },
    version: {
      type: String,
      default: "".concat(colvue_type_script_lang_js_name, "-").concat(version),
      docs: {
        validation: 'Read-only',
        description: 'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.'
      }
    }
  },
  inject: ['parent'],
  computed: {
    classObject: function classObject() {
      var obj = {};
      var baseClassName = 'mds-layout-grid__col';
      obj[this.$style["".concat(baseClassName, "--align-self-").concat(this.alignVertical)]] = this.alignVertical;
      obj[this.$style["".concat(baseClassName, "--").concat(this.cols)]] = this.cols;
      obj[this.$style["".concat(baseClassName, "--").concat(this.colsAtS, "-at-600")]] = this.colsAtS;
      obj[this.$style["".concat(baseClassName, "--").concat(this.colsAtM, "-at-768")]] = this.colsAtM;
      obj[this.$style["".concat(baseClassName, "--").concat(this.colsAtL, "-at-1000")]] = this.colsAtL;
      obj[this.$style["".concat(baseClassName, "--").concat(this.colsAtXl, "-at-1200")]] = this.colsAtXl;
      obj[this.$style["".concat(baseClassName, "--pull-").concat(this.pull)]] = this.pull;
      obj[this.$style["".concat(baseClassName, "--pull-").concat(this.pullAtS, "-at-600")]] = this.pullAtS;
      obj[this.$style["".concat(baseClassName, "--pull-").concat(this.pullAtM, "-at-768")]] = this.pullAtM;
      obj[this.$style["".concat(baseClassName, "--pull-").concat(this.pullAtL, "-at-1000")]] = this.pullAtL;
      obj[this.$style["".concat(baseClassName, "--pull-").concat(this.pullAtXl, "-at-1200")]] = this.pullAtXl;
      obj[this.$style["".concat(baseClassName, "--push-").concat(this.push)]] = this.push;
      obj[this.$style["".concat(baseClassName, "--push-").concat(this.pushAtS, "-at-600")]] = this.pushAtS;
      obj[this.$style["".concat(baseClassName, "--push-").concat(this.pushAtM, "-at-768")]] = this.pushAtM;
      obj[this.$style["".concat(baseClassName, "--push-").concat(this.pushAtL, "-at-1000")]] = this.pushAtL;
      obj[this.$style["".concat(baseClassName, "--push-").concat(this.pushAtXl, "-at-1200")]] = this.pushAtXl;
      obj[this.$style["".concat(baseClassName, "--squeeze-").concat(this.squeeze)]] = this.squeeze;
      obj[this.$style["".concat(baseClassName, "--squeeze-").concat(this.squeezeAtS, "-at-600")]] = this.squeezeAtS;
      obj[this.$style["".concat(baseClassName, "--squeeze-").concat(this.squeezeAtM, "-at-768")]] = this.squeezeAtM;
      obj[this.$style["".concat(baseClassName, "--squeeze-").concat(this.squeezeAtL, "-at-1000")]] = this.squeezeAtL;
      obj[this.$style["".concat(baseClassName, "--squeeze-").concat(this.squeezeAtXl, "-at-1200")]] = this.squeezeAtXl;
      obj[this.$style['mds-layout-grid__col--zero-padding']] = this.parent.gutters === 'none';
      return obj;
    }
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/col.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_colvue_type_script_lang_js_ = __webpack_exports__["a"] = (colvue_type_script_lang_js_); 

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(7);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/list-group/package.json
var list_group_package = __webpack_require__(32);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/list-group/src/list-group.vue?vue&type=script&lang=js&


//
//
//
//
//
//

var list_groupvue_type_script_lang_js_name = list_group_package.name,
    version = list_group_package.version;
/* harmony default export */ var list_groupvue_type_script_lang_js_ = ({
  name: 'MdsListGroup',
  props: {
    onDark: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, changes component to on-dark styling.'
      }
    },
    size: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return ['small', 'medium', 'large', 'touch'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `small`, `medium`, `large`, `touch`.',
        description: 'Sets the size of the list group.'
      }
    },
    variation: {
      type: String,
      default: 'default',
      validator: function validator(value) {
        return ['default', 'selection', 'navigation'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `default`, `selection`, `navigation`.',
        description: 'Sets the list group variation.'
      }
    },
    withIcon: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, creates space in list group items for an icon.'
      }
    },
    version: {
      type: String,
      default: "".concat(list_groupvue_type_script_lang_js_name, "-").concat(version),
      docs: {
        validation: 'Read-only',
        description: 'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.'
      }
    }
  },
  provide: function provide() {
    var _this = this;

    // Properties that are available for injection into components descendants https://vuejs.org/v2/api/#provide-inject
    var parentVariation = {};
    Object.defineProperty(parentVariation, 'variationObj', {
      enumerable: true,
      get: function get() {
        return _this.variation;
      }
    });
    Object.defineProperty(parentVariation, 'size', {
      enumerable: true,
      get: function get() {
        return _this.size;
      }
    });
    return {
      parentVariation: parentVariation
    };
  },
  computed: {
    sizeClass: function sizeClass() {
      return this.$style["mds-list-group--".concat(this.size)];
    },
    classObject: function classObject() {
      var obj = {};
      obj[this.$style['mds-list-group__navigation']] = this.variation === 'navigation';
      obj[this.$style['mds-list-group--with-icon']] = this.withIcon;
      obj[this.$style['mds-component--on-dark']] = this.onDark;
      return obj;
    }
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/list-group/src/list-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_list_groupvue_type_script_lang_js_ = __webpack_exports__["a"] = (list_groupvue_type_script_lang_js_); 

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(7);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/icon/src/icon.vue
var icon = __webpack_require__(30);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/list-group/package.json
var list_group_package = __webpack_require__(32);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/list-group/src/list-group-item.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var list_group_itemvue_type_script_lang_js_name = list_group_package.name,
    version = list_group_package.version;
/* harmony default export */ var list_group_itemvue_type_script_lang_js_ = ({
  name: 'MdsListGroupItem',
  components: {
    MdsIcon: icon["a" /* default */]
  },
  model: {
    prop: 'toggleActive',
    event: 'input'
  },
  inject: ['parentVariation'],
  // Properties that are provided via ancestor components https://vuejs.org/v2/api/#provide-inject
  props: {
    active: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, sets the item to active.'
      }
    },
    disabled: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, sets thhe item to disabled.'
      }
    },
    href: {
      type: String,
      docs: {
        validation: '—',
        description: 'When provided, makes the list group item `a`-based and sets the `href` path.'
      }
    },
    iconLeft: {
      type: String,
      docs: {
        validation: 'Must be a valid icon name.',
        description: 'Sets the item icon.'
      }
    },
    image: {
      type: String,
      docs: {
        validation: 'Must be a valid icon name.',
        description: 'Sets the item image.'
      }
    },
    imageRound: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, makes the item image round.'
      }
    },
    metadata: {
      type: String,
      docs: {
        validation: '—',
        description: 'Sets the item metadata.',
        support: ['v-html']
      }
    },
    metadataBelow: {
      type: Array,
      docs: {
        validation: '—',
        description: 'Sets the item metadata below.',
        support: ['v-html']
      }
    },
    microcopy: {
      type: String,
      docs: {
        validation: '—',
        description: 'Sets the item microcopy.'
      }
    },
    separatorBefore: {
      type: Boolean,
      default: false,
      docs: {
        validation: 'Only use within a sublist.',
        description: 'If `true`, adds a separator above the item.'
      }
    },
    sublist: {
      type: Boolean,
      docs: {
        validation: '',
        description: 'If `true`, item should wrap another list group to creates a sublist.'
      }
    },
    text: {
      type: String,
      docs: {
        validation: '**Required**',
        description: 'Sets the item text.'
      }
    },
    toggleActive: {
      type: Boolean,
      default: false,
      docs: {
        validation: 'Only use on an item with `sublist` set to `true`.',
        description: 'If `true`, expands the sublist.',
        support: ['v-model']
      }
    },
    version: {
      type: String,
      default: "".concat(list_group_itemvue_type_script_lang_js_name, "-").concat(version),
      docs: {
        validation: 'Read-only',
        description: 'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.'
      }
    }
  },
  computed: {
    classObject: function classObject() {
      var obj = {};
      obj[this.$style['mds-list-group__item--sublist']] = this.sublist;
      obj[this.$style['mds-list-group__item--active']] = this.active;
      obj[this.$style['mds-list-group__item--disabled']] = this.disabled;
      obj[this.$style['mds-list-group__item--separator-before']] = this.separatorBefore;
      return obj;
    },
    dynamicComponent: function dynamicComponent() {
      return this.href ? 'a' : 'span';
    },
    iconSize: function iconSize() {
      return this.parentVariation.size === 'small' || this.parentVariation.size === 'medium' ? 'small' : 'medium';
    },
    imageClass: function imageClass() {
      return this.image ? this.$style['mds-list-group__link--with-image'] : '';
    },
    imageRoundClass: function imageRoundClass() {
      return this.imageRound ? this.$style['mds-list-group__item-image--round'] : '';
    },
    spanIndex: function spanIndex() {
      return this.href ? null : 0;
    }
  },
  data: function data() {
    return {
      toggleId: '',
      inputId: '',
      size: null
    };
  },
  methods: {
    randomNum: function randomNum() {
      var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000000000000000;
      return Math.floor(Math.random() * Math.floor(max));
    },
    bindEventHandlers: function bindEventHandlers() {
      var _this = this;

      this.$el.addEventListener('click', function (event) {
        if (!_this.disabled) {
          _this.$emit('mds-list-item-clicked', event.currentTarget, event);
        }
      });
    }
  },
  mounted: function mounted() {
    this.toggleId = this.randomNum();
    this.inputId = this.randomNum();
    this.bindEventHandlers();
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/list-group/src/list-group-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_list_group_itemvue_type_script_lang_js_ = __webpack_exports__["a"] = (list_group_itemvue_type_script_lang_js_); 

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(35);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(37);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(7);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/tabs/src/tabs-item.vue
var tabs_item = __webpack_require__(81);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/tabs/package.json
var tabs_package = __webpack_require__(149);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/tabs/src/tabs.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var tabsvue_type_script_lang_js_name = tabs_package.name,
    version = tabs_package.version;
/* harmony default export */ var tabsvue_type_script_lang_js_ = ({
  name: 'MdsTabs',
  components: {
    MdsTabsItem: tabs_item["a" /* default */]
  },
  props: {
    alignment: {
      type: String,
      default: 'left',
      validator: function validator(value) {
        return ['left', 'center'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `left`, `center`.',
        description: 'Sets the alignment of the tabs items.'
      }
    },
    content: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      },
      validator: function validator(items) {
        var passValidation = true;
        items.forEach(function (item) {
          if (item.hasOwnProperty('active') !== true) {
            passValidation = false;
          }
        });
        return passValidation;
      },
      docs: {
        validation: '—',
        description: 'Sets content for the tabs using the tabs item API defined below. **This prop has been deprecated. Use the `MdsTabs` default slot to pass `MdsTabsItem` instead.**{.mds-doc-prop-table__deprecated-text}',
        deprecated: true
      }
    },
    onDark: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, changes component to on-dark styling.'
      }
    },
    responsive: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, turns on the overflow responsiveness of tabs. Implementing teams also need to call the `responsiveTabs()` method in order to trigger the responsive behavior.'
      }
    },
    size: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return ['small', 'medium', 'large'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `small`, `medium`, `large`.',
        description: 'Sets the size of the containted tabs items.'
      }
    },
    variation: {
      type: String,
      default: 'in-page',
      validator: function validator(value) {
        return ['in-page', 'site-navigation'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `in-page`, `site-navigation`.',
        description: 'Sets the tabs variation.'
      }
    },
    version: {
      type: String,
      default: "".concat(tabsvue_type_script_lang_js_name, "-").concat(version),
      docs: {
        validation: 'Read-only',
        description: 'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.'
      }
    }
  },
  provide: function provide() {
    var _this = this;

    // Properties that are available for injection into components descendants https://vuejs.org/v2/api/#provide-inject
    var parentVariation = {};
    Object.defineProperty(parentVariation, 'onDark', {
      enumerable: true,
      get: function get() {
        return _this.onDark;
      }
    });
    Object.defineProperty(parentVariation, 'size', {
      enumerable: true,
      get: function get() {
        return _this.size;
      }
    });
    return {
      parentVariation: parentVariation
    };
  },
  computed: {
    sizeClass: function sizeClass() {
      return this.$style["mds-tabs--".concat(this.size)];
    },
    variationClass: function variationClass() {
      return this.$style["mds-tabs--".concat(this.variation)];
    },
    classObject: function classObject() {
      var obj = {};
      obj[this.$style['mds-tabs--centered']] = this.alignment === 'center';
      obj[this.$style['mds-component--on-dark']] = this.onDark;
      return obj;
    },
    responsiveObject: function responsiveObject() {
      var obj = {};
      obj[this.$style['mds-tabs--responsive']] = this.responsive;
      obj[this.$style['mds-tabs--responsive-left']] = this.responsive && this.overflowLeft;
      obj[this.$style['mds-tabs--responsive-right']] = this.responsive && this.overflowRight;
      return obj;
    }
  },
  watch: {
    responsive: function responsive(newVal) {
      if (newVal) {
        this.responsiveTabs();
      }
    }
  },
  data: function data() {
    return {
      overflowRight: false,
      overflowLeft: false
    };
  },
  methods: {
    responsiveTabs: function responsiveTabs() {
      var containerScrollWidth = this.containerEl.scrollWidth;
      var containerOffsetWidth = this.containerEl.offsetWidth;
      var containerScrollLeft = Math.round(this.containerEl.scrollLeft);
      var containerScrollLeftMax = this.containerEl.scrollWidth - this.containerEl.clientWidth;
      this.overflowRight = containerScrollWidth > containerOffsetWidth;
      this.overflowLeft = containerScrollLeft > 0;
      this.overflowRight = containerScrollLeft !== containerScrollLeftMax;
      this.$refs['container'].addEventListener('scroll', this.responsiveTabs);
    }
  },
  mounted: function mounted() {
    this.containerEl = this.$refs['container'];

    if (this.responsive) {
      this.responsiveTabs();
    }
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/tabs/src/tabs.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tabsvue_type_script_lang_js_ = __webpack_exports__["a"] = (tabsvue_type_script_lang_js_); 

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/button/src/index.js
var src = __webpack_require__(17);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/routable/src/routable.js
var routable = __webpack_require__(96);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/tabs/src/tabs-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var tabs_itemvue_type_script_lang_js_ = ({
  name: 'MdsTabsItem',
  mixins: [routable["a" /* default */]],
  components: {
    MdsButton: src["a" /* MdsButton */]
  },
  props: {
    active: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'If `true`, applies active styling to the tab item.'
      }
    },
    href: {
      type: String,
      docs: {
        validation: '—',
        description: 'When provided, makes the tabs item `a`-based and sets the `href` path.'
      }
    },
    icon: {
      type: String,
      docs: {
        validation: 'Must be a valid icon name.',
        description: 'Sets the left icon.'
      }
    },
    iconRight: {
      type: String,
      docs: {
        validation: 'Must be a valid icon name.',
        description: 'Sets the right icon.'
      }
    },
    target: {
      type: String,
      docs: {
        validation: '—',
        description: 'Sets the `target` attribute.'
      }
    },
    text: {
      type: String,
      docs: {
        validation: '**Required**',
        description: 'Sets the tab item text.'
      }
    }
  },
  inject: ['parentVariation'],
  // Properties that are provided via ancestor components https://vuejs.org/v2/api/#provide-inject
  computed: {
    classObject: function classObject() {
      var obj = {};
      obj[this.$style['mds-tabs__item--active']] = this.active;
      return obj;
    },
    typeAttribute: function typeAttribute() {
      return this.href ? null : 'button';
    },
    size: function size() {
      return this.parentVariation.size;
    },
    onDark: function onDark() {
      return this.parentVariation.onDark;
    }
  },
  methods: {
    makeActive: function makeActive(event) {
      this.$emit('mds-tabs-item-active', event);
    },
    activeClass: function activeClass(isActive, isExactActive) {
      var active = this.exact ? isExactActive : isActive;
      return active ? this.$style['mds-tabs__item--active'] : null;
    }
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/tabs/src/tabs-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tabs_itemvue_type_script_lang_js_ = __webpack_exports__["a"] = (tabs_itemvue_type_script_lang_js_); 

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(7);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/icon/dist/mds-icons.json
var mds_icons = __webpack_require__(237);

// EXTERNAL MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/icon/package.json
var icon_package = __webpack_require__(133);

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/babel-loader/lib??ref--4!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/icon/src/icon.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//


var iconvue_type_script_lang_js_name = icon_package.name,
    version = icon_package.version;
/* harmony default export */ var iconvue_type_script_lang_js_ = ({
  name: 'MdsIcon',
  props: {
    name: {
      type: String,
      docs: {
        validation: 'Must be a valid icon name.',
        description: 'Sets the icon.'
      }
    },
    title: {
      type: String,
      docs: {
        validation: '—',
        description: 'Sets the accessible title for the icon.'
      }
    },
    size: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return ['small', 'medium'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `small`, `medium`.',
        description: 'Sets the size of the icon.'
      }
    },
    version: {
      type: String,
      default: "".concat(iconvue_type_script_lang_js_name, "-").concat(version),
      docs: {
        validation: 'Read-only',
        description: 'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.'
      }
    }
  },
  customIcons: {},
  computed: {
    sizeClass: function sizeClass() {
      return this.size === 'small' ? this.$style['mds-icon--small'] : '';
    },
    svgIcon: function svgIcon() {
      return mds_icons[this.name] || this.$options.customIcons[this.name];
    }
  }
});
// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/icon/src/icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_iconvue_type_script_lang_js_ = __webpack_exports__["a"] = (iconvue_type_script_lang_js_); 

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(113);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(378);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__);


var MdsRoutable = {
  props: {
    append: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'Setting `append` prop always appends the relative path to the current path. You can find more information about the `append` prop on the [vue-router documentation](https://router.vuejs.org/api/#router-link-props).',
        support: ['routing']
      }
    },
    exact: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'Setting `exact` prop will change the `active-class` matching behavior from using an inclusive match to an exact match. You can find more information about the `exact` prop on the [vue-router documentation](https://router.vuejs.org/api/#router-link-props).',
        support: ['routing']
      }
    },
    exactPath: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'Setting `exact-path` will exactly match the link, ignoring the query and the hash sections. You can find more information about the exact-path prop on the [vue-router documentation](https://router.vuejs.org/api/#router-link-props).',
        support: ['routing']
      }
    },
    linkTag: {
      type: String,
      default: 'router-link',
      validator: function validator(value) {
        return ['router-link', 'nuxt-link'].indexOf(value) !== -1;
      },
      docs: {
        validation: 'One of: `router-link`, `nuxt-link`.',
        description: 'Configures if `nuxt-link` or `router-link` should be used. You can find more information about the `tag` prop on the [vue-router documentation](https://router.vuejs.org/api/#router-link-props).',
        support: ['routing']
      }
    },
    noPrefetch: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'Disables the `prefetch` option on a link.',
        support: ['routing']
      }
    },
    prefetch: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'Configures the `prefetch` value on a link by overriding the default value of router.prefetchLinks configured in the nuxt.config.js configuration file.',
        support: ['routing']
      }
    },
    replace: {
      type: Boolean,
      default: false,
      docs: {
        validation: '—',
        description: 'Setting `replace` prop will call `router.replace()` instead of `router.push()` when clicked, so the navigation will not leave a history record. You can find more information about the `replace` prop on the [vue-router documentation](https://router.vuejs.org/api/#router-link-props).',
        support: ['routing']
      }
    },
    to: {
      type: [String, Object],
      docs: {
        validation: '—',
        description: 'Determines if a component is used for routing and denotes the target route of the link. You can find more information about the `to` prop on the [vue-router documentation](https://router.vuejs.org/api/#router-link-props).',
        support: ['routing']
      }
    }
  },
  computed: {
    isRoutable: function isRoutable() {
      return this.to !== null && this.to !== undefined;
    },
    routingProps: function routingProps() {
      return this.isRoutable ? {
        append: this.append,
        exact: this.exact,
        exactPath: this.exactPath,
        replace: this.replace,
        to: this.to,
        prefetch: this.prefetch,
        noPrefetch: this.noPrefetch
      } : null;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (MdsRoutable);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _loader_vue_vue_type_template_id_404454cd___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(154);
/* harmony import */ var _loader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84);
/* harmony import */ var _loader_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(136);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_loader_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"].locals || _loader_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _loader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _loader_vue_vue_type_template_id_404454cd___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _loader_vue_vue_type_template_id_404454cd___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/node_modules/@mds/loader/src/loader.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():undefined}(window,(function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=62)}([function(t,e,n){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=n(27),i="object"==("undefined"==typeof self?"undefined":r(self))&&self&&self.Object===Object&&self,u=o||i||Function("return this")();t.exports=u},function(t,e,n){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};t.exports=function(t){var e=void 0===t?"undefined":r(t);return null!=t&&("object"==e||"function"==e)}},function(t,e,n){"use strict";var r=n(76),o=n(81);t.exports=function(t,e){var n=o(t,e);return r(n)?n:void 0}},function(t,e,n){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};t.exports=function(t){return null!=t&&"object"==(void 0===t?"undefined":r(t))}},function(t,e,n){"use strict";(function(e){var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},r=function(t){return t&&t.Math==Math&&t};t.exports=r("object"==("undefined"==typeof globalThis?"undefined":n(globalThis))&&globalThis)||r("object"==("undefined"==typeof window?"undefined":n(window))&&window)||r("object"==("undefined"==typeof self?"undefined":n(self))&&self)||r("object"==(void 0===e?"undefined":n(e))&&e)||function(){return this}()||Function("return this")()}).call(this,n(19))},function(t,e,n){"use strict";var r=n(11),o=n(77),i=n(78),u=r?r.toStringTag:void 0;t.exports=function(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":u&&u in Object(t)?o(t):i(t)}},function(t,e,n){"use strict";t.exports=function(t,e){return t===e||t!=t&&e!=e}},function(t,e,n){"use strict";var r=Array.isArray;t.exports=r},function(t,e,n){"use strict";t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){"use strict";var r=n(66),o=n(67),i=n(68),u=n(69),s=n(70);function c(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}c.prototype.clear=r,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=u,c.prototype.set=s,t.exports=c},function(t,e,n){"use strict";var r=n(6);t.exports=function(t,e){for(var n=t.length;n--;)if(r(t[n][0],e))return n;return-1}},function(t,e,n){"use strict";var r=n(0).Symbol;t.exports=r},function(t,e,n){"use strict";var r=n(2)(Object,"create");t.exports=r},function(t,e,n){"use strict";var r=n(90);t.exports=function(t,e){var n=t.__data__;return r(e)?n["string"==typeof e?"string":"hash"]:n.map}},function(t,e,n){"use strict";var r=n(18),o=n(36);t.exports=function(t){return null!=t&&o(t.length)&&!r(t)}},function(t,e,n){"use strict";var r=n(8);t.exports=!r((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]}))},function(t,e,n){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};t.exports=function(t){return"object"===(void 0===t?"undefined":r(t))?null!==t:"function"==typeof t}},function(t,e,n){"use strict";var r=n(2)(n(0),"Map");t.exports=r},function(t,e,n){"use strict";var r=n(5),o=n(1);t.exports=function(t){if(!o(t))return!1;var e=r(t);return"[object Function]"==e||"[object GeneratorFunction]"==e||"[object AsyncFunction]"==e||"[object Proxy]"==e}},function(t,e,n){"use strict";var r,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};r=function(){return this}();try{r=r||new Function("return this")()}catch(t){"object"===("undefined"==typeof window?"undefined":o(window))&&(r=window)}t.exports=r},function(t,e,n){"use strict";var r=n(31);t.exports=function(t,e,n){"__proto__"==e&&r?r(t,e,{configurable:!0,enumerable:!0,value:n,writable:!0}):t[e]=n}},function(t,e,n){"use strict";t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},function(t,e,n){"use strict";var r=Object.prototype;t.exports=function(t){var e=t&&t.constructor;return t===("function"==typeof e&&e.prototype||r)}},function(t,e,n){"use strict";(function(t){var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=n(0),i=n(105),u="object"==r(e)&&e&&!e.nodeType&&e,s=u&&"object"==r(t)&&t&&!t.nodeType&&t,c=s&&s.exports===u?o.Buffer:void 0,a=(c?c.isBuffer:void 0)||i;t.exports=a}).call(this,n(21)(t))},function(t,e,n){"use strict";var r=n(107),o=n(108),i=n(109),u=i&&i.isTypedArray,s=u?o(u):r;t.exports=s},function(t,e,n){"use strict";var r=n(52),o={}.hasOwnProperty;t.exports=function(t,e){return o.call(r(t),e)}},function(t,e,n){"use strict";var r=n(9),o=n(71),i=n(72),u=n(73),s=n(74),c=n(75);function a(t){var e=this.__data__=new r(t);this.size=e.size}a.prototype.clear=o,a.prototype.delete=i,a.prototype.get=u,a.prototype.has=s,a.prototype.set=c,t.exports=a},function(t,e,n){"use strict";(function(e){var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},r="object"==(void 0===e?"undefined":n(e))&&e&&e.Object===Object&&e;t.exports=r}).call(this,n(19))},function(t,e,n){"use strict";var r=Function.prototype.toString;t.exports=function(t){if(null!=t){try{return r.call(t)}catch(t){}try{return t+""}catch(t){}}return""}},function(t,e,n){"use strict";var r=n(82),o=n(89),i=n(91),u=n(92),s=n(93);function c(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}c.prototype.clear=r,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=u,c.prototype.set=s,t.exports=c},function(t,e,n){"use strict";var r=n(20),o=n(6);t.exports=function(t,e,n){(void 0===n||o(t[e],n))&&(void 0!==n||e in t)||r(t,e,n)}},function(t,e,n){"use strict";var r=n(2),o=function(){try{var t=r(Object,"defineProperty");return t({},"",{}),t}catch(t){}}();t.exports=o},function(t,e,n){"use strict";var r=n(0).Uint8Array;t.exports=r},function(t,e,n){"use strict";var r=n(34)(Object.getPrototypeOf,Object);t.exports=r},function(t,e,n){"use strict";t.exports=function(t,e){return function(n){return t(e(n))}}},function(t,e,n){"use strict";var r=n(103),o=n(3),i=Object.prototype,u=i.hasOwnProperty,s=i.propertyIsEnumerable,c=r(function(){return arguments}())?r:function(t){return o(t)&&u.call(t,"callee")&&!s.call(t,"callee")};t.exports=c},function(t,e,n){"use strict";t.exports=function(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=9007199254740991}},function(t,e,n){"use strict";t.exports=function(t,e){if(("constructor"!==e||"function"!=typeof t[e])&&"__proto__"!=e)return t[e]}},function(t,e,n){"use strict";var r=n(39),o=n(114),i=n(14);t.exports=function(t){return i(t)?r(t,!0):o(t)}},function(t,e,n){"use strict";var r=n(113),o=n(35),i=n(7),u=n(23),s=n(40),c=n(24),a=Object.prototype.hasOwnProperty;t.exports=function(t,e){var n=i(t),f=!n&&o(t),l=!n&&!f&&u(t),p=!n&&!f&&!l&&c(t),d=n||f||l||p,y=d?r(t.length,String):[],h=y.length;for(var v in t)!e&&!a.call(t,v)||d&&("length"==v||l&&("offset"==v||"parent"==v)||p&&("buffer"==v||"byteLength"==v||"byteOffset"==v)||s(v,h))||y.push(v);return y}},function(t,e,n){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=/^(?:0|[1-9]\d*)$/;t.exports=function(t,e){var n=void 0===t?"undefined":r(t);return!!(e=null==e?9007199254740991:e)&&("number"==n||"symbol"!=n&&o.test(t))&&t>-1&&t%1==0&&t<e}},function(t,e,n){"use strict";t.exports=function(t){return t}},function(t,e,n){"use strict";var r=n(131);t.exports=function(t){return null==t?"":r(t)}},function(t,e,n){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=n(5),i=n(3);t.exports=function(t){return"symbol"==(void 0===t?"undefined":r(t))||i(t)&&"[object Symbol]"==o(t)}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={getNamespaceId:function(t,e){return t.concat("-",e||"empty").replace(/\./g,"-")}}},function(t,e,n){"use strict";var r=n(141),o=n(144),i=n(145);t.exports=function(t,e,n,u,s,c){var a=1&n,f=t.length,l=e.length;if(f!=l&&!(a&&l>f))return!1;var p=c.get(t);if(p&&c.get(e))return p==e;var d=-1,y=!0,h=2&n?new r:void 0;for(c.set(t,e),c.set(e,t);++d<f;){var v=t[d],m=e[d];if(u)var b=a?u(m,v,d,e,t,c):u(v,m,d,t,e,c);if(void 0!==b){if(b)continue;y=!1;break}if(h){if(!o(e,(function(t,e){if(!i(h,e)&&(v===t||s(v,t,n,u,c)))return h.push(e)}))){y=!1;break}}else if(v!==m&&!s(v,m,n,u,c)){y=!1;break}}return c.delete(t),c.delete(e),y}},function(t,e,n){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=n(4),i=n(174).f,u=n(178),s=n(54),c=n(55),a=n(56),f=n(25),l=function(t){var e=function(e,n,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,r)}return t.apply(this,arguments)};return e.prototype=t.prototype,e};t.exports=function(t,e){var n,p,d,y,h,v,m,b,g=t.target,_=t.global,x=t.stat,w=t.proto,j=_?o:x?o[g]:(o[g]||{}).prototype,S=_?s:s[g]||(s[g]={}),O=S.prototype;for(d in e)n=!u(_?d:g+(x?".":"#")+d,t.forced)&&j&&f(j,d),h=S[d],n&&(v=t.noTargetGet?(b=i(j,d))&&b.value:j[d]),y=n&&v?v:e[d],n&&(void 0===h?"undefined":r(h))===(void 0===y?"undefined":r(y))||(m=t.bind&&n?c(y,o):t.wrap&&n?l(y):w&&"function"==typeof y?c(Function.call,y):y,(t.sham||y&&y.sham||h&&h.sham)&&a(m,"sham",!0),S[d]=m,w&&(f(s,p=g+"Prototype")||a(s,p,{}),s[p][d]=y,t.real&&O&&!O[d]&&a(O,d,y)))}},function(t,e,n){"use strict";t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){"use strict";var r=n(8),o=n(49),i="".split;t.exports=r((function(){return!Object("z").propertyIsEnumerable(0)}))?function(t){return"String"==o(t)?i.call(t,""):Object(t)}:Object},function(t,e,n){"use strict";var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,e,n){"use strict";t.exports=function(t){if(null==t)throw TypeError("Can't call method on "+t);return t}},function(t,e,n){"use strict";var r=n(16);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){"use strict";var r=n(50);t.exports=function(t){return Object(r(t))}},function(t,e,n){"use strict";var r=n(15),o=n(8),i=n(177);t.exports=!r&&!o((function(){return 7!=Object.defineProperty(i("div"),"a",{get:function(){return 7}}).a}))},function(t,e,n){"use strict";t.exports={}},function(t,e,n){"use strict";var r=n(179);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 0:return function(){return t.call(e)};case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e,n){"use strict";var r=n(15),o=n(180),i=n(47);t.exports=r?function(t,e,n){return o.f(t,e,i(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){"use strict";var r=n(55),o=n(48),i=n(52),u=n(182),s=n(184),c=[].push,a=function(t){var e=1==t,n=2==t,a=3==t,f=4==t,l=6==t,p=7==t,d=5==t||l;return function(y,h,v,m){for(var b,g,_=i(y),x=o(_),w=r(h,v,3),j=u(x.length),S=0,O=m||s,C=e?O(y,j):n||p?O(y,0):void 0;j>S;S++)if((d||S in x)&&(g=w(b=x[S],S,_),t))if(e)C[S]=g;else if(g)switch(t){case 3:return!0;case 5:return b;case 6:return S;case 2:c.call(C,b)}else switch(t){case 4:return!1;case 7:c.call(C,b)}return l?-1:a||f?f:C}};t.exports={forEach:a(0),map:a(1),filter:a(2),some:a(3),every:a(4),find:a(5),findIndex:a(6),filterOut:a(7)}},function(t,e,n){"use strict";var r=n(192),o=n(8);t.exports=!!Object.getOwnPropertySymbols&&!o((function(){return!String(Symbol())||!Symbol.sham&&r&&r<41}))},function(t,e,n){"use strict";var r=n(54),o=n(4),i=function(t){return"function"==typeof t?t:void 0};t.exports=function(t,e){return arguments.length<2?i(r[t])||i(o[t]):r[t]&&r[t][e]||o[t]&&o[t][e]}},function(t,e,n){"use strict";t.exports=function(){}},function(t,e,n){"use strict";var r=n(59);t.exports=r},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.MwcResponsiveMixin=e.MwcLayoutMixin=e.MwcConfigMixin=void 0;var r=s(n(63)),o=s(n(137)),i=s(n(164)),u=s(n(166));function s(t){return t&&t.__esModule?t:{default:t}}e.default=r.default,e.MwcConfigMixin=o.default,e.MwcLayoutMixin=i.default,e.MwcResponsiveMixin=u.default},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=s(n(64)),i=s(n(125)),u=s(n(44));function s(t){return t&&t.__esModule?t:{default:t}}function c(){return!!window.mwc}function a(t,e){if(e instanceof Array)return e}function f(){return c()?window.mwc.configuration.defaultConfig:{}}e.default={name:"mwc-vue-base-mixin",props:["mwcId","config"],data:function(){return{mwcCustomElementReady:!1}},provide:function(){return{injectedConfig:!c()&&this.getComponentConfig()}},inject:{injectedConfig:{default:function(){return null}},formatCurrencyCustom:{default:function(){return null}},getCurrencySymbolCustom:{default:function(){return null}},formatDateCustom:{default:function(){return null}},formatNumberCustom:{default:function(){return null}},translateCustom:{default:function(){return null}},loggerCustom:{default:function(){return null}}},computed:{parsedConfig:function(){var t=this.injectedConfig||this.config;return"string"==typeof t?JSON.parse(t):t},translate:function(){var t=this;return function(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];return(t.translateCustom||c()&&t.translateWithMwc||function(e){var n=t.getComponentConfig(),r=n.labels,o=void 0===r?{}:r,i=n.settings,u=o[(void 0===i?{languageId:"en"}:i).languageId];return u&&u[e]||e}).apply(t,n)}},formatCurrency:function(){var t=this;return function(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];return(t.formatCurrencyCustom||c()&&t.formatCurrencyWithMwc||function(t){return t&&t.toString()||t}).apply(t,n)}},getCurrencySymbol:function(){var t=this;return function(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];return(t.getCurrencySymbolCustom||c()&&t.getCurrencySymbolWithMwc||function(){return""}).apply(t,n)}},formatDate:function(){var t=this;return function(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];return(t.formatDateCustom||c()&&t.formatDateWithMwc||function(t){return t&&t.toString()||t}).apply(t,n)}},formatNumber:function(){var t=this;return function(){for(var e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];return(t.formatNumberCustom||c()&&t.formatNumberWithMwc||function(t){return t&&t.toString()||t}).apply(t,n)}},logger:function(){return this.loggerCustom||this.loggerInternal}},created:function(){this.$_componentConfig=this.getComponentConfig(),this.settings=this.$_componentConfig.settings;var t=this.settings||{},e=t.languageId,n=t.currencyId;this.loggerInternal=window.mwc&&window.mwc.logger?window.mwc.logger:{fatal:console.error,error:console.error,warn:console.warn,info:console.info,debug:console.debug,trace:console.trace};var r=window.mwc;if(r){var o=r.Formatter;this.formatter=new o(e,this.$_componentConfig.format,n);var i=r.Labeller,u=this.getIntlNamespace(this.$_componentConfig);this.labeller=new i(e,this.$_componentConfig.labels,u)}},mounted:function(){var t=this;customElements&&customElements.whenDefined(this.$options.name).then((function(){t.mwcCustomElementReady=!0}))},methods:{getIntlNamespace:function(t){return t&&t.intlNamespace?t.intlNamespace:this.mwcId||"uid_"+this._uid},getComponentConfig:function(){var t=window.mwc?window.mwc.configuration:null;return this.mwcId&&t?t.getConfig(this.mwcId,this.defaultConfig,this.parsedConfig):function(t,e){var n=(0,o.default)(t,e,a);return"object"===(void 0===n?"undefined":r(n))?n:{}}(this.defaultConfig,this.parsedConfig)},getNamespaceId:function(t){return u.default.getNamespaceId(this.mwcId||"",t).replace(/^-/,"")},getMwcStorageItem:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.settings.preferredStorageMethod;return c()?window.mwc.storageHelper.getItem(this.mwcId,t,e):null},setMwcStorageItem:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.settings.preferredStorageMethod;return c()?window.mwc.storageHelper.setItem(this.mwcId,t,e,n):null},getMwcIdForChild:function(t){return[this.mwcId,t].filter((function(t){return t})).join(".")},isComponentSubscribed:function(t,e,n){return c()&&window.mwc.dataManager.isComponentSubscribed?window.mwc.dataManager.isComponentSubscribed(t,e,n):null},translateWithMwc:function(t,e){return this.labeller.getLabel(t,e)},formatNumberWithMwc:function(t,e,n){return this.formatter.number(t,e||"number",n)},formatCurrencyWithMwc:function(t,e){return this.formatter.currency(t,e)},getCurrencySymbolWithMwc:function(t){return this.formatter.currencySymbolOnly(t)},formatDateWithMwc:function(t,e){return this.formatter.number(t,e||"date")},getMwcToolName:function(t){var e=void 0,n=f(),r=this.mwcId.split(".")[0];return n[r]&&n[r].type&&(e=(0,i.default)(n[r].type)),e||t},getMwcComponentName:function(t){var e=void 0,n=f();return n[this.mwcId]&&n[this.mwcId].type&&(e=(0,i.default)(n[this.mwcId].type)),e||t},getMwcDataManagerParameters:function(){var t=this,e={},n=this.getMwcToolName(this.$options.name),r=this.getMwcComponentName(this.$options.name||n);return e.usageTrackingOptions={tool:n,component:r},this.settings&&["currencyId","environment","languageId","sourceApi","tokenSource","universeIds","urlKey"].forEach((function(n){t.settings[n]&&(e[n]=t.settings[n])})),e}}}},function(t,e,n){"use strict";var r=n(65),o=n(116)((function(t,e,n,o){r(t,e,n,o)}));t.exports=o},function(t,e,n){"use strict";var r=n(26),o=n(30),i=n(94),u=n(96),s=n(1),c=n(38),a=n(37);t.exports=function t(e,n,f,l,p){e!==n&&i(n,(function(i,c){if(p||(p=new r),s(i))u(e,n,c,f,t,l,p);else{var d=l?l(a(e,c),i,c+"",e,n,p):void 0;void 0===d&&(d=i),o(e,c,d)}}),c)}},function(t,e,n){"use strict";t.exports=function(){this.__data__=[],this.size=0}},function(t,e,n){"use strict";var r=n(10),o=Array.prototype.splice;t.exports=function(t){var e=this.__data__,n=r(e,t);return!(n<0||(n==e.length-1?e.pop():o.call(e,n,1),--this.size,0))}},function(t,e,n){"use strict";var r=n(10);t.exports=function(t){var e=this.__data__,n=r(e,t);return n<0?void 0:e[n][1]}},function(t,e,n){"use strict";var r=n(10);t.exports=function(t){return r(this.__data__,t)>-1}},function(t,e,n){"use strict";var r=n(10);t.exports=function(t,e){var n=this.__data__,o=r(n,t);return o<0?(++this.size,n.push([t,e])):n[o][1]=e,this}},function(t,e,n){"use strict";var r=n(9);t.exports=function(){this.__data__=new r,this.size=0}},function(t,e,n){"use strict";t.exports=function(t){var e=this.__data__,n=e.delete(t);return this.size=e.size,n}},function(t,e,n){"use strict";t.exports=function(t){return this.__data__.get(t)}},function(t,e,n){"use strict";t.exports=function(t){return this.__data__.has(t)}},function(t,e,n){"use strict";var r=n(9),o=n(17),i=n(29);t.exports=function(t,e){var n=this.__data__;if(n instanceof r){var u=n.__data__;if(!o||u.length<199)return u.push([t,e]),this.size=++n.size,this;n=this.__data__=new i(u)}return n.set(t,e),this.size=n.size,this}},function(t,e,n){"use strict";var r=n(18),o=n(79),i=n(1),u=n(28),s=/^\[object .+?Constructor\]$/,c=Function.prototype,a=Object.prototype,f=c.toString,l=a.hasOwnProperty,p=RegExp("^"+f.call(l).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");t.exports=function(t){return!(!i(t)||o(t))&&(r(t)?p:s).test(u(t))}},function(t,e,n){"use strict";var r=n(11),o=Object.prototype,i=o.hasOwnProperty,u=o.toString,s=r?r.toStringTag:void 0;t.exports=function(t){var e=i.call(t,s),n=t[s];try{t[s]=void 0;var r=!0}catch(t){}var o=u.call(t);return r&&(e?t[s]=n:delete t[s]),o}},function(t,e,n){"use strict";var r=Object.prototype.toString;t.exports=function(t){return r.call(t)}},function(t,e,n){"use strict";var r=n(80),o=function(){var t=/[^.]+$/.exec(r&&r.keys&&r.keys.IE_PROTO||"");return t?"Symbol(src)_1."+t:""}();t.exports=function(t){return!!o&&o in t}},function(t,e,n){"use strict";var r=n(0)["__core-js_shared__"];t.exports=r},function(t,e,n){"use strict";t.exports=function(t,e){return null==t?void 0:t[e]}},function(t,e,n){"use strict";var r=n(83),o=n(9),i=n(17);t.exports=function(){this.size=0,this.__data__={hash:new r,map:new(i||o),string:new r}}},function(t,e,n){"use strict";var r=n(84),o=n(85),i=n(86),u=n(87),s=n(88);function c(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}c.prototype.clear=r,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=u,c.prototype.set=s,t.exports=c},function(t,e,n){"use strict";var r=n(12);t.exports=function(){this.__data__=r?r(null):{},this.size=0}},function(t,e,n){"use strict";t.exports=function(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e}},function(t,e,n){"use strict";var r=n(12),o=Object.prototype.hasOwnProperty;t.exports=function(t){var e=this.__data__;if(r){var n=e[t];return"__lodash_hash_undefined__"===n?void 0:n}return o.call(e,t)?e[t]:void 0}},function(t,e,n){"use strict";var r=n(12),o=Object.prototype.hasOwnProperty;t.exports=function(t){var e=this.__data__;return r?void 0!==e[t]:o.call(e,t)}},function(t,e,n){"use strict";var r=n(12);t.exports=function(t,e){var n=this.__data__;return this.size+=this.has(t)?0:1,n[t]=r&&void 0===e?"__lodash_hash_undefined__":e,this}},function(t,e,n){"use strict";var r=n(13);t.exports=function(t){var e=r(this,t).delete(t);return this.size-=e?1:0,e}},function(t,e,n){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};t.exports=function(t){var e=void 0===t?"undefined":r(t);return"string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t}},function(t,e,n){"use strict";var r=n(13);t.exports=function(t){return r(this,t).get(t)}},function(t,e,n){"use strict";var r=n(13);t.exports=function(t){return r(this,t).has(t)}},function(t,e,n){"use strict";var r=n(13);t.exports=function(t,e){var n=r(this,t),o=n.size;return n.set(t,e),this.size+=n.size==o?0:1,this}},function(t,e,n){"use strict";var r=n(95)();t.exports=r},function(t,e,n){"use strict";t.exports=function(t){return function(e,n,r){for(var o=-1,i=Object(e),u=r(e),s=u.length;s--;){var c=u[t?s:++o];if(!1===n(i[c],c,i))break}return e}}},function(t,e,n){"use strict";var r=n(30),o=n(97),i=n(98),u=n(100),s=n(101),c=n(35),a=n(7),f=n(104),l=n(23),p=n(18),d=n(1),y=n(106),h=n(24),v=n(37),m=n(110);t.exports=function(t,e,n,b,g,_,x){var w=v(t,n),j=v(e,n),S=x.get(j);if(S)r(t,n,S);else{var O=_?_(w,j,n+"",t,e,x):void 0,C=void 0===O;if(C){var E=a(j),A=!E&&l(j),M=!E&&!A&&h(j);O=j,E||A||M?a(w)?O=w:f(w)?O=u(w):A?(C=!1,O=o(j,!0)):M?(C=!1,O=i(j,!0)):O=[]:y(j)||c(j)?(O=w,c(w)?O=m(w):d(w)&&!p(w)||(O=s(j))):C=!1}C&&(x.set(j,O),g(O,j,b,_,x),x.delete(j)),r(t,n,O)}}},function(t,e,n){"use strict";(function(t){var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=n(0),i="object"==r(e)&&e&&!e.nodeType&&e,u=i&&"object"==r(t)&&t&&!t.nodeType&&t,s=u&&u.exports===i?o.Buffer:void 0,c=s?s.allocUnsafe:void 0;t.exports=function(t,e){if(e)return t.slice();var n=t.length,r=c?c(n):new t.constructor(n);return t.copy(r),r}}).call(this,n(21)(t))},function(t,e,n){"use strict";var r=n(99);t.exports=function(t,e){var n=e?r(t.buffer):t.buffer;return new t.constructor(n,t.byteOffset,t.length)}},function(t,e,n){"use strict";var r=n(32);t.exports=function(t){var e=new t.constructor(t.byteLength);return new r(e).set(new r(t)),e}},function(t,e,n){"use strict";t.exports=function(t,e){var n=-1,r=t.length;for(e||(e=Array(r));++n<r;)e[n]=t[n];return e}},function(t,e,n){"use strict";var r=n(102),o=n(33),i=n(22);t.exports=function(t){return"function"!=typeof t.constructor||i(t)?{}:r(o(t))}},function(t,e,n){"use strict";var r=n(1),o=Object.create,i=function(){function t(){}return function(e){if(!r(e))return{};if(o)return o(e);t.prototype=e;var n=new t;return t.prototype=void 0,n}}();t.exports=i},function(t,e,n){"use strict";var r=n(5),o=n(3);t.exports=function(t){return o(t)&&"[object Arguments]"==r(t)}},function(t,e,n){"use strict";var r=n(14),o=n(3);t.exports=function(t){return o(t)&&r(t)}},function(t,e,n){"use strict";t.exports=function(){return!1}},function(t,e,n){"use strict";var r=n(5),o=n(33),i=n(3),u=Function.prototype,s=Object.prototype,c=u.toString,a=s.hasOwnProperty,f=c.call(Object);t.exports=function(t){if(!i(t)||"[object Object]"!=r(t))return!1;var e=o(t);if(null===e)return!0;var n=a.call(e,"constructor")&&e.constructor;return"function"==typeof n&&n instanceof n&&c.call(n)==f}},function(t,e,n){"use strict";var r=n(5),o=n(36),i=n(3),u={};u["[object Float32Array]"]=u["[object Float64Array]"]=u["[object Int8Array]"]=u["[object Int16Array]"]=u["[object Int32Array]"]=u["[object Uint8Array]"]=u["[object Uint8ClampedArray]"]=u["[object Uint16Array]"]=u["[object Uint32Array]"]=!0,u["[object Arguments]"]=u["[object Array]"]=u["[object ArrayBuffer]"]=u["[object Boolean]"]=u["[object DataView]"]=u["[object Date]"]=u["[object Error]"]=u["[object Function]"]=u["[object Map]"]=u["[object Number]"]=u["[object Object]"]=u["[object RegExp]"]=u["[object Set]"]=u["[object String]"]=u["[object WeakMap]"]=!1,t.exports=function(t){return i(t)&&o(t.length)&&!!u[r(t)]}},function(t,e,n){"use strict";t.exports=function(t){return function(e){return t(e)}}},function(t,e,n){"use strict";(function(t){var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=n(27),i="object"==r(e)&&e&&!e.nodeType&&e,u=i&&"object"==r(t)&&t&&!t.nodeType&&t,s=u&&u.exports===i&&o.process,c=function(){try{return u&&u.require&&u.require("util").types||s&&s.binding&&s.binding("util")}catch(t){}}();t.exports=c}).call(this,n(21)(t))},function(t,e,n){"use strict";var r=n(111),o=n(38);t.exports=function(t){return r(t,o(t))}},function(t,e,n){"use strict";var r=n(112),o=n(20);t.exports=function(t,e,n,i){var u=!n;n||(n={});for(var s=-1,c=e.length;++s<c;){var a=e[s],f=i?i(n[a],t[a],a,n,t):void 0;void 0===f&&(f=t[a]),u?o(n,a,f):r(n,a,f)}return n}},function(t,e,n){"use strict";var r=n(20),o=n(6),i=Object.prototype.hasOwnProperty;t.exports=function(t,e,n){var u=t[e];i.call(t,e)&&o(u,n)&&(void 0!==n||e in t)||r(t,e,n)}},function(t,e,n){"use strict";t.exports=function(t,e){for(var n=-1,r=Array(t);++n<t;)r[n]=e(n);return r}},function(t,e,n){"use strict";var r=n(1),o=n(22),i=n(115),u=Object.prototype.hasOwnProperty;t.exports=function(t){if(!r(t))return i(t);var e=o(t),n=[];for(var s in t)("constructor"!=s||!e&&u.call(t,s))&&n.push(s);return n}},function(t,e,n){"use strict";t.exports=function(t){var e=[];if(null!=t)for(var n in Object(t))e.push(n);return e}},function(t,e,n){"use strict";var r=n(117),o=n(124);t.exports=function(t){return r((function(e,n){var r=-1,i=n.length,u=i>1?n[i-1]:void 0,s=i>2?n[2]:void 0;for(u=t.length>3&&"function"==typeof u?(i--,u):void 0,s&&o(n[0],n[1],s)&&(u=i<3?void 0:u,i=1),e=Object(e);++r<i;){var c=n[r];c&&t(e,c,r,u)}return e}))}},function(t,e,n){"use strict";var r=n(41),o=n(118),i=n(120);t.exports=function(t,e){return i(o(t,e,r),t+"")}},function(t,e,n){"use strict";var r=n(119),o=Math.max;t.exports=function(t,e,n){return e=o(void 0===e?t.length-1:e,0),function(){for(var i=arguments,u=-1,s=o(i.length-e,0),c=Array(s);++u<s;)c[u]=i[e+u];u=-1;for(var a=Array(e+1);++u<e;)a[u]=i[u];return a[e]=n(c),r(t,this,a)}}},function(t,e,n){"use strict";t.exports=function(t,e,n){switch(n.length){case 0:return t.call(e);case 1:return t.call(e,n[0]);case 2:return t.call(e,n[0],n[1]);case 3:return t.call(e,n[0],n[1],n[2])}return t.apply(e,n)}},function(t,e,n){"use strict";var r=n(121),o=n(123)(r);t.exports=o},function(t,e,n){"use strict";var r=n(122),o=n(31),i=n(41),u=o?function(t,e){return o(t,"toString",{configurable:!0,enumerable:!1,value:r(e),writable:!0})}:i;t.exports=u},function(t,e,n){"use strict";t.exports=function(t){return function(){return t}}},function(t,e,n){"use strict";var r=Date.now;t.exports=function(t){var e=0,n=0;return function(){var o=r(),i=16-(o-n);if(n=o,i>0){if(++e>=800)return arguments[0]}else e=0;return t.apply(void 0,arguments)}}},function(t,e,n){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=n(6),i=n(14),u=n(40),s=n(1);t.exports=function(t,e,n){if(!s(n))return!1;var c=void 0===e?"undefined":r(e);return!!("number"==c?i(n)&&u(e,n.length):"string"==c&&e in n)&&o(n[e],t)}},function(t,e,n){"use strict";var r=n(126)((function(t,e,n){return t+(n?"-":"")+e.toLowerCase()}));t.exports=r},function(t,e,n){"use strict";var r=n(127),o=n(128),i=n(133),u=RegExp("['’]","g");t.exports=function(t){return function(e){return r(i(o(e).replace(u,"")),t,"")}}},function(t,e,n){"use strict";t.exports=function(t,e,n,r){var o=-1,i=null==t?0:t.length;for(r&&i&&(n=t[++o]);++o<i;)n=e(n,t[o],o,t);return n}},function(t,e,n){"use strict";var r=n(129),o=n(42),i=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,u=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g");t.exports=function(t){return(t=o(t))&&t.replace(i,r).replace(u,"")}},function(t,e,n){"use strict";var r=n(130)({"À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","Ç":"C","ç":"c","Ð":"D","ð":"d","È":"E","É":"E","Ê":"E","Ë":"E","è":"e","é":"e","ê":"e","ë":"e","Ì":"I","Í":"I","Î":"I","Ï":"I","ì":"i","í":"i","î":"i","ï":"i","Ñ":"N","ñ":"n","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","Ù":"U","Ú":"U","Û":"U","Ü":"U","ù":"u","ú":"u","û":"u","ü":"u","Ý":"Y","ý":"y","ÿ":"y","Æ":"Ae","æ":"ae","Þ":"Th","þ":"th","ß":"ss","Ā":"A","Ă":"A","Ą":"A","ā":"a","ă":"a","ą":"a","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","ć":"c","ĉ":"c","ċ":"c","č":"c","Ď":"D","Đ":"D","ď":"d","đ":"d","Ē":"E","Ĕ":"E","Ė":"E","Ę":"E","Ě":"E","ē":"e","ĕ":"e","ė":"e","ę":"e","ě":"e","Ĝ":"G","Ğ":"G","Ġ":"G","Ģ":"G","ĝ":"g","ğ":"g","ġ":"g","ģ":"g","Ĥ":"H","Ħ":"H","ĥ":"h","ħ":"h","Ĩ":"I","Ī":"I","Ĭ":"I","Į":"I","İ":"I","ĩ":"i","ī":"i","ĭ":"i","į":"i","ı":"i","Ĵ":"J","ĵ":"j","Ķ":"K","ķ":"k","ĸ":"k","Ĺ":"L","Ļ":"L","Ľ":"L","Ŀ":"L","Ł":"L","ĺ":"l","ļ":"l","ľ":"l","ŀ":"l","ł":"l","Ń":"N","Ņ":"N","Ň":"N","Ŋ":"N","ń":"n","ņ":"n","ň":"n","ŋ":"n","Ō":"O","Ŏ":"O","Ő":"O","ō":"o","ŏ":"o","ő":"o","Ŕ":"R","Ŗ":"R","Ř":"R","ŕ":"r","ŗ":"r","ř":"r","Ś":"S","Ŝ":"S","Ş":"S","Š":"S","ś":"s","ŝ":"s","ş":"s","š":"s","Ţ":"T","Ť":"T","Ŧ":"T","ţ":"t","ť":"t","ŧ":"t","Ũ":"U","Ū":"U","Ŭ":"U","Ů":"U","Ű":"U","Ų":"U","ũ":"u","ū":"u","ŭ":"u","ů":"u","ű":"u","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","Ż":"Z","Ž":"Z","ź":"z","ż":"z","ž":"z","Ĳ":"IJ","ĳ":"ij","Œ":"Oe","œ":"oe","ŉ":"'n","ſ":"s"});t.exports=r},function(t,e,n){"use strict";t.exports=function(t){return function(e){return null==t?void 0:t[e]}}},function(t,e,n){"use strict";var r=n(11),o=n(132),i=n(7),u=n(43),s=r?r.prototype:void 0,c=s?s.toString:void 0;t.exports=function t(e){if("string"==typeof e)return e;if(i(e))return o(e,t)+"";if(u(e))return c?c.call(e):"";var n=e+"";return"0"==n&&1/e==-1/0?"-0":n}},function(t,e,n){"use strict";t.exports=function(t,e){for(var n=-1,r=null==t?0:t.length,o=Array(r);++n<r;)o[n]=e(t[n],n,t);return o}},function(t,e,n){"use strict";var r=n(134),o=n(135),i=n(42),u=n(136);t.exports=function(t,e,n){return t=i(t),void 0===(e=n?void 0:e)?o(t)?u(t):r(t):t.match(e)||[]}},function(t,e,n){"use strict";var r=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;t.exports=function(t){return t.match(r)||[]}},function(t,e,n){"use strict";var r=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;t.exports=function(t){return r.test(t)}},function(t,e,n){"use strict";var r="\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",o="["+r+"]",i="\\d+",u="[a-z\\xdf-\\xf6\\xf8-\\xff]",s="[^\\ud800-\\udfff"+r+i+"\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",c="(?:\\ud83c[\\udde6-\\uddff]){2}",a="[\\ud800-\\udbff][\\udc00-\\udfff]",f="[A-Z\\xc0-\\xd6\\xd8-\\xde]",l="(?:"+u+"|"+s+")",p="(?:"+f+"|"+s+")",d="(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",y="[\\ufe0e\\ufe0f]?"+d+"(?:\\u200d(?:"+["[^\\ud800-\\udfff]",c,a].join("|")+")[\\ufe0e\\ufe0f]?"+d+")*",h="(?:"+["[\\u2700-\\u27bf]",c,a].join("|")+")"+y,v=RegExp([f+"?"+u+"+(?:['’](?:d|ll|m|re|s|t|ve))?(?="+[o,f,"$"].join("|")+")",p+"+(?:['’](?:D|LL|M|RE|S|T|VE))?(?="+[o,f+l,"$"].join("|")+")",f+"?"+l+"+(?:['’](?:d|ll|m|re|s|t|ve))?",f+"+(?:['’](?:D|LL|M|RE|S|T|VE))?","\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])","\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",i,h].join("|"),"g");t.exports=function(t){return t.match(v)||[]}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(t){return t&&t.__esModule?t:{default:t}}(n(138));e.default={name:"mwc-config-mixin",data:function(){return{options:{}}},created:function(){var t=this;Object.keys(this.settings).forEach((function(e){t.$options._propKeys.indexOf(e)>-1&&(t.$set(t.options,e,function(e){var n=void 0;if(void 0===t.settings[e])n=t[e];else{var o=t.defaultConfig&&t.defaultConfig.settings&&t.defaultConfig.settings[e];n=(0,r.default)(t.settings[e],o)&&void 0!==t.$options.propsData[e]?t[e]:t.settings[e]}return n}(e)),t.$watch(e,(function(t){this.options[e]=t})))}))}}},function(t,e,n){"use strict";var r=n(139);t.exports=function(t,e){return r(t,e)}},function(t,e,n){"use strict";var r=n(140),o=n(3);t.exports=function t(e,n,i,u,s){return e===n||(null==e||null==n||!o(e)&&!o(n)?e!=e&&n!=n:r(e,n,i,u,t,s))}},function(t,e,n){"use strict";var r=n(26),o=n(45),i=n(146),u=n(149),s=n(159),c=n(7),a=n(23),f=n(24),l="[object Arguments]",p="[object Array]",d="[object Object]",y=Object.prototype.hasOwnProperty;t.exports=function(t,e,n,h,v,m){var b=c(t),g=c(e),_=b?p:s(t),x=g?p:s(e),w=(_=_==l?d:_)==d,j=(x=x==l?d:x)==d,S=_==x;if(S&&a(t)){if(!a(e))return!1;b=!0,w=!1}if(S&&!w)return m||(m=new r),b||f(t)?o(t,e,n,h,v,m):i(t,e,_,n,h,v,m);if(!(1&n)){var O=w&&y.call(t,"__wrapped__"),C=j&&y.call(e,"__wrapped__");if(O||C){var E=O?t.value():t,A=C?e.value():e;return m||(m=new r),v(E,A,n,h,m)}}return!!S&&(m||(m=new r),u(t,e,n,h,v,m))}},function(t,e,n){"use strict";var r=n(29),o=n(142),i=n(143);function u(t){var e=-1,n=null==t?0:t.length;for(this.__data__=new r;++e<n;)this.add(t[e])}u.prototype.add=u.prototype.push=o,u.prototype.has=i,t.exports=u},function(t,e,n){"use strict";t.exports=function(t){return this.__data__.set(t,"__lodash_hash_undefined__"),this}},function(t,e,n){"use strict";t.exports=function(t){return this.__data__.has(t)}},function(t,e,n){"use strict";t.exports=function(t,e){for(var n=-1,r=null==t?0:t.length;++n<r;)if(e(t[n],n,t))return!0;return!1}},function(t,e,n){"use strict";t.exports=function(t,e){return t.has(e)}},function(t,e,n){"use strict";var r=n(11),o=n(32),i=n(6),u=n(45),s=n(147),c=n(148),a=r?r.prototype:void 0,f=a?a.valueOf:void 0;t.exports=function(t,e,n,r,a,l,p){switch(n){case"[object DataView]":if(t.byteLength!=e.byteLength||t.byteOffset!=e.byteOffset)return!1;t=t.buffer,e=e.buffer;case"[object ArrayBuffer]":return!(t.byteLength!=e.byteLength||!l(new o(t),new o(e)));case"[object Boolean]":case"[object Date]":case"[object Number]":return i(+t,+e);case"[object Error]":return t.name==e.name&&t.message==e.message;case"[object RegExp]":case"[object String]":return t==e+"";case"[object Map]":var d=s;case"[object Set]":var y=1&r;if(d||(d=c),t.size!=e.size&&!y)return!1;var h=p.get(t);if(h)return h==e;r|=2,p.set(t,e);var v=u(d(t),d(e),r,a,l,p);return p.delete(t),v;case"[object Symbol]":if(f)return f.call(t)==f.call(e)}return!1}},function(t,e,n){"use strict";t.exports=function(t){var e=-1,n=Array(t.size);return t.forEach((function(t,r){n[++e]=[r,t]})),n}},function(t,e,n){"use strict";t.exports=function(t){var e=-1,n=Array(t.size);return t.forEach((function(t){n[++e]=t})),n}},function(t,e,n){"use strict";var r=n(150),o=Object.prototype.hasOwnProperty;t.exports=function(t,e,n,i,u,s){var c=1&n,a=r(t),f=a.length;if(f!=r(e).length&&!c)return!1;for(var l=f;l--;){var p=a[l];if(!(c?p in e:o.call(e,p)))return!1}var d=s.get(t);if(d&&s.get(e))return d==e;var y=!0;s.set(t,e),s.set(e,t);for(var h=c;++l<f;){var v=t[p=a[l]],m=e[p];if(i)var b=c?i(m,v,p,e,t,s):i(v,m,p,t,e,s);if(!(void 0===b?v===m||u(v,m,n,i,s):b)){y=!1;break}h||(h="constructor"==p)}if(y&&!h){var g=t.constructor,_=e.constructor;g!=_&&"constructor"in t&&"constructor"in e&&!("function"==typeof g&&g instanceof g&&"function"==typeof _&&_ instanceof _)&&(y=!1)}return s.delete(t),s.delete(e),y}},function(t,e,n){"use strict";var r=n(151),o=n(153),i=n(156);t.exports=function(t){return r(t,i,o)}},function(t,e,n){"use strict";var r=n(152),o=n(7);t.exports=function(t,e,n){var i=e(t);return o(t)?i:r(i,n(t))}},function(t,e,n){"use strict";t.exports=function(t,e){for(var n=-1,r=e.length,o=t.length;++n<r;)t[o+n]=e[n];return t}},function(t,e,n){"use strict";var r=n(154),o=n(155),i=Object.prototype.propertyIsEnumerable,u=Object.getOwnPropertySymbols,s=u?function(t){return null==t?[]:(t=Object(t),r(u(t),(function(e){return i.call(t,e)})))}:o;t.exports=s},function(t,e,n){"use strict";t.exports=function(t,e){for(var n=-1,r=null==t?0:t.length,o=0,i=[];++n<r;){var u=t[n];e(u,n,t)&&(i[o++]=u)}return i}},function(t,e,n){"use strict";t.exports=function(){return[]}},function(t,e,n){"use strict";var r=n(39),o=n(157),i=n(14);t.exports=function(t){return i(t)?r(t):o(t)}},function(t,e,n){"use strict";var r=n(22),o=n(158),i=Object.prototype.hasOwnProperty;t.exports=function(t){if(!r(t))return o(t);var e=[];for(var n in Object(t))i.call(t,n)&&"constructor"!=n&&e.push(n);return e}},function(t,e,n){"use strict";var r=n(34)(Object.keys,Object);t.exports=r},function(t,e,n){"use strict";var r=n(160),o=n(17),i=n(161),u=n(162),s=n(163),c=n(5),a=n(28),f=a(r),l=a(o),p=a(i),d=a(u),y=a(s),h=c;(r&&"[object DataView]"!=h(new r(new ArrayBuffer(1)))||o&&"[object Map]"!=h(new o)||i&&"[object Promise]"!=h(i.resolve())||u&&"[object Set]"!=h(new u)||s&&"[object WeakMap]"!=h(new s))&&(h=function(t){var e=c(t),n="[object Object]"==e?t.constructor:void 0,r=n?a(n):"";if(r)switch(r){case f:return"[object DataView]";case l:return"[object Map]";case p:return"[object Promise]";case d:return"[object Set]";case y:return"[object WeakMap]"}return e}),t.exports=h},function(t,e,n){"use strict";var r=n(2)(n(0),"DataView");t.exports=r},function(t,e,n){"use strict";var r=n(2)(n(0),"Promise");t.exports=r},function(t,e,n){"use strict";var r=n(2)(n(0),"Set");t.exports=r},function(t,e,n){"use strict";var r=n(2)(n(0),"WeakMap");t.exports=r},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(t){return t&&t.__esModule?t:{default:t}}(n(165));e.default={name:"mwc-layout-mixin",created:function(){if(this.settings&&this.settings._layout){var t;t=this.settings._layout instanceof Array?JSON.parse(JSON.stringify(this.settings._layout.slice(0))):"string"==typeof this.settings._layout?this.settings._layout:Object.assign({},this.settings._layout),this.options=this.options||{},this.options._layout=t}},beforeMount:function(){this.layoutMixinHelper=new r.default(this.mwcId,this.$style)},mounted:function(){this.applyLayouts()},computed:{parsedLayout:function(){var t=[],e=this.options&&this.options._layout;return e&&((t="string"==typeof e?JSON.parse(e):e)instanceof Array||(t=this.layoutMixinHelper.convertLayout(t))),t}},methods:{applyGroups:function(t,e){var n=this;e.rows.forEach((function(r){r.groups&&(r.sections=[],r.groups.forEach((function(o){if(o.sections){var i=n.createGroup(t,o,e.exclusiveGroups);r.sections.push(i)}})))}))},applyLayouts:function(){var t=this;this.parsedLayout.forEach((function(e){t.applyLayout(e)}))},applyLayout:function(t){var e=this,n=this.layoutMixinHelper.getElement(this.$el,t.elementId);if(n&&t){n.style.setProperty("display","none");var r=function(){t=JSON.parse(JSON.stringify(t)),e.sortRows(t),e.defineRows(t),e.applyGroups(n,t),e.renderLayout(n,t),n.style.removeProperty("display")};!1===t.awaitNextTick?r():this.$nextTick((function(){r()}))}},createGroup:function(t,e,n){var r=e.title;r&&this.labeller.exists(r)&&(r=this.translate(r));var o=e.ariaLabel;o&&this.labeller.exists(o)&&(o=this.translate(o));var i=e.summary;return i&&this.labeller.exists(i)&&(i=this.translate(i)),this.layoutMixinHelper.createGroup({elem:t,group:e,accordionTitle:r,accordionAriaLabel:o,accordionSummary:i,exclusiveGroups:n||!1})},defineRows:function(t){var e=function(e){var n=void 0;if("string"==typeof e)n=t.rowDefinitions[e];else{n=e;var r=e.id;r&&t.rowDefinitions[r]&&(n=Object.assign({},t.rowDefinitions[r],e))}return n},n=[];t.rows.forEach((function(t){var r=e(t);r&&(n.push(r),r.sections&&r.sections.forEach((function(t){if(t.rows){var n=[];t.rows.forEach((function(t){var r=e(t);r&&n.push(r)})),t.rows=n}})))})),t.rows=n},renderLayout:function(t,e){var n=this,r={},o=function(t){Object.keys(t).forEach((function(e){var n=t[e];i(n.children)}))},i=function(t){Object.keys(t).forEach((function(e){var i=t[e];i.classList.contains("mds-layout-grid__row")||i.classList.contains(n.layoutMixinHelper.updateClassName("mds-layout-grid__row"))?o(i.children):function(t){var e=function(t){var e=t.getAttribute("mwc-id");return e?e.split(".").pop():t.getAttribute("id")}(t);e&&(r[e]=t)}(i)}))};for(!function(t){return 1===t.children.length&&(t.children[0].classList.contains("mds-layout-grid")||t.children[0].classList.contains(n.layoutMixinHelper.updateClassName("mds-layout-grid")))}(t)?i(t.children):function(t){Object.keys(t).forEach((function(e){var n=t[e];o(n.children)}))}(t.children[0].children);t.firstChild;)t.removeChild(t.firstChild);var u=this.layoutMixinHelper.createGrid(e,r);t.appendChild(u)},sortRows:function(t){var e=[];t.rows instanceof Array?e=t.rows:Object.keys(t.rows).forEach((function(n){t.rows.id=n,e.push(t.rows[n])})),e.sort((function(t,e){return(t.order||1)-(e.order||1)})),t.rows=e}}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),o=function(t){return t&&t.__esModule?t:{default:t}}(n(44)),i=function(){function t(e,n){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.mwcId=e,this.$style=n}return r(t,[{key:"convertLayout",value:function(t){var e=[];return Object.keys(t).forEach((function(n){e.push({elementId:n,rows:t[n].rows,rowDefinitions:t[n].rowDefinitions,awaitNextTick:t[n].awaitNextTick})})),e}},{key:"updateClassName",value:function(t){return this.$style&&this.$style[t]?this.$style[t]:t}},{key:"updateClassNames",value:function(t){var e=this;return this.$style?t.map((function(t){return e.$style[t]})).filter((function(t){return!!t})):t}},{key:"getElement",value:function(t,e){var n=t.querySelector("#"+e);if(!n){var r=o.default.getNamespaceId(this.mwcId,e);n=t.querySelector("#"+r)}return n}},{key:"getColumnClasses",value:function(e,n,r){var o=["mds-layout-grid__col"];return((n=n||{}).defaults||r.defaults)&&(e=Object.assign({},n.defaults,r.defaults,e)),e.cols&&o.push("mds-layout-grid__col--"+e.cols),e.zeroPadding&&(r.zeroMargin=!0,o.push("mds-layout-grid__col--zero-padding")),o=o.concat(t.getPullPushSqueezeClasses(e)),e.breakpoints&&Object.keys(e.breakpoints).forEach((function(n){var r=e.breakpoints[n];o=o.concat(t.getPullPushSqueezeClasses(r,n)),r.cols&&("auto"===r.cols?o.push("mds-layout-grid__col--auto-at-"+n):o.push("mds-layout-grid__col--"+r.cols+"-at-"+n))})),e.classList&&(o=o.concat(e.classList)),o=this.updateClassNames(o)}},{key:"createGroup",value:function(e){var n=this,r=e.elem,o=e.group,i=e.accordionTitle,u=e.accordionAriaLabel,s=e.accordionSummary,c=e.exclusiveGroups,a=(this.mwcId+"-"+o.id).replace(/\./g,"-"),f="mds-accordion-"+a,l=this.createAccordion({accordionId:f,groupId:o.id,uniqueId:a,title:i,ariaLabel:u,summary:s}),p=l.querySelector("#label-header-"+a);if(o.expanded&&(p.checked=!0,p.setAttribute("aria-expanded","true")),l.addEventListener("click",(function(t){var e=!1;"INPUT"===t.target.tagName&&("false"===p.getAttribute("aria-expanded")?(p.setAttribute("aria-expanded","true"),e=!0):p.setAttribute("aria-expanded","false")),c&&e&&r.querySelectorAll(".mds-accordion").forEach((function(t){if(t.id!==l.id){var e=t.querySelector("input");e&&(e.checked=!1,e.setAttribute("aria-expanded","false"))}}))})),o.sections){var d=l.querySelector("#mds-accordion-group-"+a),y=t.needsGridLayout(o),h=void 0;y&&(h=this.createAccordionGridRow(d)),o.sections.forEach((function(e){e=t.convertSection(e);var i=n.getElement(r,e.id);if(i)if(y){var u=n.getColumnClasses(e,null,o),s=document.createElement("div");s.className=u.join(" "),s.appendChild(i),h.appendChild(s)}else d.appendChild(i)}))}return r.appendChild(l),f}},{key:"createGrid",value:function(e,n){var r=this,i=[],u=function(e,n){var o=["mds-layout-grid__row"];return e.zeroMargin&&o.push("mds-layout-grid__row--zero-margin"),o=o.concat(t.getAlignmentClasses(e)),e.classList&&(o=o.concat(e.classList)),o=r.updateClassNames(o),t.createElement(o,n)};return e.rows.forEach((function(s){var c=function i(s){var c=[];return s.sections&&s.sections.forEach((function(a){a=t.convertSection(a);var f=r.getColumnClasses(a,e,s),l=[];if(a.rows)a.rows.forEach((function(t){var e=i(t),n=u(t,e);l.push(n)}));else{var p=n[a.id];if(!p){var d=o.default.getNamespaceId(r.mwcId,a.id);p=n[d]}p&&(l=[p])}var y=t.createElement(f,l);c.push(y)})),c}(s);c.length>0&&i.push(u(s,c))})),t.createElement([this.updateClassName("mds-layout-grid")],i)}},{key:"createAccordion",value:function(t){var e=t.accordionId,n=t.groupId,r=t.uniqueId,o=t.title,i=t.ariaLabel,u=t.summary,s="";u&&(s='<p class="'+this.updateClassName("mds-accordion__summary")+'">'+u+"</p>");var c="";i&&(c=' aria-label="'+i+'"');var a=document.createElement("div");a.setAttribute("id",e);var f=this.updateClassName("mds-accordion__trigger"),l=this.updateClassNames(["mds-header","mds-header--secondary","mds-header--level-7"]);return a.classList.add(this.updateClassName("mds-accordion"),this.updateClassName("mds-accordion--"+n)),a.innerHTML='<input id="label-header-'+r+'" type="checkbox" role="button" aria-expanded="false" aria-controls="mds-accordion-group-'+r+'" class="'+f+'" />\n        <label for="label-header-'+r+'" class="'+this.updateClassName("mds-accordion__label")+'">\n            <div class="'+l.join(" ")+'">\n                <h2 class="'+this.updateClassName("mds-header__title")+'"'+c+">\n                    "+o+'\n                </h2>\n            </div>\n        </label>\n        <section class="'+this.updateClassName("mds-accordion__content")+'" id="mds-accordion-group-'+r+'">\n            '+s+"\n        </section>",a}},{key:"createAccordionGridRow",value:function(t){var e=document.createElement("div");e.className=this.updateClassName("mds-layout-grid");var n=document.createElement("div");return n.className=this.updateClassName("mds-layout-grid__row"),e.appendChild(n),t.appendChild(e),n}}],[{key:"createElement",value:function(t,e){var n=document.createElement("div");return n.className=t.join(" "),Object.keys(e).forEach((function(t){var r=e[t];n.appendChild(r)})),n}},{key:"getAlignmentClasses",value:function(t){var e=[];switch(t.horizontalAlign){case"start":e.push("mds-layout-grid__row--justify-content-flex-start");break;case"center":e.push("mds-layout-grid__row--justify-content-center");break;case"end":e.push("mds-layout-grid__row--justify-content-flex-end");break;case"around":e.push("mds-layout-grid__row--justify-content-space-around");break;case"between":e.push("mds-layout-grid__row--justify-content-space-between")}switch(t.verticalAlign){case"top":e.push("mds-layout-grid__row--align-items-flex-start");break;case"center":e.push("mds-layout-grid__row--align-items-center");break;case"bottom":e.push("mds-layout-grid__row--align-items-flex-end")}return e}},{key:"getPullPushSqueezeClasses",value:function(t,e){var n=[];return e=e?"-at-"+e:"",t.pull&&n.push("mds-layout-grid__col--pull-"+t.pull+e),t.push&&n.push("mds-layout-grid__col--push-"+t.push+e),t.squeeze&&n.push("mds-layout-grid__col--squeeze-"+t.squeeze+e),n}},{key:"convertSection",value:function(t){return"string"==typeof t&&(t={id:t}),t}},{key:"needsGridLayout",value:function(t){var e=!1;return!!t.defaults||(t.sections.forEach((function(t){"string"!=typeof t&&(e=!0)})),e)}}]),t}();e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.BREAKPOINTS=void 0;var r=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t};e.findBreakpoint=f;var o=c(n(167)),i=c(n(170)),u=c(n(171)),s=c(n(195));function c(t){return t&&t.__esModule?t:{default:t}}var a=e.BREAKPOINTS=[{name:"xsmall",value:320},{name:"small",value:600},{name:"medium",value:768},{name:"large",value:1e3},{name:"xlarge",value:1200}];function f(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.innerWidth,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:a,n=(0,s.default)(e,(function(e){return t<=e.value}));return n=n>=0?n:e.length-1,r({index:n},e[n])}var l={wait:100,options:{leading:!1,maxing:!1,trailing:!0}};e.default={data:function(){return{elementWidth:0}},created:function(){this.elementBreakpoints=this.elementBreakpoints||a,this.elementDebounceConfig=Object.assign({},this.elementDebounceConfig||{},l)},mounted:function(){var t=this;this.elementWidth=this.$el.clientWidth,this.$_mwc_debouncedOnResize=(0,o.default)(this.$_mwc_onResize,this.elementDebounceConfig.wait,this.elementDebounceConfig.options),this.$_mwc_ro=new i.default((function(e){var n=(0,u.default)(e,(function(e){return e.target===t.$el})),r=window.getComputedStyle(t.$el),o=r.paddingLeft,i=r.paddingRight,s=n.contentRect.width;s&&t.$_mwc_debouncedOnResize(s+parseFloat(o)+parseFloat(i))})),this.$_mwc_ro.observe(this.$el)},beforeDestroy:function(){this.$_mwc_ro.unobserve(this.$el),this.$_mwc_ro.disconnect()},computed:{breakpoint:function(){var t=f(this.elementWidth,this.elementBreakpoints);return t?t.name:this.elementBreakpoints.slice(-1)[0].name},breakpointClass:function(){return"xsmall"===this.breakpoint?"":(this.namespace||this.$options.name)+"--"+this.breakpoint}},methods:{$_mwc_onResize:function(t){this.elementWidth=t||this.$el.clientWidth}}}},function(t,e,n){"use strict";var r=n(1),o=n(168),i=n(169),u=Math.max,s=Math.min;t.exports=function(t,e,n){var c,a,f,l,p,d,y=0,h=!1,v=!1,m=!0;if("function"!=typeof t)throw new TypeError("Expected a function");function b(e){var n=c,r=a;return c=a=void 0,y=e,l=t.apply(r,n)}function g(t){var n=t-d;return void 0===d||n>=e||n<0||v&&t-y>=f}function _(){var t=o();if(g(t))return x(t);p=setTimeout(_,function(t){var n=e-(t-d);return v?s(n,f-(t-y)):n}(t))}function x(t){return p=void 0,m&&c?b(t):(c=a=void 0,l)}function w(){var t=o(),n=g(t);if(c=arguments,a=this,d=t,n){if(void 0===p)return function(t){return y=t,p=setTimeout(_,e),h?b(t):l}(d);if(v)return clearTimeout(p),p=setTimeout(_,e),b(d)}return void 0===p&&(p=setTimeout(_,e)),l}return e=i(e)||0,r(n)&&(h=!!n.leading,f=(v="maxWait"in n)?u(i(n.maxWait)||0,e):f,m="trailing"in n?!!n.trailing:m),w.cancel=function(){void 0!==p&&clearTimeout(p),y=0,c=d=a=p=void 0},w.flush=function(){return void 0===p?l:x(o())},w}},function(t,e,n){"use strict";var r=n(0);t.exports=function(){return r.Date.now()}},function(t,e,n){"use strict";var r=n(1),o=n(43),i=/^\s+|\s+$/g,u=/^[-+]0x[0-9a-f]+$/i,s=/^0b[01]+$/i,c=/^0o[0-7]+$/i,a=parseInt;t.exports=function(t){if("number"==typeof t)return t;if(o(t))return NaN;if(r(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=r(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(i,"");var n=s.test(t);return n||c.test(t)?a(t.slice(2),n?2:8):u.test(t)?NaN:+t}},function(t,e,n){"use strict";(function(r){var o,i,u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};!function(r,s){"object"===u(e)&&void 0!==t?t.exports=s():void 0===(i="function"==typeof(o=s)?o.call(e,n,e,t):o)||(t.exports=i)}(0,(function(){var t=function(){if("undefined"!=typeof Map)return Map;function t(t,e){var n=-1;return t.some((function(t,r){return t[0]===e&&(n=r,!0)})),n}return function(){function e(){this.__entries__=[]}return Object.defineProperty(e.prototype,"size",{get:function(){return this.__entries__.length},enumerable:!0,configurable:!0}),e.prototype.get=function(e){var n=t(this.__entries__,e),r=this.__entries__[n];return r&&r[1]},e.prototype.set=function(e,n){var r=t(this.__entries__,e);~r?this.__entries__[r][1]=n:this.__entries__.push([e,n])},e.prototype.delete=function(e){var n=this.__entries__,r=t(n,e);~r&&n.splice(r,1)},e.prototype.has=function(e){return!!~t(this.__entries__,e)},e.prototype.clear=function(){this.__entries__.splice(0)},e.prototype.forEach=function(t,e){void 0===e&&(e=null);for(var n=0,r=this.__entries__;n<r.length;n++){var o=r[n];t.call(e,o[1],o[0])}},e}()}(),e="undefined"!=typeof window&&"undefined"!=typeof document&&window.document===document,n=void 0!==r&&r.Math===Math?r:"undefined"!=typeof self&&self.Math===Math?self:"undefined"!=typeof window&&window.Math===Math?window:Function("return this")(),o="function"==typeof requestAnimationFrame?requestAnimationFrame.bind(n):function(t){return setTimeout((function(){return t(Date.now())}),1e3/60)},i=["top","right","bottom","left","width","height","size","weight"],u="undefined"!=typeof MutationObserver,s=function(){function t(){this.connected_=!1,this.mutationEventsAdded_=!1,this.mutationsObserver_=null,this.observers_=[],this.onTransitionEnd_=this.onTransitionEnd_.bind(this),this.refresh=function(t,e){var n=!1,r=!1,i=0;function u(){n&&(n=!1,t()),r&&c()}function s(){o(u)}function c(){var t=Date.now();if(n){if(t-i<2)return;r=!0}else n=!0,r=!1,setTimeout(s,20);i=t}return c}(this.refresh.bind(this))}return t.prototype.addObserver=function(t){~this.observers_.indexOf(t)||this.observers_.push(t),this.connected_||this.connect_()},t.prototype.removeObserver=function(t){var e=this.observers_,n=e.indexOf(t);~n&&e.splice(n,1),!e.length&&this.connected_&&this.disconnect_()},t.prototype.refresh=function(){this.updateObservers_()&&this.refresh()},t.prototype.updateObservers_=function(){var t=this.observers_.filter((function(t){return t.gatherActive(),t.hasActive()}));return t.forEach((function(t){return t.broadcastActive()})),t.length>0},t.prototype.connect_=function(){e&&!this.connected_&&(document.addEventListener("transitionend",this.onTransitionEnd_),window.addEventListener("resize",this.refresh),u?(this.mutationsObserver_=new MutationObserver(this.refresh),this.mutationsObserver_.observe(document,{attributes:!0,childList:!0,characterData:!0,subtree:!0})):(document.addEventListener("DOMSubtreeModified",this.refresh),this.mutationEventsAdded_=!0),this.connected_=!0)},t.prototype.disconnect_=function(){e&&this.connected_&&(document.removeEventListener("transitionend",this.onTransitionEnd_),window.removeEventListener("resize",this.refresh),this.mutationsObserver_&&this.mutationsObserver_.disconnect(),this.mutationEventsAdded_&&document.removeEventListener("DOMSubtreeModified",this.refresh),this.mutationsObserver_=null,this.mutationEventsAdded_=!1,this.connected_=!1)},t.prototype.onTransitionEnd_=function(t){var e=t.propertyName,n=void 0===e?"":e;i.some((function(t){return!!~n.indexOf(t)}))&&this.refresh()},t.getInstance=function(){return this.instance_||(this.instance_=new t),this.instance_},t.instance_=null,t}(),c=function(t,e){for(var n=0,r=Object.keys(e);n<r.length;n++){var o=r[n];Object.defineProperty(t,o,{value:e[o],enumerable:!1,writable:!1,configurable:!0})}return t},a=function(t){return t&&t.ownerDocument&&t.ownerDocument.defaultView||n},f=h(0,0,0,0);function l(t){return parseFloat(t)||0}function p(t){for(var e=[],n=1;n<arguments.length;n++)e[n-1]=arguments[n];return e.reduce((function(e,n){return e+l(t["border-"+n+"-width"])}),0)}var d="undefined"!=typeof SVGGraphicsElement?function(t){return t instanceof a(t).SVGGraphicsElement}:function(t){return t instanceof a(t).SVGElement&&"function"==typeof t.getBBox};function y(t){return e?d(t)?function(t){var e=t.getBBox();return h(0,0,e.width,e.height)}(t):function(t){var e=t.clientWidth,n=t.clientHeight;if(!e&&!n)return f;var r=a(t).getComputedStyle(t),o=function(t){for(var e={},n=0,r=["top","right","bottom","left"];n<r.length;n++){var o=r[n],i=t["padding-"+o];e[o]=l(i)}return e}(r),i=o.left+o.right,u=o.top+o.bottom,s=l(r.width),c=l(r.height);if("border-box"===r.boxSizing&&(Math.round(s+i)!==e&&(s-=p(r,"left","right")+i),Math.round(c+u)!==n&&(c-=p(r,"top","bottom")+u)),!function(t){return t===a(t).document.documentElement}(t)){var d=Math.round(s+i)-e,y=Math.round(c+u)-n;1!==Math.abs(d)&&(s-=d),1!==Math.abs(y)&&(c-=y)}return h(o.left,o.top,s,c)}(t):f}function h(t,e,n,r){return{x:t,y:e,width:n,height:r}}var v=function(){function t(t){this.broadcastWidth=0,this.broadcastHeight=0,this.contentRect_=h(0,0,0,0),this.target=t}return t.prototype.isActive=function(){var t=y(this.target);return this.contentRect_=t,t.width!==this.broadcastWidth||t.height!==this.broadcastHeight},t.prototype.broadcastRect=function(){var t=this.contentRect_;return this.broadcastWidth=t.width,this.broadcastHeight=t.height,t},t}(),m=function(t,e){var n=function(t){var e=t.x,n=t.y,r=t.width,o=t.height,i="undefined"!=typeof DOMRectReadOnly?DOMRectReadOnly:Object,u=Object.create(i.prototype);return c(u,{x:e,y:n,width:r,height:o,top:n,right:e+r,bottom:o+n,left:e}),u}(e);c(this,{target:t,contentRect:n})},b=function(){function e(e,n,r){if(this.activeObservations_=[],this.observations_=new t,"function"!=typeof e)throw new TypeError("The callback provided as parameter 1 is not a function.");this.callback_=e,this.controller_=n,this.callbackCtx_=r}return e.prototype.observe=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof a(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)||(e.set(t,new v(t)),this.controller_.addObserver(this),this.controller_.refresh())}},e.prototype.unobserve=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof a(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)&&(e.delete(t),e.size||this.controller_.removeObserver(this))}},e.prototype.disconnect=function(){this.clearActive(),this.observations_.clear(),this.controller_.removeObserver(this)},e.prototype.gatherActive=function(){var t=this;this.clearActive(),this.observations_.forEach((function(e){e.isActive()&&t.activeObservations_.push(e)}))},e.prototype.broadcastActive=function(){if(this.hasActive()){var t=this.callbackCtx_,e=this.activeObservations_.map((function(t){return new m(t.target,t.broadcastRect())}));this.callback_.call(t,e,t),this.clearActive()}},e.prototype.clearActive=function(){this.activeObservations_.splice(0)},e.prototype.hasActive=function(){return this.activeObservations_.length>0},e}(),g="undefined"!=typeof WeakMap?new WeakMap:new t,_=function t(e){if(!(this instanceof t))throw new TypeError("Cannot call a class as a function.");if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");var n=s.getInstance(),r=new b(e,n,this);g.set(this,r)};return["observe","unobserve","disconnect"].forEach((function(t){_.prototype[t]=function(){var e;return(e=g.get(this))[t].apply(e,arguments)}})),void 0!==n.ResizeObserver?n.ResizeObserver:_}))}).call(this,n(19))},function(t,e,n){"use strict";var r=n(172);t.exports=r},function(t,e,n){"use strict";n(173);var r=n(61);t.exports=r("Array","find")},function(t,e,n){"use strict";var r=n(46),o=n(57).find,i=n(60),u=!0;"find"in[]&&Array(1).find((function(){u=!1})),r({target:"Array",proto:!0,forced:u},{find:function(t){return o(this,t,arguments.length>1?arguments[1]:void 0)}}),i("find")},function(t,e,n){"use strict";var r=n(15),o=n(175),i=n(47),u=n(176),s=n(51),c=n(25),a=n(53),f=Object.getOwnPropertyDescriptor;e.f=r?f:function(t,e){if(t=u(t),e=s(e,!0),a)try{return f(t,e)}catch(t){}if(c(t,e))return i(!o.f.call(t,e),t[e])}},function(t,e,n){"use strict";var r={}.propertyIsEnumerable,o=Object.getOwnPropertyDescriptor,i=o&&!r.call({1:2},1);e.f=i?function(t){var e=o(this,t);return!!e&&e.enumerable}:r},function(t,e,n){"use strict";var r=n(48),o=n(50);t.exports=function(t){return r(o(t))}},function(t,e,n){"use strict";var r=n(4),o=n(16),i=r.document,u=o(i)&&o(i.createElement);t.exports=function(t){return u?i.createElement(t):{}}},function(t,e,n){"use strict";var r=n(8),o=/#|\.prototype\./,i=function(t,e){var n=s[u(t)];return n==a||n!=c&&("function"==typeof e?r(e):!!e)},u=i.normalize=function(t){return String(t).replace(o,".").toLowerCase()},s=i.data={},c=i.NATIVE="N",a=i.POLYFILL="P";t.exports=i},function(t,e,n){"use strict";t.exports=function(t){if("function"!=typeof t)throw TypeError(String(t)+" is not a function");return t}},function(t,e,n){"use strict";var r=n(15),o=n(53),i=n(181),u=n(51),s=Object.defineProperty;e.f=r?s:function(t,e,n){if(i(t),e=u(e,!0),i(n),o)try{return s(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){"use strict";var r=n(16);t.exports=function(t){if(!r(t))throw TypeError(String(t)+" is not an object");return t}},function(t,e,n){"use strict";var r=n(183),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e,n){"use strict";var r=Math.ceil,o=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?o:r)(t)}},function(t,e,n){"use strict";var r=n(16),o=n(185),i=n(186)("species");t.exports=function(t,e){var n;return o(t)&&("function"!=typeof(n=t.constructor)||n!==Array&&!o(n.prototype)?r(n)&&null===(n=n[i])&&(n=void 0):n=void 0),new(void 0===n?Array:n)(0===e?0:e)}},function(t,e,n){"use strict";var r=n(49);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){"use strict";var r=n(4),o=n(187),i=n(25),u=n(191),s=n(58),c=n(194),a=o("wks"),f=r.Symbol,l=c?f:f&&f.withoutSetter||u;t.exports=function(t){return i(a,t)&&(s||"string"==typeof a[t])||(s&&i(f,t)?a[t]=f[t]:a[t]=l("Symbol."+t)),a[t]}},function(t,e,n){"use strict";var r=n(188),o=n(189);(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.12.1",mode:r?"pure":"global",copyright:"© 2021 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){"use strict";t.exports=!0},function(t,e,n){"use strict";var r=n(4),o=n(190),i=r["__core-js_shared__"]||o("__core-js_shared__",{});t.exports=i},function(t,e,n){"use strict";var r=n(4),o=n(56);t.exports=function(t,e){try{o(r,t,e)}catch(n){r[t]=e}return e}},function(t,e,n){"use strict";var r=0,o=Math.random();t.exports=function(t){return"Symbol("+String(void 0===t?"":t)+")_"+(++r+o).toString(36)}},function(t,e,n){"use strict";var r,o,i=n(4),u=n(193),s=i.process,c=s&&s.versions,a=c&&c.v8;a?o=(r=a.split("."))[0]<4?1:r[0]+r[1]:u&&(!(r=u.match(/Edge\/(\d+)/))||r[1]>=74)&&(r=u.match(/Chrome\/(\d+)/))&&(o=r[1]),t.exports=o&&+o},function(t,e,n){"use strict";var r=n(59);t.exports=r("navigator","userAgent")||""},function(t,e,n){"use strict";var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},o=n(58);t.exports=o&&!Symbol.sham&&"symbol"==r(Symbol.iterator)},function(t,e,n){"use strict";var r=n(196);t.exports=r},function(t,e,n){"use strict";n(197);var r=n(61);t.exports=r("Array","findIndex")},function(t,e,n){"use strict";var r=n(46),o=n(57).findIndex,i=n(60),u=!0;"findIndex"in[]&&Array(1).findIndex((function(){u=!1})),r({target:"Array",proto:!0,forced:u},{findIndex:function(t){return o(this,t,arguments.length>1?arguments[1]:void 0)}}),i("findIndex")}])}));
//# sourceMappingURL=main.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
  var d3 = {
    version: "3.5.17"
  };
  var d3_arraySlice = [].slice, d3_array = function(list) {
    return d3_arraySlice.call(list);
  };
  var d3_document = this.document;
  function d3_documentElement(node) {
    return node && (node.ownerDocument || node.document || node).documentElement;
  }
  function d3_window(node) {
    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
  }
  if (d3_document) {
    try {
      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
    } catch (e) {
      d3_array = function(list) {
        var i = list.length, array = new Array(i);
        while (i--) array[i] = list[i];
        return array;
      };
    }
  }
  if (!Date.now) Date.now = function() {
    return +new Date();
  };
  if (d3_document) {
    try {
      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
    } catch (error) {
      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
      d3_element_prototype.setAttribute = function(name, value) {
        d3_element_setAttribute.call(this, name, value + "");
      };
      d3_element_prototype.setAttributeNS = function(space, local, value) {
        d3_element_setAttributeNS.call(this, space, local, value + "");
      };
      d3_style_prototype.setProperty = function(name, value, priority) {
        d3_style_setProperty.call(this, name, value + "", priority);
      };
    }
  }
  d3.ascending = d3_ascending;
  function d3_ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }
  d3.descending = function(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
  };
  d3.min = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
    }
    return a;
  };
  d3.max = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
    }
    return a;
  };
  d3.extent = function(array, f) {
    var i = -1, n = array.length, a, b, c;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    }
    return [ a, c ];
  };
  function d3_number(x) {
    return x === null ? NaN : +x;
  }
  function d3_numeric(x) {
    return !isNaN(x);
  }
  d3.sum = function(array, f) {
    var s = 0, n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
    } else {
      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
    }
    return s;
  };
  d3.mean = function(array, f) {
    var s = 0, n = array.length, a, i = -1, j = n;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
    }
    if (j) return s / j;
  };
  d3.quantile = function(values, p) {
    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
    return e ? v + e * (values[h] - v) : v;
  };
  d3.median = function(array, f) {
    var numbers = [], n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
    }
    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
  };
  d3.variance = function(array, f) {
    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
    if (arguments.length === 1) {
      while (++i < n) {
        if (d3_numeric(a = d3_number(array[i]))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    } else {
      while (++i < n) {
        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    }
    if (j > 1) return s / (j - 1);
  };
  d3.deviation = function() {
    var v = d3.variance.apply(this, arguments);
    return v ? Math.sqrt(v) : v;
  };
  function d3_bisector(compare) {
    return {
      left: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
        }
        return lo;
      },
      right: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
        }
        return lo;
      }
    };
  }
  var d3_bisect = d3_bisector(d3_ascending);
  d3.bisectLeft = d3_bisect.left;
  d3.bisect = d3.bisectRight = d3_bisect.right;
  d3.bisector = function(f) {
    return d3_bisector(f.length === 1 ? function(d, x) {
      return d3_ascending(f(d), x);
    } : f);
  };
  d3.shuffle = function(array, i0, i1) {
    if ((m = arguments.length) < 3) {
      i1 = array.length;
      if (m < 2) i0 = 0;
    }
    var m = i1 - i0, t, i;
    while (m) {
      i = Math.random() * m-- | 0;
      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
    }
    return array;
  };
  d3.permute = function(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while (i--) permutes[i] = array[indexes[i]];
    return permutes;
  };
  d3.pairs = function(array) {
    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
    return pairs;
  };
  d3.transpose = function(matrix) {
    if (!(n = matrix.length)) return [];
    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
        row[j] = matrix[j][i];
      }
    }
    return transpose;
  };
  function d3_transposeLength(d) {
    return d.length;
  }
  d3.zip = function() {
    return d3.transpose(arguments);
  };
  d3.keys = function(map) {
    var keys = [];
    for (var key in map) keys.push(key);
    return keys;
  };
  d3.values = function(map) {
    var values = [];
    for (var key in map) values.push(map[key]);
    return values;
  };
  d3.entries = function(map) {
    var entries = [];
    for (var key in map) entries.push({
      key: key,
      value: map[key]
    });
    return entries;
  };
  d3.merge = function(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while (++i < n) j += arrays[i].length;
    merged = new Array(j);
    while (--n >= 0) {
      array = arrays[n];
      m = array.length;
      while (--m >= 0) {
        merged[--j] = array[m];
      }
    }
    return merged;
  };
  var abs = Math.abs;
  d3.range = function(start, stop, step) {
    if (arguments.length < 3) {
      step = 1;
      if (arguments.length < 2) {
        stop = start;
        start = 0;
      }
    }
    if ((stop - start) / step === Infinity) throw new Error("infinite range");
    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
    start *= k, stop *= k, step *= k;
    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
    return range;
  };
  function d3_range_integerScale(x) {
    var k = 1;
    while (x * k % 1) k *= 10;
    return k;
  }
  function d3_class(ctor, properties) {
    for (var key in properties) {
      Object.defineProperty(ctor.prototype, key, {
        value: properties[key],
        enumerable: false
      });
    }
  }
  d3.map = function(object, f) {
    var map = new d3_Map();
    if (object instanceof d3_Map) {
      object.forEach(function(key, value) {
        map.set(key, value);
      });
    } else if (Array.isArray(object)) {
      var i = -1, n = object.length, o;
      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
    } else {
      for (var key in object) map.set(key, object[key]);
    }
    return map;
  };
  function d3_Map() {
    this._ = Object.create(null);
  }
  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
  d3_class(d3_Map, {
    has: d3_map_has,
    get: function(key) {
      return this._[d3_map_escape(key)];
    },
    set: function(key, value) {
      return this._[d3_map_escape(key)] = value;
    },
    remove: d3_map_remove,
    keys: d3_map_keys,
    values: function() {
      var values = [];
      for (var key in this._) values.push(this._[key]);
      return values;
    },
    entries: function() {
      var entries = [];
      for (var key in this._) entries.push({
        key: d3_map_unescape(key),
        value: this._[key]
      });
      return entries;
    },
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
    }
  });
  function d3_map_escape(key) {
    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
  }
  function d3_map_unescape(key) {
    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
  }
  function d3_map_has(key) {
    return d3_map_escape(key) in this._;
  }
  function d3_map_remove(key) {
    return (key = d3_map_escape(key)) in this._ && delete this._[key];
  }
  function d3_map_keys() {
    var keys = [];
    for (var key in this._) keys.push(d3_map_unescape(key));
    return keys;
  }
  function d3_map_size() {
    var size = 0;
    for (var key in this._) ++size;
    return size;
  }
  function d3_map_empty() {
    for (var key in this._) return false;
    return true;
  }
  d3.nest = function() {
    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
    function map(mapType, array, depth) {
      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
      while (++i < n) {
        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
          values.push(object);
        } else {
          valuesByKey.set(keyValue, [ object ]);
        }
      }
      if (mapType) {
        object = mapType();
        setter = function(keyValue, values) {
          object.set(keyValue, map(mapType, values, depth));
        };
      } else {
        object = {};
        setter = function(keyValue, values) {
          object[keyValue] = map(mapType, values, depth);
        };
      }
      valuesByKey.forEach(setter);
      return object;
    }
    function entries(map, depth) {
      if (depth >= keys.length) return map;
      var array = [], sortKey = sortKeys[depth++];
      map.forEach(function(key, keyMap) {
        array.push({
          key: key,
          values: entries(keyMap, depth)
        });
      });
      return sortKey ? array.sort(function(a, b) {
        return sortKey(a.key, b.key);
      }) : array;
    }
    nest.map = function(array, mapType) {
      return map(mapType, array, 0);
    };
    nest.entries = function(array) {
      return entries(map(d3.map, array, 0), 0);
    };
    nest.key = function(d) {
      keys.push(d);
      return nest;
    };
    nest.sortKeys = function(order) {
      sortKeys[keys.length - 1] = order;
      return nest;
    };
    nest.sortValues = function(order) {
      sortValues = order;
      return nest;
    };
    nest.rollup = function(f) {
      rollup = f;
      return nest;
    };
    return nest;
  };
  d3.set = function(array) {
    var set = new d3_Set();
    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
    return set;
  };
  function d3_Set() {
    this._ = Object.create(null);
  }
  d3_class(d3_Set, {
    has: d3_map_has,
    add: function(key) {
      this._[d3_map_escape(key += "")] = true;
      return key;
    },
    remove: d3_map_remove,
    values: d3_map_keys,
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key));
    }
  });
  d3.behavior = {};
  function d3_identity(d) {
    return d;
  }
  d3.rebind = function(target, source) {
    var i = 1, n = arguments.length, method;
    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
    return target;
  };
  function d3_rebind(target, source, method) {
    return function() {
      var value = method.apply(source, arguments);
      return value === source ? target : value;
    };
  }
  function d3_vendorSymbol(object, name) {
    if (name in object) return name;
    name = name.charAt(0).toUpperCase() + name.slice(1);
    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
      var prefixName = d3_vendorPrefixes[i] + name;
      if (prefixName in object) return prefixName;
    }
  }
  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
  function d3_noop() {}
  d3.dispatch = function() {
    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    return dispatch;
  };
  function d3_dispatch() {}
  d3_dispatch.prototype.on = function(type, listener) {
    var i = type.indexOf("."), name = "";
    if (i >= 0) {
      name = type.slice(i + 1);
      type = type.slice(0, i);
    }
    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
    if (arguments.length === 2) {
      if (listener == null) for (type in this) {
        if (this.hasOwnProperty(type)) this[type].on(name, null);
      }
      return this;
    }
  };
  function d3_dispatch_event(dispatch) {
    var listeners = [], listenerByName = new d3_Map();
    function event() {
      var z = listeners, i = -1, n = z.length, l;
      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
      return dispatch;
    }
    event.on = function(name, listener) {
      var l = listenerByName.get(name), i;
      if (arguments.length < 2) return l && l.on;
      if (l) {
        l.on = null;
        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
        listenerByName.remove(name);
      }
      if (listener) listeners.push(listenerByName.set(name, {
        on: listener
      }));
      return dispatch;
    };
    return event;
  }
  d3.event = null;
  function d3_eventPreventDefault() {
    d3.event.preventDefault();
  }
  function d3_eventSource() {
    var e = d3.event, s;
    while (s = e.sourceEvent) e = s;
    return e;
  }
  function d3_eventDispatch(target) {
    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    dispatch.of = function(thiz, argumentz) {
      return function(e1) {
        try {
          var e0 = e1.sourceEvent = d3.event;
          e1.target = target;
          d3.event = e1;
          dispatch[e1.type].apply(thiz, argumentz);
        } finally {
          d3.event = e0;
        }
      };
    };
    return dispatch;
  }
  d3.requote = function(s) {
    return s.replace(d3_requote_re, "\\$&");
  };
  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
  var d3_subclass = {}.__proto__ ? function(object, prototype) {
    object.__proto__ = prototype;
  } : function(object, prototype) {
    for (var property in prototype) object[property] = prototype[property];
  };
  function d3_selection(groups) {
    d3_subclass(groups, d3_selectionPrototype);
    return groups;
  }
  var d3_select = function(s, n) {
    return n.querySelector(s);
  }, d3_selectAll = function(s, n) {
    return n.querySelectorAll(s);
  }, d3_selectMatches = function(n, s) {
    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
    d3_selectMatches = function(n, s) {
      return d3_selectMatcher.call(n, s);
    };
    return d3_selectMatches(n, s);
  };
  if (typeof Sizzle === "function") {
    d3_select = function(s, n) {
      return Sizzle(s, n)[0] || null;
    };
    d3_selectAll = Sizzle;
    d3_selectMatches = Sizzle.matchesSelector;
  }
  d3.selection = function() {
    return d3.select(d3_document.documentElement);
  };
  var d3_selectionPrototype = d3.selection.prototype = [];
  d3_selectionPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, group, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selector(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_select(selector, this);
    };
  }
  d3_selectionPrototype.selectAll = function(selector) {
    var subgroups = [], subgroup, node;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
          subgroup.parentNode = node;
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selectorAll(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_selectAll(selector, this);
    };
  }
  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
  var d3_nsPrefix = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: d3_nsXhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
  };
  d3.ns = {
    prefix: d3_nsPrefix,
    qualify: function(name) {
      var i = name.indexOf(":"), prefix = name;
      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
      return d3_nsPrefix.hasOwnProperty(prefix) ? {
        space: d3_nsPrefix[prefix],
        local: name
      } : name;
    }
  };
  d3_selectionPrototype.attr = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node();
        name = d3.ns.qualify(name);
        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
      }
      for (value in name) this.each(d3_selection_attr(value, name[value]));
      return this;
    }
    return this.each(d3_selection_attr(name, value));
  };
  function d3_selection_attr(name, value) {
    name = d3.ns.qualify(name);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrConstant() {
      this.setAttribute(name, value);
    }
    function attrConstantNS() {
      this.setAttributeNS(name.space, name.local, value);
    }
    function attrFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
    }
    function attrFunctionNS() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
    }
    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
  }
  function d3_collapse(s) {
    return s.trim().replace(/\s+/g, " ");
  }
  d3_selectionPrototype.classed = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
        if (value = node.classList) {
          while (++i < n) if (!value.contains(name[i])) return false;
        } else {
          value = node.getAttribute("class");
          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
        }
        return true;
      }
      for (value in name) this.each(d3_selection_classed(value, name[value]));
      return this;
    }
    return this.each(d3_selection_classed(name, value));
  };
  function d3_selection_classedRe(name) {
    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
  }
  function d3_selection_classes(name) {
    return (name + "").trim().split(/^|\s+/);
  }
  function d3_selection_classed(name, value) {
    name = d3_selection_classes(name).map(d3_selection_classedName);
    var n = name.length;
    function classedConstant() {
      var i = -1;
      while (++i < n) name[i](this, value);
    }
    function classedFunction() {
      var i = -1, x = value.apply(this, arguments);
      while (++i < n) name[i](this, x);
    }
    return typeof value === "function" ? classedFunction : classedConstant;
  }
  function d3_selection_classedName(name) {
    var re = d3_selection_classedRe(name);
    return function(node, value) {
      if (c = node.classList) return value ? c.add(name) : c.remove(name);
      var c = node.getAttribute("class") || "";
      if (value) {
        re.lastIndex = 0;
        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
      } else {
        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
      }
    };
  }
  d3_selectionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
        return this;
      }
      if (n < 2) {
        var node = this.node();
        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
      }
      priority = "";
    }
    return this.each(d3_selection_style(name, value, priority));
  };
  function d3_selection_style(name, value, priority) {
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleConstant() {
      this.style.setProperty(name, value, priority);
    }
    function styleFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
    }
    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
  }
  d3_selectionPrototype.property = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") return this.node()[name];
      for (value in name) this.each(d3_selection_property(value, name[value]));
      return this;
    }
    return this.each(d3_selection_property(name, value));
  };
  function d3_selection_property(name, value) {
    function propertyNull() {
      delete this[name];
    }
    function propertyConstant() {
      this[name] = value;
    }
    function propertyFunction() {
      var x = value.apply(this, arguments);
      if (x == null) delete this[name]; else this[name] = x;
    }
    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
  }
  d3_selectionPrototype.text = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.textContent = v == null ? "" : v;
    } : value == null ? function() {
      this.textContent = "";
    } : function() {
      this.textContent = value;
    }) : this.node().textContent;
  };
  d3_selectionPrototype.html = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.innerHTML = v == null ? "" : v;
    } : value == null ? function() {
      this.innerHTML = "";
    } : function() {
      this.innerHTML = value;
    }) : this.node().innerHTML;
  };
  d3_selectionPrototype.append = function(name) {
    name = d3_selection_creator(name);
    return this.select(function() {
      return this.appendChild(name.apply(this, arguments));
    });
  };
  function d3_selection_creator(name) {
    function create() {
      var document = this.ownerDocument, namespace = this.namespaceURI;
      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
    }
    function createNS() {
      return this.ownerDocument.createElementNS(name.space, name.local);
    }
    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
  }
  d3_selectionPrototype.insert = function(name, before) {
    name = d3_selection_creator(name);
    before = d3_selection_selector(before);
    return this.select(function() {
      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
    });
  };
  d3_selectionPrototype.remove = function() {
    return this.each(d3_selectionRemove);
  };
  function d3_selectionRemove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
  }
  d3_selectionPrototype.data = function(value, key) {
    var i = -1, n = this.length, group, node;
    if (!arguments.length) {
      value = new Array(n = (group = this[0]).length);
      while (++i < n) {
        if (node = group[i]) {
          value[i] = node.__data__;
        }
      }
      return value;
    }
    function bind(group, groupData) {
      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
      if (key) {
        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
        for (i = -1; ++i < n; ) {
          if (node = group[i]) {
            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
              exitNodes[i] = node;
            } else {
              nodeByKeyValue.set(keyValue, node);
            }
            keyValues[i] = keyValue;
          }
        }
        for (i = -1; ++i < m; ) {
          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          } else if (node !== true) {
            updateNodes[i] = node;
            node.__data__ = nodeData;
          }
          nodeByKeyValue.set(keyValue, true);
        }
        for (i = -1; ++i < n; ) {
          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
            exitNodes[i] = group[i];
          }
        }
      } else {
        for (i = -1; ++i < n0; ) {
          node = group[i];
          nodeData = groupData[i];
          if (node) {
            node.__data__ = nodeData;
            updateNodes[i] = node;
          } else {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          }
        }
        for (;i < m; ++i) {
          enterNodes[i] = d3_selection_dataNode(groupData[i]);
        }
        for (;i < n; ++i) {
          exitNodes[i] = group[i];
        }
      }
      enterNodes.update = updateNodes;
      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
      enter.push(enterNodes);
      update.push(updateNodes);
      exit.push(exitNodes);
    }
    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
    if (typeof value === "function") {
      while (++i < n) {
        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
      }
    } else {
      while (++i < n) {
        bind(group = this[i], value);
      }
    }
    update.enter = function() {
      return enter;
    };
    update.exit = function() {
      return exit;
    };
    return update;
  };
  function d3_selection_dataNode(data) {
    return {
      __data__: data
    };
  }
  d3_selectionPrototype.datum = function(value) {
    return arguments.length ? this.property("__data__", value) : this.property("__data__");
  };
  d3_selectionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_filter(selector) {
    return function() {
      return d3_selectMatches(this, selector);
    };
  }
  d3_selectionPrototype.order = function() {
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
        if (node = group[i]) {
          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
          next = node;
        }
      }
    }
    return this;
  };
  d3_selectionPrototype.sort = function(comparator) {
    comparator = d3_selection_sortComparator.apply(this, arguments);
    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
    return this.order();
  };
  function d3_selection_sortComparator(comparator) {
    if (!arguments.length) comparator = d3_ascending;
    return function(a, b) {
      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
    };
  }
  d3_selectionPrototype.each = function(callback) {
    return d3_selection_each(this, function(node, i, j) {
      callback.call(node, node.__data__, i, j);
    });
  };
  function d3_selection_each(groups, callback) {
    for (var j = 0, m = groups.length; j < m; j++) {
      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
        if (node = group[i]) callback(node, i, j);
      }
    }
    return groups;
  }
  d3_selectionPrototype.call = function(callback) {
    var args = d3_array(arguments);
    callback.apply(args[0] = this, args);
    return this;
  };
  d3_selectionPrototype.empty = function() {
    return !this.node();
  };
  d3_selectionPrototype.node = function() {
    for (var j = 0, m = this.length; j < m; j++) {
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        var node = group[i];
        if (node) return node;
      }
    }
    return null;
  };
  d3_selectionPrototype.size = function() {
    var n = 0;
    d3_selection_each(this, function() {
      ++n;
    });
    return n;
  };
  function d3_selection_enter(selection) {
    d3_subclass(selection, d3_selection_enterPrototype);
    return selection;
  }
  var d3_selection_enterPrototype = [];
  d3.selection.enter = d3_selection_enter;
  d3.selection.enter.prototype = d3_selection_enterPrototype;
  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
  d3_selection_enterPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, upgroup, group, node;
    for (var j = -1, m = this.length; ++j < m; ) {
      upgroup = (group = this[j]).update;
      subgroups.push(subgroup = []);
      subgroup.parentNode = group.parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
          subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  d3_selection_enterPrototype.insert = function(name, before) {
    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
    return d3_selectionPrototype.insert.call(this, name, before);
  };
  function d3_selection_enterInsertBefore(enter) {
    var i0, j0;
    return function(d, i, j) {
      var group = enter[j].update, n = group.length, node;
      if (j != j0) j0 = j, i0 = 0;
      if (i >= i0) i0 = i + 1;
      while (!(node = group[i0]) && ++i0 < n) ;
      return node;
    };
  }
  d3.select = function(node) {
    var group;
    if (typeof node === "string") {
      group = [ d3_select(node, d3_document) ];
      group.parentNode = d3_document.documentElement;
    } else {
      group = [ node ];
      group.parentNode = d3_documentElement(node);
    }
    return d3_selection([ group ]);
  };
  d3.selectAll = function(nodes) {
    var group;
    if (typeof nodes === "string") {
      group = d3_array(d3_selectAll(nodes, d3_document));
      group.parentNode = d3_document.documentElement;
    } else {
      group = d3_array(nodes);
      group.parentNode = null;
    }
    return d3_selection([ group ]);
  };
  d3_selectionPrototype.on = function(type, listener, capture) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof type !== "string") {
        if (n < 2) listener = false;
        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
        return this;
      }
      if (n < 2) return (n = this.node()["__on" + type]) && n._;
      capture = false;
    }
    return this.each(d3_selection_on(type, listener, capture));
  };
  function d3_selection_on(type, listener, capture) {
    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
    if (i > 0) type = type.slice(0, i);
    var filter = d3_selection_onFilters.get(type);
    if (filter) type = filter, wrap = d3_selection_onFilter;
    function onRemove() {
      var l = this[name];
      if (l) {
        this.removeEventListener(type, l, l.$);
        delete this[name];
      }
    }
    function onAdd() {
      var l = wrap(listener, d3_array(arguments));
      onRemove.call(this);
      this.addEventListener(type, this[name] = l, l.$ = capture);
      l._ = listener;
    }
    function removeAll() {
      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
      for (var name in this) {
        if (match = name.match(re)) {
          var l = this[name];
          this.removeEventListener(match[1], l, l.$);
          delete this[name];
        }
      }
    }
    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
  }
  var d3_selection_onFilters = d3.map({
    mouseenter: "mouseover",
    mouseleave: "mouseout"
  });
  if (d3_document) {
    d3_selection_onFilters.forEach(function(k) {
      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
    });
  }
  function d3_selection_onListener(listener, argumentz) {
    return function(e) {
      var o = d3.event;
      d3.event = e;
      argumentz[0] = this.__data__;
      try {
        listener.apply(this, argumentz);
      } finally {
        d3.event = o;
      }
    };
  }
  function d3_selection_onFilter(listener, argumentz) {
    var l = d3_selection_onListener(listener, argumentz);
    return function(e) {
      var target = this, related = e.relatedTarget;
      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
        l.call(target, e);
      }
    };
  }
  var d3_event_dragSelect, d3_event_dragId = 0;
  function d3_event_dragSuppress(node) {
    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
    if (d3_event_dragSelect == null) {
      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
    }
    if (d3_event_dragSelect) {
      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
      style[d3_event_dragSelect] = "none";
    }
    return function(suppressClick) {
      w.on(name, null);
      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
      if (suppressClick) {
        var off = function() {
          w.on(click, null);
        };
        w.on(click, function() {
          d3_eventPreventDefault();
          off();
        }, true);
        setTimeout(off, 0);
      }
    };
  }
  d3.mouse = function(container) {
    return d3_mousePoint(container, d3_eventSource());
  };
  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
  function d3_mousePoint(container, e) {
    if (e.changedTouches) e = e.changedTouches[0];
    var svg = container.ownerSVGElement || container;
    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      if (d3_mouse_bug44083 < 0) {
        var window = d3_window(container);
        if (window.scrollX || window.scrollY) {
          svg = d3.select("body").append("svg").style({
            position: "absolute",
            top: 0,
            left: 0,
            margin: 0,
            padding: 0,
            border: "none"
          }, "important");
          var ctm = svg[0][0].getScreenCTM();
          d3_mouse_bug44083 = !(ctm.f || ctm.e);
          svg.remove();
        }
      }
      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
      point.y = e.clientY;
      point = point.matrixTransform(container.getScreenCTM().inverse());
      return [ point.x, point.y ];
    }
    var rect = container.getBoundingClientRect();
    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
  }
  d3.touch = function(container, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
      if ((touch = touches[i]).identifier === identifier) {
        return d3_mousePoint(container, touch);
      }
    }
  };
  d3.behavior.drag = function() {
    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
    function drag() {
      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
    }
    function dragstart(id, position, subject, move, end) {
      return function() {
        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
        if (origin) {
          dragOffset = origin.apply(that, arguments);
          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
        } else {
          dragOffset = [ 0, 0 ];
        }
        dispatch({
          type: "dragstart"
        });
        function moved() {
          var position1 = position(parent, dragId), dx, dy;
          if (!position1) return;
          dx = position1[0] - position0[0];
          dy = position1[1] - position0[1];
          dragged |= dx | dy;
          position0 = position1;
          dispatch({
            type: "drag",
            x: position1[0] + dragOffset[0],
            y: position1[1] + dragOffset[1],
            dx: dx,
            dy: dy
          });
        }
        function ended() {
          if (!position(parent, dragId)) return;
          dragSubject.on(move + dragName, null).on(end + dragName, null);
          dragRestore(dragged);
          dispatch({
            type: "dragend"
          });
        }
      };
    }
    drag.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return drag;
    };
    return d3.rebind(drag, event, "on");
  };
  function d3_behavior_dragTouchId() {
    return d3.event.changedTouches[0].identifier;
  }
  d3.touches = function(container, touches) {
    if (arguments.length < 2) touches = d3_eventSource().touches;
    return touches ? d3_array(touches).map(function(touch) {
      var point = d3_mousePoint(container, touch);
      point.identifier = touch.identifier;
      return point;
    }) : [];
  };
  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
  function d3_sgn(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
  }
  function d3_cross2d(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
  }
  function d3_acos(x) {
    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
  }
  function d3_asin(x) {
    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
  }
  function d3_sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
  }
  function d3_cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
  }
  function d3_tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
  }
  function d3_haversin(x) {
    return (x = Math.sin(x / 2)) * x;
  }
  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
  d3.interpolateZoom = function(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    if (d2 < ε2) {
      S = Math.log(w1 / w0) / ρ;
      i = function(t) {
        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
      };
    } else {
      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / ρ;
      i = function(t) {
        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
      };
    }
    i.duration = S * 1e3;
    return i;
  };
  d3.behavior.zoom = function() {
    var view = {
      x: 0,
      y: 0,
      k: 1
    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
    if (!d3_behavior_zoomWheel) {
      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return d3.event.wheelDelta;
      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
        return -d3.event.detail;
      }, "MozMousePixelScroll");
    }
    function zoom(g) {
      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
    }
    zoom.event = function(g) {
      g.each(function() {
        var dispatch = event.of(this, arguments), view1 = view;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.zoom", function() {
            view = this.__chart__ || {
              x: 0,
              y: 0,
              k: 1
            };
            zoomstarted(dispatch);
          }).tween("zoom:zoom", function() {
            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
            return function(t) {
              var l = i(t), k = dx / l[2];
              this.__chart__ = view = {
                x: cx - l[0] * k,
                y: cy - l[1] * k,
                k: k
              };
              zoomed(dispatch);
            };
          }).each("interrupt.zoom", function() {
            zoomended(dispatch);
          }).each("end.zoom", function() {
            zoomended(dispatch);
          });
        } else {
          this.__chart__ = view;
          zoomstarted(dispatch);
          zoomed(dispatch);
          zoomended(dispatch);
        }
      });
    };
    zoom.translate = function(_) {
      if (!arguments.length) return [ view.x, view.y ];
      view = {
        x: +_[0],
        y: +_[1],
        k: view.k
      };
      rescale();
      return zoom;
    };
    zoom.scale = function(_) {
      if (!arguments.length) return view.k;
      view = {
        x: view.x,
        y: view.y,
        k: null
      };
      scaleTo(+_);
      rescale();
      return zoom;
    };
    zoom.scaleExtent = function(_) {
      if (!arguments.length) return scaleExtent;
      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.center = function(_) {
      if (!arguments.length) return center;
      center = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.size = function(_) {
      if (!arguments.length) return size;
      size = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.duration = function(_) {
      if (!arguments.length) return duration;
      duration = +_;
      return zoom;
    };
    zoom.x = function(z) {
      if (!arguments.length) return x1;
      x1 = z;
      x0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    zoom.y = function(z) {
      if (!arguments.length) return y1;
      y1 = z;
      y0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    function location(p) {
      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
    }
    function point(l) {
      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
    }
    function scaleTo(s) {
      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
    }
    function translateTo(p, l) {
      l = point(l);
      view.x += p[0] - l[0];
      view.y += p[1] - l[1];
    }
    function zoomTo(that, p, l, k) {
      that.__chart__ = {
        x: view.x,
        y: view.y,
        k: view.k
      };
      scaleTo(Math.pow(2, k));
      translateTo(center0 = p, l);
      that = d3.select(that);
      if (duration > 0) that = that.transition().duration(duration);
      that.call(zoom.event);
    }
    function rescale() {
      if (x1) x1.domain(x0.range().map(function(x) {
        return (x - view.x) / view.k;
      }).map(x0.invert));
      if (y1) y1.domain(y0.range().map(function(y) {
        return (y - view.y) / view.k;
      }).map(y0.invert));
    }
    function zoomstarted(dispatch) {
      if (!zooming++) dispatch({
        type: "zoomstart"
      });
    }
    function zoomed(dispatch) {
      rescale();
      dispatch({
        type: "zoom",
        scale: view.k,
        translate: [ view.x, view.y ]
      });
    }
    function zoomended(dispatch) {
      if (!--zooming) dispatch({
        type: "zoomend"
      }), center0 = null;
    }
    function mousedowned() {
      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
      d3_selection_interrupt.call(that);
      zoomstarted(dispatch);
      function moved() {
        dragged = 1;
        translateTo(d3.mouse(that), location0);
        zoomed(dispatch);
      }
      function ended() {
        subject.on(mousemove, null).on(mouseup, null);
        dragRestore(dragged);
        zoomended(dispatch);
      }
    }
    function touchstarted() {
      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
      started();
      zoomstarted(dispatch);
      subject.on(mousedown, null).on(touchstart, started);
      function relocate() {
        var touches = d3.touches(that);
        scale0 = view.k;
        touches.forEach(function(t) {
          if (t.identifier in locations0) locations0[t.identifier] = location(t);
        });
        return touches;
      }
      function started() {
        var target = d3.event.target;
        d3.select(target).on(touchmove, moved).on(touchend, ended);
        targets.push(target);
        var changed = d3.event.changedTouches;
        for (var i = 0, n = changed.length; i < n; ++i) {
          locations0[changed[i].identifier] = null;
        }
        var touches = relocate(), now = Date.now();
        if (touches.length === 1) {
          if (now - touchtime < 500) {
            var p = touches[0];
            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
            d3_eventPreventDefault();
          }
          touchtime = now;
        } else if (touches.length > 1) {
          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
          distance0 = dx * dx + dy * dy;
        }
      }
      function moved() {
        var touches = d3.touches(that), p0, l0, p1, l1;
        d3_selection_interrupt.call(that);
        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
          p1 = touches[i];
          if (l1 = locations0[p1.identifier]) {
            if (l0) break;
            p0 = p1, l0 = l1;
          }
        }
        if (l1) {
          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
          scaleTo(scale1 * scale0);
        }
        touchtime = null;
        translateTo(p0, l0);
        zoomed(dispatch);
      }
      function ended() {
        if (d3.event.touches.length) {
          var changed = d3.event.changedTouches;
          for (var i = 0, n = changed.length; i < n; ++i) {
            delete locations0[changed[i].identifier];
          }
          for (var identifier in locations0) {
            return void relocate();
          }
        }
        d3.selectAll(targets).on(zoomName, null);
        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
        dragRestore();
        zoomended(dispatch);
      }
    }
    function mousewheeled() {
      var dispatch = event.of(this, arguments);
      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
      mousewheelTimer = setTimeout(function() {
        mousewheelTimer = null;
        zoomended(dispatch);
      }, 50);
      d3_eventPreventDefault();
      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
      translateTo(center0, translate0);
      zoomed(dispatch);
    }
    function dblclicked() {
      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
    }
    return d3.rebind(zoom, event, "on");
  };
  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
  d3.color = d3_color;
  function d3_color() {}
  d3_color.prototype.toString = function() {
    return this.rgb() + "";
  };
  d3.hsl = d3_hsl;
  function d3_hsl(h, s, l) {
    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
  }
  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
  d3_hslPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, this.l / k);
  };
  d3_hslPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, k * this.l);
  };
  d3_hslPrototype.rgb = function() {
    return d3_hsl_rgb(this.h, this.s, this.l);
  };
  function d3_hsl_rgb(h, s, l) {
    var m1, m2;
    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
    l = l < 0 ? 0 : l > 1 ? 1 : l;
    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
    m1 = 2 * l - m2;
    function v(h) {
      if (h > 360) h -= 360; else if (h < 0) h += 360;
      if (h < 60) return m1 + (m2 - m1) * h / 60;
      if (h < 180) return m2;
      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
      return m1;
    }
    function vv(h) {
      return Math.round(v(h) * 255);
    }
    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
  }
  d3.hcl = d3_hcl;
  function d3_hcl(h, c, l) {
    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
  }
  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
  d3_hclPrototype.brighter = function(k) {
    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.darker = function(k) {
    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.rgb = function() {
    return d3_hcl_lab(this.h, this.c, this.l).rgb();
  };
  function d3_hcl_lab(h, c, l) {
    if (isNaN(h)) h = 0;
    if (isNaN(c)) c = 0;
    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
  }
  d3.lab = d3_lab;
  function d3_lab(l, a, b) {
    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
  }
  var d3_lab_K = 18;
  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
  var d3_labPrototype = d3_lab.prototype = new d3_color();
  d3_labPrototype.brighter = function(k) {
    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.darker = function(k) {
    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.rgb = function() {
    return d3_lab_rgb(this.l, this.a, this.b);
  };
  function d3_lab_rgb(l, a, b) {
    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
    x = d3_lab_xyz(x) * d3_lab_X;
    y = d3_lab_xyz(y) * d3_lab_Y;
    z = d3_lab_xyz(z) * d3_lab_Z;
    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
  }
  function d3_lab_hcl(l, a, b) {
    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
  }
  function d3_lab_xyz(x) {
    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
  }
  function d3_xyz_lab(x) {
    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
  }
  function d3_xyz_rgb(r) {
    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
  }
  d3.rgb = d3_rgb;
  function d3_rgb(r, g, b) {
    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
  }
  function d3_rgbNumber(value) {
    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
  }
  function d3_rgbString(value) {
    return d3_rgbNumber(value) + "";
  }
  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
  d3_rgbPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    var r = this.r, g = this.g, b = this.b, i = 30;
    if (!r && !g && !b) return new d3_rgb(i, i, i);
    if (r && r < i) r = i;
    if (g && g < i) g = i;
    if (b && b < i) b = i;
    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
  };
  d3_rgbPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_rgb(k * this.r, k * this.g, k * this.b);
  };
  d3_rgbPrototype.hsl = function() {
    return d3_rgb_hsl(this.r, this.g, this.b);
  };
  d3_rgbPrototype.toString = function() {
    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
  };
  function d3_rgb_hex(v) {
    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
  }
  function d3_rgb_parse(format, rgb, hsl) {
    var r = 0, g = 0, b = 0, m1, m2, color;
    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
    if (m1) {
      m2 = m1[2].split(",");
      switch (m1[1]) {
       case "hsl":
        {
          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
        }

       case "rgb":
        {
          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
        }
      }
    }
    if (color = d3_rgb_names.get(format)) {
      return rgb(color.r, color.g, color.b);
    }
    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
      if (format.length === 4) {
        r = (color & 3840) >> 4;
        r = r >> 4 | r;
        g = color & 240;
        g = g >> 4 | g;
        b = color & 15;
        b = b << 4 | b;
      } else if (format.length === 7) {
        r = (color & 16711680) >> 16;
        g = (color & 65280) >> 8;
        b = color & 255;
      }
    }
    return rgb(r, g, b);
  }
  function d3_rgb_hsl(r, g, b) {
    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
    if (d) {
      s = l < .5 ? d / (max + min) : d / (2 - max - min);
      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
      h *= 60;
    } else {
      h = NaN;
      s = l > 0 && l < 1 ? 0 : h;
    }
    return new d3_hsl(h, s, l);
  }
  function d3_rgb_lab(r, g, b) {
    r = d3_rgb_xyz(r);
    g = d3_rgb_xyz(g);
    b = d3_rgb_xyz(b);
    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
  }
  function d3_rgb_xyz(r) {
    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
  }
  function d3_rgb_parseNumber(c) {
    var f = parseFloat(c);
    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
  }
  var d3_rgb_names = d3.map({
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  });
  d3_rgb_names.forEach(function(key, value) {
    d3_rgb_names.set(key, d3_rgbNumber(value));
  });
  function d3_functor(v) {
    return typeof v === "function" ? v : function() {
      return v;
    };
  }
  d3.functor = d3_functor;
  d3.xhr = d3_xhrType(d3_identity);
  function d3_xhrType(response) {
    return function(url, mimeType, callback) {
      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
      mimeType = null;
      return d3_xhr(url, mimeType, response, callback);
    };
  }
  function d3_xhr(url, mimeType, response, callback) {
    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
      request.readyState > 3 && respond();
    };
    function respond() {
      var status = request.status, result;
      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
        try {
          result = response.call(xhr, request);
        } catch (e) {
          dispatch.error.call(xhr, e);
          return;
        }
        dispatch.load.call(xhr, result);
      } else {
        dispatch.error.call(xhr, request);
      }
    }
    request.onprogress = function(event) {
      var o = d3.event;
      d3.event = event;
      try {
        dispatch.progress.call(xhr, request);
      } finally {
        d3.event = o;
      }
    };
    xhr.header = function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers[name];
      if (value == null) delete headers[name]; else headers[name] = value + "";
      return xhr;
    };
    xhr.mimeType = function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return xhr;
    };
    xhr.responseType = function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return xhr;
    };
    xhr.response = function(value) {
      response = value;
      return xhr;
    };
    [ "get", "post" ].forEach(function(method) {
      xhr[method] = function() {
        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
      };
    });
    xhr.send = function(method, data, callback) {
      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
      request.open(method, url, true);
      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
      if (responseType != null) request.responseType = responseType;
      if (callback != null) xhr.on("error", callback).on("load", function(request) {
        callback(null, request);
      });
      dispatch.beforesend.call(xhr, request);
      request.send(data == null ? null : data);
      return xhr;
    };
    xhr.abort = function() {
      request.abort();
      return xhr;
    };
    d3.rebind(xhr, dispatch, "on");
    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
  }
  function d3_xhr_fixCallback(callback) {
    return callback.length === 1 ? function(error, request) {
      callback(error == null ? request : null);
    } : callback;
  }
  function d3_xhrHasResponse(request) {
    var type = request.responseType;
    return type && type !== "text" ? request.response : request.responseText;
  }
  d3.dsv = function(delimiter, mimeType) {
    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
    function dsv(url, row, callback) {
      if (arguments.length < 3) callback = row, row = null;
      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
      xhr.row = function(_) {
        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
      };
      return xhr;
    }
    function response(request) {
      return dsv.parse(request.responseText);
    }
    function typedResponse(f) {
      return function(request) {
        return dsv.parse(request.responseText, f);
      };
    }
    dsv.parse = function(text, f) {
      var o;
      return dsv.parseRows(text, function(row, i) {
        if (o) return o(row, i - 1);
        var a = new Function("d", "return {" + row.map(function(name, i) {
          return JSON.stringify(name) + ": d[" + i + "]";
        }).join(",") + "}");
        o = f ? function(row, i) {
          return f(a(row), i);
        } : a;
      });
    };
    dsv.parseRows = function(text, f) {
      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
      function token() {
        if (I >= N) return EOF;
        if (eol) return eol = false, EOL;
        var j = I;
        if (text.charCodeAt(j) === 34) {
          var i = j;
          while (i++ < N) {
            if (text.charCodeAt(i) === 34) {
              if (text.charCodeAt(i + 1) !== 34) break;
              ++i;
            }
          }
          I = i + 2;
          var c = text.charCodeAt(i + 1);
          if (c === 13) {
            eol = true;
            if (text.charCodeAt(i + 2) === 10) ++I;
          } else if (c === 10) {
            eol = true;
          }
          return text.slice(j + 1, i).replace(/""/g, '"');
        }
        while (I < N) {
          var c = text.charCodeAt(I++), k = 1;
          if (c === 10) eol = true; else if (c === 13) {
            eol = true;
            if (text.charCodeAt(I) === 10) ++I, ++k;
          } else if (c !== delimiterCode) continue;
          return text.slice(j, I - k);
        }
        return text.slice(j);
      }
      while ((t = token()) !== EOF) {
        var a = [];
        while (t !== EOL && t !== EOF) {
          a.push(t);
          t = token();
        }
        if (f && (a = f(a, n++)) == null) continue;
        rows.push(a);
      }
      return rows;
    };
    dsv.format = function(rows) {
      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
      var fieldSet = new d3_Set(), fields = [];
      rows.forEach(function(row) {
        for (var field in row) {
          if (!fieldSet.has(field)) {
            fields.push(fieldSet.add(field));
          }
        }
      });
      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
        return fields.map(function(field) {
          return formatValue(row[field]);
        }).join(delimiter);
      })).join("\n");
    };
    dsv.formatRows = function(rows) {
      return rows.map(formatRow).join("\n");
    };
    function formatRow(row) {
      return row.map(formatValue).join(delimiter);
    }
    function formatValue(text) {
      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
    }
    return dsv;
  };
  d3.csv = d3.dsv(",", "text/csv");
  d3.tsv = d3.dsv("	", "text/tab-separated-values");
  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
    setTimeout(callback, 17);
  };
  d3.timer = function() {
    d3_timer.apply(this, arguments);
  };
  function d3_timer(callback, delay, then) {
    var n = arguments.length;
    if (n < 2) delay = 0;
    if (n < 3) then = Date.now();
    var time = then + delay, timer = {
      c: callback,
      t: time,
      n: null
    };
    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
    d3_timer_queueTail = timer;
    if (!d3_timer_interval) {
      d3_timer_timeout = clearTimeout(d3_timer_timeout);
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
    return timer;
  }
  function d3_timer_step() {
    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
    if (delay > 24) {
      if (isFinite(delay)) {
        clearTimeout(d3_timer_timeout);
        d3_timer_timeout = setTimeout(d3_timer_step, delay);
      }
      d3_timer_interval = 0;
    } else {
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
  }
  d3.timer.flush = function() {
    d3_timer_mark();
    d3_timer_sweep();
  };
  function d3_timer_mark() {
    var now = Date.now(), timer = d3_timer_queueHead;
    while (timer) {
      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
      timer = timer.n;
    }
    return now;
  }
  function d3_timer_sweep() {
    var t0, t1 = d3_timer_queueHead, time = Infinity;
    while (t1) {
      if (t1.c) {
        if (t1.t < time) time = t1.t;
        t1 = (t0 = t1).n;
      } else {
        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
      }
    }
    d3_timer_queueTail = t0;
    return time;
  }
  function d3_format_precision(x, p) {
    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
  }
  d3.round = function(x, n) {
    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
  };
  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
  d3.formatPrefix = function(value, precision) {
    var i = 0;
    if (value = +value) {
      if (value < 0) value *= -1;
      if (precision) value = d3.round(value, d3_format_precision(value, precision));
      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
    }
    return d3_formatPrefixes[8 + i / 3];
  };
  function d3_formatPrefix(d, i) {
    var k = Math.pow(10, abs(8 - i) * 3);
    return {
      scale: i > 8 ? function(d) {
        return d / k;
      } : function(d) {
        return d * k;
      },
      symbol: d
    };
  }
  function d3_locale_numberFormat(locale) {
    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
      while (i > 0 && g > 0) {
        if (length + g + 1 > width) g = Math.max(1, width - length);
        t.push(value.substring(i -= g, i + g));
        if ((length += g + 1) > width) break;
        g = locale_grouping[j = (j + 1) % locale_grouping.length];
      }
      return t.reverse().join(locale_thousands);
    } : d3_identity;
    return function(specifier) {
      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
      if (precision) precision = +precision.substring(1);
      if (zfill || fill === "0" && align === "=") {
        zfill = fill = "0";
        align = "=";
      }
      switch (type) {
       case "n":
        comma = true;
        type = "g";
        break;

       case "%":
        scale = 100;
        suffix = "%";
        type = "f";
        break;

       case "p":
        scale = 100;
        suffix = "%";
        type = "r";
        break;

       case "b":
       case "o":
       case "x":
       case "X":
        if (symbol === "#") prefix = "0" + type.toLowerCase();

       case "c":
        exponent = false;

       case "d":
        integer = true;
        precision = 0;
        break;

       case "s":
        scale = -1;
        type = "r";
        break;
      }
      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
      if (type == "r" && !precision) type = "g";
      if (precision != null) {
        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
      }
      type = d3_format_types.get(type) || d3_format_typeDefault;
      var zcomma = zfill && comma;
      return function(value) {
        var fullSuffix = suffix;
        if (integer && value % 1) return "";
        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
        if (scale < 0) {
          var unit = d3.formatPrefix(value, precision);
          value = unit.scale(value);
          fullSuffix = unit.symbol + suffix;
        } else {
          value *= scale;
        }
        value = type(value, precision);
        var i = value.lastIndexOf("."), before, after;
        if (i < 0) {
          var j = exponent ? value.lastIndexOf("e") : -1;
          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
        } else {
          before = value.substring(0, i);
          after = locale_decimal + value.substring(i + 1);
        }
        if (!zfill && comma) before = formatGroup(before, Infinity);
        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
        negative += prefix;
        value = before + after;
        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
      };
    };
  }
  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
  var d3_format_types = d3.map({
    b: function(x) {
      return x.toString(2);
    },
    c: function(x) {
      return String.fromCharCode(x);
    },
    o: function(x) {
      return x.toString(8);
    },
    x: function(x) {
      return x.toString(16);
    },
    X: function(x) {
      return x.toString(16).toUpperCase();
    },
    g: function(x, p) {
      return x.toPrecision(p);
    },
    e: function(x, p) {
      return x.toExponential(p);
    },
    f: function(x, p) {
      return x.toFixed(p);
    },
    r: function(x, p) {
      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
    }
  });
  function d3_format_typeDefault(x) {
    return x + "";
  }
  var d3_time = d3.time = {}, d3_date = Date;
  function d3_date_utc() {
    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
  }
  d3_date_utc.prototype = {
    getDate: function() {
      return this._.getUTCDate();
    },
    getDay: function() {
      return this._.getUTCDay();
    },
    getFullYear: function() {
      return this._.getUTCFullYear();
    },
    getHours: function() {
      return this._.getUTCHours();
    },
    getMilliseconds: function() {
      return this._.getUTCMilliseconds();
    },
    getMinutes: function() {
      return this._.getUTCMinutes();
    },
    getMonth: function() {
      return this._.getUTCMonth();
    },
    getSeconds: function() {
      return this._.getUTCSeconds();
    },
    getTime: function() {
      return this._.getTime();
    },
    getTimezoneOffset: function() {
      return 0;
    },
    valueOf: function() {
      return this._.valueOf();
    },
    setDate: function() {
      d3_time_prototype.setUTCDate.apply(this._, arguments);
    },
    setDay: function() {
      d3_time_prototype.setUTCDay.apply(this._, arguments);
    },
    setFullYear: function() {
      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
    },
    setHours: function() {
      d3_time_prototype.setUTCHours.apply(this._, arguments);
    },
    setMilliseconds: function() {
      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
    },
    setMinutes: function() {
      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
    },
    setMonth: function() {
      d3_time_prototype.setUTCMonth.apply(this._, arguments);
    },
    setSeconds: function() {
      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
    },
    setTime: function() {
      d3_time_prototype.setTime.apply(this._, arguments);
    }
  };
  var d3_time_prototype = Date.prototype;
  function d3_time_interval(local, step, number) {
    function round(date) {
      var d0 = local(date), d1 = offset(d0, 1);
      return date - d0 < d1 - date ? d0 : d1;
    }
    function ceil(date) {
      step(date = local(new d3_date(date - 1)), 1);
      return date;
    }
    function offset(date, k) {
      step(date = new d3_date(+date), k);
      return date;
    }
    function range(t0, t1, dt) {
      var time = ceil(t0), times = [];
      if (dt > 1) {
        while (time < t1) {
          if (!(number(time) % dt)) times.push(new Date(+time));
          step(time, 1);
        }
      } else {
        while (time < t1) times.push(new Date(+time)), step(time, 1);
      }
      return times;
    }
    function range_utc(t0, t1, dt) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = t0;
        return range(utc, t1, dt);
      } finally {
        d3_date = Date;
      }
    }
    local.floor = local;
    local.round = round;
    local.ceil = ceil;
    local.offset = offset;
    local.range = range;
    var utc = local.utc = d3_time_interval_utc(local);
    utc.floor = utc;
    utc.round = d3_time_interval_utc(round);
    utc.ceil = d3_time_interval_utc(ceil);
    utc.offset = d3_time_interval_utc(offset);
    utc.range = range_utc;
    return local;
  }
  function d3_time_interval_utc(method) {
    return function(date, k) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = date;
        return method(utc, k)._;
      } finally {
        d3_date = Date;
      }
    };
  }
  d3_time.year = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setMonth(0, 1);
    return date;
  }, function(date, offset) {
    date.setFullYear(date.getFullYear() + offset);
  }, function(date) {
    return date.getFullYear();
  });
  d3_time.years = d3_time.year.range;
  d3_time.years.utc = d3_time.year.utc.range;
  d3_time.day = d3_time_interval(function(date) {
    var day = new d3_date(2e3, 0);
    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    return day;
  }, function(date, offset) {
    date.setDate(date.getDate() + offset);
  }, function(date) {
    return date.getDate() - 1;
  });
  d3_time.days = d3_time.day.range;
  d3_time.days.utc = d3_time.day.utc.range;
  d3_time.dayOfYear = function(date) {
    var year = d3_time.year(date);
    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
  };
  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
    i = 7 - i;
    var interval = d3_time[day] = d3_time_interval(function(date) {
      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
      return date;
    }, function(date, offset) {
      date.setDate(date.getDate() + Math.floor(offset) * 7);
    }, function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
    });
    d3_time[day + "s"] = interval.range;
    d3_time[day + "s"].utc = interval.utc.range;
    d3_time[day + "OfYear"] = function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
    };
  });
  d3_time.week = d3_time.sunday;
  d3_time.weeks = d3_time.sunday.range;
  d3_time.weeks.utc = d3_time.sunday.utc.range;
  d3_time.weekOfYear = d3_time.sundayOfYear;
  function d3_locale_timeFormat(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    function d3_time_format(template) {
      var n = template.length;
      function format(date) {
        var string = [], i = -1, j = 0, c, p, f;
        while (++i < n) {
          if (template.charCodeAt(i) === 37) {
            string.push(template.slice(j, i));
            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
            string.push(c);
            j = i + 1;
          }
        }
        string.push(template.slice(j, i));
        return string.join("");
      }
      format.parse = function(string) {
        var d = {
          y: 1900,
          m: 0,
          d: 1,
          H: 0,
          M: 0,
          S: 0,
          L: 0,
          Z: null
        }, i = d3_time_parse(d, template, string, 0);
        if (i != string.length) return null;
        if ("p" in d) d.H = d.H % 12 + d.p * 12;
        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
          date.setFullYear(d.y, 0, 1);
          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
        } else date.setFullYear(d.y, d.m, d.d);
        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
        return localZ ? date._ : date;
      };
      format.toString = function() {
        return template;
      };
      return format;
    }
    function d3_time_parse(date, template, string, j) {
      var c, p, t, i = 0, n = template.length, m = string.length;
      while (i < n) {
        if (j >= m) return -1;
        c = template.charCodeAt(i++);
        if (c === 37) {
          t = template.charAt(i++);
          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
          if (!p || (j = p(date, string, j)) < 0) return -1;
        } else if (c != string.charCodeAt(j++)) {
          return -1;
        }
      }
      return j;
    }
    d3_time_format.utc = function(template) {
      var local = d3_time_format(template);
      function format(date) {
        try {
          d3_date = d3_date_utc;
          var utc = new d3_date();
          utc._ = date;
          return local(utc);
        } finally {
          d3_date = Date;
        }
      }
      format.parse = function(string) {
        try {
          d3_date = d3_date_utc;
          var date = local.parse(string);
          return date && date._;
        } finally {
          d3_date = Date;
        }
      };
      format.toString = local.toString;
      return format;
    };
    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
    locale_periods.forEach(function(p, i) {
      d3_time_periodLookup.set(p.toLowerCase(), i);
    });
    var d3_time_formats = {
      a: function(d) {
        return locale_shortDays[d.getDay()];
      },
      A: function(d) {
        return locale_days[d.getDay()];
      },
      b: function(d) {
        return locale_shortMonths[d.getMonth()];
      },
      B: function(d) {
        return locale_months[d.getMonth()];
      },
      c: d3_time_format(locale_dateTime),
      d: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      e: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      H: function(d, p) {
        return d3_time_formatPad(d.getHours(), p, 2);
      },
      I: function(d, p) {
        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
      },
      j: function(d, p) {
        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
      },
      L: function(d, p) {
        return d3_time_formatPad(d.getMilliseconds(), p, 3);
      },
      m: function(d, p) {
        return d3_time_formatPad(d.getMonth() + 1, p, 2);
      },
      M: function(d, p) {
        return d3_time_formatPad(d.getMinutes(), p, 2);
      },
      p: function(d) {
        return locale_periods[+(d.getHours() >= 12)];
      },
      S: function(d, p) {
        return d3_time_formatPad(d.getSeconds(), p, 2);
      },
      U: function(d, p) {
        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
      },
      w: function(d) {
        return d.getDay();
      },
      W: function(d, p) {
        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
      },
      x: d3_time_format(locale_date),
      X: d3_time_format(locale_time),
      y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
      },
      Y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
      },
      Z: d3_time_zone,
      "%": function() {
        return "%";
      }
    };
    var d3_time_parsers = {
      a: d3_time_parseWeekdayAbbrev,
      A: d3_time_parseWeekday,
      b: d3_time_parseMonthAbbrev,
      B: d3_time_parseMonth,
      c: d3_time_parseLocaleFull,
      d: d3_time_parseDay,
      e: d3_time_parseDay,
      H: d3_time_parseHour24,
      I: d3_time_parseHour24,
      j: d3_time_parseDayOfYear,
      L: d3_time_parseMilliseconds,
      m: d3_time_parseMonthNumber,
      M: d3_time_parseMinutes,
      p: d3_time_parseAmPm,
      S: d3_time_parseSeconds,
      U: d3_time_parseWeekNumberSunday,
      w: d3_time_parseWeekdayNumber,
      W: d3_time_parseWeekNumberMonday,
      x: d3_time_parseLocaleDate,
      X: d3_time_parseLocaleTime,
      y: d3_time_parseYear,
      Y: d3_time_parseFullYear,
      Z: d3_time_parseZone,
      "%": d3_time_parseLiteralPercent
    };
    function d3_time_parseWeekdayAbbrev(date, string, i) {
      d3_time_dayAbbrevRe.lastIndex = 0;
      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseWeekday(date, string, i) {
      d3_time_dayRe.lastIndex = 0;
      var n = d3_time_dayRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonthAbbrev(date, string, i) {
      d3_time_monthAbbrevRe.lastIndex = 0;
      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonth(date, string, i) {
      d3_time_monthRe.lastIndex = 0;
      var n = d3_time_monthRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseLocaleFull(date, string, i) {
      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
    }
    function d3_time_parseLocaleDate(date, string, i) {
      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
    }
    function d3_time_parseLocaleTime(date, string, i) {
      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
    }
    function d3_time_parseAmPm(date, string, i) {
      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
      return n == null ? -1 : (date.p = n, i);
    }
    return d3_time_format;
  }
  var d3_time_formatPads = {
    "-": "",
    _: " ",
    "0": "0"
  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
  function d3_time_formatPad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
  }
  function d3_time_formatRe(names) {
    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
  }
  function d3_time_formatLookup(names) {
    var map = new d3_Map(), i = -1, n = names.length;
    while (++i < n) map.set(names[i].toLowerCase(), i);
    return map;
  }
  function d3_time_parseWeekdayNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
    return n ? (date.w = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberSunday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.U = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberMonday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.W = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseFullYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
    return n ? (date.y = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
  }
  function d3_time_parseZone(date, string, i) {
    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
    i + 5) : -1;
  }
  function d3_time_expandYear(d) {
    return d + (d > 68 ? 1900 : 2e3);
  }
  function d3_time_parseMonthNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
  }
  function d3_time_parseDay(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.d = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseDayOfYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.j = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseHour24(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.H = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMinutes(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.M = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseSeconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.S = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMilliseconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.L = +n[0], i + n[0].length) : -1;
  }
  function d3_time_zone(d) {
    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
  }
  function d3_time_parseLiteralPercent(date, string, i) {
    d3_time_percentRe.lastIndex = 0;
    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
  }
  function d3_time_formatMulti(formats) {
    var n = formats.length, i = -1;
    while (++i < n) formats[i][0] = this(formats[i][0]);
    return function(date) {
      var i = 0, f = formats[i];
      while (!f[1](date)) f = formats[++i];
      return f[0](date);
    };
  }
  d3.locale = function(locale) {
    return {
      numberFormat: d3_locale_numberFormat(locale),
      timeFormat: d3_locale_timeFormat(locale)
    };
  };
  var d3_locale_enUS = d3.locale({
    decimal: ".",
    thousands: ",",
    grouping: [ 3 ],
    currency: [ "$", "" ],
    dateTime: "%a %b %e %X %Y",
    date: "%m/%d/%Y",
    time: "%H:%M:%S",
    periods: [ "AM", "PM" ],
    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
  });
  d3.format = d3_locale_enUS.numberFormat;
  d3.geo = {};
  function d3_adder() {}
  d3_adder.prototype = {
    s: 0,
    t: 0,
    add: function(y) {
      d3_adderSum(y, this.t, d3_adderTemp);
      d3_adderSum(d3_adderTemp.s, this.s, this);
      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
    },
    reset: function() {
      this.s = this.t = 0;
    },
    valueOf: function() {
      return this.s;
    }
  };
  var d3_adderTemp = new d3_adder();
  function d3_adderSum(a, b, o) {
    var x = o.s = a + b, bv = x - a, av = x - bv;
    o.t = a - av + (b - bv);
  }
  d3.geo.stream = function(object, listener) {
    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
      d3_geo_streamObjectType[object.type](object, listener);
    } else {
      d3_geo_streamGeometry(object, listener);
    }
  };
  function d3_geo_streamGeometry(geometry, listener) {
    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
      d3_geo_streamGeometryType[geometry.type](geometry, listener);
    }
  }
  var d3_geo_streamObjectType = {
    Feature: function(feature, listener) {
      d3_geo_streamGeometry(feature.geometry, listener);
    },
    FeatureCollection: function(object, listener) {
      var features = object.features, i = -1, n = features.length;
      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
    }
  };
  var d3_geo_streamGeometryType = {
    Sphere: function(object, listener) {
      listener.sphere();
    },
    Point: function(object, listener) {
      object = object.coordinates;
      listener.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
    },
    LineString: function(object, listener) {
      d3_geo_streamLine(object.coordinates, listener, 0);
    },
    MultiLineString: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
    },
    Polygon: function(object, listener) {
      d3_geo_streamPolygon(object.coordinates, listener);
    },
    MultiPolygon: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
    },
    GeometryCollection: function(object, listener) {
      var geometries = object.geometries, i = -1, n = geometries.length;
      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
    }
  };
  function d3_geo_streamLine(coordinates, listener, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    listener.lineStart();
    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
    listener.lineEnd();
  }
  function d3_geo_streamPolygon(coordinates, listener) {
    var i = -1, n = coordinates.length;
    listener.polygonStart();
    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
    listener.polygonEnd();
  }
  d3.geo.area = function(object) {
    d3_geo_areaSum = 0;
    d3.geo.stream(object, d3_geo_area);
    return d3_geo_areaSum;
  };
  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
  var d3_geo_area = {
    sphere: function() {
      d3_geo_areaSum += 4 * π;
    },
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_areaRingSum.reset();
      d3_geo_area.lineStart = d3_geo_areaRingStart;
    },
    polygonEnd: function() {
      var area = 2 * d3_geo_areaRingSum;
      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
    }
  };
  function d3_geo_areaRingStart() {
    var λ00, φ00, λ0, cosφ0, sinφ0;
    d3_geo_area.point = function(λ, φ) {
      d3_geo_area.point = nextPoint;
      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
      sinφ0 = Math.sin(φ);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      φ = φ * d3_radians / 2 + π / 4;
      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
      d3_geo_areaRingSum.add(Math.atan2(v, u));
      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
    }
    d3_geo_area.lineEnd = function() {
      nextPoint(λ00, φ00);
    };
  }
  function d3_geo_cartesian(spherical) {
    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
  }
  function d3_geo_cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
  }
  function d3_geo_cartesianCross(a, b) {
    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
  }
  function d3_geo_cartesianAdd(a, b) {
    a[0] += b[0];
    a[1] += b[1];
    a[2] += b[2];
  }
  function d3_geo_cartesianScale(vector, k) {
    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
  }
  function d3_geo_cartesianNormalize(d) {
    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l;
    d[1] /= l;
    d[2] /= l;
  }
  function d3_geo_spherical(cartesian) {
    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
  }
  function d3_geo_sphericalEqual(a, b) {
    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
  }
  d3.geo.bounds = function() {
    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
    var bound = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        bound.point = ringPoint;
        bound.lineStart = ringStart;
        bound.lineEnd = ringEnd;
        dλSum = 0;
        d3_geo_area.polygonStart();
      },
      polygonEnd: function() {
        d3_geo_area.polygonEnd();
        bound.point = point;
        bound.lineStart = lineStart;
        bound.lineEnd = lineEnd;
        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
        range[0] = λ0, range[1] = λ1;
      }
    };
    function point(λ, φ) {
      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
      if (φ < φ0) φ0 = φ;
      if (φ > φ1) φ1 = φ;
    }
    function linePoint(λ, φ) {
      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
      if (p0) {
        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
        d3_geo_cartesianNormalize(inflection);
        inflection = d3_geo_spherical(inflection);
        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = inflection[1] * d3_degrees;
          if (φi > φ1) φ1 = φi;
        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = -inflection[1] * d3_degrees;
          if (φi < φ0) φ0 = φi;
        } else {
          if (φ < φ0) φ0 = φ;
          if (φ > φ1) φ1 = φ;
        }
        if (antimeridian) {
          if (λ < λ_) {
            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
          } else {
            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
          }
        } else {
          if (λ1 >= λ0) {
            if (λ < λ0) λ0 = λ;
            if (λ > λ1) λ1 = λ;
          } else {
            if (λ > λ_) {
              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
            } else {
              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
            }
          }
        }
      } else {
        point(λ, φ);
      }
      p0 = p, λ_ = λ;
    }
    function lineStart() {
      bound.point = linePoint;
    }
    function lineEnd() {
      range[0] = λ0, range[1] = λ1;
      bound.point = point;
      p0 = null;
    }
    function ringPoint(λ, φ) {
      if (p0) {
        var dλ = λ - λ_;
        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
      } else λ__ = λ, φ__ = φ;
      d3_geo_area.point(λ, φ);
      linePoint(λ, φ);
    }
    function ringStart() {
      d3_geo_area.lineStart();
    }
    function ringEnd() {
      ringPoint(λ__, φ__);
      d3_geo_area.lineEnd();
      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
      range[0] = λ0, range[1] = λ1;
      p0 = null;
    }
    function angle(λ0, λ1) {
      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
    }
    function compareRanges(a, b) {
      return a[0] - b[0];
    }
    function withinRange(x, range) {
      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
    }
    return function(feature) {
      φ1 = λ1 = -(λ0 = φ0 = Infinity);
      ranges = [];
      d3.geo.stream(feature, bound);
      var n = ranges.length;
      if (n) {
        ranges.sort(compareRanges);
        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
          b = ranges[i];
          if (withinRange(b[0], a) || withinRange(b[1], a)) {
            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
          } else {
            merged.push(a = b);
          }
        }
        var best = -Infinity, dλ;
        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
          b = merged[i];
          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
        }
      }
      ranges = range = null;
      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
    };
  }();
  d3.geo.centroid = function(object) {
    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
    d3.geo.stream(object, d3_geo_centroid);
    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
    if (m < ε2) {
      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
      m = x * x + y * y + z * z;
      if (m < ε2) return [ NaN, NaN ];
    }
    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
  };
  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
  var d3_geo_centroid = {
    sphere: d3_noop,
    point: d3_geo_centroidPoint,
    lineStart: d3_geo_centroidLineStart,
    lineEnd: d3_geo_centroidLineEnd,
    polygonStart: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
    }
  };
  function d3_geo_centroidPoint(λ, φ) {
    λ *= d3_radians;
    var cosφ = Math.cos(φ *= d3_radians);
    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
  }
  function d3_geo_centroidPointXYZ(x, y, z) {
    ++d3_geo_centroidW0;
    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
  }
  function d3_geo_centroidLineStart() {
    var x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroid.point = nextPoint;
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_centroidLineEnd() {
    d3_geo_centroid.point = d3_geo_centroidPoint;
  }
  function d3_geo_centroidRingStart() {
    var λ00, φ00, x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ00 = λ, φ00 = φ;
      d3_geo_centroid.point = nextPoint;
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    d3_geo_centroid.lineEnd = function() {
      nextPoint(λ00, φ00);
      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
      d3_geo_centroid.point = d3_geo_centroidPoint;
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
      d3_geo_centroidX2 += v * cx;
      d3_geo_centroidY2 += v * cy;
      d3_geo_centroidZ2 += v * cz;
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_compose(a, b) {
    function compose(x, y) {
      return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
  }
  function d3_true() {
    return true;
  }
  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
    var subject = [], clip = [];
    segments.forEach(function(segment) {
      if ((n = segment.length - 1) <= 0) return;
      var n, p0 = segment[0], p1 = segment[n];
      if (d3_geo_sphericalEqual(p0, p1)) {
        listener.lineStart();
        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
        listener.lineEnd();
        return;
      }
      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
      a.o = b;
      subject.push(a);
      clip.push(b);
      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
      a.o = b;
      subject.push(a);
      clip.push(b);
    });
    clip.sort(compare);
    d3_geo_clipPolygonLinkCircular(subject);
    d3_geo_clipPolygonLinkCircular(clip);
    if (!subject.length) return;
    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
      clip[i].e = entry = !entry;
    }
    var start = subject[0], points, point;
    while (1) {
      var current = start, isSubject = true;
      while (current.v) if ((current = current.n) === start) return;
      points = current.z;
      listener.lineStart();
      do {
        current.v = current.o.v = true;
        if (current.e) {
          if (isSubject) {
            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.n.x, 1, listener);
          }
          current = current.n;
        } else {
          if (isSubject) {
            points = current.p.z;
            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.p.x, -1, listener);
          }
          current = current.p;
        }
        current = current.o;
        points = current.z;
        isSubject = !isSubject;
      } while (!current.v);
      listener.lineEnd();
    }
  }
  function d3_geo_clipPolygonLinkCircular(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while (++i < n) {
      a.n = b = array[i];
      b.p = a;
      a = b;
    }
    a.n = b = array[0];
    b.p = a;
  }
  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other;
    this.e = entry;
    this.v = false;
    this.n = this.p = null;
  }
  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
    return function(rotate, listener) {
      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          clip.point = pointRing;
          clip.lineStart = ringStart;
          clip.lineEnd = ringEnd;
          segments = [];
          polygon = [];
        },
        polygonEnd: function() {
          clip.point = point;
          clip.lineStart = lineStart;
          clip.lineEnd = lineEnd;
          segments = d3.merge(segments);
          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
          if (segments.length) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
          } else if (clipStartInside) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            interpolate(null, null, 1, listener);
            listener.lineEnd();
          }
          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
          segments = polygon = null;
        },
        sphere: function() {
          listener.polygonStart();
          listener.lineStart();
          interpolate(null, null, 1, listener);
          listener.lineEnd();
          listener.polygonEnd();
        }
      };
      function point(λ, φ) {
        var point = rotate(λ, φ);
        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
      }
      function pointLine(λ, φ) {
        var point = rotate(λ, φ);
        line.point(point[0], point[1]);
      }
      function lineStart() {
        clip.point = pointLine;
        line.lineStart();
      }
      function lineEnd() {
        clip.point = point;
        line.lineEnd();
      }
      var segments;
      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
      function pointRing(λ, φ) {
        ring.push([ λ, φ ]);
        var point = rotate(λ, φ);
        ringListener.point(point[0], point[1]);
      }
      function ringStart() {
        ringListener.lineStart();
        ring = [];
      }
      function ringEnd() {
        pointRing(ring[0][0], ring[0][1]);
        ringListener.lineEnd();
        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
        ring.pop();
        polygon.push(ring);
        ring = null;
        if (!n) return;
        if (clean & 1) {
          segment = ringSegments[0];
          var n = segment.length - 1, i = -1, point;
          if (n > 0) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            while (++i < n) listener.point((point = segment[i])[0], point[1]);
            listener.lineEnd();
          }
          return;
        }
        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
      }
      return clip;
    };
  }
  function d3_geo_clipSegmentLength1(segment) {
    return segment.length > 1;
  }
  function d3_geo_clipBufferListener() {
    var lines = [], line;
    return {
      lineStart: function() {
        lines.push(line = []);
      },
      point: function(λ, φ) {
        line.push([ λ, φ ]);
      },
      lineEnd: d3_noop,
      buffer: function() {
        var buffer = lines;
        lines = [];
        line = null;
        return buffer;
      },
      rejoin: function() {
        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
      }
    };
  }
  function d3_geo_clipSort(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
  }
  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
  function d3_geo_clipAntimeridianLine(listener) {
    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
    return {
      lineStart: function() {
        listener.lineStart();
        clean = 1;
      },
      point: function(λ1, φ1) {
        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
        if (abs(dλ - π) < ε) {
          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          listener.point(λ1, φ0);
          clean = 0;
        } else if (sλ0 !== sλ1 && dλ >= π) {
          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          clean = 0;
        }
        listener.point(λ0 = λ1, φ0 = φ1);
        sλ0 = sλ1;
      },
      lineEnd: function() {
        listener.lineEnd();
        λ0 = φ0 = NaN;
      },
      clean: function() {
        return 2 - clean;
      }
    };
  }
  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
  }
  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
    var φ;
    if (from == null) {
      φ = direction * halfπ;
      listener.point(-π, φ);
      listener.point(0, φ);
      listener.point(π, φ);
      listener.point(π, 0);
      listener.point(π, -φ);
      listener.point(0, -φ);
      listener.point(-π, -φ);
      listener.point(-π, 0);
      listener.point(-π, φ);
    } else if (abs(from[0] - to[0]) > ε) {
      var s = from[0] < to[0] ? π : -π;
      φ = direction * s / 2;
      listener.point(-s, φ);
      listener.point(0, φ);
      listener.point(s, φ);
    } else {
      listener.point(to[0], to[1]);
    }
  }
  function d3_geo_pointInPolygon(point, polygon) {
    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
    d3_geo_areaRingSum.reset();
    for (var i = 0, n = polygon.length; i < n; ++i) {
      var ring = polygon[i], m = ring.length;
      if (!m) continue;
      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
      while (true) {
        if (j === m) j = 0;
        point = ring[j];
        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
          d3_geo_cartesianNormalize(arc);
          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
          d3_geo_cartesianNormalize(intersection);
          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
          }
        }
        if (!j++) break;
        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
      }
    }
    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
  }
  function d3_geo_clipCircle(radius) {
    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
    function visible(λ, φ) {
      return Math.cos(λ) * Math.cos(φ) > cr;
    }
    function clipLine(listener) {
      var point0, c0, v0, v00, clean;
      return {
        lineStart: function() {
          v00 = v0 = false;
          clean = 1;
        },
        point: function(λ, φ) {
          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
          if (!point0 && (v00 = v0 = v)) listener.lineStart();
          if (v !== v0) {
            point2 = intersect(point0, point1);
            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
              point1[0] += ε;
              point1[1] += ε;
              v = visible(point1[0], point1[1]);
            }
          }
          if (v !== v0) {
            clean = 0;
            if (v) {
              listener.lineStart();
              point2 = intersect(point1, point0);
              listener.point(point2[0], point2[1]);
            } else {
              point2 = intersect(point0, point1);
              listener.point(point2[0], point2[1]);
              listener.lineEnd();
            }
            point0 = point2;
          } else if (notHemisphere && point0 && smallRadius ^ v) {
            var t;
            if (!(c & c0) && (t = intersect(point1, point0, true))) {
              clean = 0;
              if (smallRadius) {
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
              } else {
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
              }
            }
          }
          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
            listener.point(point1[0], point1[1]);
          }
          point0 = point1, v0 = v, c0 = c;
        },
        lineEnd: function() {
          if (v0) listener.lineEnd();
          point0 = null;
        },
        clean: function() {
          return clean | (v00 && v0) << 1;
        }
      };
    }
    function intersect(a, b, two) {
      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
      if (!determinant) return !two && a;
      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
      d3_geo_cartesianAdd(A, B);
      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
      if (t2 < 0) return;
      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
      d3_geo_cartesianAdd(q, A);
      q = d3_geo_spherical(q);
      if (!two) return q;
      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
        d3_geo_cartesianAdd(q1, A);
        return [ q, d3_geo_spherical(q1) ];
      }
    }
    function code(λ, φ) {
      var r = smallRadius ? radius : π - radius, code = 0;
      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
      return code;
    }
  }
  function d3_geom_clipLine(x0, y0, x1, y1) {
    return function(line) {
      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
      r = x0 - ax;
      if (!dx && r > 0) return;
      r /= dx;
      if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = x1 - ax;
      if (!dx && r < 0) return;
      r /= dx;
      if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      r = y0 - ay;
      if (!dy && r > 0) return;
      r /= dy;
      if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = y1 - ay;
      if (!dy && r < 0) return;
      r /= dy;
      if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      if (t0 > 0) line.a = {
        x: ax + t0 * dx,
        y: ay + t0 * dy
      };
      if (t1 < 1) line.b = {
        x: ax + t1 * dx,
        y: ay + t1 * dy
      };
      return line;
    };
  }
  var d3_geo_clipExtentMAX = 1e9;
  d3.geo.clipExtent = function() {
    var x0, y0, x1, y1, stream, clip, clipExtent = {
      stream: function(output) {
        if (stream) stream.valid = false;
        stream = clip(output);
        stream.valid = true;
        return stream;
      },
      extent: function(_) {
        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
        if (stream) stream.valid = false, stream = null;
        return clipExtent;
      }
    };
    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
  };
  function d3_geo_clipExtent(x0, y0, x1, y1) {
    return function(listener) {
      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          listener = bufferListener;
          segments = [];
          polygon = [];
          clean = true;
        },
        polygonEnd: function() {
          listener = listener_;
          segments = d3.merge(segments);
          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
          if (inside || visible) {
            listener.polygonStart();
            if (inside) {
              listener.lineStart();
              interpolate(null, null, 1, listener);
              listener.lineEnd();
            }
            if (visible) {
              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
            }
            listener.polygonEnd();
          }
          segments = polygon = ring = null;
        }
      };
      function insidePolygon(p) {
        var wn = 0, n = polygon.length, y = p[1];
        for (var i = 0; i < n; ++i) {
          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
            b = v[j];
            if (a[1] <= y) {
              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
            } else {
              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
            }
            a = b;
          }
        }
        return wn !== 0;
      }
      function interpolate(from, to, direction, listener) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
          do {
            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
          } while ((a = (a + direction + 4) % 4) !== a1);
        } else {
          listener.point(to[0], to[1]);
        }
      }
      function pointVisible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
      }
      function point(x, y) {
        if (pointVisible(x, y)) listener.point(x, y);
      }
      var x__, y__, v__, x_, y_, v_, first, clean;
      function lineStart() {
        clip.point = linePoint;
        if (polygon) polygon.push(ring = []);
        first = true;
        v_ = false;
        x_ = y_ = NaN;
      }
      function lineEnd() {
        if (segments) {
          linePoint(x__, y__);
          if (v__ && v_) bufferListener.rejoin();
          segments.push(bufferListener.buffer());
        }
        clip.point = point;
        if (v_) listener.lineEnd();
      }
      function linePoint(x, y) {
        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
        var v = pointVisible(x, y);
        if (polygon) ring.push([ x, y ]);
        if (first) {
          x__ = x, y__ = y, v__ = v;
          first = false;
          if (v) {
            listener.lineStart();
            listener.point(x, y);
          }
        } else {
          if (v && v_) listener.point(x, y); else {
            var l = {
              a: {
                x: x_,
                y: y_
              },
              b: {
                x: x,
                y: y
              }
            };
            if (clipLine(l)) {
              if (!v_) {
                listener.lineStart();
                listener.point(l.a.x, l.a.y);
              }
              listener.point(l.b.x, l.b.y);
              if (!v) listener.lineEnd();
              clean = false;
            } else if (v) {
              listener.lineStart();
              listener.point(x, y);
              clean = false;
            }
          }
        }
        x_ = x, y_ = y, v_ = v;
      }
      return clip;
    };
    function corner(p, direction) {
      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
    }
    function compare(a, b) {
      return comparePoints(a.x, b.x);
    }
    function comparePoints(a, b) {
      var ca = corner(a, 1), cb = corner(b, 1);
      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
  }
  function d3_geo_conic(projectAt) {
    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
    p.parallels = function(_) {
      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
    };
    return p;
  }
  function d3_geo_conicEqualArea(φ0, φ1) {
    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
    function forward(λ, φ) {
      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = ρ0 - y;
      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
    };
    return forward;
  }
  (d3.geo.conicEqualArea = function() {
    return d3_geo_conic(d3_geo_conicEqualArea);
  }).raw = d3_geo_conicEqualArea;
  d3.geo.albers = function() {
    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
  };
  d3.geo.albersUsa = function() {
    var lower48 = d3.geo.albers();
    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
    var point, pointStream = {
      point: function(x, y) {
        point = [ x, y ];
      }
    }, lower48Point, alaskaPoint, hawaiiPoint;
    function albersUsa(coordinates) {
      var x = coordinates[0], y = coordinates[1];
      point = null;
      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
      return point;
    }
    albersUsa.invert = function(coordinates) {
      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
      return {
        point: function(x, y) {
          lower48Stream.point(x, y);
          alaskaStream.point(x, y);
          hawaiiStream.point(x, y);
        },
        sphere: function() {
          lower48Stream.sphere();
          alaskaStream.sphere();
          hawaiiStream.sphere();
        },
        lineStart: function() {
          lower48Stream.lineStart();
          alaskaStream.lineStart();
          hawaiiStream.lineStart();
        },
        lineEnd: function() {
          lower48Stream.lineEnd();
          alaskaStream.lineEnd();
          hawaiiStream.lineEnd();
        },
        polygonStart: function() {
          lower48Stream.polygonStart();
          alaskaStream.polygonStart();
          hawaiiStream.polygonStart();
        },
        polygonEnd: function() {
          lower48Stream.polygonEnd();
          alaskaStream.polygonEnd();
          hawaiiStream.polygonEnd();
        }
      };
    };
    albersUsa.precision = function(_) {
      if (!arguments.length) return lower48.precision();
      lower48.precision(_);
      alaska.precision(_);
      hawaii.precision(_);
      return albersUsa;
    };
    albersUsa.scale = function(_) {
      if (!arguments.length) return lower48.scale();
      lower48.scale(_);
      alaska.scale(_ * .35);
      hawaii.scale(_);
      return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
      if (!arguments.length) return lower48.translate();
      var k = lower48.scale(), x = +_[0], y = +_[1];
      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      return albersUsa;
    };
    return albersUsa.scale(1070);
  };
  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_pathAreaPolygon = 0;
      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
    }
  };
  function d3_geo_pathAreaRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathArea.point = function(x, y) {
      d3_geo_pathArea.point = nextPoint;
      x00 = x0 = x, y00 = y0 = y;
    };
    function nextPoint(x, y) {
      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
      x0 = x, y0 = y;
    }
    d3_geo_pathArea.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
  var d3_geo_pathBounds = {
    point: d3_geo_pathBoundsPoint,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_pathBoundsPoint(x, y) {
    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
  }
  function d3_geo_pathBuffer() {
    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointCircle = d3_geo_pathBufferCircle(_);
        return stream;
      },
      result: function() {
        if (buffer.length) {
          var result = buffer.join("");
          buffer = [];
          return result;
        }
      }
    };
    function point(x, y) {
      buffer.push("M", x, ",", y, pointCircle);
    }
    function pointLineStart(x, y) {
      buffer.push("M", x, ",", y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      buffer.push("L", x, ",", y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      buffer.push("Z");
    }
    return stream;
  }
  function d3_geo_pathBufferCircle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
  }
  var d3_geo_pathCentroid = {
    point: d3_geo_pathCentroidPoint,
    lineStart: d3_geo_pathCentroidLineStart,
    lineEnd: d3_geo_pathCentroidLineEnd,
    polygonStart: function() {
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
    }
  };
  function d3_geo_pathCentroidPoint(x, y) {
    d3_geo_centroidX0 += x;
    d3_geo_centroidY0 += y;
    ++d3_geo_centroidZ0;
  }
  function d3_geo_pathCentroidLineStart() {
    var x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
  }
  function d3_geo_pathCentroidLineEnd() {
    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
  }
  function d3_geo_pathCentroidRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      z = y0 * x - x0 * y;
      d3_geo_centroidX2 += z * (x0 + x);
      d3_geo_centroidY2 += z * (y0 + y);
      d3_geo_centroidZ2 += z * 3;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
    d3_geo_pathCentroid.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  function d3_geo_pathContext(context) {
    var pointRadius = 4.5;
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointRadius = _;
        return stream;
      },
      result: d3_noop
    };
    function point(x, y) {
      context.moveTo(x + pointRadius, y);
      context.arc(x, y, pointRadius, 0, τ);
    }
    function pointLineStart(x, y) {
      context.moveTo(x, y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      context.lineTo(x, y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      context.closePath();
    }
    return stream;
  }
  function d3_geo_resample(project) {
    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
    function resample(stream) {
      return (maxDepth ? resampleRecursive : resampleNone)(stream);
    }
    function resampleNone(stream) {
      return d3_geo_transformPoint(stream, function(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      });
    }
    function resampleRecursive(stream) {
      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
      var resample = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          stream.polygonStart();
          resample.lineStart = ringStart;
        },
        polygonEnd: function() {
          stream.polygonEnd();
          resample.lineStart = lineStart;
        }
      };
      function point(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      }
      function lineStart() {
        x0 = NaN;
        resample.point = linePoint;
        stream.lineStart();
      }
      function linePoint(λ, φ) {
        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
        stream.point(x0, y0);
      }
      function lineEnd() {
        resample.point = point;
        stream.lineEnd();
      }
      function ringStart() {
        lineStart();
        resample.point = ringPoint;
        resample.lineEnd = ringEnd;
      }
      function ringPoint(λ, φ) {
        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
        resample.point = linePoint;
      }
      function ringEnd() {
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
        resample.lineEnd = lineEnd;
        lineEnd();
      }
      return resample;
    }
    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
      if (d2 > 4 * δ2 && depth--) {
        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
          stream.point(x2, y2);
          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
        }
      }
    }
    resample.precision = function(_) {
      if (!arguments.length) return Math.sqrt(δ2);
      maxDepth = (δ2 = _ * _) > 0 && 16;
      return resample;
    };
    return resample;
  }
  d3.geo.path = function() {
    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
    function path(object) {
      if (object) {
        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
        d3.geo.stream(object, cacheStream);
      }
      return contextStream.result();
    }
    path.area = function(object) {
      d3_geo_pathAreaSum = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathArea));
      return d3_geo_pathAreaSum;
    };
    path.centroid = function(object) {
      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
    };
    path.bounds = function(object) {
      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
    };
    path.projection = function(_) {
      if (!arguments.length) return projection;
      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
      return reset();
    };
    path.context = function(_) {
      if (!arguments.length) return context;
      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
      return reset();
    };
    path.pointRadius = function(_) {
      if (!arguments.length) return pointRadius;
      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
      return path;
    };
    function reset() {
      cacheStream = null;
      return path;
    }
    return path.projection(d3.geo.albersUsa()).context(null);
  };
  function d3_geo_pathProjectStream(project) {
    var resample = d3_geo_resample(function(x, y) {
      return project([ x * d3_degrees, y * d3_degrees ]);
    });
    return function(stream) {
      return d3_geo_projectionRadians(resample(stream));
    };
  }
  d3.geo.transform = function(methods) {
    return {
      stream: function(stream) {
        var transform = new d3_geo_transform(stream);
        for (var k in methods) transform[k] = methods[k];
        return transform;
      }
    };
  };
  function d3_geo_transform(stream) {
    this.stream = stream;
  }
  d3_geo_transform.prototype = {
    point: function(x, y) {
      this.stream.point(x, y);
    },
    sphere: function() {
      this.stream.sphere();
    },
    lineStart: function() {
      this.stream.lineStart();
    },
    lineEnd: function() {
      this.stream.lineEnd();
    },
    polygonStart: function() {
      this.stream.polygonStart();
    },
    polygonEnd: function() {
      this.stream.polygonEnd();
    }
  };
  function d3_geo_transformPoint(stream, point) {
    return {
      point: point,
      sphere: function() {
        stream.sphere();
      },
      lineStart: function() {
        stream.lineStart();
      },
      lineEnd: function() {
        stream.lineEnd();
      },
      polygonStart: function() {
        stream.polygonStart();
      },
      polygonEnd: function() {
        stream.polygonEnd();
      }
    };
  }
  d3.geo.projection = d3_geo_projection;
  d3.geo.projectionMutator = d3_geo_projectionMutator;
  function d3_geo_projection(project) {
    return d3_geo_projectionMutator(function() {
      return project;
    })();
  }
  function d3_geo_projectionMutator(projectAt) {
    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
      x = project(x, y);
      return [ x[0] * k + δx, δy - x[1] * k ];
    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
    function projection(point) {
      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
      return [ point[0] * k + δx, δy - point[1] * k ];
    }
    function invert(point) {
      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
    }
    projection.stream = function(output) {
      if (stream) stream.valid = false;
      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
      stream.valid = true;
      return stream;
    };
    projection.clipAngle = function(_) {
      if (!arguments.length) return clipAngle;
      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
      return invalidate();
    };
    projection.clipExtent = function(_) {
      if (!arguments.length) return clipExtent;
      clipExtent = _;
      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
      return invalidate();
    };
    projection.scale = function(_) {
      if (!arguments.length) return k;
      k = +_;
      return reset();
    };
    projection.translate = function(_) {
      if (!arguments.length) return [ x, y ];
      x = +_[0];
      y = +_[1];
      return reset();
    };
    projection.center = function(_) {
      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
      λ = _[0] % 360 * d3_radians;
      φ = _[1] % 360 * d3_radians;
      return reset();
    };
    projection.rotate = function(_) {
      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
      δλ = _[0] % 360 * d3_radians;
      δφ = _[1] % 360 * d3_radians;
      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
      return reset();
    };
    d3.rebind(projection, projectResample, "precision");
    function reset() {
      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
      var center = project(λ, φ);
      δx = x - center[0] * k;
      δy = y + center[1] * k;
      return invalidate();
    }
    function invalidate() {
      if (stream) stream.valid = false, stream = null;
      return projection;
    }
    return function() {
      project = projectAt.apply(this, arguments);
      projection.invert = project.invert && invert;
      return reset();
    };
  }
  function d3_geo_projectionRadians(stream) {
    return d3_geo_transformPoint(stream, function(x, y) {
      stream.point(x * d3_radians, y * d3_radians);
    });
  }
  function d3_geo_equirectangular(λ, φ) {
    return [ λ, φ ];
  }
  (d3.geo.equirectangular = function() {
    return d3_geo_projection(d3_geo_equirectangular);
  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
  d3.geo.rotation = function(rotate) {
    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
    function forward(coordinates) {
      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    }
    forward.invert = function(coordinates) {
      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    };
    return forward;
  };
  function d3_geo_identityRotation(λ, φ) {
    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
  }
  d3_geo_identityRotation.invert = d3_geo_equirectangular;
  function d3_geo_rotation(δλ, δφ, δγ) {
    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
  }
  function d3_geo_forwardRotationλ(δλ) {
    return function(λ, φ) {
      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
    };
  }
  function d3_geo_rotationλ(δλ) {
    var rotation = d3_geo_forwardRotationλ(δλ);
    rotation.invert = d3_geo_forwardRotationλ(-δλ);
    return rotation;
  }
  function d3_geo_rotationφγ(δφ, δγ) {
    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
    function rotation(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
    }
    rotation.invert = function(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
    };
    return rotation;
  }
  d3.geo.circle = function() {
    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
    function circle() {
      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
      interpolate(null, null, 1, {
        point: function(x, y) {
          ring.push(x = rotate(x, y));
          x[0] *= d3_degrees, x[1] *= d3_degrees;
        }
      });
      return {
        type: "Polygon",
        coordinates: [ ring ]
      };
    }
    circle.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return circle;
    };
    circle.angle = function(x) {
      if (!arguments.length) return angle;
      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
      return circle;
    };
    circle.precision = function(_) {
      if (!arguments.length) return precision;
      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
      return circle;
    };
    return circle.angle(90);
  };
  function d3_geo_circleInterpolate(radius, precision) {
    var cr = Math.cos(radius), sr = Math.sin(radius);
    return function(from, to, direction, listener) {
      var step = direction * precision;
      if (from != null) {
        from = d3_geo_circleAngle(cr, from);
        to = d3_geo_circleAngle(cr, to);
        if (direction > 0 ? from < to : from > to) from += direction * τ;
      } else {
        from = radius + direction * τ;
        to = radius - .5 * step;
      }
      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
      }
    };
  }
  function d3_geo_circleAngle(cr, point) {
    var a = d3_geo_cartesian(point);
    a[0] -= cr;
    d3_geo_cartesianNormalize(a);
    var angle = d3_acos(-a[1]);
    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
  }
  d3.geo.distance = function(a, b) {
    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
  };
  d3.geo.graticule = function() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
      return {
        type: "MultiLineString",
        coordinates: lines()
      };
    }
    function lines() {
      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
        return abs(x % DX) > ε;
      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
        return abs(y % DY) > ε;
      }).map(y));
    }
    graticule.lines = function() {
      return lines().map(function(coordinates) {
        return {
          type: "LineString",
          coordinates: coordinates
        };
      });
    };
    graticule.outline = function() {
      return {
        type: "Polygon",
        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
      };
    };
    graticule.extent = function(_) {
      if (!arguments.length) return graticule.minorExtent();
      return graticule.majorExtent(_).minorExtent(_);
    };
    graticule.majorExtent = function(_) {
      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
      X0 = +_[0][0], X1 = +_[1][0];
      Y0 = +_[0][1], Y1 = +_[1][1];
      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
      return graticule.precision(precision);
    };
    graticule.minorExtent = function(_) {
      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
      x0 = +_[0][0], x1 = +_[1][0];
      y0 = +_[0][1], y1 = +_[1][1];
      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
      return graticule.precision(precision);
    };
    graticule.step = function(_) {
      if (!arguments.length) return graticule.minorStep();
      return graticule.majorStep(_).minorStep(_);
    };
    graticule.majorStep = function(_) {
      if (!arguments.length) return [ DX, DY ];
      DX = +_[0], DY = +_[1];
      return graticule;
    };
    graticule.minorStep = function(_) {
      if (!arguments.length) return [ dx, dy ];
      dx = +_[0], dy = +_[1];
      return graticule;
    };
    graticule.precision = function(_) {
      if (!arguments.length) return precision;
      precision = +_;
      x = d3_geo_graticuleX(y0, y1, 90);
      y = d3_geo_graticuleY(x0, x1, precision);
      X = d3_geo_graticuleX(Y0, Y1, 90);
      Y = d3_geo_graticuleY(X0, X1, precision);
      return graticule;
    };
    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
  };
  function d3_geo_graticuleX(y0, y1, dy) {
    var y = d3.range(y0, y1 - ε, dy).concat(y1);
    return function(x) {
      return y.map(function(y) {
        return [ x, y ];
      });
    };
  }
  function d3_geo_graticuleY(x0, x1, dx) {
    var x = d3.range(x0, x1 - ε, dx).concat(x1);
    return function(y) {
      return x.map(function(x) {
        return [ x, y ];
      });
    };
  }
  function d3_source(d) {
    return d.source;
  }
  function d3_target(d) {
    return d.target;
  }
  d3.geo.greatArc = function() {
    var source = d3_source, source_, target = d3_target, target_;
    function greatArc() {
      return {
        type: "LineString",
        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
      };
    }
    greatArc.distance = function() {
      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
    };
    greatArc.source = function(_) {
      if (!arguments.length) return source;
      source = _, source_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.target = function(_) {
      if (!arguments.length) return target;
      target = _, target_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.precision = function() {
      return arguments.length ? greatArc : 0;
    };
    return greatArc;
  };
  d3.geo.interpolate = function(source, target) {
    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
  };
  function d3_geo_interpolate(x0, y0, x1, y1) {
    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
    var interpolate = d ? function(t) {
      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
    } : function() {
      return [ x0 * d3_degrees, y0 * d3_degrees ];
    };
    interpolate.distance = d;
    return interpolate;
  }
  d3.geo.length = function(object) {
    d3_geo_lengthSum = 0;
    d3.geo.stream(object, d3_geo_length);
    return d3_geo_lengthSum;
  };
  var d3_geo_lengthSum;
  var d3_geo_length = {
    sphere: d3_noop,
    point: d3_noop,
    lineStart: d3_geo_lengthLineStart,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_lengthLineStart() {
    var λ0, sinφ0, cosφ0;
    d3_geo_length.point = function(λ, φ) {
      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
      d3_geo_length.point = nextPoint;
    };
    d3_geo_length.lineEnd = function() {
      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
    };
    function nextPoint(λ, φ) {
      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
    }
  }
  function d3_geo_azimuthal(scale, angle) {
    function azimuthal(λ, φ) {
      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
    }
    azimuthal.invert = function(x, y) {
      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
    };
    return azimuthal;
  }
  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
    return Math.sqrt(2 / (1 + cosλcosφ));
  }, function(ρ) {
    return 2 * Math.asin(ρ / 2);
  });
  (d3.geo.azimuthalEqualArea = function() {
    return d3_geo_projection(d3_geo_azimuthalEqualArea);
  }).raw = d3_geo_azimuthalEqualArea;
  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
    var c = Math.acos(cosλcosφ);
    return c && c / Math.sin(c);
  }, d3_identity);
  (d3.geo.azimuthalEquidistant = function() {
    return d3_geo_projection(d3_geo_azimuthalEquidistant);
  }).raw = d3_geo_azimuthalEquidistant;
  function d3_geo_conicConformal(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), t = function(φ) {
      return Math.tan(π / 4 + φ / 2);
    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
    if (!n) return d3_geo_mercator;
    function forward(λ, φ) {
      if (F > 0) {
        if (φ < -halfπ + ε) φ = -halfπ + ε;
      } else {
        if (φ > halfπ - ε) φ = halfπ - ε;
      }
      var ρ = F / Math.pow(t(φ), n);
      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
    };
    return forward;
  }
  (d3.geo.conicConformal = function() {
    return d3_geo_conic(d3_geo_conicConformal);
  }).raw = d3_geo_conicConformal;
  function d3_geo_conicEquidistant(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
    if (abs(n) < ε) return d3_geo_equirectangular;
    function forward(λ, φ) {
      var ρ = G - φ;
      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = G - y;
      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
    };
    return forward;
  }
  (d3.geo.conicEquidistant = function() {
    return d3_geo_conic(d3_geo_conicEquidistant);
  }).raw = d3_geo_conicEquidistant;
  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / cosλcosφ;
  }, Math.atan);
  (d3.geo.gnomonic = function() {
    return d3_geo_projection(d3_geo_gnomonic);
  }).raw = d3_geo_gnomonic;
  function d3_geo_mercator(λ, φ) {
    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
  }
  d3_geo_mercator.invert = function(x, y) {
    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
  };
  function d3_geo_mercatorProjection(project) {
    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
    m.scale = function() {
      var v = scale.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.translate = function() {
      var v = translate.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.clipExtent = function(_) {
      var v = clipExtent.apply(m, arguments);
      if (v === m) {
        if (clipAuto = _ == null) {
          var k = π * scale(), t = translate();
          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
        }
      } else if (clipAuto) {
        v = null;
      }
      return v;
    };
    return m.clipExtent(null);
  }
  (d3.geo.mercator = function() {
    return d3_geo_mercatorProjection(d3_geo_mercator);
  }).raw = d3_geo_mercator;
  var d3_geo_orthographic = d3_geo_azimuthal(function() {
    return 1;
  }, Math.asin);
  (d3.geo.orthographic = function() {
    return d3_geo_projection(d3_geo_orthographic);
  }).raw = d3_geo_orthographic;
  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / (1 + cosλcosφ);
  }, function(ρ) {
    return 2 * Math.atan(ρ);
  });
  (d3.geo.stereographic = function() {
    return d3_geo_projection(d3_geo_stereographic);
  }).raw = d3_geo_stereographic;
  function d3_geo_transverseMercator(λ, φ) {
    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
  }
  d3_geo_transverseMercator.invert = function(x, y) {
    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
  };
  (d3.geo.transverseMercator = function() {
    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
    projection.center = function(_) {
      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
    };
    projection.rotate = function(_) {
      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
      [ _[0], _[1], _[2] - 90 ]);
    };
    return rotate([ 0, 0, 90 ]);
  }).raw = d3_geo_transverseMercator;
  d3.geom = {};
  function d3_geom_pointX(d) {
    return d[0];
  }
  function d3_geom_pointY(d) {
    return d[1];
  }
  d3.geom.hull = function(vertices) {
    var x = d3_geom_pointX, y = d3_geom_pointY;
    if (arguments.length) return hull(vertices);
    function hull(data) {
      if (data.length < 3) return [];
      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
      for (i = 0; i < n; i++) {
        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
      }
      points.sort(d3_geom_hullOrder);
      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
      return polygon;
    }
    hull.x = function(_) {
      return arguments.length ? (x = _, hull) : x;
    };
    hull.y = function(_) {
      return arguments.length ? (y = _, hull) : y;
    };
    return hull;
  };
  function d3_geom_hullUpper(points) {
    var n = points.length, hull = [ 0, 1 ], hs = 2;
    for (var i = 2; i < n; i++) {
      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
      hull[hs++] = i;
    }
    return hull.slice(0, hs);
  }
  function d3_geom_hullOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
  }
  d3.geom.polygon = function(coordinates) {
    d3_subclass(coordinates, d3_geom_polygonPrototype);
    return coordinates;
  };
  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
  d3_geom_polygonPrototype.area = function() {
    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
    while (++i < n) {
      a = b;
      b = this[i];
      area += a[1] * b[0] - a[0] * b[1];
    }
    return area * .5;
  };
  d3_geom_polygonPrototype.centroid = function(k) {
    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
    if (!arguments.length) k = -1 / (6 * this.area());
    while (++i < n) {
      a = b;
      b = this[i];
      c = a[0] * b[1] - b[0] * a[1];
      x += (a[0] + b[0]) * c;
      y += (a[1] + b[1]) * c;
    }
    return [ x * k, y * k ];
  };
  d3_geom_polygonPrototype.clip = function(subject) {
    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
    while (++i < n) {
      input = subject.slice();
      subject.length = 0;
      b = this[i];
      c = input[(m = input.length - closed) - 1];
      j = -1;
      while (++j < m) {
        d = input[j];
        if (d3_geom_polygonInside(d, a, b)) {
          if (!d3_geom_polygonInside(c, a, b)) {
            subject.push(d3_geom_polygonIntersect(c, d, a, b));
          }
          subject.push(d);
        } else if (d3_geom_polygonInside(c, a, b)) {
          subject.push(d3_geom_polygonIntersect(c, d, a, b));
        }
        c = d;
      }
      if (closed) subject.push(subject[0]);
      a = b;
    }
    return subject;
  };
  function d3_geom_polygonInside(p, a, b) {
    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
  }
  function d3_geom_polygonIntersect(c, d, a, b) {
    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
    return [ x1 + ua * x21, y1 + ua * y21 ];
  }
  function d3_geom_polygonClosed(coordinates) {
    var a = coordinates[0], b = coordinates[coordinates.length - 1];
    return !(a[0] - b[0] || a[1] - b[1]);
  }
  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
  function d3_geom_voronoiBeach() {
    d3_geom_voronoiRedBlackNode(this);
    this.edge = this.site = this.circle = null;
  }
  function d3_geom_voronoiCreateBeach(site) {
    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
    beach.site = site;
    return beach;
  }
  function d3_geom_voronoiDetachBeach(beach) {
    d3_geom_voronoiDetachCircle(beach);
    d3_geom_voronoiBeaches.remove(beach);
    d3_geom_voronoiBeachPool.push(beach);
    d3_geom_voronoiRedBlackNode(beach);
  }
  function d3_geom_voronoiRemoveBeach(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
      x: x,
      y: y
    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
    d3_geom_voronoiDetachBeach(beach);
    var lArc = previous;
    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
      previous = lArc.P;
      disappearing.unshift(lArc);
      d3_geom_voronoiDetachBeach(lArc);
      lArc = previous;
    }
    disappearing.unshift(lArc);
    d3_geom_voronoiDetachCircle(lArc);
    var rArc = next;
    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
      next = rArc.N;
      disappearing.push(rArc);
      d3_geom_voronoiDetachBeach(rArc);
      rArc = next;
    }
    disappearing.push(rArc);
    d3_geom_voronoiDetachCircle(rArc);
    var nArcs = disappearing.length, iArc;
    for (iArc = 1; iArc < nArcs; ++iArc) {
      rArc = disappearing[iArc];
      lArc = disappearing[iArc - 1];
      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiAddBeach(site) {
    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
    while (node) {
      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
      if (dxl > ε) node = node.L; else {
        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
        if (dxr > ε) {
          if (!node.R) {
            lArc = node;
            break;
          }
          node = node.R;
        } else {
          if (dxl > -ε) {
            lArc = node.P;
            rArc = node;
          } else if (dxr > -ε) {
            lArc = node;
            rArc = node.N;
          } else {
            lArc = rArc = node;
          }
          break;
        }
      }
    }
    var newArc = d3_geom_voronoiCreateBeach(site);
    d3_geom_voronoiBeaches.insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
      d3_geom_voronoiDetachCircle(lArc);
      rArc = d3_geom_voronoiCreateBeach(lArc.site);
      d3_geom_voronoiBeaches.insert(newArc, rArc);
      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      d3_geom_voronoiAttachCircle(lArc);
      d3_geom_voronoiAttachCircle(rArc);
      return;
    }
    if (!rArc) {
      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      return;
    }
    d3_geom_voronoiDetachCircle(lArc);
    d3_geom_voronoiDetachCircle(rArc);
    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
      x: (cy * hb - by * hc) / d + ax,
      y: (bx * hc - cx * hb) / d + ay
    };
    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
  }
  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site.y === directrix ? site.x : Infinity;
  }
  function d3_geom_voronoiCell(site) {
    this.site = site;
    this.edges = [];
  }
  d3_geom_voronoiCell.prototype.prepare = function() {
    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
    while (iHalfEdge--) {
      edge = halfEdges[iHalfEdge].edge;
      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
    }
    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
    return halfEdges.length;
  };
  function d3_geom_voronoiCloseCells(extent) {
    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
    while (iCell--) {
      cell = cells[iCell];
      if (!cell || !cell.prepare()) continue;
      halfEdges = cell.edges;
      nHalfEdges = halfEdges.length;
      iHalfEdge = 0;
      while (iHalfEdge < nHalfEdges) {
        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
            x: x0,
            y: abs(x2 - x0) < ε ? y2 : y1
          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
            x: abs(y2 - y1) < ε ? x2 : x1,
            y: y1
          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
            x: x1,
            y: abs(x2 - x1) < ε ? y2 : y0
          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
            x: abs(y2 - y0) < ε ? x2 : x0,
            y: y0
          } : null), cell.site, null));
          ++nHalfEdges;
        }
      }
    }
  }
  function d3_geom_voronoiHalfEdgeOrder(a, b) {
    return b.angle - a.angle;
  }
  function d3_geom_voronoiCircle() {
    d3_geom_voronoiRedBlackNode(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
  }
  function d3_geom_voronoiAttachCircle(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -ε2) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = cy + Math.sqrt(x * x + y * y);
    circle.cy = cy;
    arc.circle = circle;
    var before = null, node = d3_geom_voronoiCircles._;
    while (node) {
      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
        if (node.L) node = node.L; else {
          before = node.P;
          break;
        }
      } else {
        if (node.R) node = node.R; else {
          before = node;
          break;
        }
      }
    }
    d3_geom_voronoiCircles.insert(before, circle);
    if (!before) d3_geom_voronoiFirstCircle = circle;
  }
  function d3_geom_voronoiDetachCircle(arc) {
    var circle = arc.circle;
    if (circle) {
      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
      d3_geom_voronoiCircles.remove(circle);
      d3_geom_voronoiCirclePool.push(circle);
      d3_geom_voronoiRedBlackNode(circle);
      arc.circle = null;
    }
  }
  function d3_geom_voronoiClipEdges(extent) {
    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
    while (i--) {
      e = edges[i];
      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
        e.a = e.b = null;
        edges.splice(i, 1);
      }
    }
  }
  function d3_geom_voronoiConnectEdge(edge, extent) {
    var vb = edge.b;
    if (vb) return true;
    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
      if (fx < x0 || fx >= x1) return;
      if (lx > rx) {
        if (!va) va = {
          x: fx,
          y: y0
        }; else if (va.y >= y1) return;
        vb = {
          x: fx,
          y: y1
        };
      } else {
        if (!va) va = {
          x: fx,
          y: y1
        }; else if (va.y < y0) return;
        vb = {
          x: fx,
          y: y0
        };
      }
    } else {
      fm = (lx - rx) / (ry - ly);
      fb = fy - fm * fx;
      if (fm < -1 || fm > 1) {
        if (lx > rx) {
          if (!va) va = {
            x: (y0 - fb) / fm,
            y: y0
          }; else if (va.y >= y1) return;
          vb = {
            x: (y1 - fb) / fm,
            y: y1
          };
        } else {
          if (!va) va = {
            x: (y1 - fb) / fm,
            y: y1
          }; else if (va.y < y0) return;
          vb = {
            x: (y0 - fb) / fm,
            y: y0
          };
        }
      } else {
        if (ly < ry) {
          if (!va) va = {
            x: x0,
            y: fm * x0 + fb
          }; else if (va.x >= x1) return;
          vb = {
            x: x1,
            y: fm * x1 + fb
          };
        } else {
          if (!va) va = {
            x: x1,
            y: fm * x1 + fb
          }; else if (va.x < x0) return;
          vb = {
            x: x0,
            y: fm * x0 + fb
          };
        }
      }
    }
    edge.a = va;
    edge.b = vb;
    return true;
  }
  function d3_geom_voronoiEdge(lSite, rSite) {
    this.l = lSite;
    this.r = rSite;
    this.a = this.b = null;
  }
  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, rSite);
    d3_geom_voronoiEdges.push(edge);
    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
    return edge;
  }
  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, null);
    edge.a = va;
    edge.b = vb;
    d3_geom_voronoiEdges.push(edge);
    return edge;
  }
  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
    if (!edge.a && !edge.b) {
      edge.a = vertex;
      edge.l = lSite;
      edge.r = rSite;
    } else if (edge.l === rSite) {
      edge.b = vertex;
    } else {
      edge.a = vertex;
    }
  }
  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
    var va = edge.a, vb = edge.b;
    this.edge = edge;
    this.site = lSite;
    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
  }
  d3_geom_voronoiHalfEdge.prototype = {
    start: function() {
      return this.edge.l === this.site ? this.edge.a : this.edge.b;
    },
    end: function() {
      return this.edge.l === this.site ? this.edge.b : this.edge.a;
    }
  };
  function d3_geom_voronoiRedBlackTree() {
    this._ = null;
  }
  function d3_geom_voronoiRedBlackNode(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null;
  }
  d3_geom_voronoiRedBlackTree.prototype = {
    insert: function(after, node) {
      var parent, grandpa, uncle;
      if (after) {
        node.P = after;
        node.N = after.N;
        if (after.N) after.N.P = node;
        after.N = node;
        if (after.R) {
          after = after.R;
          while (after.L) after = after.L;
          after.L = node;
        } else {
          after.R = node;
        }
        parent = after;
      } else if (this._) {
        after = d3_geom_voronoiRedBlackFirst(this._);
        node.P = null;
        node.N = after;
        after.P = after.L = node;
        parent = after;
      } else {
        node.P = node.N = null;
        this._ = node;
        parent = null;
      }
      node.L = node.R = null;
      node.U = parent;
      node.C = true;
      after = node;
      while (parent && parent.C) {
        grandpa = parent.U;
        if (parent === grandpa.L) {
          uncle = grandpa.R;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.R) {
              d3_geom_voronoiRedBlackRotateLeft(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
          }
        } else {
          uncle = grandpa.L;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.L) {
              d3_geom_voronoiRedBlackRotateRight(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
          }
        }
        parent = after.U;
      }
      this._.C = false;
    },
    remove: function(node) {
      if (node.N) node.N.P = node.P;
      if (node.P) node.P.N = node.N;
      node.N = node.P = null;
      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
      if (parent) {
        if (parent.L === node) parent.L = next; else parent.R = next;
      } else {
        this._ = next;
      }
      if (left && right) {
        red = next.C;
        next.C = node.C;
        next.L = left;
        left.U = next;
        if (next !== right) {
          parent = next.U;
          next.U = node.U;
          node = next.R;
          parent.L = node;
          next.R = right;
          right.U = next;
        } else {
          next.U = parent;
          parent = next;
          node = next.R;
        }
      } else {
        red = node.C;
        node = next;
      }
      if (node) node.U = parent;
      if (red) return;
      if (node && node.C) {
        node.C = false;
        return;
      }
      do {
        if (node === this._) break;
        if (node === parent.L) {
          sibling = parent.R;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            sibling = parent.R;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.R || !sibling.R.C) {
              sibling.L.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateRight(this, sibling);
              sibling = parent.R;
            }
            sibling.C = parent.C;
            parent.C = sibling.R.C = false;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            node = this._;
            break;
          }
        } else {
          sibling = parent.L;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            sibling = parent.L;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.L || !sibling.L.C) {
              sibling.R.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
              sibling = parent.L;
            }
            sibling.C = parent.C;
            parent.C = sibling.L.C = false;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            node = this._;
            break;
          }
        }
        sibling.C = true;
        node = parent;
        parent = parent.U;
      } while (!node.C);
      if (node) node.C = false;
    }
  };
  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
  }
  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
  }
  function d3_geom_voronoiRedBlackFirst(node) {
    while (node.L) node = node.L;
    return node;
  }
  function d3_geom_voronoi(sites, bbox) {
    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
    d3_geom_voronoiEdges = [];
    d3_geom_voronoiCells = new Array(sites.length);
    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
    while (true) {
      circle = d3_geom_voronoiFirstCircle;
      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
        if (site.x !== x0 || site.y !== y0) {
          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
          d3_geom_voronoiAddBeach(site);
          x0 = site.x, y0 = site.y;
        }
        site = sites.pop();
      } else if (circle) {
        d3_geom_voronoiRemoveBeach(circle.arc);
      } else {
        break;
      }
    }
    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
    var diagram = {
      cells: d3_geom_voronoiCells,
      edges: d3_geom_voronoiEdges
    };
    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
    return diagram;
  }
  function d3_geom_voronoiVertexOrder(a, b) {
    return b.y - a.y || b.x - a.x;
  }
  d3.geom.voronoi = function(points) {
    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
    if (points) return voronoi(points);
    function voronoi(data) {
      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
          var s = e.start();
          return [ s.x, s.y ];
        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
        polygon.point = data[i];
      });
      return polygons;
    }
    function sites(data) {
      return data.map(function(d, i) {
        return {
          x: Math.round(fx(d, i) / ε) * ε,
          y: Math.round(fy(d, i) / ε) * ε,
          i: i
        };
      });
    }
    voronoi.links = function(data) {
      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
        return edge.l && edge.r;
      }).map(function(edge) {
        return {
          source: data[edge.l.i],
          target: data[edge.r.i]
        };
      });
    };
    voronoi.triangles = function(data) {
      var triangles = [];
      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
        while (++j < m) {
          e0 = e1;
          s0 = s1;
          e1 = edges[j].edge;
          s1 = e1.l === site ? e1.r : e1.l;
          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
          }
        }
      });
      return triangles;
    };
    voronoi.x = function(_) {
      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
    };
    voronoi.y = function(_) {
      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
    };
    voronoi.clipExtent = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
      return voronoi;
    };
    voronoi.size = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
    };
    return voronoi;
  };
  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
  function d3_geom_voronoiTriangleArea(a, b, c) {
    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
  }
  d3.geom.delaunay = function(vertices) {
    return d3.geom.voronoi().triangles(vertices);
  };
  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
    if (compat = arguments.length) {
      x = d3_geom_quadtreeCompatX;
      y = d3_geom_quadtreeCompatY;
      if (compat === 3) {
        y2 = y1;
        x2 = x1;
        y1 = x1 = 0;
      }
      return quadtree(points);
    }
    function quadtree(data) {
      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
      if (x1 != null) {
        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
      } else {
        x2_ = y2_ = -(x1_ = y1_ = Infinity);
        xs = [], ys = [];
        n = data.length;
        if (compat) for (i = 0; i < n; ++i) {
          d = data[i];
          if (d.x < x1_) x1_ = d.x;
          if (d.y < y1_) y1_ = d.y;
          if (d.x > x2_) x2_ = d.x;
          if (d.y > y2_) y2_ = d.y;
          xs.push(d.x);
          ys.push(d.y);
        } else for (i = 0; i < n; ++i) {
          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
          if (x_ < x1_) x1_ = x_;
          if (y_ < y1_) y1_ = y_;
          if (x_ > x2_) x2_ = x_;
          if (y_ > y2_) y2_ = y_;
          xs.push(x_);
          ys.push(y_);
        }
      }
      var dx = x2_ - x1_, dy = y2_ - y1_;
      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
      function insert(n, d, x, y, x1, y1, x2, y2) {
        if (isNaN(x) || isNaN(y)) return;
        if (n.leaf) {
          var nx = n.x, ny = n.y;
          if (nx != null) {
            if (abs(nx - x) + abs(ny - y) < .01) {
              insertChild(n, d, x, y, x1, y1, x2, y2);
            } else {
              var nPoint = n.point;
              n.x = n.y = n.point = null;
              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
              insertChild(n, d, x, y, x1, y1, x2, y2);
            }
          } else {
            n.x = x, n.y = y, n.point = d;
          }
        } else {
          insertChild(n, d, x, y, x1, y1, x2, y2);
        }
      }
      function insertChild(n, d, x, y, x1, y1, x2, y2) {
        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
        n.leaf = false;
        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
        if (right) x1 = xm; else x2 = xm;
        if (below) y1 = ym; else y2 = ym;
        insert(n, d, x, y, x1, y1, x2, y2);
      }
      var root = d3_geom_quadtreeNode();
      root.add = function(d) {
        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
      };
      root.visit = function(f) {
        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
      };
      root.find = function(point) {
        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
      };
      i = -1;
      if (x1 == null) {
        while (++i < n) {
          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
        }
        --i;
      } else data.forEach(root.add);
      xs = ys = data = d = null;
      return root;
    }
    quadtree.x = function(_) {
      return arguments.length ? (x = _, quadtree) : x;
    };
    quadtree.y = function(_) {
      return arguments.length ? (y = _, quadtree) : y;
    };
    quadtree.extent = function(_) {
      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
      y2 = +_[1][1];
      return quadtree;
    };
    quadtree.size = function(_) {
      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
      return quadtree;
    };
    return quadtree;
  };
  function d3_geom_quadtreeCompatX(d) {
    return d.x;
  }
  function d3_geom_quadtreeCompatY(d) {
    return d.y;
  }
  function d3_geom_quadtreeNode() {
    return {
      leaf: true,
      nodes: [],
      point: null,
      x: null,
      y: null
    };
  }
  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
    if (!f(node, x1, y1, x2, y2)) {
      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
    }
  }
  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
    var minDistance2 = Infinity, closestPoint;
    (function find(node, x1, y1, x2, y2) {
      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
      if (point = node.point) {
        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
        if (distance2 < minDistance2) {
          var distance = Math.sqrt(minDistance2 = distance2);
          x0 = x - distance, y0 = y - distance;
          x3 = x + distance, y3 = y + distance;
          closestPoint = point;
        }
      }
      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
        if (node = children[i & 3]) switch (i & 3) {
         case 0:
          find(node, x1, y1, xm, ym);
          break;

         case 1:
          find(node, xm, y1, x2, ym);
          break;

         case 2:
          find(node, x1, ym, xm, y2);
          break;

         case 3:
          find(node, xm, ym, x2, y2);
          break;
        }
      }
    })(root, x0, y0, x3, y3);
    return closestPoint;
  }
  d3.interpolateRgb = d3_interpolateRgb;
  function d3_interpolateRgb(a, b) {
    a = d3.rgb(a);
    b = d3.rgb(b);
    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
    return function(t) {
      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
    };
  }
  d3.interpolateObject = d3_interpolateObject;
  function d3_interpolateObject(a, b) {
    var i = {}, c = {}, k;
    for (k in a) {
      if (k in b) {
        i[k] = d3_interpolate(a[k], b[k]);
      } else {
        c[k] = a[k];
      }
    }
    for (k in b) {
      if (!(k in a)) {
        c[k] = b[k];
      }
    }
    return function(t) {
      for (k in i) c[k] = i[k](t);
      return c;
    };
  }
  d3.interpolateNumber = d3_interpolateNumber;
  function d3_interpolateNumber(a, b) {
    a = +a, b = +b;
    return function(t) {
      return a * (1 - t) + b * t;
    };
  }
  d3.interpolateString = d3_interpolateString;
  function d3_interpolateString(a, b) {
    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
    a = a + "", b = b + "";
    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
      if ((bs = bm.index) > bi) {
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs; else s[++i] = bs;
      }
      if ((am = am[0]) === (bm = bm[0])) {
        if (s[i]) s[i] += bm; else s[++i] = bm;
      } else {
        s[++i] = null;
        q.push({
          i: i,
          x: d3_interpolateNumber(am, bm)
        });
      }
      bi = d3_interpolate_numberB.lastIndex;
    }
    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs; else s[++i] = bs;
    }
    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
      return b(t) + "";
    }) : function() {
      return b;
    } : (b = q.length, function(t) {
      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    });
  }
  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
  d3.interpolate = d3_interpolate;
  function d3_interpolate(a, b) {
    var i = d3.interpolators.length, f;
    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
    return f;
  }
  d3.interpolators = [ function(a, b) {
    var t = typeof b;
    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
  } ];
  d3.interpolateArray = d3_interpolateArray;
  function d3_interpolateArray(a, b) {
    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
    for (;i < na; ++i) c[i] = a[i];
    for (;i < nb; ++i) c[i] = b[i];
    return function(t) {
      for (i = 0; i < n0; ++i) c[i] = x[i](t);
      return c;
    };
  }
  var d3_ease_default = function() {
    return d3_identity;
  };
  var d3_ease = d3.map({
    linear: d3_ease_default,
    poly: d3_ease_poly,
    quad: function() {
      return d3_ease_quad;
    },
    cubic: function() {
      return d3_ease_cubic;
    },
    sin: function() {
      return d3_ease_sin;
    },
    exp: function() {
      return d3_ease_exp;
    },
    circle: function() {
      return d3_ease_circle;
    },
    elastic: d3_ease_elastic,
    back: d3_ease_back,
    bounce: function() {
      return d3_ease_bounce;
    }
  });
  var d3_ease_mode = d3.map({
    "in": d3_identity,
    out: d3_ease_reverse,
    "in-out": d3_ease_reflect,
    "out-in": function(f) {
      return d3_ease_reflect(d3_ease_reverse(f));
    }
  });
  d3.ease = function(name) {
    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
    t = d3_ease.get(t) || d3_ease_default;
    m = d3_ease_mode.get(m) || d3_identity;
    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
  };
  function d3_ease_clamp(f) {
    return function(t) {
      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
    };
  }
  function d3_ease_reverse(f) {
    return function(t) {
      return 1 - f(1 - t);
    };
  }
  function d3_ease_reflect(f) {
    return function(t) {
      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
    };
  }
  function d3_ease_quad(t) {
    return t * t;
  }
  function d3_ease_cubic(t) {
    return t * t * t;
  }
  function d3_ease_cubicInOut(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    var t2 = t * t, t3 = t2 * t;
    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
  }
  function d3_ease_poly(e) {
    return function(t) {
      return Math.pow(t, e);
    };
  }
  function d3_ease_sin(t) {
    return 1 - Math.cos(t * halfπ);
  }
  function d3_ease_exp(t) {
    return Math.pow(2, 10 * (t - 1));
  }
  function d3_ease_circle(t) {
    return 1 - Math.sqrt(1 - t * t);
  }
  function d3_ease_elastic(a, p) {
    var s;
    if (arguments.length < 2) p = .45;
    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
    return function(t) {
      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
    };
  }
  function d3_ease_back(s) {
    if (!s) s = 1.70158;
    return function(t) {
      return t * t * ((s + 1) * t - s);
    };
  }
  function d3_ease_bounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
  }
  d3.interpolateHcl = d3_interpolateHcl;
  function d3_interpolateHcl(a, b) {
    a = d3.hcl(a);
    b = d3.hcl(b);
    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
    };
  }
  d3.interpolateHsl = d3_interpolateHsl;
  function d3_interpolateHsl(a, b) {
    a = d3.hsl(a);
    b = d3.hsl(b);
    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
    };
  }
  d3.interpolateLab = d3_interpolateLab;
  function d3_interpolateLab(a, b) {
    a = d3.lab(a);
    b = d3.lab(b);
    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
    return function(t) {
      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
    };
  }
  d3.interpolateRound = d3_interpolateRound;
  function d3_interpolateRound(a, b) {
    b -= a;
    return function(t) {
      return Math.round(a + b * t);
    };
  }
  d3.transform = function(string) {
    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
    return (d3.transform = function(string) {
      if (string != null) {
        g.setAttribute("transform", string);
        var t = g.transform.baseVal.consolidate();
      }
      return new d3_transform(t ? t.matrix : d3_transformIdentity);
    })(string);
  };
  function d3_transform(m) {
    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
    if (r0[0] * r1[1] < r1[0] * r0[1]) {
      r0[0] *= -1;
      r0[1] *= -1;
      kx *= -1;
      kz *= -1;
    }
    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
    this.translate = [ m.e, m.f ];
    this.scale = [ kx, ky ];
    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
  }
  d3_transform.prototype.toString = function() {
    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
  };
  function d3_transformDot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
  }
  function d3_transformNormalize(a) {
    var k = Math.sqrt(d3_transformDot(a, a));
    if (k) {
      a[0] /= k;
      a[1] /= k;
    }
    return k;
  }
  function d3_transformCombine(a, b, k) {
    a[0] += k * b[0];
    a[1] += k * b[1];
    return a;
  }
  var d3_transformIdentity = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
  };
  d3.interpolateTransform = d3_interpolateTransform;
  function d3_interpolateTransformPop(s) {
    return s.length ? s.pop() + "," : "";
  }
  function d3_interpolateTranslate(ta, tb, s, q) {
    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
      var i = s.push("translate(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ta[0], tb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ta[1], tb[1])
      });
    } else if (tb[0] || tb[1]) {
      s.push("translate(" + tb + ")");
    }
  }
  function d3_interpolateRotate(ra, rb, s, q) {
    if (ra !== rb) {
      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
        x: d3_interpolateNumber(ra, rb)
      });
    } else if (rb) {
      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
    }
  }
  function d3_interpolateSkew(wa, wb, s, q) {
    if (wa !== wb) {
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
        x: d3_interpolateNumber(wa, wb)
      });
    } else if (wb) {
      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
    }
  }
  function d3_interpolateScale(ka, kb, s, q) {
    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ka[0], kb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ka[1], kb[1])
      });
    } else if (kb[0] !== 1 || kb[1] !== 1) {
      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
    }
  }
  function d3_interpolateTransform(a, b) {
    var s = [], q = [];
    a = d3.transform(a), b = d3.transform(b);
    d3_interpolateTranslate(a.translate, b.translate, s, q);
    d3_interpolateRotate(a.rotate, b.rotate, s, q);
    d3_interpolateSkew(a.skew, b.skew, s, q);
    d3_interpolateScale(a.scale, b.scale, s, q);
    a = b = null;
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  }
  function d3_uninterpolateNumber(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return (x - a) / b;
    };
  }
  function d3_uninterpolateClamp(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return Math.max(0, Math.min(1, (x - a) / b));
    };
  }
  d3.layout = {};
  d3.layout.bundle = function() {
    return function(links) {
      var paths = [], i = -1, n = links.length;
      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
      return paths;
    };
  };
  function d3_layout_bundlePath(link) {
    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
    while (start !== lca) {
      start = start.parent;
      points.push(start);
    }
    var k = points.length;
    while (end !== lca) {
      points.splice(k, 0, end);
      end = end.parent;
    }
    return points;
  }
  function d3_layout_bundleAncestors(node) {
    var ancestors = [], parent = node.parent;
    while (parent != null) {
      ancestors.push(node);
      node = parent;
      parent = parent.parent;
    }
    ancestors.push(node);
    return ancestors;
  }
  function d3_layout_bundleLeastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
    while (aNode === bNode) {
      sharedNode = aNode;
      aNode = aNodes.pop();
      bNode = bNodes.pop();
    }
    return sharedNode;
  }
  d3.layout.chord = function() {
    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
    function relayout() {
      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
      chords = [];
      groups = [];
      k = 0, i = -1;
      while (++i < n) {
        x = 0, j = -1;
        while (++j < n) {
          x += matrix[i][j];
        }
        groupSums.push(x);
        subgroupIndex.push(d3.range(n));
        k += x;
      }
      if (sortGroups) {
        groupIndex.sort(function(a, b) {
          return sortGroups(groupSums[a], groupSums[b]);
        });
      }
      if (sortSubgroups) {
        subgroupIndex.forEach(function(d, i) {
          d.sort(function(a, b) {
            return sortSubgroups(matrix[i][a], matrix[i][b]);
          });
        });
      }
      k = (τ - padding * n) / k;
      x = 0, i = -1;
      while (++i < n) {
        x0 = x, j = -1;
        while (++j < n) {
          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
          subgroups[di + "-" + dj] = {
            index: di,
            subindex: dj,
            startAngle: a0,
            endAngle: a1,
            value: v
          };
        }
        groups[di] = {
          index: di,
          startAngle: x0,
          endAngle: x,
          value: groupSums[di]
        };
        x += padding;
      }
      i = -1;
      while (++i < n) {
        j = i - 1;
        while (++j < n) {
          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
          if (source.value || target.value) {
            chords.push(source.value < target.value ? {
              source: target,
              target: source
            } : {
              source: source,
              target: target
            });
          }
        }
      }
      if (sortChords) resort();
    }
    function resort() {
      chords.sort(function(a, b) {
        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
      });
    }
    chord.matrix = function(x) {
      if (!arguments.length) return matrix;
      n = (matrix = x) && matrix.length;
      chords = groups = null;
      return chord;
    };
    chord.padding = function(x) {
      if (!arguments.length) return padding;
      padding = x;
      chords = groups = null;
      return chord;
    };
    chord.sortGroups = function(x) {
      if (!arguments.length) return sortGroups;
      sortGroups = x;
      chords = groups = null;
      return chord;
    };
    chord.sortSubgroups = function(x) {
      if (!arguments.length) return sortSubgroups;
      sortSubgroups = x;
      chords = null;
      return chord;
    };
    chord.sortChords = function(x) {
      if (!arguments.length) return sortChords;
      sortChords = x;
      if (chords) resort();
      return chord;
    };
    chord.chords = function() {
      if (!chords) relayout();
      return chords;
    };
    chord.groups = function() {
      if (!groups) relayout();
      return groups;
    };
    return chord;
  };
  d3.layout.force = function() {
    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
    function repulse(node) {
      return function(quad, x1, _, x2) {
        if (quad.point !== node) {
          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
          if (dw * dw / theta2 < dn) {
            if (dn < chargeDistance2) {
              var k = quad.charge / dn;
              node.px -= dx * k;
              node.py -= dy * k;
            }
            return true;
          }
          if (quad.point && dn && dn < chargeDistance2) {
            var k = quad.pointCharge / dn;
            node.px -= dx * k;
            node.py -= dy * k;
          }
        }
        return !quad.charge;
      };
    }
    force.tick = function() {
      if ((alpha *= .99) < .005) {
        timer = null;
        event.end({
          type: "end",
          alpha: alpha = 0
        });
        return true;
      }
      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
      for (i = 0; i < m; ++i) {
        o = links[i];
        s = o.source;
        t = o.target;
        x = t.x - s.x;
        y = t.y - s.y;
        if (l = x * x + y * y) {
          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
          x *= l;
          y *= l;
          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
          t.y -= y * k;
          s.x += x * (k = 1 - k);
          s.y += y * k;
        }
      }
      if (k = alpha * gravity) {
        x = size[0] / 2;
        y = size[1] / 2;
        i = -1;
        if (k) while (++i < n) {
          o = nodes[i];
          o.x += (x - o.x) * k;
          o.y += (y - o.y) * k;
        }
      }
      if (charge) {
        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
        i = -1;
        while (++i < n) {
          if (!(o = nodes[i]).fixed) {
            q.visit(repulse(o));
          }
        }
      }
      i = -1;
      while (++i < n) {
        o = nodes[i];
        if (o.fixed) {
          o.x = o.px;
          o.y = o.py;
        } else {
          o.x -= (o.px - (o.px = o.x)) * friction;
          o.y -= (o.py - (o.py = o.y)) * friction;
        }
      }
      event.tick({
        type: "tick",
        alpha: alpha
      });
    };
    force.nodes = function(x) {
      if (!arguments.length) return nodes;
      nodes = x;
      return force;
    };
    force.links = function(x) {
      if (!arguments.length) return links;
      links = x;
      return force;
    };
    force.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return force;
    };
    force.linkDistance = function(x) {
      if (!arguments.length) return linkDistance;
      linkDistance = typeof x === "function" ? x : +x;
      return force;
    };
    force.distance = force.linkDistance;
    force.linkStrength = function(x) {
      if (!arguments.length) return linkStrength;
      linkStrength = typeof x === "function" ? x : +x;
      return force;
    };
    force.friction = function(x) {
      if (!arguments.length) return friction;
      friction = +x;
      return force;
    };
    force.charge = function(x) {
      if (!arguments.length) return charge;
      charge = typeof x === "function" ? x : +x;
      return force;
    };
    force.chargeDistance = function(x) {
      if (!arguments.length) return Math.sqrt(chargeDistance2);
      chargeDistance2 = x * x;
      return force;
    };
    force.gravity = function(x) {
      if (!arguments.length) return gravity;
      gravity = +x;
      return force;
    };
    force.theta = function(x) {
      if (!arguments.length) return Math.sqrt(theta2);
      theta2 = x * x;
      return force;
    };
    force.alpha = function(x) {
      if (!arguments.length) return alpha;
      x = +x;
      if (alpha) {
        if (x > 0) {
          alpha = x;
        } else {
          timer.c = null, timer.t = NaN, timer = null;
          event.end({
            type: "end",
            alpha: alpha = 0
          });
        }
      } else if (x > 0) {
        event.start({
          type: "start",
          alpha: alpha = x
        });
        timer = d3_timer(force.tick);
      }
      return force;
    };
    force.start = function() {
      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
      for (i = 0; i < n; ++i) {
        (o = nodes[i]).index = i;
        o.weight = 0;
      }
      for (i = 0; i < m; ++i) {
        o = links[i];
        if (typeof o.source == "number") o.source = nodes[o.source];
        if (typeof o.target == "number") o.target = nodes[o.target];
        ++o.source.weight;
        ++o.target.weight;
      }
      for (i = 0; i < n; ++i) {
        o = nodes[i];
        if (isNaN(o.x)) o.x = position("x", w);
        if (isNaN(o.y)) o.y = position("y", h);
        if (isNaN(o.px)) o.px = o.x;
        if (isNaN(o.py)) o.py = o.y;
      }
      distances = [];
      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
      strengths = [];
      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
      charges = [];
      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
      function position(dimension, size) {
        if (!neighbors) {
          neighbors = new Array(n);
          for (j = 0; j < n; ++j) {
            neighbors[j] = [];
          }
          for (j = 0; j < m; ++j) {
            var o = links[j];
            neighbors[o.source.index].push(o.target);
            neighbors[o.target.index].push(o.source);
          }
        }
        var candidates = neighbors[i], j = -1, l = candidates.length, x;
        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
        return Math.random() * size;
      }
      return force.resume();
    };
    force.resume = function() {
      return force.alpha(.1);
    };
    force.stop = function() {
      return force.alpha(0);
    };
    force.drag = function() {
      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
      if (!arguments.length) return drag;
      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
    };
    function dragmove(d) {
      d.px = d3.event.x, d.py = d3.event.y;
      force.resume();
    }
    return d3.rebind(force, event, "on");
  };
  function d3_layout_forceDragstart(d) {
    d.fixed |= 2;
  }
  function d3_layout_forceDragend(d) {
    d.fixed &= ~6;
  }
  function d3_layout_forceMouseover(d) {
    d.fixed |= 4;
    d.px = d.x, d.py = d.y;
  }
  function d3_layout_forceMouseout(d) {
    d.fixed &= ~4;
  }
  function d3_layout_forceAccumulate(quad, alpha, charges) {
    var cx = 0, cy = 0;
    quad.charge = 0;
    if (!quad.leaf) {
      var nodes = quad.nodes, n = nodes.length, i = -1, c;
      while (++i < n) {
        c = nodes[i];
        if (c == null) continue;
        d3_layout_forceAccumulate(c, alpha, charges);
        quad.charge += c.charge;
        cx += c.charge * c.cx;
        cy += c.charge * c.cy;
      }
    }
    if (quad.point) {
      if (!quad.leaf) {
        quad.point.x += Math.random() - .5;
        quad.point.y += Math.random() - .5;
      }
      var k = alpha * charges[quad.point.index];
      quad.charge += quad.pointCharge = k;
      cx += k * quad.point.x;
      cy += k * quad.point.y;
    }
    quad.cx = cx / quad.charge;
    quad.cy = cy / quad.charge;
  }
  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
  d3.layout.hierarchy = function() {
    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
    function hierarchy(root) {
      var stack = [ root ], nodes = [], node;
      root.depth = 0;
      while ((node = stack.pop()) != null) {
        nodes.push(node);
        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
          var n, childs, child;
          while (--n >= 0) {
            stack.push(child = childs[n]);
            child.parent = node;
            child.depth = node.depth + 1;
          }
          if (value) node.value = 0;
          node.children = childs;
        } else {
          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
          delete node.children;
        }
      }
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var childs, parent;
        if (sort && (childs = node.children)) childs.sort(sort);
        if (value && (parent = node.parent)) parent.value += node.value;
      });
      return nodes;
    }
    hierarchy.sort = function(x) {
      if (!arguments.length) return sort;
      sort = x;
      return hierarchy;
    };
    hierarchy.children = function(x) {
      if (!arguments.length) return children;
      children = x;
      return hierarchy;
    };
    hierarchy.value = function(x) {
      if (!arguments.length) return value;
      value = x;
      return hierarchy;
    };
    hierarchy.revalue = function(root) {
      if (value) {
        d3_layout_hierarchyVisitBefore(root, function(node) {
          if (node.children) node.value = 0;
        });
        d3_layout_hierarchyVisitAfter(root, function(node) {
          var parent;
          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
          if (parent = node.parent) parent.value += node.value;
        });
      }
      return root;
    };
    return hierarchy;
  };
  function d3_layout_hierarchyRebind(object, hierarchy) {
    d3.rebind(object, hierarchy, "sort", "children", "value");
    object.nodes = object;
    object.links = d3_layout_hierarchyLinks;
    return object;
  }
  function d3_layout_hierarchyVisitBefore(node, callback) {
    var nodes = [ node ];
    while ((node = nodes.pop()) != null) {
      callback(node);
      if ((children = node.children) && (n = children.length)) {
        var n, children;
        while (--n >= 0) nodes.push(children[n]);
      }
    }
  }
  function d3_layout_hierarchyVisitAfter(node, callback) {
    var nodes = [ node ], nodes2 = [];
    while ((node = nodes.pop()) != null) {
      nodes2.push(node);
      if ((children = node.children) && (n = children.length)) {
        var i = -1, n, children;
        while (++i < n) nodes.push(children[i]);
      }
    }
    while ((node = nodes2.pop()) != null) {
      callback(node);
    }
  }
  function d3_layout_hierarchyChildren(d) {
    return d.children;
  }
  function d3_layout_hierarchyValue(d) {
    return d.value;
  }
  function d3_layout_hierarchySort(a, b) {
    return b.value - a.value;
  }
  function d3_layout_hierarchyLinks(nodes) {
    return d3.merge(nodes.map(function(parent) {
      return (parent.children || []).map(function(child) {
        return {
          source: parent,
          target: child
        };
      });
    }));
  }
  d3.layout.partition = function() {
    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
    function position(node, x, dx, dy) {
      var children = node.children;
      node.x = x;
      node.y = node.depth * dy;
      node.dx = dx;
      node.dy = dy;
      if (children && (n = children.length)) {
        var i = -1, n, c, d;
        dx = node.value ? dx / node.value : 0;
        while (++i < n) {
          position(c = children[i], x, d = c.value * dx, dy);
          x += d;
        }
      }
    }
    function depth(node) {
      var children = node.children, d = 0;
      if (children && (n = children.length)) {
        var i = -1, n;
        while (++i < n) d = Math.max(d, depth(children[i]));
      }
      return 1 + d;
    }
    function partition(d, i) {
      var nodes = hierarchy.call(this, d, i);
      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
      return nodes;
    }
    partition.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return partition;
    };
    return d3_layout_hierarchyRebind(partition, hierarchy);
  };
  d3.layout.pie = function() {
    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
    function pie(data) {
      var n = data.length, values = data.map(function(d, i) {
        return +value.call(pie, d, i);
      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
        return values[j] - values[i];
      } : function(i, j) {
        return sort(data[i], data[j]);
      });
      index.forEach(function(i) {
        arcs[i] = {
          data: data[i],
          value: v = values[i],
          startAngle: a,
          endAngle: a += v * k + pa,
          padAngle: p
        };
      });
      return arcs;
    }
    pie.value = function(_) {
      if (!arguments.length) return value;
      value = _;
      return pie;
    };
    pie.sort = function(_) {
      if (!arguments.length) return sort;
      sort = _;
      return pie;
    };
    pie.startAngle = function(_) {
      if (!arguments.length) return startAngle;
      startAngle = _;
      return pie;
    };
    pie.endAngle = function(_) {
      if (!arguments.length) return endAngle;
      endAngle = _;
      return pie;
    };
    pie.padAngle = function(_) {
      if (!arguments.length) return padAngle;
      padAngle = _;
      return pie;
    };
    return pie;
  };
  var d3_layout_pieSortByValue = {};
  d3.layout.stack = function() {
    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
    function stack(data, index) {
      if (!(n = data.length)) return data;
      var series = data.map(function(d, i) {
        return values.call(stack, d, i);
      });
      var points = series.map(function(d) {
        return d.map(function(v, i) {
          return [ x.call(stack, v, i), y.call(stack, v, i) ];
        });
      });
      var orders = order.call(stack, points, index);
      series = d3.permute(series, orders);
      points = d3.permute(points, orders);
      var offsets = offset.call(stack, points, index);
      var m = series[0].length, n, i, j, o;
      for (j = 0; j < m; ++j) {
        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
        for (i = 1; i < n; ++i) {
          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
        }
      }
      return data;
    }
    stack.values = function(x) {
      if (!arguments.length) return values;
      values = x;
      return stack;
    };
    stack.order = function(x) {
      if (!arguments.length) return order;
      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
      return stack;
    };
    stack.offset = function(x) {
      if (!arguments.length) return offset;
      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
      return stack;
    };
    stack.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      return stack;
    };
    stack.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      return stack;
    };
    stack.out = function(z) {
      if (!arguments.length) return out;
      out = z;
      return stack;
    };
    return stack;
  };
  function d3_layout_stackX(d) {
    return d.x;
  }
  function d3_layout_stackY(d) {
    return d.y;
  }
  function d3_layout_stackOut(d, y0, y) {
    d.y0 = y0;
    d.y = y;
  }
  var d3_layout_stackOrders = d3.map({
    "inside-out": function(data) {
      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
        return max[a] - max[b];
      }), top = 0, bottom = 0, tops = [], bottoms = [];
      for (i = 0; i < n; ++i) {
        j = index[i];
        if (top < bottom) {
          top += sums[j];
          tops.push(j);
        } else {
          bottom += sums[j];
          bottoms.push(j);
        }
      }
      return bottoms.reverse().concat(tops);
    },
    reverse: function(data) {
      return d3.range(data.length).reverse();
    },
    "default": d3_layout_stackOrderDefault
  });
  var d3_layout_stackOffsets = d3.map({
    silhouette: function(data) {
      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o > max) max = o;
        sums.push(o);
      }
      for (j = 0; j < m; ++j) {
        y0[j] = (max - sums[j]) / 2;
      }
      return y0;
    },
    wiggle: function(data) {
      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
      y0[0] = o = o0 = 0;
      for (j = 1; j < m; ++j) {
        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
          }
          s2 += s3 * data[i][j][1];
        }
        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
        if (o < o0) o0 = o;
      }
      for (j = 0; j < m; ++j) y0[j] -= o0;
      return y0;
    },
    expand: function(data) {
      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
      }
      for (j = 0; j < m; ++j) y0[j] = 0;
      return y0;
    },
    zero: d3_layout_stackOffsetZero
  });
  function d3_layout_stackOrderDefault(data) {
    return d3.range(data.length);
  }
  function d3_layout_stackOffsetZero(data) {
    var j = -1, m = data[0].length, y0 = [];
    while (++j < m) y0[j] = 0;
    return y0;
  }
  function d3_layout_stackMaxIndex(array) {
    var i = 1, j = 0, v = array[0][1], k, n = array.length;
    for (;i < n; ++i) {
      if ((k = array[i][1]) > v) {
        j = i;
        v = k;
      }
    }
    return j;
  }
  function d3_layout_stackReduceSum(d) {
    return d.reduce(d3_layout_stackSum, 0);
  }
  function d3_layout_stackSum(p, d) {
    return p + d[1];
  }
  d3.layout.histogram = function() {
    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
    function histogram(data, i) {
      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
      while (++i < m) {
        bin = bins[i] = [];
        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
        bin.y = 0;
      }
      if (m > 0) {
        i = -1;
        while (++i < n) {
          x = values[i];
          if (x >= range[0] && x <= range[1]) {
            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
            bin.y += k;
            bin.push(data[i]);
          }
        }
      }
      return bins;
    }
    histogram.value = function(x) {
      if (!arguments.length) return valuer;
      valuer = x;
      return histogram;
    };
    histogram.range = function(x) {
      if (!arguments.length) return ranger;
      ranger = d3_functor(x);
      return histogram;
    };
    histogram.bins = function(x) {
      if (!arguments.length) return binner;
      binner = typeof x === "number" ? function(range) {
        return d3_layout_histogramBinFixed(range, x);
      } : d3_functor(x);
      return histogram;
    };
    histogram.frequency = function(x) {
      if (!arguments.length) return frequency;
      frequency = !!x;
      return histogram;
    };
    return histogram;
  };
  function d3_layout_histogramBinSturges(range, values) {
    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
  }
  function d3_layout_histogramBinFixed(range, n) {
    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
    while (++x <= n) f[x] = m * x + b;
    return f;
  }
  function d3_layout_histogramRange(values) {
    return [ d3.min(values), d3.max(values) ];
  }
  d3.layout.pack = function() {
    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
    function pack(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
        return radius;
      };
      root.x = root.y = 0;
      d3_layout_hierarchyVisitAfter(root, function(d) {
        d.r = +r(d.value);
      });
      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
      if (padding) {
        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r += dr;
        });
        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r -= dr;
        });
      }
      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
      return nodes;
    }
    pack.size = function(_) {
      if (!arguments.length) return size;
      size = _;
      return pack;
    };
    pack.radius = function(_) {
      if (!arguments.length) return radius;
      radius = _ == null || typeof _ === "function" ? _ : +_;
      return pack;
    };
    pack.padding = function(_) {
      if (!arguments.length) return padding;
      padding = +_;
      return pack;
    };
    return d3_layout_hierarchyRebind(pack, hierarchy);
  };
  function d3_layout_packSort(a, b) {
    return a.value - b.value;
  }
  function d3_layout_packInsert(a, b) {
    var c = a._pack_next;
    a._pack_next = b;
    b._pack_prev = a;
    b._pack_next = c;
    c._pack_prev = b;
  }
  function d3_layout_packSplice(a, b) {
    a._pack_next = b;
    b._pack_prev = a;
  }
  function d3_layout_packIntersects(a, b) {
    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
    return .999 * dr * dr > dx * dx + dy * dy;
  }
  function d3_layout_packSiblings(node) {
    if (!(nodes = node.children) || !(n = nodes.length)) return;
    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
    function bound(node) {
      xMin = Math.min(node.x - node.r, xMin);
      xMax = Math.max(node.x + node.r, xMax);
      yMin = Math.min(node.y - node.r, yMin);
      yMax = Math.max(node.y + node.r, yMax);
    }
    nodes.forEach(d3_layout_packLink);
    a = nodes[0];
    a.x = -a.r;
    a.y = 0;
    bound(a);
    if (n > 1) {
      b = nodes[1];
      b.x = b.r;
      b.y = 0;
      bound(b);
      if (n > 2) {
        c = nodes[2];
        d3_layout_packPlace(a, b, c);
        bound(c);
        d3_layout_packInsert(a, c);
        a._pack_prev = c;
        d3_layout_packInsert(c, b);
        b = a._pack_next;
        for (i = 3; i < n; i++) {
          d3_layout_packPlace(a, b, c = nodes[i]);
          var isect = 0, s1 = 1, s2 = 1;
          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
            if (d3_layout_packIntersects(j, c)) {
              isect = 1;
              break;
            }
          }
          if (isect == 1) {
            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
              if (d3_layout_packIntersects(k, c)) {
                break;
              }
            }
          }
          if (isect) {
            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
            i--;
          } else {
            d3_layout_packInsert(a, c);
            b = c;
            bound(c);
          }
        }
      }
    }
    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
    for (i = 0; i < n; i++) {
      c = nodes[i];
      c.x -= cx;
      c.y -= cy;
      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
    }
    node.r = cr;
    nodes.forEach(d3_layout_packUnlink);
  }
  function d3_layout_packLink(node) {
    node._pack_next = node._pack_prev = node;
  }
  function d3_layout_packUnlink(node) {
    delete node._pack_next;
    delete node._pack_prev;
  }
  function d3_layout_packTransform(node, x, y, k) {
    var children = node.children;
    node.x = x += k * node.x;
    node.y = y += k * node.y;
    node.r *= k;
    if (children) {
      var i = -1, n = children.length;
      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
    }
  }
  function d3_layout_packPlace(a, b, c) {
    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
    if (db && (dx || dy)) {
      var da = b.r + c.r, dc = dx * dx + dy * dy;
      da *= da;
      db *= db;
      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
      c.x = a.x + x * dx + y * dy;
      c.y = a.y + x * dy - y * dx;
    } else {
      c.x = a.x + db;
      c.y = a.y;
    }
  }
  d3.layout.tree = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
    function tree(d, i) {
      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
      d3_layout_hierarchyVisitBefore(root1, secondWalk);
      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
        var left = root0, right = root0, bottom = root0;
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          if (node.x < left.x) left = node;
          if (node.x > right.x) right = node;
          if (node.depth > bottom.depth) bottom = node;
        });
        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          node.x = (node.x + tx) * kx;
          node.y = node.depth * ky;
        });
      }
      return nodes;
    }
    function wrapTree(root0) {
      var root1 = {
        A: null,
        children: [ root0 ]
      }, queue = [ root1 ], node1;
      while ((node1 = queue.pop()) != null) {
        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
          queue.push((children[i] = child = {
            _: children[i],
            parent: node1,
            children: (child = children[i].children) && child.slice() || [],
            A: null,
            a: null,
            z: 0,
            m: 0,
            c: 0,
            s: 0,
            t: null,
            i: i
          }).a = child);
        }
      }
      return root1.children[0];
    }
    function firstWalk(v) {
      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
      if (children.length) {
        d3_layout_treeShift(v);
        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
        if (w) {
          v.z = w.z + separation(v._, w._);
          v.m = v.z - midpoint;
        } else {
          v.z = midpoint;
        }
      } else if (w) {
        v.z = w.z + separation(v._, w._);
      }
      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    function secondWalk(v) {
      v._.x = v.z + v.parent.m;
      v.m += v.parent.m;
    }
    function apportion(v, w, ancestor) {
      if (w) {
        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
          vom = d3_layout_treeLeft(vom);
          vop = d3_layout_treeRight(vop);
          vop.a = v;
          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
          if (shift > 0) {
            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
            sip += shift;
            sop += shift;
          }
          sim += vim.m;
          sip += vip.m;
          som += vom.m;
          sop += vop.m;
        }
        if (vim && !d3_layout_treeRight(vop)) {
          vop.t = vim;
          vop.m += sim - sop;
        }
        if (vip && !d3_layout_treeLeft(vom)) {
          vom.t = vip;
          vom.m += sip - som;
          ancestor = v;
        }
      }
      return ancestor;
    }
    function sizeNode(node) {
      node.x *= size[0];
      node.y = node.depth * size[1];
    }
    tree.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return tree;
    };
    tree.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null ? sizeNode : null;
      return tree;
    };
    tree.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) == null ? null : sizeNode;
      return tree;
    };
    return d3_layout_hierarchyRebind(tree, hierarchy);
  };
  function d3_layout_treeSeparation(a, b) {
    return a.parent == b.parent ? 1 : 2;
  }
  function d3_layout_treeLeft(v) {
    var children = v.children;
    return children.length ? children[0] : v.t;
  }
  function d3_layout_treeRight(v) {
    var children = v.children, n;
    return (n = children.length) ? children[n - 1] : v.t;
  }
  function d3_layout_treeMove(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
  }
  function d3_layout_treeShift(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while (--i >= 0) {
      w = children[i];
      w.z += shift;
      w.m += shift;
      shift += w.s + (change += w.c);
    }
  }
  function d3_layout_treeAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
  }
  d3.layout.cluster = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
    function cluster(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var children = node.children;
        if (children && children.length) {
          node.x = d3_layout_clusterX(children);
          node.y = d3_layout_clusterY(children);
        } else {
          node.x = previousNode ? x += separation(node, previousNode) : 0;
          node.y = 0;
          previousNode = node;
        }
      });
      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
        node.x = (node.x - root.x) * size[0];
        node.y = (root.y - node.y) * size[1];
      } : function(node) {
        node.x = (node.x - x0) / (x1 - x0) * size[0];
        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
      });
      return nodes;
    }
    cluster.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return cluster;
    };
    cluster.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null;
      return cluster;
    };
    cluster.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) != null;
      return cluster;
    };
    return d3_layout_hierarchyRebind(cluster, hierarchy);
  };
  function d3_layout_clusterY(children) {
    return 1 + d3.max(children, function(child) {
      return child.y;
    });
  }
  function d3_layout_clusterX(children) {
    return children.reduce(function(x, child) {
      return x + child.x;
    }, 0) / children.length;
  }
  function d3_layout_clusterLeft(node) {
    var children = node.children;
    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
  }
  function d3_layout_clusterRight(node) {
    var children = node.children, n;
    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
  }
  d3.layout.treemap = function() {
    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
    function scale(children, k) {
      var i = -1, n = children.length, child, area;
      while (++i < n) {
        area = (child = children[i]).value * (k < 0 ? 0 : k);
        child.area = isNaN(area) || area <= 0 ? 0 : area;
      }
    }
    function squarify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while ((n = remaining.length) > 0) {
          row.push(child = remaining[n - 1]);
          row.area += child.area;
          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
            remaining.pop();
            best = score;
          } else {
            row.area -= row.pop().area;
            position(row, u, rect, false);
            u = Math.min(rect.dx, rect.dy);
            row.length = row.area = 0;
            best = Infinity;
          }
        }
        if (row.length) {
          position(row, u, rect, true);
          row.length = row.area = 0;
        }
        children.forEach(squarify);
      }
    }
    function stickify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), remaining = children.slice(), child, row = [];
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while (child = remaining.pop()) {
          row.push(child);
          row.area += child.area;
          if (child.z != null) {
            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
            row.length = row.area = 0;
          }
        }
        children.forEach(stickify);
      }
    }
    function worst(row, u) {
      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
      while (++i < n) {
        if (!(r = row[i].area)) continue;
        if (r < rmin) rmin = r;
        if (r > rmax) rmax = r;
      }
      s *= s;
      u *= u;
      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
    }
    function position(row, u, rect, flush) {
      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
      if (u == rect.dx) {
        if (flush || v > rect.dy) v = rect.dy;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dy = v;
          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
        }
        o.z = true;
        o.dx += rect.x + rect.dx - x;
        rect.y += v;
        rect.dy -= v;
      } else {
        if (flush || v > rect.dx) v = rect.dx;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dx = v;
          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
        }
        o.z = false;
        o.dy += rect.y + rect.dy - y;
        rect.x += v;
        rect.dx -= v;
      }
    }
    function treemap(d) {
      var nodes = stickies || hierarchy(d), root = nodes[0];
      root.x = root.y = 0;
      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
      if (stickies) hierarchy.revalue(root);
      scale([ root ], root.dx * root.dy / root.value);
      (stickies ? stickify : squarify)(root);
      if (sticky) stickies = nodes;
      return nodes;
    }
    treemap.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return treemap;
    };
    treemap.padding = function(x) {
      if (!arguments.length) return padding;
      function padFunction(node) {
        var p = x.call(treemap, node, node.depth);
        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
      }
      function padConstant(node) {
        return d3_layout_treemapPad(node, x);
      }
      var type;
      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
      padConstant) : padConstant;
      return treemap;
    };
    treemap.round = function(x) {
      if (!arguments.length) return round != Number;
      round = x ? Math.round : Number;
      return treemap;
    };
    treemap.sticky = function(x) {
      if (!arguments.length) return sticky;
      sticky = x;
      stickies = null;
      return treemap;
    };
    treemap.ratio = function(x) {
      if (!arguments.length) return ratio;
      ratio = x;
      return treemap;
    };
    treemap.mode = function(x) {
      if (!arguments.length) return mode;
      mode = x + "";
      return treemap;
    };
    return d3_layout_hierarchyRebind(treemap, hierarchy);
  };
  function d3_layout_treemapPadNull(node) {
    return {
      x: node.x,
      y: node.y,
      dx: node.dx,
      dy: node.dy
    };
  }
  function d3_layout_treemapPad(node, padding) {
    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
    if (dx < 0) {
      x += dx / 2;
      dx = 0;
    }
    if (dy < 0) {
      y += dy / 2;
      dy = 0;
    }
    return {
      x: x,
      y: y,
      dx: dx,
      dy: dy
    };
  }
  d3.random = {
    normal: function(µ, σ) {
      var n = arguments.length;
      if (n < 2) σ = 1;
      if (n < 1) µ = 0;
      return function() {
        var x, y, r;
        do {
          x = Math.random() * 2 - 1;
          y = Math.random() * 2 - 1;
          r = x * x + y * y;
        } while (!r || r > 1);
        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
      };
    },
    logNormal: function() {
      var random = d3.random.normal.apply(d3, arguments);
      return function() {
        return Math.exp(random());
      };
    },
    bates: function(m) {
      var random = d3.random.irwinHall(m);
      return function() {
        return random() / m;
      };
    },
    irwinHall: function(m) {
      return function() {
        for (var s = 0, j = 0; j < m; j++) s += Math.random();
        return s;
      };
    }
  };
  d3.scale = {};
  function d3_scaleExtent(domain) {
    var start = domain[0], stop = domain[domain.length - 1];
    return start < stop ? [ start, stop ] : [ stop, start ];
  }
  function d3_scaleRange(scale) {
    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
  }
  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
    return function(x) {
      return i(u(x));
    };
  }
  function d3_scale_nice(domain, nice) {
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
    if (x1 < x0) {
      dx = i0, i0 = i1, i1 = dx;
      dx = x0, x0 = x1, x1 = dx;
    }
    domain[i0] = nice.floor(x0);
    domain[i1] = nice.ceil(x1);
    return domain;
  }
  function d3_scale_niceStep(step) {
    return step ? {
      floor: function(x) {
        return Math.floor(x / step) * step;
      },
      ceil: function(x) {
        return Math.ceil(x / step) * step;
      }
    } : d3_scale_niceIdentity;
  }
  var d3_scale_niceIdentity = {
    floor: d3_identity,
    ceil: d3_identity
  };
  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
    if (domain[k] < domain[0]) {
      domain = domain.slice().reverse();
      range = range.slice().reverse();
    }
    while (++j <= k) {
      u.push(uninterpolate(domain[j - 1], domain[j]));
      i.push(interpolate(range[j - 1], range[j]));
    }
    return function(x) {
      var j = d3.bisect(domain, x, 1, k) - 1;
      return i[j](u[j](x));
    };
  }
  d3.scale.linear = function() {
    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
  };
  function d3_scale_linear(domain, range, interpolate, clamp) {
    var output, input;
    function rescale() {
      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
      output = linear(domain, range, uninterpolate, interpolate);
      input = linear(range, domain, uninterpolate, d3_interpolate);
      return scale;
    }
    function scale(x) {
      return output(x);
    }
    scale.invert = function(y) {
      return input(y);
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(Number);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.rangeRound = function(x) {
      return scale.range(x).interpolate(d3_interpolateRound);
    };
    scale.clamp = function(x) {
      if (!arguments.length) return clamp;
      clamp = x;
      return rescale();
    };
    scale.interpolate = function(x) {
      if (!arguments.length) return interpolate;
      interpolate = x;
      return rescale();
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      d3_scale_linearNice(domain, m);
      return rescale();
    };
    scale.copy = function() {
      return d3_scale_linear(domain, range, interpolate, clamp);
    };
    return rescale();
  }
  function d3_scale_linearRebind(scale, linear) {
    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
  }
  function d3_scale_linearNice(domain, m) {
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    return domain;
  }
  function d3_scale_linearTickRange(domain, m) {
    if (m == null) m = 10;
    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
    extent[0] = Math.ceil(extent[0] / step) * step;
    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
    extent[2] = step;
    return extent;
  }
  function d3_scale_linearTicks(domain, m) {
    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
  }
  function d3_scale_linearTickFormat(domain, m, format) {
    var range = d3_scale_linearTickRange(domain, m);
    if (format) {
      var match = d3_format_re.exec(format);
      match.shift();
      if (match[8] === "s") {
        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
        match[8] = "f";
        format = d3.format(match.join(""));
        return function(d) {
          return format(prefix.scale(d)) + prefix.symbol;
        };
      }
      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
      format = match.join("");
    } else {
      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
    }
    return d3.format(format);
  }
  var d3_scale_linearFormatSignificant = {
    s: 1,
    g: 1,
    p: 1,
    r: 1,
    e: 1
  };
  function d3_scale_linearPrecision(value) {
    return -Math.floor(Math.log(value) / Math.LN10 + .01);
  }
  function d3_scale_linearFormatPrecision(type, range) {
    var p = d3_scale_linearPrecision(range[2]);
    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
  }
  d3.scale.log = function() {
    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
  };
  function d3_scale_log(linear, base, positive, domain) {
    function log(x) {
      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
    }
    function pow(x) {
      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
    }
    function scale(x) {
      return linear(log(x));
    }
    scale.invert = function(x) {
      return pow(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      positive = x[0] >= 0;
      linear.domain((domain = x.map(Number)).map(log));
      return scale;
    };
    scale.base = function(_) {
      if (!arguments.length) return base;
      base = +_;
      linear.domain(domain.map(log));
      return scale;
    };
    scale.nice = function() {
      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
      linear.domain(niced);
      domain = niced.map(pow);
      return scale;
    };
    scale.ticks = function() {
      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
      if (isFinite(j - i)) {
        if (positive) {
          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
          ticks.push(pow(i));
        } else {
          ticks.push(pow(i));
          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
        }
        for (i = 0; ticks[i] < u; i++) {}
        for (j = ticks.length; ticks[j - 1] > v; j--) {}
        ticks = ticks.slice(i, j);
      }
      return ticks;
    };
    scale.tickFormat = function(n, format) {
      if (!arguments.length) return d3_scale_logFormat;
      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
      var k = Math.max(1, base * n / scale.ticks().length);
      return function(d) {
        var i = d / pow(Math.round(log(d)));
        if (i * base < base - .5) i *= base;
        return i <= k ? format(d) : "";
      };
    };
    scale.copy = function() {
      return d3_scale_log(linear.copy(), base, positive, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
    floor: function(x) {
      return -Math.ceil(-x);
    },
    ceil: function(x) {
      return -Math.floor(-x);
    }
  };
  d3.scale.pow = function() {
    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
  };
  function d3_scale_pow(linear, exponent, domain) {
    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
    function scale(x) {
      return linear(powp(x));
    }
    scale.invert = function(x) {
      return powb(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      linear.domain((domain = x.map(Number)).map(powp));
      return scale;
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      return scale.domain(d3_scale_linearNice(domain, m));
    };
    scale.exponent = function(x) {
      if (!arguments.length) return exponent;
      powp = d3_scale_powPow(exponent = x);
      powb = d3_scale_powPow(1 / exponent);
      linear.domain(domain.map(powp));
      return scale;
    };
    scale.copy = function() {
      return d3_scale_pow(linear.copy(), exponent, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_scale_powPow(e) {
    return function(x) {
      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
    };
  }
  d3.scale.sqrt = function() {
    return d3.scale.pow().exponent(.5);
  };
  d3.scale.ordinal = function() {
    return d3_scale_ordinal([], {
      t: "range",
      a: [ [] ]
    });
  };
  function d3_scale_ordinal(domain, ranger) {
    var index, range, rangeBand;
    function scale(x) {
      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
    }
    function steps(start, step) {
      return d3.range(domain.length).map(function(i) {
        return start + step * i;
      });
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = [];
      index = new d3_Map();
      var i = -1, n = x.length, xi;
      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
      return scale[ranger.t].apply(scale, ranger.a);
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      rangeBand = 0;
      ranger = {
        t: "range",
        a: arguments
      };
      return scale;
    };
    scale.rangePoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
      0) : (stop - start) / (domain.length - 1 + padding);
      range = steps(start + step * padding / 2, step);
      rangeBand = 0;
      ranger = {
        t: "rangePoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundPoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
      0) : (stop - start) / (domain.length - 1 + padding) | 0;
      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
      rangeBand = 0;
      ranger = {
        t: "rangeRoundPoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
      range = steps(start + step * outerPadding, step);
      if (reverse) range.reverse();
      rangeBand = step * (1 - padding);
      ranger = {
        t: "rangeBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
      if (reverse) range.reverse();
      rangeBand = Math.round(step * (1 - padding));
      ranger = {
        t: "rangeRoundBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeBand = function() {
      return rangeBand;
    };
    scale.rangeExtent = function() {
      return d3_scaleExtent(ranger.a[0]);
    };
    scale.copy = function() {
      return d3_scale_ordinal(domain, ranger);
    };
    return scale.domain(domain);
  }
  d3.scale.category10 = function() {
    return d3.scale.ordinal().range(d3_category10);
  };
  d3.scale.category20 = function() {
    return d3.scale.ordinal().range(d3_category20);
  };
  d3.scale.category20b = function() {
    return d3.scale.ordinal().range(d3_category20b);
  };
  d3.scale.category20c = function() {
    return d3.scale.ordinal().range(d3_category20c);
  };
  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
  d3.scale.quantile = function() {
    return d3_scale_quantile([], []);
  };
  function d3_scale_quantile(domain, range) {
    var thresholds;
    function rescale() {
      var k = 0, q = range.length;
      thresholds = [];
      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
      return scale;
    }
    function scale(x) {
      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.quantiles = function() {
      return thresholds;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
    };
    scale.copy = function() {
      return d3_scale_quantile(domain, range);
    };
    return rescale();
  }
  d3.scale.quantize = function() {
    return d3_scale_quantize(0, 1, [ 0, 1 ]);
  };
  function d3_scale_quantize(x0, x1, range) {
    var kx, i;
    function scale(x) {
      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
    }
    function rescale() {
      kx = range.length / (x1 - x0);
      i = range.length - 1;
      return scale;
    }
    scale.domain = function(x) {
      if (!arguments.length) return [ x0, x1 ];
      x0 = +x[0];
      x1 = +x[x.length - 1];
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      y = y < 0 ? NaN : y / kx + x0;
      return [ y, y + 1 / kx ];
    };
    scale.copy = function() {
      return d3_scale_quantize(x0, x1, range);
    };
    return rescale();
  }
  d3.scale.threshold = function() {
    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
  };
  function d3_scale_threshold(domain, range) {
    function scale(x) {
      if (x <= x) return range[d3.bisect(domain, x)];
    }
    scale.domain = function(_) {
      if (!arguments.length) return domain;
      domain = _;
      return scale;
    };
    scale.range = function(_) {
      if (!arguments.length) return range;
      range = _;
      return scale;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return [ domain[y - 1], domain[y] ];
    };
    scale.copy = function() {
      return d3_scale_threshold(domain, range);
    };
    return scale;
  }
  d3.scale.identity = function() {
    return d3_scale_identity([ 0, 1 ]);
  };
  function d3_scale_identity(domain) {
    function identity(x) {
      return +x;
    }
    identity.invert = identity;
    identity.domain = identity.range = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(identity);
      return identity;
    };
    identity.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    identity.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    identity.copy = function() {
      return d3_scale_identity(domain);
    };
    return identity;
  }
  d3.svg = {};
  function d3_zero() {
    return 0;
  }
  d3.svg.arc = function() {
    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
    function arc() {
      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
        if (!cw) p1 *= -1;
        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
      }
      if (r1) {
        x0 = r1 * Math.cos(a0 + p1);
        y0 = r1 * Math.sin(a0 + p1);
        x1 = r1 * Math.cos(a1 - p1);
        y1 = r1 * Math.sin(a1 - p1);
        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
          var h1 = (a0 + a1) / 2;
          x0 = r1 * Math.cos(h1);
          y0 = r1 * Math.sin(h1);
          x1 = y1 = null;
        }
      } else {
        x0 = y0 = 0;
      }
      if (r0) {
        x2 = r0 * Math.cos(a1 - p0);
        y2 = r0 * Math.sin(a1 - p0);
        x3 = r0 * Math.cos(a0 + p0);
        y3 = r0 * Math.sin(a0 + p0);
        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
          var h0 = (a0 + a1) / 2;
          x2 = r0 * Math.cos(h0);
          y2 = r0 * Math.sin(h0);
          x3 = y3 = null;
        }
      } else {
        x2 = y2 = 0;
      }
      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
        cr = r0 < r1 ^ cw ? 0 : 1;
        var rc1 = rc, rc0 = rc;
        if (da < π) {
          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
        }
        if (x1 != null) {
          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
          if (rc === rc1) {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
          } else {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
          }
        } else {
          path.push("M", x0, ",", y0);
        }
        if (x3 != null) {
          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
          if (rc === rc0) {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          } else {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          }
        } else {
          path.push("L", x2, ",", y2);
        }
      } else {
        path.push("M", x0, ",", y0);
        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
        path.push("L", x2, ",", y2);
        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
      }
      path.push("Z");
      return path.join("");
    }
    function circleSegment(r1, cw) {
      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
    }
    arc.innerRadius = function(v) {
      if (!arguments.length) return innerRadius;
      innerRadius = d3_functor(v);
      return arc;
    };
    arc.outerRadius = function(v) {
      if (!arguments.length) return outerRadius;
      outerRadius = d3_functor(v);
      return arc;
    };
    arc.cornerRadius = function(v) {
      if (!arguments.length) return cornerRadius;
      cornerRadius = d3_functor(v);
      return arc;
    };
    arc.padRadius = function(v) {
      if (!arguments.length) return padRadius;
      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
      return arc;
    };
    arc.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return arc;
    };
    arc.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return arc;
    };
    arc.padAngle = function(v) {
      if (!arguments.length) return padAngle;
      padAngle = d3_functor(v);
      return arc;
    };
    arc.centroid = function() {
      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
      return [ Math.cos(a) * r, Math.sin(a) * r ];
    };
    return arc;
  };
  var d3_svg_arcAuto = "auto";
  function d3_svg_arcInnerRadius(d) {
    return d.innerRadius;
  }
  function d3_svg_arcOuterRadius(d) {
    return d.outerRadius;
  }
  function d3_svg_arcStartAngle(d) {
    return d.startAngle;
  }
  function d3_svg_arcEndAngle(d) {
    return d.endAngle;
  }
  function d3_svg_arcPadAngle(d) {
    return d && d.padAngle;
  }
  function d3_svg_arcSweep(x0, y0, x1, y1) {
    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
  }
  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
  }
  function d3_svg_line(projection) {
    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
    function line(data) {
      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
      function segment() {
        segments.push("M", interpolate(projection(points), tension));
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
        } else if (points.length) {
          segment();
          points = [];
        }
      }
      if (points.length) segment();
      return segments.length ? segments.join("") : null;
    }
    line.x = function(_) {
      if (!arguments.length) return x;
      x = _;
      return line;
    };
    line.y = function(_) {
      if (!arguments.length) return y;
      y = _;
      return line;
    };
    line.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return line;
    };
    line.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      return line;
    };
    line.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return line;
    };
    return line;
  }
  d3.svg.line = function() {
    return d3_svg_line(d3_identity);
  };
  var d3_svg_lineInterpolators = d3.map({
    linear: d3_svg_lineLinear,
    "linear-closed": d3_svg_lineLinearClosed,
    step: d3_svg_lineStep,
    "step-before": d3_svg_lineStepBefore,
    "step-after": d3_svg_lineStepAfter,
    basis: d3_svg_lineBasis,
    "basis-open": d3_svg_lineBasisOpen,
    "basis-closed": d3_svg_lineBasisClosed,
    bundle: d3_svg_lineBundle,
    cardinal: d3_svg_lineCardinal,
    "cardinal-open": d3_svg_lineCardinalOpen,
    "cardinal-closed": d3_svg_lineCardinalClosed,
    monotone: d3_svg_lineMonotone
  });
  d3_svg_lineInterpolators.forEach(function(key, value) {
    value.key = key;
    value.closed = /-closed$/.test(key);
  });
  function d3_svg_lineLinear(points) {
    return points.length > 1 ? points.join("L") : points + "Z";
  }
  function d3_svg_lineLinearClosed(points) {
    return points.join("L") + "Z";
  }
  function d3_svg_lineStep(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
    if (n > 1) path.push("H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepBefore(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepAfter(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
    return path.join("");
  }
  function d3_svg_lineCardinalOpen(points, tension) {
    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineCardinalClosed(points, tension) {
    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
  }
  function d3_svg_lineCardinal(points, tension) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineHermite(points, tangents) {
    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
      return d3_svg_lineLinear(points);
    }
    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
    if (quad) {
      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
      p0 = points[1];
      pi = 2;
    }
    if (tangents.length > 1) {
      t = tangents[1];
      p = points[pi];
      pi++;
      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      for (var i = 2; i < tangents.length; i++, pi++) {
        p = points[pi];
        t = tangents[i];
        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      }
    }
    if (quad) {
      var lp = points[pi];
      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
    }
    return path;
  }
  function d3_svg_lineCardinalTangents(points, tension) {
    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
    while (++i < n) {
      p0 = p1;
      p1 = p2;
      p2 = points[i];
      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
    }
    return tangents;
  }
  function d3_svg_lineBasis(points) {
    if (points.length < 3) return d3_svg_lineLinear(points);
    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    points.push(points[n - 1]);
    while (++i <= n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    points.pop();
    path.push("L", pi);
    return path.join("");
  }
  function d3_svg_lineBasisOpen(points) {
    if (points.length < 4) return d3_svg_lineLinear(points);
    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
    while (++i < 3) {
      pi = points[i];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
    --i;
    while (++i < n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBasisClosed(points) {
    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
    while (++i < 4) {
      pi = points[i % n];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    --i;
    while (++i < m) {
      pi = points[i % n];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBundle(points, tension) {
    var n = points.length - 1;
    if (n) {
      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
      while (++i <= n) {
        p = points[i];
        t = i / n;
        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
      }
    }
    return d3_svg_lineBasis(points);
  }
  function d3_svg_lineDot4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
  }
  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
  function d3_svg_lineBasisBezier(path, x, y) {
    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
  }
  function d3_svg_lineSlope(p0, p1) {
    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
  }
  function d3_svg_lineFiniteDifferences(points) {
    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
    while (++i < j) {
      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
    }
    m[i] = d;
    return m;
  }
  function d3_svg_lineMonotoneTangents(points) {
    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
    while (++i < j) {
      d = d3_svg_lineSlope(points[i], points[i + 1]);
      if (abs(d) < ε) {
        m[i] = m[i + 1] = 0;
      } else {
        a = m[i] / d;
        b = m[i + 1] / d;
        s = a * a + b * b;
        if (s > 9) {
          s = d * 3 / Math.sqrt(s);
          m[i] = s * a;
          m[i + 1] = s * b;
        }
      }
    }
    i = -1;
    while (++i <= j) {
      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
      tangents.push([ s || 0, m[i] * s || 0 ]);
    }
    return tangents;
  }
  function d3_svg_lineMonotone(points) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
  }
  d3.svg.line.radial = function() {
    var line = d3_svg_line(d3_svg_lineRadial);
    line.radius = line.x, delete line.x;
    line.angle = line.y, delete line.y;
    return line;
  };
  function d3_svg_lineRadial(points) {
    var point, i = -1, n = points.length, r, a;
    while (++i < n) {
      point = points[i];
      r = point[0];
      a = point[1] - halfπ;
      point[0] = r * Math.cos(a);
      point[1] = r * Math.sin(a);
    }
    return points;
  }
  function d3_svg_area(projection) {
    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
    function area(data) {
      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
        return x;
      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
        return y;
      } : d3_functor(y1), x, y;
      function segment() {
        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
        } else if (points0.length) {
          segment();
          points0 = [];
          points1 = [];
        }
      }
      if (points0.length) segment();
      return segments.length ? segments.join("") : null;
    }
    area.x = function(_) {
      if (!arguments.length) return x1;
      x0 = x1 = _;
      return area;
    };
    area.x0 = function(_) {
      if (!arguments.length) return x0;
      x0 = _;
      return area;
    };
    area.x1 = function(_) {
      if (!arguments.length) return x1;
      x1 = _;
      return area;
    };
    area.y = function(_) {
      if (!arguments.length) return y1;
      y0 = y1 = _;
      return area;
    };
    area.y0 = function(_) {
      if (!arguments.length) return y0;
      y0 = _;
      return area;
    };
    area.y1 = function(_) {
      if (!arguments.length) return y1;
      y1 = _;
      return area;
    };
    area.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return area;
    };
    area.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      interpolateReverse = interpolate.reverse || interpolate;
      L = interpolate.closed ? "M" : "L";
      return area;
    };
    area.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return area;
    };
    return area;
  }
  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
  d3.svg.area = function() {
    return d3_svg_area(d3_identity);
  };
  d3.svg.area.radial = function() {
    var area = d3_svg_area(d3_svg_lineRadial);
    area.radius = area.x, delete area.x;
    area.innerRadius = area.x0, delete area.x0;
    area.outerRadius = area.x1, delete area.x1;
    area.angle = area.y, delete area.y;
    area.startAngle = area.y0, delete area.y0;
    area.endAngle = area.y1, delete area.y1;
    return area;
  };
  d3.svg.chord = function() {
    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
    function chord(d, i) {
      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
    }
    function subgroup(self, f, d, i) {
      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
      return {
        r: r,
        a0: a0,
        a1: a1,
        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
      };
    }
    function equals(a, b) {
      return a.a0 == b.a0 && a.a1 == b.a1;
    }
    function arc(r, p, a) {
      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
    }
    function curve(r0, p0, r1, p1) {
      return "Q 0,0 " + p1;
    }
    chord.radius = function(v) {
      if (!arguments.length) return radius;
      radius = d3_functor(v);
      return chord;
    };
    chord.source = function(v) {
      if (!arguments.length) return source;
      source = d3_functor(v);
      return chord;
    };
    chord.target = function(v) {
      if (!arguments.length) return target;
      target = d3_functor(v);
      return chord;
    };
    chord.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return chord;
    };
    chord.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return chord;
    };
    return chord;
  };
  function d3_svg_chordRadius(d) {
    return d.radius;
  }
  d3.svg.diagonal = function() {
    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
    function diagonal(d, i) {
      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
        x: p0.x,
        y: m
      }, {
        x: p3.x,
        y: m
      }, p3 ];
      p = p.map(projection);
      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
    }
    diagonal.source = function(x) {
      if (!arguments.length) return source;
      source = d3_functor(x);
      return diagonal;
    };
    diagonal.target = function(x) {
      if (!arguments.length) return target;
      target = d3_functor(x);
      return diagonal;
    };
    diagonal.projection = function(x) {
      if (!arguments.length) return projection;
      projection = x;
      return diagonal;
    };
    return diagonal;
  };
  function d3_svg_diagonalProjection(d) {
    return [ d.x, d.y ];
  }
  d3.svg.diagonal.radial = function() {
    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
    diagonal.projection = function(x) {
      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
    };
    return diagonal;
  };
  function d3_svg_diagonalRadialProjection(projection) {
    return function() {
      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
      return [ r * Math.cos(a), r * Math.sin(a) ];
    };
  }
  d3.svg.symbol = function() {
    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
    function symbol(d, i) {
      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
    }
    symbol.type = function(x) {
      if (!arguments.length) return type;
      type = d3_functor(x);
      return symbol;
    };
    symbol.size = function(x) {
      if (!arguments.length) return size;
      size = d3_functor(x);
      return symbol;
    };
    return symbol;
  };
  function d3_svg_symbolSize() {
    return 64;
  }
  function d3_svg_symbolType() {
    return "circle";
  }
  function d3_svg_symbolCircle(size) {
    var r = Math.sqrt(size / π);
    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
  }
  var d3_svg_symbols = d3.map({
    circle: d3_svg_symbolCircle,
    cross: function(size) {
      var r = Math.sqrt(size / 5) / 2;
      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
    },
    diamond: function(size) {
      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
    },
    square: function(size) {
      var r = Math.sqrt(size) / 2;
      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
    },
    "triangle-down": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
    },
    "triangle-up": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
    }
  });
  d3.svg.symbolTypes = d3_svg_symbols.keys();
  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
  d3_selectionPrototype.transition = function(name) {
    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
      time: Date.now(),
      ease: d3_ease_cubicInOut,
      delay: 0,
      duration: 250
    };
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_selectionPrototype.interrupt = function(name) {
    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
  };
  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
  function d3_selection_interruptNS(ns) {
    return function() {
      var lock, activeId, active;
      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
        active.timer.c = null;
        active.timer.t = NaN;
        if (--lock.count) delete lock[activeId]; else delete this[ns];
        lock.active += .5;
        active.event && active.event.interrupt.call(this, this.__data__, active.index);
      }
    };
  }
  function d3_transition(groups, ns, id) {
    d3_subclass(groups, d3_transitionPrototype);
    groups.namespace = ns;
    groups.id = id;
    return groups;
  }
  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
  d3_transitionPrototype.call = d3_selectionPrototype.call;
  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
  d3_transitionPrototype.node = d3_selectionPrototype.node;
  d3_transitionPrototype.size = d3_selectionPrototype.size;
  d3.transition = function(selection, name) {
    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
  };
  d3.transition.prototype = d3_transitionPrototype;
  d3_transitionPrototype.select = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
          if ("__data__" in node) subnode.__data__ = node.__data__;
          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
          subgroup.push(subnode);
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.selectAll = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          transition = node[ns][id];
          subnodes = selector.call(node, node.__data__, i, j);
          subgroups.push(subgroup = []);
          for (var k = -1, o = subnodes.length; ++k < o; ) {
            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
            subgroup.push(subnode);
          }
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_transition(subgroups, this.namespace, this.id);
  };
  d3_transitionPrototype.tween = function(name, tween) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
    return d3_selection_each(this, tween == null ? function(node) {
      node[ns][id].tween.remove(name);
    } : function(node) {
      node[ns][id].tween.set(name, tween);
    });
  };
  function d3_transition_tween(groups, name, value, tween) {
    var id = groups.id, ns = groups.namespace;
    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
    } : (value = tween(value), function(node) {
      node[ns][id].tween.set(name, value);
    }));
  }
  d3_transitionPrototype.attr = function(nameNS, value) {
    if (arguments.length < 2) {
      for (value in nameNS) this.attr(value, nameNS[value]);
      return this;
    }
    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrTween(b) {
      return b == null ? attrNull : (b += "", function() {
        var a = this.getAttribute(name), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttribute(name, i(t));
        });
      });
    }
    function attrTweenNS(b) {
      return b == null ? attrNullNS : (b += "", function() {
        var a = this.getAttributeNS(name.space, name.local), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttributeNS(name.space, name.local, i(t));
        });
      });
    }
    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.attrTween = function(nameNS, tween) {
    var name = d3.ns.qualify(nameNS);
    function attrTween(d, i) {
      var f = tween.call(this, d, i, this.getAttribute(name));
      return f && function(t) {
        this.setAttribute(name, f(t));
      };
    }
    function attrTweenNS(d, i) {
      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
      return f && function(t) {
        this.setAttributeNS(name.space, name.local, f(t));
      };
    }
    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.style(priority, name[priority], value);
        return this;
      }
      priority = "";
    }
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleString(b) {
      return b == null ? styleNull : (b += "", function() {
        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
        return a !== b && (i = d3_interpolate(a, b), function(t) {
          this.style.setProperty(name, i(t), priority);
        });
      });
    }
    return d3_transition_tween(this, "style." + name, value, styleString);
  };
  d3_transitionPrototype.styleTween = function(name, tween, priority) {
    if (arguments.length < 3) priority = "";
    function styleTween(d, i) {
      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
      return f && function(t) {
        this.style.setProperty(name, f(t), priority);
      };
    }
    return this.tween("style." + name, styleTween);
  };
  d3_transitionPrototype.text = function(value) {
    return d3_transition_tween(this, "text", value, d3_transition_text);
  };
  function d3_transition_text(b) {
    if (b == null) b = "";
    return function() {
      this.textContent = b;
    };
  }
  d3_transitionPrototype.remove = function() {
    var ns = this.namespace;
    return this.each("end.transition", function() {
      var p;
      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
    });
  };
  d3_transitionPrototype.ease = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].ease;
    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
    return d3_selection_each(this, function(node) {
      node[ns][id].ease = value;
    });
  };
  d3_transitionPrototype.delay = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].delay;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].delay = +value.call(node, node.__data__, i, j);
    } : (value = +value, function(node) {
      node[ns][id].delay = value;
    }));
  };
  d3_transitionPrototype.duration = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].duration;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
    } : (value = Math.max(1, value), function(node) {
      node[ns][id].duration = value;
    }));
  };
  d3_transitionPrototype.each = function(type, listener) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) {
      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
      try {
        d3_transitionInheritId = id;
        d3_selection_each(this, function(node, i, j) {
          d3_transitionInherit = node[ns][id];
          type.call(node, node.__data__, i, j);
        });
      } finally {
        d3_transitionInherit = inherit;
        d3_transitionInheritId = inheritId;
      }
    } else {
      d3_selection_each(this, function(node) {
        var transition = node[ns][id];
        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
      });
    }
    return this;
  };
  d3_transitionPrototype.transition = function() {
    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if (node = group[i]) {
          transition = node[ns][id0];
          d3_transitionNode(node, i, ns, id1, {
            time: transition.time,
            ease: transition.ease,
            delay: transition.delay + transition.duration,
            duration: transition.duration
          });
        }
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id1);
  };
  function d3_transitionNamespace(name) {
    return name == null ? "__transition__" : "__transition_" + name + "__";
  }
  function d3_transitionNode(node, i, ns, id, inherit) {
    var lock = node[ns] || (node[ns] = {
      active: 0,
      count: 0
    }), transition = lock[id], time, timer, duration, ease, tweens;
    function schedule(elapsed) {
      var delay = transition.delay;
      timer.t = delay + time;
      if (delay <= elapsed) return start(elapsed - delay);
      timer.c = start;
    }
    function start(elapsed) {
      var activeId = lock.active, active = lock[activeId];
      if (active) {
        active.timer.c = null;
        active.timer.t = NaN;
        --lock.count;
        delete lock[activeId];
        active.event && active.event.interrupt.call(node, node.__data__, active.index);
      }
      for (var cancelId in lock) {
        if (+cancelId < id) {
          var cancel = lock[cancelId];
          cancel.timer.c = null;
          cancel.timer.t = NaN;
          --lock.count;
          delete lock[cancelId];
        }
      }
      timer.c = tick;
      d3_timer(function() {
        if (timer.c && tick(elapsed || 1)) {
          timer.c = null;
          timer.t = NaN;
        }
        return 1;
      }, 0, time);
      lock.active = id;
      transition.event && transition.event.start.call(node, node.__data__, i);
      tweens = [];
      transition.tween.forEach(function(key, value) {
        if (value = value.call(node, node.__data__, i)) {
          tweens.push(value);
        }
      });
      ease = transition.ease;
      duration = transition.duration;
    }
    function tick(elapsed) {
      var t = elapsed / duration, e = ease(t), n = tweens.length;
      while (n > 0) {
        tweens[--n].call(node, e);
      }
      if (t >= 1) {
        transition.event && transition.event.end.call(node, node.__data__, i);
        if (--lock.count) delete lock[id]; else delete node[ns];
        return 1;
      }
    }
    if (!transition) {
      time = inherit.time;
      timer = d3_timer(schedule, 0, time);
      transition = lock[id] = {
        tween: new d3_Map(),
        time: time,
        timer: timer,
        delay: inherit.delay,
        duration: inherit.duration,
        ease: inherit.ease,
        index: i
      };
      inherit = null;
      ++lock.count;
    }
  }
  d3.svg.axis = function() {
    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
    function axis(g) {
      g.each(function() {
        var g = d3.select(this);
        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
        d3.transition(path));
        tickEnter.append("line");
        tickEnter.append("text");
        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
        if (orient === "bottom" || orient === "top") {
          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
        } else {
          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
        }
        lineEnter.attr(y2, sign * innerTickSize);
        textEnter.attr(y1, sign * tickSpacing);
        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
        if (scale1.rangeBand) {
          var x = scale1, dx = x.rangeBand() / 2;
          scale0 = scale1 = function(d) {
            return x(d) + dx;
          };
        } else if (scale0.rangeBand) {
          scale0 = scale1;
        } else {
          tickExit.call(tickTransform, scale1, scale0);
        }
        tickEnter.call(tickTransform, scale0, scale1);
        tickUpdate.call(tickTransform, scale1, scale1);
      });
    }
    axis.scale = function(x) {
      if (!arguments.length) return scale;
      scale = x;
      return axis;
    };
    axis.orient = function(x) {
      if (!arguments.length) return orient;
      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
      return axis;
    };
    axis.ticks = function() {
      if (!arguments.length) return tickArguments_;
      tickArguments_ = d3_array(arguments);
      return axis;
    };
    axis.tickValues = function(x) {
      if (!arguments.length) return tickValues;
      tickValues = x;
      return axis;
    };
    axis.tickFormat = function(x) {
      if (!arguments.length) return tickFormat_;
      tickFormat_ = x;
      return axis;
    };
    axis.tickSize = function(x) {
      var n = arguments.length;
      if (!n) return innerTickSize;
      innerTickSize = +x;
      outerTickSize = +arguments[n - 1];
      return axis;
    };
    axis.innerTickSize = function(x) {
      if (!arguments.length) return innerTickSize;
      innerTickSize = +x;
      return axis;
    };
    axis.outerTickSize = function(x) {
      if (!arguments.length) return outerTickSize;
      outerTickSize = +x;
      return axis;
    };
    axis.tickPadding = function(x) {
      if (!arguments.length) return tickPadding;
      tickPadding = +x;
      return axis;
    };
    axis.tickSubdivide = function() {
      return arguments.length && axis;
    };
    return axis;
  };
  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  };
  function d3_svg_axisX(selection, x0, x1) {
    selection.attr("transform", function(d) {
      var v0 = x0(d);
      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
    });
  }
  function d3_svg_axisY(selection, y0, y1) {
    selection.attr("transform", function(d) {
      var v0 = y0(d);
      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
    });
  }
  d3.svg.brush = function() {
    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
    function brush(g) {
      g.each(function() {
        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
        var background = g.selectAll(".background").data([ 0 ]);
        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
        var resize = g.selectAll(".resize").data(resizes, d3_identity);
        resize.exit().remove();
        resize.enter().append("g").attr("class", function(d) {
          return "resize " + d;
        }).style("cursor", function(d) {
          return d3_svg_brushCursor[d];
        }).append("rect").attr("x", function(d) {
          return /[ew]$/.test(d) ? -3 : null;
        }).attr("y", function(d) {
          return /^[ns]/.test(d) ? -3 : null;
        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
        resize.style("display", brush.empty() ? "none" : null);
        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
        if (x) {
          range = d3_scaleRange(x);
          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
          redrawX(gUpdate);
        }
        if (y) {
          range = d3_scaleRange(y);
          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
          redrawY(gUpdate);
        }
        redraw(gUpdate);
      });
    }
    brush.event = function(g) {
      g.each(function() {
        var event_ = event.of(this, arguments), extent1 = {
          x: xExtent,
          y: yExtent,
          i: xExtentDomain,
          j: yExtentDomain
        }, extent0 = this.__chart__ || extent1;
        this.__chart__ = extent1;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.brush", function() {
            xExtentDomain = extent0.i;
            yExtentDomain = extent0.j;
            xExtent = extent0.x;
            yExtent = extent0.y;
            event_({
              type: "brushstart"
            });
          }).tween("brush:brush", function() {
            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
            xExtentDomain = yExtentDomain = null;
            return function(t) {
              xExtent = extent1.x = xi(t);
              yExtent = extent1.y = yi(t);
              event_({
                type: "brush",
                mode: "resize"
              });
            };
          }).each("end.brush", function() {
            xExtentDomain = extent1.i;
            yExtentDomain = extent1.j;
            event_({
              type: "brush",
              mode: "resize"
            });
            event_({
              type: "brushend"
            });
          });
        } else {
          event_({
            type: "brushstart"
          });
          event_({
            type: "brush",
            mode: "resize"
          });
          event_({
            type: "brushend"
          });
        }
      });
    };
    function redraw(g) {
      g.selectAll(".resize").attr("transform", function(d) {
        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
      });
    }
    function redrawX(g) {
      g.select(".extent").attr("x", xExtent[0]);
      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
    }
    function redrawY(g) {
      g.select(".extent").attr("y", yExtent[0]);
      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
    }
    function brushstart() {
      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
      if (d3.event.changedTouches) {
        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
      } else {
        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
      }
      g.interrupt().selectAll("*").interrupt();
      if (dragging) {
        origin[0] = xExtent[0] - origin[0];
        origin[1] = yExtent[0] - origin[1];
      } else if (resizing) {
        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
        origin[0] = xExtent[ex];
        origin[1] = yExtent[ey];
      } else if (d3.event.altKey) center = origin.slice();
      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
      d3.select("body").style("cursor", eventTarget.style("cursor"));
      event_({
        type: "brushstart"
      });
      brushmove();
      function keydown() {
        if (d3.event.keyCode == 32) {
          if (!dragging) {
            center = null;
            origin[0] -= xExtent[1];
            origin[1] -= yExtent[1];
            dragging = 2;
          }
          d3_eventPreventDefault();
        }
      }
      function keyup() {
        if (d3.event.keyCode == 32 && dragging == 2) {
          origin[0] += xExtent[1];
          origin[1] += yExtent[1];
          dragging = 0;
          d3_eventPreventDefault();
        }
      }
      function brushmove() {
        var point = d3.mouse(target), moved = false;
        if (offset) {
          point[0] += offset[0];
          point[1] += offset[1];
        }
        if (!dragging) {
          if (d3.event.altKey) {
            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
            origin[0] = xExtent[+(point[0] < center[0])];
            origin[1] = yExtent[+(point[1] < center[1])];
          } else center = null;
        }
        if (resizingX && move1(point, x, 0)) {
          redrawX(g);
          moved = true;
        }
        if (resizingY && move1(point, y, 1)) {
          redrawY(g);
          moved = true;
        }
        if (moved) {
          redraw(g);
          event_({
            type: "brush",
            mode: dragging ? "move" : "resize"
          });
        }
      }
      function move1(point, scale, i) {
        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
        if (dragging) {
          r0 -= position;
          r1 -= size + position;
        }
        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
        if (dragging) {
          max = (min += position) + size;
        } else {
          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
          if (position < min) {
            max = min;
            min = position;
          } else {
            max = position;
          }
        }
        if (extent[0] != min || extent[1] != max) {
          if (i) yExtentDomain = null; else xExtentDomain = null;
          extent[0] = min;
          extent[1] = max;
          return true;
        }
      }
      function brushend() {
        brushmove();
        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
        d3.select("body").style("cursor", null);
        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
        dragRestore();
        event_({
          type: "brushend"
        });
      }
    }
    brush.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.clamp = function(z) {
      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
      return brush;
    };
    brush.extent = function(z) {
      var x0, x1, y0, y1, t;
      if (!arguments.length) {
        if (x) {
          if (xExtentDomain) {
            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
          } else {
            x0 = xExtent[0], x1 = xExtent[1];
            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
            if (x1 < x0) t = x0, x0 = x1, x1 = t;
          }
        }
        if (y) {
          if (yExtentDomain) {
            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
          } else {
            y0 = yExtent[0], y1 = yExtent[1];
            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
            if (y1 < y0) t = y0, y0 = y1, y1 = t;
          }
        }
        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
      }
      if (x) {
        x0 = z[0], x1 = z[1];
        if (y) x0 = x0[0], x1 = x1[0];
        xExtentDomain = [ x0, x1 ];
        if (x.invert) x0 = x(x0), x1 = x(x1);
        if (x1 < x0) t = x0, x0 = x1, x1 = t;
        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
      }
      if (y) {
        y0 = z[0], y1 = z[1];
        if (x) y0 = y0[1], y1 = y1[1];
        yExtentDomain = [ y0, y1 ];
        if (y.invert) y0 = y(y0), y1 = y(y1);
        if (y1 < y0) t = y0, y0 = y1, y1 = t;
        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
      }
      return brush;
    };
    brush.clear = function() {
      if (!brush.empty()) {
        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
        xExtentDomain = yExtentDomain = null;
      }
      return brush;
    };
    brush.empty = function() {
      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
    };
    return d3.rebind(brush, event, "on");
  };
  var d3_svg_brushCursor = {
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
  };
  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
  var d3_time_formatUtc = d3_time_format.utc;
  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
  function d3_time_formatIsoNative(date) {
    return date.toISOString();
  }
  d3_time_formatIsoNative.parse = function(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
  };
  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
  d3_time.second = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 1e3) * 1e3);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
  }, function(date) {
    return date.getSeconds();
  });
  d3_time.seconds = d3_time.second.range;
  d3_time.seconds.utc = d3_time.second.utc.range;
  d3_time.minute = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 6e4) * 6e4);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
  }, function(date) {
    return date.getMinutes();
  });
  d3_time.minutes = d3_time.minute.range;
  d3_time.minutes.utc = d3_time.minute.utc.range;
  d3_time.hour = d3_time_interval(function(date) {
    var timezone = date.getTimezoneOffset() / 60;
    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
  }, function(date) {
    return date.getHours();
  });
  d3_time.hours = d3_time.hour.range;
  d3_time.hours.utc = d3_time.hour.utc.range;
  d3_time.month = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setDate(1);
    return date;
  }, function(date, offset) {
    date.setMonth(date.getMonth() + offset);
  }, function(date) {
    return date.getMonth();
  });
  d3_time.months = d3_time.month.range;
  d3_time.months.utc = d3_time.month.utc.range;
  function d3_time_scale(linear, methods, format) {
    function scale(x) {
      return linear(x);
    }
    scale.invert = function(x) {
      return d3_time_scaleDate(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
      linear.domain(x);
      return scale;
    };
    function tickMethod(extent, count) {
      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
        return d / 31536e6;
      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
    }
    scale.nice = function(interval, skip) {
      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
      if (method) interval = method[0], skip = method[1];
      function skipped(date) {
        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
      }
      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
        floor: function(date) {
          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
          return date;
        },
        ceil: function(date) {
          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
          return date;
        }
      } : interval));
    };
    scale.ticks = function(interval, skip) {
      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
        range: interval
      }, skip ];
      if (method) interval = method[0], skip = method[1];
      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
    };
    scale.tickFormat = function() {
      return format;
    };
    scale.copy = function() {
      return d3_time_scale(linear.copy(), methods, format);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_time_scaleDate(t) {
    return new Date(t);
  }
  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
    return d.getMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getMinutes();
  } ], [ "%I %p", function(d) {
    return d.getHours();
  } ], [ "%a %d", function(d) {
    return d.getDay() && d.getDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getDate() != 1;
  } ], [ "%B", function(d) {
    return d.getMonth();
  } ], [ "%Y", d3_true ] ]);
  var d3_time_scaleMilliseconds = {
    range: function(start, stop, step) {
      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
    },
    floor: d3_identity,
    ceil: d3_identity
  };
  d3_time_scaleLocalMethods.year = d3_time.year;
  d3_time.scale = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
  };
  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
    return [ m[0].utc, m[1] ];
  });
  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
    return d.getUTCMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getUTCSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getUTCMinutes();
  } ], [ "%I %p", function(d) {
    return d.getUTCHours();
  } ], [ "%a %d", function(d) {
    return d.getUTCDay() && d.getUTCDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getUTCDate() != 1;
  } ], [ "%B", function(d) {
    return d.getUTCMonth();
  } ], [ "%Y", d3_true ] ]);
  d3_time_scaleUtcMethods.year = d3_time.year.utc;
  d3_time.scale.utc = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
  };
  d3.text = d3_xhrType(function(request) {
    return request.responseText;
  });
  d3.json = function(url, callback) {
    return d3_xhr(url, "application/json", d3_json, callback);
  };
  function d3_json(request) {
    return JSON.parse(request.responseText);
  }
  d3.html = function(url, callback) {
    return d3_xhr(url, "text/html", d3_html, callback);
  };
  function d3_html(request) {
    var range = d3_document.createRange();
    range.selectNode(d3_document.body);
    return range.createContextualFragment(request.responseText);
  }
  d3.xml = d3_xhrType(function(request) {
    return request.responseXML;
  });
  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else {}
}();

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(1);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(44);
var store = __webpack_require__(170);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.5.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var createNonEnumerableProperty = __webpack_require__(11);

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(2);

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(175);
var IndexedObject = __webpack_require__(106);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(20);
var arraySpeciesCreate = __webpack_require__(107);

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(2);
var classof = __webpack_require__(27);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
var isArray = __webpack_require__(48);
var wellKnownSymbol = __webpack_require__(1);

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(38);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 111 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(14).f;
var has = __webpack_require__(8);
var wellKnownSymbol = __webpack_require__(1);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var exec = __webpack_require__(56);

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(273),
    baseMatchesProperty = __webpack_require__(325),
    identity = __webpack_require__(65),
    isArray = __webpack_require__(12),
    property = __webpack_require__(335);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(57),
    stackClear = __webpack_require__(280),
    stackDelete = __webpack_require__(281),
    stackGet = __webpack_require__(282),
    stackHas = __webpack_require__(283),
    stackSet = __webpack_require__(284);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(23),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(291),
    mapCacheDelete = __webpack_require__(298),
    mapCacheGet = __webpack_require__(300),
    mapCacheHas = __webpack_require__(301),
    mapCacheSet = __webpack_require__(302);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(313),
    stubArray = __webpack_require__(201);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(15),
    stubFalse = __webpack_require__(316);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(120)(module)))

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 122 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(193);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(120)(module)))

/***/ }),
/* 125 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(12),
    isSymbol = __webpack_require__(63);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(197);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(13);
var global = __webpack_require__(4);
var isForced = __webpack_require__(181);
var redefine = __webpack_require__(26);
var has = __webpack_require__(8);
var classof = __webpack_require__(27);
var inheritIfRequired = __webpack_require__(374);
var toPrimitive = __webpack_require__(34);
var fails = __webpack_require__(2);
var create = __webpack_require__(52);
var getOwnPropertyNames = __webpack_require__(51).f;
var getOwnPropertyDescriptor = __webpack_require__(49).f;
var defineProperty = __webpack_require__(14).f;
var trim = __webpack_require__(218).trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 115);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var Utils = __webpack_require__(4);

/**
 * Creates a new DataManager instance.
 * @example
 * var dataManager = new DataManager();
 * @constructor
 */
function DataManager() {
    /**
     * @type {Array}
     * @private
     */
    this._data = [];
    /**
     * @type {Object}
     * @private
     */
    this._parsers = {};
    /**
     * @type {Number} Integer that holds the next index to assign
     * @private
     */
    this._nextIndex = 0;
}

/**
 * Gets all series attributes as parameters and returns a series object. This is intended to mantain legacy with previos versions.
 *
 * @param {String} seriesName Identifier for the series. Required.
 * @param {Array} series Array containing the series values. Required.
 * @param {String} groupName Identifier used to group series.
 * @param {Boolean} notIndexable If it is true the series is not indexed into the data manager.
 * @param {String} displayName String to be displayed.
 * @param {String} color String used for color of the data point.
 * @returns {Object} Series object
 */
function getSetAttributes(args) {
    var seriesName, series, groupName, notIndexable, displayName, color;
    seriesName = args[0];
    series = args[1];
    groupName = args[2];
    notIndexable = args[3];
    displayName = args[4];
    color = args[5];

    if (!seriesName || !series) {
        return;
    }

    return {
        name: seriesName,
        series: series,
        group: groupName,
        notIndexable: notIndexable,
        display: displayName,
        color: color
    };
}

/**
 * Recalculate indexed series indexes.
 *
 * @param {Array} data Array of series object.
 */
function recalcIndexes(data) {
    data.forEach(function (dataItem, i) {
        if (dataItem.index !== -1) {
            dataItem.index = i;
        }
    });
}

/**
 * Recalculate in-group indexes.
 *
 * @param {any} groupArray
 */
function recalcGroupIndexes(groupArray) {
    groupArray.forEach(function (item, i) {
        item.groupIndex = i;
    });
}

/**
 * Adds a series to the data manager. Receives an <i>Options Object</i> this way:
 * <br><br>
 * <code>
 * {
 *   name: "green_apples" // String
 *   series: [10, 20, 30, 40], // Array
 *   group: "Fruits",
 *   display: "Green Apples",
 *   notIndexable: false,
 *   color: "red"
 * }
 * </code>
 * <br>The <b>name</b> is the identifier for each series.
 * <br>The <b>series</b> Array is not necessary an array of number, it can be an array of objects with data.
 * <br><b>group</b> identifier is for data aggrupation if is not passed then <i>name</i> is used as group.
 * <br><b>display</b> is the text to show. If not passed then <i>name</i> is used as display name.
 * <br>If <b>notIndexable</b> is false, then the series is being indexed, non indexed series has index equals to -1.
 * <br><br>
 * For each series the datamanager creates a <i>Series Object</i> like:
 * <code>
 * {
 *   name: "green_apples",
 *   series: [10, 20, 30, 40],
 *   groupName: "Fruits",
 *   displayName: "Green Apples",
 *   index: 0,
 *   groupIndex: 0,
 *   color: "red"
 * }
 * </code>
 * @example
 * var dataManager = new DataManager();
 * // Minimal
 * dataManager.set({
 *   name: "Bar Chart Data",
 *   series: [40, 50, 60, 25]
 * });
 *
 * // If you need grouped data for a grouped bar chart for example.
 *
 * dataManager.set(
 *   name: "apples",
 *   display: "Apples",
 *   series: [25, 45, 43, 20],
 *   group: "grouped-bar-chart-data"
 * });
 *
 * dataManager.set({
 *   name: "oranges",
 *   display: "Oranges",
 *   series: [5, 20, 16, 27],
 *   group: "grouped-bar-chart-data"
 * });
 *
 * @param {Object} options Set of options.
 */
DataManager.prototype.set = function (options) {
    var groupName, groupIndex;
    if (!options) {
        return;
    }

    // For legacy purposes.
    if (typeof options === "string") {
        options = getSetAttributes(arguments);
        if (typeof options === "undefined") {
            return;
        }
    }

    groupName = options.group || options.name;
    groupIndex = this.queryGroup(groupName).length;

    this._data.push({
        name: options.name,
        series: options.series,
        groupName: groupName,
        displayName: options.display || options.name,
        index: !options.notIndexable || options.includeIndex ? this._nextIndex++ : -1,
        groupIndex: groupIndex,
        color: options.color,
        lineStrokeWidth: options.lineStrokeWidth
    });
};

/**
 * Unindexed Set, Same of set method but without set index to data, assing index = -1
 * Adds an unindexed series to the data manager. Receives an <i>Options Object</i> this way:
 * <br><br>
 * <code>
 * {
 *   name: "green_apples" // String
 *   series: [10, 20, 30, 40], // Array
 *   group: "Fruits",
 *   display: "Green Apples",
 * }
 * </code>
 * <br>The <b>name</b> is the identifier for each series.
 * <br>The <b>series</b> Array is not necessary an array of number, it can be an array of objects with data.
 * <br><b>group</b> identifier is for data aggrupation if is not passed then <i>name</i> is used as group.
 * <br><b>display</b> is the text to show. If not passed then <i>name</i> is used as display name.
 * @see set
 * @param {Object} options Set of options.
 */
DataManager.prototype.uset = function (options) {
    if (typeof options === "string") {
        options = getSetAttributes(arguments);
        if (typeof options === "undefined") {
            return;
        }
    }

    options.notIndexable = true;
    this.set(options);
};

/**
 * Update the series data specified by <i>seriesName</i>.
 * @example
 * dataManager.update("Apples", [2, 4, 6, 8]);
 * @param {String} seriesName Name of the series to update.
 * @param {Array} series Array of data to update.
 */
DataManager.prototype.update = function (seriesName, series) {
    var query = this._data.filter(function (series) {
        return series.name === seriesName;
    });

    var item;

    if (query.length) {
        item = query[0];
        item.series = series;
    }
};

/**
 * Removes a series from the data manager based on the series name.
 *
 * @param {String} seriesName Identifier of the series to remove.
 *
 * @return {Object} Removed Series Object.
 */
DataManager.prototype.remove = function (seriesName) {
    var index = Utils.array.indexOf(this._data, "name", seriesName);
    this._nextIndex = 0;
    var removed;
    if (index !== -1) {
        removed = this._data.splice(index, 1);

        // Recalculate general indexes
        recalcIndexes(this._data);

        // Recalculate group indexes
        recalcGroupIndexes(this.queryGroup(removed[0].groupName));
    }

    return removed;
};

/**
 * Resets the Datamanager.
 */
DataManager.prototype.clean = function () {
    this._data = [];
    this._parsers = {};
    this._nextIndex = 0;
};

/**
 * Search for the series in a determined group.
 *
 * @param {String} groupName Name of the group to search.
 * @returns {Array<Object>} Series in the group
 */
DataManager.prototype.queryGroup = function (groupName) {
    return this._data.filter(function (series) {
        return series.groupName === groupName;
    });
};

/**
 * If no parser is setted for the group then returns the raw data array from the store.
 * <br><br>
 * If parser is setted, then returns the data parsed by the function.
 *
 * @example
 * function parser(data, domain) {
 *   // data contains an array of series objects {}
 *   // domain is an argument
 *   var map = domain.map(function (point, i) {
 *       var obj = { point: point };
 *
 *       obj.values = data.map(function (value) {
 *           return {
 *               series: value.name,
 *               value: value.series[i]
 *           };
 *       });
 *       return obj;
 *   });
 *   return map;
 * }
 *
 * dataManager.parser("grouped-bar-chart-data", parser, ["Mon", "Tue", "Wed", "Thu"]);
 * var data = dataManager.get("grouped-bar-chart-data";
 * //  Resultingdata:
 * //  [{
 * //      point: "Mon",
 * //      values: {[
 * //          series: "Apples",
 * //          value: 25
 * //      ],[
 * //          series: "Oranges",
 * //          value: 5
 * //      ]...}
 * //  } ...]
 *
 * @param {any} groupName
 * @returns {Array} Array that contains data.
 */
DataManager.prototype.get = function (groupName) {
    if (!groupName) {
        return;
    }

    var data = this.queryGroup(groupName);
    var parser = this._parsers[groupName];
    var args;

    if (!parser) {
        return data;
    } else {
        args = [data].concat(parser.arguments);
        return parser.fn.apply(this, args);
    }
};

/**
 * Calculates the domain for the groups in _groupArray_, if not _groupArray_ is specified calculates for all data in the store.
 * <br><br>
 * Also rounds the domains to the nearest tenth (by default) or by the value specified in _roundDomainTo_.
 * @example
 * // There are 3 data groups: datagroup-1, datagroup-2 and datagroup-3.
 *
 * // Calculates domain only for groups datagroup-1 and datagroup-3.
 * var domain = dataManager.calculateDomain({
 *    groups: ["datagroup-1", "datagroup-2"]
 * });
 *
 * // Calculates domain for all groups.
 * var domain = dataManager.calculateDomain();
 *
 * // Calculates domain for all groups and round it to hundreds.
 * var domain = dataManager.calculateDomain({
 *  roundTo: 100
 *});
 *
 * // Calculates domain only for datagroup-3 and round it to hundreds.
 * var domain = dataManager.calculateDomain({
 *   groups: ["datagroup-3"],
 *   roundTo: 1000
 * });
 * @param {Object}? options Options available:
 * <li><b>groups:</b> Optional. Array of names of the data groups to include in the domain calculation.
 * <li><b>roundTo:</b> Optional. roundTo 10, 100, 1000, etc.
 * <li><b>forceNegative:</b> Optional. Boolean value to force negative values on the domain
 * <li><b>symmetrical:</b> Optional.
 * <li><b>steps:</b> Optional. Intended ticks number.
 * <li><b>accessor:</b> Optional. To access data.
 * <li><b>raw:</b> Optional. Force the domain calculation using unrounded values.
 *
 * @returns {Array} An array of length 2 with the calculated domain
 */
DataManager.prototype.calculateDomain = function (options) {
    options = options || {};
    var _this = this;
    var values = [];
    var groupArray = options.groups;
    var domainOptions = {
        forceNegative: options.forceNegative,
        symmetrical: options.symmetrical,
        steps: options.steps,
        integers: options.integers,
        raw: options.raw
    };

    // If not defined get all groups
    if (!groupArray) {
        groupArray = Utils.array.removeDuplicates(this._data.map(function (data) {
            return data.groupName;
        }));
    }

    groupArray.forEach(function (group) {
        var query = _this.queryGroup(group);
        var series;

        var accessorMap = function accessorMap(item, accessor) {
            return item.series.map(function (d) {
                return Utils.object.extract(d, accessor);
            });
        };

        if (options.stacked) {
            series = query.map(function (item) {
                if (options.accessor) {
                    return accessorMap(item, options.accessor);
                } else {
                    return item.series;
                }
            });

            values = values.concat(Utils.array.getStackedValues(series));
        } else {
            query.forEach(function (item) {
                if (options.accessor) {
                    values = values.concat(accessorMap(item, options.accessor));
                } else {
                    values = values.concat(item.series);
                }
            });
        }
    });

    // check values
    values = values.map(function (value) {
        return typeof value !== "undefined" ? value : 0;
    });

    var min = d3.min(values);
    var max = d3.max(values);
    var highest;
    var forceNegative = options.forceNegative;

    if (min === 0 && max === 0) {
        return forceNegative ? [-1, 1] : [0, 1];
    }

    if (max % 10 === 0) {
        values.push(max + 10);
    }

    if (min < 0 && min % 10 === 0) {
        values.push(min - 10);
    }

    if (typeof options.roundTo === "number") {
        domainOptions.roundTo = options.roundTo;
    } else if (min > -1 && max < 1) {
        return min < 0 || forceNegative ? [-1, 1] : [0, 1];
    } else if (max < 10 && min > -10) {
        highest = Math.max(Math.abs(min), Math.abs(max));
        domainOptions.roundTo = highest % 2 === 0 ? highest % 6 === 0 ? 4 : 3 : 2;
    } else {
        domainOptions.roundTo = Utils.array.getRoundToUnits(values);
    }

    domainOptions.values = values;
    return Utils.chart.getDomain(domainOptions);
};

/**
 * Sets a parser (formatter) function for a determined group of data. If arguments are passed they are passed too to the parser function as parameters.
 *
 * @param {any} groupName
 * @param {any} parser
 * @returns {Function} If only one argument is passed
 */
DataManager.prototype.parser = function (groupName, parser) {
    var newParser;
    if (!groupName) {
        return;
    }

    if (!parser) {
        return this._parsers[groupName];
    }

    newParser = {};
    newParser.fn = parser;
    newParser.arguments = Array.prototype.slice.call(arguments, 2);

    this._parsers[groupName] = newParser;
    return parser;
};

/**
 * Returns all data combined
 * @example
 *  dataManager.set("Cars", [10, 20], "vehicles");
 *  dataManager.set("Planes", [30, 40], "vehicles");
 *  dataManager.set("Tricycle", [5, 15], "tricycle");
 *
 *  dataManager.combine("tricycle")
 *  dataManager.combine(["vehicles", "tricycle"])
 *
 * @param {Array|String} groupNames The name of a group name or an array containing all group names you want to get data combined.
 * @return {Array} Data combined.
 */
DataManager.prototype.combine = function (groupNames) {
    var metadataArray = [];
    var seriesArray = [];
    var combined = [];
    var i = 0;
    var j = 0;
    var len, pointObj, seriesLength, metadata, value;
    groupNames = typeof groupNames === "string" ? [groupNames] : groupNames;
    groupNames.forEach(function (seriesObject) {
        this.queryGroup(seriesObject).forEach(function (point) {
            seriesArray.push(point.series);
            metadataArray.push({
                name: point.name,
                groupName: point.groupName,
                displayName: point.displayName,
                index: point.index,
                groupIndex: point.groupIndex,
                color: point.color
            });
        });
    }.bind(this));

    len = seriesArray[0].length;
    seriesLength = seriesArray.length;

    for (; i < len; i++) {
        pointObj = [];
        j = 0;
        for (; j < seriesLength; j++) {
            value = seriesArray[j][i];
            metadata = metadataArray[j];
            pointObj.push({
                name: metadata.name,
                groupName: metadata.groupName,
                displayName: metadata.displayName,
                index: metadata.index,
                value: value,
                groupIndex: metadata.groupIndex,
                color: metadata.color
            });
        }

        combined.push(pointObj);
    }

    return combined;
};

/**
 * Returns <b>true</b> if a series is contained in a give group.
 * @param {String} seriesName
 * @param {String} groupName
 * @returns {Boolean}
 */
DataManager.prototype.inGroup = function (seriesName, groupName) {
    var group = this.queryGroup(groupName);
    var len = group.length;
    var i;

    for (i = 0; i < len; i++) {
        if (group[i].name === seriesName) {
            return true;
        }
    }

    return false;
};

module.exports = DataManager;

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Creates a new ScaleManager instance.
 *
 * @constructor
 * @param {Object} scales
 */

function ScaleManager(scales) {
    this._scales = scales || {};
}

/**
 * Sets a new scale, if no <i>scale</i> is passed then returns the scale object.
 *
 * @param {String} scaleName Name for the scale.
 * @param {D3.scale} scale
 * @returns {D3.scale}
 */
ScaleManager.prototype.scale = function (scaleName, scale) {
    if (!scaleName) {
        return;
    }

    if (!scale) {
        return this._scales[scaleName];
    }

    this._scales[scaleName] = scale;
};

/**
 * Sets the scale's domain, if no <i>domain</i> is passed returns it.
 *
 * @param {String} scaleName
 * @param {Array} domain
 * @returns {Array} Domain for a specific scale.
 */
ScaleManager.prototype.domain = function (scaleName, domain) {
    if (!scaleName) {
        return;
    }

    if (!domain) {
        return this._scales[scaleName].domain();
    }

    this._scales[scaleName].domain(domain);
};

/**
 * Sets the scale's range, if no _range_ is passed returns it.
 *
 * @param {String} scaleName
 * @param {Array} range
 * @returns Range for a specific scale.
 */
ScaleManager.prototype.range = function (scaleName, range) {
    if (!scaleName) {
        return;
    }

    if (!range) {
        return this._scales[scaleName].range();
    }

    this._scales[scaleName].range(range);
};

/**
 * Remove a scale from the hashmap.
 * @param {String} scaleName Scale to remove.
 */
ScaleManager.prototype.remove = function (scaleName) {
    delete this._scales[scaleName];
};

module.exports = ScaleManager;

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(16);


/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @module Core */

var AxesManager = __webpack_require__(8);
var Canvas = __webpack_require__(9);
var Chart = __webpack_require__(37);
var DataManager = __webpack_require__(10);
var Base = __webpack_require__(6);
var ScalesManager = __webpack_require__(11);
var Utils = __webpack_require__(4);
var Classes = __webpack_require__(7);
var d3Overrides = __webpack_require__(49);
var version = __webpack_require__(50);
var Axes = __webpack_require__(39);

// D3 overrides
d3Overrides();
// Sets MBC version on window
version();

module.exports = {
  /**
   * @see AxesManager
   */
  AxesManager: AxesManager,
  /**
   * @see Canvas
   */
  Canvas: Canvas,
  /**
   * @see Chart
   */
  Chart: Chart,
  /**
   * @see Base
   */
  Base: Base,
  /**
   * @see ScalesManager
   */
  ScalesManager: ScalesManager,
  /**
   * @see DataManager
   */
  DataManager: DataManager,
  /**
  * @see Utils
  */
  Utils: Utils,
  /**
   * @see Classes
   */
  Classes: Classes,
  /**
  * @see Axes
  */
  Axes: Axes
};

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extract = __webpack_require__(3).extract;
/**
 * Returns true if an array contains just null values. If the parameter is a falsey value returns undefined.
 * @example
 * Util.array.hasNulls([null, null, null]) // returns true
 *  @param {Array} arr Array to inspect.
 * @return {Boolean} true means that the array contains null values.
 **/
var hasNulls = function hasNulls(arr) {
    if (!arr) return;
    var len = arr.length;
    var i = 0;
    for (; i < len; i++) {
        if (arr[i] !== null) {
            return false;
        }
    }

    return true;
};

/**
 * Returns false if the array passed contains negative values.
 *
 * @param {Array<Number>} allValues Numeric array.
 * @return {Boolean} Boolean indicating if the array contains at least one negative value.
 */
var hasNegative = function hasNegative(allValues) {
    if (!allValues) return;
    return d3.min(allValues) < 0;
};

/**
 * Return a new array with absolute numbers.
 * @param {Array<Number>} allValues Input array of numbers.
 */
var getAllPositives = function getAllPositives(allValues) {
    return allValues.map(function (val) {
        return Math.abs(val);
    });
};

/**
 * Rmoves duplicates from an array.
 *
 * @export
 * @param {Array} array Source array.
 * @returns {Array} Array without duplicates.
 */
var removeDuplicates = function removeDuplicates(array) {
    if (!array) return;
    return array.filter(function (elem, index, _this) {
        return index === _this.indexOf(elem);
    });
};

var indexOf = function indexOf(array, property, search) {
    var i, len;
    for (i = 0, len = array.length; i < len; i++) {
        if (array[i][property] === search) return i;
    }

    return -1;
};

/**
 * Returns and array with all values stacked by index, it includes negative and positive values
 * @param {Array} arrays Array of arrays containig series values.
 * @return {Array} Array with all values.
 */
var getStackedValues = function getStackedValues(arrays) {
    var i = 0;
    var j = 0;
    var arrLength = arrays.length;
    var length = -1;
    var positive = 0;
    var negative = 0;
    var stacked = [];
    var actualLength, value;

    // Check array lengths
    for (; i < arrLength; i++) {
        actualLength = arrays[i].length;
        if (length !== -1 && actualLength !== length) {
            throw new Error("Arrays must have the same length");
        }

        length = actualLength;
    }

    i = 0;
    for (; i < length; i++) {
        for (; j < arrLength; j++) {
            value = arrays[j][i];
            if (value >= 0) {
                positive += value;
            } else {
                negative += value;
            }
        }

        stacked.push(Math.round(positive));
        if (negative !== 0) stacked.push(Math.round(negative));
        positive = 0;
        negative = 0;
        j = 0;
    }

    return stacked;
};

/**
 * It searches for the min and max value inside an array.
 *
 * @param {any} array
 * @param {any} accesor
 * @returns Object
 */
function minmax(array, accesor) {
    var len = array.length;
    var i = 0;
    var obj, value, min, max, minValue, maxValue;
    for (; i < len; i++) {
        obj = array[i];
        value = extract(obj, accesor);

        if (typeof minValue === "undefined" || value < minValue) {
            minValue = value;
            min = array[i];
        }

        if (typeof maxValue === "undefined" || value > maxValue) {
            maxValue = value;
            max = array[i];
        }
    }

    return { min: min, max: max };
}

/**
 * It returns the thousandths, hundredths, tenths, hundred, thousands to round the domain.
 *
 * @param {Number[]} array Array of numbers.
 * @return {Number} 0.001, 0.01, 0.1, 1, 10, 100, 1000, ...
 */
function getRoundToUnits(array) {
    if (!array || !array.length) return 1;
    var absMean = d3.mean(array, function (d) {
        return Math.abs(d);
    });

    if (absMean === 0) return 1;
    if (absMean >= 1) {
        absMean = Math.ceil(absMean / 10);
        return Math.pow(10, ("" + absMean).length);
    } else {
        var decimals = ("" + absMean).split(".")[1];
        var match = decimals.match(/[^0]/);
        return 1 / Math.pow(10, match.index + 1);
    }
}

module.exports = {
    getAllPositives: getAllPositives,
    getRoundToUnits: getRoundToUnits,
    getStackedValues: getStackedValues,
    hasNegative: hasNegative,
    hasNulls: hasNulls,
    indexOf: indexOf,
    minmax: minmax,
    removeDuplicates: removeDuplicates
};

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = {"constants":{"color":{"white":"#ffffff","black":"#000000","neutral":{"12":"#1e1e1e","20":"#333333","37":"#5e5e5e","50":"#808080","67":"#ababab","80":"#cccccc","90":"#e5e5e5","95":"#f2f2f2"},"blue":{"23":"#004376","32":"#005ba1","36":"#006fba","38":"#1f55a5","41":"#0077cf","44":"#008dde"},"green":{"34":"#00af41"},"dark-green":{"34":"#518428"},"teal":{"19":"#005f5f"},"violet":{"46":"#6a4c9e"},"cyan":{"44":"#00a8e1"},"maroon":{"32":"#a50032"},"red":{"50":"#ff0000"},"yellow":{"48":"#f5c400"},"orange":{"54":"#ef7622"},"light-red":{"46":"#e60546"},"dark-violet":{"32":"#7d256f"},"dark-yellow":{"47":"#c19c31"},"aqua":{"37":"#00beaf"},"bright-orange":{"50":"#ff3c00"},"light-green":{"50":"#89bd40"}},"brand":{"blue":"#1f55a5","cyan":"#00a8e1"},"background-color":{"default":"#ffffff","light":"#f2f2f2","dark":"#1e1e1e","black":"#000000","alternative-row":{"default":"#e5e5e5","on-light":"#e5e5e5","on-dark":"#333333"},"feedback":{"error":"#ff0000","warning":"#f5c400"}},"text-color":{"primary":{"default":"#1e1e1e","on-light":"#1e1e1e","on-dark":"#ffffff"},"secondary":{"default":"#5e5e5e","on-light":"#5e5e5e","on-dark":"#ababab"},"link":{"default":"#006fba","on-light":"#006fba","on-dark":"#008dde"},"error":{"default":"#ff0000","on-light":"#ff0000","on-dark":"#ff0000"}},"interactive-color":{"primary":{"default":"#0077cf","hover":"#005ba1","focus":"#005ba1","active":"#004376"},"secondary":{"primary":"transparent","hover":"#5e5e5e","focus":"#5e5e5e","active":{"on-light":"#333333","on-dark":"#e5e5e5"}},"disabled":{"on-light":"#808080","on-dark":"#ababab"}},"visualization-color":{"asset-allocation":{"local-stocks":"#1f55a5","non-local-stocks":"#8faad2","stocks":"#1f55a5","real-estate":"#a50032","other":"#f5c400","cash":"#518428","bonds":"#ef7622","not-classified":"#e5e5e5"},"correlation":{"positive":"#1f55a5","negative":"#ef7622"},"sector":{"cyclical":"#ef7622","sensitive":"#1f55a5","defensive":"#518428"},"sustainability":"#1f55a5","valuation":{"under":"#00a8e1","fair":"#e5efef","over":"#ef7622"},"performance":{"positive":"#00af41","neutral-text":"#5e5e5e","neutral-chart":"#cccccc","negative":"#ff0000"}},"chart-color":{"1":"#1f55a5","2":"#a50032","3":"#f5c400","4":"#518428","5":"#00a8e1","6":"#6a4c9e","7":"#ef7622","8":"#005f5f","9":"#00af41","10":"#e60546","11":"#7d256f","12":"#c19c31","13":"#00beaf","14":"#ff3c00","15":"#89bd40"},"feedback-color":{"info":"#f2f2f2","error":"#ff0000","error-background":"#ffe5e5","warning":"#f5c400","warning-background":"#fef9e5","success":"#00af41","success-background":"#e5f7eb"},"font":{"family":{"sans-serif":"'Univers', HelveticaNeue, 'Helvetica Neue', Helvetica, Arial, sans-serif","monospace":"'Lucida Sans Typewriter', 'Lucida Console', monaco, 'Bitstream Vera Sans Mono', monospace"},"weight":{"thin":200,"light":300,"regular":400,"bold":600},"size":{"xs":"10px","s":"14px","m":"16px","l":"20px","base":"16px","default":"16px","heading-level-1":"45px","heading-level-2":"32px","heading-level-3":"28px","heading-level-4":"23px","heading-level-5":"20px","heading-level-6":"18px","code":"12px"},"line-height":{"headings":1.2,"body":1.375}},"border":{"separator":{"default":"solid 1px #e5e5e5","on-light":"solid 1px #cccccc","on-dark":"solid 1px #333333","on-title":"solid 2px #333333","color-on-light":"#cccccc","color-on-dark":"#333333"},"control":{"default":"solid 1px #808080","color":"#808080"},"container":{"default":"solid 1px #e5e5e5","color-default":"#e5e5e5"},"disabled":"solid 1px #808080","radius":{"panel":"12px","pill":"24px","round":"50%","s":"2px"}},"size":{"icon":{"s":"15px","m":"23px"}},"space":{"xs":"4px","s":"6px","m":"8px","l":"12px","xl":"16px","quarter-x":"2px","half-x":"4px","three-quarter-x":"6px","1-x":"8px","1-and-a-half-x":"12px","2-x":"16px","3-x":"24px","4-x":"32px","8-x":"64px","inset":{"xs":"4px","s":"6px","m":"8px","l":"12px","xl":"16px","quarter-x":"2px","half-x":"4px","three-quarter-x":"6px","1-x":"8px","1-and-a-half-x":"12px","2-x":"16px","3-x":"24px","4-x":"32px","8-x":"64px","stretch":{"s":"6px 12px","m":"8px 16px","l":"12px 24px"}},"inline-left":{"xs":"0 4px 0 0","s":"0 6px 0 0","m":"0 8px 0 0","l":"0 12px 0 0","xl":"0 16px 0 0","half-x":"0 4px 0 0","three-quarter-x":"0 6px 0 0","1-x":"0 8px 0 0","1-and-a-half-x":"0 12px 0 0","2-x":"0 16px 0 0"},"inline-right":{"xs":"0 0 0 4px","s":"0 0 0 6px","m":"0 0 0 8px","l":"0 0 0 12px","xl":"0 0 0 16px","half-x":"0 0 0 4px","three-quarter-x":"0 0 0 6px","1-x":"0 0 0 8px","1-and-a-half-x":"0 0 0 12px","2-x":"0 0 0 16px"},"stack":{"s":"0 0 6px","m":"0 0 8px","l":"0 0 12px","xl":"0 0 16px","quarter-x":"0 0 2px","half-x":"0 0 4px","three-quarter-x":"0 0 6px","1-x":"0 0 8px","1-and-a-half-x":"0 0 12px","2-x":"0 0 16px","3-x":"0 0 24px","4-x":"0 0 32px","8-x":"0 0 64px"}},"transition":{"color":{"link":"color, 300ms"}},"opacity":{"disabled":".4","overlay":".5"},"box-shadow":{"drop":"0 2px 4px 0 rgba(0, 0, 0, .08)","focus":"0 0 4px 2px rgba(#0077cf, .8)"},"z-index":{"low":1,"sticky":100,"modal-overlay":800,"modal-content":810,"top-of-the-world":900},"breakpoint":{"navigation":{"on-canvas-nav":"768px","wide":"1024px"}},"masthead":{"height":"50px","height-tall":"70px"},"site-navigation":{"height":"50px","vertical-width":"230px"}},"shared":[{"utils":true},{"color":true},{"fonts":true},{"accessibility":true},{"animation":true},{"size":true},{"bubbles":true},{"typography":true}],"components":[{"link":true},{"icon":true},{"button":true},{"button_group":true},{"card":true},{"navigation_container":true},{"container":true},{"data_table":true},{"dialog":true},{"form":true},{"combo_box":true},{"list_group":true},{"loader":true},{"modal":true},{"menu":true},{"notification":true},{"pagination":true},{"page_shell":true},{"popover":true},{"range_slider":true},{"search_field":true},{"stepper":true},{"switch":true},{"tag":true},{"tooltip":true},{"masthead":true},{"site_navigation":true},{"alert":true},{"top_hat":true},{"layout_grid":true}],"theme":"mds"}

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



__webpack_require__(96);

var _core = __webpack_require__(12);

var _core2 = _interopRequireDefault(_core);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module Core */

module.exports = _core2.default;

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Given a path it extract a value from a complex deep object.
 *
 * @param {Object} obj
 * @param {String} path
 * @returns Object's value found in the given path.
 */

function getPath(obj, path) {
    var index, prefix, subpath;
    if (!obj || !path || typeof path !== "string" || path === "") {
        return;
    }

    index = path.indexOf(".");
    if (index === -1) {
        return obj[path];
    } else {
        prefix = path.substring(0, index);
        subpath = path.substring(index + 1);
        return getPath(obj[prefix], subpath);
    }
}

/**
 * Copy source object properties into a target one.
 *
 * @export
 * @param {Object} target Target object.
 * @param {Object} source Source Object
 */
var copy = function copy(target) {
    var key, source;

    if (!target) {
        return;
    }

    for (var i = 1; i < arguments.length; i++) {
        source = arguments[i];
        for (key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
};

/**
 * Extracts a value using an accessor or the same value if no accessor.
 * @param {Object} item Contains the value.
 * @param {Function|String}? accessor Accesor function or field that contains the value.
 * @param {Object} params Parameters to pass to the accesor function.
 * @return {Object} Value.
 */
var extract = function extract(item, accessor, params) {
    var value;
    if (typeof accessor === "undefined") {
        value = item;
    } else if (typeof accessor === "function") {
        value = accessor(item, params);
    } else if (typeof accessor === "string") {
        value = item[accessor];
    }

    return value;
};

/**
 * Clones and object.
 *
 * @export
 * @param {Object} target Object toclone.
 * @returns {Object} Cloned object.
 */
var clone = function clone(target) {
    if (target === undefined || target === null) {
        throw new TypeError("Cannot convert first argument to object");
    }

    var to = Object(target);
    for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) {
            continue;
        }

        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
                to[nextKey] = nextSource[nextKey];
            }
        }
    }

    return to;
};

/**
 * If just the value is passed return a boolean indicated is the value is undefined.
 * If the second parameter exists if value is undefined retunrs the second parameter, if not returns the value.
 * @param {Obect} value Object to evaluate.
 * @param {Object} defaultValue Object to return in case vale¡ue is undefined.
 */
var isUndefined = function isUndefined(value, defaultValue) {
    if (typeof defaultValue !== "undefined") return typeof value === "undefined" ? defaultValue : value;else return typeof value === "undefined";
};

/**
 * Check if the given value is not a number then return null, if it is a number return the number.
 * @param {Object} val Value to check.
 * @returns {undefined|Number}
 */
var NaNtoNull = function NaNtoNull(val) {
    if (typeof val !== "number" || isNaN(val) || val === Infinity) {
        return null;
    } else {
        return val;
    }
};

/**
 * Method to get the boolean value, if not it returnd a default value.
 * @param {Object} value Value to check if it is a boolean.
 * @param {Boolean} defaultValue Default value in case value is not a boolean.
 * @returns {Boolean}
 */
var getBoolean = function getBoolean(value, defaultValue) {
    return typeof value === "boolean" ? value : defaultValue;
};

var assign = function assign(target) {
    // .length of function is 2
    if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
            // Skip over if undefined or null
            for (var nextKey in nextSource) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                    to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
};

module.exports = {
    clone: clone,
    copy: copy,
    extract: extract,
    getBoolean: getBoolean,
    isUndefined: isUndefined,
    NaNtoNull: NaNtoNull,
    path: getPath,
    assign: assign
};

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AxesManager = __webpack_require__(8);
var Base = __webpack_require__(6);
var Canvas = __webpack_require__(9);
var DataManager = __webpack_require__(10);
var ScalesManager = __webpack_require__(11);
var Utils = __webpack_require__(4);
var Classes = __webpack_require__(7);

/**
 * A foundation for all axed charts.
 * The renderng cycle is:
 * <em><br>0- setData() Data is initialized.
 * <br>1- beforeDraw() method is called. Event <i>beforeDraw</i> is triggered.
 * <br>2- draw() method is called.
 * <br>3- afterDraw() method called. Event <i>afterDraw</i> is triggered.</em>
 * <br><br><small>Methods setData() and draw() MUST be implemented</small>
 * @example
 * var BarChart = Chart.extend({
 *  ...
 * })
 * @param {Object} options
 * @class
 * @extends Base
 */
var Chart = Base.extend(
/**
 * A foundation for all axed charts.
 *  @lends Chart.prototype
 **/
{
    /** @type {String} */
    UID: null,
    /** @type {AxisManager} */
    axes: null,
    /** @type {Canvas} */
    canvas: null,
    /** @type {DataManager} */
    data: null,
    /** @type {Array} */
    colors: Utils.colors.combined,
    /** @type {D3.dispatch} */
    dispatch: null,
    /** @type {ScaleManager} */
    scales: null,
    /** @type {Object} */
    margins: { top: 20, right: 40, bottom: 30, left: 40 },
    /** @type {String} */
    canvasTemplate: null,
    /** @type {Number} */
    yAxesLabelWidth: 0,
    /** @type {String} */
    legendPopoverParentElement: 'body', // pass string selector id including # (e.g. '#line-chart-container') or class including . (e.g. '.mbc-line-chart') of element to append popover

    /**
     * Initializes the chart.
     */
    initializer: function initializer() {
        this.set("UID", "mbc" + Utils.string.UID());
        this.set("axes", new AxesManager());
        this.set("data", new DataManager());
        this.set("dispatch", d3.dispatch("hover", "click", "afterDraw", "beforeDraw", "mouseout"));
        this.set("scales", new ScalesManager());
        d3.rebind(this, this.get("dispatch"), "on");
    },

    /**
     * Returns the function D3 calls to set the data.
     * @example
     * container.datum(dataset).call(chart.init());
     *
     * @returns {Function}
     */
    init: function init() {
        return this._createChart.bind(this);
    },
    /**
     * Adds a new Canvas object and calls the _prepare function for each selection
     * @param {D3.Selection} name Selection where the charts are going to be created.
     * @private
     */
    _createChart: function _createChart(selection) {
        var _selection$classed;

        this.set("selection", selection);
        selection.classed((_selection$classed = {}, _defineProperty(_selection$classed, this.get("id") || "", true), _defineProperty(_selection$classed, this.get("UID"), true), _selection$classed));
        this._createCanvas();
        selection.each(this._prepare.bind(this));
    },

    /**
     * Create and set a new canvas instance.
     */
    _createCanvas: function _createCanvas() {
        var selection = this.get("selection");
        // beforeCanvas method is called if exists.
        Utils.fn.call(this, this.beforeCanvas, selection);
        this.set("canvas", new Canvas({
            selection: selection,
            margin: this.get("margins"),
            template: this.get("canvasTemplate"),
            yAxesLabelWidth: this.get("yAxesLabelWidth"),
            UID: this.get("UID")
        }));
    },

    /**
     * Calls the setData or/and setup function if they exist and calls the rendering cycle if the data is valid.
     * @private
     */
    _prepare: function _prepare(data) {
        var invalidData = false;
        invalidData = Utils.fn.call(this, this.setup, data);
        /* FIXME: remove setData call next major version */
        invalidData = invalidData || Utils.fn.call(this, this.setData, data);
        if (!invalidData) this.update();
    },

    /**
     * Executes the rendering cycle in this order
     * <li> beforeDraw
     * <li> draw
     * <li> afterDraw
     */
    update: function update(options) {
        this.get("dispatch").beforeDraw();
        var updateCanvas = Utils.fn.call(this, this.beforeDraw, options);
        if (typeof updateCanvas === "undefined" || updateCanvas) this.get("canvas").update();
        this.draw(options);
        Utils.fn.call(this, this.afterDraw, options);
        this.get("dispatch").afterDraw();
    },

    /**
     * Returns the index *n* color from the *colors* attribute array
     * @param {Number} index Index of color to return
     */
    color: function color(index) {
        var colors = this.get("colors");
        return colors[index % colors.length];
    },

    /**
     * Returns a closure function with a formatter within.
     * @param {Function|String} format If it is a string uses d3.format.
     */
    tickFormat: function tickFormat(format) {
        return function (d, i) {
            if (!format) {
                return d;
            }

            return typeof format === "function" ? format(d, i) : d3.format(format)(d);
        };
    },

    /**
     * @abstract
     * @deprecated Use setup method instead.
     * Prepare the data for the chart and all the initial values prior to start rendering. Legacy.
     */
    setData: function setData() {},

    /**
     * @abstract
     * Prepare the data for the chart and all the initial values prior to start rendering.
     */
    setup: function setup() {},

    /**
     * @abstract
     * This method is called before creating the canvas instance, is useful to change the template before.
     */
    beforeCanvas: function beforeCanvas() {},

    /**
     * @abstract
     * This method is called before drawing the chart. Useful to prepare data when the SVG element is already inserted into the dom.
     */
    beforeDraw: function beforeDraw() {},

    /**
     * @abstract
     * Used to draw the chart into the SVG element.
     */
    draw: function draw() {
        console.error(new Error("draw method is not defined"));
    },

    /**
     * @abstract
     * Called after the chart is rendered. Useful to make post-render modifications.
     */
    afterDraw: function afterDraw() {},

    /**
     * Returns an id based class.
     * @param {String} suffix Suffix to add to the id.
     * @return {String} The class name (id + suffix).
     */
    getId: function getId(suffix) {
        return this.get("id") + "-" + suffix;
    },

    /**
     * @adjustYLabels
     * Visual adjustments after the chart has been rendered
     * appendYAbbreviation and adjustYAxisLabel
     */
    adjustYLabels: function adjustYLabels() {
        var axes = this.get("canvas").get("axesGroup");

        axes.selectAll(".x-alternative-first, .x-alternative-last").remove();

        axes.selectAll("." + Classes.AXIS + "-left .tick text, ." + Classes.AXIS + "-right .tick text").attrs({ x: 0, y: 12 });

        var y1Ticks = axes.selectAll("." + Classes.AXIS + "-y1 .tick");
        y1Ticks.first().classed("dark", true).select("text").attr("y", -10);

        y1Ticks.last().classed("dark", true);

        var y2Ticks = axes.selectAll("." + Classes.AXIS + "-y2 .tick");
        y2Ticks.first().classed("dark", true).select("text").attr("y", -10);

        y2Ticks.last().classed("dark", true);

        var y1TicksAlign = this.get("y1TicksAlign");
        var y1AxisOrient = this.get("y1AxisOrient");
        var y1Texts = axes.selectAll("." + Classes.AXIS + "-y1 text");
        if (y1TicksAlign === "right" && y1AxisOrient === "right") {
            y1Texts.attr("x", this.get("yTickSize")).style("text-anchor", "end");
        }

        if (y1TicksAlign === "left" && y1AxisOrient === "left") {
            y1Texts.attr("x", this.get("yTickSize") * -1).style("text-anchor", "start");
        }

        if (this.get("y2TicksAlign") === "right" && this.get("y2AxisOrient") === "right") {
            axes.selectAll("." + Classes.AXIS + "-y2 text").attr("x", this.get("yTickSize")).style("text-anchor", "end");
        }

        this.appendYAbbreviation(axes);

        this.adjustYAxisLabel("y1");
        if (this.get("y2")) {
            this.adjustYAxisLabel("y2");
        }
    },

    /**
     * Appends Y axes abbreviations under the up most tick.
     * Checks for 'y1Abbreviation' and 'y2Abbreviation.
     */
    appendYAbbreviation: function appendYAbbreviation(axes) {
        var appendAbbrev = function appendAbbrev(tick, abbrev, align) {
            var lastText = tick.select("text");
            tick.append("text").attrs({
                "text-anchor": align === "right" ? "end" : "start",
                x: lastText.attr("x"),
                y: lastText.attr("y") * 2 + 4,
                dy: lastText.attr("dy")
            }).classed("mbc-tick-abbreviation", true).text(abbrev);
        };

        var lastTick, textAlign;
        var y1Abbrev = this.get("y1Abbreviation"),
            y2Abbrev = this.get("y2Abbreviation");
        if (y1Abbrev) {
            lastTick = axes.selectAll("." + Classes.AXIS + "-y1 .tick").last();
            textAlign = this.get("y1TicksAlign");
            appendAbbrev(lastTick, y1Abbrev, textAlign);
        }

        if (this.get("y2") && y2Abbrev) {
            lastTick = axes.selectAll("." + Classes.AXIS + "-y2 .tick").last();
            textAlign = this.get("y2TicksAlign");
            appendAbbrev(lastTick, y2Abbrev, textAlign);
        }
    },

    /**
     * @adjustYAxisLabel
     * dynamic hide Y labels to avoid overlap
     * @param {String} yAxisName: "y1" or "y2"
     */
    adjustYAxisLabel: function adjustYAxisLabel(yAxisName) {
        var axes = this.get("canvas").get("axesGroup"),
            tickValues = this.get("axes").axis(yAxisName).tickValues(),
            axesTicks = axes.selectAll("." + Classes.AXIS + "-" + yAxisName + " .tick"),
            textSpacing = 23; // the height of tick text(18 + 0.32em)

        var lastPosition = 0,
            beforeLastPosition = 0,
            beforeLastShowedTickIndex = 0,
            lastShowedTickIndex = 0,
            showLastShowedTick = true,
            showBeforeLastShowedTick = true;

        axesTicks.style({
            opacity: function opacity(d, i) {
                var opacity = 0;
                var tickPosition = d3.transform(this.getAttribute("transform")).translate[1];
                var textTotalDy = parseFloat(this.lastChild.attributes.dy.value) * (this.childNodes.length - 1) * 14;
                var textDistance = +this.lastChild.attributes.y.value + textTotalDy;
                var currentPosition = tickPosition + textDistance;
                var distance = Math.abs(currentPosition - lastPosition);
                if (distance > textSpacing) {
                    opacity = 1;
                    beforeLastShowedTickIndex = lastShowedTickIndex;
                    lastShowedTickIndex = i;
                    beforeLastPosition = lastPosition;
                    lastPosition = currentPosition;
                }

                if (i === tickValues.length - 1 && opacity === 0) {
                    opacity = 1;
                    showLastShowedTick = false;
                    if (Math.abs(currentPosition - beforeLastPosition) < textSpacing) {
                        showBeforeLastShowedTick = false;
                    }
                }
                return opacity;
            }
        });

        if (!showLastShowedTick && showLastShowedTick !== 0) {
            d3.select(axesTicks[0][lastShowedTickIndex]).style({ opacity: 0 });
        }

        if (!showBeforeLastShowedTick && beforeLastShowedTickIndex !== 0) {
            d3.select(axesTicks[0][beforeLastShowedTickIndex]).style({ opacity: 0 });
        }
    },

    /**
     * Appends a Y axis label.
     * @param {Object} layer: "y1" or "y2"
     * @param {String} axisName: "y1" or "y2"
     * @param {String} text: y1AxisLabel or y2AxisLabel
     */
    appendYLabel: function appendYLabel(layer, axisName, text, adjustCanvasHeight) {
        var yTickSize = this.get("yTickSize");
        var canvas = this.get("canvas");
        var axis = this.get("axes").axis(axisName);
        var isLeft = axis.orient() === "left";
        var axisSelector = Classes.AXIS + "-" + axisName;
        var anchor = isLeft ? "start" : "end";
        var rotation = isLeft ? 270 : 90;
        var axisLayer, translate, x, y, yLabel, svgText;
        var yAxesLabelPadding = this.get("yAxesLabelPadding");
        adjustCanvasHeight = adjustCanvasHeight === undefined ? 0 : adjustCanvasHeight;

        // Calculating
        axisLayer = canvas.layer(axisSelector, "axes", true);
        translate = d3.transform(axisLayer.attr("transform")).translate;
        x = isLeft ? translate[0] - yAxesLabelPadding - yTickSize : translate[0] + yTickSize + yAxesLabelPadding;
        y = canvas.height() - adjustCanvasHeight;

        yLabel = layer.append("g").attr(axisSelector + "-label", "axes").attr("transform", "translate(" + x + ", " + y + ")");

        svgText = yLabel.append("text").text(text).classed(axisSelector + "-label-text", "true").classed("mbc-y-axis-text", "true").attrs({
            "text-anchor": anchor,
            transform: "rotate(" + rotation + ")"
        });

        // dynamic abbreviate yAxisLabel if it is higher than container
        var labelText = svgText[0][0];
        var textHeight = Math.abs(labelText.clientWidth);
        if (textHeight > y) {
            var maxNum = Math.floor(y / (textHeight / text.length));
            labelText.innerHTML = text.substr(0, maxNum - 2) + "...";
        }
    }
});

module.exports = Chart;

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Core = __webpack_require__(12);
var Utils = __webpack_require__(4);
var Base = __webpack_require__(6);

var DateAxis = Base.extend({
    /*axis data*/
    domain: [],
    range: [0, 0],
    subLabels: [],

    /*axis style*/
    orient: 'bottom',
    labelSpacing: 10,
    font: '14px helvetica neue',
    rangeBandsPadding: 0.00,
    rangeBandsOuterPadding: 0.00,

    /*label format*/
    labelFormat: '%b',
    subLabelFormat: '%Y',
    subLabelDx: '-0.75em',
    tickFormat: null,

    timeLevel: 'monthly',

    //======================= initialize ==========================

    initializer: function initializer() {
        this._initData();
        this._initScale();
        this._initAxis();
    },

    _initData: function _initData() {

        var opDomain = this.get('domain');
        var labelInterval = this._calcLabelInterval();
        var subLabels = this._calcSubLabels(opDomain, labelInterval);

        this.set('labelInterval', labelInterval);
        this.set('subLabels', subLabels);

        //temporary handle way, will set a map to contain yearly, quarterly, monthly
        var timeLevel = this.get('timeLevel').toLowerCase();
        switch (timeLevel) {
            case 'quarterly':
                this.set('tickFormat', this.quarterlyTickFormat);
                this.set('subLabelDx', '-0.5em');
                break;

            case 'yearly':
                this.set('tickFormat', d3.time.format('%Y'));
                this.set('subLabels', []);
                break;

            default:
                this.set('tickFormat', d3.time.format(this.get('labelFormat')));
                break;
        }
    },

    _initScale: function _initScale() {
        var domain = this.get('domain'),
            range = this.get('range');

        var scale = d3.scale.ordinal().domain(domain).rangeBands(range, this.get('rangeBandsPadding'), this.get('rangeBandsOuterPadding'));

        this.set('scale', scale);
    },

    _initAxis: function _initAxis() {
        var scale = this.getScale(),
            orient = this.get('orient'),
            formatFun = this.get('tickFormat'),
            labelInterval = this.get('labelInterval'),
            getDate = this.getDate;

        var axis = d3.svg.axis().scale(scale).orient(orient).tickFormat(function (d, i) {

            if (i % labelInterval !== 0) {
                return '';
            }

            if (typeof formatFun === 'function') {
                return formatFun(getDate(d));
            }

            return d;
        });

        this.set('axis', axis);
    },

    _calcLabelInterval: function _calcLabelInterval() {
        var opDomain = this.get('domain'),
            range = this.get('range'),
            axisWidth = range[1] - range[0],
            spacing = this.get('labelSpacing'),
            labelFormat = d3.time.format(this.get('labelFormat')),
            getDate = this.getDate,
            maxTextWidth,
            maxLabelCount,
            labelInterval;

        maxTextWidth = this.calcMaxTextWidth(opDomain.map(function (item) {
            return labelFormat(getDate(item));
        }));

        //maxText * n + spacing * (n-1) < width;
        maxLabelCount = Math.floor((axisWidth + spacing) / (maxTextWidth + spacing));

        labelInterval = Math.ceil(opDomain.length / maxLabelCount);

        return labelInterval;
    },

    _calcSubLabels: function _calcSubLabels(domain, labelInterval) {
        if (!Array.isArray(domain)) {
            return [];
        }

        var subLabels = [];
        var timeFormat = d3.time.format;
        var subLabelFormat = timeFormat(this.get('subLabelFormat'));
        var getDate = this.getDate;

        domain.forEach(function (item, index) {
            var date = getDate(item);
            var label = subLabelFormat(date);

            if (index % labelInterval === 0 && subLabels.indexOf(label) === -1) {
                subLabels.push(label);
            } else {
                subLabels.push(null);
            }
        });

        return subLabels;
    },

    //======================== public methods ======================

    draw: function draw(selection) {
        var axis = this.getAxis();
        selection.call(axis);
    },

    drawSubLabels: function drawSubLabels(canvas) {
        var xScale = this.get("scale");
        var xAxisOrient = this.get("orient");
        var subLabels = this.get("subLabels");
        var xlayer = canvas.layer("mbc-axes-xlabels", "axes");
        var xTexts;

        xTexts = xlayer.selectAll(".mbc-x-label").data(xScale.domain());
        xTexts.enter().append("g").classed("mbc-x-label", true).attr("transform", function (d) {
            var x = xScale(d) + xScale.rangeBand() / 2;
            var y = xAxisOrient === "bottom" ? canvas.height() + 35 : -25;
            return "translate(" + x + ", " + y + ")";
        }).append("text").text(function (d, i) {
            var label = "";
            if (i < subLabels.length) {
                label = subLabels[i] || "";
            }

            return label;
        }).attrs({
            "text-anchor": "start",
            "dx": this.get("subLabelDx")
        });
    },

    getScale: function getScale() {
        return this.get('scale');
    },

    getAxis: function getAxis() {
        return this.get('axis');
    },

    //=================== util methods ============================

    isInvalidDate: function isInvalidDate(date) {
        if (date instanceof Date && date.toString() !== 'Invalid Date') {
            return false;
        }

        return true;
    },

    checkLabelsWidth: function checkLabelsWidth(labelList, axisWidth, spacing, font) {
        var totalSpacing = spacing * (labelList.length - 1);
        var totalWidth = this.getTextWidth({
            font: font,
            text: labelList.join('')
        });

        //axis can show all labels well.
        if (axisWidth > totalWidth + totalSpacing) {
            return true;
        }

        return false;
    },

    getTextWidth: function getTextWidth(option) {

        var canvas = this.getTextWidth.canvas || (this.getTextWidth.canvas = document.createElement('canvas'));
        var context = canvas.getContext('2d');

        context.font = option.font;

        var dimension = context.measureText(option.text);

        return dimension.width;
    },

    calcMaxTextWidth: function calcMaxTextWidth(texts) {
        var _this = this;
        var font = this.get('font');
        var maxTextWidth = d3.max(texts.map(function (text) {
            return _this.getTextWidth({
                font: font,
                text: text
            });
        }));

        return maxTextWidth;
    },

    getDate: function getDate(maskDate) {
        return new Date(Utils.string.unmask(maskDate));
    },

    quarterlyTickFormat: function quarterlyTickFormat(date) {
        var month = +d3.time.format('%m')(date);
        var quarterly = [3, 6, 9, 12];

        if (quarterly.indexOf(month) === -1) {
            return;
        }

        return "Q" + month / 3;
    },

    //========================= getter & setter ============================

    get: function get(key) {
        return this.__attributes[key];
    },

    set: function set(key, value) {
        this.__attributes[key] = value;
    }

});

module.exports = DateAxis;

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DateAxis = __webpack_require__(38);

module.exports = {
    DateAxis: DateAxis
};

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var array = __webpack_require__(13);
var chart = __webpack_require__(40);
var fn = __webpack_require__(44);
var object = __webpack_require__(3);
var str = __webpack_require__(46);
var svg = __webpack_require__(47);
var colors = __webpack_require__(41);
var number = __webpack_require__(45);
var generators = __webpack_require__(43);

/** @module Core/Utils */

module.exports = {
    assign: object.assign,
    callFn: fn.call,
    clone: object.clone,
    convertDashToEnDash: str.convertDashToEnDash,
    copy: object.copy,
    dashify: str.dashify,
    extract: object.extract,
    getBoolean: object.getBoolean,
    getDomain: chart.getDomain,
    getGreaterSVGTextWidth: svg.getGreaterSVGTextWidth,
    getRoundToUnits: array.getRoundToUnits,
    getStackedValues: array.getStackedValues,
    getSVGTextWidth: svg.getSVGTextWidth,
    getTickValues: chart.getTickValues,
    hasNegative: array.hasNegative,
    indexOf: array.indexOf,
    isUndefined: object.isUndefined,
    minmax: array.minmax,
    NaNtoNull: object.NaNtoNull,
    removeDuplicates: array.removeDuplicates,
    template: str.template,
    UID: str.UID,

    array: array,
    chart: chart,
    fn: fn,
    object: object,
    string: str,
    svg: svg,
    colors: colors,
    number: number,
    generators: generators
};

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var array = __webpack_require__(13);
var object = __webpack_require__(3);

/**
 * Calculate tickvalues for a given dataset.
 *
 * @param {Array} domain Two values array.
 * @param {Number} ticksNumber Number of ticks to show.
 *
 * @return {Array} Containing the ticks to include in the chart's axis.
 */
var getTickValues = function getTickValues(domain, ticksNumber) {
    ticksNumber = ticksNumber || 4;
    var distance = Math.abs(domain[0] - domain[1]);
    var domainStep = distance / ticksNumber;
    var min = domain[0];
    var max = domain[1];
    var tickValues = [];

    while (min < max) {
        tickValues.push(min);
        min += domainStep;
    }

    tickValues.push(min);

    return tickValues;
};

function ensureGreaterThanOne(num) {
    var power = 0;
    while (num < 10) {
        num = num * 10;
        power++;
    }

    return { number: num, power: power };
}

/**
 * Returns a domain with positive numbers starting from 0 based on the chart values.
 *
 * @param {Array} allValues Array of numbers containing values used to caculate the domain.
 * @param {Number} roundTo Tenths, hundreds, thousands,...
 * @param {boolean} integers Show only integer numbers, without decimal.
 * @param {Number} steps Numbers of intended steps into the domain.
 * @returns {Array} Two values array with the domain.
 */
function getPositiveDomain(allValues, roundTo, integers, steps) {
    var max = Math.ceil(d3.max(allValues) / roundTo) * roundTo;
    if (max === 0) return [0, 1];
    var ensured = ensureGreaterThanOne(max);
    var mod, power;
    var almostZero = 0.01;

    max = ensured.number;
    power = ensured.power;
    roundTo *= Math.pow(10, power);

    if (integers) {
        mod = max % steps;
        while (mod <= almostZero) {
            max += roundTo;
            mod = max % steps;
        }
    }

    max = max / Math.pow(10, power);

    return [0, max];
}

/**
 * Returns a Symmetrical domain based on the chart values.
 *
 * @param {Array} allValues Array of numbers containing values used to caculate the domain.
 * @param {Number} roundTo Tenths, hundreds, thousands,...
 * @returns
 */
function getSymmetricalDomain(allValues, roundTo, integers, steps) {
    var allPositive = array.getAllPositives(allValues);
    var max = Math.ceil(d3.max(allPositive) / roundTo) * roundTo;
    if (max === 0) return [-1, 1];
    var ensured = ensureGreaterThanOne(max);
    var min, mod, power;

    max = ensured.number;
    power = ensured.power;
    min = max * -1;
    roundTo *= Math.pow(10, power);

    if (integers) {
        mod = max * 2 % steps;
        while (mod !== 0) {
            max += roundTo;
            mod = max * 2 % steps;
        }

        min = max * -1;
    }

    min = min / Math.pow(10, power);
    max = max / Math.pow(10, power);

    return [min, max];
}

/**
 * Returns an Asymmetrical domain based on the chart values.
 *
 * @param {Array} allValues Array of numbers containing values used to caculate the domain.
 * @param {Number} roundTo Tenths, hundreds, thousands,...
 * @returns
 */
function getAsymmetricalDomain(allValues, roundTo) {
    var max = Math.ceil(d3.max(allValues) / roundTo) * roundTo;
    var min = Math.floor(d3.min(allValues) / roundTo) * roundTo;

    return [min, max];
}

/**
 * Calculates the domain for a certain dataset.
 *
 * @param {Object}? options Options available:
 * <li><b>values:</b> Required. Array of values.
 * <li><b>roundTo:</b> Optional. roundTo 10, 100, 1000, etc.
 * <li><b>forceNegative:</b> Optional. Boolean value to force negative values on the domain
 * <li><b>symmetrical:</b> Optional.
 * <li><b>steps:</b> Optional. Intended ticks number.
 *
 * @return {Array} Two values array indicating the domain.
 */
var getDomain = function getDomain(options) {
    options = options || {};
    var allValues = options.values;
    var roundTo = options.roundTo || 10;
    var integers = object.getBoolean(options.integers, false);
    var forceNegative = object.getBoolean(options.forceNegative, false);
    var symmetrical = object.getBoolean(options.symmetrical, true);
    var raw = object.getBoolean(options.raw, false);
    var steps = options.steps || 4;
    var negatives;

    if (!allValues || allValues.length === 0) {
        return [0, 1];
    }

    negatives = array.hasNegative(allValues);
    allValues = array.removeDuplicates(allValues);

    if (raw) {
        return [d3.min(allValues), d3.max(allValues)];
    }

    if (!negatives && !forceNegative) {
        return getPositiveDomain(allValues, roundTo, integers, steps);
    } else if (symmetrical) {
        return getSymmetricalDomain(allValues, roundTo, integers, steps);
    } else {
        return getAsymmetricalDomain(allValues, roundTo, integers, steps);
    }
};

/**
 * Returns the index of a given value into a range array.
 * @param {Number} val Value to find index into range array.
 * @param {Array<Array>} range Range array. ex: [[-infinity, -1], [-1, 0], [0, 1], [1, Infinity]]
 * @return {Number} The range index or -1.
 */
function getRangeIndex(val, range) {
    for (var i = 0; i < range.length; i++) {
        if (val > range[i][0] && (val <= range[i][1] || range[i][1] === undefined)) {
            return i;
        }
    }

    return -1;
}

/**
 * Returns the value of a given value into a values array.
 * @param {Number} val Value to find index into range array.
 * @param {Array<Array>} range Range array. ex: [[-infinity, -1], [-1, 0], [0, 1], [1, Infinity]]
 * @param {Array} values Values to return
 * @return {Object} The value that matches range index or `undefined`.
 */
function getRangeValue(val, range, values) {
    var index = getRangeIndex(val, range);
    if (index !== -1) return values[index];
}

/**
 * Returns the calculated padding between bars
 * @param {Array} num the number of bars
 * @param {Number} dim the height or width of the canvas
 * @param {String} orient whether horizontal or vertical bar chart
 * @return {String} type whether standard or grouped bars
 */
function getBarPadding(num, dim, orient) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "standard";


    var padding = 9;
    var ratio = dim / num;

    if (orient === "horizontal" || orient === "vertical" && type === "standard") {

        if (ratio > 21) {
            return padding;
        } else if (ratio <= 21 && ratio > 14) {
            padding = 6;
        } else if (ratio <= 14 && ratio > 7) {
            padding = 3;
        } else {
            padding = 1;
        }
    } else if (orient === "vertical" && type === "grouped") {

        if (ratio > 16.5) {
            return padding;
        } else if (ratio <= 16.5 && ratio > 11) {
            padding = 6;
        } else if (ratio <= 11 && ratio > 5.5) {
            padding = 3;
        } else {
            padding = 1;
        }
    }

    return padding;
}

module.exports = {
    getTickValues: getTickValues,
    getDomain: getDomain,
    getRangeIndex: getRangeIndex,
    getRangeValue: getRangeValue,
    getBarPadding: getBarPadding
};

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mbc_mds_constants = __webpack_require__(14).constants;
var mbc_mds_chart_color = mbc_mds_constants["chart-color"];

/**
 * deprecating `var colors` in v3.0.0
 */
var colors = {
    "blue": mbc_mds_chart_color["1"],
    "maroon": mbc_mds_chart_color["2"],
    "teal": mbc_mds_chart_color["8"],
    "orange": mbc_mds_chart_color["7"],
    "green": mbc_mds_chart_color["9"],
    "violet": mbc_mds_chart_color["6"],
    "yellow": mbc_mds_chart_color["3"],
    "cyan": mbc_mds_chart_color["5"],
    "dark-green": mbc_mds_chart_color["4"],
    "red": mbc_mds_constants["color"]["red"]["50"],
    "light-red": mbc_mds_chart_color["10"],
    "dark-violet": mbc_mds_chart_color["11"],
    "dark-yellow": mbc_mds_chart_color["12"],
    "aqua": mbc_mds_chart_color["13"],
    "bright-orange": mbc_mds_chart_color["14"],
    "light-green": mbc_mds_chart_color["15"],
    "white": mbc_mds_constants["color"].white,
    "grey1": mbc_mds_constants["color"]["neutral"]["90"],
    "grey2": mbc_mds_constants["background-color"].light,
    "grey3": mbc_mds_constants["color"]["neutral"]["80"],
    "grey4": mbc_mds_constants["color"]["neutral"]["80"],
    "grey5": mbc_mds_constants["color"]["neutral"]["50"],
    "grey6": mbc_mds_constants["color"]["neutral"]["37"],
    "grey7": mbc_mds_constants["color"]["neutral"]["12"],
    "black": mbc_mds_constants["color"].black
};

var primary = [mbc_mds_chart_color["1"], mbc_mds_chart_color["2"], mbc_mds_chart_color["3"], mbc_mds_chart_color["4"], mbc_mds_chart_color["5"], mbc_mds_chart_color["6"], mbc_mds_chart_color["7"], mbc_mds_chart_color["8"], mbc_mds_chart_color["9"]];

var secondary = [mbc_mds_chart_color["10"], mbc_mds_chart_color["11"], mbc_mds_chart_color["12"], mbc_mds_chart_color["13"], mbc_mds_chart_color["14"], mbc_mds_chart_color["15"]];

var palettes = [primary, secondary];

var combined = palettes.reduce(function (a, b) {
    return a.concat(b);
}, []);

module.exports = {
    colors: colors,
    primary: primary,
    secondary: secondary,
    combined: combined,
    mbc_mds_constants: mbc_mds_constants,
    mds_constants: mbc_mds_constants,
    mbc_mds_chart_color: mbc_mds_chart_color,
    mds_chart_color: mbc_mds_chart_color
};

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var names = ["Asia/Pacific Long-Short Equity", "Bear-Market Equity", "China Long-Short Equity", "Convertible Arbitrage", "Currency", "Debt Arbitage", "Distressed Securities", "Diversified Arbitage", "Emrg-Mkta Long-Short Equity", "Equity Market Neutral", "Europe Long-Short Equity", "Event Driven", "Global Long-Short Equity", "Global Macro", "Long-Short Debt", "Merger Arbitage", "Multistrategy", "Systematic Futures", "U.S. Long-Short Equity", "U.S. Sm-Cap Lg-Short Equity", "Volatility"];

function getDummyArray(n) {
    var i = 0;
    var arr = [];
    var sign;
    for (; i < n; i++) {
        sign = Math.random() < 0.5 ? -1 : 1;
        arr.push(Math.random() * sign);
    }

    return arr;
}

function getRandomName() {
    return names[Math.floor(names.length * Math.random())];
}

function getDummyRows(num) {
    var length = num || 3 + Math.floor(Math.random() * 47);
    var i = 0;
    var rows = [];
    var name;

    for (; i < length; i++) {
        name = getRandomName();
        rows.push(name);
    }

    return rows;
}

function getDummyMatrix(num) {
    var i;
    var j;
    var matrix = [];
    var length = num || 3 + Math.floor(Math.random() * 47);
    var sign, value;

    // for (i = 0; i < num; i++) {
    //     matrix[i] = [];
    // }

    for (i = 0; i < length; i++) {
        for (j = 0; j < length; j++) {
            if (!matrix[i]) matrix[i] = [];
            if (!matrix[j]) matrix[j] = [];

            sign = Math.random() < 0.5 ? -1 : 1;
            value = Math.random() * sign;
            if (j < i) {
                matrix[i][j] = value;
                matrix[j][i] = value;
            } else if (i === j) {
                matrix[i][j] = 1;
                break;
            }
        }
    }

    return matrix;
}

function grow(matrix) {
    var arr = getDummyArray(matrix.length);
    arr.forEach(function (val, i) {
        matrix[i].push(val);
    });

    arr.push(1);
    matrix.push(arr);
    return matrix;
}

function dataset(num) {
    var length = num || 3 + Math.floor(Math.random() * 47);
    var dummyRows = getDummyRows(length);
    var dummyMatrix = getDummyMatrix(length);

    return {
        rows: dummyRows,
        matrix: dummyMatrix
    };
}

module.exports = {
    matrix: getDummyMatrix,
    rows: getDummyRows,
    array: getDummyArray,
    dataset: dataset,
    grow: grow,
    name: getRandomName
};

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crmatrix = __webpack_require__(42);
/**
 * @fileOverview Generates "Lorem ipsum" style text.
 * @author rviscomi@gmail.com Rick Viscomi,
 * 		tinsley@tinsology.net Mathew Tinsley
 * @version 1.0
 */

/**
 *	Copyright (c) 2009, Mathew Tinsley (tinsley@tinsology.net)
 *	All rights reserved.
 *
 *	Redistribution and use in source and binary forms, with or without
 *	modification, are permitted provided that the following conditions are met:
 *		* Redistributions of source code must retain the above copyright
 *		  notice, this list of conditions and the following disclaimer.
 *		* Redistributions in binary form must reproduce the above copyright
 *		  notice, this list of conditions and the following disclaimer in the
 *		  documentation and/or other materials provided with the distribution.
 *		* Neither the name of the organization nor the
 *		  names of its contributors may be used to endorse or promote products
 *		  derived from this software without specific prior written permission.
 *
 *	THIS SOFTWARE IS PROVIDED BY MATHEW TINSLEY ""AS IS"" AND ANY
 *	EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *	WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 *	DISCLAIMED. IN NO EVENT SHALL <copyright holder> BE LIABLE FOR ANY
 *	DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 *	(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 *	LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 *	ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 *	(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 *	SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class Jibborish generator.
 */
var LoremIpsum = function LoremIpsum() {};

/**
 * Average number of words per sentence.
 * @constant {number}
 */
LoremIpsum.WORDS_PER_SENTENCE_AVG = 24.460;

/**
 * Standard deviation of the number of words per sentence.
 * @constant {number}
 */
LoremIpsum.WORDS_PER_SENTENCE_STD = 5.080;

/**
 * List of possible words.
 * @constant {Array.string}
 */
LoremIpsum.WORDS = ["lorem", "ipsum", "dolor", "sit", "amet", "consectetur", "adipiscing", "elit", "curabitur", "vel", "hendrerit", "libero", "eleifend", "blandit", "nunc", "ornare", "odio", "ut", "orci", "gravida", "imperdiet", "nullam", "purus", "lacinia", "a", "pretium", "quis", "congue", "praesent", "sagittis", "laoreet", "auctor", "mauris", "non", "velit", "eros", "dictum", "proin", "accumsan", "sapien", "nec", "massa", "volutpat", "venenatis", "sed", "eu", "molestie", "lacus", "quisque", "porttitor", "ligula", "dui", "mollis", "tempus", "at", "magna", "vestibulum", "turpis", "ac", "diam", "tincidunt", "id", "condimentum", "enim", "sodales", "in", "hac", "habitasse", "platea", "dictumst", "aenean", "neque", "fusce", "augue", "leo", "eget", "semper", "mattis", "tortor", "scelerisque", "nulla", "interdum", "tellus", "malesuada", "rhoncus", "porta", "sem", "aliquet", "et", "nam", "suspendisse", "potenti", "vivamus", "luctus", "fringilla", "erat", "donec", "justo", "vehicula", "ultricies", "varius", "ante", "primis", "faucibus", "ultrices", "posuere", "cubilia", "curae", "etiam", "cursus", "aliquam", "quam", "dapibus", "nisl", "feugiat", "egestas", "class", "aptent", "taciti", "sociosqu", "ad", "litora", "torquent", "per", "conubia", "nostra", "inceptos", "himenaeos", "phasellus", "nibh", "pulvinar", "vitae", "urna", "iaculis", "lobortis", "nisi", "viverra", "arcu", "morbi", "pellentesque", "metus", "commodo", "ut", "facilisis", "felis", "tristique", "ullamcorper", "placerat", "aenean", "convallis", "sollicitudin", "integer", "rutrum", "duis", "est", "etiam", "bibendum", "donec", "pharetra", "vulputate", "maecenas", "mi", "fermentum", "consequat", "suscipit", "aliquam", "habitant", "senectus", "netus", "fames", "quisque", "euismod", "curabitur", "lectus", "elementum", "tempor", "risus", "cras"];

/**
 * Generate "Lorem ipsum" style words.
 * @param numWords {number} Number of words to generate.
 * @return {string} "Lorem ipsum..."
 */
LoremIpsum.prototype.generate = function (numWords, punctuate) {
    var words, ii, position, word, current, sentences, sentenceLength, sentence;

    /**
    * @default 100
    */
    numWords = numWords || 100;

    words = [LoremIpsum.WORDS[0], LoremIpsum.WORDS[1]];
    numWords -= 2;

    for (ii = 0; ii < numWords; ii++) {
        position = Math.floor(Math.random() * LoremIpsum.WORDS.length);
        word = LoremIpsum.WORDS[position];

        if (ii > 0 && words[ii - 1] === word) {
            ii -= 1;
        } else {
            words[ii] = word;
        }
    }

    sentences = [];
    current = 0;

    while (numWords > 0) {
        sentenceLength = this.getRandomSentenceLength();

        if (numWords - sentenceLength < 4) {
            sentenceLength = numWords;
        }

        numWords -= sentenceLength;

        sentence = [];

        for (ii = current; ii < current + sentenceLength; ii++) {
            sentence.push(words[ii]);
        }

        if (punctuate) {
            sentence = this.punctuate(sentence);
        }

        current += sentenceLength;
        sentences.push(sentence.join(" "));
    }

    return sentences.join(" ");
};

/**
 * Insert commas and periods in the given sentence.
 * @param {Array.string} sentence List of words in the sentence.
 * @return {Array.string} Sentence with punctuation added.
 */
LoremIpsum.prototype.punctuate = function (sentence) {
    var wordLength, numCommas, ii, position;

    wordLength = sentence.length;

    /* End the sentence with a period. */
    sentence[wordLength - 1] += ".";

    if (wordLength < 4) {
        return sentence;
    }

    numCommas = this.getRandomCommaCount(wordLength);

    for (ii = 0; ii <= numCommas; ii++) {
        position = Math.round(ii * wordLength / (numCommas + 1));

        if (position < wordLength - 1 && position > 0) {
            /* Add the comma. */
            sentence[position] += ",";
        }
    }

    /* Capitalize the first word in the sentence. */
    sentence[0] = sentence[0].charAt(0).toUpperCase() + sentence[0].slice(1);

    return sentence;
};

/**
 * Produces a random number of commas.
 * @param {number} wordLength Number of words in the sentence.
 * @return {number} Random number of commas
 */
LoremIpsum.prototype.getRandomCommaCount = function (wordLength) {
    var base, average, standardDeviation;

    /* Arbitrary. */
    base = 6;

    average = Math.log(wordLength) / Math.log(base);
    standardDeviation = average / base;

    return Math.round(this.gaussMS(average, standardDeviation));
};

/**
 * Produces a random sentence length based on the average word length
 * of an English sentence.
 * @return {number} Random sentence length
 */
LoremIpsum.prototype.getRandomSentenceLength = function () {
    return Math.round(this.gaussMS(LoremIpsum.WORDS_PER_SENTENCE_AVG, LoremIpsum.WORDS_PER_SENTENCE_STD));
};

/**
 * Produces a random number.
 * @return {number} Random number
 */
LoremIpsum.prototype.gauss = function () {
    return Math.random() * 2 - 1 + (Math.random() * 2 - 1) + (Math.random() * 2 - 1);
};

/**
 * Produces a random number with Gaussian distribution.
 * @param {number} mean
 * @param {number} standardDeviation
 * @return {number} Random number
 */
LoremIpsum.prototype.gaussMS = function (mean, standardDeviation) {
    return Math.round(this.gauss() * standardDeviation + mean);
};

function Tickers() {}

Tickers.TICKERS = ["PIH", "FLWS", "FCCY", "SRCE", "VNET", "TWOU", "JOBS", "CAFD", "EGHT", "AVHI", "SHLM", "AAON", "ABAX", "ABEO", "ABEOW", "ABIL", "ABMD", "AXAS", "ACIU", "ACIA", "ACTG", "ACHC", "ACAD", "ACST", "AXDX", "XLRN", "ANCX", "ARAY", "ACRX", "ACET", "AKAO", "ACHN", "ACIW", "ACRS", "ACNB", "ACOR", "ACTS", "ACPW", "ATVI", "ACTA", "ACUR", "ACXM", "ADMS", "ADMP", "ADAP", "ADUS", "AEY", "IOTS", "ADMA", "ADBE", "ADTN", "ADRO", "AAAP", "ADES", "AEIS", "AMD", "ADXS", "ADXSW", "ADVM", "MAUI", "AEGR", "AEGN", "AGLE", "AEHR", "AMTX", "AEPI", "AERI", "AVAV", "AEZS", "AEMD", "AFMD", "AGEN", "AGRX", "AGYS", "AGIO", "AGNC", "AGNCB", "AGNCP", "AGFS", "AGFSW", "AIMT", "AIRM", "AIRT", "ATSG", "AIRG", "AMCN", "AIXG", "AKAM", "AKTX", "AKBA", "AKER", "AKRX", "ALRM", "ALSK", "AMRI", "ALBO", "ABDC", "ADHD", "ALDR", "ALDX", "ALXN", "ALCO", "ALGN", "ALIM", "ALJJ", "ALKS", "ABTX", "ALGT", "AIQ", "AHGP", "AMMA", "ARLP", "AHPI", "AMOT", "ALQA", "ALLT", "MDRX", "AFAM", "ALNY", "AOSL", "GOOG", "GOOGL", "SMCP", "ATEC", "ASPS", "AIMC", "AMAG", "AMRN", "AMRK", "AYA", "AMZN", "AMBC", "AMBCW", "AMBA", "AMCX", "DOX", "AMDA", "AMED", "UHAL", "ATAX", "AMOV", "AAL", "ACSF", "ACAS", "AETI", "AMNB", "ANAT", "APEI", "ARII", "AMRB", "AMSWA", "AMSC", "AMWD", "CRMT", "ABCB", "AMSF", "ASRV", "ASRVP", "ATLO", "AMGN", "FOLD", "AMKR", "AMPH", "IBUY", "AMSG", "AMSGP", "ASYS", "AFSI", "AMRS", "ADI", "ALOG", "AVXL", "ANCB", "ANDA", "ANDAR", "ANDAU", "ANDAW", "ANGI", "ANGO", "ANIP", "ANIK", "ANSS", "ATRS", "ANTH", "ABAC", "APOG", "APOL", "AINV", "APPF", "AAPL", "ARCI", "APDN", "APDNW", "AGTC", "AMAT", "AMCC", "AAOI", "AREX", "APTI", "APRI", "APVO", "APTO", "AQMS", "AQXP", "ARDM", "ARLZ", "PETX", "ABUS", "ARCW", "ABIO", "RKDA", "ARCB", "ACGL", "ACGLP", "APLP", "ACAT", "ARDX", "ARNA", "ARCC", "AGII", "AGIIL", "ARGS", "ARIS", "ARIA", "ARKR", "ARTX", "ARWA", "ARWAR", "ARWAU", "ARWAW", "ARQL", "ARRY", "ARRS", "DWAT", "AROW", "ARWR", "ARTNA", "ARTW", "ASBB", "ASNA", "ASND", "ASCMA", "APWC", "ASML", "AZPN", "ASMB", "ASFI", "ASTE", "ATRO", "ALOT", "ASTC", "ASUR", "ATAI", "ATRA", "ATHN", "ATHX", "AAPC", "AAME", "ACBI", "ACFC", "ABY", "ATLC", "AAWW", "AFH", "TEAM", "ATNI", "ATOM", "ATOS", "ATRC", "ATRI", "ATTU", "LIFE", "AUBN", "BOLD", "AUDC", "AUPH", "EARS", "ABTL", "ADSK", "ADP", "AVEO", "AVXS", "AVNW", "AVID", "AVGR", "AVIR", "CAR", "AHPAU", "AWRE", "AXAR", "AXARU", "AXARW", "ACLS", "AXGN", "AXSM", "AXTI", "AZRX", "BCOM", "RILY", "RILYL", "BOSC", "BEAV", "BIDU", "BCPC", "BWINA", "BWINB", "BLDP", "BANF", "BANFP", "BCTF", "BKMU", "BOCH", "BMRC", "BKSC", "BOTJ", "OZRK", "BFIN", "BWFG", "BANR", "BZUN", "TAPR", "DLBL", "BHAC", "BHACR", "BHACU", "BHACW", "BBSI", "BSET", "BYBK", "BV", "BCBP", "BECN", "BSF", "BBGI", "BEBE", "BBBY", "BGNE", "BELFA", "BELFB", "BLPH", "BLCM", "BNCL", "BNFT", "BNTC", "BNTCW", "BGCP", "BGFV", "BASI", "ORPN", "BIOC", "BCRX", "BDSI", "BIIB", "BIOL", "BLFS", "BLRX", "BMRN", "BMRA", "BVXV", "BVXVW", "BPTH", "BIOS", "BBC", "BBP", "BSTC", "BSTG", "BSPM", "TECH", "BEAT", "BJRI", "BBOX", "BDE", "BLKB", "BBRY", "HAWK", "BL", "BKCC", "ADRA", "ADRD", "ADRE", "ADRU", "BLMN", "BCOR", "BLBD", "BUFF", "BHBK", "NILE", "BLUE", "BKEP", "BKEPP", "BPMC", "ITEQ", "BMCH", "BNCN", "BOBE", "BOFI", "BOFIL", "WIFI", "BOJA", "BOKF", "BOKFL", "BNSO", "BPFH", "BPFHP", "BPFHW", "EPAY", "BLVD", "BLVDU", "BLVDW", "BCLI", "BBRG", "BDGE", "BLIN          ", "BRID", "BCOV", "AVGO", "BSFT", "BVSN", "BYFC", "BWEN", "BRCD", "BRKL", "BRKS", "BRKR", "BMTC", "BLMT", "BSQR", "BWLD", "BLDR", "BMLA", "BUR", "CFFI", "CHRW", "CA", "CCMP", "CDNS", "CDZI", "CACQ", "CZR", "CSTE", "PRSS", "CLBS", "CLMS", "CHY", "CHI", "CCD", "CHW", "CGO", "CSQ", "CAMP", "CVGW", "CFNB", "CALA", "CALD", "CALM", "CLMT", "ABCD", "CAC", "CAMT", "CSIQ", "CGIX", "CPHC", "CPLA", "CBF", "CCBG", "CPLP", "CSWC", "CPTA", "CLAC", "CLACU", "CLACW", "CFFN", "CAPN", "CAPNW", "CAPR", "CSTR", "CPST", "CARA", "CARB", "CCN", "CCNWW", "CFNL", "CRME", "CSII", "CATM", "CDNA", "CECO", "CTRE", "CKEC", "CLBH", "CARO", "CART", "CRZO", "TAST", "CRTN", "CARV", "CASM", "CACB", "CASC", "CWST", "CASY", "CASI", "CASS", "CATB", "CBIO", "CPRX", "CATY", "CATYW", "CVCO", "CAVM", "CBFV", "CBOE", "CDK", "CDW", "CECE", "CELG", "CELGZ", "CLDX", "APOP", "APOPW", "CLRB", "CLRBW", "CLRBZ", "CLLS", "CBMG", "CLSN", "CYAD", "CEMP", "CETX", "CDEV", "CDEVW", "CSFL", "CETV", "CFBK", "CENT", "CENTA", "CVCY", "CFCB", "CENX", "CNBKA", "CNTY", "CRNT", "CERC", "CERCW", "CERCZ", "CERN", "CERU", "CERS", "KOOL", "CEVA", "CFCO", "CFCOU", "CFCOW", "CSBR", "CYOU", "HOTR", "HOTRW", "CTHR", "GTLS", "CHTR", "CHFN", "CHKP", "CHEK", "CHEKW", "CEMI", "CHFC", "CCXI", "CHMG", "CHKE", "CHMA", "PLCE", "CMRX", "CADC", "CALI", "CAAS", "CBAK", "CBPO", "CCCL", "CCCR", "CCRC", "JRJC", "HGSH", "CNIT", "CJJD", "CLDC", "CLDCW", "HTHT", "CHNR", "CREG", "CNTF", "CXDC", "CCIH", "CNET", "IMOS", "CDXC", "CHSCL", "CHSCM", "CHSCN", "CHSCO", "CHSCP", "CHDN", "CHUY", "CDTX", "CMCT", "CMPR", "CINF", "CIDM", "CTAS", "CPHR", "CRUS", "CSCO", "CTRN", "CZNC", "CZWI", "CZFC", "CIZN", "CTXS", "CHCO", "CIVB", "CIVBP", "CDTI", "CLNE", "CLNT", "CLFD", "CLRO", "CLSD", "CLIR", "CBLI", "CSBK", "CLVS", "CMFN", "CME", "CCNE", "CISG", "CNV", "CWAY", "COBZ", "COKE", "CDXS", "CVLY", "JVA", "CCOI", "CGNT", "COGT", "CGNX", "CTSH", "COHR", "CHRS", "COHU", "CLCT", "COLL", "CIGI", "CBAN", "CLCD", "COLB", "COLM", "CMCO", "CBMX", "CBMXW", "CMCSA", "CBSH", "CBSHP", "CUBN", "CHUBA", "CHUBK", "CVGI", "COMM", "CSAL", "JCS", "ESXB", "CYHHZ", "CTBI", "CWBC", "CVLT", "CGEN", "CPSI", "CTG", "SCOR", "CHCI", "CMTL", "CNAT", "CNCE", "CXRX", "CCUR", "CDOR", "CFMS", "CNFR", "CNMD", "CTWS", "CNOB", "CNXR", "CONN", "CNSL", "CWCO", "CPSS", "CFRX", "CFRXW", "CTRV", "CTRL", "CPAA", "CPAAU", "CPAAW", "CPRT", "COYN", "COYNW", "CRBP", "CORT", "CORE", "CORI", "CSOD", "CRVL", "CRVS", "CSGP", "COST", "CPAH", "ICBK", "COUP", "CVTI", "COVS", "COWN", "COWNL", "PMTS", "CPSH", "CRAI", "CBRL", "BREW", "CRAY", "CACC", "GLDI", "SLVO", "CREE", "CRESY", "CRSP", "CRTO", "CROX", "CCRN", "XRDC", "CRDS", "CRWS", "CYRX", "CYRXW", "CSGS", "CCLP", "CSPI", "CSWI", "CSX", "CTIC", "CTIB", "CTRP", "CUNB", "CUI", "CPIX", "CMLS", "CRIS", "CUTR", "CVBF", "CVV", "CYAN", "CYBR", "CYBE", "CYCC", "CYCCP", "CBAY", "CYNO", "CY", "CYRN", "CONE", "CYTK", "CTMX", "CYTX", "CYTXW", "CTSO", "CYTR", "DJCO", "DAKT", "DRIO", "DRIOW", "DZSI", "DAIO", "DTLK", "DRAM", "DWCH", "PLAY", "DTEA", "DWSN", "DBVT", "DFRG", "TACO", "TACOW", "DCTH", "DMPI", "DGAS", "DELT", "DELTW", "DENN", "XRAY", "DEPO", "DSCI", "DERM", "DEST", "DXLG", "DSWL", "DTRM", "DXCM", "DXTR", "DHXM", "DHIL", "FANG", "DCIX", "DRNA", "DFBG", "DFFN", "DGII", "DMRC", "DRAD", "DGLY", "APPS", "DCOM", "DMTX", "DIOD", "DPRX", "DISCA", "DISCB", "DISCK", "DISH", "DVCR", "SAUC", "DLHC", "BOOM", "DNBF", "DLTR", "DGICA", "DGICB", "DMLP", "DORM", "EAGL", "EAGLU", "EAGLW", "DRWI", "DRYS", "DSKX", "DSPG", "DTSI", "DLTH", "DNKN", "DRRX", "DXPE", "DYSL", "DYNT", "DVAX", "ETFC", "EBMT", "EGBN", "EGLE", "EGRX", "IGLEU", "ELNK", "EWBC", "EACQ", "EACQU", "EACQW", "EML", "EVBS", "EVGBC", "EVSTC", "EVLMC", "EBAY", "EBAYL", "EBIX", "ELON", "ECHO", "SATS", "EEI", "ECAC", "ECACR", "ECACU", "ESES", "EDAP", "EDGE", "EDGW", "EDIT", "EDUC", "EFUT", "EGAN", "EGLT", "EHTH", "EIGR", "EKSO", "LOCO", "EMITF", "ESLT", "ERI", "ESIO", "EA", "EFII", "ELSE", "ELEC", "ELECU", "ELECW", "EBIO", "DWAC", "CAPX", "ESBK", "ELTK", "EMCI", "EMCF", "EMKR", "EMMS", "NYNY", "ERS", "ENTA", "ECPG", "WIRE", "ENDP", "ECYT", "ELGX", "EIGI", "WATT", "EFOI", "ERII", "ENOC", "ENG", "ENPH", "ESGR", "ENFC", "ENTG", "ENTL", "ETRM", "EBTC", "EFSC", "EGT", "ENZY          ", "EPZM", "PLUS", "EQIX", "EQFN", "EQBK", "ERIC", "ERIE", "ESCA", "ESPR", "ESSA", "EPIX", "ESND", "UTES", "ETSY", "CLWT", "EEFT", "ESEA", "EVEP", "EVBG", "EVK", "MRAM", "EVLV", "EVOK", "EVOL", "EXA", "EXAS", "EXAC", "EXEL", "EXFO", "EXLS", "EXPE", "EXPD", "EXPO", "ESRX", "XOG", "EXTR", "EYEG", "EYEGW", "EZPW", "FFIV", "FB", "FRP", "FALC", "DAVE", "FARM", "FFKT", "FMNB", "FARO", "FAST", "FATE", "FBSS", "FBRC", "FDML", "FNHC", "FHCO", "FENX", "GSM", "FCSC", "FGEN", "ONEQ", "LION", "FDUS", "FRGI", "FSAM", "FSC", "FSCFL", "FSFR", "FITB", "FITBI", "FNGN", "FISI", "FNSR", "FNJN", "FEYE", "FBNC", "FNLC", "FRBA", "BUSE", "FBIZ", "FCAP", "FCFS", "FCNCA", "FCBC", "FCCO", "FCFP", "FBNK", "FDEF", "FFBC", "FFBCW", "FFIN", "THFF", "FFNW", "FFWM", "FGBI", "FHB", "INBK", "INBKL", "FIBK", "FRME", "FMBH", "FMBI", "FNBC", "FNWB", "FSFG", "FSLR", "FSBK", "FAAR", "FPA", "BICK", "FBZ", "FCAN", "FTCS", "FCEF", "FCA", "FDT", "FDTS", "FVC", "FV", "IFV", "FEM", "FEMB", "FEMS", "FTSM", "FEP", "FEUZ", "FGM", "FTGC", "FTHI", "HYLS", "FHK", "FTAG", "FTRI", "FPXI", "YDIV", "SKYY", "FJP", "FEX", "FTC", "FTA", "FLN", "FTLB", "LMBS", "FMB", "FMK", "FNX", "FNY", "FNK", "FAD", "FAB", "MDIV", "MCEF", "QABA", "FTXO", "QCLN", "GRID", "CIBR", "FTXG", "CARZ", "FTXN", "FTXH", "FTXD", "RDVY", "FTXL", "FONE", "TDIV", "FTXR", "QQEW", "QQXT", "QTEC", "AIRR", "QINC", "RFAP", "RFDI", "RFEM", "RFEU", "FTSL", "FYX", "FYC", "FYT", "FKO", "FCVT", "FDIV", "FSZ", "FTW", "TUSA", "FKU", "FUNC", "FUSB", "SVVC", "FSV", "FISV", "FIVE", "FPRX", "FVE", "FIVN", "FLML", "FLEX", "FLKS", "FLXN", "SKOR", "LKOR", "MBSD", "ASET", "ESGG", "ESG", "QLC", "FPAY", "FLXS", "FLIR", "FLDM", "FFIC", "FOMX", "FOGO", "FONR", "FH", "FORM", "FORTY", "FORR", "FRTA", "FTNT", "FBIO", "FWRD", "FORD", "FWP", "FOSL", "FMI", "FOXF", "FRAN", "FELE", "FRED", "RAIL", "FEIM", "FRPT", "FTEO", "FTR", "FTRPR", "FRPH", "FSBW", "FSBC", "FTD", "FTEK", "FCEL", "FLGT", "FORK", "FLL", "FULT", "FNCX", "FSNN", "FFHL", "FXCM", "GK", "WILC", "GAIA", "GLPG", "GALT", "GALTU", "GALTW", "GALE", "GLMD", "GLPI", "GPIC", "GRMN", "GARS", "GDS", "GEMP", "GENC", "GNCMA", "GFN", "GFNCP", "GFNSL", "GENE", "GNUS", "GNMK", "GNCA", "GHDX", "GNTX", "THRM", "GNVC", "GTWN", "GEOS", "GABC", "GERN", "GEVO", "ROCK", "GIGM", "GIGA", "GIII", "GILT", "GILD", "GBCI", "GLAD", "GLADO", "GOOD", "GOODM", "GOODO", "GOODP", "GAIN", "GAINM", "GAINN", "GAINO", "LAND", "LANDP", "GLBZ", "GBT", "ENT", "GBLI", "GBLIZ", "GPAC", "GPACU", "GPACW", "SELF", "GSOL", "GWRS", "KRMA", "FINX", "ACTX", "BFIT", "SNSR", "LNGR", "MILN", "EFAS", "QQQC", "BOTZ", "CATH", "SOCL", "ALTY", "SRET", "YLCO", "GLBS", "GLUU", "GLYC", "GOGO", "GLNG", "GMLP", "GDEN", "GOGL", "GBDC", "GTIM", "GPRO", "GMAN", "GOV", "GOVNI", "GPIA", "GPIAU", "GPIAW", "LOPE", "GRVY", "FULLL", "GECC", "GEC", "GLDD", "GSBC", "GNBC", "GRBK", "GPP", "GPRE", "GCBC", "GLRE", "GSUM", "GRIF", "GRFS", "GRPN", "OMAB", "GGAL", "GSIT", "GSVC", "GTXI", "GTYH", "GTYHU", "GTYHW", "GBNK", "GFED", "GUID", "GIFI", "GURE", "GPOR", "GWPH", "GWGH", "GYRO", "HEES", "HLG", "HNRG", "HALL", "HALO", "HBK", "HBHC", "HBHCL", "HNH", "HAFC", "HQCL", "HONE", "HDNG", "HLIT", "HRMN", "HRMNU", "HRMNW", "TINY", "HBIO", "HCAP", "HCAPL", "HAS", "HA", "HCOM", "HWKN", "HWBK", "HAYN", "HDS", "HIIQ", "HCSG", "HQY", "HSTM", "HWAY", "HTLD", "HTLF", "HTBX", "HSII", "HELE", "HMNY", "HMTV", "HNNA", "HCAC", "HCACU", "HCACW", "HSIC", "HTBK", "HFWA", "HEOP", "HCCI", "MLHR", "HRTX", "HSKA", "HIBB", "SNLN", "HPJ", "HIHO", "HIMX", "HIFS", "HSGX", "HMNF", "HMSY", "HOLI", "HOLX", "HBCP", "HOMB", "HFBL", "HMST", "HMTA", "HTBI", "HMU", "CETC", "HOFT", "HOPE", "HFBC", "HBNC", "HZNP", "HRZN", "HDP", "HPT", "HPTRP", "TWNK", "TWNKW", "HMHC", "HWCC", "HOVNP", "HBMD", "HSNI", "HTGM", "HUBG", "HSON", "HDSN", "HUNTU", "HBAN", "HBANN", "HBANO", "HBANP", "HURC", "HURN", "HCM", "HBP", "HDRA", "HDRAR", "HDRAU", "HDRAW", "HYGS", "IDSY", "IAC", "IKGH", "IBKC", "IBKCO", "IBKCP", "ICAD", "IEP", "ICFI", "ICLR", "ICON", "ICUI", "IPWR", "INVE", "IDRA", "IDXX", "IESC", "IROQ", "IRG", "RXDX", "INFO", "IIVI", "KANG", "IKNX", "ILG", "ILMN", "ISNS", "IMMR", "ICCC", "IMDZ", "IMNP          ", "IMGN", "IMMU", "IPXL", "PI", "IMMY", "INCR", "INCY", "INDB", "IBCP", "IBTX", "IDSA", "INFN", "INFI", "IPCC", "III", "IFON", "IMKTA", "INWK", "INNL", "INOD", "IPHS", "IOSP", "ISSC", "INVA", "INGN", "ITEK", "INOV", "INO", "INSG", "NSIT", "ISIG", "INSM", "IIIN", "PODD", "INSY", "NTEC", "IART", "IDTI", "INTC", "IQNT", "NTLA", "IPCI", "IPAR", "IBKR", "ININ", "ICPT", "IDCC", "TILE", "LINK", "IMI", "INAP", "IBOC", "ISCA", "IGLD", "IIJI", "IDXG", "XENT", "INTX", "ISIL", "IVAC", "INTL", "ITCI", "IIN", "INTU", "ISRG", "INVT", "SNAK", "ISTR", "ISBC", "ITIC", "NVIV", "IVTY", "IONS", "IPAS", "DTYS", "DTYL", "DTUS", "DTUL", "DFVS", "DFVL", "FLAT", "DLBS", "STPP", "IPGP", "IRMD", "IRTC", "IRIX", "IRDM", "IRDMB", "IRBT", "IRWD", "IRCP", "PMPT", "SLQD", "TLT", "AIA", "COMT", "IXUS", "FALN", "IFEU", "IFGL", "IGF", "GNMA", "HYXE", "JKI", "ACWX", "ACWI", "AAXJ", "EWZS", "MCHI", "ESGD", "SCZ", "ESGE", "EEMA", "EUFN", "IEUS", "MPCT", "ENZL", "QAT", "UAE", "IBB", "SOXX", "EMIF", "ICLN", "WOOD", "INDY", "ISHG", "IGOV", "ISLE", "ISRL", "ITI", "ITRI", "ITRN", "ITUS", "IVENC", "IVFGC", "IVFVC", "XXIA", "IXYS", "IZEA", "JJSF", "MAYS", "JBHT", "JCOM", "JASO", "JKHY", "JACK", "JXSB", "JAGX", "JAKK", "JMBA", "JRVR", "JSML", "JSMD", "JASN", "JASNW", "JAZZ", "JD", "JSYN", "JSYNR", "JSYNU", "JSYNW", "JBLU", "JTPY", "JCTCF", "JIVE", "WYIG", "WYIGU", "WYIGW", "JBSS", "JOUT", "JNP", "JUNO", "KTWO", "KALU", "KALV", "KMDA", "KNDI", "KPTI", "KBSF", "KCAP", "KRNY", "KELYA", "KELYB", "KMPH", "KFFB", "KERX", "KEQU", "KTEC", "KTCC", "KFRC", "KE", "KBAL", "KIN", "KGJI", "KINS", "KONE", "KNSL", "KIRK", "KITE", "KTOV", "KTOVW", "KLAC", "KLRE", "KLREU", "KLREW", "KLXI", "KONA", "KZ", "KOPN", "KRNT", "KOSS", "KWEB", "KTOS", "KLIC", "KURA", "KVHI", "FSTR", "LJPC", "LSBK", "LSBG", "LBAI", "LKFN", "LAKE", "LRCX", "LAMR", "LANC", "LCA", "LCAHU", "LCAHW", "LNDC", "LARK", "LMRK", "LMRKO", "LMRKP", "LE", "LSTR", "LNTH", "LTRX", "LSCC", "LAWS", "LAYN", "LCNB", "LBIX", "LGCY", "LGCYO", "LGCYP", "LTXB", "DDBI", "EDBI", "LVHD", "UDBI", "LMAT", "TREE", "LXRX", "LGIH", "LHCG", "LLIT", "LBRDA", "LBRDK", "LEXEA", "LEXEB", "LBTYA", "LBTYB", "LBTYK", "LILA", "LILAK", "LVNTA", "LVNTB", "QVCA", "QVCB", "BATRA", "BATRK", "LMCA", "LMCK", "LSXMA", "LSXMB", "LSXMK", "TAX", "LTRPA", "LTRPB", "LPNT", "LCUT", "LFVN", "LWAY", "LGND", "LTBR", "LPTH", "LMB", "LLNW", "LMNR", "LINC", "LECO", "LIND", "LINDW", "LLTC", "LBIO", "LIOX", "LPCN", "LQDT", "LFUS", "LIVN", "LOB", "LIVE", "LPSN", "LKQ", "LMFA", "LMFAW", "LMIA", "LOGI", "LOGM", "EVAR", "CNCR", "LONE", "LTEA", "LORL", "LOXO", "LPTN", "LPLA", "LRAD", "LYTS", "LULU", "LITE", "LMNX", "LMOS", "LUNA", "MBTF", "MACQ", "MACQU", "MACQW", "MIII", "MIIIU", "MIIIW", "MBVX", "MCBC", "MFNC", "MTSI", "MCUR", "MGNX", "MDGL", "MAGS", "MGLN", "MPET", "MGIC", "CALL", "MNGA", "MGYR", "MHLD", "MSFG", "COOL", "MMYT", "MBUU", "MLVF", "MAMS", "TUSK", "MANH", "LOAN", "MNTX", "MTEX", "MNKD", "MANT", "MARA", "MCHX", "MARPS", "MRNS", "MKTX", "MRLN", "MAR", "MBII", "MRTN", "MMLP", "MRVL", "MASI", "MTCH", "MATN", "MTLS", "MTRX", "MAT", "MATR", "MATW", "MXIM", "MXPT", "MXWL", "MZOR", "MBFI", "MBFIP", "MCFT", "MGRC", "MDCA", "MFIN", "MFINL", "MDGN", "MTBC", "MTBCP", "MNOV", "MDSO", "MDGS", "MDWD", "MDVX", "MDVXW", "MEDP", "MEET", "MEIP", "MPEL", "MLNX", "MELR", "MEMP", "MENT", "MTSL", "MELI", "MBWM", "MERC", "MBVT", "MRCY", "EBSB", "VIVO", "MMSI", "MACK", "MSLI", "MRUS", "MLAB", "MESO", "CASH", "MBLX", "MEOH", "MFRI", "MGCD", "MGEE", "MGPI", "MCHP", "MU", "MICT", "MICTW", "MSCC", "MSFT", "MSTR", "MVIS", "MPB", "MTP", "MCEP", "MBRG", "MBCN", "MSEX", "MSBI", "MOFG", "MIME", "MDXG", "MNDO", "MB", "NERV", "MRTX", "MIRN", "MSON", "MIND", "MINDP", "MITK", "MITL", "MKSI", "MMAC", "MINI", "MOBL", "MOCO", "MDSY", "MLNK", "MBRX", "MNTA", "MOMO", "MCRI", "MDLZ", "MGI", "MPWR", "TYPE", "MNRO", "MRCC", "MNST", "MSDI", "MSDIW", "MHGC", "MORN", "MOSY", "MTFB", "MTFBW", "MPAA", "MDM", "MOXC", "MRVC", "MSBF", "MSG", "MTGE", "MTGEP", "MTSC", "LABL", "MFSF", "MYSZ", "MYL", "MYOK", "MYOS", "MYRG", "MYGN", "NBRV", "NAKD", "NNDM", "NANO", "NSTG", "NH", "NK", "NSSC", "NDAQ", "NTRA", "NATH", "NAUH", "NKSH", "FIZZ", "NCMI", "NCOM", "NGHC", "NGHCN", "NGHCO", "NGHCP", "NGHCZ", "NHLD", "NATI", "NRCIA", "NRCIB", "NSEC", "NWLI", "NAII", "NHTC", "NATR", "BABY", "NAVI", "NBTB", "NCIT", "NKTR", "NEOG", "NEO", "NEON", "NEOS", "NEOT", "NVCN", "NEPT", "UEPS", "NETE", "NTAP", "NTES", "NFLX", "NTGR", "NLST", "NTCT", "NTWK", "CUR", "NBIX", "NDRM", "NURO", "NUROW", "NYMT", "NYMTO", "NYMTP", "NLNK", "NWS", "NWSA", "NEWS", "NEWT", "NEWTL", "NEWTZ", "NXEO", "NXEOU", "NXEOW", "NXST", "NVET", "NFEC", "EGOV", "NICE", "NICK", "NCBS", "NIHD", "NVLS", "NMIH", "NNBR", "NDLS", "NDSN", "NSYS", "NBN", "NTIC", "NTRS", "NTRSP", "NFBK", "NRIM", "NWBI", "NWBO", "NWBOW", "NWPX", "NCLH", "NWFL", "NVFY", "NVMI", "NVDQ", "NOVN", "NOVT", "NVAX", "NVCR", "NVGN", "NUAN", "NMRX", "NTNX", "NUTR", "NTRI", "NUVA", "NVTR", "QQQX", "NVEE", "NVEC", "NVDA", "NXPI", "NXTM", "NXTD", "NXTDW", "NYMX", "OIIM", "OVLY", "OASM", "OBLN", "OBCI", "OPTT", "ORIG", "OSHC", "OCFC", "OCRX", "OCLR", "OFED", "OCUL", "OCLS", "OCLSW", "OMEX", "ODP", "OFS", "OHAI", "OVBC", "OHRP", "ODFL", "OLBK", "ONB", "OPOF", "OSBC", "OSBCP", "OLLI", "ZEUS", "OFLX", "OMER", "OMCL", "ON", "OTIV", "ONS", "ONSIW", "ONSIZ", "OGXI", "OMED", "ONTX", "ONTXW", "ONCS", "OHGI", "ONVI", "OTEX", "OPXA", "OPXAW", "OPGN", "OPGNW", "OPHT", "OPK", "OBAS", "OCC", "OPHC", "OPB", "ORMP", "OSUR", "ORBC", "ORBK", "ORLY", "OREX", "ONVO", "SEED", "OACQ", "OACQR", "OACQU", "OACQW", "OESX", "ORIT", "ORRF", "OFIX", "OSIS", "OSIR", "OSN", "OTEL", "OTIC", "OTTW", "OTTR", "OVAS", "OSTK", "OXBR", "OXBRW", "OXFD", "OXLC", "OXLCN", "OXLCO", "PFIN", "PTSI", "PCAR", "PACE", "PACEU", "PACEW", "PACB", "PCBK", "PEIX", "PMBC", "PPBI", "PAAC", "PAACR", "PAACU", "PAACW", "PCRX", "PACW", "PTIE", "PAAS", "PNRA", "PANL", "PZZA", "FRSH", "PBNC", "PRTK", "PRXL", "PCYG", "PSTB", "PKBK", "PRKR", "PKOH", "PARN", "PTNR", "PBHC", "PATK", "PNBK", "PATI", "PEGI", "PDCO", "PTEN", "PAVM", "PAVMW", "PAYX", "PCTY", "PYDS", "PYPL", "PBBI", "CNXN", "PCMI", "PCTI", "PDCE", "PDFS", "PDLI", "PDVW", "SKIS", "PGC", "PEGA", "PCO", "PENN", "PFLT", "PNNT", "PWOD", "PTXP", "PEBO", "PEBK", "PFBX", "PFIS", "PBCT", "PUB", "PRCP", "PPHM", "PPHMP", "PRFT", "PFMT", "PERF", "PERI", "PESI", "PTX", "PERY", "PGLC", "PETS", "PFSW", "PGTI", "PZRX", "PHII", "PHIIK", "PAHC", "PHMD", "PLAB", "PICO", "PIRS", "PPC", "PME", "PNK", "PNFP", "PPSI", "PXLW", "PLPM", "PLXS", "PLUG", "PLBC", "PSTI", "PBSK", "PNTR", "PCOM", "POOL", "POPE", "PLKI", "BPOP", "BPOPM", "BPOPN", "PBIB", "PTLA", "PBPB", "PCH", "POWL", "POWI", "PSIX", "DWLV", "DWIN", "DWTR", "IDLB", "PRFZ", "PAGG", "PSAU", "IPKW", "LDRI", "LALT", "PNQI", "PDBC", "QQQ", "USLB", "PSCD", "PSCC", "PSCE", "PSCF", "PSCH", "PSCI", "PSCT", "PSCM", "PSCU", "VRIG", "PRAA", "PRAH", "PRAN", "PFBC", "PLPC", "PFBI", "PINC", "LENS", "PRGX", "PSMT", "PBMD", "PNRG", "PRMW", "PRIM", "BTEC", "GENY", "PSET", "PY", "PSC", "PRZM", "PVTB", "PVTBP", "PDEX", "IPDN", "PFIE", "PGNX", "PRGS", "DNAI", "PFPT", "PRPH", "PRQR", "BIB", "UBIO", "TQQQ", "ZBIO", "SQQQ", "BIS", "PSEC", "PTGX", "PRTO", "PTI", "PRTA", "PVBC", "PROV", "PBIP", "PSDV", "PMD", "PTC", "PTCT", "PULM", "PLSE", "PCYO", "IMED", "FINQ", "PXS", "QADA", "QADB", "QCRH", "QGEN", "QIWI", "QLTI", "QRVO", "QCOM", "QSII", "QBAK", "QLYS", "QTNA", "QRHC", "QUIK", "QDEL", "QPAC", "QPACU", "QPACW", "QNST", "QUMU", "QUNR", "QTNT", "RRD", "RARX", "RADA", "RDCM", "ROIA", "ROIAK", "RSYS", "RDUS", "RDNT", "RDWR", "RMBS", "RAND", "RLOG", "GOLD", "RNDB", "RPD", "RAVE", "RAVN", "ROLL", "TALL", "RICK", "RCMT", "RDI", "RDIB", "RGSE", "RELY", "RNWK", "RP", "RETA", "DAX", "QYLD", "RCON", "REPH", "RRGB", "RRR", "RDHL", "REGN", "RGNX", "RGLS", "REIS", "RELV", "MARK", "RNST", "REGI", "RNVA", "RNVAZ", "RCII", "RTK", "RGEN", "RPRX", "RBCAA", "FRBK", "REFR", "RESN", "RECN", "ROIC", "SALE", "RTRX", "RVNC", "RVEN", "RVLT", "RWLK", "REXX", "RFIL", "RGCO", "RIBT", "RIBTW", "RELL", "RIGL", "NAME", "RNET", "RTTR", "RVSB", "RLJE", "RMGN", "ROBO", "FUEL", "RMTI", "RCKY", "RMCF", "ROKA", "ROSG", "ROST", "RBPAA", "RGLD", "RPXC", "RTIX", "RBCN", "RUSHA", "RUSHB", "RUTH", "RXII", "RYAAY", "STBA", "SANW", "SCAC", "SCACU", "SCACW", "SBRA", "SBRAP", "SABR", "SAEX", "SAFT", "SAGE", "SAIA", "SAJA", "SALM", "SAL", "SAFM", "SASR", "SGMO", "SANM", "GCVRZ", "SPNS", "SRPT", "SBFG", "SBFGP", "SBAC", "SCSC", "SMIT", "SCHN", "SCHL", "SCLN", "SGMS", "SNI", "SCYX", "SEAC", "SBCF", "STX", "SHIP", "SRSC", "SHLD", "SHLDW", "SHOS", "SPNE", "SGEN", "EYES", "SCWX", "SNFCA", "SEIC", "SLCT", "SCSS", "SIR", "SELB", "SIGI", "LEDS", "SMTC", "SENEA", "SENEB", "SNH", "SNHNI", "SNHNL", "SNMX", "SRTS", "SRTSW", "SQBG", "MCRB", "SREV", "SFBS", "SEV", "SVBI", "SGOC", "SMED", "SHSP", "SHEN", "SHLO", "TYHT", "SHPG", "SCVL", "SHBI", "SHOR", "SFLY", "SIFI", "SIEB", "SIEN", "BSRR", "SWIR", "SIFY", "SIGM", "SGMA", "SGNL", "SBNY", "SBNYW", "SLGN", "SILC", "SLAB", "SIMO", "SPIL", "SSRI", "SAMG", "SFNC", "SLP", "SINA", "SBGI", "SINO", "SVA", "SIRI", "SITO", "SKYS", "SKLN", "SPU", "SKYW", "SWKS", "ISM", "JSM", "OSM", "SLM", "SLMAP", "SLMBP", "SND", "SMBK", "SWHC", "SMSI", "SMTX", "LNCE", "SRAX", "SCKT", "SODA", "SOHU", "SLRC", "SUNS", "SEDG", "SONC", "SOFO", "SONS", "SPHS", "SORL", "SRNE", "SOHO", "SOHOB", "SOHOM", "SFBC", "SSB", "SFST", "SMBC", "SONA", "SBSI", "OKSB", "SP", "SPAN", "SBSA", "SGRP", "SPKE", "ONCE", "SPAR", "SPTN", "DWFI", "SPPI", "ANY", "SPEX", "SPI", "SAVE", "SPLK", "SPOK", "SPWH", "SBPH", "FUND", "SFM", "SPSC", "SSNC", "STAA", "STAF", "STMP", "STLY", "SPLS", "SBLK", "SBLKL", "SBUX", "STRZA", "STRZB", "STFC", "STBZ", "SNC", "STDY", "GASS", "STLD", "SMRT", "STLR", "STLRU", "STLRW", "SBOT", "STEM", "STML", "SRCL", "SRCLP", "STRL", "SHOO", "SSFN", "SYBT", "BANX", "SGBK", "SSKN", "SSYS", "STRT", "STRS", "STRA", "STRM", "SBBP", "STB", "SCMP", "SUMR", "SMMF", "SSBI", "SMMT", "SNBC", "SNHY", "SNDE", "SEMI", "SNSS", "STKL", "SPWR", "RUN", "SBCP", "SSH", "SUNW", "SMCI", "SPCB", "SCON", "SGC", "SUPN", "SPRT", "SGRY", "SCAI", "SRDX", "SBBX", "SIVB", "SIVBO", "SYKE", "SYMC", "SYNC", "SYNL", "SYNA", "SNCR", "SNDX", "SGYP", "SGYPU", "SGYPW", "ELOS", "SNPS", "SYNT", "SYMX", "SYUT", "SYPR", "SYRS", "SYRX", "TROW", "TTOO", "TRHC", "TCMD", "TAIT", "TTWO", "TLND", "TNDM", "TLF", "TNGO", "TANH", "TPIV", "TEDU", "TASR", "TATT", "TAYD", "TCPC", "AMTD", "TEAR", "TECD", "TCCO", "TTGT", "TGLS", "TGEN", "TNAV", "TTEC", "TLGT", "TENX", "GLBL", "TERP", "TRTL", "TRTLU", "TRTLW", "TVIA", "TBNK", "TSRO", "TESO", "TSLA", "TESS", "TSRA", "TTEK", "TTPH", "TCBI", "TCBIL", "TCBIP", "TCBIW", "TXN", "TXRH", "TFSL", "TGTX", "ABCO", "ANDE", "TBBK", "BONT", "CG", "CAKE", "CHEF", "TCFC", "DSGX", "DXYN", "ENSG", "XONE", "FINL", "FBMS", "FLIC", "GT", "HABT", "HCKT", "HAIN", "FITS", "CUBA", "INTG", "JYNT", "KEYW", "KHC", "OLD", "MDCO", "MIK", "MIDD", "NAVG", "SLIM", "STKS", "ORG", "PCLN", "PRSC", "BITE", "RMR", "SPNC", "TTD", "ULTI", "YORW", "NCTY", "TBPH", "TST", "TCRD", "THLD", "TICC", "TTS", "TIL", "TSBK", "TIPT", "TITN", "TTNP", "TIVO", "TMUS", "TMUSP", "TKAI", "TNXP", "TISA", "TOPS", "TORM          ", "TRCH", "TSEM", "TWER", "CLUB", "TOWN", "TPIC", "TCON", "TSCO", "TWMC", "TACT", "TRNS", "TBIO", "TGA", "TA", "TANNI", "TANNL", "TANNZ", "TZOO", "TRVN", "TCBK", "TRIL", "TRS", "TRMB", "TRIB", "TRIP", "TSC", "TBK", "TRNC", "TROV", "TROVU", "TROVW", "TRUE", "THST", "TRUP", "TRST", "TRMK", "TSRI", "TTMI", "TUBE", "TCX", "TUES", "TOUR", "HEAR", "TUTI", "TUTT", "FOX", "FOXA", "TWIN", "TRCB", "USCR", "PRTS", "USEG", "GROW", "UBNT", "UFPT", "ULTA", "UCTT", "RARE", "ULBI", "UTEK", "UMBF", "UMPQ", "UNAM", "UNIS", "UBSH", "UNB", "UNXL", "QURE", "UBCP", "UBOH", "UBSI", "UCBA", "UCBI", "UCFC", "UBNK", "UFCS", "UIHC", "UNFI", "UBFO", "USLM", "UTHR", "UG", "UNTY", "OLED", "UEIC", "UFPI", "ULH", "USAP", "UVSP", "UPLD", "URRE", "URBN", "ECOL", "USAT", "USATP", "USAK", "UTMD", "UTSI", "VALX", "VALU", "VNDA", "BBH", "GNRX", "PPH", "VWOB", "VNQI", "VGIT", "VCIT", "VIGI", "VYMI", "VCLT", "VGLT", "VMBS", "VNR", "VNRAP", "VNRBP", "VNRCP", "VONE", "VONG", "VONV", "VTWO", "VTWG", "VTWV", "VTHR", "VCSH", "VGSH", "VTIP", "BNDX", "VXUS", "VRNS", "VDSI", "VBLT", "VASC", "VBIV", "WOOF", "VECO", "DGLD", "DSLV", "UGLD", "USLV", "TVIZ", "TVIX", "ZIV", "XIV", "VIIZ", "VIIX", "APPY", "VRA", "VCYT", "VSTM", "VCEL", "VRNT", "VRSN", "VRSK", "VBTX", "VRML", "VSAR", "VTNR", "VRTX", "VRTB", "VIA", "VIAB", "VSAT", "VIAV", "VICL", "VICR", "CIZ", "CEZ", "CID", "CIL", "CFO", "CFA", "CSF", "CDC", "CDL", "CSB", "CSA", "VBND", "VUSE", "VIDI", "VDTH", "VRAY", "VKTX", "VKTXW", "VBFC", "VLGEA", "VIP", "VNOM", "VIRC", "VA", "VIRT", "VRTS", "VRTU", "VISN", "VTGN", "VTL", "VIVE", "VVUS", "VOD", "VLTC", "VOXX", "VYGR", "VSEC", "VTVT", "VUZI", "VWR", "WGBS", "WBA", "WAFD", "WAFDW", "WASH", "WFBI", "WSBF", "WVE", "WAYN", "WSTG", "WCFB", "WDFC", "FLAG", "WEB", "WBMD", "WCST", "WB", "WEBK", "WEN", "WERN", "WSBC", "WTBA", "WSTC", "WMAR", "WABC", "WBB", "WSTL", "WDC", "WNEB", "WLB", "WPRT", "WEYS", "WHLR", "WHLRD", "WHLRP", "WHLRW", "WHF", "WHFBL", "WFM", "WILN", "WHLM", "WVVI", "WVVIP", "WLDN", "WLFC", "WLTW", "WIN", "WINT", "WING", "WINA", "WINS", "WTFC", "WTFCM", "WTFCW", "AGND", "AGZD", "HYND", "HYZD", "CXSE", "EMCG", "EMCB", "DGRE", "DXGE", "WETF", "DXJS", "DXKW", "GULF", "CRDT", "DGRW", "DGRS", "DXPS", "UBND", "WIX", "WMIH", "WBKC", "WWD", "WKHS", "WRLD", "JMU", "WPCS", "WPPGY", "WMGI", "WMGIZ", "WSFS", "WSFSL", "WSCI", "WVFC", "WYNN", "XBIT", "XELB", "XCRA", "XNCR", "XBIO", "XBKS", "XENE", "XGTI", "XGTIW", "XLNX", "XOMA", "XPLR", "XTLB", "XNET", "YHOO", "YNDX", "YIN", "YRCW", "YECO", "YY", "ZFGN", "ZAGG", "ZAIS", "ZBRA", "ZLTQ", "Z", "ZG", "ZN", "ZNWAA", "ZION", "ZIONW", "ZIONZ", "ZIOP", "ZIXI", "ZGNX", "ZSAN", "ZUMZ", "ZYNE", "ZNGA"];

Tickers.prototype.ticker = function () {
    var length = Tickers.TICKERS.length;
    var index = Math.floor(Math.random() * length);
    return Tickers.TICKERS[index];
};

var tickers = new Tickers();
var lipsum = new LoremIpsum();

function getLipsum(num) {
    var phrase = lipsum.generate(num + 2);
    return phrase.substring(0, 1).toUpperCase() + phrase.substring(1);
}

function randomNumber(max, signed) {
    var val = Math.random() * max;
    if (signed) val *= Math.random() > 0.5 ? 1 : -1;
    return val;
}

function randomSignedNumber(max, negative) {
    var val = Math.random() * max;
    return val * (negative ? -1 : 1);
}

function randomArray(length, max) {
    var i = 0;
    var arr = [];
    var rnd = Math.random();
    var num, sign;

    if (rnd >= 0.2 && rnd < 0.7) {
        sign = true;
    } else if (rnd >= 0.7) {
        sign = false;
    }

    for (; i < length; i++) {
        if (typeof sign === "undefined") {
            num = randomNumber(max, true);
        } else {
            num = randomSignedNumber(max, !sign);
        }

        arr[i] = num;
    }

    return arr;
}

var scatterplot = {
    item: function item() {
        var ticker = tickers.ticker();
        return {
            totalReturn: randomNumber(20, true),
            standardDeviation: randomNumber(20, true),
            weight: randomNumber(100),
            ticker: ticker
        };
    },

    category: function category() {
        var arr = [];
        var num = Math.ceil(Math.random() * 5);
        var i = 0;
        for (; i < num; i++) {
            arr.push(scatterplot.item());
        }

        return {
            category: getLipsum(2),
            data: arr
        };
    },

    data: function data() {
        var dataset = [];
        var num = Math.ceil(Math.random() * 5) + 1;
        var i = 0;

        for (; i < num; i++) {
            dataset.push(scatterplot.category());
        }

        return {
            benchmark: {
                totalReturn: randomNumber(20, true),
                standardDeviation: randomNumber(20, true)
            },
            data: dataset
        };
    }
};

var barchart = {
    data: function data(howMany, maxValue) {
        var dataset = [];
        var num = Math.ceil(Math.random() * 5) + 1;
        var i = 0;
        howMany = howMany || 7;
        maxValue = maxValue || 100;

        for (; i < num; i++) {
            dataset.push(barchart.series(howMany, maxValue));
        }

        return dataset;
    },

    data2: function data2(howMany, maxValue) {
        var dataset = [];
        var num = Math.ceil(Math.random() * 5) + 1;
        var i = 0;
        howMany = howMany || 7;
        maxValue = maxValue || 100;

        for (; i < num; i++) {
            dataset.push({
                name: "Data " + (i + 1),
                values: randomArray(howMany, maxValue)
            });
        }

        return dataset;
    },

    series: function series(howMany, maxValue) {
        return {
            name: getLipsum(2),
            values: randomArray(howMany, maxValue)
        };
    },

    categories: function categories(prefix, num) {
        var arr = [];
        var i = 0;
        for (; i < num; i++) {
            arr[i] = prefix + " " + (i + 1);
        }

        return arr;
    },

    xlabels: function xlabels(num) {
        var i = 0;
        var arr = [];
        for (; i < num; i++) {
            if (Math.random() > 0.7) {
                arr[i] = getLipsum(1);
            } else {
                arr[i] = null;
            }
        }

        return arr;
    }
};

var getRandomDate = function getRandomDate(start, end) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
};

var generateDates = function generateDates(range, amtOfDates) {
    var dates = [];

    var dateRange = void 0;
    switch (range) {
        case "hours":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2016, 0, 1), new Date(2016, 0, 2));
            };
            break;
        case "days":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2016, 0, 1), new Date(2016, 0, 6));
            };
            break;
        case "weeks":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2016, 0, 1), new Date(2016, 1, 28));
            };
            break;
        case "months":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2016, 0, 1), new Date(2016, 11, 1));
            };
            break;
        case "quarters":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2015, 0, 1), new Date(2016, 12, 31));
            };
            break;
        case "years":
            dateRange = function dateRange() {
                return getRandomDate(new Date(2010, 0, 1), new Date(2016, 11, 0));
            };
            break;
        default:
            console.error("range required to generate dates");
            break;
    }

    for (var i = 0; i < amtOfDates; i++) {
        dates.push(dateRange());
    }

    return dates;
};

function getIncrementalValue(increment) {
    var positive = Math.floor(Math.random() * 2 + 1) === 1 ? false : true;

    if (positive) {
        return Math.floor(Math.random() * increment);
    } else {
        return -Math.floor(Math.random() * increment);
    }
}

//***** line chart *****/

var LineGenerator = function LineGenerator(dateRange) {
    this.leng = 50;
    this.dates = generateDates(dateRange, this.leng);
};

LineGenerator.prototype.generateDataset = function (opts) {
    return {
        y1: this.generateLineData(opts),
        y2: this.generateLineData(opts)
    };
};

LineGenerator.prototype.generateLineData = function (opts) {
    var groupName = Math.floor(Math.random() * 2 + 1) === 1 ? "y2" : "y1";
    var time = new Date();
    var name = time.getMilliseconds() + Math.floor(Math.random() * 999).toString();
    var segments = [];
    var currentValue = Math.floor(Math.random() + opts.minValue);

    for (var i = 0; i < opts.segments; i++) {
        var newValue;
        if (currentValue >= opts.maxValue || currentValue + opts.increment > opts.maxValue) {
            newValue = currentValue - opts.increment;
        } else {
            newValue = currentValue + getIncrementalValue(opts.increment);
        }

        segments.push({
            name: name,
            value: newValue,
            date: this.dates[i],
            groupName: groupName
        });
        currentValue = newValue;
    }
    return segments;
};

/**** end linechart */

module.exports = {
    ticker: tickers.ticker,
    lipsum: getLipsum,
    number: randomNumber,
    array: randomArray,
    scatterplot: scatterplot,
    barchart: barchart,
    getRandomDate: getRandomDate,
    generateDates: generateDates,
    linechart: LineGenerator,
    crmatrix: crmatrix
};

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Calls a function if exists. The first argument should be the function to call followed by the arguments.
 *
 * @return {Object} Undefined if there is no function to call or what the function returns.
 */

var callFn = function callFn() {
    var args = Array.prototype.slice.call(arguments, 2);
    var context = arguments[0];
    var fn = arguments[1];

    if (fn) {
        return fn.apply(context, args);
    }
};

module.exports = {
    call: callFn
};

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    /**
     * Returns how many digits have a number.
     * @param {number} number Number to inspect. Rquired.
     * @param {Number} base Numeric base.
     * @returns {Number}
     */
    digits: function digits(number) {
        var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

        var digits = 0;

        while (number >= 1) {
            number = number / base;
            digits++;
        }

        return digits;
    },
    /**
    * @method isNumber
    * @desc Judge if a value is a valid number or a valid string number
    * @param literals value
    * Return Boolean
    */
    isNumber: function isNumber(value) {
        if (typeof value === "number" && isFinite(value)) {
            return true;
        }
        if (typeof value === "string" && value !== "" && !isNaN(value - 0)) {
            return true;
        }
        return false;
    },

    /**
     * @method getValidValue
     * @desc Return value if it is included in the valid values array, return the default otherwise
     * @param {Number} value 
     * @param {Object} validValues array including valid values
     * @param {Number} defaultValue
     */
    getValidValue: function getValidValue(value, validValues, defaultValue) {
        if (validValues.length === 0 || validValues.indexOf(value) === -1) {
            return defaultValue;
        }
        return value;
    }

};

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CARDINAL_STR = "$$";

/**
 * It returns either the original value if zero or positive, or, if negative or NaN, the value with an em dash.
 *
 * @param {Number} A single number.
 * @return {Number || String} 10, "—10", "NaN", ...
 */
function convertDashToEnDash(val) {
    var stringed = val.toString();

    if (stringed === "NaN") {
        return "\u2014";
    }

    if (stringed[0] === "-") {
        var sliced = stringed.slice(1);
        sliced = "\u2013" + sliced;
        return sliced;
    }

    return val;
}
/**
 * Generates a Unique ID.
 * @returns {String} New unique ID.
 */
var UID = function UID() {
    return "_" + (Date.now().toString(36) + Math.random().toString(36).substr(2, 5));
};

/**
 * Converts a string in dashed format.
 *
 * @param {String} str String to convert.
 * @returns {String}
 */
function dashify(str) {
    str = str.replace(/\s+/g, "-").toLowerCase();
    return str;
}

/**
 * Compiles a string template agains a context and returns a new string.
 * <code>
 * var template =
 * 'My skills:' +
 * '<%if(this.showSkills) {%>' +
 *    '<%for(var index in this.skills) {%>' +
 *    '<a href="#"><%this.skills[index]%></a>' +
 *   '<%}%>' +
 * '<%} else {%>' +
 *    '<p>none</p>' +
 * '<%}%>';
 * console.log(TemplateEngine(template, {
 *    skills: ["js", "html", "css"],
 *    showSkills: true
 * }));
 * </code>
 * @param {String} html Template string.
 * @param {Object} data Context object that contains the data.
 * @returns {String}
 */
var template = function template(html, data) {
    var re = /<%([^%>]+)?%>/g;
    var reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g;
    var code = "var r=[];\n";
    var cursor = 0;
    var match;

    var add = function add(line, js) {
        js ? code += line.match(reExp) ? line + "\n" : "r.push(" + line + ");\n" : code += line !== "" ? "r.push('" + line.replace(/"/g, "\\'") + "');\n" : ""; //jshint ignore:line
        return add;
    };

    match = re.exec(html);
    while (match) {
        add(html.slice(cursor, match.index))(match[1], true);
        cursor = match.index + match[0].length;
        match = re.exec(html);
    }

    add(html.substr(cursor, html.length - cursor));
    code += "return r.join('');";
    return new Function(code.replace(/[\r\t\n]/g, "")).apply(data); // jshint ignore:line
};

/**
 * Adds a prefix based on an index.
 *
 * @param {String} str
 * @param {Number} index
 * @returns {String}
 */
function mask(str, index) {
    return index + CARDINAL_STR + str;
}

/**
 * Remove index based prefix.
 *
 * @param {String} str
 * @returns {String}
 */
function unmask(str) {
    if (!str) return '';

    var index = str.indexOf(CARDINAL_STR);
    return index < 0 ? str : str.substr(index + CARDINAL_STR.length);
}

/**
 * Get pixel with of string appended to the DOM
 *
 * @param {String} txt
 * @param {String} fontname = font family, e.g., "'UniversBold', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif"
 * @param {Number} fontsize, e.g., 16px
 * @returns {String}
 */
function getTextWidth(txt, fontname, fontsize) {
    var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
    var context = canvas.getContext("2d");
    context.font = fontsize + " " + fontname;
    var w = context.measureText(txt);
    canvas = null;
    return w.width;
}

/**
 * To get the pixel width of the longest string in the data set
 *
 * @param {String} txt
 * @param {String} fontname = font family, e.g., "'UniversBold', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif"
 * @param {Number} fontsize, e.g., 16
 * @returns {String}
 */
function getLongestTextStringWidth(data, font, size) {

    font = font || "'UniversBold', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif";
    size = size || 16;

    var longest = 0;
    var value;

    data.forEach(function (obj) {
        if (obj.value != null && obj.value.toString().length > longest) {
            longest = obj.value.toString().length;
            value = obj.value;
        }
    });

    var w = getTextWidth(value, font, size);
    return w;
}

/**
 * Break strings to fit a specific width when no natural breakpoints are available
 *
 * @param {String} text string that needs to be broken
 * @param {Number} textWidth calculated DOM width of that string
 * @param {Number} containerWidth width the string cannot exceed.
 * @param {Boolean} isStyleMap specifies if the chart type is Style Map
 * @returns {Array}
 */
function breakString(text, textWidth, containerWidth) {
    var isStyleMap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var acceptableStringLength = Math.round(text.length * containerWidth / textWidth);
    var newStrings = text.match(new RegExp('.{1,' + acceptableStringLength + '}', 'g'));
    return this.checkSingleStrings(newStrings, isStyleMap);
}

/**
 * @param {string} character such as 'a', '-', '#'
 *
 * @returns {number} width of the character in 14px Univers
 */
function getCharacterWidth(character) {
    var _characterWidthMap;

    var characterWidthMap = (_characterWidthMap = {
        a: 6.14599609375,
        b: 6.467987060546875,
        c: 5.683990478515625,
        d: 6.467987060546875,
        e: 6.1039886474609375,
        f: 3.891998291015625,
        g: 6.48199462890625,
        h: 6.6079864501953125,
        i: 2.98199462890625,
        j: 2.98199462890625,
        k: 5.739990234375,
        l: 2.98199462890625,
        m: 9.64599609375,
        n: 6.6079864501953125,
        o: 6.2299957275390625,
        p: 6.467987060546875,
        q: 6.4539947509765625,
        r: 4.05999755859375,
        s: 5.36199951171875,
        t: 3.9059906005859375,
        u: 6.6079864501953125,
        v: 5.6139984130859375,
        w: 9.393997192382812,
        x: 5.4319915771484375,
        y: 5.62799072265625,
        z: 4.717987060546875,
        A: 7.6719970703125,
        B: 7.321990966796875,
        C: 7.15399169921875,
        D: 7.82598876953125,
        E: 6.3839874267578125,
        F: 5.85198974609375,
        G: 7.5879974365234375,
        H: 8.035995483398438,
        I: 3.42999267578125,
        J: 6.3839874267578125,
        K: 6.985992431640625,
        L: 5.7679901123046875,
        M: 11.017990112304688,
        N: 8.581985473632812,
        O: 7.7559967041015625,
        P: 6.7899932861328125,
        Q: 7.839996337890625,
        R: 7.33599853515625,
        S: 6.803985595703125,
        T: 6.0619964599609375,
        U: 8.035995483398438,
        V: 7.097991943359375,
        W: 11.605987548828125,
        X: 7,
        Y: 6.761993408203125,
        Z: 6.313995361328125,
        0: 6.3279876708984375,
        1: 6.3279876708984375,
        2: 6.3279876708984375,
        3: 6.3279876708984375,
        4: 6.3279876708984375,
        5: 6.3279876708984375,
        6: 6.3279876708984375,
        7: 6.3279876708984375,
        8: 6.3279876708984375,
        9: 6.3279876708984375,
        "‐": 8.1005859375,
        "-": 4.003997802734375,
        "–": 7,
        "—": 14.013992309570312,
        _: 7,
        "=": 7.545989990234375,
        "~": 7.545989990234375,
        "^": 8.301986694335938,
        "&": 7.881988525390625,
        "#": 6.3279876708984375,
        "@": 12.235992431640625,
        "(": 3.485992431640625,
        ")": 3.485992431640625,
        "*": 5.907989501953125,
        "[": 3.485992431640625,
        "]": 3.485992431640625
    }, _defineProperty(_characterWidthMap, "-", 4.003997802734375), _defineProperty(_characterWidthMap, "#", 6.3279876708984375), _characterWidthMap);

    if (character in characterWidthMap) {
        return characterWidthMap[character];
    }
    return getTextWidth(character, "Univers", "14px");
}

/**
 * @param {character} char1 such as 'a', '-', '#'
 * @param {character} char2 such as 'A', '-', '#'
 *
 * @returns {boolean} true if they are both letters and char1 
 * is in lower case and char2 is in upper case, false otherwise
 */
function compareLetterCase(char1, char2) {
    var isLowerCaseRegex = /[a-z]/;
    var isUpperCaseRegex = /[A-Z]/;
    if (isLowerCaseRegex.test(char1) && isUpperCaseRegex.test(char2)) {
        return true;
    }
    return false;
}

/**
 * Break legend text to an array when the text cannot fit in the container
 *
 * Note:
 * 1. The logic factors in punctuation marks such as hyphen
 * 2. The logic factors in letter cases
 *
 * @example
 * "somePrefix-content" is broken into ["somePrefix-", "content"] instead of ["somePrefix-con", "tent"]
 * "MorningstarBaseCharts" is broken into ["Morningstar", "BaseCharts"] instead of ["MorningstarBa", "seCharts"]
 *
 * @param {String} text string that needs to be broken
 * @param {Number} containerWidth width the string cannot exceed excluding any icon paddings
 * @returns {Array} an array guaranteed to fit in the container
 */
function breakLegend(text, containerWidth) {
    var fragments = [];
    var runningText = "";
    var runningTextIndex = 0;
    var runningTextWidth = 0;
    var breakpointIndex = -1; // This could either be a punctuation mark or a different letter case
    var punctuationMarks = [" ", "‐", "-", "–", "—", "_", "=", "~", "^", "&", "#", "@", "(", ")", "*", "[", "]", "-", "#"]; // Add more punctuation marks if necessary

    for (var i = 0; i < text.length; i++) {
        var currChar = text[i];
        runningTextWidth += getCharacterWidth(currChar);

        if (runningTextWidth >= containerWidth) {
            // If we have seen a breakpoint, add the text up to the breakpoint; otherwise, add all running text
            if (breakpointIndex != -1) {
                fragments.push(runningText.slice(0, breakpointIndex));
                runningText = runningText.slice(breakpointIndex) + currChar;
                runningTextIndex = runningText.length;
                runningTextWidth = getTextWidth(runningText);
            } else {
                fragments.push(runningText);
                runningText = currChar;
                runningTextIndex = 1;
                runningTextWidth = getCharacterWidth(currChar);
            }
            breakpointIndex = -1;
            continue;
        }

        runningText += currChar;
        runningTextIndex += 1;

        // Mark the punctuation or the next character if the next character has a different letter case
        if (punctuationMarks.indexOf(currChar) >= 0) {
            breakpointIndex = runningTextIndex;
        } else if (i + 1 < text.length && compareLetterCase(currChar, text[i + 1])) {
            breakpointIndex = runningTextIndex;
        }
    }

    if (runningText !== "") {
        fragments.push(runningText);
    }
    return fragments;
}

/**
 * Concats strings that have been broken into some segments
 *
 * @example
 *  when isStypeMap is false:
 *  checkSingleStrings(['abc', 'd']) returns ['abcd']
 *  checkSingleStrings(['abc', 'de']) returns ['abc', 'de']
 *  checkSingleStrings(['abc', 'def']) returns ['abc', 'def']
 * 
 *  when isStypeMap is true:
 *  checkSingleStrings(['abc', 'd']) returns ['abcd']
 *  checkSingleStrings(['abc', 'de']) returns ['abcde']
 *  checkSingleStrings(['abc', 'def']) returns ['abcdef']
 * 
 * @param {Array} text string array that is broken
 * @param {Boolean} isStyleMap specifies if the chart type is Style Map
 * @returns {Array}
 **/
function checkSingleStrings(text, isStyleMap) {
    var maxLength = isStyleMap ? 3 : 1;
    for (var i = 0; i < text.length; i++) {
        var obj = text[i];
        if (obj.length <= maxLength) {
            // get index of current
            var indexOfWord = text.indexOf(obj);
            // set prev index to concat with current
            if (indexOfWord === 0) {
                if (text.length < maxLength) {
                    text = text[indexOfWord].concat(text[indexOfWord + 1]);
                    return [text];
                } else {
                    break;
                }
            } else {
                text.splice(indexOfWord - 1, 2, text[indexOfWord - 1].concat(text[indexOfWord]));
            }
        }
    }
    return text;
}

module.exports = {
    convertDashToEnDash: convertDashToEnDash,
    dashify: dashify,
    template: template,
    UID: UID,
    mask: mask,
    unmask: unmask,
    getLongestTextStringWidth: getLongestTextStringWidth,
    getTextWidth: getTextWidth,
    breakString: breakString,
    checkSingleStrings: checkSingleStrings,
    breakLegend: breakLegend
};

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var object = __webpack_require__(3);

/**
 * Returns the path for a rounded rectangle.
 * @param {Number} x X position.
 * @param {Number} y Y position.
 * @param {Number} w Width.
 * @param {Number} h Heigth.
 * @param {Number} r Radius.
 * @param {Boolean} tl Top-Left.
 * @param {Boolean} tr Top-Right.
 * @param {Boolean} bl Bottom-Left.
 * @param {Boolean} br Bottom-Right.
 * @returns {String} Rounded Rectangle path.
 */
var roundedRect = function roundedRect(x, y, w, h, r, tl, tr, bl, br) {
    var result;
    result = "M" + (x + r) + "," + y;
    result += "h" + (w - 2 * r);
    if (tr) {
        result += "a" + r + "," + r + " 0 0 1 " + r + "," + r;
    } else {
        result += "h" + r;result += "v" + r;
    }

    result += "v" + (h - 2 * r);
    if (br) {
        result += "a" + r + "," + r + " 0 0 1 " + -r + "," + r;
    } else {
        result += "v" + r;result += "h" + -r;
    }

    result += "h" + (2 * r - w);
    if (bl) {
        result += "a" + r + "," + r + " 0 0 1 " + -r + "," + -r;
    } else {
        result += "h" + -r;result += "v" + -r;
    }

    result += "v" + (2 * r - h);
    if (tl) {
        result += "a" + r + "," + r + " 0 0 1 " + r + "," + -r;
    } else {
        result += "v" + -r;result += "h" + r;
    }

    result += "z";
    return result;
};

/**
 * Get an SVG Text width by adding it, getting the width and removing it.
 * @param {D3.Object} svgContainer Container where the text is gonna be attached.
 * @param {String} text Text to test width.
 * @return {Number} Calculated width.
 */
var getSVGTextWidth = function getSVGTextWidth(svgContainer, text, className) {
    var el = svgContainer.append("text").classed(className,  true && className).text(text);
    var width = el.node().getBoundingClientRect().width;
    el.remove();
    return width;
};

/**
 * Get the longest String in pixels from a given array of data.
 * @param {D3.Object} svgContainer Container where the texts are gonna be attached.
 * @param {Array} data Array containig the texts.
 * @param {String|Function}? accessor description
 */
var getGreaterSVGTextWidth = function getGreaterSVGTextWidth(svgContainer, data, accessor) {
    var greatest = 0;
    var text, width;
    data.forEach(function (item, i) {
        text = object.extract(item, accessor, i);
        width = getSVGTextWidth(svgContainer, text);
        greatest = width > greatest ? width : greatest;
    });

    return greatest;
};

/**
 * Get the total width of all Strings in pixels from a given array of data.
 * @param {D3.Object} svgContainer Container where the texts are gonna be attached.
 * @param {Array} data Array containig the texts.
 * @param {String|Function}? accessor description
 */
var getTotalSVGTextWidth = function getTotalSVGTextWidth(svgContainer, data, accessor) {
    var total = 0;
    var width;
    data.forEach(function (item, i) {
        var dataName = item.__data__.displayName || item.__data__.name;
        width = getSVGTextWidth(svgContainer, dataName) + 15;
        if (item instanceof SVGElement) {
            var isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent);
            width = item.getBoundingClientRect().width > width && !isSafari ? item.getBoundingClientRect().width : width;
        }
        total += width;
    });
    return total;
};

module.exports = {
    roundedRect: roundedRect,
    getSVGTextWidth: getSVGTextWidth,
    getGreaterSVGTextWidth: getGreaterSVGTextWidth,
    getTotalSVGTextWidth: getTotalSVGTextWidth
};

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * morningstar-base-charts
 *
 * Copyright © 2016 . All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
var mbc_mds_constants = __webpack_require__(14).constants;
var mbc_mds_chart_color = mbc_mds_constants["chart-color"];

module.exports = {
    colors: [mbc_mds_chart_color["1"], mbc_mds_chart_color["2"], mbc_mds_chart_color["3"], mbc_mds_chart_color["4"], mbc_mds_chart_color["5"], mbc_mds_chart_color["6"], mbc_mds_chart_color["7"]],
    canvasDefaults: {
        axesSpacing: 5,
        margin: { top: 20, right: 20, bottom: 20, left: 20 }
    }
};

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    // d3 overrides
    //----------------------------------

    d3.selection.prototype.first = function () {
        if (!this[0]) {
            return d3.select();
        }

        return d3.select(this[0][0]);
    };

    d3.selection.prototype.last = function () {
        if (!this[0]) {
            return d3.select();
        }

        var last = this.size() - 1;
        return d3.select(this[0][last]);
    };
    d3.selection.prototype.attrs = function (obj) {
        for (var attr in obj) {
            this.attr(attr, obj[attr]);
        }

        return this;
    };

    //---------------oOo-----------------
};

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
    // Makes version of MBC available on window for debugging
    // VERSION is dynamically replaced as prebuild step
    window.mbc = {
        version: "2.32.12"
    };
};

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



// jscs:disable safeContextKeyword

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Utils = __webpack_require__(4);

/**
 * Base object. Provides a way to Class inheritance and use of mixins.
 *
 * @example {@lang javascript}
 *  // Simple extension.
 *
 *  // Creates a Person class extending from Base.
 *  var Person = Base.extend({
 *      name: "John",
 *      greet: function () { return "Hello, my name is" + this.get("name") + ".";}
 *  });
 *  var person = new Person();
 *  person.greet(); // "Hello, my name is John."
 *
 *  // Extending Person
 *  var Musician = Person.extend({
 *      name: "Wolfgang",
 *      instrument: "Violin",
 *      greet: function () { return this.__super__.greet.call(this) + " I play the " + this.get("instrument"); }
 *  });
 *
 *  var mozart = new Musician();
 *  mozart.greet()  // Hello, my name is Wolfgang. I play the Violin.
 *
 *  mozart.set("instrument", "Piano");
 *  mozart.greet()  // Hello, my name is Wolfgang. I play the Piano.
 * @example
 *  // Extension with mixins
 *
 *  // Mixin definition
 *  function DriverMixin () {}
 *  DriverMixin.prototype.drive = function() { return this.get("name") + "is driving a" + this.get("vehicle"); };
 *
 *  var Driver = Person.extend(DriverMixin, {
 *      vehicle: "Motorcycle"
 *  })
 *
 *  var juanPabloMontoya = new Driver();
 *
 *  juanPabloMontoya.drive(); // "John is driving a motorcycle"  <-- That's incorrect
 *  juanPabloMontoya.set("name", "Juan Pablo");
 *  juanPabloMontoya.set("vehicle", "Formula Car");
 *  juanPabloMontoya.drive(); // "Juan Pablo is driving a Formula Car"  <-- Now That's correct
 * @param {Object} options Class' instance attributes to be setted. Overrides existing ones or create a new attribute if it does not exist.
 * @constructor
 */
var Base = function Base() {};

Base.prototype = {
    __attributes: null,
    __watchers: null,
    /**
     * Sets the <i>value</i> under the passed <i>key</i> into the attributes's store.
     * @param {any} key Name of the attribute to store.
     * @param {any} value Attribute's value.
     * @returns {Base} object's instance to allow chainability.
     */
    set: function set(key, value) {
        this.__attributes[key] = value;
        this._checkWatcher(key, value);
        return this;
    },

    /**
     * Search the attribute's store and returns its value.
     * @param {any} key Attribute's key to retrieve.
     * @returns {Object} Attribute's value.
     */
    get: function get(key) {
        return this.__attributes[key];
    },

    /**
     * Initialize object attributes.
     */
    _initAttrs: function _initAttrs(options) {
        for (var key in options) {
            this.set(key, options[key]);
        }
    },

    /**
     * Set an attribute bound watcher.
     * @param {String} attribute Attribute's name.
     * @param {Function} handler Method to execute when the attribute changes.
     */
    watch: function watch(attribute, handler) {
        var watcher = this.__watchers[attribute];
        var handlers, length, value;

        if (watcher) {
            handlers = watcher.handlers;
            length = handlers.filter(function (fn) {
                return "" + fn === "" + handler;
            }).length;
            if (!length) {
                handlers.push(handler);
            }
        } else {
            value = this.__attributes ? this.__attributes[attribute] : undefined;
            this.__watchers[attribute] = {
                oldValue: value,
                handlers: [handler]
            };
        }
    },

    /**
     * Remove all handlers attached to an attribute key or just the one that contains the specified handler if it is passed as paramter
     * @param {String} attribute Attribute's name.
     * @param {Function} handler Optional. If not passed removes all handlers attached to the attribute.
     */
    unwatch: function unwatch(attribute, handler) {
        var watcher = this.__watchers[attribute];
        var handlers;

        if (watcher) {
            if (!handler) {
                delete this.__watchers[attribute];
            } else {
                handlers = watcher.handlers;
                handlers.splice(handlers.indexOf(handler), 1);
            }
        }
    },

    /**
     * Removes all attributes watchers.
     */
    unwatchAll: function unwatchAll() {
        this.__watchers = {};
    },

    /**
     * Checks if the attribute have been modified and execute the handler function.
     * @param {String} attribute Attribute's name.
     * @param {Object} newValue New attribute's value.
     */
    _checkWatcher: function _checkWatcher(attribute, newValue) {
        var watcher = this.__watchers[attribute];

        if (watcher && newValue !== watcher.oldValue) {
            watcher.handlers.forEach(function (handler) {
                handler(newValue, watcher.oldValue);
                watcher.oldValue = newValue;
            });
        }
    }

};

/**
 * Method that returns a new class extending the class that calls it. If mixins are
 * passed its methods are extended to the resultant class too.
 * @static
 * @returns {Class}
 */
Base.extend = function () {
    var properties = {};
    var mixins = [];
    var i = 0;
    var arg = arguments[i++];
    var parent = this;
    var parentDefaults = parent.prototype.__defaults__ || {};
    var defaults = {};
    var child, key, value;

    Utils.object.copy(defaults, parentDefaults);

    while ((typeof arg === "undefined" ? "undefined" : _typeof(arg)) !== "object") {
        mixins.push(arg);
        arg = arguments[i++];
    }

    properties = arg;

    child = function child(options) {
        parent.apply(this, arguments);

        this.__attributes = this.__attributes || {
            _id: new Date().getTime()
        };
        this.__watchers = {};
        for (key in this.__defaults__) {
            if (!this.__attributes[key]) {
                this.__attributes[key] = this.__defaults__[key];
            }
        }

        // Apply options
        if (options) {
            this._initAttrs(options);
        }

        if (properties.initializer && typeof properties.initializer === "function") {
            properties.initializer.call(this);
        }

        mixins.forEach(function (mixin) {
            if (mixin.prototype.initializer) {
                mixin.prototype.initializer.call(this);
            }
        }.bind(this));
    };

    // Copying statics from old class to new one.
    for (key in parent) {
        if (parent.hasOwnProperty(key)) {
            child[key] = parent[key];
        }
    }

    child.prototype = Object.create(parent.prototype);

    for (key in parent.prototype) {
        value = parent.prototype[key];
        if (typeof value !== "function") {
            if (key !== "attributes" && key !== "__super__" && key !== "__defaults__") {
                defaults[key] = value;
            }
        }
    }

    // Adding/overwriting new properties into child prototype.
    if (properties) {
        for (key in properties) {
            if (properties.hasOwnProperty(key)) {
                value = properties[key];
                if (typeof value === "function") {
                    child.prototype[key] = value;
                } else if (key !== "attributes" && key !== "__super__" && key !== "__defaults__") {
                    defaults[key] = value;
                }
            }
        }
    }

    mixins.forEach(function (mixin) {
        Utils.object.copy(child.prototype, mixin.prototype);
    });

    child.prototype.__defaults__ = Utils.object.clone(defaults);

    child.prototype.__super__ = parent.prototype;
    return child;
};

module.exports = Base;

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BASE = "mbc";
var CHART = BASE + "-chart";

module.exports = {
    AXES: BASE + "-axes",
    AXIS: BASE + "-axis",
    BACK: BASE + "-back-group",
    CANVAS: BASE + "-canvas",
    CHART_GROUP: CHART + "-group",
    CHART: CHART,
    CHARTS_AREA: CHART + "s-area",
    CONTAINER: CHART + "-container",
    DECK: CHART + "-deck",
    FOCUS: CHART + "-focus",
    FRONT: BASE + "-front-group",
    GRID: BASE + "-grid",
    GRID_LINE: BASE + "-grid-line",
    INNER: CHART + "-inner",
    LAYERS: BASE + "-layers",
    LEGEND_ITEM: CHART + "-legend-item",
    LEGEND: CHART + "-legend",
    TITLE: CHART + "-title",
    TOOLTIP: CHART + "-tooltip",
    TOOLTIP_CONTAINER: CHART + "-tooltip-container",
    ZONES: CHART + "-zones",
    ZONE: CHART + "-zone"
};

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates an AxesManager instance. AxesManagers centralize chart's axes
 * in order to access them transversely.<br>
 * @example
 * var axesManager = new AxesManager({"x", d3.svg.axis()})
 * @constructor
 * @param {object} axes <i>Optional</i>. A hashmap with chart's axes.
 */

function AxesManager(axes) {
    this._axes = axes || {};
}
/**
 * Sets or returns an axis. If no axis object is passsed then sets the axis.
 * @param  {String} axisName
 * @param  {D3.axis} axis
 *
 * @return {D3.axis}
 */
AxesManager.prototype.axis = function (axisName, axis) {
    if (!axisName) {
        return;
    }

    if (!axis) {
        return this._axes[axisName];
    }

    this._axes[axisName] = axis;
    return axis;
};

/**
 * Remove an axis from the collection.
 * @param {String} axisName Axis to remove.
 */
AxesManager.prototype.remove = function (axisName) {
    delete this._axes[axisName];
};

/**
 * Return the axes store object.
 *
 * @returns {Object} Hashmap that containing the axes.
 */
AxesManager.prototype.axes = function () {
    return this._axes;
};

module.exports = AxesManager;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Base = __webpack_require__(6);
var Classes = __webpack_require__(7);
var Config = __webpack_require__(48);

/**
 * Canvas is in charge of create and calculate dimensions of the svg container where the chart is going to be rendered.
 * Also creates layers that holds chart's parts (axis, chart area, etc.)
 * @constructor
 * @param {D3.selection} container
 * @param {Object} margin
 */
var Canvas = Base.extend(
/**
 *  @lends Canvas.prototype
 **/
{
    /** @type {D3 selection} */
    selection: null,
    /** @type {Object} */
    margin: Config.canvasDefaults.margin,
    /** @type {Number} */
    axesSpacing: Config.canvasDefaults.axesSpacing,
    /** @type {Number} */
    axesPadding: 0,
    /** @type {DOM element} */
    container: null,
    /** @type {DOM element} */
    svg: null,
    /** @type {Number} */
    yAxesLabelWidth: 10,

    /**
     * Sets up the canvas object
     */
    initializer: function initializer() {
        var template = this.get("template");

        if (template && (typeof template === "string" || typeof template === "function")) {
            this.get("selection").html(template);
            this.set("container", this.get("selection").select("." + Classes.INNER)[0][0]);
            this.set("inner", true);
        } else {
            this.set("container", this.get("selection")[0][0]);
        }

        this.calculate();
        this.buildSVG();
    },

    /**
     * Update the canvas.
     * @return {Canvas} this Canvas object.
     */
    update: function update() {
        this.calculate();
        this.buildSVG();
        return this;
    },

    /**
     * Returns the width of chart inner container.
     * @return {Number} Inner container width.
     */
    width: function width() {
        return this.get("width");
    },

    /**
     * Returns the inner container height.
     * @return {Number} Inner container height.
     */
    height: function height() {
        return this.get("height");
    },

    /**
     * Returns the outer container width.
     * @return {Number} Outer container width.
     */
    outerWidth: function outerWidth() {
        return this.get("outerWidth");
    },

    /**
     * Returns the outer container height.
     * @return {Number} Outer container height.
     */
    outerHeight: function outerHeight() {
        return this.get("outerHeight");
    },

    /**
     * Calculates width and height of chart's area.
     */
    calculate: function calculate() {
        var selection = this.get("selection")[0][0];
        var container = this.get("container");
        var margin = this.get("margin");

        this.set("width", container.offsetWidth - margin.left - margin.right);
        this.set("height", container.offsetHeight - margin.top - margin.bottom);
        this.set("outerWidth", selection.offsetWidth);
        this.set("outerHeight", selection.offsetHeight);
    },

    /**
     * Appends the SVG Elements and set its dimensions.
     * @private
     */
    buildSVG: function buildSVG() {
        var svg = this.get("svg");
        var margin = this.get("margin");

        if (!svg) {
            svg = d3.select(this.get("container")).append("svg").attr("role", "figure").classed(Classes.CANVAS, true);
            this.set("svg", svg);
        }

        this.buildContainerGroups();
        svg.attrs({
            width: this.get("width") + margin.left + margin.right,
            height: this.get("height") + margin.top + margin.bottom
        });
    },

    /**
     * Build layered contaiers for each charts components in this order:.
     *
     * <li> Axes layer. </li>
     * <li> Behind chart layer. </li>
     * <li> Chart layer. </li>
     * <li> Front Chart layer. </li>
     * @private
     */
    buildContainerGroups: function buildContainerGroups() {
        var margin = this.get("margin");
        var svg = this.get("svg");
        var groups = svg.select("." + Classes.LAYERS);

        if (groups.empty()) {
            groups = svg.append("g").classed(Classes.LAYERS, true);

            this.set("axesGroup", groups.append("g").classed(Classes.AXES, true));
            this.set("backGroup", groups.append("g").classed(Classes.BACK, true));
            this.set("chartGroup", groups.append("g").classed(Classes.CHART_GROUP, true));
            this.set("frontGroup", groups.append("g").classed(Classes.FRONT, true));
        }

        groups.attrs({
            transform: "translate(" + margin.left + "," + margin.top + ")"
        });
    },

    /**
     * Returns a layer inside the chart area, if it does not exist creates it unless avoidCreate is true.
     *
     * @param {String} layerName
     * @param {String} groupName axes, back, front, chart.
     * @param {Boolean} avoidCreate
     * @returns {D3.Selection}
     */
    layer: function layer(layerName, groupName, avoidCreate) {
        groupName = (groupName || "chart") + "Group";
        var group = this.get(groupName);
        var layer = group.select("." + layerName);

        if (!avoidCreate && layer.empty()) {
            layer = group.append("g").classed(layerName, true);
        }

        return layer;
    },

    /**
     * Removes a layer inside the given group.
     *
     * @param {String} layerName
     * @param {String} groupName axes, back, front, chart.
     * @returns {D3.Selection}
     */
    removeLayer: function removeLayer(layerName, groupName) {
        groupName = (groupName || "chart") + "Group";
        var group = this.get(groupName);
        group.select("." + layerName).remove();
    },

    /**
     * Remove the old axes (if they exist) and add the new axes into the axes layer.
     *
     * @param {AxesManager} axesManager AxesManager containing updated axes.
     */
    drawAxes: function drawAxes(axesManager) {
        var axes = axesManager.axes();
        var axesCount = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
        var axesGroup = this.get("axesGroup");
        var yAxesLabelWidth = this.get("yAxesLabelWidth");
        var axesSpacing = this.get("axesSpacing") + yAxesLabelWidth;
        var axesPadding = this.get("axesPadding");
        var key, axis, translate, orient, count, tickSize, calc;

        axesGroup.selectAll("." + Classes.AXIS).remove();
        for (key in axes) {
            var _axesGroup$append$cla;

            axis = axes[key];
            orient = axis.orient();
            count = axesCount[orient];
            tickSize = axis.tickSize();

            switch (orient) {
                case "bottom":
                    translate = "translate(0, " + this.get("height") + ")";
                    break;
                case "right":
                    calc = axesPadding + (this.get("width") + count * (axesSpacing + tickSize));
                    translate = "translate(" + calc + ", 0)";
                    break;
                case "top":
                    translate = "translate(0, 0)";
                    break;
                case "left":
                    calc = 0 - axesPadding - count * (axesSpacing + tickSize);
                    translate = "translate(" + calc + ", 0)";
                    break;
                default:
                    break;
            }
            axesCount[orient]++;
            axesGroup.append("g").classed((_axesGroup$append$cla = {}, _defineProperty(_axesGroup$append$cla, Classes.AXIS, true), _defineProperty(_axesGroup$append$cla, Classes.AXIS + "-" + key, true), _defineProperty(_axesGroup$append$cla, Classes.AXIS + "-" + orient, true), _axesGroup$append$cla)).attr("transform", translate).call(axis);
        }
    },
    /**
     * Removes the canvas from the container and reset the watchers object.
     */
    remove: function remove() {
        this.unwatchAll();
        this.get("selection").selectAll("*").remove();
    }
});

module.exports = Canvas;

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _tabs_vue_vue_type_template_id_5eed886d___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(164);
/* harmony import */ var _tabs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93);
/* harmony import */ var _tabs_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(150);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_tabs_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"].locals || _tabs_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _tabs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _tabs_vue_vue_type_template_id_5eed886d___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _tabs_vue_vue_type_template_id_5eed886d___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/node_modules/@mds/tabs/src/tabs.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__131__;

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _pp_scenario_analysis_vue_vue_type_template_id_58d4bd34___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(153);
/* harmony import */ var _pp_scenario_analysis_js_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82);
/* harmony import */ var _pp_scenario_analysis_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(402);
/* harmony import */ var _pp_scenario_analysis_vue_vue_type_style_index_1_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(152);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);






var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_pp_scenario_analysis_vue_vue_type_style_index_1_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_3__["default"].locals || _pp_scenario_analysis_vue_vue_type_style_index_1_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_3__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(
  _pp_scenario_analysis_js_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _pp_scenario_analysis_vue_vue_type_template_id_58d4bd34___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _pp_scenario_analysis_vue_vue_type_template_id_58d4bd34___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/src/pp-scenario-analysis.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 133 */
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"@mds/icon\",\"version\":\"4.3.3\",\"license\":\"ISC\",\"author\":\"designsystem@morningstar.com\",\"contributors\":[{\"name\":\"James Harris\"},{\"name\":\"Jonathan Duncan\"},{\"name\":\"Pegah Ahmadi\"},{\"name\":\"Raina Shannon\"}],\"repository\":{\"type\":\"git\",\"url\":\"https://msstash.morningstar.com/scm/mds/library.git\"},\"description\":\"Icons enhance experiences by visually communicating meaning, actions, status, and feedback.\",\"main\":\"src/icon.vue\",\"types\":\"src/index.d.ts\",\"files\":[\"src/*.vue\",\"src/*.scss\",\"src/*.d.ts\",\"icons\",\"dist\"],\"dependencies\":{\"@mds/constants\":\"^3.3.0\",\"@mds/utils-scss\":\"^3.0.14\"},\"scripts\":{\"test\":\"start-server-and-test view http://localhost:6006 jest\",\"test:unit\":\"jest --testMatch '**/!(avr)+(.test).js'\",\"test:promote\":\"start-server-and-test view http://localhost:6006 promote\",\"promote\":\"jest -u\",\"view\":\"yarn build && start-storybook -p 6006\",\"view:docs\":\"cross-env NODE_ENV=development webpack-dev-server --open --hot --config '../../configs/docs.config.js'\",\"build\":\"node scripts/generate-json.js\",\"build:docs\":\"cross-env NODE_ENV=production webpack --progress --hide-modules --config '../../configs/docs.config.js'\",\"build:storybook\":\"build-storybook -o public\"},\"gitHead\":\"b8711eb5853184a6fb733ab5fab8fe73921e4df6\"}");

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 135 */
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"@mds/loader\",\"version\":\"3.3.5\",\"license\":\"ISC\",\"author\":\"designsystem@morningstar.com\",\"contributors\":[{\"name\":\"James Harris\"},{\"name\":\"Trevor Rice\"}],\"repository\":{\"type\":\"git\",\"url\":\"https://msstash.morningstar.com/scm/mds/library.git\"},\"description\":\"Loaders indicate that content will process for an indeterminate amount of time.\",\"main\":\"src/loader.vue\",\"types\":\"src/index.d.ts\",\"files\":[\"src/*.vue\",\"src/*.scss\",\"src/*.d.ts\"],\"dependencies\":{\"@mds/constants\":\"^3.3.0\"},\"scripts\":{\"test\":\"start-server-and-test view http://localhost:6006 jest\",\"test:unit\":\"jest --testMatch '**/!(avr)+(.test).js'\",\"test:promote\":\"start-server-and-test view http://localhost:6006 promote\",\"promote\":\"jest -u\",\"view\":\"start-storybook -p 6006\",\"view:docs\":\"cross-env NODE_ENV=development webpack-dev-server --open --hot --config '../../configs/docs.config.js'\",\"build:docs\":\"cross-env NODE_ENV=production webpack --progress --hide-modules --config '../../configs/docs.config.js'\",\"build:storybook\":\"build-storybook -o public\"},\"gitHead\":\"b8711eb5853184a6fb733ab5fab8fe73921e4df6\"}");

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_loader_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_loader_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_loader_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_loader_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_button_container_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_button_container_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_button_container_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_button_container_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 139 */
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"@mds/dialog\",\"version\":\"3.3.12\",\"license\":\"ISC\",\"author\":\"designsystem@morningstar.com\",\"contributors\":[{\"name\":\"James Harris\"}],\"repository\":{\"type\":\"git\",\"url\":\"https://msstash.morningstar.com/scm/mds/library.git\"},\"description\":\"Dialogs elicit a response or reveal critical information without losing the context of the underlying page.\",\"main\":\"src/dialog.vue\",\"types\":\"src/index.d.ts\",\"files\":[\"src/*.vue\",\"src/*.scss\",\"src/*.d.ts\"],\"dependencies\":{\"@mds/button\":\"^3.3.6\",\"@mds/constants\":\"^3.3.0\",\"@mds/fonts\":\"^3.1.1\",\"@mds/typography\":\"^3.1.9\",\"@mds/utils-js\":\"^5.0.1\",\"@mds/utils-scss\":\"^3.0.14\"},\"scripts\":{\"test\":\"start-server-and-test view http://localhost:6006 jest\",\"test:unit\":\"jest --testMatch '**/!(avr)+(.test).js'\",\"test:promote\":\"start-server-and-test view http://localhost:6006 promote\",\"promote\":\"jest -u\",\"view\":\"start-storybook -p 6006\",\"view:docs\":\"cross-env NODE_ENV=development webpack-dev-server --open --hot --config '../../configs/docs.config.js'\",\"build:docs\":\"cross-env NODE_ENV=production webpack --progress --hide-modules --config '../../configs/docs.config.js'\",\"build:storybook\":\"build-storybook -o public\"},\"gitHead\":\"b8711eb5853184a6fb733ab5fab8fe73921e4df6\"}");

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_dialog_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_dialog_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_dialog_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_dialog_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_layout_grid_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_layout_grid_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_layout_grid_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_layout_grid_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_row_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_row_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_row_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_row_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_col_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_col_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_col_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_col_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_list_group_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_list_group_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_list_group_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_list_group_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_list_group_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_list_group_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_list_group_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_list_group_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 146 */
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"@mds/section\",\"version\":\"5.1.13\",\"license\":\"ISC\",\"author\":\"designsystem@morningstar.com\",\"contributors\":[{\"name\":\"James Harris\"},{\"name\":\"Samina Pathan\"}],\"repository\":{\"type\":\"git\",\"url\":\"https://msstash.morningstar.com/scm/mds/library.git\"},\"description\":\"Sections combine a title, border, content area, and–when appropriate–actions to introduce a group of information and/or functionality. They also help establish clear visual hierarchy, adding structure to a composition.\",\"main\":\"src/section.vue\",\"types\":\"src/index.d.ts\",\"files\":[\"src/*.vue\",\"src/*.scss\",\"src/*.d.ts\"],\"dependencies\":{\"@mds/button\":\"^3.3.6\",\"@mds/constants\":\"^3.3.0\",\"@mds/fonts\":\"^3.1.1\",\"@mds/icon\":\"^4.3.3\",\"@mds/typography\":\"^3.1.9\",\"@mds/utils-scss\":\"^3.0.14\"},\"scripts\":{\"test\":\"start-server-and-test view http://localhost:6006 jest\",\"test:unit\":\"jest --testMatch '**/!(avr)+(.test).js'\",\"test:promote\":\"start-server-and-test view http://localhost:6006 promote\",\"promote\":\"jest -u\",\"view\":\"start-storybook -p 6006\",\"view:docs\":\"cross-env NODE_ENV=development webpack-dev-server --open --hot --config '../../configs/docs.config.js'\",\"build:docs\":\"cross-env NODE_ENV=production webpack --progress --hide-modules --config '../../configs/docs.config.js'\",\"build:storybook\":\"build-storybook -o public\"},\"gitHead\":\"b8711eb5853184a6fb733ab5fab8fe73921e4df6\"}");

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_section_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_section_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_section_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_section_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 149 */
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"@mds/tabs\",\"version\":\"3.4.7\",\"license\":\"ISC\",\"author\":\"designsystem@morningstar.com\",\"contributors\":[{\"name\":\"James Harris\"}],\"repository\":{\"type\":\"git\",\"url\":\"https://msstash.morningstar.com/scm/mds/library.git\"},\"description\":\"Tabs provide navigation between sets of content.\",\"main\":\"src/index.js\",\"types\":\"src/index.d.ts\",\"files\":[\"src/*.vue\",\"src/*.scss\",\"src/*.d.ts\"],\"dependencies\":{\"@mds/button\":\"^3.3.6\",\"@mds/constants\":\"^3.3.0\",\"@mds/routable\":\"^3.1.0\"},\"scripts\":{\"test\":\"start-server-and-test view http://localhost:6006 jest\",\"test:unit\":\"jest --testMatch '**/!(avr)+(.test).js'\",\"test:promote\":\"start-server-and-test view http://localhost:6006 promote\",\"promote\":\"jest -u\",\"view\":\"start-storybook -p 6006\",\"view:docs\":\"cross-env NODE_ENV=development webpack-dev-server --open --hot --config '../../configs/docs.config.js'\",\"build:docs\":\"cross-env NODE_ENV=production webpack --progress --hide-modules --config '../../configs/docs.config.js'\",\"build:storybook\":\"build-storybook -o public\"},\"gitHead\":\"b8711eb5853184a6fb733ab5fab8fe73921e4df6\"}");

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 151 */
/***/ (function(module) {

module.exports = JSON.parse("{\"scenarioSelected\":{\"action\":\"scenarioSelected\"},\"tabChanged\":{\"action\":\"tabChanged\"}}");

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_pp_scenario_analysis_vue_vue_type_style_index_1_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_pp_scenario_analysis_vue_vue_type_style_index_1_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_pp_scenario_analysis_vue_vue_type_style_index_1_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_0_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_0_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_0_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_pp_scenario_analysis_vue_vue_type_style_index_1_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/src/pp-scenario-analysis.vue?vue&type=template&id=58d4bd34&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style["mwc-pp-scenario-analysis"] },
    [
      _vm.loading ? _c("mds-loader", { attrs: { size: "medium" } }) : _vm._e(),
      _vm._v(" "),
      _c(
        "mds-layout-grid",
        [
          _c(
            "mds-row",
            [
              _c(
                "mds-col",
                {
                  class: _vm.$style["mwc-pp-scenario-analysis__left-section"],
                  attrs: { cols: 2 },
                },
                [
                  _c("mds-section", {
                    class: _vm.$style["mwc-pp-scenario-analysis__top-market"],
                    attrs: {
                      title: _vm.translate("topMarketScenarios"),
                      size: 9,
                      bold: "",
                      border: "none",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "mds-list-group",
                    { attrs: { variation: "selection" } },
                    _vm._l(_vm.scenarios, function (item, index) {
                      return _c("mds-list-group-item", {
                        key: item.id,
                        attrs: {
                          text: item.name,
                          active: item.active,
                          "separator-before": index === 0 ? true : false,
                        },
                        on: {
                          "mds-list-item-clicked": function ($event) {
                            return _vm.listItemClicked(item)
                          },
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "mds-col",
                {
                  class: _vm.$style["mwc-pp-scenario-analysis__right-section"],
                  attrs: { cols: 10 },
                },
                [
                  _c(
                    "mds-section",
                    {
                      class: _vm.$style["mwc-pp-scenario-analysis__what-if"],
                      attrs: {
                        title:
                          _vm.translate("whatIfHappenOne") +
                          " " +
                          (_vm.selectedScenario && _vm.selectedScenario.name
                            ? _vm.selectedScenario.name
                            : null) +
                          " " +
                          _vm.translate("whatIfHappenTwo"),
                        size: 4,
                        border: "none",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.getScenarioDescription()) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("mds-tabs", {
                    class: _vm.$style["mwc-pp-scenario-analysis__tabs"],
                    attrs: { content: _vm.tabsContent, size: "large" },
                    on: { "mds-tabs-item-active": _vm.setTabActiveItem },
                  }),
                  _vm._v(" "),
                  _c(
                    "section",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showTab("snapshot"),
                          expression: "showTab('snapshot')",
                        },
                      ],
                      class: _vm.$style["mwc-pp-scenario-analysis__cards"],
                    },
                    _vm._l(_vm.cardDataList, function (card, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          class:
                            _vm.$style["mwc-pp-scenario-analysis__cards-card"],
                        },
                        [
                          _c("mwc-pp-sa-card", {
                            attrs: {
                              "mwc-id": _vm.mwcId + ".card" + index,
                              id: _vm.mwcId + ".card" + index,
                              "is-error": card.isDataError || false,
                              "error-message": card.errorMessage,
                            },
                            domProps: { scenario: card },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showTab("chart"),
                          expression: "showTab('chart')",
                        },
                      ],
                    },
                    [
                      _c("div", {
                        class: _vm.$style["mwc-pp-scenario-analysis__chart"],
                        attrs: { id: _vm.chartContainerId },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("section", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showTab("table"),
                        expression: "showTab('table')",
                      },
                    ],
                    class: _vm.$style["mwc-pp-scenario-analysis__table"],
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("mwc-pp-sa-data", {
        attrs: {
          "mwc-id": _vm.mwcId + ".saData",
          "listen-on": "[mwc-id='" + _vm.mwcId + "']",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/src/pp-scenario-analysis.vue?vue&type=template&id=58d4bd34&


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/loader/src/loader.vue?vue&type=template&id=404454cd&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._b(
      {
        class: [_vm.$style["mds-loader"], _vm.classObject, _vm.sizeClass],
        attrs: {
          role: "progressbar",
          "aria-valuetext": _vm.ariaValuetext,
          "data-mds-version": _vm.version,
        },
      },
      "div",
      _vm.$attrs,
      false
    ),
    _vm._l(8, function (n) {
      return _c("div", {
        key: n,
        class: [
          _vm.$style["mds-loader__item"],
          _vm.$style["mds-loader__item--" + n],
        ],
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/loader/src/loader.vue?vue&type=template&id=404454cd&


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/dialog/src/dialog.vue?vue&type=template&id=b93ffca6&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "overlay",
          rawName: "v-overlay:[{value:isVisible,class:classes}]",
          value: _vm.hide,
          expression: "hide",
          arg: { value: _vm.isVisible, class: _vm.classes },
        },
      ],
      class: _vm.$style["mds-dialog-wrapper"],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _c("transition", { attrs: { name: "mds-dialog" } }, [
        _vm.isVisible
          ? _c(
              "div",
              {
                class: [_vm.$style["mds-dialog"], _vm.widthClass],
                attrs: { role: "dialog", "aria-hidden": !_vm.isVisible },
              },
              [
                _vm.title
                  ? _c("div", {
                      class: _vm.$style["mds-dialog__title"],
                      domProps: { innerHTML: _vm._s(_vm.title) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { class: _vm.$style["mds-dialog__message"] },
                  [
                    _vm._t("default", function () {
                      return [_vm._v(_vm._s(_vm.text))]
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("mds-dialog-supplemental-content"),
                _vm._v(" "),
                _c(
                  "div",
                  { class: _vm.$style["mds-dialog__actions"] },
                  [
                    _vm._t("mds-dialog-actions-left"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { class: _vm.$style["mds-dialog__actions-right"] },
                      [
                        _vm._t("mds-dialog-actions-right", function () {
                          return [
                            _c(
                              "mds-button",
                              {
                                attrs: { variation: "secondary" },
                                on: { click: _vm.hide },
                              },
                              [_vm._v("Dismiss")]
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ],
                  2
                ),
              ],
              2
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/dialog/src/dialog.vue?vue&type=template&id=b93ffca6&


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/section/src/section.vue?vue&type=template&id=43fd82fa&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      class: [_vm.$style["mds-section"], _vm.classObject],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _c(
        "div",
        {
          class: [
            _vm.$style["mds-section__header-container"],
            _vm.headerClasses,
            _vm.sizeClass,
          ],
          attrs: {
            tabindex: _vm.tabIndex,
            "aria-expanded": _vm.ariaExpanded,
            "aria-controls": _vm.collapsible ? _vm.expandedId : null,
            role: _vm.collapsible ? "button" : null,
          },
          on: {
            click: function ($event) {
              return _vm.toggle($event)
            },
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.toggle($event)
            },
          },
        },
        [
          _vm.collapsible
            ? _c("mds-icon", {
                class: _vm.$style["mds-section__toggle"],
                attrs: { name: "triangle-fill-right", size: _vm.iconSize },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            _vm.headingType,
            { tag: "component", class: _vm.$style["mds-section__title"] },
            [
              _vm._t("mds-section-title", function () {
                return [_vm._v(_vm._s(_vm.title))]
              }),
              _vm._v(" "),
              _vm.hasTitleDescription
                ? _c(
                    "div",
                    { class: _vm.$style["mds-section__title-description"] },
                    [_vm._t("mds-section-title-description")],
                    2
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          this.$slots["mds-section-supplemental-content"]
            ? _c(
                "div",
                { class: _vm.$style["mds-section__supplemental-content"] },
                [_vm._t("mds-section-supplemental-content")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          this.$slots["mds-section-actions"]
            ? _c(
                "div",
                {
                  class: _vm.$style["mds-section__actions"],
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [_vm._t("mds-section-actions")],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.collapsible || (_vm.open && _vm.collapsible),
              expression: "!collapsible || (open && collapsible)",
            },
          ],
          class: _vm.$style["mds-section__content"],
          attrs: { id: _vm.collapsible ? _vm.expandedId : null },
        },
        [
          _vm.content
            ? [_c("span", { domProps: { innerHTML: _vm._s(_vm.content) } })]
            : [_vm._t("default")],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/section/src/section.vue?vue&type=template&id=43fd82fa&


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/button/src/button.vue?vue&type=template&id=60e2ab6d&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.componentType,
    _vm._g(
      _vm._b(
        {
          tag: "component",
          class: [
            _vm.$style["mds-button"],
            _vm.classObject,
            _vm.variationClass,
            _vm.sizeClass,
          ],
          attrs: {
            "aria-label": _vm.iconAriaLabel,
            href: _vm.href,
            "data-mds-version": _vm.version,
          },
        },
        "component",
        _vm.routingProps,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.icon
        ? _c("mds-icon", {
            class: [
              _vm.$style["mds-button__icon"],
              _vm.$style["mds-button__icon--left"],
            ],
            attrs: { name: _vm.icon, size: _vm.iconSize },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.variation !== "icon-only"
        ? _c(
            "span",
            [
              _vm._t("default", function () {
                return [_vm._v(_vm._s(_vm.text))]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.iconRight
        ? _c("mds-icon", {
            class: [
              _vm.$style["mds-button__icon"],
              _vm.$style["mds-button__icon--right"],
            ],
            attrs: { name: _vm.iconRight, size: _vm.iconSize },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "mds-button__loader" } },
        [
          _vm.loading && _vm.variation === "primary"
            ? _c("mds-loader", {
                class: [_vm.$style["mds-button__loader"]],
                attrs: {
                  "aria-valuetext": _vm.loaderAriaValuetext,
                  "on-dark": "",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/button/src/button.vue?vue&type=template&id=60e2ab6d&


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/button/src/button-container.vue?vue&type=template&id=90b20bbe&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [_vm.$style["mds-button-container"], _vm.classObject],
      attrs: { "data-mds-version": _vm.version },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/button/src/button-container.vue?vue&type=template&id=90b20bbe&


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/layout-grid.vue?vue&type=template&id=f713976a&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [_vm.$style["mds-layout-grid"]],
      attrs: { "data-mds-version": _vm.version },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/layout-grid.vue?vue&type=template&id=f713976a&


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/row.vue?vue&type=template&id=e8b768c8&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [_vm.$style["mds-layout-grid__row"], _vm.classObject],
      attrs: { "data-mds-version": _vm.version },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/row.vue?vue&type=template&id=e8b768c8&


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/col.vue?vue&type=template&id=718bd042&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [_vm.$style["mds-layout-grid__col"], _vm.classObject],
      attrs: { "data-mds-version": _vm.version },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/col.vue?vue&type=template&id=718bd042&


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/list-group/src/list-group.vue?vue&type=template&id=ed73d6a6&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      class: [_vm.$style["mds-list-group"], _vm.classObject, _vm.sizeClass],
      attrs: { "data-mds-version": _vm.version },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/list-group/src/list-group.vue?vue&type=template&id=ed73d6a6&


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/list-group/src/list-group-item.vue?vue&type=template&id=ddccdb3a&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      class: [_vm.$style["mds-list-group__item"], _vm.classObject],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _vm.sublist
        ? [
            _c("input", {
              class: [_vm.$style["mds-list-group__toggle-input"]],
              attrs: {
                type: "checkbox",
                id: "mds-list-group__toggle-input-" + _vm.toggleId,
              },
              domProps: { checked: _vm.toggleActive },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                class: _vm.$style["mds-list-group__toggle"],
                attrs: { for: "mds-list-group__toggle-input-" + _vm.toggleId },
              },
              [
                _vm.iconLeft
                  ? _c("mds-icon", {
                      class: [_vm.$style["mds-list-group__left-icon"]],
                      attrs: { name: _vm.iconLeft, size: _vm.iconSize },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("mds-icon", {
                  class: [
                    _vm.$style[("mds-icon", "mds-list-group__toggle-icon")],
                  ],
                  attrs: {
                    name: "triangle-fill-down",
                    title: "triangle-fill-down",
                    size: "small",
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  { class: _vm.$style["mds-list-group__toggle-text"] },
                  [
                    _vm._v(
                      "\n                " + _vm._s(_vm.text) + "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._t("mds-list-item-right"),
              ],
              2
            ),
            _vm._v(" "),
            _vm._t("default"),
          ]
        : [
            _c(
              _vm.dynamicComponent,
              {
                tag: "component",
                class: [_vm.$style["mds-list-group__link"], _vm.imageClass],
                attrs: {
                  href: _vm.href,
                  "aria-disabled": _vm.disabled,
                  tabindex: _vm.spanIndex,
                },
              },
              [
                _vm.iconLeft
                  ? _c("mds-icon", {
                      class: [_vm.$style["mds-list-group__left-icon"]],
                      attrs: { name: _vm.iconLeft, size: _vm.iconSize },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.image
                  ? _c("img", {
                      class: [
                        _vm.$style["mds-list-group__item-image"],
                        _vm.imageRoundClass,
                      ],
                      attrs: { src: _vm.image, "aria-hidden": "true", alt: "" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  { class: [_vm.$style["mds-list-group__item-text"]] },
                  [
                    _vm._t("default", function () {
                      return [_vm._v(_vm._s(_vm.text))]
                    }),
                    _vm._v(" "),
                    _vm.metadata
                      ? _c("span", {
                          class: _vm.$style["mds-list-group__item-metadata"],
                          domProps: { innerHTML: _vm._s(_vm.metadata) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._t("mds-list-item-microcopy", function () {
                      return [
                        _vm.microcopy
                          ? _c("span", {
                              class:
                                _vm.$style["mds-list-group__item-microcopy"],
                              domProps: { innerHTML: _vm._s(_vm.microcopy) },
                            })
                          : _vm._e(),
                      ]
                    }),
                    _vm._v(" "),
                    _vm.metadataBelow && _vm.metadataBelow.length
                      ? _c(
                          "span",
                          {
                            class:
                              _vm.$style["mds-list-group__item-metadata-below"],
                          },
                          _vm._l(_vm.metadataBelow, function (item, index) {
                            return _c("span", {
                              key: "metabelow-" + index,
                              class:
                                _vm.$style[
                                  "mds-list-group__item-metadata-below-item"
                                ],
                              domProps: { innerHTML: _vm._s(item) },
                            })
                          }),
                          0
                        )
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._t("mds-list-item-right"),
                _vm._v(" "),
                _vm.parentVariation.variationObj === "navigation" && _vm.active
                  ? _c("div", {
                      class: _vm.$style["mds-list-group__active-indicator"],
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.parentVariation.variationObj === "selection" && _vm.active
                  ? _c("mds-icon", {
                      class: _vm.$style["mds-list-group__active-icon"],
                      attrs: { name: "check", size: _vm.iconSize },
                    })
                  : _vm._e(),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/list-group/src/list-group-item.vue?vue&type=template&id=ddccdb3a&


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/tabs/src/tabs.vue?vue&type=template&id=5eed886d&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      class: [
        _vm.$style["mds-tabs"],
        _vm.classObject,
        _vm.responsiveObject,
        _vm.variationClass,
        _vm.sizeClass,
      ],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _c(
        "ul",
        {
          ref: "container",
          class: _vm.$style["mds-tabs__inner"],
          attrs: { role: "tablist" },
        },
        [
          _vm._t("default", function () {
            return _vm._l(_vm.content, function (item, index) {
              return _c(
                "mds-tabs-item",
                _vm._b(
                  {
                    key: index,
                    attrs: { onDark: _vm.onDark, size: _vm.size },
                    on: {
                      "mds-tabs-item-active": function ($event) {
                        return _vm.$emit("mds-tabs-item-active", $event)
                      },
                    },
                  },
                  "mds-tabs-item",
                  item,
                  false
                )
              )
            })
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/tabs/src/tabs.vue?vue&type=template&id=5eed886d&


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/tabs/src/tabs-item.vue?vue&type=template&id=9e7712ba&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isRoutable
    ? _c(
        _vm.linkTag,
        _vm._b(
          {
            tag: "component",
            attrs: { custom: "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var href = ref.href
                    var route = ref.route
                    var navigate = ref.navigate
                    var isActive = ref.isActive
                    var isExactActive = ref.isExactActive
                    return [
                      _c(
                        "li",
                        {
                          class: [
                            _vm.$style["mds-tabs__item"],
                            _vm.classObject,
                            _vm.activeClass(isActive, isExactActive),
                          ],
                          attrs: { role: "tab" },
                          on: { click: _vm.makeActive },
                        },
                        [
                          _c(
                            "mds-button",
                            {
                              attrs: {
                                href: href,
                                onDark: _vm.onDark,
                                icon: _vm.icon,
                                iconRight: _vm.iconRight,
                                size: _vm.size,
                                text: _vm.text,
                                variation: "flat",
                                type: _vm.typeAttribute,
                                target: _vm.target,
                              },
                              on: { click: navigate },
                            },
                            [
                              _vm._t("default", function () {
                                return [_vm._v(_vm._s(_vm.text))]
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          },
          "component",
          _vm.routingProps,
          false
        )
      )
    : _c(
        "li",
        {
          class: [_vm.$style["mds-tabs__item"], _vm.classObject],
          attrs: { role: "tab" },
          on: { click: _vm.makeActive },
        },
        [
          _c(
            "mds-button",
            {
              attrs: {
                href: _vm.href,
                onDark: _vm.onDark,
                icon: _vm.icon,
                iconRight: _vm.iconRight,
                size: _vm.size,
                text: _vm.text,
                variation: "flat",
                type: _vm.typeAttribute,
                target: _vm.target,
              },
            },
            [
              _vm._t("default", function () {
                return [_vm._v(_vm._s(_vm.text))]
              }),
            ],
            2
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/tabs/src/tabs-item.vue?vue&type=template&id=9e7712ba&


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ render; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ staticRenderFns; });

// CONCATENATED MODULE: ./node_modules/mwc-cli/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/mwc-cli/node_modules/vue-loader/lib??vue-loader-options!./packages/pp-scenario-analysis/node_modules/@mds/icon/src/icon.vue?vue&type=template&id=4ac77a66&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", {
    class: [_vm.$style["mds-icon"], _vm.sizeClass],
    attrs: {
      "aria-hidden": "true",
      "data-mds-version": _vm.version,
      "data-mds-icon-name": _vm.name,
    },
    domProps: { innerHTML: _vm._s(_vm.svgIcon) },
  })
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/pp-scenario-analysis/node_modules/@mds/icon/src/icon.vue?vue&type=template&id=4ac77a66&


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(13);
var fails = __webpack_require__(2);
var createElement = __webpack_require__(168);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var isObject = __webpack_require__(9);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 169 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var setGlobal = __webpack_require__(102);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__(104);

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol() == 'symbol';


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(170);

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(100);
var classofRaw = __webpack_require__(27);
var wellKnownSymbol = __webpack_require__(1);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(176);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(8);
var ownKeys = __webpack_require__(252);
var getOwnPropertyDescriptorModule = __webpack_require__(49);
var definePropertyModule = __webpack_require__(14);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);

module.exports = global;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(8);
var toIndexedObject = __webpack_require__(22);
var indexOf = __webpack_require__(180).indexOf;
var hiddenKeys = __webpack_require__(47);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(22);
var toLength = __webpack_require__(20);
var toAbsoluteIndex = __webpack_require__(109);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(2);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(1);

exports.f = wellKnownSymbol;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(178);
var has = __webpack_require__(8);
var wrappedWellKnownSymbolModule = __webpack_require__(182);
var defineProperty = __webpack_require__(14).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(22);
var addToUnscopables = __webpack_require__(185);
var Iterators = __webpack_require__(39);
var InternalStateModule = __webpack_require__(45);
var defineIterator = __webpack_require__(186);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(1);
var create = __webpack_require__(52);
var createNonEnumerableProperty = __webpack_require__(11);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  createNonEnumerableProperty(ArrayPrototype, UNSCOPABLES, create(null));
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var createIteratorConstructor = __webpack_require__(258);
var getPrototypeOf = __webpack_require__(188);
var setPrototypeOf = __webpack_require__(189);
var setToStringTag = __webpack_require__(112);
var createNonEnumerableProperty = __webpack_require__(11);
var redefine = __webpack_require__(26);
var wellKnownSymbol = __webpack_require__(1);
var IS_PURE = __webpack_require__(44);
var Iterators = __webpack_require__(39);
var IteratorsCore = __webpack_require__(187);

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__(188);
var createNonEnumerableProperty = __webpack_require__(11);
var has = __webpack_require__(8);
var wellKnownSymbol = __webpack_require__(1);
var IS_PURE = __webpack_require__(44);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(8);
var toObject = __webpack_require__(16);
var sharedKey = __webpack_require__(46);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(259);

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var aPossiblePrototype = __webpack_require__(260);

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(38);
var requireObjectCoercible = __webpack_require__(19);

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var userAgent = __webpack_require__(270);

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(40),
    isObject = __webpack_require__(21);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(169)))

/***/ }),
/* 194 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(303),
    isObjectLike = __webpack_require__(24);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(304),
    arraySome = __webpack_require__(307),
    cacheHas = __webpack_require__(308);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(199),
    getSymbols = __webpack_require__(118),
    keys = __webpack_require__(28);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(200),
    isArray = __webpack_require__(12);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 200 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(314),
    isArguments = __webpack_require__(203),
    isArray = __webpack_require__(12),
    isBuffer = __webpack_require__(119),
    isIndex = __webpack_require__(121),
    isTypedArray = __webpack_require__(204);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(315),
    isObjectLike = __webpack_require__(24);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(317),
    baseUnary = __webpack_require__(123),
    nodeUtil = __webpack_require__(124);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 205 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(209),
    toKey = __webpack_require__(64);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(12),
    isKey = __webpack_require__(126),
    stringToPath = __webpack_require__(327),
    toString = __webpack_require__(330);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 210 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(213),
    eq = __webpack_require__(59);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(214);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(23);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(200),
    getPrototype = __webpack_require__(216),
    getSymbols = __webpack_require__(118),
    stubArray = __webpack_require__(201);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(205);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(368),
    createBaseEach = __webpack_require__(371);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(19);
var whitespaces = __webpack_require__(219);

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),
/* 219 */
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _button_vue_vue_type_template_id_60e2ab6d___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(157);
/* harmony import */ var _button_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86);
/* harmony import */ var _button_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(137);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_button_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"].locals || _button_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _button_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _button_vue_vue_type_template_id_60e2ab6d___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _button_vue_vue_type_template_id_60e2ab6d___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/node_modules/@mds/button/src/button.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createNonEnumerableProperty = __webpack_require__(11);
var redefine = __webpack_require__(26);
var fails = __webpack_require__(2);
var wellKnownSymbol = __webpack_require__(1);
var regexpExec = __webpack_require__(56);

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
    if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
  }
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(190).charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(27);
var regexpExec = __webpack_require__(56);

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _button_container_vue_vue_type_template_id_90b20bbe___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(158);
/* harmony import */ var _button_container_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87);
/* harmony import */ var _button_container_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(138);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_button_container_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"].locals || _button_container_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _button_container_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _button_container_vue_vue_type_template_id_90b20bbe___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _button_container_vue_vue_type_template_id_90b20bbe___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/node_modules/@mds/button/src/button-container.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
var classof = __webpack_require__(27);
var wellKnownSymbol = __webpack_require__(1);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var $map = __webpack_require__(105).map;
var fails = __webpack_require__(2);
var arrayMethodHasSpeciesSupport = __webpack_require__(55);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = HAS_SPECIES_SUPPORT && !fails(function () {
  [].map.call({ length: -1, 0: 1 }, function (it) { throw it; });
});

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var toObject = __webpack_require__(16);
var nativeKeys = __webpack_require__(53);
var fails = __webpack_require__(2);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _layout_grid_vue_vue_type_template_id_f713976a___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(159);
/* harmony import */ var _layout_grid_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88);
/* harmony import */ var _layout_grid_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(141);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_layout_grid_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"].locals || _layout_grid_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _layout_grid_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _layout_grid_vue_vue_type_template_id_f713976a___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _layout_grid_vue_vue_type_template_id_f713976a___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/layout-grid.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _row_vue_vue_type_template_id_e8b768c8___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(160);
/* harmony import */ var _row_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89);
/* harmony import */ var _row_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(142);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_row_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"].locals || _row_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _row_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _row_vue_vue_type_template_id_e8b768c8___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _row_vue_vue_type_template_id_e8b768c8___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/row.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _col_vue_vue_type_template_id_718bd042___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var _col_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90);
/* harmony import */ var _col_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(143);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_col_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"].locals || _col_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _col_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _col_vue_vue_type_template_id_718bd042___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _col_vue_vue_type_template_id_718bd042___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/node_modules/@mds/layout-grid/src/col.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _list_group_vue_vue_type_template_id_ed73d6a6___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(162);
/* harmony import */ var _list_group_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91);
/* harmony import */ var _list_group_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(144);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_list_group_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"].locals || _list_group_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _list_group_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _list_group_vue_vue_type_template_id_ed73d6a6___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _list_group_vue_vue_type_template_id_ed73d6a6___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/node_modules/@mds/list-group/src/list-group.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _list_group_item_vue_vue_type_template_id_ddccdb3a___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(163);
/* harmony import */ var _list_group_item_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92);
/* harmony import */ var _list_group_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(145);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_list_group_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"].locals || _list_group_item_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _list_group_item_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _list_group_item_vue_vue_type_template_id_ddccdb3a___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _list_group_item_vue_vue_type_template_id_ddccdb3a___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/node_modules/@mds/list-group/src/list-group-item.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__234__;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(210),
    baseIteratee = __webpack_require__(114),
    baseMap = __webpack_require__(373),
    isArray = __webpack_require__(12);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 236 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 237 */
/***/ (function(module) {

module.exports = JSON.parse("{\"alert-fill\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" d=\\\"M11.5 12.5h-8\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M3.5 10.5h8l-4-7-4 7z\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" d=\\\"M5.5 2.5l-4 7m12 0l-4-7\\\"/></svg>\\n\",\"alert\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" d=\\\"M11.5 12.5h-8m0-2h8l-4-7-4 7zm2-8l-4 7m12 0l-4-7\\\"/></svg>\\n\",\"angle-double-down\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M13.973 2.554L7.374 8.152.776 2.555\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M13.973 7.554l-6.599 5.598L.776 7.555\\\"/></svg>\\n\",\"angle-double-left\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M12.403 1.889L7.596 7.438 12.404 13M7.403 2L2.596 7.55l4.807 5.561\\\"/></svg>\\n\",\"angle-double-right\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M2.597 1.889l4.807 5.549L2.596 13M7.597 2l4.807 5.55-4.807 5.561\\\"/></svg>\\n\",\"angle-double-up\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M.774 13.152l6.599-5.598 6.598 5.597\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M.774 8.152l6.599-5.598 6.598 5.597\\\"/></svg>\\n\",\"angle-down\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.265 4.518L7.489 10l6.246-5.492\\\"/></svg>\\n\",\"angle-left\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M9.903 1.889L5.096 7.438 9.904 13\\\"/></svg>\\n\",\"angle-right\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M5.097 1.889l4.807 5.549L5.096 13\\\"/></svg>\\n\",\"angle-up\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.27 10.578l6.224-5.482 6.246 5.492\\\"/></svg>\\n\",\"bell\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M9 11.75a1.5 1.5 0 01-3 0\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M11 5a3.5 3.5 0 00-7 0v2.5c0 1.105-.895 3-2 3h11c-1.105 0-2-1.895-2-3z\\\" fill=\\\"none\\\" stroke-linejoin=\\\"bevel\\\"/></svg>\\n\",\"bookmark-fill\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path d=\\\"M5.5 1a2.614 2.614 0 00-2.521 2.7v10.275l4.647-3.153L12.1 14V1z\\\" stroke=\\\"none\\\"/></svg>\\n\",\"bookmark\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M11.6 1.5H5.5a2.112 2.112 0 00-2.021 2.2v9.334l4.154-2.817 3.967 2.814z\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"bullhorn\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 9.5l12 4V1.45L1.5 5.5v4z\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M8.5 11.5a2 2 0 01-2 2h-2v-3\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"caret-circle-down\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M4.5 5l3 5 3-5\\\"/><circle cx=\\\"7.5\\\" cy=\\\"7.5\\\" r=\\\"6.5\\\" fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"caret-circle-left\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M10 4.5l-5 3 5 3\\\"/><circle cx=\\\"7.5\\\" cy=\\\"7.5\\\" r=\\\"6.5\\\" fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"caret-circle-right\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M5 10.5l5-3-5-3\\\"/><circle cx=\\\"7.5\\\" cy=\\\"7.5\\\" r=\\\"6.5\\\" fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"caret-circle-up\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M10.5 10l-3-5-3 5\\\"/><circle cx=\\\"7.5\\\" cy=\\\"7.5\\\" r=\\\"6.5\\\" fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"caret-down\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M11 4.5l-3.5 6-3.5-6\\\"/></svg>\\n\",\"caret-left\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M10.5 11l-6-3.5 6-3.5\\\"/></svg>\\n\",\"caret-right\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M4.5 4l6 3.5-6 3.5\\\"/></svg>\\n\",\"caret-up\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M4 10.5l3.5-6 3.5 6\\\"/></svg>\\n\",\"chat-bubble\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M4 11.5H2.5a1 1 0 01-1-1v-8a1 1 0 011-1h10a1 1 0 011 1v8a1 1 0 01-1 1H8l-3.5 2M4 5h7M4 8h4.667\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"check\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M13 2L6 12 2 8\\\"/></svg>\\n\",\"clock-back\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M4.5 12.5c-1.1-1.088-3-2-3-5a6 6 0 116 6\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-linecap=\\\"square\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M7.5 4.5v3h2\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1 12.5h3.5V9\\\"/></svg>\\n\",\"clock\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><circle vector-effect=\\\"non-scaling-stroke\\\" cx=\\\"7.5\\\" cy=\\\"7.5\\\" r=\\\"6\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-linecap=\\\"square\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M7.5 4.5v3h2\\\"/></svg>\\n\",\"collapse\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 8.5h5v5l-5-5zm7-7l5 5h-5v-5z\\\"/></svg>\\n\",\"create\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M10.5 1.5l-3 3-2 5 5-2 3.115-3.115M7.5 4.5l3 3\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M12.5 9v4.5h-10v-12H7\\\"/></svg>\\n\",\"cursor\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M13.263 11.926L8.734 7.397l2.603-2.578L1.5 1.5l3.179 9.912 2.473-2.449 4.537 4.537 1.574-1.574z\\\"/></svg>\\n\",\"document\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M12.5 5.5v8h-10v-12h6l4 4z\\\"/><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M12.5 5.5h-4v-4M4 7.5h7M4 5.5h2M4 9.5h7\\\"/></svg>\\n\",\"download\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1 13.5h12.838M7.5 11V1m4.054 5.5L7.5 11.473 3.446 6.5\\\"/></svg>\\n\",\"ellipsis-circle\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M10 7h1v1h-1zM7 7h1v1H7zM4 7h1v1H4z\\\"/><circle vector-effect=\\\"non-scaling-stroke\\\" cx=\\\"7.5\\\" cy=\\\"7.5\\\" r=\\\"7\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"envelope\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M13.5 3.5L7.51 7.533 1.5 3.5\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 3.5h12v8h-12z\\\"/></svg>\\n\",\"exclaim-circle-fill\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M7.5.5a7 7 0 107 7 7 7 0 00-7-7zM8.25 12h-1.5v-1.5h1.5zm0-3h-1.5V3h1.5z\\\"/></svg>\\n\",\"exclaim\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path d=\\\"M8.25 12h-1.5v-1.5h1.5zm0-3h-1.5V3h1.5z\\\" stroke=\\\"none\\\"/></svg>\\n\",\"expand\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M7.5 12.5h-5v-5l5 5zM12.5 7.5l-5-5h5v5z\\\"/></svg>\\n\",\"eye-crossed\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M6.147 8.079A1.5 1.5 0 017.5 5.931m1.229.645A1.5 1.5 0 017.5 8.931a1.537 1.537 0 01-.3-.031\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M10.289 4.21c.183.1.357.2.524.314s.319.22.467.336.289.236.422.356A8.707 8.707 0 0113.5 7.5s-2 4-6 4a5.773 5.773 0 01-1.824-.293M4.454 10.644A8.553 8.553 0 011.5 7.5s2-4 6-4a5.762 5.762 0 011.568.215M2.782 12.895l7.511-11.318\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"eye\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M7.5 8.931A1.5 1.5 0 119 7.437a1.5 1.5 0 01-1.5 1.494z\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M1.5 7.5s2-4 6-4 6 4 6 4-2 4-6 4-6-4-6-4z\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"file-cabinet\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM1.5 7.5h12M5 3.5h5M5 9.5h5\\\"/></svg>\\n\",\"folder-close\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M13.5 3.5h-7l-1-1h-4v10h12v-9zM13.5 5.5h-12\\\"/></svg>\\n\",\"funnel-fill\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M8.5 7.5v4l-2 1v-5L2 3.531h11L8.5 7.5z\\\"/></svg>\\n\",\"funnel\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M8.5 7.5v4l-2 1v-5L2 3.531h11L8.5 7.5z\\\"/></svg>\\n\",\"gear\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M12.214 7.5a4.753 4.753 0 00-.147-1.152l1.272-.735-1.286-2.226-1.27.733a4.72 4.72 0 00-2-1.152V1.5H6.214v1.468a4.72 4.72 0 00-2 1.152l-1.27-.733-1.283 2.226 1.272.735a4.587 4.587 0 000 2.3l-1.272.735 1.286 2.226 1.27-.733a4.72 4.72 0 002 1.152V13.5h2.569v-1.468a4.72 4.72 0 002-1.152l1.27.733 1.286-2.226-1.272-.735a4.753 4.753 0 00.144-1.152z\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/><circle vector-effect=\\\"non-scaling-stroke\\\" cx=\\\"7.5\\\" cy=\\\"7.5\\\" r=\\\"2\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"grab-handle\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M5 3h1V2H5zm0 3h1V5H5zm0 3h1V8H5zm0 3h1v-1H5zm4-3h1V8H9zm0 3h1v-1H9zM9 2v1h1V2zm0 4h1V5H9z\\\"/></svg>\\n\",\"group-column\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 6V1.5h12V6m-9-3v11m6-11v11m-3-11v11\\\"/></svg>\\n\",\"group-row\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M6 13.5H1.5v-12H6m-3 9h11m-11-6h11m-11 3h11\\\"/></svg>\\n\",\"group\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M5.5 5.5h8v8h-8z\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-linecap=\\\"square\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M3.5 11.5v-8h8\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-linecap=\\\"square\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 9.5v-8h8\\\"/></svg>\\n\",\"heart\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M7.469 12.6L2.526 7.458a3.151 3.151 0 01-.915-2.264 3.14 3.14 0 01.915-2.26A3.207 3.207 0 014.8 2a2.5 2.5 0 011.94.934l.732.729.728-.729A2.555 2.555 0 0110.176 2a3.2 3.2 0 012.271.934 3.184 3.184 0 010 4.524z\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"home\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M13.5 13.5h-6v-4h-3v4h-3v-8l6-4 6 4v8z\\\"/></svg>\\n\",\"import\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M7 2.5H1.5v11h11V8m-7 1.5l8-8\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M10 9.5H5.5V5\\\"/></svg>\\n\",\"info-circle\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><circle cx=\\\"7.5\\\" cy=\\\"7.5\\\" r=\\\"6.5\\\" fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\"/><path stroke=\\\"none\\\" d=\\\"M6.75 3.75H8V5H6.75zM9.125 11V9.875h-1V6h-2.25v1.125h1v2.75h-1V11h3.25z\\\"/></svg>\\n\",\"ip-low-carbon\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M13.5 1h-6a6 6 0 00-5.9 6A5.929 5.929 0 003 10.8 4.413 4.413 0 001.5 14h2.2a2.367 2.367 0 01.3-2.2A6.4 6.4 0 007.7 13a6.118 6.118 0 005.8-6zM7 10.4h-.9L3.4 6.7 4 6l2.5 2.5 5.1-5.8.5.4z\\\" fill-rule=\\\"evenodd\\\"/></svg>\\n\",\"ip-performance-arrow-down\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M7.589 11.831l-4.38-3.963 1.069-1.12L6.9 9.143l-.073-.417V2.771h1.53v5.954l-.057.418 2.607-2.4 1.083 1.125z\\\"/></svg>\\n\",\"ip-performance-arrow-up\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M7.516 2.785L11.9 6.748l-1.062 1.12L8.2 5.466l.081.425v5.955H6.754V5.891l.059-.425-2.607 2.4-1.085-1.118z\\\"/></svg>\\n\",\"ip-pillar-negative\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M7.436 2.123a5.445 5.445 0 014.7 2.7 5.414 5.414 0 01.007 5.451 5.435 5.435 0 01-1.992 1.991 5.415 5.415 0 01-5.451-.004A5.456 5.456 0 012 7.558a5.363 5.363 0 01.727-2.718 5.309 5.309 0 011.991-1.991 5.366 5.366 0 012.718-.726zm3.719 4.539H3.664V8.39h7.491z\\\"/></svg>\\n\",\"ip-pillar-neutral\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M12.138 4.825a5.445 5.445 0 00-7.42-1.976 5.31 5.31 0 00-1.991 1.992 5.437 5.437 0 00-.006 5.42 5.368 5.368 0 001.982 2 5.415 5.415 0 005.451.006 5.436 5.436 0 001.992-1.991 5.414 5.414 0 00-.007-5.451zM8.79 8.341a1.56 1.56 0 01-.572.571 1.554 1.554 0 01-1.565 0 1.562 1.562 0 01-.567-2.13 1.523 1.523 0 01.571-.572 1.563 1.563 0 012.13.567 1.554 1.554 0 010 1.565z\\\"/></svg>\\n\",\"ip-pillar-positive\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M7.436 2.123a5.445 5.445 0 014.7 2.7 5.414 5.414 0 01.007 5.451 5.435 5.435 0 01-1.992 1.991 5.415 5.415 0 01-5.451-.004A5.456 5.456 0 012 7.558a5.363 5.363 0 01.727-2.718 5.309 5.309 0 011.991-1.991 5.366 5.366 0 012.718-.726zm3.719 4.539H8.274V3.781H6.545v2.881H3.664V8.39h2.881v2.881h1.729V8.39h2.881z\\\"/></svg>\\n\",\"ip-quartile-empty\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM1.5 4.5h12M1.5 10.46h12M1.5 7.5h12\\\"/></svg>\\n\",\"ip-quartile-first\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM1.5 4.5h12M1.5 10.46h12M1.5 7.5h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M1.5 1.5h12v3h-12z\\\"/></svg>\\n\",\"ip-quartile-fourth\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM1.5 4.5h12M1.5 10.46h12M1.5 7.5h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M1.5 10.5h12v3h-12z\\\"/></svg>\\n\",\"ip-quartile-second\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM1.5 4.5h12M1.5 10.46h12M1.5 7.5h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M1.5 4.5h12v3h-12z\\\"/></svg>\\n\",\"ip-quartile-third\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM1.5 4.5h12M1.5 10.46h12M1.5 7.5h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M1.5 7.5h12v3h-12z\\\"/></svg>\\n\",\"ip-sector-basic-materials\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M14 14H1V1h13zm-8.862-3L4.89 9.364a.362.362 0 00-.1-.259A.321.321 0 004.548 9H2.576a.321.321 0 00-.243.1.361.361 0 00-.1.259L1.987 11zm1.949-3l-.249-1.652a.351.351 0 00-.094-.248.3.3 0 00-.232-.1H4.523a.328.328 0 00-.241.1.337.337 0 00-.1.246L3.931 8zm1.962-3L8.8 3.359a.354.354 0 00-.1-.251A.318.318 0 008.463 3h-2a.3.3 0 00-.232.107.372.372 0 00-.094.251L5.893 5zm0 6L8.8 9.364a.356.356 0 00-.1-.259A.321.321 0 008.46 9H6.471a.3.3 0 00-.231.1.373.373 0 00-.094.259L5.9 11zM11 8l-.25-1.652a.346.346 0 00-.1-.246.31.31 0 00-.234-.1H8.428a.318.318 0 00-.241.1.346.346 0 00-.1.246L7.837 8zm1.944 3l-.248-1.636a.361.361 0 00-.1-.259.321.321 0 00-.243-.1h-1.971a.321.321 0 00-.243.1.362.362 0 00-.1.259L9.792 11z\\\"/></svg>\\n\",\"ip-sector-bond-corporate\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M14 1v13H1V1zm-2.078 7.2l.955-.723-.955-.7.687-.969-1.117-.364.346-1.13-1.176-.024-.024-1.171-1.129.341-.364-1.109-.967.681-.723-.95-.692.95-.963-.681-.37 1.112-1.14-.341-.012 1.171-1.178.024.346 1.13-1.116.364.686.969-.955.7.955.723-.686.963 1.116.37-.346 1.123 1.176.024.014 1.177 1.135-.34.37 1.111.968-.687.692.956.723-.956.967.687.364-1.111 1.129.34.024-1.177 1.176-.024-.346-1.124 1.117-.37zM9.766 6.122a1.933 1.933 0 01.3.694l.854.149v1.04l-.842.173a2.213 2.213 0 01-.311.67l.514.723-.741.723-.71-.478a2.479 2.479 0 01-.663.281l-.155.855H6.966L6.8 10.1a2.5 2.5 0 01-.71-.317l-.711.514-.71-.723.477-.735a2.315 2.315 0 01-.268-.658l-.854-.173V6.965l.83-.149a3.188 3.188 0 01.292-.658l-.477-.735.71-.735.711.5A2.534 2.534 0 016.8 4.9l.168-.861h1.043l.155.861a2.278 2.278 0 01.663.293l.71-.5.741.735zM7.467 8.9a1.342 1.342 0 00.991-.41 1.372 1.372 0 00.406-1.007 1.378 1.378 0 00-1.4-1.387 1.358 1.358 0 00-.994.407 1.331 1.331 0 00-.409.98 1.365 1.365 0 00.412 1 1.351 1.351 0 00.994.417z\\\"/></svg>\\n\",\"ip-sector-bond-government\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M1 1h13v13H1zm10.154 2.242H3.786v3.069h7.368zM5.105 7H3.81v1.089A3.508 3.508 0 004.162 9.6a3.042 3.042 0 00.943 1.181zM6.96 5.032l-.853-.642h1.05l.328-1 .322 1h1.062l-.853.642.328 1.011-.859-.618-.853.618zM8.308 7H6.656v4.9l.829.612.823-.6zm2.846 0H9.848v3.788A3.03 3.03 0 0010.8 9.6a3.486 3.486 0 00.358-1.513z\\\"/></svg>\\n\",\"ip-sector-bond-municipal\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M14 1v13H1V1zM2.611 4.645v2.361h4.647V4.634h.621L4.973 2.207 2 4.645zm3.961 4.7a1.707 1.707 0 00-1.7-1.713 1.672 1.672 0 00-1.217.5 1.641 1.641 0 00-.507 1.214 1.565 1.565 0 00.31.951 6.245 6.245 0 01.579.99 1.936 1.936 0 01.113.693h-.072v.339l.49.636h.584l.5-.636v-.339h-.07a1.971 1.971 0 01.14-.752 5.251 5.251 0 01.558-.928 1.7 1.7 0 00.292-.956zm6.528 2.52v-.815a.859.859 0 00-.128-.469.706.706 0 00-.337-.286 1.783 1.783 0 00-.307-.847 1.977 1.977 0 00-.708-.648 2.042 2.042 0 00-.991-.237 2.1 2.1 0 00-.913.193 1.723 1.723 0 00-.668.559 2.617 2.617 0 00-.388.794 1.7 1.7 0 00-1.142.553 1.779 1.779 0 00-.4 1.2h.442a.8.8 0 00.262.476.738.738 0 00.483.16.689.689 0 00.391-.1.735.735 0 00.245-.258.585.585 0 00.086-.274h2.041a.75.75 0 00.757.672.732.732 0 00.418-.113.924.924 0 00.271-.279.562.562 0 00.105-.28zm-4.462-6.2A1.662 1.662 0 009.13 6.87a1.625 1.625 0 001.208.5 1.707 1.707 0 001.706-1.707 1.584 1.584 0 00-.3-.951 18.226 18.226 0 01-1.134-1.746 1.811 1.811 0 01-.244-.74h-.036a4.369 4.369 0 01-.949 1.844l-.447.642a1.7 1.7 0 00-.297.956z\\\"/></svg>\\n\",\"ip-sector-bond-other\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M14 1v13H1V1zm-2.458 11.489v-6.88L8.416 2.475H3.565v10.014zm-.937-5.935v4.984H4.52V3.414h2.941v.661H5.218v6.8h4.689V6.554zM7.461 5.02v1.534h1.492v3.39H6.167V5.02zm2.762.589H8.416v-1.79z\\\"/></svg>\\n\",\"ip-sector-communication-services\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" stroke=\\\"none\\\" d=\\\"M6.526 9.2a.308.308 0 00-.229.1.328.328 0 00-.1.237.3.3 0 00.1.223.312.312 0 00.229.1.32.32 0 00.235-.1.307.307 0 00.1-.223.331.331 0 00-.1-.237.315.315 0 00-.235-.1zm.974-.974a.331.331 0 10.235.1.317.317 0 00-.235-.1zm0 1.942a.329.329 0 00-.234.091.3.3 0 00-.1.229.326.326 0 00.1.237.326.326 0 00.469 0 .326.326 0 00.1-.237.3.3 0 00-.1-.229.331.331 0 00-.235-.091z\\\"/><path stroke=\\\"none\\\" d=\\\"M11 1H1v13h13V1zm-1 10.951a1.04 1.04 0 01-.293.738.978.978 0 01-.746.311H6.038a.988.988 0 01-.74-.308 1.026 1.026 0 01-.3-.741V3.922a1.141 1.141 0 01.23-.634.946.946 0 01.73-.288h3.12l.063-1h.8l.059.764z\\\"/><path stroke=\\\"none\\\" d=\\\"M8.55 9.214a.331.331 0 100 .663.33.33 0 00.238-.1.328.328 0 000-.469.33.33 0 00-.238-.094zM9 5.949v-.9a1.089 1.089 0 00-.27-.745A.845.845 0 008.074 4H6.942a.867.867 0 00-.664.308A1.071 1.071 0 006 5.05v.9a1.063 1.063 0 00.278.748.872.872 0 00.664.3h1.132a.853.853 0 00.653-.3A1.074 1.074 0 009 5.949z\\\"/></svg>\\n\",\"ip-sector-consumer-cyclical\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M1 1.124h13v13H1zm12.153 8.754V8.331a1.812 1.812 0 00-.24-.929 1.313 1.313 0 00-.643-.576 3.573 3.573 0 00-.648-1.7 3.661 3.661 0 00-1.4-1.216A4.066 4.066 0 008.4 3.493a4.066 4.066 0 00-1.087.135 3.819 3.819 0 00-.948.411 3.52 3.52 0 00-.825.685 4.323 4.323 0 00-.624.93 3.469 3.469 0 00-.323.831 3.723 3.723 0 00-1.633.569 2.722 2.722 0 00-1.008 1.2 4 4 0 00-.327 1.627h.848a1.109 1.109 0 00.127.419 1.408 1.408 0 00.3.435 1.319 1.319 0 00.42.264 1.5 1.5 0 00.57.1 1.38 1.38 0 00.956-.332 1.469 1.469 0 00.463-.893h3.963a1.181 1.181 0 00.128.426 1.528 1.528 0 00.311.47 1.4 1.4 0 00.429.293 1.452 1.452 0 00.585.107 1.512 1.512 0 00.709-.17 1.388 1.388 0 00.53-.484 1.757 1.757 0 00.268-.634zM5.664 6.3a2.218 2.218 0 01.722-1.286 2.348 2.348 0 011.4-.615V6.3zm2.889-1.948l.1-.012h.1a2.341 2.341 0 011.526.56 2.249 2.249 0 01.819 1.4H8.553z\\\"/></svg>\\n\",\"ip-sector-consumer-defensive\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M1 1h12.967v12.967H1zm11.9 3.766l-8.94-.838-.28-1.545H1.927a.448.448 0 00-.339.143.466.466 0 00-.136.333.488.488 0 00.475.475h.987l1.2 6.516a1.317 1.317 0 00-.783.457 1.3 1.3 0 00-.321.873 1.282 1.282 0 00.4.962 1.357 1.357 0 001.9-.006 1.288 1.288 0 00.4-.957 1.274 1.274 0 00-.065-.38h5.9a.445.445 0 00.333-.142.467.467 0 00.136-.333.474.474 0 00-.469-.476H5.063L4.748 8.14l7.687-.6zm-2.023 7.706a.715.715 0 10-.5-.208.677.677 0 00.498.208z\\\"/></svg>\\n\",\"ip-sector-energy\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M7.843 8.723a3.661 3.661 0 011.094 2.009 1.482 1.482 0 01-1.475 1.486 1.521 1.521 0 01-1.085-.439 1.377 1.377 0 01-.461-1.022 1.579 1.579 0 01.148-.625 5.9 5.9 0 01.366-.692c.145-.235.3-.467.464-.692l.448-.618zM14 1v13H1V1zm-2.874 7.788a6.306 6.306 0 00-1.079-3.454 10.8 10.8 0 00-3.059-3.026L7 2.457V2.7a4.4 4.4 0 01-.146 1.15 3.061 3.061 0 01-.407.922 3.686 3.686 0 01-.767.781 10.616 10.616 0 00-1.534 1.384 3.369 3.369 0 00-.761 2.2 3.205 3.205 0 00.547 1.754 4.021 4.021 0 001.478 1.363 3.931 3.931 0 001.917.511 3.65 3.65 0 001.932-.529 3.728 3.728 0 001.37-1.444 4.135 4.135 0 00.497-2.004z\\\"/></svg>\\n\",\"ip-sector-financial-services\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M8 9.041a1.125 1.125 0 11-1.125-1.125A1.127 1.127 0 018 9.041zm1.875-6.125A1.125 1.125 0 1011 4.041a1.127 1.127 0 00-1.125-1.125zM14 .833v13H1v-13zm-1 4h-1.157a2.125 2.125 0 10-3.937 0H4v4h.771a2.071 2.071 0 00-.021.208 2.108 2.108 0 00.157.792H3v-4H2v5h3.744a2.106 2.106 0 001.131.333c.049 0 .1-.011.143-.014a1.482 1.482 0 00-.018.181 1.5 1.5 0 102.908-.5H12v-1H8.843A2.108 2.108 0 009 9.041a2.071 2.071 0 00-.021-.208H13z\\\"/></svg>\\n\",\"ip-sector-healthcare\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M1 1.083v13h13v-13zm11 8H9v3H6v-3H3v-3h3v-3h3v3h3z\\\"/></svg>\\n\",\"ip-sector-industrials\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M1 1h12.976v13H1zm11.58 5.737L11.3 6.5a3.311 3.311 0 00-.428-1.011l.743-1.046-1.08-1.077-1.076.734a3.145 3.145 0 00-.969-.417L8.258 2.4H6.725l-.256 1.281a3.766 3.766 0 00-1.041.429L4.37 3.366 3.323 4.448l.7 1.082a4.223 4.223 0 00-.423.97l-1.254.232v1.527l1.278.268a3.516 3.516 0 00.4.963l-.708 1.094 1.054 1.058 1.058-.742a3.937 3.937 0 001.041.452l.256 1.278h1.533l.232-1.278a3.421 3.421 0 00.969-.4l1.076.689 1.082-1.059-.743-1.069a3.49 3.49 0 00.439-1l1.267-.256zm-5.1-1.291A2.041 2.041 0 019.524 7.5a2.068 2.068 0 01-.271 1.037 2.028 2.028 0 01-.746.761 1.979 1.979 0 01-1.028.283A2.081 2.081 0 015.393 7.5a1.954 1.954 0 01.615-1.463 2.043 2.043 0 011.471-.591z\\\"/></svg>\\n\",\"ip-sector-real-estate\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M14 14H1.006V1H14zm-2.028-6.269h1.2L7.557 3.012 1.833 7.731h1.189v4.585h1.72V8.97h1.917v3.345h5.313zm-1.708 3.478H8.36V8.983h1.9z\\\"/></svg>\\n\",\"ip-sector-technology\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M5 9h1v2H5V9zm2 1v1h1V9H7zm2.588-6.929H5.425a.492.492 0 00-.369.158.521.521 0 00-.156.371v3.812a.521.521 0 00.151.375.491.491 0 00.369.157h4.168a.534.534 0 00.369-.144.494.494 0 00.163-.384V3.6a.5.5 0 00-.16-.38.525.525 0 00-.372-.149zM14 1v13H1V1zm-1.812 8.795a.7.7 0 00-.2-.5.652.652 0 00-.494-.21H11.3V2.6a.7.7 0 00-.712-.7H4.422a.667.667 0 00-.5.207.683.683 0 00-.2.492v6.484h-.2a.678.678 0 00-.5.207.685.685 0 00-.207.5v2.22a.669.669 0 00.207.492.678.678 0 00.5.207H11.5a.651.651 0 00.491-.213.686.686 0 00.2-.486zM9 10v1h1V9H9z\\\"/></svg>\\n\",\"ip-sector-utilities\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M1 1v13h13V1zm7.574 11.691a.316.316 0 01-.068.2.283.283 0 01-.187.1l-1.558.3h-.048a.322.322 0 01-.2-.068.333.333 0 01-.119-.187v-.053a.318.318 0 01.068-.2.279.279 0 01.188-.107l1.623-.291a.283.283 0 01.19.071.357.357 0 01.113.185zm.41-1.011a.316.316 0 01-.068.2.283.283 0 01-.187.1l-2.408.439h-.048a.31.31 0 01-.2-.068.279.279 0 01-.1-.187v-.048a.319.319 0 01.065-.2.272.272 0 01.179-.1l2.407-.439h.048a.31.31 0 01.2.068.34.34 0 01.116.188zm1.254-4.405a9.42 9.42 0 00-1.051 1.91 5.181 5.181 0 00-.321 1.777H6.089a5.127 5.127 0 00-.324-1.78 9.728 9.728 0 00-1.049-1.907A3.147 3.147 0 014.139 5.4a3.34 3.34 0 013.34-3.337A3.337 3.337 0 0110.815 5.4a3.252 3.252 0 01-.577 1.875z\\\"/></svg>\\n\",\"ip-size-aggregate-large-cap\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M1.5 1.5h12v4h-12z\\\"/></svg>\\n\",\"ip-size-aggregate-mid-cap\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M1.5 5.5h12v4h-12z\\\"/></svg>\\n\",\"ip-size-aggregate-small-cap\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M1.5 9.5h12v4h-12z\\\"/></svg>\\n\",\"ip-star-rating-hypo\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M9.334 8.729l1.138 3.541-2.979-2.182-2.945 2.182L5.7 8.729 2.707 6.5h3.675l1.111-3.474L8.605 6.5h3.688z\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"ip-star-rating\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M9.908 8.919l1.494 4.65L7.491 10.7l-3.867 2.869 1.512-4.65-3.929-2.926h4.825l1.459-4.562L8.95 5.993h4.843z\\\"/></svg>\\n\",\"ip-style-aggregate-core\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M9.5 1.5v12h-4v-12z\\\"/></svg>\\n\",\"ip-style-aggregate-growth\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M13.5 1.5v12h-4v-12z\\\"/></svg>\\n\",\"ip-style-aggregate-value\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M5.5 1.5v12h-4v-12z\\\"/></svg>\\n\",\"ip-style-box-bottom-left\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M1.5 9.5h4v4h-4z\\\"/></svg>\\n\",\"ip-style-box-bottom-mid\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M5.5 9.5h4v4h-4z\\\"/></svg>\\n\",\"ip-style-box-bottom-right\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M9.5 9.5h4v4h-4z\\\"/></svg>\\n\",\"ip-style-box-middle-left\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M1.5 5.5h4v4h-4z\\\"/></svg>\\n\",\"ip-style-box-middle-mid\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M5.5 5.5h4v4h-4z\\\"/></svg>\\n\",\"ip-style-box-middle-right\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M9.5 5.5h4v4h-4z\\\"/></svg>\\n\",\"ip-style-box-top-left\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M1.5 1.5h4v4h-4z\\\"/></svg>\\n\",\"ip-style-box-top-mid\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M5.5 1.5h4v4h-4z\\\"/></svg>\\n\",\"ip-style-box-top-right\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" stroke=\\\"none\\\" d=\\\"M9.5 1.5h4v4h-4z\\\"/></svg>\\n\",\"ip-style-box\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1.5 1.5h12v12h-12zM5.5 1.5v12M9.5 2v12M1.5 5.5h12M1.5 9.46h12\\\"/></svg>\\n\",\"ip-super-sector-cyclical\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\">><path stroke=\\\"none\\\" d=\\\"M10.917 9.619v.372c0 .438-.107.846-.322 1.226-.215.38-.509.681-.884.901-.374.221-.78.331-1.217.331-.434 0-.841-.115-1.224-.345-.382-.231-.682-.542-.899-.934-.216-.392-.325-.805-.325-1.239V5.08c0-.244-.088-.469-.263-.674-.175-.205-.385-.307-.63-.307-.181 0-.341.042-.479.124-.137.082-.247.205-.331.369s-.123.307-.123.429v1.644c0 .209-.075.388-.225.538-.15.15-.329.225-.538.225-.205 0-.383-.076-.535-.227-.151-.153-.227-.331-.227-.536V5.003c0-.434.111-.843.334-1.226.223-.384.523-.685.901-.901.379-.217.786-.326 1.223-.326.434 0 .838.116 1.215.349.376.232.671.545.884.937.212.392.318.807.318 1.244v4.853c0 .26.091.487.275.68.183.193.399.29.647.29.205 0 .372-.047.503-.142.13-.095.229-.212.296-.352.067-.14.1-.279.1-.417V9.62h-1.43l2.181-3.753 2.163 3.753-1.388-.001z\\\"/></svg>\\n\",\"ip-super-sector-defensive\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M9.761 9.642V8.296H2.462c-.235 0-.438-.085-.607-.254-.17-.17-.255-.363-.255-.578 0-.231.087-.428.26-.589s.378-.242.613-.242H9.76V5.358L13.5 7.5 9.761 9.642z\\\"/></svg>\\n\",\"ip-super-sector-sensitive\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M12.256 8.871l-.946-1.076-2.1 1.778-1.765-1.986-2.409 4.216-3.217-5.519c-.079-.123-.119-.256-.119-.398 0-.206.08-.382.241-.527.161-.145.344-.217.55-.217.285 0 .499.133.642.399l1.891 3.241 2.141-3.764L9.371 7.48l.928-.791-.891-.988 4.192-.904-1.344 4.074z\\\"/></svg>\\n\",\"ip-sustainability\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M2.021 4.261a17.913 17.913 0 002.264.571A7.951 7.951 0 003.7 7.191H1.121a6.319 6.319 0 01.9-2.93zm0 6.709a6.273 6.273 0 01-.9-2.908H3.7a7.8 7.8 0 00.586 2.351 18.367 18.367 0 00-2.265.557zM4.681 4a17.065 17.065 0 01-2.132-.5 6.733 6.733 0 011.887-1.608A6.417 6.417 0 016.7 1.1a9.977 9.977 0 00-1.034 1.282A13.4 13.4 0 004.681 4zm0 7.258a12.981 12.981 0 001 1.626 10.186 10.186 0 001.019 1.25 6.684 6.684 0 01-4.153-2.4 18.443 18.443 0 012.134-.478zm.534-6.284a19.724 19.724 0 002.029.161v2.056h-2.6a7.308 7.308 0 01.571-2.219zm0 5.3a7.362 7.362 0 01-.57-2.2h2.6v2.051a13.969 13.969 0 00-2.03.142zm2.029-6.042a15.257 15.257 0 01-1.633-.1 15.045 15.045 0 011.633-2.5zm0 9.39A14.1 14.1 0 015.611 11.1q.606-.066 1.633-.1zm.916-12a16.721 16.721 0 011.633 2.5 15.751 15.751 0 01-1.633.1zm2.021 3.347a7.977 7.977 0 01.57 2.219H8.16V5.133a19.948 19.948 0 002.022-.161zm0 5.3a13.936 13.936 0 00-2.021-.154V8.063h2.592a7.653 7.653 0 01-.57 2.204zM8.16 11q1 .037 1.633.1a15.817 15.817 0 01-1.633 2.52zm2.563-7a13.843 13.843 0 00-1-1.63A9.675 9.675 0 008.694 1.1a6.48 6.48 0 012.249.78 6.855 6.855 0 011.911 1.62 19.334 19.334 0 01-2.131.5zm0 7.258a19.627 19.627 0 012.132.476 6.69 6.69 0 01-1.886 1.6 6.582 6.582 0 01-2.274.8 10.433 10.433 0 001.048-1.278 12.634 12.634 0 00.98-1.6zm2.652-6.995a6.675 6.675 0 01.9 2.93H11.7a7.791 7.791 0 00-.586-2.358 17.577 17.577 0 002.261-.574zm0 6.709a19.8 19.8 0 00-2.264-.557 7.579 7.579 0 00.589-2.352h2.578a6.449 6.449 0 01-.903 2.907z\\\"/></svg>\\n\",\"jump-to\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M2.5 2v6.5H12\\\"/><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M9.5 5.5l3.004 3-3.004 3\\\"/></svg>\\n\",\"list\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M6 3.5h7M6 7.5h7M6 11.5h7M2 3.5h2M2 7.5h2M2 11.5h2\\\"/></svg>\\n\",\"lock-close\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M2.5 6.5h10v7h-10z\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M4.5 4.5v-2a1 1 0 011-1h4a1 1 0 011 1v2\\\" fill=\\\"none\\\" stroke-linecap=\\\"square\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"lock-open\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M2.5 6.5h10v7h-10z\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M4.5 2.5a1 1 0 011-1h4a1 1 0 011 1v2\\\" fill=\\\"none\\\" stroke-linecap=\\\"square\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"menu\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1 2.5h13M1 5.833h13M1 12.5h13M1 9.167h13\\\"/></svg>\\n\",\"minus\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M1 7.5h13\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"object-plus\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M8 2.5h4.5v10h-10V8M1 4h6M4 1v6\\\"/></svg>\\n\",\"open-new\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M4.5 2.5h8v8h-8z\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M10.958 12.5H2.5V4.083\\\"/></svg>\\n\",\"paperclip-angle\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M9.768 4.525l-5.3 5.3a.953.953 0 000 1.415.952.952 0 001.415 0l6.293-6.294a2.123 2.123 0 00.071-2.9 2.123 2.123 0 00-2.9.071L3.05 8.414a2.854 2.854 0 000 4.243 2.854 2.854 0 004.243 0l5.3-5.3\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"paperclip\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M6.5 4v7.5a.951.951 0 001 1 .951.951 0 001-1V2.6a2.123 2.123 0 00-2-2.1 2.123 2.123 0 00-2 2.1v8.9a2.854 2.854 0 003 3 2.854 2.854 0 003-3V4\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"pause-circle\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><circle cx=\\\"7.5\\\" cy=\\\"7.5\\\" r=\\\"6.5\\\" fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\"/><path stroke=\\\"none\\\" d=\\\"M5 5h2v5H5zM8 5h2v5H8z\\\"/></svg>\\n\",\"pencil\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M10.5 1.5l-7 7-2 5 5-2 7-7m-10 4l3 3\\\"/></svg>\\n\",\"person-group\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M5.5 14v-2.5a1 1 0 011-1h6a1 1 0 011 1V14m-12-2V9.5a1 1 0 011-1H5\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/><circle vector-effect=\\\"non-scaling-stroke\\\" cx=\\\"9.5\\\" cy=\\\"6\\\" r=\\\"2.5\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M6.768 2.232A2.5 2.5 0 105 6.5\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"person-plus\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M13.5 14v-2.5a2 2 0 00-2-2h-8a2 2 0 00-2 2V14m10-13v5M9 3.5h5M9.947 6.236a3 3 0 11-1.558-4.6\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"person\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M1.5 14v-2.5a2 2 0 012-2h8a2 2 0 012 2V14\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/><circle vector-effect=\\\"non-scaling-stroke\\\" cx=\\\"7.5\\\" cy=\\\"4.5\\\" r=\\\"3\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"play-circle\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><circle cx=\\\"7.5\\\" cy=\\\"7.5\\\" r=\\\"6.5\\\" fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\"/><path stroke=\\\"none\\\" d=\\\"M5.5 4.538v5.924l5-2.962z\\\"/></svg>\\n\",\"plus\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\"  stroke-miterlimit=\\\"10\\\" d=\\\"M7.5 2v11M2 7.5h11\\\"/></svg>\\n\",\"print\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M2 11.5H.5v-7h14v7H13\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M3.5 9.5h8v4h-8zm0-6.5V1.5h8V3M3 6.5h2\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"question-circle\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><circle cx=\\\"7.5\\\" cy=\\\"7.5\\\" r=\\\"6.5\\\" fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\"/><path stroke=\\\"none\\\" d=\\\"M6.875 10.75h1.25V12h-1.25zM8.121 9.5h-1.25a4.015 4.015 0 011.187-2.441A2.806 2.806 0 008.875 5.5a1.375 1.375 0 00-2.75 0h-1.25a2.625 2.625 0 015.25 0 4.007 4.007 0 01-1.183 2.442A2.875 2.875 0 008.121 9.5z\\\"/></svg>\\n\",\"refresh\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path d=\\\"M12.5 4.75c-1.088-1.1-2-3-5-3a6 6 0 106 6\\\" fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\"/><path fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M12.5 1.25v3.5H9\\\"/></svg>\\n\",\"remove\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path d=\\\"M3 3l9 9m0-9l-9 9\\\" fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\"  stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"save\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M13.5 13.5h-12v-12h10.562L13.5 3.125z\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M4.5 1.5h6v4h-6zm-1 6h8v6h-8zm5-4.5v1\\\"/></svg>\\n\",\"scale\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M3 1.5h9m-9 12h9m-4.5-12v12m4-10l-2 6h4zm-8 0l-2 6h4z\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"search\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M9.154 9.181l4.451 4.45\\\"/><circle vector-effect=\\\"non-scaling-stroke\\\" cx=\\\"6\\\" cy=\\\"6\\\" r=\\\"4.5\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"share\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M7 2.5H1.5v11h11V8m1-6.5l-8 8m3.5-8h4.5V6\\\"/></svg>\\n\",\"stop-circle\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><circle cx=\\\"7.5\\\" cy=\\\"7.5\\\" r=\\\"6.5\\\" fill=\\\"none\\\" vector-effect=\\\"non-scaling-stroke\\\" stroke-miterlimit=\\\"10\\\"/><path stroke=\\\"none\\\" d=\\\"M5 5h5v5H5z\\\"/></svg>\\n\",\"text-size\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M9 8.5h3m-11-2h5M3.5 9V4M1 10.5h5m1.5 2l3-9 3 9\\\"/></svg>\\n\",\"trash\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M2 3.5h11M3.5 5v8.5h8V5M6 6v6M9 6v6M5 1.5h5\\\"/></svg>\\n\",\"triangle-fill-down\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M11.5 4.5l-4 7-4-7h8z\\\"/></svg>\\n\",\"triangle-fill-left\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M11 12L4 8l7-4v8z\\\"/></svg>\\n\",\"triangle-fill-right\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M4 4l7 4-7 4V4z\\\"/></svg>\\n\",\"triangle-fill-up\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path stroke=\\\"none\\\" d=\\\"M3.5 11.5l4-7 4 7h-8z\\\"/></svg>\\n\",\"undo\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M5.682 7.682L2.5 4.5l3.182-3.182\\\"/><path vector-effect=\\\"non-scaling-stroke\\\" d=\\\"M3 4.5h5.5a4 4 0 010 8h-2\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\"/></svg>\\n\",\"upload\":\"<svg focusable=\\\"false\\\" xmlns=\\\"http://www.w3.org/2000/svg\\\" viewBox=\\\"0 0 15 15\\\"><path vector-effect=\\\"non-scaling-stroke\\\" fill=\\\"none\\\" stroke-miterlimit=\\\"10\\\" d=\\\"M1 13.5h12.838M7.5 2v10m4.054-5.5L7.5 1.527 3.446 6.5\\\"/></svg>\\n\"}");

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _dialog_vue_vue_type_template_id_b93ffca6___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(155);
/* harmony import */ var _dialog_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83);
/* harmony import */ var _dialog_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(140);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_dialog_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"].locals || _dialog_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _dialog_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _dialog_vue_vue_type_template_id_b93ffca6___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _dialog_vue_vue_type_template_id_b93ffca6___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/node_modules/@mds/dialog/src/dialog.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _section_vue_vue_type_template_id_43fd82fa___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(156);
/* harmony import */ var _section_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85);
/* harmony import */ var _section_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(147);
/* harmony import */ var _node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);





var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (_section_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"].locals || _section_vue_vue_type_style_index_0_lang_scss_module_true___WEBPACK_IMPORTED_MODULE_2__["default"])
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && false



        module.hot && false

/* normalize component */

var component = Object(_node_modules_mwc_cli_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _section_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
  _section_vue_vue_type_template_id_43fd82fa___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _section_vue_vue_type_template_id_43fd82fa___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/pp-scenario-analysis/node_modules/@mds/section/src/section.vue"
/* harmony default export */ __webpack_exports__["a"] = (component.exports);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(6)(module)))

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(390);


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(129), __webpack_require__(400), __webpack_require__(401));
	else {}
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 129);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



__webpack_require__(110);

var _timeSeriesLine = __webpack_require__(91);

var _timeSeriesLine2 = _interopRequireDefault(_timeSeriesLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _timeSeriesLine2.default;

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToolTip = __webpack_require__(1);
var Core = __webpack_require__(0);
var Utils = Core.Utils;
var mbc_mds_constants = Utils.colors.mbc_mds_constants;

function ToolTipMixin() {}
/**
 * To configure the tooltip template function;
 * The template outer div must be given the "tooltip-inner" class;
 * The template outer div must also be given the "tooltip-flag" class;
 * The toolTipTemplate method must accept "d" as a parameter;
 * The toolTipTemplate method must return a template string
 * @type {Function}
 */

/* private methods */

/**
 * _currentDate
 * @private
 **/
var _currentDate = null;

/**
 * @method _getCurrentDate
 * @private
 * @desc returns the current mouse coordinate date
 * @example
 * var currentDate = _getCurrentDate();
 *
 * @return {Object} Date object
**/
var _getCurrentDate = function _getCurrentDate() {
    return _currentDate;
};

/**
 * @method _setCurrentDate
 * @private
 * @param {Object} - Date object
 * @desc Expects a Date object and sets it as the current date
 * @example
 * _setCurrentDate(new Date())
 *
 * @return undefined
**/
var _setCurrentDate = function _setCurrentDate(date) {
    if (Object.prototype.toString.call(date) !== "[object Date]") {
        console.warn("Can't update date: not a date object!");
        return;
    }

    _currentDate = date;
};

/**
 * @method _generateCells
 * @param {Array} colors - color codes to style each dash per line
 * @desc  Generates the cells of the template for each line on the chart.
 * @example
 * var cells = _generateCells(["#FF0000"]);
 *
 * @return {String} Concatenated template string of the cells
**/

ToolTipMixin.prototype.generateCells = function () {
    var data = this.get("tooltipData");
    var colors = this.get("colors");
    var dottedLines = this.get("dottedLines");
    var maxWidthTextCell = 164 - Utils.string.getLongestTextStringWidth(data); // 200 max width - 10 icon with - 26 in total padding
    var defaultLineStrokeWidth = 2;

    return data.map(function (item) {
        var line = item.name;
        var color = item.color || colors[item.index] || mbc_mds_constants["color"].black;
        var lineStrokeWidth = item.lineStrokeWidth || defaultLineStrokeWidth;
        var marginBottomConfigs = { 2: 4, 4: 3, 6: 2 };
        var showDots = dottedLines.indexOf(line) !== -1;
        var benchmarkStyle = showDots ? "border-top:2px dotted " + color + "; margin-bottom: 4px" : "border-top:" + lineStrokeWidth + "px solid " + color + "; margin-bottom: " + marginBottomConfigs[lineStrokeWidth] + "px";
        return "<div class=\"cell tooltip-row\">\n                        <div class=\"tip-cell-icon tooltip-cell\" style=\"" + benchmarkStyle + "\"> </div>\n                        <div class=\"tip-cell-name tooltip-cell\" style=\"max-width: " + maxWidthTextCell + "px\"> " + line + " </div>\n                        <div class=\"tip-cell-data tooltip-cell\">" + item.value + "</div>\n                    </div>";
    }).join("");
};

/**
 * @method _getLineData
 * @private
 * @desc Retrieve and concatenate the line data for the given context's data manager '
 * @example
 * var lines = _getLineData();
 *
 * @return {Array} Concatenated array of line data for y1 and y2 groups
**/
var _getLineData = function _getLineData() {
    if (!this) {
        throw new Error("Context required to find line data");
    }

    var dataManager = this.get("data");
    var y1DomainDataset = this.get("y1DomainDataset");
    var lines = dataManager.get(y1DomainDataset);
    var hasY2 = this.get("y2");

    if (hasY2) {
        var y2DomainDataset = this.get("y2DomainDataset");
        lines = lines.concat(dataManager.get(y2DomainDataset));
    }

    return lines;
};

/* end private methods */

/**
 * @method updateTooltipData
 * @param {String} name
 * @param {Number} value
 * @param {Number} index
 * @desc Sets or updates data for one of the lines on the chart.
 * @example
 * this.updateTooltipData("602107", -47, 1)
 *
 * @return undefined
**/
ToolTipMixin.prototype.updateTooltipData = function (series, mouseObjects) {
    if (!series.length) {
        console.warn("Can't update data: missing information");
        return;
    }

    // sort tooltip items by the end value of series line
    series = this.sortDataByEndValue(series);

    // format tooltipData value
    var y1FormatFn = this.tickFormat(this.get("y1TickFormat"));
    var y2FormatFn = this.tickFormat(this.get("y2TickFormat"));
    var dataManager = this.get("data");

    var tooltipData = [];
    series.forEach(function (item) {
        var value = null;
        var name = item.name;
        var data = mouseObjects[name];
        if (data) {
            value = data.value;
        }
        var formatter = dataManager.inGroup(name, "y1") ? y1FormatFn : y2FormatFn;
        var formattedValue = Utils.string.convertDashToEnDash(formatter(value));
        var transformedValue = formattedValue == null || formattedValue == "" ? "N/A" : formattedValue;
        tooltipData.push({
            name: name,
            index: item.index,
            value: transformedValue,
            color: item.color,
            lineStrokeWidth: item.lineStrokeWidth
        });
    });

    this.set("tooltipData", tooltipData);
};

/**
 * @method toolTipTemplate
 * @desc Either uses the custom template added by the user or generates a default one.
 *       Used to draw the tooltip later.
 * @example
 * chart.toolTipTemplate()
 *
 *
 * @return {String} template for tooltip
**/
ToolTipMixin.prototype.toolTipTemplate = function () {
    var customTemplate = this.get("tooltipCustomTemplate");
    if (customTemplate) {
        return customTemplate;
    } else {
        var format, title;
        var cells = this.generateCells.call(this);
        var date = _getCurrentDate();

        if (date) {
            format = this.get("tooltipTimeFormat") || d3.time.format("%x");
            title = this.get("tooltipTitle") || format(date);
        } else {
            title = this.get("tooltipTitle") || "Securities";
        }

        return "<div class=\"tooltip-inner tooltip-flag\">\n                    <div class=\"tooltip-title\">\n                        <p>" + title + "</p>\n                    </div>\n\n                    <div class=\"tooltip-body tooltip-table\">\n                        " + cells + "\n                    </div>\n                </div>";
    }
};

/**
 * @method drawToolTip
 * @desc Binds the tooltip to the tooltip transparent canvas
 * @example
 * chart.drawToolTip()
 *
 *
 * @return undefined
 **/
ToolTipMixin.prototype.drawToolTip = function (options) {

    this.set("showToolTip", true);

    var defaultOpts = {
        transition: false,
        namespace: this.get("id"),
        chart: "time-series"
    };

    Utils.object.copy(defaultOpts, options);

    var t = this.toolTipTemplate.bind(this);
    var tooltip = ToolTip(defaultOpts).template(t);
    var canvas = this.get("canvas");
    var svg = canvas.layer("top-layer", "front").select("rect");

    svg.call(tooltip.bind());

    this.set("tooltipInfo", tooltip);
};

/**
 * @method removeToolTip
 * @desc Removes the tooltip and the tooltip canvas
 * @example
 * chart.removeToolTip()
 *
 *
 * @return undefined
**/
ToolTipMixin.prototype.removeToolTip = function () {

    this.set("showToolTip", false);

    var canvas = this.get("canvas");
    var layer = canvas.layer("front-group");

    layer.remove();
    this.update();
};

/**
 * @method validateTooltipDirection
 * @desc Determines if the tooltip needs to change positions based on where it is on the canvas and update it.
 *
 * @param {Array} mouse - d3 selection
 * @example
 * var mouse = d3.mouse(this)
 * chart.validateTooltipDirection(mouse)
 *
 *
 * @return undefined
 **/
ToolTipMixin.prototype.validateTooltipDirection = function (mouse) {
    var coords = {};
    var canvas = this.get("canvas");
    var tooltipData = this.get("tooltipData");

    coords.tooltip = this.get("tooltipInfo")._clientRect;
    coords.mouse = mouse;
    coords.canvasWidth = canvas.width();
    coords.canvasHeight = canvas.height();
    coords.canvasPositioning = canvas.get("svg").select(".mbc-front-group").node().getBoundingClientRect();

    this.getHoverLineLeft();
    this.changeToolTipDirection(coords);

    if (this.get("tooltipHidden")) {
        this.get("tooltipInfo").show(tooltipData, {
            position: this.get("direction"),
            namespace: this.get("id"),
            hoverLeft: this.get("hoverLineLeft")
        });
        this.set("tooltipHidden", false);
    }
};

/**
 * @method changeToolTipDirection
 * @desc Uses the coordinate information to decide how the tooltip should be positioned in the canvas. Determines top and bottom boundry when size of flag exceeds size of canvas.
 *
 * @param {Object} coords - mouse and tooltip positional information
 * @example
 * var coords = {};
 * coords.tooltip = this.get("tooltipInfo")._clientRect;
 * coords.mouse = mouse;
 * coords.canvasWidth = canvas.width();
 * coords.canvasHeight = canvas.height();
 * coords.canvasPositioning = canvas.get("svg").node().getBoundingClientRect();
 * chart.changeToolTipDirection(coords)
 *
 * @return undefined
 **/
ToolTipMixin.prototype.changeToolTipDirection = function (coords) {
    var tooltip = this.get("tooltipInfo"); //Reference to tooltip
    var canvasWidth = coords.canvasWidth; // Chart plotted width
    var canvasHeight = coords.canvasHeight; // Chart plotted height
    var hoverLineToLeft = this.get("hoverLineLeft") - coords.canvasPositioning.left; //The distance between hoverLine and left side of canvas

    var tooFarRight = coords.tooltip && coords.mouse[0] >= canvasWidth - coords.tooltip.width && hoverLineToLeft >= coords.tooltip.width; //Boolean for right canvas boundry
    var tooFarLeft = coords.tooltip && (coords.mouse[0] < canvasWidth - coords.tooltip.width ? true : hoverLineToLeft < coords.tooltip.width); //Boolean for left canvas boundry
    var tooHigh = coords.tooltip && coords.mouse[1] <= coords.tooltip.height; //Boolean for top canvas boundry
    var tooLow = coords.tooltip && coords.mouse[1] >= canvasHeight - coords.tooltip.height; //Boolean for bottom canvas boundry

    var windowHeight = window.innerHeight; // Window/viewport height to use for bottom boundry
    var viewportMousePositionY = d3.event.clientY; // Y mouse position relative to window/viewport
    var exceedsViewportTop = coords.tooltip && coords.tooltip.height - coords.mouse[1] > coords.canvasPositioning.top; //Boolean check if tooltip exceeds beyond viewport top
    var exceedsViewportBottom = coords.tooltip && viewportMousePositionY + coords.tooltip.height > windowHeight; //Boolean check if tooltip exceeds beyond viewport bottom

    // If flag exceeds top and bottom of canvas, then check collision with viewport viewport
    if (tooHigh && tooLow) {

        // Check collision to viewport, default to display flag down if conditions both fail
        tooHigh = !exceedsViewportTop && exceedsViewportBottom ? false : true;
        tooLow = !exceedsViewportTop && exceedsViewportBottom ? true : false;
    }

    // If flag exceeds neither the top or bottom of canvas default the position
    if (!tooHigh && !tooLow) {
        tooLow = true;
    }

    if (tooFarRight && tooLow) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "left-bottom");
        return;
    }

    if (tooFarLeft && tooLow) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "right-bottom");
        return;
    }

    if (tooFarRight && tooHigh) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "left-top");
        return;
    }

    if (tooFarLeft && tooHigh) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "right-top");
        return;
    }

    return;
};

/**
     * @method getHoverLineLeft
     * @desc Set the left px position of the current selected data line
     * @return undefined
**/
ToolTipMixin.prototype.getHoverLineLeft = function () {
    var canvas = this.get("canvas");
    var mouseRect = canvas.layer('front-group').select(".mouse-rect-line");
    this.set("hoverLineLeft", mouseRect[0][0].getBoundingClientRect().left);
};

/**
     * @method createMouseRect
     * @desc Create the area on the canvas that listens to mouse events for the tooltip
     *
     * @example
     * chart.this.createMouseRect();
     *
     *
     * @return undefined
    **/
ToolTipMixin.prototype.createMouseRect = function () {
    var _this = this;
    var canvas = this.get("canvas");
    var scales = this.get("scales");

    var yPadding = this.get("yPadding");
    var width = canvas.width() - yPadding * 2;
    var height = canvas.height();
    var topLayer = canvas.layer("top-layer", "front");
    var x = scales.scale("x");
    var rectMouse = topLayer.append("rect"); // append a rect to catch mouse movements on canvas

    rectMouse.attr("x", yPadding).attr("width", width).attr("height", height).attr("fill", "none").attr("pointer-events", "all").classed({
        "rect__event-area": true
    }).on("mouseleave", function () {
        // on mouse leave hide line
        canvas.layer('front-group').select(".mouse-rect-line").style("opacity", "0");

        var agileStyle = _this.get("agileStyle");
        if (!agileStyle.bubbleOpacity) {
            var layer = canvas.layer("line-chart-layer");
            layer.selectAll(".line-bubbles").attr("opacity", 0);
        }
    }).on("mouseover", function () {
        // on mouse in show line
        canvas.layer('front-group').select(".mouse-rect-line").style("opacity", "1");
    }).on("mousemove", function () {
        // mouse moving over canvas
        var frontGroup = canvas.layer('front-group');
        var mouse = d3.mouse(this);

        var seriesData = [];
        var series = [];
        // build seriesData at the same time when get translate
        frontGroup.selectAll(".mouse-per-line").attr("transform", function (d) {
            seriesData = seriesData.concat(d.series);
            series.push({
                name: d.displayName,
                index: d.index,
                value: _this.getValidEndValue(d.series),
                color: d.color,
                lineStrokeWidth: d.lineStrokeWidth
            });
            return "translate(" + mouse[0] + "," + mouse[1] + ")";
        });

        // sort all seriesData by date
        seriesData.sort(function (a, b) {
            return a.date < b.date ? -1 : a.date > b.date ? 1 : 0;
        });

        var xDate = x.invert(mouse[0]);
        var bisect = d3.bisector(function (d) {
            return d.date;
        }).right;
        var idx = bisect(seriesData, xDate) - 1;
        idx = idx >= seriesData.length ? seriesData.length - 1 : idx;
        idx = idx < 0 ? 0 : idx;
        // find out the date at which mouse place, it will be used in the following
        var mouseDate = seriesData[idx].date;

        // find out items at the mouseDate,
        // Notice: if a series have no data on the day, mouseItems will not catains this series data
        // this is why we need seriesNames to record whole series
        var mouseItems = seriesData.filter(function (item) {
            return item.date.toString() === mouseDate.toString();
        });
        // convert to a object to make data more easy to be found
        var mouseObjects = {};
        mouseItems.forEach(function (item) {
            mouseObjects[item.name] = item;
        });

        /**
         * make sure tooltip use this data
         */
        _this.updateTooltipData(series, mouseObjects);

        /**
         * snap scrubber line to relevant hover data point
         */
        frontGroup.select(".mouse-rect-line").attr("d", function () {
            var d = "M" + x(mouseDate) + "," + height;
            d += " " + x(mouseDate) + "," + 0;
            return d;
        });

        _setCurrentDate(mouseDate);
        _this.validateTooltipDirection(mouse);
        _this.handleAgileStyle(mouseDate);
    }); //end mousemove
};

/**
* @method handleAgileStyle
* @desc Display bubbles which has the same date as mouseDate, hide other bubbles.
* @param {Date} mouseDate: the closest calculated date with mouse position
*/
ToolTipMixin.prototype.handleAgileStyle = function (mouseDate) {
    var agileStyle = this.get("agileStyle");
    if (!agileStyle.bubbleOpacity) {
        var canvas = this.get("canvas");
        var layer = canvas.layer("line-chart-layer");
        layer.selectAll(".line-bubbles").attr("opacity", 0);
        layer.selectAll(".line-bubbles.date" + mouseDate.getTime()).attr("opacity", 1);
    }
};

/**
 * @method renderToolTip
 * @desc Takes all the necessary steps to display the tooltip flag as long as the proper conditions are met
 *
 * @example
 * chart.renderToolTip();
 *
 *
 * @return undefined
 **/
ToolTipMixin.prototype.renderToolTip = function () {
    if (this.get("showToolTip") && !this.get("initialized")) {
        this.set("tooltipData", []);
        this.set("tooltipHidden", true); //initializes the property used to show tooltip
        this.createTooltip();
        this.drawToolTip({
            namespace: this.get("id")
        });
        this.set("direction", "right-top");
        this.set("initialized", true);
    }
};

/**
 * @method createTooltip
 * @desc Takes each line of the chart and calculates necessary tooltip data including timestamp, value, and name
 *       depending on where the mouse is on the canvas.
 *
 * @example
 * chart.renderToolTip();
 *
 *
 * @return undefined
 **/
ToolTipMixin.prototype.createTooltip = function () {
    var canvas = this.get("canvas");
    var lineData = _getLineData.bind(this);

    var layer = canvas.layer("front-group");

    var mouseG = layer.append("g").attr("class", "mouse-over-effects");

    mouseG.append("path") // this is the black vertical line to follow mouse
    .attr("class", "mouse-rect-line").style("stroke", "black").style("stroke-width", "1px").style("stroke-dasharray", "3,3").style("opacity", "0").style("pointer-events", "all");

    var mousePerLine = mouseG.selectAll(".mouse-per-line").data(lineData);

    mousePerLine.attr("class", "mouse-per-line");

    mousePerLine.enter().append("g").attr("class", "mouse-per-line");

    mousePerLine.exit().remove();

    this.createMouseRect();
};

module.exports = ToolTipMixin;

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var YEAR_FORMAT = "%Y";

/**
 * Ticks period configuration. '_sm' suffix stands for small screens (breakpoint).
 */
var TICKS_DEF = {
    year: [d3.time.years, 1],
    year_sm: [d3.time.years, 2],
    year_at_15: [d3.time.years, 2],
    year_at_15_sm: [d3.time.years, 3],
    year_at_30: [d3.time.years, 3],
    year_at_30_sm: [d3.time.years, 5],
    year_at_45: [d3.time.years, 5],
    year_at_45_sm: [d3.time.years, 10],
    year_at_60: [d3.time.years, 10],
    year_at_60_sm: [d3.time.years, 15],
    quarter: [d3.time.months, 3],
    quarter_sm: [d3.time.months, 6],
    month: [d3.time.months, 1],
    month_sm: [d3.time.months, 2],
    week: [d3.time.weeks, 1],
    week_sm: [d3.time.weeks, 2],
    day: [d3.time.days, 1],
    day_sm: [d3.time.days, 2],
    hour: [d3.time.hours, 4],
    hour_sm: [d3.time.hours, 4]
};

/**
 * Map that holds the timeline sub level for each period.
 */
var LEVEL_MAPPER = {
    year: "year",
    quarter: "quarter",
    month: "month",
    week: "week",
    day: "day",
    hour: "hour"
};

/**
 * Returns the tick period parameters for a given period and screen type.
 * @param {*} period
 * @param {*} smallScreen
 * @returns {Array} Array that holds the tick configuration for the x axis label.
 */
var getTickParameters = function getTickParameters(period, smallScreen) {
    period = period + (smallScreen ? "_sm" : "");
    return TICKS_DEF[period];
};

function Helper() {}

/**
 * Returns an array that contains the years within the domain.
 * @method getYear
 * @param {Array} domain
 * @returns {Array}
 */
var getYear = function getYear(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var yr = Math.floor(date.getFullYear());
    newDate.setYear(++yr);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        newDate.setDate(1);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        yr = Math.floor(newDate.getFullYear());
        newDate.setYear(++yr);
    }
    return dateArr;
};

/**
 * Returns an array that contains the quarters within the domain.
 * @method getQuarter
 * @param {Array} domain
 * @returns {Array}
 */
var getQuarter = function getQuarter(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var qtr = Math.floor(date.getMonth() / 3);
    newDate.setMonth(++qtr * 3);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        newDate.setDate(1);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        qtr = Math.floor(newDate.getMonth() / 3);
        newDate.setMonth(++qtr * 3);
    }
    return dateArr;
};

/**
 * Returns an array that contains the months within the domain.
 * @method getMonth
 * @param {Array} domain
 * @returns {Array}
 */
var getMonth = function getMonth(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var nextMonth = date.getMonth() + 1;
    newDate.setMonth(nextMonth);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        newDate.setDate(1);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        nextMonth = newDate.getMonth() + 1;
        newDate.setMonth(nextMonth);
    }

    return dateArr;
};

/**
 * Returns the next week first day.
 * @param {Date} date
 * @returns {Date}
 */
var getNextWeekStartDate = function getNextWeekStartDate(date) {
    var newDate = new Date(date.toString());
    var day = newDate.getDate();
    var weekDay = newDate.getDay();
    newDate.setDate(day + (7 - weekDay));
    return newDate;
};

/**
 * Returns an array that contains the weeks within the domain.
 * @method getWeek
 * @param {Array} domain
 * @returns {Array}
 */
var getWeek = function getWeek(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = getNextWeekStartDate(date);
    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        dateArr.push(newDate);
        newDate = getNextWeekStartDate(newDate);
    }

    return dateArr;
};

/**
 * Returns an array that contains the days within the domain.
 * @method getDay
 * @param {Array} domain
 * @returns {Array}
 */
var getDay = function getDay(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var nextDay = date.getDate() + 1;
    newDate.setDate(nextDay);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        nextDay = newDate.getDate() + 1;
        newDate.setDate(nextDay);
    }

    return dateArr;
};

/**
 * Returns an array that contains the hours within the domain.
 * @method getHour
 * @param {Array} domain
 * @returns {Array}
 */
var getHour = function getHour(domain) {
    var date = domain[0];
    var endDate = domain[1];
    var dateArr = [];
    dateArr.push(date);
    var newDate = new Date(date.toString());
    var nextHour = date.getHours() + 1;
    newDate.setHours(nextHour);

    while (newDate.getTime() < endDate.getTime()) {
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        dateArr.push(newDate);
        newDate = new Date(newDate.toString());
        nextHour = newDate.getHours() + 1;
        newDate.setHours(nextHour);
    }

    return dateArr;
};

/**
 * Gets the first visible tick from the ticks array.
 * @param {D3 Selection} allTicks Must contain a selection of ticks. Required.
 * @returns {D3 Selection}
 */
var getNextVisible = function getNextVisible(allTicks) {
    var next;
    allTicks.each(function () {
        var el = d3.select(this);
        if (!next && el.style("display") !== "none") {
            next = el;
        }
    });

    return next || d3.select();
};

/**
 * Used to make the domain symmetrical bc line chart doesn't use calculateDomain method in Core
 * @method makeSymmetrical
 * @param {Array} domain containing min and max values
 */
Helper.prototype.makeSymmetrical = function (arr) {
    var p0 = arr[0] < 0 ? arr[0] * -1 : arr[0];
    var p1 = arr[1] < 1 ? arr[1] * -1 : arr[1];

    if (p0 > p1) {
        return [p0 * -1, p0];
    } else {
        return [p1 * -1, p1];
    }
},

/**
 * Sets the x axis ticks funtion depending on the timeline level.
 * @method helperSetTicks
 * @param {Boolean} smallScreen
 */
Helper.prototype.helperSetTicks = function (smallScreen) {
    var timelineLevel = this.get("timelineLevel");

    var xDomain = this.get("xDomain");
    if (xDomain) {
        var dateDiff = xDomain[1].getFullYear() - xDomain[0].getFullYear();
        if (dateDiff > 14) {
            if (dateDiff < 29) timelineLevel = 'year_at_15';else if (dateDiff < 44) timelineLevel = 'year_at_30';else if (dateDiff < 59) timelineLevel = 'year_at_45';else timelineLevel = 'year_at_60';
        }
    }
    var xTicks = getTickParameters(timelineLevel, smallScreen);

    var subLabelFormat = YEAR_FORMAT;

    this.set("_xTicks", xTicks);
    this.set("subLabelFormat", subLabelFormat);
};

/**
 * Sets the x axis sub labels array.
 * @method helperSetSublabels
 */
Helper.prototype.helperSetSublabels = function () {
    var axes = this.get("canvas").get("axesGroup");
    var xDomain = this.get("xDomain");
    var subLabelFormat = this.get("subLabelFormat") || "%Y";

    var ticks = [];
    var subLabels = [];
    var previous = d3.time.format(subLabelFormat)(xDomain[0]);

    axes.selectAll(".mbc-axis-x .tick").each(function (d) {
        ticks.push(d);
    });

    ticks.forEach(function (tick) {
        var formatted = d3.time.format(subLabelFormat)(tick);
        if (previous === formatted) {
            subLabels.push(null);
        } else {
            subLabels.push(formatted);
            previous = formatted;
        }
    });

    this.set("xSubLabels", subLabels);
};

/**
 * Adds the first and last date x axes ticks.
 * @method helperAddFirstLabel
 * @param {Canvas} canvas Canvas containing the chart.
 */
Helper.prototype.helperAddFirstLabel = function (canvas) {

    var xDomain = this.get("xDomain");
    var subLabelFormat = d3.time.format(this.get("subLabelFormat") || YEAR_FORMAT);
    var yPadding = this.get("yPadding");
    var xTickFormat = this.get("_xTickFormat");
    var axes = canvas.get("axesGroup").select(".mbc-axis-x");
    var xAxisOrient = this.get("xAxisOrient");
    var xScale = this.get("scales").scale("x");
    var allTicks, firstTick, lastTick, tick, tickLast, firstRect, lastRect, tickRect, x, showLastSublabel, lastSublabel, diff;

    axes.selectAll("g.artificial").remove();
    allTicks = axes.selectAll(".tick").filter(function () {
        return !d3.select(this).classed("artificial");
    }).style("display", "");

    firstTick = getNextVisible(allTicks); //allTicks.first();
    lastTick = allTicks.last();

    // First one
    tick = axes.append("g").classed({
        tick: true,
        artificial: true,
        first: true
    }).attr("transform", "translate(0, 0)");

    tick.append("text").attrs({
        x: yPadding,
        y: xAxisOrient === "bottom" ? 3 : -3,
        "text-anchor": "start",
        dy: xAxisOrient === "bottom" ? ".71em" : "0em"
    }).text(xTickFormat(xDomain[0]));
    tick.append("text").text(subLabelFormat(xDomain[0])).attr("transform", function () {
        var y = xAxisOrient === "bottom" ? 28 : -18;
        return "translate(" + yPadding + ", " + y + ")";
    }).attr("class", "mbc-tick-abbreviation");

    if (!firstTick.empty()) {
        firstRect = firstTick.node().getBoundingClientRect();
        tickRect = tick.node().getBoundingClientRect();

        if (Math.abs(firstRect.left - tickRect.left) < tickRect.width + 10) {
            firstTick.style("display", "none");
        }
    }

    // Last Tick
    if (!lastTick.empty()) {
        lastRect = lastTick.node().getBoundingClientRect();
        x = canvas.width() - yPadding * 2;

        tickLast = axes.append("g").classed({
            tick: true,
            artificial: true,
            last: true
        }).attr("transform", "translate(" + x + ", 0)");

        tickLast.append("text").attrs({
            x: yPadding,
            y: xAxisOrient === "bottom" ? 3 : -3,
            "text-anchor": "end",
            dy: xAxisOrient === "bottom" ? ".71em" : "0em",
            class: "mbc-tick-label"
        }).text(xTickFormat(xDomain[1]));

        lastSublabel = tickLast.append("text").text(subLabelFormat(xDomain[1])).attrs({
            class: "mbc-tick-abbreviation",
            "text-anchor": "end",
            transform: function transform() {
                var y = xAxisOrient === "bottom" ? 28 : -18;
                return "translate(" + yPadding + ", " + y + ")";
            }
        });

        diff = tickLast.select(".mbc-tick-label").node().getBoundingClientRect().width - tickLast.select(".mbc-tick-abbreviation").node().getBoundingClientRect().width - 1;

        lastSublabel.attr("dx", diff * -1 + "px");

        tickRect = tickLast.node().getBoundingClientRect();

        showLastSublabel = lastTick[0][0].__data__.getYear() !== xDomain[1].getYear();
        if (xScale(lastTick[0][0].__data__) + lastRect.width - 2 > canvas.width() - yPadding) {
            lastTick.style("display", "none");
            showLastSublabel = lastTick[0][0].previousSibling && lastTick[0][0].previousSibling.__data__.getYear() !== xDomain[1].getYear();
        }

        if (!showLastSublabel) {
            lastSublabel.style("display", "none");
        } else {
            lastSublabel.style("display", "");
        }

        tickLast.style("display", "none");
    }
};

/**
 *
 * @method helperGetBackgroundArray
 * @param {Array} domain Chart domain.
 * @param {String} period Time period to generate the array for the background.
 * @returns {Array} Array containing the dates for each period within the domain.
 */
Helper.prototype.helperGetBackgroundArray = function (domain) {
    var period = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "quarter";

    var datesArray;
    switch (period) {
        case "year":
            datesArray = getYear(domain);
            break;
        case "quarter":
            datesArray = getQuarter(domain);
            break;
        case "month":
            datesArray = getMonth(domain);
            break;
        case "week":
            datesArray = getWeek(domain);
            break;
        case "day":
            datesArray = getDay(domain);
            break;
        case "hour":
            datesArray = getHour(domain);
            break;
        default:
            break;
    }
    return datesArray;
};

/**
 * @method helperXBuffer
 * @desc set buffer for xAxis
 * @param {Date} original - original date to be buffered
 * @param {Object} options - options for how much to buffer
 * @example
 *  this.helperXBuffer(new Date(), {level: 'hour', amount: 5})
 *
 * @return {Date} buffered date object
 */
Helper.prototype.helperXBuffer = function (original, options) {
    var level = LEVEL_MAPPER[options.level];
    var buffered;

    if (typeof d3.time[level] === "function") {
        buffered = d3.time[level].offset(original, options.amount);
    }

    return (typeof buffered === "undefined" ? "undefined" : _typeof(buffered)) === "object" ? buffered : original;
};

/**
 * @method sortDataByEndValue
 * @desc sort data by series end value
 * @example {Array} data
 *  [{name: "name", index: "2", endValue: 1345.002}, ...]
 * @return {Array} data
 */
Helper.prototype.sortDataByEndValue = function (data) {
    // tooltip items' order, legend items' order
    var linesOrder = this.get("linesOrder");
    data.sort(function (a, b) {
        var value = b.value - a.value;
        if (linesOrder === 'asc') {
            return -value;
        } else if (linesOrder === 'desc') {
            return value;
        } else {
            return 0;
        }
    });

    return data;
};

/**
 * @method getValidEndValue
 * @desc get valid end value of lines
 * @param {Array} series
 */
Helper.prototype.getValidEndValue = function (series) {
    var endValue;
    if (!series || !(series instanceof Array && series.length)) {
        return;
    }
    for (var i = series.length - 1; i >= 0; i--) {
        var value = series[i].value;
        if (value != null) {
            endValue = value;
            break;
        }
    }
    return endValue;
};

module.exports = Helper;

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Core = __webpack_require__(0);
var Legend = __webpack_require__(2);
var Tooltip = __webpack_require__(89);
var Helper = __webpack_require__(90);

var Chart = Core.Chart;
var Utils = Core.Utils;
var Classes = Core.Classes;

/**
 * Time Series Line Chart.
 *
 * @example
 * // Extension example:
 * var TimeSeriesLineChart = require("mbc-time-series-line-chart");
 *
 * var newExtendedTimeSeriesLineChart = TimeSeriesLineChart.extend({
 *   ...
 * });
 *
 * @examples
 * // Use example:
 * var TimeSeriesLineChart = require("mbc-time-series-line-chart");
 *
 * var timeSeries = new TimeSeriesLineChart(<options>);
 * d3Container.datum(data).call(timeSeries.init());
 *
 * @class
 * @extends Chart
 */
var TimeSeriesLineChart = Chart.extend(Helper, Legend, Tooltip,
/**
 * @lends TimeSeriesLineChart.prototype
 **/
{
    id: "mbc-time-series-line-chart", // Also used as class for this chart type.
    /** @type {Number} */
    screenMinHeight: 100, // container min-height
    breakpoint: 650,
    smallBreakpoint: 400,
    legend: true,
    legendMaxWidth: 150,
    ticksNumber: 4,
    tickValues: null,
    xAxisOrient: "bottom",
    xDomain: null,
    xDomainDataset: "x",
    y1DomainDataset: "y1",
    y2DomainDataset: "y2",
    y1Abbreviation: null,
    y1AxisLabel: false,
    y1AxisOrient: "left",
    y1TickValues: null,
    y1TicksAlign: "right",
    y1TickFormat: ",.2f",
    y1TickSymbol: "$",
    y1Bubbled: false,
    y1Symmetrical: false,
    y2Abbreviation: null,
    y2AxisLabel: false,
    y2AxisOrient: "left",
    y2TickValues: null,
    y2TicksAlign: "right",
    y2TickFormat: ",.2f",
    y2TickSymbol: "$",
    y2Bubbled: false,
    y2Symmetrical: false,
    lineStrokeWidth: 2,
    dottedDashDimensions: "1 5",
    bubbleRadius: 4,
    bubbleStrokeWidth: 2,
    yAxesLabelWidth: 20,
    yAxesLabelPadding: 6,
    yAxesSpacing: 5,
    yDomain: null,
    yPadding: 12,
    yPaddingBig: 12,
    yPaddingSmall: 6,
    yTickMargin: 6,
    yTickSize: 35,
    xTickFormat: null,
    xTicks: null, // Optional now and exclusive with timelineLevel for legacy
    xTickSize: null,
    showLegendValues: false, // Boolean
    greyBandLevel: null,
    timelineLevel: null, // year, quarter, month, week, day. Exclusive with xTicks
    firstTickDate: true, // true or false
    xAxisBuffer: null, // Optional Object
    xAxisStart: null, //Optional Date Object
    xAxisEnd: null, // Optional Date Object
    legendValueFont: "bold 18px helvetica neue",
    legendLabelFont: "14px helvetica neue",
    linesOrder: null, // asc/desc/null, will be used to sort the items order in legend and tooltip by the end value of series line
    dottedLines: [], //set dotted line key, such as ['line1Key','line2Key']
    responsiveWeight: true, // turn on/off responsive line and bubble weights
    /**
     * Prepare the data for the chart.
     * @method setData
     * @param {Object} data
     */
    setData: function setData(data) {
        var validLineStrokeWidths = [2, 4, 6];
        var defaultLineStrokeWidth = 2;
        var dataManager = this.get("data");
        var y1DomainDataset = this.get("y1DomainDataset");
        var y2DomainDataset = this.get("y2DomainDataset");
        var parseFormat = this.get("parseFormat") || null;

        /* set up lines in y1 and y2 groups */
        var y1Lines = d3.nest().key(function (d) {
            return d.name;
        }).entries(data[y1DomainDataset]);

        y1Lines.forEach(function (line) {
            line.values.forEach(function (segment) {
                if (parseFormat && _typeof(segment.date) !== "object") {
                    segment.date = parseFormat(segment.date);
                }
            });

            dataManager.set({
                name: line.key,
                series: line.values,
                group: y1DomainDataset,
                notIndexable: undefined,
                display: undefined,
                color: line.values && line.values[0] && line.values[0].color,
                lineStrokeWidth: line.values && line.values[0] && Utils.number.getValidValue(line.values[0].lineStrokeWidth, validLineStrokeWidths, defaultLineStrokeWidth)
            });
        });

        if (this.get("y2")) {
            var y2Lines = d3.nest().key(function (d) {
                return d.name;
            }).entries(data[y2DomainDataset]);

            y2Lines.forEach(function (line) {
                line.values.forEach(function (segment) {
                    if (parseFormat && _typeof(segment.date) !== "object") {
                        segment.date = parseFormat(segment.date);
                    }
                });

                dataManager.set({
                    name: line.key,
                    series: line.values,
                    group: y2DomainDataset,
                    notIndexable: undefined,
                    display: undefined,
                    color: line.values && line.values[0] && line.values[0].color,
                    lineStrokeWidth: line.values && line.values[0] && Utils.number.getValidValue(line.values[0].lineStrokeWidth, validLineStrokeWidths, defaultLineStrokeWidth)
                });
            });
        }

        this.setParsers();
    },
    /**
     * @method checkForDataIslands
     * @param {Array} data
     * @param {String} yAxis
     * @desc Determine if dataset includes any datapoints surrounded by null or undefined values
     * @return undefined
     */
    checkForDataIslands: function checkForDataIslands(data, yAxis) {
        var hasIslands = false;
        var indexes = [];
        var vals = data[0].series;
        for (var i = 0; i < vals.length; i++) {
            var lastVal = vals[i - 1] ? vals[i - 1].value : null,
                // vals[0-1] === undefined
            nextVal = vals[i + 1] ? vals[i + 1].value : null; // vals[(vals.length-1)+1] === undefined
            if (vals[i].value != null && lastVal == null && nextVal == null) {
                indexes.push(i);
                hasIslands = true;
            }
        }

        if (hasIslands) {
            this.drawIslandBubbles(data, indexes, yAxis);
        }
    },
    /**
     * @method drawIslandBubbles
     * @param {Array} data
     * @param {Array} indexes
     * @param {String} yAxis
     * @desc Render bubble dots for datapoints that are islands, i.e., surrounded by null or undefined values
     * @return undefined
     */
    drawIslandBubbles: function drawIslandBubbles(data, indexes, yAxis) {

        var _this = this;
        var scales = this.get("scales");
        var xScale = scales.scale("x");
        var yScale = scales.scale(yAxis);
        var canvas = this.get("canvas");
        var layer = canvas.layer("line-chart-layer");
        var dottedLines = this.get('dottedLines');
        var agileStyle = this.get("agileStyle");
        var bubbles;

        data.forEach(function (item) {
            bubbles = layer.selectAll("circle").filter("." + item.groupName + "_" + item.groupIndex).data(item.series);
            bubbles.attr("class", item.groupName + "_" + item.groupIndex + " bubble").attr("cx", function (d) {
                return xScale(d.date);
            }).attr("cy", function (d, i) {
                return yScale(d.value) - 1;
            }).attr("r", agileStyle.bubbleRadius).attr("stroke", _this.color(item.index)).attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", function () {
                return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : _this.color(item.index);
            }).attr("opacity", function (d, i) {
                if (indexes.indexOf(i) > -1) {
                    return 1;
                } else {
                    return 0;
                }
            });

            bubbles.enter().append('circle').attr("class", item.groupName + "_" + item.groupIndex + " bubble").attr("cx", function (d) {
                return xScale(d.date);
            }).attr("cy", function (d, i) {
                return yScale(d.value) - 1;
            }).attr("r", agileStyle.bubbleRadius).attr("stroke", item.color || _this.color(item.index)).attr("stroke-width", item.lineStrokeWidth || agileStyle.lineStrokeWidth).attr("fill", function () {
                return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : item.color || _this.color(item.index);
            }).attr("opacity", function (d, i) {
                if (indexes.indexOf(i) > -1) {
                    return 1;
                } else {
                    return 0;
                }
            });

            bubbles.exit().remove();
        });
    },

    /**
     * @method setParsers
     * @desc Set default or user-specific parsers for datasets
     * @example
     * chart.setParsers()
     *
     *
     * @return undefined
     */
    setParsers: function setParsers() {
        var dataManager = this.get("data");
        var y1DomainDataset = this.get("y1DomainDataset");
        var y2DomainDataset = this.get("y2DomainDataset");
        var parseFormat = this.get("parseFormat") || null;
        var y1Parser = this.get("y1Parser");
        var y2Parser = this.get("y2Parser");
        var useDefaultParsers = this.get("useDefaultParsers");
        var y2 = this.get("y2");

        var defaultParser = function defaultParser(data) {

            var map = data.map(function (line) {
                line.series.forEach(function (segment) {
                    if (parseFormat && _typeof(segment.date) !== "object") {
                        segment.date = parseFormat(segment.date);
                    }
                });

                var sorted = line.series.sort(function (a, b) {
                    return a.date - b.date;
                });

                line.series = sorted;
                return line;
            });

            return map;
        };

        if (useDefaultParsers) {
            dataManager.parser(y1DomainDataset, defaultParser);
            dataManager.parser(y2DomainDataset, defaultParser);
        }

        if (y1Parser && !useDefaultParsers) {
            dataManager.parser(y1DomainDataset, y1Parser.bind(this));
        }

        if (y2 && y2Parser && !useDefaultParsers) {
            dataManager.parser(y2DomainDataset, y2Parser.bind(this));
        }
    },

    /**
     * @override
     * Set the tickSize, axesSpacing, padding, and margin
     */
    beforeDraw: function beforeDraw() {
        this.redoCanvas();
        this.checkBreakpoints();
        var canvas = this.get("canvas");
        var y1LabelText = this.get("y1AxisLabel");
        var y2LabelText = this.get("y2AxisLabel");
        var yAxesLabelWidth = this.get("yAxesLabelWidth");
        var xTicks = this.get("xTicks");
        var xTickFormat = this.get("xTickFormat");
        var smallScreen = canvas.get("outerWidth") <= this.get("breakpoint");

        if (!y1LabelText && !y2LabelText) {
            canvas.set("yAxesLabelWidth", 0);
        } else {
            canvas.set("yAxesLabelWidth", yAxesLabelWidth);
        }

        canvas.set("tickSize", this.get("yTickSize"));
        canvas.set("axesSpacing", this.get("yAxesSpacing"));
        canvas.set("margin", this.getMargins());

        if (!this.get("y2")) {
            this.get("axes").remove("y2");
        }

        if (smallScreen) {
            this.set("yPadding", this.get("yPaddingSmall"));
        } else {
            this.set("yPadding", this.get("yPaddingBig"));
        }

        // xTicks Legacy
        if (xTicks) {
            this.set("_xTicks", xTicks); // Private variable
        } else {
            if (!this.get("timelineLevel")) {
                this.set("timelineLevel", "year");
            }

            this.helperSetTicks(smallScreen);
        }

        if (!xTickFormat && !xTicks) {
            this.set("_xTickFormat", d3.time.format("%Y"));
        }

        if (!xTickFormat && this.get("timelineLevel")) {
            this.set("_xTickFormat", d3.time.format("%b %e"));
        } else {
            this.set("_xTickFormat", xTickFormat);
        }

        if (this.get("legend")) {
            this.invokeLegend({
                chart: "time-series",
                data: this.get('data')._data,
                mouseover: false
            });
        }
    },

    /**
     * @override
     * Visual adjustments after the chart has been rendered
     */
    afterDraw: function afterDraw(options) {
        var canvas = this.get("canvas");
        var axes = canvas.get("axesGroup");
        var noTicksRecalc = options && options.noTicksRecalc;
        var tinyScreen = canvas.get("outerWidth") <= this.get("smallBreakpoint");
        var xSubLabels = this.get("xSubLabels");
        var xOriginalTicks, lastTick;
        var showLegend = this.get("legend");

        this.adjustYLabels();

        var xTicks = axes.selectAll("." + Classes.AXIS + "-x text");

        xTicks.style("text-anchor", "start");

        if (showLegend) {
            canvas.watch("outerWidth", function (newValue, oldValue) {
                this.checkBreakpoints(newValue, oldValue);
            }.bind(this));
        }

        if (!noTicksRecalc) {
            this.updateTickWidths();
        }
        if (this.get("timelineLevel") && this.get("firstTickDate")) {
            this.helperAddFirstLabel(canvas);
        }

        if (Array.isArray(xSubLabels) && xSubLabels.length || this.get("timelineLevel")) {
            this.appendAxisSubLabels();
        }

        lastTick = axes.select("." + Classes.AXIS + "-x g.tick.last");
        if (tinyScreen) {
            xOriginalTicks = axes.selectAll("." + Classes.AXIS + "-x g.tick").filter(function () {
                return !d3.select(this).classed("artificial");
            });

            xOriginalTicks.style("opacity", 0);
            lastTick.style("display", "inline");
        } else {
            lastTick.style("display", "none");
        }

        this.renderToolTip();

        if (this.get("legend")) {
            this.adjustLegendHeight();
        }
    },

    /**
     * @method appendAxisSubLabels
     * @desc Appends axis Sub Labels
     */
    appendAxisSubLabels: function appendAxisSubLabels() {
        var canvas = this.get("canvas");
        var axes = canvas.get("axesGroup");
        var xAxis = axes.selectAll("." + Classes.AXIS + "-x g.tick");
        var xSubLabels = this.get("xSubLabels");
        var xAxisOrient = this.get("xAxisOrient");
        var chartID = this.get('UID');

        d3.selectAll("." + chartID + " .mbc-axis.mbc-axis-x g.tick").each(function () {
            if (!d3.select(this).classed("artificial")) {
                d3.select(this).select(".mbc-tick-abbreviation").remove();
            }
        });
        xAxis[0].forEach(function (tick, idx) {
            if (xSubLabels[idx]) {
                d3.select(tick).append("text").text(function () {
                    return xSubLabels[idx];
                }).attr("transform", function () {
                    var y = xAxisOrient === "bottom" ? 28 : -18;
                    return "translate(0, " + y + ")";
                }).attr("class", "mbc-tick-abbreviation");
            }
        });
    },

    /**
     * @method updateTickWidths
     * @desc calculate and update the y axis tick width
     * @example
     *
     * chart.updateTickWidths()
     *
     *
     * @return undefined
     */
    updateTickWidths: function updateTickWidths() {
        var maxWidth = 0;
        var ticks = [];
        var el;
        var chartID = this.get('UID');

        d3.selectAll("." + chartID + " .mbc-axis.mbc-axis-y1 .tick text").each(function () {
            el = d3.select(this);
            ticks.push(el.text());
        });
        maxWidth = Utils.svg.getGreaterSVGTextWidth(this.get("canvas").get("svg"), ticks);
        this.set("yTickSize", maxWidth + this.get("yTickMargin"));
        this.set("ticksUpdated", true);
        this.update({ noTicksRecalc: true });
    },

    /**
     * @override
     * @method draw
     */
    draw: function draw() {
        this.buildScales();
        this.buildAxes();
        this.drawAxes();
        this.drawLines();
        this.drawBubbles();
        this.drawBackgroundBars();
        this.drawGrid();
        this.drawClipPath();

        if (this.get("timelineLevel")) {
            this.helperSetSublabels();
        }
    },

    /**
     * @method drawLines
     * @desc Graph the lines onto the chart for each dataset (y1 and y2 if used)
     * @example
     *
     * chart.drawLines()
     *
     * @return undefined
     */
    drawLines: function drawLines() {
        var _this = this;
        var dataManager = this.get("data");
        var scales = this.get("scales");
        var canvas = this.get("canvas");
        var layer = canvas.layer("line-chart-layer");
        var xScale = scales.scale("x");
        var yScale = scales.scale("y1");
        var y2Scale = scales.scale("y2");
        var isY2 = false;
        var dottedLines = this.get('dottedLines');
        var agileStyle = this.calculateAgileStyle();

        var generateLine = d3.svg.line().defined(function (d) {
            return d.value != null;
        }).x(function (d) {
            return xScale(d.date);
        }).y(function (d) {
            return isY2 === false ? yScale(d.value) - 1 : y2Scale(d.value) - 1; // compensate for line thickness
        }).interpolate("linear");

        var y1DomainDataset = this.get("y1DomainDataset");

        //clear old lines on update
        var y1Lines = layer.selectAll("path").filter(".y1").data(dataManager.get(y1DomainDataset));
        this.checkForDataIslands(dataManager.get(y1DomainDataset), "y1");

        y1Lines.classed({
            line: true,
            y1: true
        }).attr("d", function (d) {
            return generateLine(d.series);
        }).attr("stroke", function (d) {
            return _this.color(d.index);
        }).attr("stroke-dasharray", function (d) {
            return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
        }).attr("stroke-linecap", "round").attr("stroke-linejoin", "round").attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

        y1Lines.enter().append("path").classed({
            line: true,
            y1: true
        }).attr("d", function (d) {
            return generateLine(d.series);
        }).attr("stroke", function (d) {
            return d.color || _this.color(d.index);
        }).attr("stroke-dasharray", function (d) {
            return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
        }).attr("stroke-linecap", "round").attr("stroke-linejoin", "round").attr("stroke-width", function (d) {
            return d.lineStrokeWidth || agileStyle.lineStrokeWidth;
        }).attr("fill", "none");

        y1Lines.exit().remove();

        if (this.get("y2")) {
            isY2 = true;
            var y2DomainDataset = this.get("y2DomainDataset");
            var y2Lines = layer.selectAll("path").filter(".y2").data(dataManager.get(y2DomainDataset));

            this.checkForDataIslands(dataManager.get(y2DomainDataset), "y2");

            y2Lines.classed({
                line: true,
                y2: true
            }).attr("d", function (d) {
                return generateLine(d.series);
            }).attr("stroke", function (d) {
                return _this.color(d.index);
            }).attr("stroke-dasharray", function (d) {
                return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
            }).attr("stroke-linecap", "round").attr("stroke-linejoin", "round").attr("stroke-width", agileStyle.lineStrokeWidth).attr("fill", "none");

            y2Lines.enter().append("path").classed({
                line: true,
                y2: true
            }).attr("d", function (d) {
                return generateLine(d.series);
            }).attr("stroke", function (d) {
                return d.color || _this.color(d.index);
            }).attr("stroke-dasharray", function (d) {
                return dottedLines.indexOf(d.name) > -1 ? agileStyle.dottedDashDimensions : null;
            }).attr("stroke-linecap", "round").attr("stroke-linejoin", "round").attr("stroke-width", function (d) {
                return d.lineStrokeWidth || agileStyle.lineStrokeWidth;
            }).attr("fill", "none");

            y2Lines.exit().remove();
        }
    },

    /**
    * @method getLongestSeriesLength
    * @desc Compare data sets and length of series and return the longest array
    * @return {Number} the length of the longest series.
    */
    getLongestSeriesLength: function getLongestSeriesLength() {
        var length = 0;

        this.get("data")._data.forEach(function (a) {
            var seriesLength = a.series.length;
            length = seriesLength > length ? seriesLength : length;
        });

        return length;
    },

    /**
    * @method calculateAgileStyle
    * @desc Calculate agile style for chart based on container size
    * @return {Object} the agile style for chart.
    */
    calculateAgileStyle: function calculateAgileStyle() {
        var xScale = this.get("scales").scale("x");
        var xDomain = this.get("xDomain");
        var yPadding = this.get("yPadding");
        var bandLevel = this.get("greyBandLevel");
        var nodesLength = bandLevel ? this.helperGetBackgroundArray(xDomain, bandLevel).length : this.getLongestSeriesLength();
        var bubbleSpacing = (this.get("canvas").get('width') - yPadding) / nodesLength;
        var bubbleRadius = this.get("bubbleRadius"); // default: 4
        var lineStrokeWidth = this.get("lineStrokeWidth"); // default: 2
        var bubbleStrokeWidth = this.get("bubbleStrokeWidth"); // default: 2
        var dottedDashDimensions = this.get("dottedDashDimensions"); // default: "1 5"
        var showBigBubbleMinWidth = 2 * (bubbleRadius + 4); // 4px: dot marging
        var showSmallBubbleMinWidth = 2 * (bubbleRadius / 2 + 2); // 2px: dot marging
        var responsiveWeight = this.get("responsiveWeight"); // default true

        var agileStyle;
        if (bubbleSpacing >= showBigBubbleMinWidth || !responsiveWeight) {
            agileStyle = {
                dottedDashDimensions: dottedDashDimensions,
                lineStrokeWidth: lineStrokeWidth,
                bubbleRadius: bubbleRadius,
                bubbleStrokeWidth: bubbleStrokeWidth,
                bubbleHeight: bubbleRadius,
                bubbleOpacity: 1
            };
        } else if (bubbleSpacing >= showSmallBubbleMinWidth) {
            agileStyle = {
                dottedDashDimensions: "1 3",
                lineStrokeWidth: lineStrokeWidth / 2,
                bubbleRadius: bubbleRadius / 2,
                bubbleStrokeWidth: bubbleStrokeWidth / 2,
                bubbleHeight: bubbleRadius / 2,
                bubbleOpacity: 1
            };
        } else {
            agileStyle = {
                dottedDashDimensions: "1 3",
                lineStrokeWidth: lineStrokeWidth / 2,
                bubbleRadius: bubbleRadius / 2,
                bubbleStrokeWidth: bubbleStrokeWidth / 2,
                bubbleHeight: bubbleRadius / 2,
                bubbleOpacity: 0
            };
        }
        this.set("agileStyle", agileStyle);
        return agileStyle;
    },

    /**
     * @method drawBubbles
     * @desc Graph the bubbles onto the line for each dataset (y1 and y2 if used)
     * @example
     *
     * chart.drawBubbles()
     *
     * @return undefined
     */
    drawBubbles: function drawBubbles() {
        var dataManager = this.get("data");
        var scales = this.get("scales");
        var y1Bubbled = this.get("y1Bubbled");
        var y2Bubbled = this.get("y2Bubbled");

        if (y1Bubbled) {
            var y1DomainDataset = this.get("y1DomainDataset");
            var y1LinesData = dataManager.get(y1DomainDataset);
            var yScale = scales.scale("y1");
            this.generateBubbles(y1LinesData, yScale);
        }

        if (this.get("y2") && y2Bubbled) {
            var y2DomainDataset = this.get("y2DomainDataset");
            var y2LinesData = dataManager.get(y2DomainDataset);
            var y2Scale = scales.scale("y2");
            this.generateBubbles(y2LinesData, y2Scale);
        }
    },

    /**
     * @method generateBubbles
     * @param   {Object} linesData
     * @param   {Function} yScale
     * @desc Render the bubble dots for each datapoint
     * @return undefined
     */
    generateBubbles: function generateBubbles(linesData, yScale) {
        var _this = this;
        var scales = this.get("scales");
        var xScale = scales.scale("x");
        var canvas = this.get("canvas");
        var clipPathId = this.get("clipPathId", clipPathId);
        var layer = canvas.layer("line-chart-layer").attr("clip-path", "url(#" + clipPathId + ")");
        var dottedLines = this.get('dottedLines');
        var agileStyle = this.get('agileStyle');
        var bubbles;
        linesData.forEach(function (item) {
            bubbles = layer.selectAll("circle").filter("." + item.groupName + "_" + item.groupIndex).data(item.series);
            bubbles.attr("class", function (d) {
                return item.groupName + "_" + item.groupIndex + " bubble line-bubbles date" + d.date.getTime();
            }).attr("cx", function (d) {
                return xScale(d.date);
            }).attr("cy", function (d, i) {
                return yScale(d.value) - 1;
            }).attr("r", function (d) {
                return d.value == null ? 0 : agileStyle.bubbleRadius;
            }).attr("stroke", item.color || _this.color(item.index)).attr("stroke-width", agileStyle.bubbleStrokeWidth).attr("fill", function () {
                return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : item.color || _this.color(item.index);
            }).attr("opacity", function (d) {
                if (d.value == null || !agileStyle.bubbleOpacity) {
                    return 0;
                }
            });

            bubbles.enter().append('circle').attr("class", function (d) {
                return item.groupName + "_" + item.groupIndex + " bubble line-bubbles date" + d.date.getTime();
            }).attr("cx", function (d) {
                return xScale(d.date);
            }).attr("cy", function (d, i) {
                return yScale(d.value) - 1;
            }).attr("r", function (d) {
                return d.value == null ? 0 : agileStyle.bubbleRadius;
            }).attr("stroke", item.color || _this.color(item.index)).attr("stroke-width", agileStyle.bubbleStrokeWidth).attr("fill", function () {
                return dottedLines.indexOf(item.name) > -1 ? "#FFFFFF" : item.color || _this.color(item.index);
            }).attr("opacity", function (d) {
                if (d.value == null || !agileStyle.bubbleOpacity) {
                    return 0;
                }
            });

            bubbles.exit().remove();
        });
    },

    /**
     * @method drawAxes
     * @desc Call on the canvas to draw the axes and calls to build the labels
     * @example
     *
     * chart.drawAxes()
     *
     * @return undefined
     */
    drawAxes: function drawAxes() {
        var axes = this.get("axes");
        var canvas = this.get("canvas");

        canvas.drawAxes(axes);
        this.drawAxesLabels();
    },

    /**
     * @method drawAxesLabels
     * @desc Invoke the appendLabel method with the label text set in config and the correct axis layer
     *
     * chart.drawAxesLabels()
     *
     * @return undefined
     */
    drawAxesLabels: function drawAxesLabels() {
        var canvas = this.get("canvas");
        var y1LabelText = this.get("y1AxisLabel");
        var y2LabelText = this.get("y2AxisLabel");

        canvas.layer(Classes.AXES + "-labels").remove();

        var layer = canvas.layer(Classes.AXES + "-labels");
        var y1Orient = this.get("y1AxisOrient");
        var y2Orient = this.get("y2AxisOrient");
        var chartID = this.get('UID');

        var containerTop = d3.select("." + chartID + " .mbc-chart-legend.mbc-chart-legend-top");
        var oneRight = y1Orient === "right" && y2Orient !== "right" || y2Orient === "right" && y2Orient !== "right";
        var zeroRight = y1Orient !== "right" && y2Orient !== "right";
        var twoRight = y1Orient === "right" && y2Orient === "right";

        if (y1LabelText) {
            this.appendYLabel(layer, "y1", y1LabelText);
        }

        if (this.get("y2") && y2LabelText) {
            this.appendYLabel(layer, "y2", y2LabelText);
        }

        if (y1LabelText || y2LabelText) {
            if (zeroRight) {
                containerTop.style("margin-left", "20px");
            }
        } else {
            containerTop.style("margin-left", "0px");
        }

        if (oneRight || twoRight) {
            containerTop.style("margin-left", "6px");
        }
    },

    /**
     * @method drawGrid
     * @desc Draw the grid lines with the y axis ticks
     * @example
     *
     * chart.drawGrid()
     *
     * @return undefined
     */
    drawGrid: function drawGrid() {
        var scales = this.get("scales");
        var y1Scale = scales.scale("y1");
        var y1Axis = this.get("axes").axis("y1");
        var yPadding = this.get("yPadding");
        var canvas = this.get("canvas");
        var tickValues = y1Axis.tickValues();
        var backGroup = canvas.get("backGroup");
        var grid = backGroup.selectAll("." + Classes.GRID_LINE).data(tickValues);
        var isSmallHeight = this.get("canvas").height() <= this.get("screenMinHeight");

        var extractor = function extractor(d) {
            return y1Scale(d);
        };

        grid.enter().append("line").attrs({
            x1: yPadding,
            x2: canvas.width() - yPadding,
            y1: extractor,
            y2: extractor,
            class: function _class(d, i) {
                var appendClass = "";
                if (i === 0) {
                    appendClass = "first";
                }
                if (i === tickValues.length - 1) {
                    appendClass = "last";
                }
                return Classes.GRID_LINE + " " + appendClass;
            },
            opacity: function opacity(d, i) {
                // if container's height is small, only show first and last grid line
                return !isSmallHeight || i === 0 || i === tickValues.length - 1 ? 1 : 0;
            }
        });

        grid.attrs({
            x1: yPadding,
            x2: canvas.width() - yPadding,
            y1: extractor,
            y2: extractor,
            opacity: function opacity(d, i) {
                // if container's height is small, only show first and last grid line
                return !isSmallHeight || i === 0 || i === tickValues.length - 1 ? 1 : 0;
            }
        });

        grid.exit().remove();
    },

    /**
     * @method drawClipPath
     * @desc Chart svg includes clipping layer, clips lines and bubbles at edge of chart area
     * @example
     *
     * chart.drawClipPath()
     *
     * @return undefined
     */
    drawClipPath: function drawClipPath() {
        var canvas = this.get("canvas");
        var svg = canvas.get("svg");
        var layer = svg.select("." + Classes.BACK);
        var layerBBox = layer.node().getBBox();
        var clipPathId = this.get("clipPathId");
        svg.insert("defs", ":first-child").append("clipPath").attr("id", clipPathId).append("rect").attr({
            x: layerBBox.x,
            y: layerBBox.y,
            width: layerBBox.width,
            height: layerBBox.height
        });
    },

    /**
     * @method drawBackgroundBars
     * @desc Draw the alternating background bars that follow the x-axis ticks on the grid
     * @example
     *
     * chart.drawBackgroundBars()
     *
     * @return undefined
     */
    drawBackgroundBars: function drawBackgroundBars() {
        var scales = this.get("scales");
        var canvas = this.get("canvas");
        var backGroup = canvas.get("backGroup");
        var xScale = scales.scale("x");
        var xDomain = this.get("xDomain");
        var yPadding = this.get("yPadding");
        var bandLevel = this.get("greyBandLevel");
        var tickArr;

        if (bandLevel) {
            tickArr = this.helperGetBackgroundArray(xDomain, bandLevel);
        } else {
            tickArr = xScale.ticks.apply(this, this.get("_xTicks"));
        }

        var bars = backGroup.selectAll("rect").data(tickArr);
        var fnWidth = function fnWidth(d, i) {
            if (i + 1 === tickArr.length) {
                return canvas.width() - yPadding - xScale(tickArr[i]);
            } else {
                return xScale(tickArr[i + 1]) - xScale(tickArr[i]);
            }
        };

        // Update Selection
        bars.attrs({
            class: "grid__bars",
            x: xScale,
            y: 0,
            height: canvas.height(),
            width: fnWidth
        }).style("overflow", "hidden");

        // Enter Selection
        bars.enter().append("rect").attrs({
            class: "grid__bars",
            x: xScale,
            y: 0,
            height: canvas.height(),
            width: fnWidth
        }).style("overflow", "hidden");

        // Exit Selection
        bars.exit().remove();
    },

    /**
     * @method buildAxes
     * @desc Build all of the axes
     * @example
     *
     * chart.buildAxes()
     *
     * @return undefined
     */
    buildAxes: function buildAxes() {
        var _this = this;
        var scales = this.get("scales");
        var axes = this.get("axes");
        var calculatedTicksY1 = Utils.getTickValues(this.get("y1Domain"), this.get("ticksNumber"));
        var y1TickValues = this.get("y1TickValues") || this.get("tickValues") || calculatedTicksY1;
        var xScale = scales.scale("x");

        var tickFormat = function tickFormat(symbol, length, formatFn) {
            return function (d, i) {
                var value = _this.tickFormat(formatFn)(d);
                value = Utils.string.convertDashToEnDash(value);
                return symbol && i === length - 1 ? symbol + value : value;
            };
        };

        var xAxis = d3.svg.axis().scale(xScale).orient(this.get("xAxisOrient")).tickSize(this.get("xTickSize")).tickFormat(this.get("_xTickFormat")).ticks.apply(this, this.get("_xTicks"));

        var yAxis = d3.svg.axis().scale(scales.scale("y1")).orient(this.get("y1AxisOrient")).tickSize(this.get("yTickSize")).tickValues(y1TickValues).tickFormat(tickFormat(this.get("y1TickSymbol"), y1TickValues.length, this.get("y1TickFormat")));

        axes.axis("x", xAxis);
        axes.axis("y1", yAxis);

        if (this.get("y2")) {
            var calculatedTicksY2 = Utils.getTickValues(this.get("y2Domain"), this.get("ticksNumber"));
            var y2TickValues = this.get("y2TickValues") || this.get("tickValues") || calculatedTicksY2;

            axes.axis("y2", d3.svg.axis().scale(scales.scale("y2")).orient(this.get("y2AxisOrient")).tickSize(this.get("yTickSize")).tickValues(y2TickValues).tickFormat(tickFormat(this.get("y2TickSymbol"), y2TickValues.length, this.get("y2TickFormat"))));
        }
    },

    /**
     * @method buildScales
     * @desc Invoke the calculateDomain method and build all of the scales
     * @example
     *
     * chart.buildScales()
     *
     * @return undefined
     */
    buildScales: function buildScales() {
        this.calculateDomain();
        var scales = this.get("scales");
        var canvas = this.get("canvas");
        var yPadding = this.get("yPadding");

        var xScale = d3.time.scale().domain(this.get("xDomain")).rangeRound([yPadding, canvas.width() - yPadding - 1]);

        var y1TickValues = this.get("y1TickValues") || this.get("tickValues");
        var y1Domain = y1TickValues ? [d3.min(y1TickValues), d3.max(y1TickValues)] : this.get("y1Domain");
        var yScale = d3.scale.linear().domain(y1Domain).range([canvas.height(), 0]);

        scales.scale("x", xScale);
        scales.scale("y1", yScale);

        if (this.get("y2")) {
            var y2TickValues = this.get("y2TickValues") || this.get("tickValues");
            var y2Domain = y2TickValues ? [d3.min(y2TickValues), d3.max(y2TickValues)] : this.get("y2Domain");
            scales.scale("y2", d3.scale.linear().domain(y2Domain).range([canvas.height(), 0]));
        }
    },

    /**
     * @method calculateDomain
     * @desc Takes the values in the datasets and calculates the domain, setting them as:
     * y1Domain, y2Domain, xDomain
     *
     * @example
     *
     * chart.calculateDomain()
     *
     * @return undefined
     */
    calculateDomain: function calculateDomain() {
        var dataManager = this.get("data");
        var y1DomainDataset = this.get("y1DomainDataset");
        var y1 = dataManager.get(y1DomainDataset);
        var y1Symmetrical = this.get("y1Symmetrical");
        var y1DataSet = [];
        var xDataSet = [];

        y1.forEach(function (dataset) {
            dataset.series.forEach(function (segment) {
                xDataSet.push(segment.date);
                y1DataSet.push(segment.value);
            });
        });

        var adjustedY1Domain = this.adjustYDomain(y1DataSet, y1Symmetrical);
        this.set("y1Domain", adjustedY1Domain);

        if (this.get("y2")) {
            var y2DomainDataset = this.get("y2DomainDataset");
            var y2 = dataManager.get(y2DomainDataset);
            var y2Symmetrical = this.get("y2Symmetrical");
            var y2DataSet = [];

            y2.forEach(function (dataset) {
                dataset.series.forEach(function (segment) {
                    xDataSet.push(segment.date);
                    y2DataSet.push(segment.value);
                });
            });

            var adjustedY2Domain = this.adjustYDomain(y2DataSet, y2Symmetrical);
            this.set("y2Domain", adjustedY2Domain);
        }

        var adjustedXDomain = this.adjustXDomain(xDataSet);

        this.set("xDomain", adjustedXDomain);
    },

    /**
     * @method  adjustXDomain
     * @desc    Calculate and return a buffer for the x domain
     *
     * @example
     *      var adjustedY1Domain = this.adjustXDomain(dataset)
     * @param   {Object} dataset
     *
     * @return  {Array} extent
     */
    adjustXDomain: function adjustXDomain(dataset) {
        // add buffer spacing between datapoints and axix
        var xAxisStart = this.get("xAxisStart");
        var xAxisBuffer = this.get("xAxisBuffer");
        var xAxisEnd = this.get("xAxisEnd");
        var extent = d3.extent(dataset);

        if (this.get("xAxisStart")) {
            extent[0] = xAxisStart;
        }

        if (this.get("xAxisEnd")) {
            extent[1] = xAxisEnd;
        }

        if (!xAxisBuffer) {
            return extent;
        }

        if (xAxisBuffer.start) {
            extent[0] = this.helperXBuffer(extent[0], xAxisBuffer.start);
        }

        if (xAxisBuffer.end) {
            extent[1] = this.helperXBuffer(extent[1], xAxisBuffer.end);
        }

        return extent;
    },

    /**
     * @method  adjustYDomain
     * @desc    Calculate and return a buffer for the y domain
     *
     * @example
     *      var adjustedY1Domain = this.adjustYDomain(dataset)
     * @param   {Object} dataset
     *
     * @return  {Array} extent
     */
    adjustYDomain: function adjustYDomain(dataset, symmetrical) {
        // add buffer spacing between datapoints and axix
        var extent = d3.extent(dataset);
        var range = extent[1] - extent[0];
        var minMagnitude = this.getMagnitude(extent[0]);
        var maxMagnitude = this.getMagnitude(extent[1]);
        var setLowerBoundZero = extent[0] >= 0 && minMagnitude < maxMagnitude && range > Math.abs(extent[0]);
        var lowerBound = setLowerBoundZero ? 0 : Math.floor(extent[0] - range * 0.05);
        lowerBound = extent[0] < 0 && minMagnitude < maxMagnitude ? extent[0] : lowerBound;
        var adjusted = [lowerBound, Math.ceil(extent[1] + range * 0.05)];
        if (symmetrical) {
            return this.makeSymmetrical(adjusted);
        }

        return adjusted;
    },

    getMagnitude: function getMagnitude(number) {
        return Math.log(Math.abs(number)) * Math.LOG10E + 1 | 0;
    },

    /**
     * @method getMargins
     * @desc Calculate and return the margins for the chart
     *
     * @example
     *
     * var margins = chart.getMargins();
     * var leftMargin = margins.left;
     * @return {Object}
     */
    getMargins: function getMargins() {
        var y1AxisOrient = this.get("y1AxisOrient");
        var y2AxisOrient = this.get("y2AxisOrient");
        var yTickSize = this.get("yTickSize");
        var canvas = this.get("canvas");
        var yAxesLabelWidth = canvas.get("yAxesLabelWidth");
        var yAxesSpacing = this.get("yAxesSpacing");
        var margin = {
            top: 5,
            right: 0,
            bottom: 25,
            left: yTickSize + yAxesLabelWidth
        };

        if (this.get("y2")) {
            if (y1AxisOrient === "left" && y2AxisOrient === "left") {
                margin.left = (yTickSize + yAxesLabelWidth) * 2 + yAxesSpacing;
            } else if (y1AxisOrient === "right" && y2AxisOrient === "right") {
                margin.right = (yTickSize + yAxesLabelWidth) * 2 + yAxesSpacing;
                margin.left = 0;
            } else {
                margin.right = yTickSize + yAxesLabelWidth;
            }
        } else if (y1AxisOrient === "right") {
            margin.right = yTickSize + yAxesLabelWidth;
            margin.left = 0;
        }

        if (this.get("xAxisOrient") === "top") {
            margin.top = 30;
            margin.bottom = 0;
        } else {
            margin.top = 5;
            margin.bottom = this.get("xLabels") ? 45 : 35;
        }

        return margin;
    },

    /**
     * @method checkBreakpoints
     * @desc Checks if a set breakpoint has been met with the grid and invokes the
     * redoCanvas method if so
     * @param {Number} newValue
     * @param {Number} oldValue
     *
     * @example
     *  canvas.watch("outerWidth", function (newValue, oldValue) {
            this.checkBreakpoints(newValue, oldValue);
        }.bind(this));
      * @return undefined
     */
    checkBreakpoints: function checkBreakpoints(newValue, oldValue) {
        var dw = newValue > oldValue;
        var breakpoint = this.get("breakpoint");
        if (dw && oldValue <= breakpoint && newValue > breakpoint || !dw && oldValue > breakpoint && newValue <= breakpoint) {
            this.redoCanvas();
        }
    },

    /**
     * @method setCanvasTemplate
     * @desc set the canvas template which is used in beforeCanvas from grid core
     * @param {Number} width
     *
     * @example
     *
     *  this.setCanvasTemplate(selection[0][0].offsetWidth);
     * @return undefined
     */
    setCanvasTemplate: function setCanvasTemplate(width) {
        var template;
        if (this.get("legend")) {
            if (width > this.get("breakpoint")) {
                template = "<div class=\"" + Classes.INNER + " " + Classes.INNER + "-right\"></div>\n                    <div class=\"" + Classes.LEGEND + " " + Classes.LEGEND + "-right\"><div class=\"" + Classes.LEGEND + "-inner\"></div></div>";
            } else {
                template = "<div class=\"" + Classes.LEGEND + " " + Classes.LEGEND + "-top\"><div class=\"" + Classes.LEGEND + "-inner\"></div></div>\n                <div class=\"" + Classes.INNER + " " + Classes.INNER + "-top\"></div>";
            }
        }

        this.set("canvasTemplate", template);
    },

    /**
     * @method setClipPathId
     * @desc set clipPath ID which is used in beforeCanvas from grid core
     *
     * @example
     *
     *  this.setClipPathId
     * @return undefined
     */
    setClipPathId: function setClipPathId() {
        var id = Math.floor(Math.random() * 90000) + 10000;
        if (this.get('clipPathId') == null) {
            this.set("clipPathId", "mbc-time-series-clip-mask--" + id);
        }
    },

    // @IMPLEMENTED
    // Do something before canvas render.
    beforeCanvas: function beforeCanvas(selection) {
        this.setCanvasTemplate(selection[0][0].offsetWidth);
        this.setClipPathId();
    },

    /**
     * @method redoCanvas
     * @desc Removes the canvas, resets the template, and then re-renders the canvas
     *
     * @example
     *
     *  chart.redoCanvas
     * @return undefined
     */
    redoCanvas: function redoCanvas() {
        var canvas = this.get("canvas");
        canvas.remove();
        this.set("initialized", false);

        this.setCanvasTemplate();
        this._createCanvas();
    },

    /**
     * Reloads all the chart's data.
     * @param {Object} dataset Initial dataset object.
     */
    data: function data(dataset) {
        this.get("data").clean();
        this.setData(dataset);
        this.redoCanvas();
        this.update();
        return this;
    },

    /**
     * @method add
     * @description Add a series to the chart
      * @param {Object} series Object {name: <name of the series>, values: <Array of values for the series>}
     * @param {String} groupName - name of the dataset group
     * @example
     * chart.add({
     *      name: "Apple Inc.",
     *      values: [{}, {}]
     * })
     * @return {this}
     */
    add: function add(name, series, groupName) {
        this.get("data").set(name, series, groupName);

        this.redoCanvas();
        this.update();

        return this;
    },

    /**
     * @method remove
     * @description Removes a series from the chart.
     * @param {String} seriesName Name of the series to remove from the chart.
     * @return {this}
     */
    remove: function remove(seriesName) {
        this.get("data").remove(seriesName);
        this.redoCanvas();
        this.update();
        return this;
    }

});

module.exports = TimeSeriesLineChart;

/***/ })

/******/ });
});

/***/ }),
/* 242 */
/***/ (function(module) {

module.exports = JSON.parse("{\"saCard\":{\"type\":\"mwcPpSaCard\"},\"saData\":{\"type\":\"mwcPpSaData\"}}");

/***/ }),
/* 243 */
/***/ (function(module) {

module.exports = JSON.parse("{\"en\":{\"benchmark\":\"Benchmark\",\"benchmark1\":\"Benchmark 1\",\"benchmark2\":\"Benchmark 2\",\"chart\":\"Chart\",\"current\":\"Current\",\"currentPortfolio\":\"Current Portfolio\",\"investment\":\"Investment\",\"investment1\":\"Investment A\",\"investment2\":\"Investment B\",\"investment3\":\"Investment C\",\"unsupportedHoldings\":\"Unsupported holdings, this portfolio cannot be analysed\",\"portfolio\":\"Portfolio\",\"portfolio1\":\"Portfolio 1\",\"portfolio2\":\"Portfolio 2\",\"proposed\":\"Proposed\",\"proposedPortfolio\":\"Proposed Portfolio\",\"snapshot\":\"Snapshot\",\"table\":\"Table\",\"topMarketScenarios\":\"TOP MARKET SCENARIOS\",\"whatIfHappenOne\":\"What if a\",\"whatIfHappenTwo\":\"were to happen again?\"},\"es-MX\":{\"benchmark\":\"Referencia\",\"benchmark1\":\"Referencia 1\",\"benchmark2\":\"Referencia 2\",\"currentPortfolio\":\"Cartera actual\",\"proposedPortfolio\":\"Cartera propuesta\",\"chart\":\"Diagrama\",\"current\":\"Actual\",\"portfolio\":\"Cartera\",\"portfolio1\":\"Cartera 1\",\"portfolio2\":\"Cartera 2\",\"proposed\":\"Propuesto\",\"snapshot\":\"Instantánea\",\"table\":\"Tabla\",\"topMarketScenarios\":\"PRINCIPALES SITUACIONES DEL MERCADO\"}}");

/***/ }),
/* 244 */
/***/ (function(module) {

module.exports = JSON.parse("{\"portfolios\":null,\"riskModelId\":\"\",\"startValue\":100000,\"scenarioDescriptionType\":\"short\",\"tabsContent\":[{\"text\":\"snapshot\",\"id\":\"snapshot\",\"active\":true,\"show\":true},{\"text\":\"chart\",\"id\":\"chart\",\"active\":false,\"show\":true},{\"text\":\"table\",\"id\":\"table\",\"active\":false,\"show\":false}],\"timeSeriesLineChartSettings\":{\"colors\":[\"#1f55a5\",\"#ef7622\",\"#a50032\",\"#518428\",\"#f5c400\",\"#e5e5e5\"],\"legend\":true,\"y1AxisLabel\":\"\",\"y2AxisLabel\":\"\",\"y1AxisOrient\":\"left\",\"useDefaultParsers\":true,\"showLegendValues\":true,\"showToolTip\":true,\"timelineLevel\":\"month\"},\"showCustomScenarios\":false,\"showDefaultScenarios\":true,\"showMacroShockScenarios\":true,\"showMarketShockScenarios\":true,\"updateDataSourceOnSubscribe\":true}");

/***/ }),
/* 245 */
/***/ (function(module) {

module.exports = JSON.parse("{\"type\":\"mwcPpScenarioAnalysis\",\"settings\":{\"riskModelId\":\"morn-glb-ma-usd\"}}");

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(131);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var vue_custom_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(234);
/* harmony import */ var vue_custom_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(vue_custom_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _src_pp_scenario_analysis_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(132);






vue__WEBPACK_IMPORTED_MODULE_3___default.a.use(vue_custom_element__WEBPACK_IMPORTED_MODULE_4___default.a);
var customElement = vue__WEBPACK_IMPORTED_MODULE_3___default.a.customElement(_src_pp_scenario_analysis_vue__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].name, _src_pp_scenario_analysis_vue__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], {
  vueInstanceCreatedCallback: function vueInstanceCreatedCallback() {
    var _this = this;

    var vueInstance = this.getVueInstance();
    var exposeMethods;

    if (typeof vueInstance.exposeMethods === 'function') {
      exposeMethods = vueInstance.exposeMethods();
    } else {
      exposeMethods = vueInstance.exposeMethods;
    }

    if (Array.isArray(exposeMethods)) {
      exposeMethods.forEach(function (m) {
        if (typeof vueInstance[m] === 'function') {
          _this[m] = vueInstance[m];
        }
      });
    }
  }
});
/* harmony default export */ __webpack_exports__["default"] = (customElement);

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var inspectSource = __webpack_require__(172);

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(100);
var classof = __webpack_require__(173);

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(105).forEach;
var sloppyArrayMethod = __webpack_require__(250);

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = sloppyArrayMethod('forEach') ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(2);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !method || !fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var global = __webpack_require__(4);
var getBuiltIn = __webpack_require__(50);
var IS_PURE = __webpack_require__(44);
var DESCRIPTORS = __webpack_require__(13);
var NATIVE_SYMBOL = __webpack_require__(104);
var USE_SYMBOL_AS_UID = __webpack_require__(171);
var fails = __webpack_require__(2);
var has = __webpack_require__(8);
var isArray = __webpack_require__(48);
var isObject = __webpack_require__(9);
var anObject = __webpack_require__(10);
var toObject = __webpack_require__(16);
var toIndexedObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(34);
var createPropertyDescriptor = __webpack_require__(36);
var nativeObjectCreate = __webpack_require__(52);
var objectKeys = __webpack_require__(53);
var getOwnPropertyNamesModule = __webpack_require__(51);
var getOwnPropertyNamesExternal = __webpack_require__(255);
var getOwnPropertySymbolsModule = __webpack_require__(111);
var getOwnPropertyDescriptorModule = __webpack_require__(49);
var definePropertyModule = __webpack_require__(14);
var propertyIsEnumerableModule = __webpack_require__(108);
var createNonEnumerableProperty = __webpack_require__(11);
var redefine = __webpack_require__(26);
var shared = __webpack_require__(101);
var sharedKey = __webpack_require__(46);
var hiddenKeys = __webpack_require__(47);
var uid = __webpack_require__(103);
var wellKnownSymbol = __webpack_require__(1);
var wrappedWellKnownSymbolModule = __webpack_require__(182);
var defineWellKnownSymbol = __webpack_require__(183);
var setToStringTag = __webpack_require__(112);
var InternalStateModule = __webpack_require__(45);
var $forEach = __webpack_require__(105).forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = NATIVE_SYMBOL && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

if (!USE_SYMBOL_AS_UID) {
  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(50);
var getOwnPropertyNamesModule = __webpack_require__(51);
var getOwnPropertySymbolsModule = __webpack_require__(111);
var anObject = __webpack_require__(10);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(13);
var definePropertyModule = __webpack_require__(14);
var anObject = __webpack_require__(10);
var objectKeys = __webpack_require__(53);

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(50);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(22);
var nativeGetOwnPropertyNames = __webpack_require__(51).f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.github.io/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(13);
var global = __webpack_require__(4);
var has = __webpack_require__(8);
var isObject = __webpack_require__(9);
var defineProperty = __webpack_require__(14).f;
var copyConstructorProperties = __webpack_require__(177);

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(183);

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(187).IteratorPrototype;
var create = __webpack_require__(52);
var createPropertyDescriptor = __webpack_require__(36);
var setToStringTag = __webpack_require__(112);
var Iterators = __webpack_require__(39);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(2);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(190).charAt;
var InternalStateModule = __webpack_require__(45);
var defineIterator = __webpack_require__(186);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var DOMIterables = __webpack_require__(174);
var ArrayIteratorMethods = __webpack_require__(184);
var createNonEnumerableProperty = __webpack_require__(11);
var wellKnownSymbol = __webpack_require__(1);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var from = __webpack_require__(264);
var checkCorrectnessOfIteration = __webpack_require__(268);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(175);
var toObject = __webpack_require__(16);
var callWithSafeIterationClosing = __webpack_require__(265);
var isArrayIteratorMethod = __webpack_require__(266);
var toLength = __webpack_require__(20);
var createProperty = __webpack_require__(54);
var getIteratorMethod = __webpack_require__(267);

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var index = 0;
  var iteratorMethod = getIteratorMethod(O);
  var length, result, step, iterator, next;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      createProperty(result, index, mapping
        ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true)
        : step.value
      );
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
    }
  }
  result.length = index;
  return result;
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(1);
var Iterators = __webpack_require__(39);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(173);
var Iterators = __webpack_require__(39);
var wellKnownSymbol = __webpack_require__(1);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(1);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var isObject = __webpack_require__(9);
var isArray = __webpack_require__(48);
var toAbsoluteIndex = __webpack_require__(109);
var toLength = __webpack_require__(20);
var toIndexedObject = __webpack_require__(22);
var createProperty = __webpack_require__(54);
var arrayMethodHasSpeciesSupport = __webpack_require__(55);
var wellKnownSymbol = __webpack_require__(1);

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('slice') }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(50);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(10);

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(114),
    isArrayLike = __webpack_require__(29),
    keys = __webpack_require__(28);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(274),
    getMatchData = __webpack_require__(324),
    matchesStrictComparable = __webpack_require__(207);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(115),
    baseIsEqual = __webpack_require__(195);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 275 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(58);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(58);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(58);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(58);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(57);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 281 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 283 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(57),
    Map = __webpack_require__(116),
    MapCache = __webpack_require__(117);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(192),
    isMasked = __webpack_require__(288),
    isObject = __webpack_require__(21),
    toSource = __webpack_require__(194);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(41);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 287 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(289);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 290 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(292),
    ListCache = __webpack_require__(57),
    Map = __webpack_require__(116);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(293),
    hashDelete = __webpack_require__(294),
    hashGet = __webpack_require__(295),
    hashHas = __webpack_require__(296),
    hashSet = __webpack_require__(297);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(60);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(60);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(60);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(60);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(61);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 299 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(61);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(61);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(61);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(115),
    equalArrays = __webpack_require__(196),
    equalByTag = __webpack_require__(309),
    equalObjects = __webpack_require__(312),
    getTag = __webpack_require__(62),
    isArray = __webpack_require__(12),
    isBuffer = __webpack_require__(119),
    isTypedArray = __webpack_require__(204);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(117),
    setCacheAdd = __webpack_require__(305),
    setCacheHas = __webpack_require__(306);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 306 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 307 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 308 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(41),
    Uint8Array = __webpack_require__(197),
    eq = __webpack_require__(59),
    equalArrays = __webpack_require__(196),
    mapToArray = __webpack_require__(310),
    setToArray = __webpack_require__(311);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 310 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 311 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(198);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 313 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(40),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(40),
    isLength = __webpack_require__(122),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(125),
    nativeKeys = __webpack_require__(319);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(205);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(23),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(23),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(23),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(23),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(206),
    keys = __webpack_require__(28);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(195),
    get = __webpack_require__(326),
    hasIn = __webpack_require__(332),
    isKey = __webpack_require__(126),
    isStrictComparable = __webpack_require__(206),
    matchesStrictComparable = __webpack_require__(207),
    toKey = __webpack_require__(64);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(208);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(328);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(329);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(117);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(331);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(41),
    arrayMap = __webpack_require__(210),
    isArray = __webpack_require__(12),
    isSymbol = __webpack_require__(63);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(333),
    hasPath = __webpack_require__(334);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 333 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(209),
    isArguments = __webpack_require__(203),
    isArray = __webpack_require__(12),
    isIndex = __webpack_require__(121),
    isLength = __webpack_require__(122),
    toKey = __webpack_require__(64);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(336),
    basePropertyDeep = __webpack_require__(337),
    isKey = __webpack_require__(126),
    toKey = __webpack_require__(64);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 336 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(208);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(339),
    baseIteratee = __webpack_require__(114),
    toInteger = __webpack_require__(340);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 339 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(341);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(342);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(343),
    isObject = __webpack_require__(21),
    isSymbol = __webpack_require__(63);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(344);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(115),
    arrayEach = __webpack_require__(211),
    assignValue = __webpack_require__(212),
    baseAssign = __webpack_require__(346),
    baseAssignIn = __webpack_require__(347),
    cloneBuffer = __webpack_require__(350),
    copyArray = __webpack_require__(351),
    copySymbols = __webpack_require__(352),
    copySymbolsIn = __webpack_require__(353),
    getAllKeys = __webpack_require__(198),
    getAllKeysIn = __webpack_require__(354),
    getTag = __webpack_require__(62),
    initCloneArray = __webpack_require__(355),
    initCloneByTag = __webpack_require__(356),
    initCloneObject = __webpack_require__(361),
    isArray = __webpack_require__(12),
    isBuffer = __webpack_require__(119),
    isMap = __webpack_require__(363),
    isObject = __webpack_require__(21),
    isSet = __webpack_require__(365),
    keys = __webpack_require__(28),
    keysIn = __webpack_require__(66);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(42),
    keys = __webpack_require__(28);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(42),
    keysIn = __webpack_require__(66);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21),
    isPrototype = __webpack_require__(125),
    nativeKeysIn = __webpack_require__(349);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(15);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(120)(module)))

/***/ }),
/* 351 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(42),
    getSymbols = __webpack_require__(118);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(42),
    getSymbolsIn = __webpack_require__(215);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(199),
    getSymbolsIn = __webpack_require__(215),
    keysIn = __webpack_require__(66);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 355 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(127),
    cloneDataView = __webpack_require__(357),
    cloneRegExp = __webpack_require__(358),
    cloneSymbol = __webpack_require__(359),
    cloneTypedArray = __webpack_require__(360);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(127);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(41);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(127);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(362),
    getPrototype = __webpack_require__(216),
    isPrototype = __webpack_require__(125);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(364),
    baseUnary = __webpack_require__(123),
    nodeUtil = __webpack_require__(124);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(62),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(366),
    baseUnary = __webpack_require__(123),
    nodeUtil = __webpack_require__(124);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(62),
    isObjectLike = __webpack_require__(24);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(211),
    baseEach = __webpack_require__(217),
    castFunction = __webpack_require__(372),
    isArray = __webpack_require__(12);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(369),
    keys = __webpack_require__(28);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(370);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(29);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(65);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(217),
    isArrayLike = __webpack_require__(29);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
var setPrototypeOf = __webpack_require__(189);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(5);
var assign = __webpack_require__(376);

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(13);
var fails = __webpack_require__(2);
var objectKeys = __webpack_require__(53);
var getOwnPropertySymbolsModule = __webpack_require__(111);
var propertyIsEnumerableModule = __webpack_require__(108);
var toObject = __webpack_require__(16);
var IndexedObject = __webpack_require__(106);

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var toAbsoluteIndex = __webpack_require__(109);
var toInteger = __webpack_require__(38);
var toLength = __webpack_require__(20);
var toObject = __webpack_require__(16);
var arraySpeciesCreate = __webpack_require__(107);
var createProperty = __webpack_require__(54);
var arrayMethodHasSpeciesSupport = __webpack_require__(55);

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('splice') }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(221);
var anObject = __webpack_require__(10);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(20);
var toInteger = __webpack_require__(38);
var requireObjectCoercible = __webpack_require__(19);
var advanceStringIndex = __webpack_require__(222);
var regExpExec = __webpack_require__(223);

var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var $includes = __webpack_require__(180).includes;
var addToUnscopables = __webpack_require__(185);

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var notARegExp = __webpack_require__(381);
var requireObjectCoercible = __webpack_require__(19);
var correctIsRegExpLogic = __webpack_require__(382);

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__(225);

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(1);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(221);
var isRegExp = __webpack_require__(225);
var anObject = __webpack_require__(10);
var requireObjectCoercible = __webpack_require__(19);
var speciesConstructor = __webpack_require__(384);
var advanceStringIndex = __webpack_require__(222);
var toLength = __webpack_require__(20);
var callRegExpExec = __webpack_require__(223);
var regexpExec = __webpack_require__(56);
var fails = __webpack_require__(2);

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var aFunction = __webpack_require__(176);
var wellKnownSymbol = __webpack_require__(1);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var $trim = __webpack_require__(218).trim;
var forcedStringTrimMethod = __webpack_require__(386);

// `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(2);
var whitespaces = __webpack_require__(219);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(5);
var createHTML = __webpack_require__(388);
var forcedStringHTMLMethod = __webpack_require__(389);

// `String.prototype.bold` method
// https://tc39.github.io/ecma262/#sec-string.prototype.bold
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('bold') }, {
  bold: function bold() {
    return createHTML(this, 'b', '', '');
  }
});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(19);

var quot = /"/g;

// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
// https://tc39.github.io/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(2);

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(42),
    createAssigner = __webpack_require__(391),
    keysIn = __webpack_require__(66);

/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */
var assignIn = createAssigner(function(object, source) {
  copyObject(source, keysIn(source), object);
});

module.exports = assignIn;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(392),
    isIterateeCall = __webpack_require__(399);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(65),
    overRest = __webpack_require__(393),
    setToString = __webpack_require__(395);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(394);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 394 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(396),
    shortOut = __webpack_require__(398);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(397),
    defineProperty = __webpack_require__(214),
    identity = __webpack_require__(65);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(59),
    isArrayLike = __webpack_require__(29),
    isIndex = __webpack_require__(121),
    isObject = __webpack_require__(21);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(129));
	else {}
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 118);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(19);


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(99);

var _flag = __webpack_require__(59);

var _flag2 = _interopRequireDefault(_flag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _flag2.default;

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ToolTipConfig = function ToolTipConfig() {

    this._DEFAULT_CONFIG = {
        template: function template(d) {
            return "<div class='tooltip-inner'>" + d.value + "</div>";
        }
    };

    this._config = this._DEFAULT_CONFIG;
};

ToolTipConfig.prototype.configuration = function (v) {
    if (arguments.length === 0) {
        return this._config;
    }

    // Polyfill for ES6 assign method
    if (typeof Object.assign !== "function") {
        Object.assign = function (target) {
            /*jshint maxcomplexity:6 */
            if (target === null) {
                throw new TypeError("Cannot convert undefined or null to object");
            }

            target = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                var source = arguments[index];
                if (source !== null) {
                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key];
                        }
                    }
                }
            }

            return target;
        };
    }

    this._config = Object.assign({}, this._DEFAULT_CONFIG, v);
    return this;
};

ToolTipConfig.prototype.template = function (v) {
    if (arguments.length === 0) {
        return this._config.template;
    }

    this._config.template = v;

    return this;
};

var configuration = exports.configuration = new ToolTipConfig();

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getPositionTop(ttClientRect, canvas, mousePosition, position) {
    var tooFarLeft, tooFarRight, tooLow, tooHigh;
    tooFarRight = mousePosition[0] >= canvas.width() - ttClientRect.width / 2;
    tooFarLeft = mousePosition[0] < ttClientRect.width / 2;
    tooHigh = mousePosition[1] < ttClientRect.height;
    tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
    if (tooHigh && !tooFarLeft && tooFarRight) {
        position = "bottom-left";
    } else if (tooHigh && tooFarLeft && !tooFarRight) {
        position = "bottom-right";
    } else if (tooHigh) {
        position = "bottom";
    } else if (!tooFarLeft && tooFarRight) {
        position = "top-left";
    } else if (tooFarLeft && !tooFarRight) {
        position = "top-right";
    }

    return position;
}

function getPositionBottom(ttClientRect, canvas, mousePosition, position) {
    var tooFarLeft, tooFarRight, tooLow, tooHigh;
    tooFarRight = mousePosition[0] >= canvas.width() - ttClientRect.width / 2;
    tooFarLeft = mousePosition[0] < ttClientRect.width / 2;
    tooHigh = mousePosition[1] < ttClientRect.height;
    tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
    if (tooLow && !tooFarLeft && tooFarRight) {
        position = "top-left";
    } else if (tooLow && tooFarLeft && !tooFarRight) {
        position = "top-right";
    } else if (tooLow) {
        position = "top";
    } else if (!tooFarLeft && tooFarRight) {
        position = "bottom-left";
    } else if (tooFarLeft && !tooFarRight) {
        position = "bottom-right";
    }

    return position;
}

function getPositionTopRight(ttClientRect, canvas, mousePosition, position, isLine) {
    var tooFarLeft, tooFarRight, tooLow, tooHigh;
    var width = isLine ? ttClientRect.width * 2 : ttClientRect.width;
    tooFarRight = mousePosition[0] >= canvas.width() - width;
    tooFarLeft = mousePosition[0] < width;
    tooHigh = mousePosition[1] < ttClientRect.height;
    tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
    if (tooHigh && tooLow) {
        tooHigh = false;
    }
    if (tooHigh && !tooLow && !tooFarRight) {
        position = "bottom-right";
    } else if (tooHigh && !tooLow && tooFarRight) {
        position = "bottom-left";
    } else if (!tooHigh && tooFarRight) {
        position = "top-left";
    }

    return position;
}

function getRightTop(ttClientRect, canvas, mousePosition, position, isLine) {
    var tooFarRight, tooLow;
    var width = isLine ? ttClientRect.width * 2 : ttClientRect.width;
    tooFarRight = mousePosition[0] >= canvas.width() - width;
    tooLow = mousePosition[1] >= canvas.height() - ttClientRect.height;
    if (tooFarRight && tooLow) {
        position = "left-bottom";
    } else if (tooFarRight) {
        position = "left-top";
    } else if (tooLow) {
        position = "right-bottom";
    }

    return position;
}

/**
 * @method changeToolTipDirection
 * @desc Uses the coordinate information to decide how the tooltip should be positioned in the canvas. Determines top and bottom boundry when size of flag exceeds size of canvas.
 *
 * @return undefined
 **/
function changeToolTipDirection(ttClientRect, canvas, mousePosition, position) {
    var chartCanvas = canvas.get("svg").select(".mbc-front-group").node().getBoundingClientRect();

    var canvasWidth = chartCanvas.width; // Chart plotted width
    var canvasHeight = chartCanvas.height; // Chart plotted height

    var tooFarRight = ttClientRect && mousePosition[0] >= canvasWidth - ttClientRect.width; //Boolean for right canvas boundry
    var tooFarLeft = ttClientRect && mousePosition[0] < canvasWidth - ttClientRect.width; //Boolean for left canvas boundry
    var tooHigh = ttClientRect && mousePosition[1] <= ttClientRect.height; //Boolean for top canvas boundry
    var tooLow = ttClientRect && mousePosition[1] >= canvasHeight - ttClientRect.height; //Boolean for bottom canvas boundry

    var windowHeight = window.innerHeight; // Window/viewport height to use for bottom boundry
    var viewportMousePositionY = d3.event.clientY; // Y mouse position relative to window/viewport
    var exceedsViewportTop = ttClientRect && ttClientRect.height - mousePosition[1] > chartCanvas.top; //Boolean check if tooltip exceeds beyond viewport top
    var exceedsViewportBottom = ttClientRect && viewportMousePositionY + ttClientRect.height > windowHeight; //Boolean check if tooltip exceeds beyond viewport bottom

    // If flag exceeds top and bottom of canvas, then check collision with viewport viewport
    if (tooHigh && tooLow) {

        // Check collision to viewport, default to display flag down if conditions both fail
        tooHigh = !exceedsViewportTop && exceedsViewportBottom ? false : true;
        tooLow = !exceedsViewportTop && exceedsViewportBottom ? true : false;
    }

    // If flag exceeds neither the top or bottom of canvas default the position
    if (!tooHigh && !tooLow) {
        tooLow = true;
    }

    if (tooFarRight && tooLow) {
        position = "left-bottom";
    }

    if (tooFarLeft && tooLow) {
        position = "right-bottom";
    }

    if (tooFarRight && tooHigh) {
        position = "left-top";
    }

    if (tooFarLeft && tooHigh) {
        position = "right-top";
    }

    return position;
};

module.exports = {
    top: getPositionTop,
    bottom: getPositionBottom,
    topRight: getPositionTopRight,
    rightTop: getRightTop,
    setPosition: changeToolTipDirection
};

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _mbcCore = __webpack_require__(0);

var _mbcCore2 = _interopRequireDefault(_mbcCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configuration = __webpack_require__(57).configuration;
var positioning = __webpack_require__(58);

var Classes = _mbcCore2.default.Classes;
var Utils = _mbcCore2.default.Utils;

/**
 * D3 tooltip plugin
 * Modification of https://github.com/roncr/d3-tooltip-box
 * @class Tooltip
 */
var ToolTip = function ToolTip(options) {

    options = options || {};
    this.__OPTIONS = options;
    this._tooltipMap = {
        top: { top: true },
        "top-left": { top: true, "top-left": true },
        "top-right": { top: true, "top-right": true },
        bottom: { bottom: true },
        "bottom-left": { bottom: true, "bottom-left": true },
        "bottom-right": { bottom: true, "bottom-right": true },
        left: { left: true },
        "left-top": { left: true, "left-top": true },
        "left-bottom": { left: true, "left-bottom": true },
        right: { right: true },
        "right-top": { right: true, "right-top": true },
        "right-bottom": { right: true, "right-bottom": true }
    };

    var defaultOptions = {
        position: "top-right",
        delay: 250,
        transitionDuration: 20,
        opacity: 0.95,
        transition: true
    };

    Utils.object.copy(defaultOptions, options);

    this._options = defaultOptions;

    // Constants
    this._DEFAULT_POSITION_OFFSET = { top: 0, left: 0 };

    // Variables
    this._tooltipClass = Classes.TOOLTIP_CONTAINER;
    this._parent = d3.select("body");
    this._dataAccessor = function (d) {
        return d;
    };

    this._template = configuration.template();
    this._positionOffset = this._DEFAULT_POSITION_OFFSET;
};

/**
 * Initializes the tooltip container, if there is already
 * a container, reuses the same tooltip, otherwise creates
 * a new <div> container
 * @returns {d3.selection} tooltip container
 * @private
 */
ToolTip.prototype._initTooltip = function () {
    var tooltipEl = d3.select("." + this._tooltipClass);
    if (tooltipEl.empty()) {
        tooltipEl = this._createTooltip(this._options);
    }

    return tooltipEl;
};

/**
 * Creates a new <div> as the container of the tooltip
 * @returns {d3.selection} new tooltip container
 * @private
 */
ToolTip.prototype._createTooltip = function (options) {
    var positionClass = this._tooltipMap[options.position];
    var tooltip = this.parent().append("div").attr("class", this._tooltipClass).classed("tooltip", true).classed(positionClass).style('display', 'none').classed("in", true).classed("fade", true);

    if (this._options && this._options.namespace && typeof this._options.namespace === "string") {
        tooltip.classed(this._options.namespace + "-tooltip", true);
    }

    return tooltip;
};

/**
 * Gets the content of the tooltip by either
 * compiling a static template or invoking the
 * function of a dynamic template
 * @param d the associated data
 * @returns {ELEMENT_NODE} content of the tooltip as HTML
 * @private
 */
ToolTip.prototype._getContent = function (d) {
    var template = this._template;

    var compileTemplate = function compileTemplate(template, data) {
        for (var prop in data) {
            var regex = new RegExp("\\@\\{" + prop + "}", "gi");
            template = template.replace(regex, data[prop]);
        }

        return template;
    };

    if (typeof template === "function") {
        return template(d);
    } else {
        var data = this._dataAccessor(d);
        return compileTemplate(template, data);
    }
};

/**
 * Parent getter/setter
 * @param v the parent to set
 * @returns {d3.selection} the current parent (returned only if
 * invoked with no parameters)
 */
ToolTip.prototype.parent = function (v) {

    var isD3Selection = function isD3Selection(obj) {
        return obj instanceof d3.selection;
    };

    if (arguments.length === 0) {
        return this._parent;
    }

    if (!isD3Selection(v)) {
        v = d3.select(v);
    }

    this._parent = v;
    return this;
};

/**
 * Position offset getter/setter, the offset must
 * be in the shape of {left: 0, top: 0}
 * @param v the offset to set
 * @returns {Object} current offset (returned only if invoked with
 * not parameters)
 */
ToolTip.prototype.positionOffset = function (v) {
    if (arguments.length === 0) {
        return this._positionOffset;
    }

    this._positionOffset = {};
    Utils.object.copy(this._positionOffset, this._DEFAULT_POSITION_OFFSET, v);
    return this;
};

/**
 * Data accessor getter/setter
 * @param v the accessor function to set
 * @returns {Function} the current accessor function (returned only if
 * invoked with no parameters)
 */
ToolTip.prototype.data = function (v) {
    if (arguments.length === 0) {
        return this._dataAccessor;
    }

    this._dataAccessor = v;
    return this;
};

/**
 * Template getter/setter
 * @param v the template to set, if string it is considered
 * static template, if function it is considered dynamic template
 * and will be invoked with the associated data as parameter
 * @returns {*} the current template string or factory function
 * (returned only if invoked with no parameters)
 */
ToolTip.prototype.template = function (v) {
    if (arguments.length === 0) {
        return this._template;
    }

    this._template = v;
    return this;
};

/**
 * Makes the tooltip visible
 * @param d the associated data of the selection
 */
ToolTip.prototype.show = function (d, changes) {
    var html, options;

    if (changes) {
        var defaultOptions = { position: "top-right" };
        Utils.object.copy(defaultOptions, changes);
        if (changes.isStyleMap && changes.tooltipType === "tooltipObjectCentroid") {
            this._options.position = changes.position;
            this._options.transition = null;
        } else {
            this._options = defaultOptions;
        }
    }

    if (!this._tooltipEl) {
        this._tooltipEl = this._initTooltip();
    }

    options = this._options;

    if (!this._disabled) {
        html = this._getContent(d);

        if (html !== null && typeof html !== "undefined") {
            html += "<div class='tooltip-arrow'></div>";
            this._tooltipEl.html(html);
            if (options.transition) {
                this._tooltipEl.style({
                    opacity: 0,
                    display: "inline-block"
                }).transition().duration(options.transitionDuration).delay(options.delay).style({
                    opacity: options.opacity
                });
            } else {
                this._tooltipEl.style({
                    opacity: options.opacity,
                    display: "inline-block"
                });
            }
        }
    }
};

ToolTip.prototype.disabled = function (disabled) {
    this._disabled = disabled;
};

// This method calculates the flag positioning inside the chart canvas based on its initial position.
function calcPosition(tooltip, canvas, position, mousePosition, isLine) {
    var ttClientRect = tooltip.node().getBoundingClientRect();
    return positioning.setPosition(ttClientRect, canvas, mousePosition, position);;
}

/**
 * Moves the tooltip to the mouse position
 */
ToolTip.prototype.move = function (d, mousePosition) {

    // If the tooltip is not shown already, show it
    if (!this._tooltipEl) this.show(d);

    var autoposition = this._options.autoposition;
    var _this = this;
    var positionClass;
    var isLine = _this.__OPTIONS.chart === "line";
    var isTimeSeries = _this.__OPTIONS.chart === "time-series";

    var getOffset = function getOffset(ctx) {
        var tooltipEl = ctx._tooltipEl;
        var clientRect = tooltipEl.node().getBoundingClientRect();
        var height = clientRect.height;
        var width = clientRect.width;
        var position = ctx._options.position;
        var top = 0;
        var left = 0;

        // Note this if block is unreachable because autoposition is never set anywhere
        if (autoposition) {
            position = calcPosition(tooltipEl, autoposition, position, mousePosition, isLine);
        }

        positionClass = ctx._tooltipMap[position];

        tooltipEl.classed({
            top: false,
            "top-left": false,
            "top-right": false,
            bottom: false,
            "bottom-left": false,
            "bottom-right": false,
            left: false,
            "left-top": false,
            "left-bottom": false,
            right: false,
            "right-top": false,
            "right-bottom": false
        }).classed(positionClass);

        switch (position) {
            case "top":
                top = height;
                left = width / 2;
                break;

            case "top-left":
                top = height;
                left = width;
                break;

            case "top-right":
                top = height;
                break;

            case "bottom":
                left = width / 2;
                top = -10;
                break;

            case "bottom-left":
                left = width;
                top = -10;
                break;

            case "bottom-right":
                top = -10;
                break;

            case "left":
                top = height / 2;
                left = width;
                break;

            case "left-top":
                left = width;
                break;

            case "left-bottom":
                left = width;
                top = height;
                break;

            case "right":
                top = height / 2;
                left = -5;
                break;

            case "right-top":
                left = -5;
                break;

            case "right-bottom":
                left = -5;
                top = height;
                break;

            default:
                break;
        }

        return { top: top, left: left };
    };

    var clientRect = _this._tooltipEl.node().getBoundingClientRect();

    _this._clientRect = clientRect;
    _this._positionOffset = getOffset(_this);

    if (isLine) {
        var select = document.querySelector(".mbc-line-chart-tooltip");
        var mouse = d3.mouse(select);
        var closestLine = _this.getCalculation();
        var zoneWidth = _this.__OPTIONS.flagZoneWidth;
    }

    var formatPx = function formatPx(value) {
        return value + "px";
    };
    var padding = -5;

    if (_this.hasPositionLeft(positionClass)) {
        padding = clientRect.width + 5;
    }

    if (isTimeSeries) {
        var closestLine = _this._options.hoverLeft - _this._positionOffset.left;
        padding = 3;
    }

    _this._tooltipEl.style({
        position: "absolute",
        left: isLine || isTimeSeries ? formatPx(closestLine - padding) : formatPx(d3.event.pageX - _this._positionOffset.left),
        top: formatPx(d3.event.pageY - _this._positionOffset.top)
    });
};

ToolTip.prototype.hasPositionLeft = function (pos) {
    return pos.hasOwnProperty("top-left") || pos.hasOwnProperty("bottom-left") || pos.hasOwnProperty("left-top") || pos.hasOwnProperty("left-bottom");
};

ToolTip.prototype.getCalculation = function () {
    var isTimeSeries = this.__OPTIONS.chart === "time-series";
    var select = document.querySelector("body");
    var lines = Array.prototype.slice.call(document.querySelectorAll(".mouse-line")).map(function (line) {
        return line.getBoundingClientRect().left;
    });

    var position;
    var mouse = d3.mouse(select)[0];

    var zoneWidth = this.__OPTIONS.flagZoneWidth;
    var canvasWidth = this.__OPTIONS.canvasWidth;
    var zones = Math.round(canvasWidth / zoneWidth);
    var findRange = function findRange() {
        var w = Math.floor(zoneWidth / 2);
        lines.forEach(function (line, idx) {
            if (mouse >= line - w && mouse <= line + w) {
                position = line;
                return false;
            }
        });
    };

    findRange();

    return position;
};

/**
 * Hides the tooltip
 */
ToolTip.prototype.hide = function () {
    if (this._tooltipEl) {
        this._tooltipEl.transition();
    }

    var container = d3.select(".mbc-chart-tooltip-container");
    container.remove();
    this._tooltipEl = null;
};

/**
 * Attaches the tooltip event listeners to
 * the current selection
 * @returns {Function} function to be used for the
 * d3.selection.call method
 */
ToolTip.prototype.bind = function () {
    var _this = this;

    return function (selection) {
        selection.each(function () {
            var element = d3.select(this);

            element.on("mousemove.tooltip-container", function (d) {
                return _this.move(d, d3.mouse(this));
            }).on("mousewheel.tooltip-container", function () {
                return _this.hide();
            }).on("mouseout.tooltip-container", function () {
                return _this.hide();
            });
        });
    };
};

/**
 * Tooltip factory, creates new instances of the tooltip
 * @returns {Tooltip} the new tooltip instance
 */
function create(options) {
    var instance = new ToolTip(options);
    return instance;
}

module.exports = create;

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });
});

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(129));
	else {}
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 121);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNTAwIDE1MDAiPjxwYXRoIGQ9Ik02OTguNSA3OTguNWgxMDB2LTEwMGgtMTAwdjEwMHptLTMwMCAwaDEwMHYtMTAwaC0xMDB2MTAwem0zNTAtODAwYy00MTAgMC03NTAgMzQwLTc1MCA3NTBzMzQwIDc1MCA3NTAgNzUwIDc1MC0zNDAgNzUwLTc1MC0zNDAtNzUwLTc1MC03NTB6bTAgMTQwMGMtMzYwIDAtNjUwLTI5MC02NTAtNjUwczI5MC02NTAgNjUwLTY1MCA2NTAgMjkwIDY1MCA2NTAtMjkwIDY1MC02NTAgNjUwem0yNTAtNjAwaDEwMHYtMTAwaC0xMDB2MTAweiIvPjwvc3ZnPjwhLS0gbW9ybmluZ3N0YXItZGVzaWduLXN5c3RlbSB2MS4xNi4xIC0tPg=="

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(22);


/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(102);

var _legend = __webpack_require__(68);

var _legend2 = _interopRequireDefault(_legend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _legend2.default;

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var core = __webpack_require__(0);
var Utils = core.Utils;

/**
 * @method addItemsSVG
 * Creates svg items within legend on right side of chart
 * Key and Item name
 */
function addItemsSVG(params) {
    var names = [];
    var items = params.items;
    var firstPass;
    var lineHeight = 17;
    var keyPadding = 5;
    var linePadding = 3;
    var timeSeriesLinePadding = 13;
    var scatterplotYBuffer = 10;
    var timeSeriesNoValueLinePadding = 8;
    var defaultLineStrokeWidth = 2;
    var wrapVars = {
        params: params,
        container: params.container,
        names: names,
        firstPass: firstPass
    };
    var rangeLength = items.length * lineHeight + keyPadding; //line height + padding
    var y = d3.scale.linear().range([0, rangeLength]);

    var isLineChart = function isLineChart() {
        return params.chartType === 'lineChart';
    };
    var isTimeSeries = function isTimeSeries() {
        return params.chartType === 'time-series';
    };
    var isScatterPlot = function isScatterPlot() {
        return params.chartType === 'scatterplot';
    };
    var isBubbleChart = function isBubbleChart() {
        return params.chartType === 'bubbleChart';
    };
    var isBenchmark = function isBenchmark(d) {
        return d.groupName === params.benchmarksDataSource;
    };
    var isBenchmarkFirst = function isBenchmarkFirst(d) {
        return d.index === -1 && params.showBenchmark;
    };

    items.selectAll("*").remove();
    items.enter().append("g").attr("class", function (d) {
        return d.name ? Utils.string.dashify(d.name) : Utils.string.dashify(d.displayName);
    }).classed("legend-item", true);

    if (isTimeSeries()) {
        var additionalHeightConfigs = { 2: 0, 4: 2, 6: 4 };
        var additionalHeightForTopItem = 1; // Some oddity with the top legend item alignment
        var legendValuesFormat = Utils.string.convertDashToEnDash(params.legendValuesFormat);
        items.append("text").attr("class", function (d, i) {
            return "mbc-time-series_dataKey";
        }).attr("x", 0).text(function (d) {
            return d.displayName;
        }).call(wrap, wrapVars).attr("y", function (d, i) {
            var lineStrokeWidth = d.lineStrokeWidth || defaultLineStrokeWidth;
            var additionalHeight = lineStrokeWidth - additionalHeightConfigs[lineStrokeWidth];
            var yValue = y(i) + lineHeight + lineHeight * i;
            yValue = yValue + keyPadding * i;
            if (items[0][i - 1]) {
                var valueLine = params.legendShowValue ? linePadding / 2 * lineHeight : 5.5;
                yValue = getElementY(items[0][i - 1], 0) + getNumTspan(items[0][i - 1], params.chartType) * lineHeight + timeSeriesLinePadding + additionalHeight + valueLine;
            } else {
                // Top item
                yValue -= additionalHeightForTopItem;
            }
            return yValue;
        });
        if (params.legendShowValue) {
            items.append("text").attr("class", "mbc-time-series_dataValue").attr("x", 0).attr("y", function (d, i) {
                var yValue = y(i) + lineHeight * 2 + lineHeight * i;
                yValue = yValue + keyPadding * i + 3;
                if (items[0][i]) {
                    yValue = getNumTspan(items[0][i], params.chartType) * lineHeight + linePadding + getElementY(items[0][i], 0);
                }
                return yValue;
            }).text(function (d) {
                names.push(legendValuesFormat(d.value));
                return legendValuesFormat(d.value);
            });
        }

        items.append("line").attr("x1", 0).attr("y1", function (d, i) {
            var yValue = y(i) + lineHeight * i;
            yValue = yValue + 5 * i;
            if (items[0][i - 1]) {
                var index = params.legendShowValue ? 1 : 0;
                var numLinesNoValue = params.legendShowValue ? 0 : getNumTspan(items[0][i - 1], params.chartType) * lineHeight - timeSeriesNoValueLinePadding;
                yValue = getElementY(items[0][i - 1], index) + numLinesNoValue + lineHeight / 2 * index + timeSeriesLinePadding;
            }
            return yValue;
        }).attr("x2", function (d) {
            var svg = params.container.append("svg");
            var largestWidth = parseInt(Utils.svg.getGreaterSVGTextWidth(svg, wrapVars.names)) + 21;
            svg.remove();
            var width = largestWidth - params.legendWidth >= 1 ? largestWidth : params.legendWidth - 1;
            return scrollbarPresent(wrapVars) ? width + 15 : width;
        }).attr("y2", function (d, i) {
            var yValue = y(i) + lineHeight * i;
            yValue = yValue + 5 * i;
            if (items[0][i - 1]) {
                var index = params.legendShowValue ? 1 : 0;
                var numLinesNoValue = params.legendShowValue ? 0 : getNumTspan(items[0][i - 1], params.chartType) * lineHeight - timeSeriesNoValueLinePadding;
                yValue = getElementY(items[0][i - 1], index) + numLinesNoValue + lineHeight / 2 * index + timeSeriesLinePadding;
            }
            return yValue;
        }).attr("stroke", function (d) {
            return d.color || params.colors[d.index % params.colors.length];
        }).attr("stroke-dasharray", function (d) {
            var lineIsDotted = params.dottedLines.indexOf(d.displayName) > -1;
            return lineIsDotted ? "1 5" : "transparent";
        }).attr("stroke-linecap", "square").attr("stroke-width", function (d) {
            return d.lineStrokeWidth || defaultLineStrokeWidth;
        });
    } else {

        // Draw the text for all series and benchmark info
        items.append("text").attr("class", function (d, i) {
            return "dataName" + i;
        }).text(function (d) {
            if ((isScatterPlot() || isBubbleChart()) && d.index === -1) {
                return params.benchmarkLabel;
            }
            return d.displayName;
        }).attr("x", 15).call(wrap, wrapVars).attr("y", function (d, i) {
            var yValue = y(i) + 10;
            if (items[0][i - 1]) {
                yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) : yValue;
            }
            if (isScatterPlot() || isBubbleChart()) {
                var yValue = y(i);
                if (items[0][i - 1]) yValue = getNumTspan(items[0][i - 1]) > 4 ? getNumTspan(items[0][i - 1]) - 4 : yValue;
                if (i == 0) yValue = params.showBenchmark ? yValue = yValue + 15 : yValue + 12;
                return yValue;
            }
            return yValue;
        }).on("mouseover", function (d) {
            if (isScatterPlot() || isBubbleChart()) {
                return params.showBenchmark && d.index === -1 ? params._this.legendBenchmarkMouseover.call(params._this, d, this) : params._this.legendMouseover.call(params._this, d, this);
            }
            return null;
        }).on("mouseout", function (d) {
            if (isScatterPlot() || isBubbleChart()) {
                return params.showBenchmark && d.index === -1 ? params._this.legendBenchmarkMouseout.call(params._this, d, this) : params._this.legendMouseout.call(params._this, d, this);
            }
            return null;
        });

        // Get the series without the benchmark
        var series = items.filter(function (d) {
            return d.groupName !== params.benchmarksDataSource;
        });

        // Only draw the line for the line chart
        if (isLineChart()) {
            series.append("line").attr("x1", 0).attr("y1", function (d, i) {
                var yValue = y(i) + 5;
                if (items[0][i - 1]) {
                    yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 5 : yValue;
                }
                return yValue;
            }).attr("x2", 10).attr("y2", function (d, i) {
                var yValue = y(i) + 5;
                if (items[0][i - 1]) {
                    yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 5 : yValue;
                }
                return yValue;
            }).attr("stroke-width", function (d) {
                return d.lineStrokeWidth || defaultLineStrokeWidth;
            }).attr("stroke", function (d, i) {
                return d.color || params.colors[i % params.colors.length];
            }).attr("stroke-linecap", "square").attr("stroke-dasharray", function (d) {
                if (params.lineStyles[d.displayName]) {
                    return "1 5";
                }
            });
        }

        // Only draw the rectangles for non-line charts like vertical-bar
        if (isScatterPlot() || isBubbleChart()) {
            // Get the series without the benchmark
            series = items.filter(function (d) {
                return params.showBenchmark ? d.index !== -1 : true;
            });
            if (params.showBenchmark) {
                d3.select(items[0][0]).append("rect").attr("x", 0).attr("y", function (d, i) {
                    return y(i) + 4;
                }).attr("width", 10).attr("height", 10).attr("fill", params.benchmarkColor).attr("fill-opacity", 0.8).on("mouseover", function (d) {
                    return params._this.legendBenchmarkMouseover.call(params._this, d, this);
                }).on("mouseout", function (d) {
                    return params._this.legendBenchmarkMouseout.call(params._this, d, this);
                });
            }

            series.append("circle").attr("cx", 5).attr("cy", function (d, i) {
                if (params.showBenchmark) i = i + 1;
                var yValue = y(i);
                if (items[0][i - 1]) yValue = getNumTspan(items[0][i - 1]) > 10 ? getNumTspan(items[0][i - 1]) - 10 : yValue;
                if (i == 0) yValue = params.showBenchmark ? yValue = yValue + 15 : yValue + 7;
                return yValue;
            }).attr("r", 5).attr("fill", function (d, i) {
                if (isBubbleChart()) return d.color || params.colors[i % params.colors.length];
                return params.scatterplotColors[d.groupIndex % params.scatterplotColors.length];
            }).attr("fill-opacity", 0.8).on("mouseover", function (d) {
                return params._this.legendMouseover.call(params._this, d, this);
            }).on("mouseout", function (d) {
                return params._this.legendMouseout.call(params._this, d, this);
            });
        }

        if (!isScatterPlot() && !isLineChart() && !isBubbleChart()) {
            // Only draw the rectangles for non-line charts like vertical-bar
            series.append("rect").attr("x", 0).attr("y", function (d, i) {
                var yValue = y(i);
                if (items[0][i - 1]) {
                    yValue = getNumTspan(items[0][i - 1]) > yValue ? getNumTspan(items[0][i - 1]) - 10 : yValue;
                }
                return yValue;
            }).attr("width", 10).attr("height", 10).attr("fill", function (d, i) {
                return d.color || params.colors[i % params.colors.length];
            }).attr("fill-opacity", 0.8);
        }
    }

    // Draw Just Benchmark
    var benchmarkPosition = items[0].length - 2; //Needed to correctly position the benchmark line relative to the data point legend values
    var benchmark = items.filter(function (d) {
        return d.groupName === params.benchmarksDataSource;
    });
    if (!isTimeSeries()) {
        benchmark.append("line").attr("x1", 0).attr("y1", function (d, i) {
            var yValue = y(i) + 5;
            yValue = getNumTspan(items[0][benchmarkPosition]) > yValue ? getNumTspan(items[0][benchmarkPosition]) - 5 : yValue;
            return yValue;
        }).attr("x2", 10).attr("y2", function (d, i) {
            var yValue = y(i) + 5;
            yValue = getNumTspan(items[0][benchmarkPosition]) > yValue ? getNumTspan(items[0][benchmarkPosition]) - 5 : yValue;
            return yValue;
        }).attr("stroke", params.benchmarkColor).attr("stroke-width", "2");

        if (params.dottedBenchmark) {
            benchmark.attr("stroke-dasharray", "2,2");
        }
    }
    items.exit().remove();

    adjustSVGHeight(params, items);
    setLegendWidth(wrapVars);
}

/**
 * @method addTopItemsSVG
 * Creates svg items within legend on top of chart
 * Key and Item name
 * Hides elements that scope beyond chart width
 */
function addTopItemsSVG(params) {
    var items = params.items;
    var iconWithPadding = 16;
    var horizontalIconPadding = 5;
    var overflowBtnWithSpace = 24;
    var isBenchmark = function isBenchmark(d) {
        return d.groupName === params.benchmarksDataSource;
    };
    var isBenchmarkFirst = function isBenchmarkFirst(d) {
        return d.index === -1 && params.showBenchmark;
    };
    var isLineChart = function isLineChart() {
        return params.chartType === 'lineChart';
    };
    var isTimeSeries = function isTimeSeries() {
        return params.chartType === 'time-series';
    };
    var isHorizontalBar = function isHorizontalBar() {
        return params.chartType === 'horizontalBar';
    };
    var isVerticalBar = function isVerticalBar() {
        return params.chartType === 'verticalBar';
    };
    var isLineTime = function isLineTime() {
        return isLineChart() || isTimeSeries();
    };
    var isScatterPlot = function isScatterPlot() {
        return params.chartType === 'scatterplot';
    };
    var isBubbleChart = function isBubbleChart() {
        return params.chartType === 'bubbleChart';
    };

    items.enter().append("g").attr("class", function (d) {
        return d.displayName ? Utils.string.dashify(d.displayName) : Utils.string.dashify(d.name);
    }).style("display", function (d, i) {
        var titleWidth;
        var svg = params.container.append("svg");
        var textWidth = Utils.svg.getSVGTextWidth(svg, d.displayName);
        var containerWidth = params.legendWidth;
        svg.remove();
        var benchmarkWidth = params.showBenchmark ? Utils.svg.getSVGTextWidth(params.container, params.benchmarkLabel) : 0;
        i = params.showBenchmark ? i + 1 : i;
        var textX = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName'); //item spacing + overflow button spacing and width
        var start = params.showBenchmark ? 1 : 0;
        if (isScatterPlot() || isBubbleChart()) {
            var titleNode = items[0].parentNode.childNodes[0];
            titleWidth = titleNode.getBoundingClientRect().width;
            var width = params.showBenchmark && i === 0 ? 0 : benchmarkWidth + getTotalItemsWidth(params.container, items[0].slice(start, i - 1), 'displayName');
            textX = params.showBenchmark ? width : textX + benchmarkWidth;
            var prevItemWidth = width + (i - 1) * iconWithPadding + textWidth + iconWithPadding;
            textX = titleNode.className.baseVal === "mbc-legend-title" && titleWidth > 0 ? params.showBenchmark ? prevItemWidth + benchmarkWidth + 23 : textX + 40 : params.showBenchmark ? isBubbleChart() ? prevItemWidth + 13 : prevItemWidth + 21 : textX - 12;
            containerWidth = titleNode.className.baseVal === "mbc-legend-title" && titleWidth > 0 ? containerWidth - (isBubbleChart() && params._this.__attributes.view === null ? 40 : 20) : isBubbleChart() ? params.showBenchmark ? containerWidth - 40 : containerWidth : containerWidth - 8;
        }
        textX = params.showBenchmark ? textX + horizontalIconPadding : textWidth + textX + i * iconWithPadding + iconWithPadding + overflowBtnWithSpace;
        return textX > containerWidth ? "none" : "";
    }).classed("legend-item", true);

    if (isScatterPlot() || isBubbleChart()) {
        var benchmarkWidth = params.showBenchmark ? Utils.svg.getSVGTextWidth(params.container, params.benchmarkLabel) : 0;
        var titleNode = items[0].parentNode.childNodes[0];
        // Get the series without the benchmark
        var series = items.filter(function (d) {
            return params.showBenchmark ? d.index !== -1 : true;
        });
        if (params.showBenchmark) {
            d3.select(items[0][0]).append("rect").attr("x", function (d, i) {
                var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
                if (titleNode.className.baseVal === "mbc-legend-title") {
                    var titleWidth = titleNode.getBoundingClientRect().width;
                    width = titleWidth > 0 ? width + titleWidth + 15 : width;
                }
                if (i === 0) {
                    return width;
                }
                return width + i * iconWithPadding;
            }).attr("y", function (d, i) {
                return iconWithPadding / 4;
            }).attr("width", 10).attr("height", 10).attr("fill", params.benchmarkColor).attr("fill-opacity", 0.8).on("mouseover", function (d) {
                return params._this.legendBenchmarkMouseover.call(params._this, d, this);
            }).on("mouseout", function (d) {
                return params._this.legendBenchmarkMouseout.call(params._this, d, this);
            });
        }
        series.append("circle").attr("cx", function (d, i) {
            var titleWidth;
            var start = 0;
            if (params.showBenchmark) {
                i = i + 1;
                start = 1;
            }
            var width = benchmarkWidth + getTotalItemsWidth(params.container, items[0].slice(start, i), 'displayName');
            if (titleNode.className.baseVal === "mbc-legend-title") {
                titleWidth = titleNode.getBoundingClientRect().width;
                width = width + titleWidth;
            }
            if (i === 0) {
                return width > 0 ? width + 18 : width + horizontalIconPadding;
            }
            var prevItemWidth = width + i * iconWithPadding;
            return titleWidth > 0 ? params.showBenchmark ? prevItemWidth + 35 : prevItemWidth + 15 : params.showBenchmark ? prevItemWidth + iconWithPadding + horizontalIconPadding : prevItemWidth + horizontalIconPadding;
        }).attr("cy", function () {
            return iconWithPadding / 2;
        }).attr("r", 5).attr("fill", function (d, i) {
            if (isBubbleChart()) return d.color || params.colors[i % params.colors.length];
            return isBenchmarkFirst(d) ? "transparent" : params.scatterplotColors[d.groupIndex];
        }).attr("fill-opacity", 0.8).on("mouseover", function (d) {
            return params._this.legendMouseover.call(params._this, d, this);
        }).on("mouseout", function (d) {
            return params._this.legendMouseout.call(params._this, d, this);
        });
        items.append("text").attr("x", function (d, i) {
            var titleWidth;
            var start = params.showBenchmark ? 1 : 0;
            var width = params.showBenchmark && i === 0 ? 0 : benchmarkWidth + getTotalItemsWidth(params.container, items[0].slice(start, i), 'displayName');
            if (titleNode.className.baseVal === "mbc-legend-title") {
                titleWidth = titleNode.getBoundingClientRect().width;
                width = width + titleWidth;
            }
            if (i === 0) {
                var prevItemWidth = width + iconWithPadding;
                return titleWidth > 0 ? params.showBenchmark ? prevItemWidth + 15 : prevItemWidth + 11 : prevItemWidth;
            }
            var prevItemWidth = width + i * iconWithPadding;
            return titleWidth > 0 ? params.showBenchmark ? prevItemWidth + 45 : prevItemWidth + 25 : params.showBenchmark ? prevItemWidth + iconWithPadding + horizontalIconPadding + 10 : prevItemWidth + iconWithPadding;
        }).attr("y", function () {
            return iconWithPadding - 3;
        }).text(function (d) {
            if (d.index === -1) {
                return params.benchmarkLabel;
            }
            return d.displayName;
        }).on("mouseover", function (d) {
            return params.showBenchmark && d.index === -1 ? params._this.legendBenchmarkMouseover.call(params._this, d, this) : params._this.legendMouseover.call(params._this, d, this);
        }).on("mouseout", function (d) {
            return params.showBenchmark && d.index === -1 ? params._this.legendBenchmarkMouseout.call(params._this, d, this) : params._this.legendMouseout.call(params._this, d, this);
        });
    }
    if (isHorizontalBar()) {
        items.attr("class", function (d) {
            var className = d.displayName ? Utils.string.dashify(d.displayName) : Utils.string.dashify(d.name);
            // Add 'benchmark-legend' class to the benchmark legend in Horizontal Bar
            var benchmarkLegendClass = ' benchmark-legend';
            return d.isBenchmark ? className + benchmarkLegendClass : className;
        });
        items.append("rect").attr("x", function (d, i) {
            var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
            return i === 0 ? width : width + (iconWithPadding - 3);
        }).attr("y", function (d, i) {
            return 0;
        }).attr("width", function (d, i) {
            return i === 1 ? 2 : 10;
        }).attr("height", function (d, i) {
            return 10;
        }).attr("fill", function (d, i) {
            if (i === 1) {
                return;
            }
            return params.colors[i % params.colors.length];
        }).attr("fill-opacity", function () {
            return 0.8;
        }).attr("stroke", function (d, i) {
            if (i === 0) {
                return;
            }
            return params.benchmarkColor;
        }).attr("stroke-width", "1");

        items.append("text").attr("x", function (d, i) {
            var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
            if (i == 0) {
                return width + (iconWithPadding - 1);
            }
            return width + (iconWithPadding - 1) + horizontalIconPadding;;
        }).attr("y", 10).text(function (d) {
            return d.displayName;
        });
    }

    if (!isHorizontalBar() && !isScatterPlot() && !isBubbleChart()) {
        items.append("rect").attr("x", function (d, i) {
            var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
            if (i == 0) {
                return width;
            }
            return width + i * iconWithPadding;
        }).attr("y", function (d, i) {
            return isBenchmark(d, i) || isLineTime() ? 4 : 0;
        }).attr("width", function (d, i) {
            return 10;
        }).attr("height", function (d, i) {
            return isBenchmark(d, i) || isLineTime() ? 1 : 10;
        }).attr("fill", function (d, i) {
            if (isBenchmark(d, i) || isLineTime()) {
                return "none";
            }
            return params.colors[i % params.colors.length];
        }).attr("fill-opacity", function () {
            return isVerticalBar() ? 0.8 : 1;
        }).attr("stroke", function (d, i) {
            if (isLineChart()) {
                return d.color || params.colors[i % params.colors.length];
            }
            if (isTimeSeries()) {
                return d.color || params.colors[d.index % params.colors.length];
            }
            if (isBenchmark(d, i)) {
                return params.benchmarkColor;
            }
            return;
        }).attr("stroke-dasharray", function (d, i) {
            if (isTimeSeries() && params.dottedLines.indexOf(d.displayName) > -1) {
                return "3,3";
            }
            if (params.lineStyles[d.displayName] || isBenchmark(d, i) && params.dottedBenchmark) {
                return "3,3";
            }
            return;
        }).attr("stroke-width", function (d) {
            var defaultLineStrokeWidthForSmallLegend = "1";
            if (isTimeSeries() || isLineChart()) {
                return d.lineStrokeWidth || defaultLineStrokeWidthForSmallLegend;
            }
            return defaultLineStrokeWidthForSmallLegend;
        });

        items.append("text").attr("x", function (d, i) {
            var width = getTotalItemsWidth(params.container, items[0].slice(0, i), 'displayName');
            if (i == 0) {
                return width + (iconWithPadding - 1);
            }
            return width + i * iconWithPadding + (iconWithPadding - 1);
        }).attr("y", 10).text(function (d) {
            return d.displayName;
        });
    }
    items.exit().remove();
}

/**
 * @method getLegendWidth
 * Get Legend Width
 * @param container, @param data
 * @return {Number}
 */
function getTotalItemsWidth(container, data, accessor) {
    var svg = container.append("svg");
    var width = Utils.svg.getTotalSVGTextWidth(svg, data, accessor);
    svg.remove();
    return width;
}

/**
 * @method getNumTspan
 * Gets number of lines text element wraps to
 * Line returns next line y-position
 * Time Series returns number of lines for element
 * @param element, @param chartType
 * @return {Number}
 */
function getNumTspan(element, chartType) {
    var numLines = 1;
    var prevY = getElementY(element, 0);

    if (typeof element !== 'undefined') {
        numLines = element.childNodes[0].childNodes.length;
        if (chartType === 'time-series') {
            return numLines > 1 ? numLines : 1;
        }
    }
    return numLines * 17 + prevY + 5;
}

/**
 * @method getElementY
 * Gets y attribute of elements child i
 * @param element, @param i
 * @return {Number}
 */
function getElementY(element, i) {
    return typeof element !== 'undefined' ? parseFloat(d3.select(element.childNodes[i]).attr("y")) : 0;
}

/**
 * @method wrap
 * Wraps text to multiple lines as needed according to legend width
 * @param text, @param container
 */
function wrap(text, wrapVars) {
    if (wrapVars.params.chartType === 'scatterplot' || wrapVars.params.chartType === 'bubbleChart' || wrapVars.params.chartType === 'verticalBar' || wrapVars.params.chartType === 'lineChart') {
        var iconWithPadding = 14;
        var svgMaxWidth = 120;

        var svgLegendElement = wrapVars.params.container[0][0].children[1].children[1];
        var legendMaxWidth = Math.min(svgLegendElement.getBoundingClientRect().width, svgMaxWidth);

        var runningMaxWidth = legendMaxWidth;

        text.each(function () {
            var text = d3.select(this);
            var word = text.text();

            var x = text.attr("x");
            var y = text.attr("y");
            var tspan = text.text(null).append("tspan").attr("x", x).attr("y", y);

            var textWidth = Utils.string.getTextWidth(word, "Univers", "14px") + iconWithPadding;

            if (textWidth <= runningMaxWidth) {
                tspan.text(word);
            } else if (runningMaxWidth < svgMaxWidth && textWidth <= svgMaxWidth) {
                runningMaxWidth = textWidth;
                tspan.text(word);
            } else {
                runningMaxWidth = svgMaxWidth;

                var fragments = Utils.string.breakLegend(word, runningMaxWidth - iconWithPadding);

                tspan.text(fragments[0]);
                for (var i = 1; i < fragments.length; i++) {
                    tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", 1 + 0.25 + "em").text(fragments[i]);
                    text.attr("id", "double");
                }
            }
        });

        wrapVars.runningMaxWidth = runningMaxWidth;

        return;
    } else {

        var legendMaxWidth = 120;
        var legendCurrentWidth = 120;
        if (wrapVars.params.chartType === 'scatterplot' || wrapVars.params.chartType === 'bubbleChart' || wrapVars.params.chartType === 'verticalBar') {
            var SVGLegendElement = wrapVars.params.container[0][0].children[1].children[1];
            legendCurrentWidth = SVGLegendElement.getBoundingClientRect().width;
        }
        var scrollbarWidth = 17;
        var iconWithPadding = 21;
        text.each(function () {
            var text = d3.select(this),
                textWidth,
                words = text.text().split(/\s+/).reverse(),
                word,
                line = [],
                lineHeight = 1,
                // ems
            x = text.attr("x"),
                y = text.attr("y"),
                tspan = text.text(null).append("tspan").attr("x", x).attr("y", y),
                scrollbar = scrollbarPresent(wrapVars) ? scrollbarWidth : 0;

            var extraPadding = scrollbarPresent(wrapVars) ? scrollbarWidth : 0;
            /*
            // For each legend item:
            // * Find all the individual words that are wider than the legend max width
            // * Split them into fragments that will fit the width of the legend
            // * Insert the fragments in the correct order back into the array
            // * Let existing wrapping logic handle the rest.
            */
            var wordsArrayClone = words.slice();
            for (var i = 0; i < wordsArrayClone.length; i++) {
                var fragments;
                var indexOfWord;
                textWidth = Utils.string.getTextWidth(wordsArrayClone[i], 'sans-serif', '14px') + iconWithPadding + scrollbar;
                var legendDynamicWidth;
                if (wrapVars.params.chartType === 'bubbleChart') {
                    // Expand the legend container width instead of wrapping the legend
                    var totalTextWidth = textWidth + scrollbarWidth;
                    legendDynamicWidth = legendCurrentWidth < legendMaxWidth && totalTextWidth < legendMaxWidth ? Math.max(legendCurrentWidth, totalTextWidth) : legendMaxWidth;
                } else {
                    legendDynamicWidth = legendMaxWidth;
                }
                if (textWidth > legendDynamicWidth) {
                    fragments = Utils.string.breakString(wordsArrayClone[i], textWidth, legendCurrentWidth).reverse();
                    indexOfWord = words.indexOf(wordsArrayClone[i]);
                    words.splice.apply(words, [indexOfWord, 1].concat(fragments));
                }
            }

            if (words.length < 2) {
                wrapVars.names.push(words[0]);
            };

            while (word = words.pop()) {
                line.push(word);
                tspan.text(line.join(" "));
                wrapVars.firstPass = scrollbarPresent(wrapVars);
                var totalTSpanWidth;
                var legendDynamicWidth;
                if (wrapVars.params.chartType === 'bubbleChart') {
                    totalTSpanWidth = tspan.node().getComputedTextLength() + iconWithPadding + scrollbarWidth;
                    // Expand the legend container width instead of wrapping the legend
                    legendDynamicWidth = legendCurrentWidth < legendMaxWidth && totalTSpanWidth < legendMaxWidth ? Math.max(legendCurrentWidth, totalTSpanWidth) : legendMaxWidth;
                } else if (wrapVars.params.chartType === 'verticalBar') {
                    totalTSpanWidth = tspan.node().getComputedTextLength() + iconWithPadding + scrollbar + extraPadding;
                    legendDynamicWidth = legendMaxWidth;
                } else {
                    totalTSpanWidth = tspan.node().getComputedTextLength() + iconWithPadding + scrollbar;
                    legendDynamicWidth = legendMaxWidth;
                }
                if (totalTSpanWidth > legendDynamicWidth && line.length > 1) {
                    if (wrapVars.params.chartType === 'bubbleChart') {
                        wrapVars.names.push(line.join(" "));
                    }
                    line.pop();
                    tspan.text(line.join(" "));
                    wrapVars.names.push(line.pop());
                    line = [word];
                    tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", 1 * lineHeight + 0.25 + "em").text(word);
                    text.attr("id", "double");
                    wrapVars.names.push(word);
                } else {
                    wrapVars.names.push(line.join(" "));
                }
            }
        });
    }
}

/**
 * @method adjustSVGHeight
 * Sets legend svg height according to last item in data
 * @param items
 * @return {Number}
 */
function adjustSVGHeight(params, items) {
    var parentID = params.parentID;
    var isTimeSeries = params.chartType === "time-series";
    var isBubbleChart = params.chartType === "bubbleChart";
    var isScatterPlot = params.chartType === "scatterplot";
    var lastElement = items[0][items[0].length - 1];
    var lastelemIndex = isTimeSeries && params.legendShowValue ? 1 : 0;
    var lastElementY = parseFloat(d3.select(lastElement.childNodes[lastelemIndex]).attr("y"));
    var lastElementH = lastElement.childNodes[lastelemIndex].getBoundingClientRect().height;
    var newLegendHeight = isTimeSeries ? lastElementH + lastElementY - 10 : lastElementH + lastElementY;
    var setLegendHeight = isBubbleChart ? newLegendHeight - 10 : newLegendHeight;
    setLegendHeight = isScatterPlot ? setLegendHeight - 15 : setLegendHeight;
    d3.select("#svgcontainer_" + parentID).select("svg").attr("height", setLegendHeight);
}

/**
 * @method scrollbarPresent
 * Get Legend Height compare to chart height
 * 
 * Note this method doesn't always yield the correct result.
 * This is likely because some elements are not yet available
 * in DOM when this method is called.
 * 
 * @param container
 * @return {Number}
 */
function scrollbarPresent(wrapVars) {
    var svgLegendElement = wrapVars.params.container[0][0].children[1].getElementsByClassName("mbc-legend")[0];
    if (wrapVars.params.chartType === 'scatterplot' || wrapVars.params.chartType === 'bubbleChart' || wrapVars.params.chartType === 'verticalBar') {
        var legendContainer = wrapVars.params.container[0][0].children[1];
        var legendTitleHeight = legendContainer.children[0].clientHeight;
        var padding = 18; // 5px margin top + 5px padding top + 5px padding bottom + 3px magic padding
        var svgaLegendElementMaxHeight = legendContainer.getBoundingClientRect().height - legendTitleHeight - padding;
        return svgLegendElement.clientHeight >= svgaLegendElementMaxHeight;
    }
    var legendContainerHeight = parseFloat(wrapVars.params.container[0][0].children[1].style.height);
    return legendContainerHeight <= svgLegendElement.clientHeight;
}

/**
* @method setLegendWidth
* Get Legend Width
* @param container, @param data
* @return {Number}
*/
function setLegendWidth(wrapVars) {
    var params = wrapVars.params;
    var parentID = params.parentID;
    var legendMaxWidth = 120;
    var scrollbarWidth = 17;
    var iconWithPadding = 21;
    var svg = params.container.append("svg");
    var width = parseInt(Utils.svg.getGreaterSVGTextWidth(svg, wrapVars.names)) + iconWithPadding; // icon and padding
    svg.remove();
    if (scrollbarPresent(wrapVars)) {
        //Scrollbar space
        if (wrapVars.params.chartType === 'scatterplot' || wrapVars.params.chartType === 'bubbleChart') {
            var SVGLegendElement = wrapVars.params.container[0][0].children[1].children[1];
            var legendCurrentWidth = SVGLegendElement.getBoundingClientRect().width;
            width = width + scrollbarWidth < legendMaxWidth ? width : legendMaxWidth;
            // The width should not be smaller than current width
            width = Math.max(legendCurrentWidth, width);
        } else {
            width = width < legendMaxWidth - scrollbarWidth && params.chartType !== 'time-series' ? legendMaxWidth - scrollbarWidth : width;
        }
    }
    width = width > legendMaxWidth ? legendMaxWidth : width;

    if (wrapVars.params.chartType === 'scatterplot' || wrapVars.params.chartType === 'bubbleChart' || wrapVars.params.chartType === 'verticalBar' || wrapVars.params.chartType === 'lineChart') {
        width = wrapVars.runningMaxWidth;
    }

    d3.select("#svgcontainer_" + parentID).select("svg").attr("width", width);
}

module.exports = {
    addItemsSVG: addItemsSVG,
    addTopItemsSVG: addTopItemsSVG
};

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var core = __webpack_require__(0);
var Utils = core.Utils;
var Classes = core.Classes;
var mbc_mds_constants = Utils.colors.mbc_mds_constants;
var mbc_mds_space = mbc_mds_constants["space"];
var mbc_mds_size_icon = mbc_mds_constants["size"]["icon"];
var drawSVG = __webpack_require__(67);
var icon_mds_ellipsis_circle_s = __webpack_require__(112);

function Legend() {}
/**
 * @class Legend
 * instantiates legend object with necessary variable and constants
 * defaultOptions consistent across charts unless otherwise defined in specific chart
 * @param options Contains any chart specific options declared in chart
 */
Legend.prototype.invokeLegend = function (options) {
    var canvas = this.get("canvas"),
        _this = this;
    options = options || {};
    this.__OPTIONS = options;

    var defaultOptions = {
        container: this.get("selection").select("." + Classes.LEGEND),
        legend: this.get("selection").select("." + Classes.LEGEND).select("." + Classes.LEGEND + "-inner"),
        data: this.get("data"),
        benchmark: this.get("data").get("benchmark"),
        benchmarkColor: this.get("benchmarksColor") || this.get("benchmarkColor"),
        benchmarkStyle: false,
        benchmarkSpan: "benchmark",
        mouseover: true
    };

    Utils.object.copy(defaultOptions, options);
    this._options = defaultOptions;

    // Variables
    this._canvas = canvas;
    if (this._isBubbleChart() && !this._options.container[0][0].parentElement) return;
    var parentClassList = this._options.container[0][0].parentElement.classList;
    var arr = [].slice.call(parentClassList);
    arr.forEach(function (pClass, idx) {
        if (pClass.indexOf('mbc_') >= 0) {
            _this.set('parentID', pClass);
        }
    });
    var parentID = this.get('parentID');
    this._container = this._options.container.attr("id", "svgcontainer_" + parentID);
    this._data = this._options.data;
    this._legend = this._options.legend;
    this._benchmarkColor = this._options.benchmarkColor;
    this._benchmarkStyle = this._options.benchmarkStyle;
    this._benchmarkSpan = this._options.benchmarkSpan;

    this._margin = canvas.get("margin");
    this._legendTitle = this.get("legendTitle");
    this._benchmarkLabel = this.get("benchmarkLabel");
    this._legendMaxWidth = this.get("legendMaxWidth");

    var id = "mbc-mds-popover--" + this.generateID();
    if (this.get('popoverID') == null) {
        _this.set('popoverID', id);
    }
    this._createLegend();
};

/**
 * @method _createLegend
 * Create legend div container
 * Includes the title
 */
Legend.prototype._createLegend = function () {

    var parentID = this.get('parentID');
    var _this = this;
    if (this._options.chart === "horizontalBar") {
        var child = this._container[0][0].children;
        var arr = [].slice.call(child);
        if (typeof arr !== 'undefined') {
            arr.forEach(function (gElem) {
                gElem.parentElement.removeChild(gElem);
            });
        }
        _this.get("selection").select(".mbc-chart-legend").append('div').attr('class', Classes.LEGEND + "-container");
        this._container.style({
            "margin-left": this._canvas.get("margin").left + "px",
            "margin-right": "30px",
            "margin-top": this._canvas.get("margin").top + "px",
            "margin-bottom": "-30px"
        });
        if (this._options.orient === "top") this._container.style({ "margin-bottom": -20 + "px" });
        if (this._options.orient === "bottom") this._container.style({ "margin-bottom": -30 + "px" });
    } else {
        if (this._isScatterPlot()) {
            var child = this._container[0][0].children;
            var arr = [].slice.call(child);
            if (typeof arr !== 'undefined') {
                arr.forEach(function (gElem) {
                    gElem.parentNode.removeChild(gElem);
                });
            }
        } else {
            this._legend.remove();
        }

        this._setLegendHeightWidth();
        this.getDottedLines();
    }

    if (this._isVerticalBar() || this._options.chart === "lineChart" || this._options.chart === "time-series" || this._options.chart === "horizontalBar" || this._isScatterPlot() || this._isBubbleChart()) {
        var id = this.get('popoverID');
        var iconBtn = document.getElementsByClassName('mbc-mds-popover__trigger');
        var child = this._container[0][0].parentElement.children;
        var arr = [].slice.call(child);
        arr.forEach(function (div) {
            d3.select(div).attr('popoverID', id);
        });
        this.makeSVGContainer();
        this.drawSVGLegend();
        if (this._options.chart !== "horizontalBar") this.adjustLegendWidth(parseFloat(d3.select("#svgcontainer_" + parentID).select("svg").attr("width")));
        if (iconBtn != null && iconBtn.length > 0) this.setPopoverPosition(id);

        if ((this._isScatterPlot() || this._isBubbleChart()) && this._container[0][0].hasChildNodes() && this._container[0][0].childNodes.length > 1 && this._container.classed(Classes.LEGEND + "-right")) {
            var borderWeight = 1; // Border style is 1px in weight
            var noOffset = 0;
            var legendTitleDefaultHeight = 14; // Default legend title is one line with height 14px

            var legendTitle = this._container[0][0].childNodes[0];
            var legendTitleHeight = legendTitle.getBoundingClientRect().height;
            var legendTitleMargin = parseInt(window.getComputedStyle(legendTitle).marginBottom, 10);
            var legendContainerPadding = parseInt(window.getComputedStyle(this._container[0][0]).paddingTop, 10);

            if (this._isScatterPlot()) {
                var chartLayerHeight = this._canvas.layer("y-axis", "axes")[0][0].getBoundingClientRect().height;

                // Subtract the border weight when the legend title wraps
                var legenTitleMaxWidth = parseInt(legendTitle.style.maxWidth.slice(0, -2), 10);
                var legendTitleWidth = legendTitle.getBoundingClientRect().width;
                var borderOffset = legendTitleWidth == legenTitleMaxWidth ? noOffset : borderWeight;
                var legendHeight = chartLayerHeight - legendTitleHeight - legendTitleMargin - legendContainerPadding - borderOffset;

                d3.select(this._container[0][0]).style('height', chartLayerHeight + "px");
                d3.select(this._container[0][0].childNodes[1]).style('height', legendHeight + "px");
            }
            if (this._isBubbleChart()) {
                // Subtract the extra height due to legend title wrapping
                var legendTitleExtraHeight = legendTitleHeight - legendTitleDefaultHeight;
                if (legendTitleExtraHeight > 0) {
                    var legendHeight = d3.select(this._container[0][0].childNodes[1])[0][0].offsetHeight - legendTitleExtraHeight;
                    d3.select(this._container[0][0].childNodes[1]).style('height', legendHeight + "px");
                }
            }
        }
    } else {
        this._addLegendItems();
    }

    // removes empty elements from inner chart svg
    // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
    if (d3.select("." + Classes.LEGEND + "-inner").selectAll(".legend-item") !== null) {
        var arr = d3.select("." + Classes.LEGEND + "-inner").selectAll(".legend-item");
        if (typeof arr[0] !== 'undefined') {
            arr[0].forEach(function (gElem) {
                if (gElem.hasOwnProperty('remove') && gElem.childNodes.length === 0) {
                    gElem.remove();
                }
                // for IE remove polyfill
                if (!gElem.hasOwnProperty('remove') && gElem.childNodes.length === 0) {
                    Object.defineProperty(gElem, 'remove', {
                        configurable: true,
                        enumerable: true,
                        writable: true,
                        value: function remove() {
                            if (this.parentNode !== null) this.parentNode.removeChild(this);
                        }
                    });
                }
            });
        }
    }
};

/**
 * @method makeSVGContainer
 * Create svg legend container
 * Includes width and height
 */
Legend.prototype.makeSVGContainer = function () {
    var legendWidth = this.get("legendWidth");
    var parentID = this.get('parentID');
    var textWidth = this._container.classed(Classes.LEGEND + "-right") ? legendWidth : this._container[0][0].offsetWidth - 20; // padding left + icon margin + icon width vertical
    var legendHeight = this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule

    if (this._legend[0][0] && legendHeight < this._legend[0][0].scrollHeight) {
        //Scrollbar space
        textWidth += 12;
    }
    this.set("legendWidth", textWidth);

    var svgHeight = legendHeight > this._data.length * 22 + 5 ? legendHeight : this._data.length * 22 + 5;
    var numHeight = this._container.classed(Classes.LEGEND + "-right") ? svgHeight : 20; // 17 line height + 5 padding
    var innerLegendSelector = document.querySelector("#svgcontainer_" + parentID);
    if (this._isScatterPlot()) {
        if (this._container.classed(Classes.LEGEND + "-right")) {
            d3.select(innerLegendSelector).style("padding-top", "5px");
            d3.select(innerLegendSelector).style("margin-top", "4px");
        }
    }
    if (this._container.classed(Classes.LEGEND + "-right")) {
        if (this._isScatterPlot() || this._isBubbleChart() || this._isVerticalBar() || this._isLineChart()) {
            var titleLabel = d3.select(innerLegendSelector).append("span").classed("mbc-legend-title", true).style('max-width', legendWidth - 15 + 'px').style('word-break', 'break-word'); // 15 for spacing to left of title
            titleLabel.html(this.get("legendTitle"));
            innerLegendSelector = d3.select(innerLegendSelector).append("div").attr('class', 'mbc-legend-svg').style('overflow', 'auto').style('overflow-x', 'hidden');
        }
    }
    if (this._options.chart === "horizontalBar") {
        numHeight = 41;
        innerLegendSelector = document.querySelector("#svgcontainer_" + parentID).children[0];
    }
    innerLegendSelector = innerLegendSelector[0] ? innerLegendSelector[0][0] : innerLegendSelector;
    var svg = d3.select(innerLegendSelector).append("svg").attr("role", "legend").attr("class", "mbc-legend").attr("height", numHeight + "px");
    this.set("legendSVG", svg);
};

Legend.prototype.getDottedLines = function () {
    var arr = [].slice.call(this._data);
    var dotted = this.get("dottedLineNames");
    var lineStyles = {};
    arr.forEach(function (data, idx) {
        if (dotted) {
            var group = data.groupName;
            var name = data.displayName;
            var dottedLineNames = !(group === "benchmark") ? dotted[group] : null;
            lineStyles[name] = dottedLineNames;
        }
    });
    this.set('lineStyles', lineStyles);
};

/**
 * @method drawSVGLegend
 * Adds legend items to svg container
 * Includes right and top positioning
 */
Legend.prototype.drawSVGLegend = function () {
    var y1Axis = this.get("axes").axis("y1") || this.get("axes").axis("y");
    this._clearPopoversOverlays();
    var legendSVG = this.get("legendSVG");
    var legendWidth = this.get("legendWidth");
    if (legendSVG[0][0].childNodes.length < 1) {
        this.set("legendfrontGroup", legendSVG.append("g").classed(Classes.LEGEND + "-inner", true));
    }
    if (this._isTimeSeries()) {
        this._data = this._sortLegendData();
    }
    if (this._isBubbleChart()) this._data = this.get("benchmark") ? this._options.benchmark.concat(this._data) : this._data;
    if (this._isScatterPlot()) {
        var spData = this.get("data").get("scatterplot");
        this._color(0); //run colors to set scatterplotColors
        if (this.get("benchmark") && this._options.benchmark) {
            this._data = this._options.benchmark.concat(spData);
        }
    }
    var endPadding = legendWidth - 6; // SVG specific '7' - padding + borders
    var innerGroup = this.get("legendfrontGroup");
    var items = innerGroup.selectAll(".legend-item").data(this._data);
    var benchmarkColor = this.get("benchmarksColor") || this.get("benchmarkColor");
    var dottedBenchmark = this.get("dottedBenchmarks");
    var dottedLines = this.get('dottedLines');
    var colors = this.get("colors");
    var scatterColors = this.get('scatterplotColors');
    var showBenchmark = this.get("_showBenchmark") || this._isBubbleChart() && this.get('benchmark');
    var benchmarkLabel = this.get("benchmarkLabel");
    var legendWidth = this.get("legendWidth");
    var legendValuesFormat = this.get("legendValuesFormat");
    var legendShowValue = this.get("showLegendValues");
    var benchMarksVisible = this.get("benchMarksVisible");
    var parentID = this.get('parentID');
    var lineStyles = this.get('lineStyles');
    var chartType = this._options.chart;
    var benchmarksDataSource = this.get('benchmarksDataSource');
    var legendContainer = this.get("selection");
    var params = {
        _this: this,
        items: items,
        endPadding: endPadding,
        benchmarkColor: benchmarkColor,
        dottedBenchmark: dottedBenchmark,
        dottedLines: dottedLines,
        colors: colors,
        scatterplotColors: scatterColors,
        legendWidth: legendWidth,
        legendValuesFormat: legendValuesFormat,
        legendShowValue: legendShowValue,
        container: legendContainer,
        parentID: parentID,
        chartType: chartType,
        lineStyles: lineStyles,
        showBenchmark: showBenchmark,
        benchmarkLabel: benchmarkLabel,
        benchmarksDataSource: benchmarksDataSource
    };

    if (y1Axis || this._isBubbleChart()) {
        if (innerGroup && !this._isBubbleChart() && !this._isScatterPlot()) {
            innerGroup[0][0].setAttribute('transform', "translate(0,1)");
        }
        if (this._container.classed(Classes.LEGEND + "-right")) {
            drawSVG.addItemsSVG(params);
            var id = this.get('popoverID');
            if (document.getElementById(id) !== null) {
                document.getElementById(id).parentElement.classList.remove('mbc-mds-popover__wrapper--visible');
                if (document.querySelector('[data-mbc-mds-popover="' + id + '"]') !== null) {
                    document.querySelector('[data-mbc-mds-popover="' + id + '"]').setAttribute('aria-expanded', 'false');
                }
            }
        } else {
            if (this._isScatterPlot() || this._isBubbleChart()) {
                innerGroup.append('text').attr('class', "mbc-legend-title").attr("x", 0).attr("y", 13).text(this._legendTitle);
            }
            if (this._options.chart !== "horizontalBar") {
                drawSVG.addTopItemsSVG(params);
                this.createLegendPopoverSVG();
            }
        }
    }
    if (this._options.chart === "horizontalBar") {
        this.get("selection").select(".mbc-chart-legend");
        params.legendFundName = this.get("legendFundName");
        params.legendBenchmarkName = this.get("legendBenchmarkName");
        params.benchmarkColor = this._options.benchmarkColor;
        var legendData = benchMarksVisible ? [{ 'name': 'legendFundName', 'displayName': this.get("legendFundName") }, { 'name': 'legendBenchmarkName', 'displayName': this.get("legendBenchmarkName"), 'isBenchmark': true }] : [{ 'name': 'legendFundName', 'displayName': this.get("legendFundName") }];
        params.items = innerGroup.selectAll(".legend-item").data(legendData);
        d3.select(innerGroup[0][0]).attr("transform", "translate(0, 17)");
        drawSVG.addTopItemsSVG(params);
        this.createLegendPopoverSVG();
        var legendDivWidth = document.getElementById("svgcontainer_" + parentID).clientWidth;
        d3.select(document.getElementById("svgcontainer_" + parentID).children[0].children[0]).attr("width", legendDivWidth - 8); //set legend svg elem to legend div width
    }
};

/**
 * @method _clearPopoverWrapperOverlays
 * Removes existed popover wrappers and overlays
 */
Legend.prototype._clearPopoversOverlays = function () {
    if (document.getElementsByClassName('mbc-mds-popover__overlay').length != 0) {
        var overlays = document.getElementsByClassName('mbc-mds-popover__overlay');
        var arr = [].slice.call(overlays);
        arr.forEach(function (overlay) {
            overlay.parentElement.removeChild(overlay);
        });
    }
    if (document.getElementsByClassName('mbc-mds-popover').length != 0) {
        var popovers = document.getElementsByClassName('mbc-mds-popover');
        var arr = [].slice.call(popovers);
        arr.forEach(function (popover) {
            popover.parentElement.removeChild(popover);
        });
    }
};

/**
 * @method _addLegendItems
 * Add Items to legend container both benchmark and data
 * sets identifier and styles for items
 * maintains current chart specific css
 */
Legend.prototype._addLegendItems = function (container) {
    var _this = this;
    var enter;
    var mainDiv = container !== null && typeof container !== 'undefined' ? container : this._legend;
    var horizontalBarData = this.get("benchMarksVisible") ? [{ 'name': 'legendFundName', 'displayName': this.get("legendFundName") }, { 'name': 'legendBenchmarkName', 'displayName': this.get("legendBenchmarkName") }] : [{ 'name': 'legendFundName', 'displayName': this.get("legendFundName") }];
    var defaultLineStrokeWidth = 2;
    var marginTopConfigs = { 2: 6, 4: 5, 6: 4 };

    if (this.get("benchmark") && this._options.benchmark) {
        this._data = this._data[0] !== this.get("data").get("benchmark")[0] ? this.get("data").get("benchmark").concat(this._data) : this._data;
    }

    if (this._isTimeSeries()) {
        this._data = this._sortLegendData();
    }

    var isLineBenchmark = function isLineBenchmark(d) {
        return _this._isVerticalBar() && d.index === -1;
    };

    var isHorizontalBarBenchmark = function isHorizontalBarBenchmark(i) {
        return _this._options.chart === "horizontalBar" && i === 1;
    };

    var isBenchmarkFirst = function isBenchmarkFirst(d) {
        return d.index === -1 && _this.get("_showBenchmark");
    };

    var lineStyle = function lineStyle(d) {
        var dottedLines = _this.get('dottedLines');
        var color = d.color || _this._color(d.index);
        var lineIsDotted = dottedLines.indexOf(d.displayName) > -1;
        var lineStrokeWidth = d.lineStrokeWidth || defaultLineStrokeWidth;
        var style = lineIsDotted ? "2px dotted " + color : lineStrokeWidth + "px solid " + color;
        return style;
    };

    /**
     *  Similar to lineStyle() above but with different prop names and prop structure
     */
    var lineStyleForLine = function lineStyleForLine(d) {
        var dottedLines = _this.get('dottedLineNames');
        var axisData = d.name;
        var color = d.color || _this._color(d.index);
        var lineIsDotted = dottedLines[axisData] === true || Array.isArray(dottedLines[axisData]) && dottedLines[axisData].indexOf(d.displayName) > -1;
        var lineStrokeWidth = d.lineStrokeWidth || defaultLineStrokeWidth;
        var style = lineIsDotted ? "2px dotted " + color : lineStrokeWidth + "px solid " + color;
        return style;
    };

    var popOverData = this._options.chart === "horizontalBar" ? horizontalBarData : this._data;
    enter = d3.select(mainDiv[0][0]).selectAll("div").data(popOverData).enter().append("div").attr("class", function (d) {
        return d.displayName ? Utils.string.dashify(d.displayName) : Utils.string.dashify(d.name);
    }).classed("mbc-chart-legend-item", true);
    if (this._options.mouseover && this._options.chart !== "horizontalBar") {
        enter.on("mouseover", function (d) {
            isBenchmarkFirst(d) ? _this.legendBenchmarkMouseover(d) : _this.legendMouseover(d);
        }).on("mouseout", function (d) {
            isBenchmarkFirst(d) ? _this.legendBenchmarkMouseout(d) : _this.legendMouseout(d);
        });
    }
    if (this._isTimeSeries() && this._container.classed(Classes.LEGEND + "-right")) {
        var legendValuesFormat = Utils.string.convertDashToEnDash(this.get("legendValuesFormat"));

        enter.append("p").attr("class", Classes.LEGEND_ITEM + "__label--right").text(function (d) {
            return d.displayName;
        }).style("border-top", function (d) {
            return lineStyle(d);
        }.bind(this));

        if (this.get("showLegendValues")) {
            enter.append("p").attr("class", Classes.LEGEND_ITEM + "__value--right").text(function (d) {
                return legendValuesFormat(d.value);
            });
        }
    } else {

        enter.append("span").classed(this._benchmarkSpan, function (d, i) {
            return isBenchmarkFirst(d) || isLineBenchmark(d);
        }).classed('horiz-bar-benchmark', function (d, i) {
            return isHorizontalBarBenchmark(i);
        }).classed(this._benchmarkSpan + "--dotted", function (d) {
            return isLineBenchmark(d) && this._benchmarkStyle;
        }).classed(Classes.LEGEND_ITEM + "__key", function (d) {
            return _this._isTimeSeries();
        }).classed("square", function (d, i) {
            return _this._isVerticalBar() && !isLineBenchmark(d) || _this._isScatterPlot() && isBenchmarkFirst(d) || _this._isBubbleChart() && isBenchmarkFirst(d) || _this._options.chart === "horizontalBar" && i === 0;
        }).classed("circle", function (d) {
            return (_this._isScatterPlot() || _this._isBubbleChart()) && d.index !== -1;
        }).style("background-color", function (d, i) {
            if (_this._isTimeSeries()) {
                return 'transparent';
            }
            if (_this._isLineChart()) {
                return null;
            }
            if (isLineBenchmark(d) || isHorizontalBarBenchmark(i)) {
                return this._benchmarkStyle ? 'transparent' : this._benchmarkColor;
            }
            if (isBenchmarkFirst(d)) {
                return this._benchmarkColor;
            }
            if (this._isScatterPlot() || this._isBubbleChart()) {
                return this._color(d.groupIndex);
            }
            return !this._isDottedLine(d.groupName, d.displayName) ? this._color(i) : null;
        }.bind(this)).style("border-top", function (d, i) {
            if (_this._isLineChart()) {
                return null;
            }
            if (isLineBenchmark(d) && this._benchmarkStyle) {
                return "2px dotted " + this._benchmarkColor;
            }
            return this._isDottedLine(d.groupName, d.displayName) ? "2px dotted " + this._color(i) : null;
        }.bind(this)).style("border-bottom", function (d) {
            if (_this._isTimeSeries()) {
                return lineStyle(d);
            }
            if (_this._isLineChart()) {
                return lineStyleForLine(d);
            }
            return null;
        }.bind(this)).style("margin-top", function (d) {
            if (_this._isTimeSeries() || _this._isLineChart()) {
                var lineStrokeWidth = d.lineStrokeWidth || defaultLineStrokeWidth;
                return marginTopConfigs[lineStrokeWidth] + "px";
            }
            return null;
        }.bind(this)).style("opacity", this.get("opacity"));

        enter.append("p").text(function (d) {
            return isBenchmarkFirst(d) && d.index === -1 ? _this._benchmarkLabel : d.displayName;
        });
    }
};

/**
 * @method generateID
 * Returns 5 digit id for legend popover created
 */
Legend.prototype.generateID = function () {
    return Math.floor(Math.random() * 90000) + 10000;
};

/**
 * @method addPopoverContent
 * Sets title and adds legend items to popover
 * @param id ID of popover generated at instantiation
 */
Legend.prototype.addPopoverContent = function (id) {
    var popOverElem = document.getElementById(id);
    if (popOverElem.getElementsByClassName("mbc-mds-popover__header").length !== 0) {
        var currentHeader = popOverElem.getElementsByClassName("mbc-mds-popover__header");
        currentHeader[0].parentNode.removeChild(currentHeader[0]);
    }
    if (popOverElem.getElementsByClassName("mbc-mds-popover__content").length !== 0) {
        var oldContent = popOverElem.getElementsByClassName("mbc-mds-popover__content");
        oldContent[0].parentNode.removeChild(oldContent[0]);
    }
    var headerElem = d3.select(popOverElem).append('header').attr('class', 'mbc-mds-popover__header');
    var titleElem = headerElem.append('h2').attr('class', 'mbc-mds-popover__title');
    titleElem[0][0].innerHTML = "Legend";

    var contentElem = d3.select(popOverElem).append('div').attr('class', 'mbc-mds-popover__content').style('overflow', 'auto');
    var chartInners = document.getElementsByClassName('mbc-chart-inner');
    var chartTop = document.getElementsByClassName('mbc-chart-inner')[0].getBoundingClientRect().top;
    var arr = [].slice.call(chartInners);
    arr.forEach(function (inner) {
        if (d3.select(inner).attr('popoverID') == id) {
            chartTop = inner.getBoundingClientRect().top;
        }
    });
    var legendMax = window.innerHeight - chartTop - headerElem[0][0].clientHeight;
    var calcMax = legendMax - 120 < 120 ? 120 : legendMax - 120;
    var maxHeight = calcMax > 250 ? 250 : calcMax;
    contentElem[0][0].style.maxHeight = maxHeight + "px"; //minus container bottom padding and title
    this._addLegendItems(contentElem);
};

/**
 * @method createOverlayDismiss
 * Adds popover overlay for dismissal
 * @param parentID ID of popover chart parent to get popover wrapper
 */
Legend.prototype.createOverlayDismiss = function (id) {

    var popoverParentSelector = this.get('legendPopoverParentElement');
    var popoverParent = document.querySelector(popoverParentSelector);
    if (popoverParent === null) {
        console.error("Chart parameter legendPopoverParentElement must be a class or id selector, invalid value is '" + popoverParentSelector + "'");
    }
    var overLay = document.createElement('div');
    overLay.setAttribute('class', "mbc-mds-popover__overlay mbc-overlay_" + id);
    overLay.style.width = '100%';
    overLay.style.height = '100%';
    overLay.style.display = 'block';

    function removePopovers(e) {
        if (e.type === 'click' || e.type === 'keydown' && e.key.substr(0, 3).toLowerCase() === 'esc') {
            (function () {
                var popovers = document.querySelectorAll('.mbc-mds-popover');
                // Close currently opened popovers outside of current selected

                var _loop = function _loop(m) {
                    popovers[m].classList.remove('mbc-legend-popover--visible');
                    popoverParent.removeChild(popovers[m]);
                    var arr = [].slice.call(popovers[m].classList);
                    arr.forEach(function (popOverClass) {
                        if (popOverClass.indexOf('mbc-mds-legend-popover_') >= 0) {
                            var chartClass = popOverClass.substring(popOverClass.indexOf('_') + 1);
                            if (document.getElementsByClassName(chartClass)[0].children[0].classList.contains(Classes.LEGEND + "-top")) {
                                document.querySelector('[data-mbc-mds-popover="' + popovers[m].id + '"]').setAttribute('aria-expanded', 'false');
                            }
                        }
                    });
                };

                for (var m = 0; m < popovers.length; m++) {
                    _loop(m);
                }
                popoverParent.removeChild(overLay);
            })();
        }
    }

    overLay.addEventListener('click', removePopovers, false);
    window.addEventListener('keydown', removePopovers, { once: true });

    popoverParent.appendChild(overLay);
};

/**
 * @method createLegendPopoverSVG
 * Build MDS popover using MDS icon see docs
 * http://designsystem.morningstar.com/components/popovers.html#css-class-references
 * http://designsystem.morningstar.com/visual-language/iconography.html
 */
Legend.prototype.createLegendPopoverSVG = function () {
    var id = this.get('popoverID');
    var parentID = this.get('parentID');
    var _this = this;
    var popoverParentSelector = this.get('legendPopoverParentElement');
    var popoverParent = document.querySelector(popoverParentSelector);
    this._container.style('overflow', 'visible');
    this._container.style('position', 'relative');

    if (document.querySelector('[data-mbc-mds-popover="' + id + '"]')) {
        document.querySelector('[data-mbc-mds-popover="' + id + '"]').parentNode.removeChild(document.querySelector('[data-mbc-mds-popover="' + id + '"]'));
    }
    var buttonTop = this._options.chart === "horizontalBar" ? this._canvas.get("margin").top - 5 + "px" : '1px';
    buttonTop = this._isBubbleChart() ? 0 : buttonTop;
    var buttonDiv = this._container.append('button').attr('class', "mbc-mds-button mbc-mds-button--small mbc-mds-popover__trigger mbc-mds-button--icon-only").attr('type', 'button').attr('data-mbc-mds-popover', id).style('top', buttonTop).style('right', '6px').style('position', 'absolute').style('visibility', 'hidden').attr('aria-controls', id).attr('aria-haspopup', "true").attr('aria-expanded', 'false');
    var btnImage = buttonDiv.append("svg").attr("class", "mbc-mds-icon--s mbc-mds-button__icon");
    btnImage.attr('viewBox', '0 0 1500 1500').append('path').attr('d', 'M698.5 798.5h100v-100h-100v100zm-300 0h100v-100h-100v100zm350-800c-410 0-750 340-750 750s340 750 750 750 750-340 750-750-340-750-750-750zm0 1400c-360 0-650-290-650-650s290-650 650-650 650 290 650 650-290 650-650 650zm250-600h100v-100h-100v100z'); // draws ellipses icon from morningstar-design-system/dist/src/icons/ellipsis-circle--s.svg

    if (document.querySelector('[data-mbc-mds-popover="' + id + '"]')) {
        document.querySelector('[data-mbc-mds-popover="' + id + '"]').addEventListener('click', function () {
            var popOver = document.getElementById(id);
            if (popOver === null) {
                popOver = document.createElement('div');
                popOver.setAttribute('id', "" + id);
                popOver.setAttribute('class', "mbc-mds-popover mbc-mds-popover--width-200px mbc-mds-legend-popover_" + parentID);
                popOver.setAttribute('role', 'tooltip');
                popoverParent.appendChild(popOver);
            }

            _this.addPopoverContent(id);
            var popOverElem = document.getElementById(id);
            var popovers = document.querySelectorAll('.mbc-mds-popover');
            for (var m = 0; m < popovers.length; m++) {
                // Close currently opened popovers outside of current selected
                if (!popovers[m].isSameNode(popOverElem)) {
                    popovers[m].classList.remove('mbc-legend-popover--visible');
                    document.getElementsByClassName("" + parentID)[0].getElementsByClassName('mbc-mds-button--icon-only')[0].setAttribute('aria-expanded', 'false');
                }
            }
            var setPopover = _this.setPopoverPosition(id);
            setPopover.setPosition(popOverElem);
            popOverElem.classList.add('mbc-legend-popover--visible'); // Open currently selected popover
            document.querySelector('[data-mbc-mds-popover="' + id + '"]').setAttribute('aria-expanded', 'true');
            _this.createOverlayDismiss(id);
        });
    }
    this.showOverflowBtn(id);
};

/**
 * @method showOverflowBtn
 * Sets MDS popover wrapper to visible which shows only button in unselected state
 */
Legend.prototype.showOverflowBtn = function (id) {
    var parentID = this.get('parentID');
    var chartContainerElem = document.getElementsByClassName("" + parentID);
    var currentInner = chartContainerElem[0].getElementsByClassName('mbc-chart-legend-inner');

    var legendMaxWidth = chartContainerElem[0].childNodes[0].getBoundingClientRect().width;
    var legendContainerPadding = 20; // Padding between each legend item
    var legendContainerButtonLeftPadding = 50; // Left padding of the show/hide modal button
    var svgContainer = d3.select(chartContainerElem[0].childNodes[0].childNodes[0]);

    if (this._isScatterPlot() || this._isBubbleChart()) {
        var childNodes = currentInner[0].childNodes;
        var legendAvailableWidth = legendMaxWidth - legendContainerPadding - legendContainerButtonLeftPadding;

        for (var i = 0; i < childNodes.length; i++) {
            var childWidth = Utils.svg.getSVGTextWidth(svgContainer, childNodes[i].textContent, 'displayName');
            legendAvailableWidth = legendAvailableWidth - childWidth - legendContainerPadding;

            if (legendAvailableWidth < 0) {
                // Hide the legend item when no width is available
                childNodes[i].style.display = 'none';
            }
        }
    }

    if (currentInner[0].lastElementChild.style.display === 'none') {
        document.querySelector('[data-mbc-mds-popover="' + id + '"]').style.visibility = 'visible';
    }
};

/**
 * @method setPopoverPosition
 * Sets position of popovers on window scroll
 * Based on current overflow btn position and chart container position in window
 * @param id ID of popover generated at instantiation
 */
Legend.prototype.setPopoverPosition = function (id) {
    var _this = this;
    var parentID = this.get('parentID');
    var popoverWidth = 200;
    var currentPopover = document.getElementById(id);
    var popovers = document.querySelectorAll('.mbc-mds-popover');
    var chartContainerElem = document.getElementsByClassName("" + parentID);

    var iconBtns = document.querySelectorAll('.mbc-mds-popover__trigger');
    if (iconBtns.length > 0) {
        setPosition(currentPopover);
        window.onscroll = function () {
            var arr = [].slice.call(popovers);
            arr.forEach(function (popOverElem) {
                setPosition(popOverElem);
                if (!(popOverElem.getBoundingClientRect().top >= 0 || popOverElem.getBoundingClientRect().bottom >= 0) || !(popOverElem.getBoundingClientRect().left >= 0 || popOverElem.getBoundingClientRect().right >= 0)) {
                    //if out of viewport then remove popover and overlay
                    var popoverParentSelector = _this.get('legendPopoverParentElement');
                    var popoverParent = document.querySelector(popoverParentSelector);
                    var overLay = document.querySelector(".mbc-overlay_" + popOverElem.id);
                    var popoverBtn = document.querySelector('[data-mbc-mds-popover="' + popOverElem.id + '"]');
                    popOverElem.classList.remove('mbc-legend-popover--visible');
                    popoverBtn.blur();
                    popoverParent.removeChild(popOverElem);
                    popoverParent.removeChild(overLay);
                    popoverBtn.setAttribute('aria-expanded', 'false');
                }
            });
        };
    }

    function setPosition(popOverElem) {
        if (typeof popOverElem !== 'undefined' && popOverElem !== null) {
            var chartElem = chartContainerElem[0];
            var arr = [].slice.call(popOverElem.classList);
            arr.forEach(function (popOverClass) {
                if (popOverClass.indexOf('mbc-mds-legend-popover_') >= 0) {
                    var chartClass = popOverClass.substring(popOverClass.indexOf('_') + 1);
                    chartElem = document.querySelector("." + chartClass);
                }
            });
            if (popOverElem !== null && chartElem.children[0].classList.contains(Classes.LEGEND + "-top") || _this._options.chart === "horizontalBar") {
                removePopoverPosition(popOverElem);

                var iconBtn = document.querySelector('[data-mbc-mds-popover="' + popOverElem.id + '"]');
                var bodyRect = document.body.getBoundingClientRect(),
                    btnRect = iconBtn.getBoundingClientRect(),
                    offsetTop = btnRect.top - bodyRect.top,
                    offsetLeft = btnRect.left - bodyRect.left,
                    popOverHeight = popOverElem.getBoundingClientRect().height;

                if (window.innerWidth - iconBtn.getBoundingClientRect().right >= popoverWidth) {
                    //room on right of icon
                    popOverElem.style.top = offsetTop + iconBtn.getBoundingClientRect().height / 2 + "px";
                    popOverElem.style.left = offsetLeft + iconBtn.getBoundingClientRect().width + "px";
                    popOverElem.classList.add('mbc-mds-popover--right-bottom');
                    return;
                }

                if (iconBtn.getBoundingClientRect().top >= popOverElem.getBoundingClientRect().height) {
                    //room top of icon
                    popOverElem.style.top = offsetTop - popOverHeight - iconBtn.getBoundingClientRect().height / 2 + "px";
                    popOverElem.style.left = offsetLeft - popoverWidth + iconBtn.getBoundingClientRect().width / 2 + "px";
                    popOverElem.style.bottom = 'auto';
                    popOverElem.classList.add('mbc-mds-popover--top-left');
                    return;
                }

                popOverElem.style.top = offsetTop + iconBtn.getBoundingClientRect().height + "px";
                popOverElem.style.left = offsetLeft - popoverWidth + iconBtn.getBoundingClientRect().width / 2 + "px";
                popOverElem.classList.add('mbc-mds-popover--bottom-left');
            }
        }
    }
    return {
        setPosition: setPosition
    };

    function removePopoverPosition(popOverElem) {
        popOverElem.removeAttribute("style");
        if (popOverElem.classList.contains('mbc-mds-popover--top-left')) {
            popOverElem.classList.remove('mbc-mds-popover--top-left');
        }
        if (popOverElem.classList.contains('mbc-mds-popover--bottom-left')) {
            popOverElem.classList.remove('mbc-mds-popover--bottom-left');
        }
        if (popOverElem.classList.contains('mbc-mds-popover--right-bottom')) {
            popOverElem.classList.remove('mbc-mds-popover--right-bottom');
        }
        if (popOverElem.classList.contains('mbc-mds-popover--left-bottom')) {
            popOverElem.classList.remove('mbc-mds-popover--left-bottom');
        }
    }
};

/**
 * @method getLegendWidth
 * Get Legend Width
 * @param container, @param data
 * @return {Number}
 */
Legend.prototype.getLegendWidth = function (container, data) {
    var svg = container.append("svg");
    var width = Utils.svg.getGreaterSVGTextWidth(svg, data, "displayName");
    svg.remove();
    return width;
};

Legend.prototype.getItemsWidth = function (container, data) {
    var svg = container.append("svg");
    var width = Utils.svg.getTotalSVGTextWidth(svg, data, "displayName");
    svg.remove();
    return width;
};

/**
 * @method _setLegendHeightWidth
 * Set Legend width/height
 * Set Chart Container Width/Height
 * based on 'right' or 'top' attribute of legend container
 */
Legend.prototype._setLegendHeightWidth = function () {
    var chartContainer = this._canvas.get("container");
    var textWidth = this.getLegendWidth(this._container, this._data) + 15 + 6; // padding left + icon margin + icon width
    var legendHeight = this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule
    var marginLeft = 0;

    this.set("legendHeight", legendHeight);
    this.adjustLegendWidth(textWidth);

    if (!this._container.classed(Classes.LEGEND + "-right")) {
        //When legend is placed at top of chart
        legendHeight = this._container[0][0].offsetHeight;
        marginLeft = this.get("yAxisOrient") === "left" ? this.get("yAxesLabelWidth") + this.get("yAxesLabelPadding") : 0;
        if (this._isBubbleChart()) marginLeft = this.checkViewIsGrid() ? marginLeft : 0;

        this._container.style("margin-left", marginLeft + "px");

        if (this._data.length > 0 && this._data[0].groupName !== "benchmark" && !this._isBubbleChart()) {
            var yAxesWidth = this.get("yAxesLabelWidth");
            if (this._isScatterPlot()) {
                yAxesWidth = this.get("yAxisOrient") == "right" ? 0 : this.get("yAxesLabelWidth") + 2;
            }
            yAxesWidth = this._isVerticalBar() || this._options.chart === "lineChart" ? this.axesLabelMarginValues() : yAxesWidth;
            this._container.style("margin-left", yAxesWidth + "px");
        } else {
            var timeSeriesBottom = this._isTimeSeries() ? 2 : 0;
            if (!this._isBubbleChart()) d3.select(chartContainer).style("height", "calc(100% - " + (legendHeight - timeSeriesBottom) + "px)");
            if (this._isBubbleChart()) {
                var topLegendHeight = 20;
                if (this.checkViewIsGrid()) d3.select(chartContainer).style("height", "calc(100% - " + topLegendHeight + "px)");
            }
        }
    }

    this.set("legendContainer", this._container);
};

/**
 * @method axesLabelMarginValues
 * @desc determine axes layout return margin left of top legend
 * @return {Float}
 */
Legend.prototype.axesLabelMarginValues = function () {
    // one left, one right, one left/one right, two left, two right
    //vert-bar: left axis, no label || no label X top || show X labels || right axis || double axes no label || double axes left right || double axes right = 0
    if (this._isVerticalBar() && !this.get("y1AxisLabel") && this.get("y1AxisOrient") == "left") return 0;
    if (this._isVerticalBar() && this.get("y1AxisOrient") == "right") return 4;

    if (!this.get("y1AxisLabel") && !this.get("y2AxisLabel") && this.get("y1AxisOrient") == "left" || this.get("y1AxisOrient") == "right" && (this.get("y2AxisOrient") == "right" || !this.get("y2"))) return 0;
    if (!this.get("y1AxisLabel") && this.get("y1AxisOrient") == "right" && !this.get("y2")) return 3;
    if (this.get("y1AxisOrient") == "right" || this.get("y2") && this.get("y2AxisOrient") == "right" && this.get("y1AxisOrient") == "right") return 4;
    return 15;
};

/**
 * @method adjustLegendHeight
 * @desc adjusts the legend height after the chart has been rendered
 * used within time-series chart currently
 */
Legend.prototype.adjustLegendHeight = function () {
    var container = this.get("selection").selectAll("." + Classes.LEGEND);
    var canvas = this.get("canvas");

    if (container.classed(Classes.LEGEND + "-right")) {
        var timeSeriesBottom = this._isTimeSeries() ? 2 : 0;
        container.style({
            height: canvas.height() + timeSeriesBottom + "px"
        });
    }
};

/**
 * @method adjustLegendWidth
 * @desc adjusts the legend height after the chart has been rendered
 * used within time-series chart currently
 */
Legend.prototype.adjustLegendWidth = function (textWidth) {
    var canvas = this._canvas;
    var parentID = this.get('parentID');
    var chartContainer = canvas.get("container");
    var scrollbarWithPadding = 19;
    var iconWidth = 40;
    var legendMarginPad = 13;
    var legendHeight = typeof this._container[0][0].children[0] !== 'undefined' ? this._container[0][0].children[0].clientHeight : this._container[0][0].offsetHeight - this._margin.bottom - this._margin.top - 1; // subtract 1 to align bottom rule

    if (this._container.classed(Classes.LEGEND + "-right")) {
        if (this._isBubbleChart()) {
            var legendContainerHeight = !this.checkViewIsGrid() ? canvas.height() + 20 : canvas.height() - 9;
            if (this._container[0][0].childNodes[1]) {
                legendContainerHeight = this.checkViewIsGrid() ? legendContainerHeight - 21 : legendContainerHeight;
                d3.select(this._container[0][0].childNodes[1]).style({
                    height: legendContainerHeight + "px"
                });
            }
        }

        var legendTitleMarginBottom = 5;
        var legendContainerMarginTop = 4;

        if (this._isScatterPlot()) {
            var svgHeight = typeof this._container[0][0].children[1] !== 'undefined' && typeof this._container[0][0].children[1].children[0] !== 'undefined' ? this._container[0][0].children[1].children[0].clientHeight : legendHeight;
            var legendTitleHeight = this._container[0][0].children[0] && this._container[0][0].children[0].getBoundingClientRect().height || 0;
            var padding = 8; // Magic padding
            legendHeight = legendContainerMarginTop + legendTitleHeight + legendTitleMarginBottom + svgHeight + padding;
        } else if (this._isVerticalBar()) {
            var svgHeight = typeof this._container[0][0].children[1] !== 'undefined' ? this._container[0][0].children[1].clientHeight : legendHeight;
            var padding = 1; // Magic padding
            legendHeight = svgHeight + padding;
        } else if (this._isBubbleChart()) {
            var svgHeight = typeof this._container[0][0].children[1] !== 'undefined' && typeof this._container[0][0].children[1].children[0] !== 'undefined' ? this._container[0][0].children[1].children[0].clientHeight : legendHeight;
            var legendTitleHeight = this._container[0][0].children[0] && this._container[0][0].children[0].getBoundingClientRect().height;
            var padding = this.checkViewIsGrid() ? 4 : 3; // Magic padding
            var paddingTop = 9; // Bubble's special padding top style (MDS-11723)
            legendHeight = legendContainerMarginTop + legendTitleHeight + legendTitleMarginBottom + svgHeight + padding + paddingTop;
        } else if (this._isLineChart()) {
            var svgHeight = typeof this._container[0][0].children[1] !== 'undefined' && typeof this._container[0][0].children[1].children[0] !== 'undefined' ? this._container[0][0].children[1].children[0].clientHeight : legendHeight;
            var padding = 6; // Magic padding
            legendHeight = svgHeight + padding;
        }

        var legendMaxWidth = this._legendMaxWidth;
        var legendMaxWidthWithScrollbar = 120 + scrollbarWithPadding;

        // This scrollbar present logic is slightly different from the logic in the scrollbarPresent() method in _svg.js
        if (legendHeight > this._container[0][0].offsetHeight) {
            textWidth = textWidth + scrollbarWithPadding;
            if (this._isTimeSeries()) {
                //show item line full width of container
                d3.select(this._container[0][0].children[0]).attr('width', (textWidth || 15) - 15);
            }
        }

        if (this._isScatterPlot() || this._isBubbleChart()) {
            var titleWidth = Utils.string.getTextWidth(this._legendTitle, 'Univers', '14px') + 15 + 6; // padding left + icon margin + icon width;
            textWidth = Math.max(textWidth, titleWidth);
            textWidth = Math.min(textWidth, legendMaxWidthWithScrollbar);
        }

        textWidth = textWidth > legendMaxWidth ? legendMaxWidth : textWidth;

        this._container.style("width", textWidth + "px");
        var newLegendWidth = this.get("selection")[0][0].offsetWidth - textWidth - legendMarginPad;
        var chartWidth = this._isScatterPlot() ? newLegendWidth + 2 : newLegendWidth;

        d3.select(chartContainer).style("width", chartWidth + "px");
        this.set("legendWidth", textWidth);
        if (!this._isScatterPlot() && this._data[0].groupName !== "benchmark" && !this._isBubbleChart()) {
            var marginTop = this._isTimeSeries() ? canvas.get("margin").top - 2 : canvas.get("margin").top;
            this._legend.style("height", legendHeight + "px");
            this._container.style({
                height: canvas.height() - 5 + "px", //SVG Specific
                width: textWidth + "px",
                "margin-top": marginTop + "px" //SVG Specific
            });

            chartContainer = d3.select(canvas.get("container"));
            var chartWidth = chartContainer.node().clientWidth;

            var marginRight = this._isTimeSeries() && this.chartRightAxesNoLabel() ? 12 : 0;

            //calc was not working properly on IE 11, set width based on client instead
            chartContainer.style("width", "calc(100% - " + (textWidth + marginRight) + "px)");
        }
    } else {
        chartContainer = d3.select(canvas.get("container"));
        var chartWidth = chartContainer.node().clientWidth;
        if (this._isBubbleChart()) {
            chartContainer.style({
                width: "100%"
            });
        }
        d3.select("#svgcontainer_" + parentID).select("svg").attr("width", chartWidth - iconWidth - 8); //overflow button - medium space
    }
};

/**
  * @method _color
  * Returns the index *n* color from the *colors* attribute array
  * @param {Number} index Index of color to return
  * scatterplot uses plot colors different array than colors
  * @return {Array}
  */
Legend.prototype._color = function (index) {
    var plotColors = this.get("plotColors");
    var colors = this.get("colors");
    if (plotColors) {
        if (!plotColors.length) {
            plotColors = [colors[0], colors[2]];
        }
        plotColors = plotColors.concat(colors.slice(3));
        this.set("scatterplotColors", plotColors);
        return plotColors[index % plotColors.length];
    }
    return colors[index % colors.length];
};

/**
  * @method _isDottedLine
  * Returns whether current key is dotted line
  * @param {String} group Chart group set
  * @param {String} name Current data value name
  * when adding legend item determines whether a {background-color, dotted line, or border} needed
  * @return {Boolean}
  */
Legend.prototype._isDottedLine = function (group, name) {
    if (this.get("dottedLineNames")) {
        var dottedLineNames = !(this._isScatterPlot(group) || group === "benchmark") ? this.get("dottedLineNames")[group] : null;
        if (dottedLineNames instanceof Array) {
            return dottedLineNames.indexOf(name) > -1;
        } else {
            return dottedLineNames;
        }
    }
    return group === "benchmark" && this._benchmarkStyle;
};

/**
  * @method _isScatterPlot
  * Returns whether chart option is scatterplot
  * @return {Boolean}
  */
Legend.prototype._isScatterPlot = function () {
    return this._options.chart === "scatterplot";
};

Legend.prototype._isVerticalBar = function () {
    return this._options.chart === "verticalBar";
};

Legend.prototype._isLineChart = function () {
    return this._options.chart === "lineChart";
};

Legend.prototype._isTimeSeries = function () {
    return this._options.chart === "time-series";
};

/**
  * @method _isBubbleChart
  * Returns whether chart option is bubbleChart
  * @return {Boolean}
  */
Legend.prototype._isBubbleChart = function () {
    return this._options.chart === "bubbleChart";
};

/**
  * @method _isBenchmark
  * Returns whether current data is in benchmark group
  * @return {Boolean}
  */
Legend.prototype._isBenchmark = function (groupName) {
    return groupName === "benchmark";
};

/**
 * @method sortLegendData
 * @param {Array} groups
 * @desc Takes an array of group names and creates a new data object sorted in descending order by value. This method is only used in Time-series Line chart.
 * @return {Array} sortedArray
 */
Legend.prototype._sortLegendData = function () {
    var dataManager = this.get("data");
    var sortedArr = [];

    var _this = this;
    var addLegendSet = function addLegendSet(group) {
        group.forEach(function (dataset) {
            var value = _this.getValidEndValue(dataset.series);
            var displayName = dataset.displayName,
                index = dataset.index,
                color = dataset.color,
                lineStrokeWidth = dataset.lineStrokeWidth;

            sortedArr.push({
                value: value,
                displayName: displayName,
                index: index,
                color: color,
                lineStrokeWidth: lineStrokeWidth
            });
        });
    };

    var y1DomainDataset = this.get("y1DomainDataset");
    var groups = [y1DomainDataset];
    if (this.get("y2")) {
        var y2DomainDataset = this.get("y2DomainDataset");
        groups = groups.concat(y2DomainDataset);
    }

    groups.forEach(function (name) {
        addLegendSet(dataManager.get(name));
    });

    // sort legend items by the end value of series line
    sortedArr = this.sortDataByEndValue(sortedArr);

    return sortedArr;
};

/**
 * Set chart container width properly with no axes labels
 */
Legend.prototype.chartRightAxesNoLabel = function () {
    var y1LabelText = this.get("y1AxisLabel");
    var y2LabelText = this.get("y2AxisLabel");
    var y1Orient = this.get("y1AxisOrient");
    var y2Orient = this.get("y2AxisOrient");
    return y1Orient === "right" && y2Orient !== "right" && !y1LabelText || y1Orient !== "right" && y2Orient === "right" && !y2LabelText || y1Orient === "right" && y2Orient === "right" && !y2LabelText;
};

/**
 * Used to display the legend after having been removed
 */
Legend.prototype.addLegend = function () {
    if (this.get("showLegend") === false) {
        this.set("showLegend", true);
        this.update();
    }
};
/**
 * To remove the legend after having been rendered
 */
Legend.prototype.removeLegend = function () {
    this.set("showLegend", false);
    this.set("legendCreated", false);
    this.update();
};

/**
 * Mouse Listeners
 */
Legend.prototype.legendFocusIn = function (group) {
    this.get("legendContainer").selectAll(".legend-item").filter(function () {
        return !d3.select(this).classed(group);
    }).classed("unfocused", true);
};

Legend.prototype.legendFocusOut = function () {
    this.get("legendContainer").selectAll(".legend-item").classed("unfocused", false);
};

Legend.prototype.legendMouseover = function (d) {
    var group = Utils.string.dashify(d.name);
    var canvas = this.get("canvas");
    canvas.layer("chart-layer").selectAll("g.dot").filter(function () {
        return !d3.select(this).classed(group);
    }).classed({
        unfocused: true,
        less: true
    });
    canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
        unfocused: true
    });
    this.legendFocusIn(group);
};

Legend.prototype.legendMouseout = function () {
    var canvas = this.get("canvas");
    canvas.layer("chart-layer").selectAll("g.dot").classed({
        unfocused: false,
        less: false
    });
    canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
        unfocused: false
    });
    this.legendFocusOut();
};

Legend.prototype.getLegendWidth = function (container, data) {
    var svg = container.append("svg");
    var width = Utils.svg.getGreaterSVGTextWidth(svg, data, "displayName");
    svg.remove();
    return width;
};

Legend.prototype.legendBenchmarkMouseover = function (d) {
    var canvas = this.get("canvas");
    canvas.layer("chart-layer").selectAll("g.dot").classed({
        unfocused: true,
        less: true
    });
    canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
        focused: true
    });
    this.legendFocusIn("benchmark");
};

Legend.prototype.legendBenchmarkMouseout = function () {
    var canvas = this.get("canvas");
    canvas.layer("chart-layer").selectAll("g.dot").classed({
        unfocused: false,
        less: false
    });
    canvas.layer(this.getId("benchmark"), "front").select("rect").classed({
        focused: false
    });
    this.legendFocusOut();
};

module.exports = Legend;

/***/ })

/******/ });
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_pp_scenario_analysis_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(233);
/* harmony import */ var _node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_pp_scenario_analysis_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mwc_cli_node_modules_mini_css_extract_plugin_dist_loader_js_node_modules_mwc_cli_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_mwc_cli_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_mwc_cli_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_mwc_cli_node_modules_vue_loader_lib_index_js_vue_loader_options_pp_scenario_analysis_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ })
/******/ ])["default"];
});
//# sourceMappingURL=mwc-pp-scenario-analysis.js.map